import { api } from "infra/api/baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAssets: build.query<GetAssetsApiResponse, GetAssetsApiArg>({
      query: (queryArg) => ({
        url: `/assets`,
        params: {
          updatedBefore: queryArg.updatedBefore,
          sortDirection: queryArg.sortDirection,
          privacy: queryArg.privacy,
          inferenceId: queryArg.inferenceId,
          modelId: queryArg.modelId,
          updatedAfter: queryArg.updatedAfter,
          parentAssetId: queryArg.parentAssetId,
          createdBefore: queryArg.createdBefore,
          sortBy: queryArg.sortBy,
          createdAfter: queryArg.createdAfter,
          authorId: queryArg.authorId,
          projectId: queryArg.projectId,
          originalAssets: queryArg.originalAssets,
          pageSize: queryArg.pageSize,
          rootAssetId: queryArg.rootAssetId,
          type: queryArg["type"],
          paginationToken: queryArg.paginationToken,
          tags: queryArg.tags,
          types: queryArg.types,
          collectionId: queryArg.collectionId,
        },
      }),
    }),
    postAsset: build.mutation<PostAssetApiResponse, PostAssetApiArg>({
      query: (queryArg) => ({
        url: `/assets`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
        },
      }),
    }),
    deleteAsset: build.mutation<DeleteAssetApiResponse, DeleteAssetApiArg>({
      query: (queryArg) => ({
        url: `/assets`,
        method: "DELETE",
        body: queryArg.body,
        params: { projectId: queryArg.projectId },
      }),
    }),
    postDownloadAssets: build.mutation<
      PostDownloadAssetsApiResponse,
      PostDownloadAssetsApiArg
    >({
      query: (queryArg) => ({
        url: `/assets/download`,
        method: "POST",
        body: queryArg.body,
        params: { projectId: queryArg.projectId },
      }),
    }),
    getDownloadAssets: build.query<
      GetDownloadAssetsApiResponse,
      GetDownloadAssetsApiArg
    >({
      query: (queryArg) => ({
        url: `/assets/download/${queryArg.jobId}`,
        params: { projectId: queryArg.projectId },
      }),
    }),
    postAssetGetBulk: build.mutation<
      PostAssetGetBulkApiResponse,
      PostAssetGetBulkApiArg
    >({
      query: (queryArg) => ({
        url: `/assets/get-bulk`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
        },
      }),
    }),
    getPublicAssets: build.query<
      GetPublicAssetsApiResponse,
      GetPublicAssetsApiArg
    >({
      query: (queryArg) => ({
        url: `/assets/public`,
        params: {
          updatedBefore: queryArg.updatedBefore,
          sortDirection: queryArg.sortDirection,
          modelId: queryArg.modelId,
          updatedAfter: queryArg.updatedAfter,
          createdBefore: queryArg.createdBefore,
          sortBy: queryArg.sortBy,
          createdAfter: queryArg.createdAfter,
          originalAssets: queryArg.originalAssets,
          pageSize: queryArg.pageSize,
          type: queryArg["type"],
          paginationToken: queryArg.paginationToken,
          tags: queryArg.tags,
          types: queryArg.types,
        },
      }),
    }),
    getAssetsByAssetId: build.query<
      GetAssetsByAssetIdApiResponse,
      GetAssetsByAssetIdApiArg
    >({
      query: (queryArg) => ({
        url: `/assets/${queryArg.assetId}`,
        params: {
          withEmbedding: queryArg.withEmbedding,
          projectId: queryArg.projectId,
          originalAssets: queryArg.originalAssets,
        },
      }),
    }),
    putAssetByAssetId: build.mutation<
      PutAssetByAssetIdApiResponse,
      PutAssetByAssetIdApiArg
    >({
      query: (queryArg) => ({
        url: `/assets/${queryArg.assetId}`,
        method: "PUT",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
        },
      }),
    }),
    copyAssetByAssetId: build.mutation<
      CopyAssetByAssetIdApiResponse,
      CopyAssetByAssetIdApiArg
    >({
      query: (queryArg) => ({
        url: `/assets/${queryArg.assetId}/copy`,
        method: "POST",
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
        },
      }),
    }),
    lockAssetByAssetId: build.mutation<
      LockAssetByAssetIdApiResponse,
      LockAssetByAssetIdApiArg
    >({
      query: (queryArg) => ({
        url: `/assets/${queryArg.assetId}/lock`,
        method: "PUT",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
        },
      }),
    }),
    privacyAssetByAssetId: build.mutation<
      PrivacyAssetByAssetIdApiResponse,
      PrivacyAssetByAssetIdApiArg
    >({
      query: (queryArg) => ({
        url: `/assets/${queryArg.assetId}/privacy`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
        },
      }),
    }),
    getCanvasAssetSnapshots: build.query<
      GetCanvasAssetSnapshotsApiResponse,
      GetCanvasAssetSnapshotsApiArg
    >({
      query: (queryArg) => ({
        url: `/assets/${queryArg.assetId}/snapshots`,
        params: {
          projectId: queryArg.projectId,
          pageSize: queryArg.pageSize,
          paginationToken: queryArg.paginationToken,
        },
      }),
    }),
    putAssetsTagsByAssetId: build.mutation<
      PutAssetsTagsByAssetIdApiResponse,
      PutAssetsTagsByAssetIdApiArg
    >({
      query: (queryArg) => ({
        url: `/assets/${queryArg.assetId}/tags`,
        method: "PUT",
        body: queryArg.body,
        params: { projectId: queryArg.projectId },
      }),
    }),
    unlockAssetByAssetId: build.mutation<
      UnlockAssetByAssetIdApiResponse,
      UnlockAssetByAssetIdApiArg
    >({
      query: (queryArg) => ({
        url: `/assets/${queryArg.assetId}/unlock`,
        method: "PUT",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
        },
      }),
    }),
    getCollections: build.query<
      GetCollectionsApiResponse,
      GetCollectionsApiArg
    >({
      query: (queryArg) => ({
        url: `/collections`,
        params: {
          pageSize: queryArg.pageSize,
          projectId: queryArg.projectId,
          paginationToken: queryArg.paginationToken,
        },
      }),
    }),
    postCollection: build.mutation<
      PostCollectionApiResponse,
      PostCollectionApiArg
    >({
      query: (queryArg) => ({
        url: `/collections`,
        method: "POST",
        body: queryArg.body,
        params: { projectId: queryArg.projectId },
      }),
    }),
    getCollectionsByCollectionId: build.query<
      GetCollectionsByCollectionIdApiResponse,
      GetCollectionsByCollectionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/collections/${queryArg.collectionId}`,
        params: { projectId: queryArg.projectId },
      }),
    }),
    putCollectionsByCollectionId: build.mutation<
      PutCollectionsByCollectionIdApiResponse,
      PutCollectionsByCollectionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/collections/${queryArg.collectionId}`,
        method: "PUT",
        body: queryArg.body,
        params: { projectId: queryArg.projectId },
      }),
    }),
    deleteCollectionsByCollectionId: build.mutation<
      DeleteCollectionsByCollectionIdApiResponse,
      DeleteCollectionsByCollectionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/collections/${queryArg.collectionId}`,
        method: "DELETE",
        params: { projectId: queryArg.projectId },
      }),
    }),
    putAssetsByCollectionId: build.mutation<
      PutAssetsByCollectionIdApiResponse,
      PutAssetsByCollectionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/collections/${queryArg.collectionId}/assets`,
        method: "PUT",
        body: queryArg.body,
        params: { projectId: queryArg.projectId },
      }),
    }),
    deleteAssetsByCollectionId: build.mutation<
      DeleteAssetsByCollectionIdApiResponse,
      DeleteAssetsByCollectionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/collections/${queryArg.collectionId}/assets`,
        method: "DELETE",
        body: queryArg.body,
        params: { projectId: queryArg.projectId },
      }),
    }),
    putModelsByCollectionId: build.mutation<
      PutModelsByCollectionIdApiResponse,
      PutModelsByCollectionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/collections/${queryArg.collectionId}/models`,
        method: "PUT",
        body: queryArg.body,
        params: { projectId: queryArg.projectId },
      }),
    }),
    deleteModelsByCollectionId: build.mutation<
      DeleteModelsByCollectionIdApiResponse,
      DeleteModelsByCollectionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/collections/${queryArg.collectionId}/models`,
        method: "DELETE",
        body: queryArg.body,
        params: { projectId: queryArg.projectId },
      }),
    }),
    postCaptionInferences: build.mutation<
      PostCaptionInferencesApiResponse,
      PostCaptionInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/caption`,
        method: "POST",
        body: queryArg.body,
        params: { projectId: queryArg.projectId, dryRun: queryArg.dryRun },
      }),
    }),
    postControlnetInferences: build.mutation<
      PostControlnetInferencesApiResponse,
      PostControlnetInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/controlnet`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    postControlnetImg2ImgInferences: build.mutation<
      PostControlnetImg2ImgInferencesApiResponse,
      PostControlnetImg2ImgInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/controlnet-img2img`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    postControlnetInpaintInferences: build.mutation<
      PostControlnetInpaintInferencesApiResponse,
      PostControlnetInpaintInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/controlnet-inpaint`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    postControlnetInpaintIpAdapterInferences: build.mutation<
      PostControlnetInpaintIpAdapterInferencesApiResponse,
      PostControlnetInpaintIpAdapterInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/controlnet-inpaint-ip-adapter`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    postControlnetIpAdapterInferences: build.mutation<
      PostControlnetIpAdapterInferencesApiResponse,
      PostControlnetIpAdapterInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/controlnet-ip-adapter`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    postControlnetTextureInferences: build.mutation<
      PostControlnetTextureInferencesApiResponse,
      PostControlnetTextureInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/controlnet-texture`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    postGenerateCustom: build.mutation<
      PostGenerateCustomApiResponse,
      PostGenerateCustomApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/custom/${queryArg.modelId}`,
        method: "POST",
        body: queryArg.body,
        params: { projectId: queryArg.projectId, dryRun: queryArg.dryRun },
      }),
    }),
    postDescribeStyleInferences: build.mutation<
      PostDescribeStyleInferencesApiResponse,
      PostDescribeStyleInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/describe-style`,
        method: "POST",
        body: queryArg.body,
        params: { projectId: queryArg.projectId, dryRun: queryArg.dryRun },
      }),
    }),
    postDetectInferences: build.mutation<
      PostDetectInferencesApiResponse,
      PostDetectInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/detect`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    postEmbedInferences: build.mutation<
      PostEmbedInferencesApiResponse,
      PostEmbedInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/embed`,
        method: "POST",
        body: queryArg.body,
        params: { projectId: queryArg.projectId, dryRun: queryArg.dryRun },
      }),
    }),
    postGenerativeFillInferences: build.mutation<
      PostGenerativeFillInferencesApiResponse,
      PostGenerativeFillInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/generative-fill`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    postImg2ImgInferences: build.mutation<
      PostImg2ImgInferencesApiResponse,
      PostImg2ImgInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/img2img`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    postImg2ImgIpAdapterInferences: build.mutation<
      PostImg2ImgIpAdapterInferencesApiResponse,
      PostImg2ImgIpAdapterInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/img2img-ip-adapter`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    postImg2ImgTextureInferences: build.mutation<
      PostImg2ImgTextureInferencesApiResponse,
      PostImg2ImgTextureInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/img2img-texture`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    postInpaintInferences: build.mutation<
      PostInpaintInferencesApiResponse,
      PostInpaintInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/inpaint`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    postInpaintIpAdapterInferences: build.mutation<
      PostInpaintIpAdapterInferencesApiResponse,
      PostInpaintIpAdapterInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/inpaint-ip-adapter`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    postPatchInferences: build.mutation<
      PostPatchInferencesApiResponse,
      PostPatchInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/patch`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    postPixelateInferences: build.mutation<
      PostPixelateInferencesApiResponse,
      PostPixelateInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/pixelate`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    postPromptInferences: build.mutation<
      PostPromptInferencesApiResponse,
      PostPromptInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/prompt`,
        method: "POST",
        body: queryArg.body,
        params: { projectId: queryArg.projectId, dryRun: queryArg.dryRun },
      }),
    }),
    postPromptEditingInferences: build.mutation<
      PostPromptEditingInferencesApiResponse,
      PostPromptEditingInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/prompt-editing`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    postReframeInferences: build.mutation<
      PostReframeInferencesApiResponse,
      PostReframeInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/reframe`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    postRemoveBackgroundInferences: build.mutation<
      PostRemoveBackgroundInferencesApiResponse,
      PostRemoveBackgroundInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/remove-background`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    postRestyleInferences: build.mutation<
      PostRestyleInferencesApiResponse,
      PostRestyleInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/restyle`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    postSegmentInferences: build.mutation<
      PostSegmentInferencesApiResponse,
      PostSegmentInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/segment`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    postSkyboxBase360Inferences: build.mutation<
      PostSkyboxBase360InferencesApiResponse,
      PostSkyboxBase360InferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/skybox-base-360`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    postSkyboxUpscale360Inferences: build.mutation<
      PostSkyboxUpscale360InferencesApiResponse,
      PostSkyboxUpscale360InferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/skybox-upscale-360`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    postTextureInferences: build.mutation<
      PostTextureInferencesApiResponse,
      PostTextureInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/texture`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    postTranslateInferences: build.mutation<
      PostTranslateInferencesApiResponse,
      PostTranslateInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/translate`,
        method: "POST",
        body: queryArg.body,
        params: { projectId: queryArg.projectId, dryRun: queryArg.dryRun },
      }),
    }),
    postTxt2ImgInferences: build.mutation<
      PostTxt2ImgInferencesApiResponse,
      PostTxt2ImgInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/txt2img`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    postTxt2ImgIpAdapterInferences: build.mutation<
      PostTxt2ImgIpAdapterInferencesApiResponse,
      PostTxt2ImgIpAdapterInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/txt2img-ip-adapter`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    postTxt2ImgTextureInferences: build.mutation<
      PostTxt2ImgTextureInferencesApiResponse,
      PostTxt2ImgTextureInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/txt2img-texture`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    postUpscaleInferences: build.mutation<
      PostUpscaleInferencesApiResponse,
      PostUpscaleInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/upscale`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    postVectorizeInferences: build.mutation<
      PostVectorizeInferencesApiResponse,
      PostVectorizeInferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/generate/vectorize`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    putImagesDetection: build.mutation<
      PutImagesDetectionApiResponse,
      PutImagesDetectionApiArg
    >({
      query: (queryArg) => ({
        url: `/images/detection`,
        method: "PUT",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    putImagesEraseBackground: build.mutation<
      PutImagesEraseBackgroundApiResponse,
      PutImagesEraseBackgroundApiArg
    >({
      query: (queryArg) => ({
        url: `/images/erase-background`,
        method: "PUT",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    putImagePatch: build.mutation<
      PutImagePatchApiResponse,
      PutImagePatchApiArg
    >({
      query: (queryArg) => ({
        url: `/images/patch`,
        method: "PUT",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    putImagesPixelate: build.mutation<
      PutImagesPixelateApiResponse,
      PutImagesPixelateApiArg
    >({
      query: (queryArg) => ({
        url: `/images/pixelate`,
        method: "PUT",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    putImagesSegmentation: build.mutation<
      PutImagesSegmentationApiResponse,
      PutImagesSegmentationApiArg
    >({
      query: (queryArg) => ({
        url: `/images/segmentation`,
        method: "PUT",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    putImageUpscale: build.mutation<
      PutImageUpscaleApiResponse,
      PutImageUpscaleApiArg
    >({
      query: (queryArg) => ({
        url: `/images/upscale`,
        method: "PUT",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    putImageVectorization: build.mutation<
      PutImageVectorizationApiResponse,
      PutImageVectorizationApiArg
    >({
      query: (queryArg) => ({
        url: `/images/vectorization`,
        method: "PUT",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    getInferences: build.query<GetInferencesApiResponse, GetInferencesApiArg>({
      query: (queryArg) => ({
        url: `/inferences`,
        params: {
          projectId: queryArg.projectId,
          originalAssets: queryArg.originalAssets,
          pageSize: queryArg.pageSize,
          paginationToken: queryArg.paginationToken,
        },
      }),
    }),
    getJobs: build.query<GetJobsApiResponse, GetJobsApiArg>({
      query: (queryArg) => ({
        url: `/jobs`,
        params: {
          authorId: queryArg.authorId,
          hideResults: queryArg.hideResults,
          projectId: queryArg.projectId,
          pageSize: queryArg.pageSize,
          type: queryArg["type"],
          paginationToken: queryArg.paginationToken,
          types: queryArg.types,
          status: queryArg.status,
        },
      }),
    }),
    getJobId: build.query<GetJobIdApiResponse, GetJobIdApiArg>({
      query: (queryArg) => ({
        url: `/jobs/${queryArg.jobId}`,
        params: { projectId: queryArg.projectId },
      }),
    }),
    postJobActionByJobId: build.mutation<
      PostJobActionByJobIdApiResponse,
      PostJobActionByJobIdApiArg
    >({
      query: (queryArg) => ({
        url: `/jobs/${queryArg.jobId}/action`,
        method: "POST",
        body: queryArg.body,
        params: { projectId: queryArg.projectId },
      }),
    }),
    getMe: build.query<GetMeApiResponse, GetMeApiArg>({
      query: () => ({ url: `/me` }),
    }),
    putMe: build.mutation<PutMeApiResponse, PutMeApiArg>({
      query: (queryArg) => ({ url: `/me`, method: "PUT", body: queryArg.body }),
    }),
    deleteMe: build.mutation<DeleteMeApiResponse, DeleteMeApiArg>({
      query: (queryArg) => ({
        url: `/me`,
        method: "DELETE",
        headers: { Authorization: queryArg.authorization },
        params: { confirmMethod: queryArg.confirmMethod },
      }),
    }),
    getUserConfirmDeletion: build.query<
      GetUserConfirmDeletionApiResponse,
      GetUserConfirmDeletionApiArg
    >({
      query: (queryArg) => ({
        url: `/me/confirm-deletion`,
        params: { token: queryArg.token },
      }),
    }),
    getUserConfirmInvitation: build.query<
      GetUserConfirmInvitationApiResponse,
      GetUserConfirmInvitationApiArg
    >({
      query: (queryArg) => ({
        url: `/me/confirm-invitation`,
        params: { hash: queryArg.hash },
      }),
    }),
    getUserNotificationsByToken: build.query<
      GetUserNotificationsByTokenApiResponse,
      GetUserNotificationsByTokenApiArg
    >({
      query: (queryArg) => ({
        url: `/me/notifications`,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    putUserNotificationsByToken: build.mutation<
      PutUserNotificationsByTokenApiResponse,
      PutUserNotificationsByTokenApiArg
    >({
      query: (queryArg) => ({
        url: `/me/notifications`,
        method: "PUT",
        body: queryArg.body,
        headers: { Authorization: queryArg.authorization },
      }),
    }),
    getModels: build.query<GetModelsApiResponse, GetModelsApiArg>({
      query: (queryArg) => ({
        url: `/models`,
        params: {
          privacy: queryArg.privacy,
          projectId: queryArg.projectId,
          originalAssets: queryArg.originalAssets,
          pageSize: queryArg.pageSize,
          paginationToken: queryArg.paginationToken,
          status: queryArg.status,
          collectionId: queryArg.collectionId,
          loadedOnly: queryArg.loadedOnly,
        },
      }),
    }),
    postModels: build.mutation<PostModelsApiResponse, PostModelsApiArg>({
      query: (queryArg) => ({
        url: `/models`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
        },
      }),
    }),
    postModelsGetBulk: build.mutation<
      PostModelsGetBulkApiResponse,
      PostModelsGetBulkApiArg
    >({
      query: (queryArg) => ({
        url: `/models/get-bulk`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
        },
      }),
    }),
    getModelsByModelId: build.query<
      GetModelsByModelIdApiResponse,
      GetModelsByModelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}`,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
        },
      }),
    }),
    putModelsByModelId: build.mutation<
      PutModelsByModelIdApiResponse,
      PutModelsByModelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}`,
        method: "PUT",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
        },
      }),
    }),
    deleteModelsByModelId: build.mutation<
      DeleteModelsByModelIdApiResponse,
      DeleteModelsByModelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}`,
        method: "DELETE",
        params: { projectId: queryArg.projectId },
      }),
    }),
    postModelActionByModelId: build.mutation<
      PostModelActionByModelIdApiResponse,
      PostModelActionByModelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/action`,
        method: "POST",
        body: queryArg.body,
        params: { projectId: queryArg.projectId },
      }),
    }),
    getModelsCategoriesByModelId: build.query<
      GetModelsCategoriesByModelIdApiResponse,
      GetModelsCategoriesByModelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/categories`,
        params: { projectId: queryArg.projectId },
      }),
    }),
    getModelsClassesByModelId: build.query<
      GetModelsClassesByModelIdApiResponse,
      GetModelsClassesByModelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/classes`,
        params: {
          category: queryArg.category,
          projectId: queryArg.projectId,
          pageSize: queryArg.pageSize,
          paginationToken: queryArg.paginationToken,
        },
      }),
    }),
    postModelsCopyByModelId: build.mutation<
      PostModelsCopyByModelIdApiResponse,
      PostModelsCopyByModelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/copy`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
        },
      }),
    }),
    getModelsDescriptionByModelId: build.query<
      GetModelsDescriptionByModelIdApiResponse,
      GetModelsDescriptionByModelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/description`,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
        },
      }),
    }),
    putModelsDescriptionByModelId: build.mutation<
      PutModelsDescriptionByModelIdApiResponse,
      PutModelsDescriptionByModelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/description`,
        method: "PUT",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
        },
      }),
    }),
    postDownloadModel: build.mutation<
      PostDownloadModelApiResponse,
      PostDownloadModelApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/download`,
        method: "POST",
        params: { projectId: queryArg.projectId },
      }),
    }),
    getModelsExamplesByModelId: build.query<
      GetModelsExamplesByModelIdApiResponse,
      GetModelsExamplesByModelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/examples`,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
        },
      }),
    }),
    putModelsExamplesByModelId: build.mutation<
      PutModelsExamplesByModelIdApiResponse,
      PutModelsExamplesByModelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/examples`,
        method: "PUT",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
        },
      }),
    }),
    deleteModelsImagesByModelId: build.mutation<
      DeleteModelsImagesByModelIdApiResponse,
      DeleteModelsImagesByModelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/images`,
        method: "DELETE",
        params: { ids: queryArg.ids, projectId: queryArg.projectId },
      }),
    }),
    getModelsInferencesByModelId: build.query<
      GetModelsInferencesByModelIdApiResponse,
      GetModelsInferencesByModelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/inferences`,
        params: {
          projectId: queryArg.projectId,
          originalAssets: queryArg.originalAssets,
          pageSize: queryArg.pageSize,
          paginationToken: queryArg.paginationToken,
        },
      }),
    }),
    postModelsInferencesByModelId: build.mutation<
      PostModelsInferencesByModelIdApiResponse,
      PostModelsInferencesByModelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/inferences`,
        method: "POST",
        body: queryArg.body,
        params: {
          projectId: queryArg.projectId,
          originalAssets: queryArg.originalAssets,
          dryRun: queryArg.dryRun,
        },
      }),
    }),
    deleteModelsInferencesByModelId: build.mutation<
      DeleteModelsInferencesByModelIdApiResponse,
      DeleteModelsInferencesByModelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/inferences`,
        method: "DELETE",
        params: {
          inferenceIds: queryArg.inferenceIds,
          projectId: queryArg.projectId,
        },
      }),
    }),
    deleteModelsInferencesAllByModelId: build.mutation<
      DeleteModelsInferencesAllByModelIdApiResponse,
      DeleteModelsInferencesAllByModelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/inferences/all`,
        method: "DELETE",
        params: { projectId: queryArg.projectId },
      }),
    }),
    getModelsInferencesByModelIdAndInferenceId: build.query<
      GetModelsInferencesByModelIdAndInferenceIdApiResponse,
      GetModelsInferencesByModelIdAndInferenceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/inferences/${queryArg.inferenceId}`,
        params: {
          projectId: queryArg.projectId,
          originalAssets: queryArg.originalAssets,
        },
      }),
    }),
    deleteModelsInferencesByModelIdAndInferenceId: build.mutation<
      DeleteModelsInferencesByModelIdAndInferenceIdApiResponse,
      DeleteModelsInferencesByModelIdAndInferenceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/inferences/${queryArg.inferenceId}`,
        method: "DELETE",
        params: { projectId: queryArg.projectId },
      }),
    }),
    postModelsInferencesActionByModelIdAndInferenceId: build.mutation<
      PostModelsInferencesActionByModelIdAndInferenceIdApiResponse,
      PostModelsInferencesActionByModelIdAndInferenceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/inferences/${queryArg.inferenceId}/action`,
        method: "POST",
        body: queryArg.body,
        params: { projectId: queryArg.projectId },
      }),
    }),
    getModelsInferencesImagesByModelIdAndInferenceIdAndImageId: build.query<
      GetModelsInferencesImagesByModelIdAndInferenceIdAndImageIdApiResponse,
      GetModelsInferencesImagesByModelIdAndInferenceIdAndImageIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/inferences/${queryArg.inferenceId}/images/${queryArg.imageId}`,
        params: {
          projectId: queryArg.projectId,
          originalAssets: queryArg.originalAssets,
        },
      }),
    }),
    deleteModelsInferencesImagesByModelIdAndInferenceIdAndImageId:
      build.mutation<
        DeleteModelsInferencesImagesByModelIdAndInferenceIdAndImageIdApiResponse,
        DeleteModelsInferencesImagesByModelIdAndInferenceIdAndImageIdApiArg
      >({
        query: (queryArg) => ({
          url: `/models/${queryArg.modelId}/inferences/${queryArg.inferenceId}/images/${queryArg.imageId}`,
          method: "DELETE",
          params: { projectId: queryArg.projectId },
        }),
      }),
    getModelPresetsByModelId: build.query<
      GetModelPresetsByModelIdApiResponse,
      GetModelPresetsByModelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/presets`,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
        },
      }),
    }),
    postModelPresetByModelId: build.mutation<
      PostModelPresetByModelIdApiResponse,
      PostModelPresetByModelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/presets`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
        },
      }),
    }),
    putModelPresetByModelIdAndPresetId: build.mutation<
      PutModelPresetByModelIdAndPresetIdApiResponse,
      PutModelPresetByModelIdAndPresetIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/presets/${queryArg.presetId}`,
        method: "PUT",
        body: queryArg.body,
        params: {
          projectId: queryArg.projectId,
          originalAssets: queryArg.originalAssets,
        },
      }),
    }),
    deleteModelPresetByModelIdAndPresetId: build.mutation<
      DeleteModelPresetByModelIdAndPresetIdApiResponse,
      DeleteModelPresetByModelIdAndPresetIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/presets/${queryArg.presetId}`,
        method: "DELETE",
        params: { projectId: queryArg.projectId },
      }),
    }),
    getModelsScoresPromptByModelId: build.query<
      GetModelsScoresPromptByModelIdApiResponse,
      GetModelsScoresPromptByModelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/scores/prompt`,
        params: { prompt: queryArg.prompt, projectId: queryArg.projectId },
      }),
    }),
    getModelsScoresTrainingDatasetByModelId: build.query<
      GetModelsScoresTrainingDatasetByModelIdApiResponse,
      GetModelsScoresTrainingDatasetByModelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/scores/training-dataset`,
        params: { projectId: queryArg.projectId },
      }),
    }),
    putModelsTagsByModelId: build.mutation<
      PutModelsTagsByModelIdApiResponse,
      PutModelsTagsByModelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/tags`,
        method: "PUT",
        body: queryArg.body,
        params: { projectId: queryArg.projectId },
      }),
    }),
    putModelsTrainByModelId: build.mutation<
      PutModelsTrainByModelIdApiResponse,
      PutModelsTrainByModelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/train`,
        method: "PUT",
        body: queryArg.body,
        params: {
          projectId: queryArg.projectId,
          originalAssets: queryArg.originalAssets,
          dryRun: queryArg.dryRun,
          trainingImagesCount: queryArg.trainingImagesCount,
        },
      }),
    }),
    postModelTrainingActionByModelId: build.mutation<
      PostModelTrainingActionByModelIdApiResponse,
      PostModelTrainingActionByModelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/train/action`,
        method: "POST",
        body: queryArg.body,
        params: { projectId: queryArg.projectId },
      }),
    }),
    postModelsTrainingImagesByModelId: build.mutation<
      PostModelsTrainingImagesByModelIdApiResponse,
      PostModelsTrainingImagesByModelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/training-images`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
        },
      }),
    }),
    putModelsTrainingImagesByModelIdAndTrainingImageId: build.mutation<
      PutModelsTrainingImagesByModelIdAndTrainingImageIdApiResponse,
      PutModelsTrainingImagesByModelIdAndTrainingImageIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/training-images/${queryArg.trainingImageId}`,
        method: "PUT",
        body: queryArg.body,
        params: {
          projectId: queryArg.projectId,
          originalAssets: queryArg.originalAssets,
        },
      }),
    }),
    deleteModelsTrainingImagesByModelIdAndTrainingImageId: build.mutation<
      DeleteModelsTrainingImagesByModelIdAndTrainingImageIdApiResponse,
      DeleteModelsTrainingImagesByModelIdAndTrainingImageIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/training-images/${queryArg.trainingImageId}`,
        method: "DELETE",
        params: { projectId: queryArg.projectId },
      }),
    }),
    postModelsTransferByModelId: build.mutation<
      PostModelsTransferByModelIdApiResponse,
      PostModelsTransferByModelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/models/${queryArg.modelId}/transfer`,
        method: "POST",
        body: queryArg.body,
        params: { projectId: queryArg.projectId },
      }),
    }),
    getProjects: build.query<GetProjectsApiResponse, GetProjectsApiArg>({
      query: (queryArg) => ({
        url: `/projects`,
        params: {
          pageSize: queryArg.pageSize,
          teamId: queryArg.teamId,
          paginationToken: queryArg.paginationToken,
        },
      }),
    }),
    postProject: build.mutation<PostProjectApiResponse, PostProjectApiArg>({
      query: (queryArg) => ({
        url: `/projects`,
        method: "POST",
        body: queryArg.body,
        params: { teamId: queryArg.teamId },
      }),
    }),
    getProjectsByProjectId: build.query<
      GetProjectsByProjectIdApiResponse,
      GetProjectsByProjectIdApiArg
    >({
      query: (queryArg) => ({ url: `/projects/${queryArg.projectId}` }),
    }),
    putProjectsByProjectId: build.mutation<
      PutProjectsByProjectIdApiResponse,
      PutProjectsByProjectIdApiArg
    >({
      query: (queryArg) => ({
        url: `/projects/${queryArg.projectId}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteProjectsByProjectId: build.mutation<
      DeleteProjectsByProjectIdApiResponse,
      DeleteProjectsByProjectIdApiArg
    >({
      query: (queryArg) => ({
        url: `/projects/${queryArg.projectId}`,
        method: "DELETE",
      }),
    }),
    postProjectsApiKeysByProjectId: build.mutation<
      PostProjectsApiKeysByProjectIdApiResponse,
      PostProjectsApiKeysByProjectIdApiArg
    >({
      query: (queryArg) => ({
        url: `/projects/${queryArg.projectId}/api-keys`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteProjectsApiKeyByProjectIdAndKeyId: build.mutation<
      DeleteProjectsApiKeyByProjectIdAndKeyIdApiResponse,
      DeleteProjectsApiKeyByProjectIdAndKeyIdApiArg
    >({
      query: (queryArg) => ({
        url: `/projects/${queryArg.projectId}/api-keys/${queryArg.keyId}`,
        method: "DELETE",
      }),
    }),
    postProjectsMembersByProjectId: build.mutation<
      PostProjectsMembersByProjectIdApiResponse,
      PostProjectsMembersByProjectIdApiArg
    >({
      query: (queryArg) => ({
        url: `/projects/${queryArg.projectId}/members`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putProjectsMembersByProjectIdAndMemberId: build.mutation<
      PutProjectsMembersByProjectIdAndMemberIdApiResponse,
      PutProjectsMembersByProjectIdAndMemberIdApiArg
    >({
      query: (queryArg) => ({
        url: `/projects/${queryArg.projectId}/members/${queryArg.memberId}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteProjectsMembersByProjectIdAndMemberId: build.mutation<
      DeleteProjectsMembersByProjectIdAndMemberIdApiResponse,
      DeleteProjectsMembersByProjectIdAndMemberIdApiArg
    >({
      query: (queryArg) => ({
        url: `/projects/${queryArg.projectId}/members/${queryArg.memberId}`,
        method: "DELETE",
      }),
    }),
    getProjectWebhookEndpoints: build.query<
      GetProjectWebhookEndpointsApiResponse,
      GetProjectWebhookEndpointsApiArg
    >({
      query: (queryArg) => ({
        url: `/projects/${queryArg.projectId}/webhook-endpoints`,
      }),
    }),
    postProjectWebhookEndpoints: build.mutation<
      PostProjectWebhookEndpointsApiResponse,
      PostProjectWebhookEndpointsApiArg
    >({
      query: (queryArg) => ({
        url: `/projects/${queryArg.projectId}/webhook-endpoints`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putProjectWebhookEndpointById: build.mutation<
      PutProjectWebhookEndpointByIdApiResponse,
      PutProjectWebhookEndpointByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/projects/${queryArg.projectId}/webhook-endpoints/${queryArg.webhookEndpointId}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteProjectWebhookEndpointById: build.mutation<
      DeleteProjectWebhookEndpointByIdApiResponse,
      DeleteProjectWebhookEndpointByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/projects/${queryArg.projectId}/webhook-endpoints/${queryArg.webhookEndpointId}`,
        method: "DELETE",
      }),
    }),
    getProjectWebhookEndpointEvents: build.query<
      GetProjectWebhookEndpointEventsApiResponse,
      GetProjectWebhookEndpointEventsApiArg
    >({
      query: (queryArg) => ({
        url: `/projects/${queryArg.projectId}/webhook-endpoints/${queryArg.webhookEndpointId}/events`,
      }),
    }),
    getWebhookEvent: build.query<
      GetWebhookEventApiResponse,
      GetWebhookEventApiArg
    >({
      query: (queryArg) => ({
        url: `/projects/${queryArg.projectId}/webhook-endpoints/${queryArg.webhookEndpointId}/events/${queryArg.eventId}`,
      }),
    }),
    putPromptGenerator: build.mutation<
      PutPromptGeneratorApiResponse,
      PutPromptGeneratorApiArg
    >({
      query: (queryArg) => ({
        url: `/prompt-generator`,
        method: "PUT",
        body: queryArg.body,
        params: { projectId: queryArg.projectId, dryRun: queryArg.dryRun },
      }),
    }),
    getRecommendationsModels: build.query<
      GetRecommendationsModelsApiResponse,
      GetRecommendationsModelsApiArg
    >({
      query: (queryArg) => ({
        url: `/recommendations/models`,
        params: {
          excludeModelIds: queryArg.excludeModelIds,
          limit: queryArg.limit,
          nextToken: queryArg.nextToken,
          privacy: queryArg.privacy,
          projectId: queryArg.projectId,
          originalAssets: queryArg.originalAssets,
          tags: queryArg.tags,
          excludeTypes: queryArg.excludeTypes,
          modelType: queryArg.modelType,
        },
      }),
    }),
    postSearchAssets: build.mutation<
      PostSearchAssetsApiResponse,
      PostSearchAssetsApiArg
    >({
      query: (queryArg) => ({
        url: `/search/assets`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalAssets: queryArg.originalAssets,
          projectId: queryArg.projectId,
        },
      }),
    }),
    postSearchModels: build.mutation<
      PostSearchModelsApiResponse,
      PostSearchModelsApiArg
    >({
      query: (queryArg) => ({
        url: `/search/models`,
        method: "POST",
        body: queryArg.body,
        params: {
          originalModels: queryArg.originalModels,
          projectId: queryArg.projectId,
        },
      }),
    }),
    getTags: build.query<GetTagsApiResponse, GetTagsApiArg>({
      query: (queryArg) => ({
        url: `/tags`,
        params: {
          pageSize: queryArg.pageSize,
          projectId: queryArg.projectId,
          paginationToken: queryArg.paginationToken,
        },
      }),
    }),
    getTeams: build.query<GetTeamsApiResponse, GetTeamsApiArg>({
      query: () => ({ url: `/teams` }),
    }),
    postTeams: build.mutation<PostTeamsApiResponse, PostTeamsApiArg>({
      query: (queryArg) => ({
        url: `/teams`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getTeamsByTeamId: build.query<
      GetTeamsByTeamIdApiResponse,
      GetTeamsByTeamIdApiArg
    >({
      query: (queryArg) => ({ url: `/teams/${encodeURI(queryArg.teamId)}` }),
    }),
    putTeamsByTeamId: build.mutation<
      PutTeamsByTeamIdApiResponse,
      PutTeamsByTeamIdApiArg
    >({
      query: (queryArg) => ({
        url: `/teams/${encodeURI(queryArg.teamId)}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteTeamsByTeamId: build.mutation<
      DeleteTeamsByTeamIdApiResponse,
      DeleteTeamsByTeamIdApiArg
    >({
      query: (queryArg) => ({
        url: `/teams/${encodeURI(queryArg.teamId)}`,
        method: "DELETE",
      }),
    }),
    postTeamsApiKeysByTeamId: build.mutation<
      PostTeamsApiKeysByTeamIdApiResponse,
      PostTeamsApiKeysByTeamIdApiArg
    >({
      query: (queryArg) => ({
        url: `/teams/${encodeURI(queryArg.teamId)}/api-keys`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putTeamsApiKeyByTeamIdAndKeyId: build.mutation<
      PutTeamsApiKeyByTeamIdAndKeyIdApiResponse,
      PutTeamsApiKeyByTeamIdAndKeyIdApiArg
    >({
      query: (queryArg) => ({
        url: `/teams/${encodeURI(queryArg.teamId)}/api-keys/${queryArg.keyId}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteTeamsApiKeyByTeamIdAndKeyId: build.mutation<
      DeleteTeamsApiKeyByTeamIdAndKeyIdApiResponse,
      DeleteTeamsApiKeyByTeamIdAndKeyIdApiArg
    >({
      query: (queryArg) => ({
        url: `/teams/${encodeURI(queryArg.teamId)}/api-keys/${queryArg.keyId}`,
        method: "DELETE",
      }),
    }),
    deleteTeamsInvitationsByTeamId: build.mutation<
      DeleteTeamsInvitationsByTeamIdApiResponse,
      DeleteTeamsInvitationsByTeamIdApiArg
    >({
      query: (queryArg) => ({
        url: `/teams/${encodeURI(queryArg.teamId)}/invitations`,
        method: "DELETE",
        params: { email: queryArg.email },
      }),
    }),
    getTeamsLimitsByTeamId: build.query<
      GetTeamsLimitsByTeamIdApiResponse,
      GetTeamsLimitsByTeamIdApiArg
    >({
      query: (queryArg) => ({
        url: `/teams/${encodeURI(queryArg.teamId)}/limits`,
      }),
    }),
    postTeamsMembersByTeamId: build.mutation<
      PostTeamsMembersByTeamIdApiResponse,
      PostTeamsMembersByTeamIdApiArg
    >({
      query: (queryArg) => ({
        url: `/teams/${encodeURI(queryArg.teamId)}/members`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putTeamsMembersByTeamIdAndMemberId: build.mutation<
      PutTeamsMembersByTeamIdAndMemberIdApiResponse,
      PutTeamsMembersByTeamIdAndMemberIdApiArg
    >({
      query: (queryArg) => ({
        url: `/teams/${encodeURI(queryArg.teamId)}/members/${
          queryArg.memberId
        }`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteTeamsMembersByTeamIdAndMemberId: build.mutation<
      DeleteTeamsMembersByTeamIdAndMemberIdApiResponse,
      DeleteTeamsMembersByTeamIdAndMemberIdApiArg
    >({
      query: (queryArg) => ({
        url: `/teams/${encodeURI(queryArg.teamId)}/members/${
          queryArg.memberId
        }`,
        method: "DELETE",
      }),
    }),
    postTeamsOscuByTeamId: build.mutation<
      PostTeamsOscuByTeamIdApiResponse,
      PostTeamsOscuByTeamIdApiArg
    >({
      query: (queryArg) => ({
        url: `/teams/${encodeURI(queryArg.teamId)}/oscu`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postTeamsOscuAutoRefillByTeamId: build.mutation<
      PostTeamsOscuAutoRefillByTeamIdApiResponse,
      PostTeamsOscuAutoRefillByTeamIdApiArg
    >({
      query: (queryArg) => ({
        url: `/teams/${encodeURI(queryArg.teamId)}/oscu/auto-refill`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteTeamsOscuAutoRefillByTeamId: build.mutation<
      DeleteTeamsOscuAutoRefillByTeamIdApiResponse,
      DeleteTeamsOscuAutoRefillByTeamIdApiArg
    >({
      query: (queryArg) => ({
        url: `/teams/${encodeURI(queryArg.teamId)}/oscu/auto-refill`,
        method: "DELETE",
      }),
    }),
    getTeamsOscuPricesByTeamId: build.query<
      GetTeamsOscuPricesByTeamIdApiResponse,
      GetTeamsOscuPricesByTeamIdApiArg
    >({
      query: (queryArg) => ({
        url: `/teams/${encodeURI(queryArg.teamId)}/oscu/prices`,
      }),
    }),
    getTeamsSubscriptionsByTeamId: build.query<
      GetTeamsSubscriptionsByTeamIdApiResponse,
      GetTeamsSubscriptionsByTeamIdApiArg
    >({
      query: (queryArg) => ({
        url: `/teams/${encodeURI(queryArg.teamId)}/subscriptions`,
        params: { paymentProvider: queryArg.paymentProvider },
      }),
    }),
    postTeamsSubscriptionsByTeamId: build.mutation<
      PostTeamsSubscriptionsByTeamIdApiResponse,
      PostTeamsSubscriptionsByTeamIdApiArg
    >({
      query: (queryArg) => ({
        url: `/teams/${encodeURI(queryArg.teamId)}/subscriptions`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putTeamsSubscriptionsByTeamId: build.mutation<
      PutTeamsSubscriptionsByTeamIdApiResponse,
      PutTeamsSubscriptionsByTeamIdApiArg
    >({
      query: (queryArg) => ({
        url: `/teams/${encodeURI(queryArg.teamId)}/subscriptions`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteTeamsSubscriptionsByTeamId: build.mutation<
      DeleteTeamsSubscriptionsByTeamIdApiResponse,
      DeleteTeamsSubscriptionsByTeamIdApiArg
    >({
      query: (queryArg) => ({
        url: `/teams/${encodeURI(queryArg.teamId)}/subscriptions`,
        method: "DELETE",
        body: queryArg.body,
      }),
    }),
    getTeamsSubscriptionsCustomerPortalByTeamId: build.query<
      GetTeamsSubscriptionsCustomerPortalByTeamIdApiResponse,
      GetTeamsSubscriptionsCustomerPortalByTeamIdApiArg
    >({
      query: (queryArg) => ({
        url: `/teams/${encodeURI(
          queryArg.teamId
        )}/subscriptions/customer-portal`,
        params: { paymentProvider: queryArg.paymentProvider },
      }),
    }),
    postTeamsSubscriptionsSeatsByTeamId: build.mutation<
      PostTeamsSubscriptionsSeatsByTeamIdApiResponse,
      PostTeamsSubscriptionsSeatsByTeamIdApiArg
    >({
      query: (queryArg) => ({
        url: `/teams/${encodeURI(queryArg.teamId)}/subscriptions/seats`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getTeamWebhookEndpoints: build.query<
      GetTeamWebhookEndpointsApiResponse,
      GetTeamWebhookEndpointsApiArg
    >({
      query: (queryArg) => ({
        url: `/teams/${encodeURI(queryArg.teamId)}/webhook-endpoints`,
      }),
    }),
    postWebhookEndpoints: build.mutation<
      PostWebhookEndpointsApiResponse,
      PostWebhookEndpointsApiArg
    >({
      query: (queryArg) => ({
        url: `/teams/${encodeURI(queryArg.teamId)}/webhook-endpoints`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putWebhookEndpointsById: build.mutation<
      PutWebhookEndpointsByIdApiResponse,
      PutWebhookEndpointsByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/teams/${encodeURI(queryArg.teamId)}/webhook-endpoints/${
          queryArg.webhookEndpointId
        }`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteWebhookEndpointById: build.mutation<
      DeleteWebhookEndpointByIdApiResponse,
      DeleteWebhookEndpointByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/teams/${encodeURI(queryArg.teamId)}/webhook-endpoints/${
          queryArg.webhookEndpointId
        }`,
        method: "DELETE",
      }),
    }),
    postUploads: build.mutation<PostUploadsApiResponse, PostUploadsApiArg>({
      query: (queryArg) => ({
        url: `/uploads`,
        method: "POST",
        body: queryArg.body,
        params: { projectId: queryArg.projectId },
      }),
    }),
    getUploads: build.query<GetUploadsApiResponse, GetUploadsApiArg>({
      query: (queryArg) => ({
        url: `/uploads/${queryArg.uploadId}`,
        params: { projectId: queryArg.projectId },
      }),
    }),
    postUploadsAction: build.mutation<
      PostUploadsActionApiResponse,
      PostUploadsActionApiArg
    >({
      query: (queryArg) => ({
        url: `/uploads/${queryArg.uploadId}/action`,
        method: "POST",
        body: queryArg.body,
        params: { projectId: queryArg.projectId },
      }),
    }),
    getUsages: build.query<GetUsagesApiResponse, GetUsagesApiArg>({
      query: (queryArg) => ({
        url: `/usages`,
        params: {
          userId: queryArg.userId,
          activityOffset: queryArg.activityOffset,
          userIds: queryArg.userIds,
          teamId: queryArg.teamId,
          type: queryArg["type"],
          endDate: queryArg.endDate,
          projectIds: queryArg.projectIds,
          timeRange: queryArg.timeRange,
          startDate: queryArg.startDate,
        },
      }),
    }),
    postWebhooksClerkEmails: build.mutation<
      PostWebhooksClerkEmailsApiResponse,
      PostWebhooksClerkEmailsApiArg
    >({
      query: (queryArg) => ({
        url: `/webhooks/clerk/emails`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postWebhooksClerkSessions: build.mutation<
      PostWebhooksClerkSessionsApiResponse,
      PostWebhooksClerkSessionsApiArg
    >({
      query: (queryArg) => ({
        url: `/webhooks/clerk/sessions`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postWebhooksReplicateJobId: build.mutation<
      PostWebhooksReplicateJobIdApiResponse,
      PostWebhooksReplicateJobIdApiArg
    >({
      query: (queryArg) => ({
        url: `/webhooks/replicate/${queryArg.jobId}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as scenarioApi };
export type GetAssetsApiResponse = /** status 200 200 response */ {
  /** A token to query the next page of assets */
  nextPaginationToken?: string;
  assets: {
    /** Metadata of the asset with some additional information */
    metadata: {
      maxIterations?: number;
      /** Modality to detect */
      modality?:
        | "canny"
        | "depth"
        | "grayscale"
        | "lineart_anime"
        | "mlsd"
        | "normal"
        | "pose"
        | "scribble"
        | "segmentation"
        | "sketch";
      /** If set to true, during the upscaling process, the model will match tiles of the source image with tiles of the style image(s). This will result in a more coherent restyle. Works best with style images that have a similar composition. */
      tileStyle?: boolean;
      /** The modelId used to generate this asset */
      modelId?: string;
      /** A bounding box around the object of interest, in the format [x1, y1, x2, y2]. */
      bbox?: any[];
      /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
      keypointThreshold?: number;
      /** The type of the asset. Ex: 'inference-txt2img' will represent an asset generated from a text to image model */
      type:
        | "background-removal"
        | "canvas"
        | "canvas-drawing"
        | "canvas-export"
        | "detection"
        | "generative-fill"
        | "image-prompt-editing"
        | "img23d-custom"
        | "img2img-custom"
        | "img2video-custom"
        | "inference-controlnet"
        | "inference-controlnet-img2img"
        | "inference-controlnet-inpaint"
        | "inference-controlnet-inpaint-ip-adapter"
        | "inference-controlnet-ip-adapter"
        | "inference-controlnet-reference"
        | "inference-controlnet-texture"
        | "inference-img2img"
        | "inference-img2img-ip-adapter"
        | "inference-img2img-texture"
        | "inference-inpaint"
        | "inference-inpaint-ip-adapter"
        | "inference-reference"
        | "inference-reference-texture"
        | "inference-txt2img"
        | "inference-txt2img-ip-adapter"
        | "inference-txt2img-texture"
        | "patch"
        | "pixelization"
        | "reframe"
        | "restyle"
        | "segment"
        | "segmentation-image"
        | "segmentation-mask"
        | "skybox-base-360"
        | "texture"
        | "texture-albedo"
        | "texture-ao"
        | "texture-edge"
        | "texture-height"
        | "texture-metallic"
        | "texture-normal"
        | "texture-smoothness"
        | "txt23d-custom"
        | "txt2audio-custom"
        | "txt2img-custom"
        | "unknown-custom"
        | "uploaded"
        | "upscale"
        | "upscale-skybox"
        | "upscale-texture"
        | "vectorization"
        | "video2video-custom";
      /** A textual description / keywords describing the object of interest. */
      text?: string;
      height?: number;
      nbMasks?: number;
      /** Amount of decay in creativity over the upscale process. The lowest the value, the less the creativity will be preserved over the upscale process. */
      creativityDecay?: number;
      layerDifference?: number;
      /** Scaling factor (when `targetWidth` not specified) */
      scalingFactor?: number;
      /** The type of the generator used */
      modelType?:
        | "custom"
        | "flux.1"
        | "flux.1-composition"
        | "flux.1-lora"
        | "flux.1-pro"
        | "flux.1.1-pro-ultra"
        | "flux1.1-pro"
        | "gpt-image-1"
        | "sd-1_5"
        | "sd-1_5-composition"
        | "sd-1_5-lora"
        | "sd-xl"
        | "sd-xl-composition"
        | "sd-xl-lora";
      /** The number of outputs to generate. */
      numOutputs?: number;
      /** How angular is the surface? 0 is like a sphere, 1 is like a mechanical object */
      angular?: number;
      /** The target height of the output image. */
      targetHeight?: number;
      /** Flux LoRa or Composition to style the image. */
      concepts?: {
        weightName: string;
        /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
        modelId: string;
        /** The scale of the model (example: 1.0) */
        scale: number;
      }[];
      size?: number;
      spliceThreshold?: number;
      /** The number of pixels to dilate the result masks. */
      dilate?: number;
      style?:
        | "3d-cartoon"
        | "3d-rendered"
        | "anime"
        | "cartoon"
        | "cinematic"
        | "claymation"
        | "cloud-skydome"
        | "comic"
        | "cyberpunk"
        | "enchanted"
        | "fantasy"
        | "ink"
        | "manga"
        | "manga-color"
        | "minimalist"
        | "neon-tron"
        | "oil-painting"
        | "pastel"
        | "photo"
        | "photography"
        | "psychedelic"
        | "retro-fantasy"
        | "scifi-concept-art"
        | "space"
        | "standard"
        | "whimsical";
      /** Strengthen the similarity to the original image during the upscale. Default: optimized for your preset and style. */
      imageFidelity?: number;
      /** Location of the input image in the output. */
      inputLocation?: "bottom" | "left" | "middle" | "right" | "top";
      /** The seed used to generate this asset */
      seed?: string;
      /** The higher the value the more it will look like the secondary reference image(s) */
      secondaryRefFidelity?: number;
      preset?: string;
      trainingImage?: boolean;
      /** Boolean to able return the masks (binary image) in the response. */
      resultMask?: boolean;
      /** The ISO timestamp when the lock on the canvas will expire */
      lockExpiresAt?: string;
      /** The baseModelId that maybe changed at inference time */
      baseModelId?: string;
      pathPrecision?: number;
      rootParentId?: string;
      /** Sharpen tiles. */
      sharpen?: boolean;
      cornerThreshold?: number;
      /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
      styleImages?: string[];
      /** The asset to convert in texture maps. Must reference an existing AssetId. */
      texture?: string;
      filterSpeckle?: number;
      /** Minimum threshold for Grayscale conversion */
      minThreshold?: number;
      /** Maximum threshold for Grayscale conversion */
      maxThreshold?: number;
      /** Condition the influence of the style image(s). The higher the value, the more the style images will influence the upscaled image. */
      styleImagesFidelity?: number;
      /** The control image processed by depth estimator. Must reference an existing AssetId. */
      depthImage?: string;
      parentId?: string;
      parentJobId?: string;
      /** Optional List of secondary style images. Example: portrait of people. It must be existing AssetIds. */
      secondaryRefImages?: string[];
      /** The width of the rendered image. */
      width?: number;
      /** The checkpoint to use */
      checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
      strength?: number;
      /** The id of the Inference describing how this image was generated */
      inferenceId?: string;
      lengthThreshold?: number;
      /** Int to set between 0 and 255 for the opacity of the background in the result images. */
      backgroundOpacity?: number;
      /** The optional aspect ratio given for the generation, only applicable for some models */
      aspectRatio?: string;
      /** Amount of details to remove or add */
      detailsLevel?: number;
      /** Determine the scale at which the upscale process works.
            - With a small value, the upscale works at the largest scale, resulting in fewer added details and more coherent images. Ideal for portraits, for example.
            - With a large value, the upscale works at the smallest scale, resulting in more added details and more hallucinations. Ideal for landscapes, for example.
            
            (info): A small value is slower and more expensive to run. */
      fractality?: number;
      /** (deprecated) Horizontal expansion ratio. */
      horizontalExpansionRatio?: number;
      /** List of points (label, x, y) in the image where label = 0 for background and 1 for object. */
      points?: any[][];
      mode?: string;
      colorPrecision?: number;
      /** Increase the fidelity to the prompt during upscale. Default: optimized for your preset and style. */
      promptFidelity?: number;
      /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
      betterQuality?: boolean;
      /** Remove background for Grayscale detector */
      removeBackground?: boolean;
      /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your preset and style. */
      creativity?: number;
      /** Strength for the input image structure preservation */
      structureFidelity?: number;
      /** Preserve the seamless properties of skybox or texture images. Input has to be of same type (seamless). */
      imageType?: "seamfull" | "skybox" | "texture";
      /** The input image to process. Must reference an existing AssetId or be a data URL. */
      image?: string;
      /** The thumbnail of the canvas */
      thumbnail?: {
        /** The AssetId of the image used as a thumbnail for the canvas (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        assetId: string;
        /** The url of the image used as a thumbnail for the canvas */
        url: string;
      };
      /** The control image for structure. A canny detector will be applied to this image. Must reference an existing AssetId. */
      structureImage?: string;
      /** To invert the relief */
      invert?: boolean;
      kind: "3d" | "audio" | "document" | "image" | "json" | "video";
      colorMode?: string;
      /** High threshold for Canny detector */
      highThreshold?: number;
      /** (deprecated) Vertical expansion ratio. */
      verticalExpansionRatio?: number;
      halfMode?: boolean;
      name?: string;
      /** Additional refinement steps before scaling.
            
            If scalingFactor == 1, the refinement process will be applied (1 + refinementSteps) times.
            If scalingFactor > 1, the refinement process will be applied refinementSteps times. */
      refinementSteps?: number;
      /** The reference images used for the image generation or editing */
      referenceImages?: string[];
      /** The higher the value the more it will look like the style image(s) */
      styleFidelity?: number;
      /** Boolean to output the contours. */
      resultContours?: boolean;
      /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
      polished?: number;
      /** The scheduler used to generate this asset */
      scheduler?: string;
      /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
      overrideEmbeddings?: boolean;
      progressPercent?: number;
      /** Contrast factor for Grayscale detector */
      factor?: number;
      /** The mask used for the image generation or editing */
      mask?: string;
      /** Low threshold for Canny detector */
      lowThreshold?: number;
      /** The depth fidelity if a depth image provided */
      depthFidelity?: number;
      /** How raised is the surface? 0 is flat like water, 1 is like a very rough rock */
      raised?: number;
      message?: string;
      contours?: number[][][][];
      /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
      negativePrompt?: string;
      /** If true, use the default parameters */
      defaultParameters?: boolean;
      /** Size proportion of the input image in the output. */
      resizeOption?: number;
      outputIndex?: number;
      /** Save a flipbook of the texture. Deactivated when the input texture is larger than 2048x2048px */
      saveFlipbook?: boolean;
      /** The guidance used to generate this asset */
      guidance?: number;
      /** The number of denoising steps for each image generation. */
      numInferenceSteps?: number;
      hdr?: number;
      /** How shiny is the surface? 0 is like a matte surface, 1 is like a diamond */
      shiny?: number;
      /** Ensure upscaled tile have the same color histogram as original tile. */
      colorCorrection?: boolean;
      /** Overlap percentage for the output image. */
      overlapPercentage?: number;
      /** The prompt that guided the image generation or editing */
      prompt?: string;
      /** Boolean to able output the cut out object. */
      resultImage?: boolean;
      /** The control image already processed by canny detector. Must reference an existing AssetId. */
      cannyStructureImage?: string;
      /** Apply extra control to the Skybox 360 geometry.
            The higher the value, the more the 360 geometry will influence the generated skybox image.
            
            Use with caution. Default is adapted to the other parameters. */
      geometryEnforcement?: number;
      /** Target width for the upscaled image, take priority over scaling factor */
      targetWidth?: number;
    };
    /** The NSFW labels */
    nsfw?: string[];
    /** Automatic captioning of the asset */
    automaticCaptioning?: string;
    /** The description of the asset */
    description?: string;
    /** The privacy of the asset */
    privacy: "private" | "public" | "unlisted";
    /** The date when the asset will be soft deleted (only for Free plan) */
    softDeletionOn?: string;
    /** The mime type of the asset (example: "image/png") */
    mimeType: string;
    /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
    authorId: string;
    /** The owner (project) ID (example: "proj_23tlk332lkht3kl2" or "team_dlkhgs23tlk3hlkth32lkht3kl2" for old teams) */
    ownerId: string;
    /** Signed URL to get the asset content */
    url: string;
    /** The associated tags (example: ["sci-fi", "landscape"]) */
    tags: string[];
    /** The asset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt: string;
    /** The output index of the asset within the job
        This index is an positive integer that starts at 0
        It is used to differentiate between multiple outputs of the same job
        If the job has only one output, this index is 0
        This is only applicable for generations with: Flux, Skybox, Reframe at the moment */
    outputIndex?: number;
    /** A list of CollectionId this asset belongs to */
    collectionIds: string[];
    /** List of edit capabilities for the asset */
    editCapabilities: (
      | "DETECTION"
      | "GENERATIVE_FILL"
      | "PIXELATE"
      | "PROMPT_EDITING"
      | "REFINE"
      | "REFRAME"
      | "REMOVE_BACKGROUND"
      | "SEGMENTATION"
      | "UPSCALE"
      | "UPSCALE_360"
      | "VECTORIZATION"
    )[];
    /** The embedding of the asset when requested and asset can be embedded
        
        ie: Detection maps don't have embeddings */
    embedding?: number[];
    /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
    id: string;
    /** The status of the asset */
    status: "error" | "pending" | "success";
    /** The asset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    updatedAt: string;
  }[];
};
export type GetAssetsApiArg = {
  /** Filter results to only return assets updated before the specified ISO string date (exclusive). Requires the sortBy parameter to be "updatedAt" */
  updatedBefore?: string;
  /** Sort results in ascending (asc) or descending (desc) order */
  sortDirection?: string;
  /** Filters result by asset privacy. If set to public, it will return -all- public assets from all organizations */
  privacy?: string;
  /** List assets generated from a specific inference */
  inferenceId?: string;
  /** List assets generated from all inferences coming from a specific model (this is not the training images) */
  modelId?: string;
  /** Filter results to only return assets updated after the specified ISO string date (exclusive). Requires the sortBy parameter to be "updatedAt" */
  updatedAfter?: string;
  /** List all the children assets that were generated from a specific parent asset */
  parentAssetId?: string;
  /** Filter results to only return assets created before the specified ISO string date (exclusive). Requires the sortBy parameter to be "createdAt" */
  createdBefore?: string;
  /** Sort results by the createdAt or updatedAt */
  sortBy?: string;
  /** Filter results to only return assets created after the specified ISO string date (exclusive). Requires the sortBy parameter to be "createdAt" */
  createdAfter?: string;
  /** List assets generated by a specific author (the user that created the asset) */
  authorId?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The number of items to return in the response. The default value is 50, maximum value is 100, minimum value is 1 */
  pageSize?: string;
  /** List all the children assets that were generated from a specific root asset */
  rootAssetId?: string;
  /** List all the assets of a specific type. The parameter "type" and "types" cannot be used together. Can be any of the following values: inference-txt2img, inference-txt2img-ip-adapter, inference-txt2img-texture, inference-img2img, inference-img2img-ip-adapter, inference-img2img-texture, inference-inpaint, inference-inpaint-ip-adapter, inference-reference, inference-reference-texture, inference-controlnet, inference-controlnet-ip-adapter, inference-controlnet-img2img, inference-controlnet-reference, inference-controlnet-inpaint, inference-controlnet-inpaint-ip-adapter, inference-controlnet-texture, background-removal, canvas, canvas-export, canvas-drawing, detection, patch, pixelization, uploaded, upscale, upscale-texture, upscale-skybox, vectorization, segment, segmentation-image, segmentation-mask, skybox-base-360, restyle, reframe, generative-fill, texture, texture-height, texture-normal, texture-smoothness, texture-metallic, texture-edge, texture-ao, texture-albedo, image-prompt-editing, unknown-custom, txt2img-custom, img2img-custom, img23d-custom, txt23d-custom, img2video-custom, txt2audio-custom, video2video-custom, assets with a type starting with "inference-" will be returned */
  type?:
    | "background-removal"
    | "canvas"
    | "canvas-drawing"
    | "canvas-export"
    | "detection"
    | "generative-fill"
    | "image-prompt-editing"
    | "img23d-custom"
    | "img2img-custom"
    | "img2video-custom"
    | "inference-controlnet"
    | "inference-controlnet-img2img"
    | "inference-controlnet-inpaint"
    | "inference-controlnet-inpaint-ip-adapter"
    | "inference-controlnet-ip-adapter"
    | "inference-controlnet-reference"
    | "inference-controlnet-texture"
    | "inference-img2img"
    | "inference-img2img-ip-adapter"
    | "inference-img2img-texture"
    | "inference-inpaint"
    | "inference-inpaint-ip-adapter"
    | "inference-reference"
    | "inference-reference-texture"
    | "inference-txt2img"
    | "inference-txt2img-ip-adapter"
    | "inference-txt2img-texture"
    | "patch"
    | "pixelization"
    | "reframe"
    | "restyle"
    | "segment"
    | "segmentation-image"
    | "segmentation-mask"
    | "skybox-base-360"
    | "texture"
    | "texture-albedo"
    | "texture-ao"
    | "texture-edge"
    | "texture-height"
    | "texture-metallic"
    | "texture-normal"
    | "texture-smoothness"
    | "txt23d-custom"
    | "txt2audio-custom"
    | "txt2img-custom"
    | "unknown-custom"
    | "uploaded"
    | "upscale"
    | "upscale-skybox"
    | "upscale-texture"
    | "vectorization"
    | "video2video-custom";
  /** A token you received in a previous request to query the next page of items */
  paginationToken?: string;
  /** List of tags, comma separated. Only for public assets on all teams. */
  tags?: string;
  /** List of the asset types to request. The parameter "type" and "types" cannot be used together. Can be any of the following values: inference-txt2img, inference-txt2img-ip-adapter, inference-txt2img-texture, inference-img2img, inference-img2img-ip-adapter, inference-img2img-texture, inference-inpaint, inference-inpaint-ip-adapter, inference-reference, inference-reference-texture, inference-controlnet, inference-controlnet-ip-adapter, inference-controlnet-img2img, inference-controlnet-reference, inference-controlnet-inpaint, inference-controlnet-inpaint-ip-adapter, inference-controlnet-texture, background-removal, canvas, canvas-export, canvas-drawing, detection, patch, pixelization, uploaded, upscale, upscale-texture, upscale-skybox, vectorization, segment, segmentation-image, segmentation-mask, skybox-base-360, restyle, reframe, generative-fill, texture, texture-height, texture-normal, texture-smoothness, texture-metallic, texture-edge, texture-ao, texture-albedo, image-prompt-editing, unknown-custom, txt2img-custom, img2img-custom, img23d-custom, txt23d-custom, img2video-custom, txt2audio-custom, video2video-custom */
  types?: (
    | "background-removal"
    | "canvas"
    | "canvas-drawing"
    | "canvas-export"
    | "detection"
    | "generative-fill"
    | "image-prompt-editing"
    | "img23d-custom"
    | "img2img-custom"
    | "img2video-custom"
    | "inference-controlnet"
    | "inference-controlnet-img2img"
    | "inference-controlnet-inpaint"
    | "inference-controlnet-inpaint-ip-adapter"
    | "inference-controlnet-ip-adapter"
    | "inference-controlnet-reference"
    | "inference-controlnet-texture"
    | "inference-img2img"
    | "inference-img2img-ip-adapter"
    | "inference-img2img-texture"
    | "inference-inpaint"
    | "inference-inpaint-ip-adapter"
    | "inference-reference"
    | "inference-reference-texture"
    | "inference-txt2img"
    | "inference-txt2img-ip-adapter"
    | "inference-txt2img-texture"
    | "patch"
    | "pixelization"
    | "reframe"
    | "restyle"
    | "segment"
    | "segmentation-image"
    | "segmentation-mask"
    | "skybox-base-360"
    | "texture"
    | "texture-albedo"
    | "texture-ao"
    | "texture-edge"
    | "texture-height"
    | "texture-metallic"
    | "texture-normal"
    | "texture-smoothness"
    | "txt23d-custom"
    | "txt2audio-custom"
    | "txt2img-custom"
    | "unknown-custom"
    | "uploaded"
    | "upscale"
    | "upscale-skybox"
    | "upscale-texture"
    | "vectorization"
    | "video2video-custom"
  )[];
  collectionId?: string;
};
export type PostAssetApiResponse = /** status 200 200 response */ {
  asset: {
    /** Metadata of the asset with some additional information */
    metadata: {
      maxIterations?: number;
      /** Modality to detect */
      modality?:
        | "canny"
        | "depth"
        | "grayscale"
        | "lineart_anime"
        | "mlsd"
        | "normal"
        | "pose"
        | "scribble"
        | "segmentation"
        | "sketch";
      /** If set to true, during the upscaling process, the model will match tiles of the source image with tiles of the style image(s). This will result in a more coherent restyle. Works best with style images that have a similar composition. */
      tileStyle?: boolean;
      /** The modelId used to generate this asset */
      modelId?: string;
      /** A bounding box around the object of interest, in the format [x1, y1, x2, y2]. */
      bbox?: any[];
      /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
      keypointThreshold?: number;
      /** The type of the asset. Ex: 'inference-txt2img' will represent an asset generated from a text to image model */
      type:
        | "background-removal"
        | "canvas"
        | "canvas-drawing"
        | "canvas-export"
        | "detection"
        | "generative-fill"
        | "image-prompt-editing"
        | "img23d-custom"
        | "img2img-custom"
        | "img2video-custom"
        | "inference-controlnet"
        | "inference-controlnet-img2img"
        | "inference-controlnet-inpaint"
        | "inference-controlnet-inpaint-ip-adapter"
        | "inference-controlnet-ip-adapter"
        | "inference-controlnet-reference"
        | "inference-controlnet-texture"
        | "inference-img2img"
        | "inference-img2img-ip-adapter"
        | "inference-img2img-texture"
        | "inference-inpaint"
        | "inference-inpaint-ip-adapter"
        | "inference-reference"
        | "inference-reference-texture"
        | "inference-txt2img"
        | "inference-txt2img-ip-adapter"
        | "inference-txt2img-texture"
        | "patch"
        | "pixelization"
        | "reframe"
        | "restyle"
        | "segment"
        | "segmentation-image"
        | "segmentation-mask"
        | "skybox-base-360"
        | "texture"
        | "texture-albedo"
        | "texture-ao"
        | "texture-edge"
        | "texture-height"
        | "texture-metallic"
        | "texture-normal"
        | "texture-smoothness"
        | "txt23d-custom"
        | "txt2audio-custom"
        | "txt2img-custom"
        | "unknown-custom"
        | "uploaded"
        | "upscale"
        | "upscale-skybox"
        | "upscale-texture"
        | "vectorization"
        | "video2video-custom";
      /** A textual description / keywords describing the object of interest. */
      text?: string;
      height?: number;
      nbMasks?: number;
      /** Amount of decay in creativity over the upscale process. The lowest the value, the less the creativity will be preserved over the upscale process. */
      creativityDecay?: number;
      layerDifference?: number;
      /** Scaling factor (when `targetWidth` not specified) */
      scalingFactor?: number;
      /** The type of the generator used */
      modelType?:
        | "custom"
        | "flux.1"
        | "flux.1-composition"
        | "flux.1-lora"
        | "flux.1-pro"
        | "flux.1.1-pro-ultra"
        | "flux1.1-pro"
        | "gpt-image-1"
        | "sd-1_5"
        | "sd-1_5-composition"
        | "sd-1_5-lora"
        | "sd-xl"
        | "sd-xl-composition"
        | "sd-xl-lora";
      /** The number of outputs to generate. */
      numOutputs?: number;
      /** How angular is the surface? 0 is like a sphere, 1 is like a mechanical object */
      angular?: number;
      /** The target height of the output image. */
      targetHeight?: number;
      /** Flux LoRa or Composition to style the image. */
      concepts?: {
        weightName: string;
        /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
        modelId: string;
        /** The scale of the model (example: 1.0) */
        scale: number;
      }[];
      size?: number;
      spliceThreshold?: number;
      /** The number of pixels to dilate the result masks. */
      dilate?: number;
      style?:
        | "3d-cartoon"
        | "3d-rendered"
        | "anime"
        | "cartoon"
        | "cinematic"
        | "claymation"
        | "cloud-skydome"
        | "comic"
        | "cyberpunk"
        | "enchanted"
        | "fantasy"
        | "ink"
        | "manga"
        | "manga-color"
        | "minimalist"
        | "neon-tron"
        | "oil-painting"
        | "pastel"
        | "photo"
        | "photography"
        | "psychedelic"
        | "retro-fantasy"
        | "scifi-concept-art"
        | "space"
        | "standard"
        | "whimsical";
      /** Strengthen the similarity to the original image during the upscale. Default: optimized for your preset and style. */
      imageFidelity?: number;
      /** Location of the input image in the output. */
      inputLocation?: "bottom" | "left" | "middle" | "right" | "top";
      /** The seed used to generate this asset */
      seed?: string;
      /** The higher the value the more it will look like the secondary reference image(s) */
      secondaryRefFidelity?: number;
      preset?: string;
      trainingImage?: boolean;
      /** Boolean to able return the masks (binary image) in the response. */
      resultMask?: boolean;
      /** The ISO timestamp when the lock on the canvas will expire */
      lockExpiresAt?: string;
      /** The baseModelId that maybe changed at inference time */
      baseModelId?: string;
      pathPrecision?: number;
      rootParentId?: string;
      /** Sharpen tiles. */
      sharpen?: boolean;
      cornerThreshold?: number;
      /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
      styleImages?: string[];
      /** The asset to convert in texture maps. Must reference an existing AssetId. */
      texture?: string;
      filterSpeckle?: number;
      /** Minimum threshold for Grayscale conversion */
      minThreshold?: number;
      /** Maximum threshold for Grayscale conversion */
      maxThreshold?: number;
      /** Condition the influence of the style image(s). The higher the value, the more the style images will influence the upscaled image. */
      styleImagesFidelity?: number;
      /** The control image processed by depth estimator. Must reference an existing AssetId. */
      depthImage?: string;
      parentId?: string;
      parentJobId?: string;
      /** Optional List of secondary style images. Example: portrait of people. It must be existing AssetIds. */
      secondaryRefImages?: string[];
      /** The width of the rendered image. */
      width?: number;
      /** The checkpoint to use */
      checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
      strength?: number;
      /** The id of the Inference describing how this image was generated */
      inferenceId?: string;
      lengthThreshold?: number;
      /** Int to set between 0 and 255 for the opacity of the background in the result images. */
      backgroundOpacity?: number;
      /** The optional aspect ratio given for the generation, only applicable for some models */
      aspectRatio?: string;
      /** Amount of details to remove or add */
      detailsLevel?: number;
      /** Determine the scale at which the upscale process works.
            - With a small value, the upscale works at the largest scale, resulting in fewer added details and more coherent images. Ideal for portraits, for example.
            - With a large value, the upscale works at the smallest scale, resulting in more added details and more hallucinations. Ideal for landscapes, for example.
            
            (info): A small value is slower and more expensive to run. */
      fractality?: number;
      /** (deprecated) Horizontal expansion ratio. */
      horizontalExpansionRatio?: number;
      /** List of points (label, x, y) in the image where label = 0 for background and 1 for object. */
      points?: any[][];
      mode?: string;
      colorPrecision?: number;
      /** Increase the fidelity to the prompt during upscale. Default: optimized for your preset and style. */
      promptFidelity?: number;
      /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
      betterQuality?: boolean;
      /** Remove background for Grayscale detector */
      removeBackground?: boolean;
      /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your preset and style. */
      creativity?: number;
      /** Strength for the input image structure preservation */
      structureFidelity?: number;
      /** Preserve the seamless properties of skybox or texture images. Input has to be of same type (seamless). */
      imageType?: "seamfull" | "skybox" | "texture";
      /** The input image to process. Must reference an existing AssetId or be a data URL. */
      image?: string;
      /** The thumbnail of the canvas */
      thumbnail?: {
        /** The AssetId of the image used as a thumbnail for the canvas (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        assetId: string;
        /** The url of the image used as a thumbnail for the canvas */
        url: string;
      };
      /** The control image for structure. A canny detector will be applied to this image. Must reference an existing AssetId. */
      structureImage?: string;
      /** To invert the relief */
      invert?: boolean;
      kind: "3d" | "audio" | "document" | "image" | "json" | "video";
      colorMode?: string;
      /** High threshold for Canny detector */
      highThreshold?: number;
      /** (deprecated) Vertical expansion ratio. */
      verticalExpansionRatio?: number;
      halfMode?: boolean;
      name?: string;
      /** Additional refinement steps before scaling.
            
            If scalingFactor == 1, the refinement process will be applied (1 + refinementSteps) times.
            If scalingFactor > 1, the refinement process will be applied refinementSteps times. */
      refinementSteps?: number;
      /** The reference images used for the image generation or editing */
      referenceImages?: string[];
      /** The higher the value the more it will look like the style image(s) */
      styleFidelity?: number;
      /** Boolean to output the contours. */
      resultContours?: boolean;
      /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
      polished?: number;
      /** The scheduler used to generate this asset */
      scheduler?: string;
      /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
      overrideEmbeddings?: boolean;
      progressPercent?: number;
      /** Contrast factor for Grayscale detector */
      factor?: number;
      /** The mask used for the image generation or editing */
      mask?: string;
      /** Low threshold for Canny detector */
      lowThreshold?: number;
      /** The depth fidelity if a depth image provided */
      depthFidelity?: number;
      /** How raised is the surface? 0 is flat like water, 1 is like a very rough rock */
      raised?: number;
      message?: string;
      contours?: number[][][][];
      /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
      negativePrompt?: string;
      /** If true, use the default parameters */
      defaultParameters?: boolean;
      /** Size proportion of the input image in the output. */
      resizeOption?: number;
      outputIndex?: number;
      /** Save a flipbook of the texture. Deactivated when the input texture is larger than 2048x2048px */
      saveFlipbook?: boolean;
      /** The guidance used to generate this asset */
      guidance?: number;
      /** The number of denoising steps for each image generation. */
      numInferenceSteps?: number;
      hdr?: number;
      /** How shiny is the surface? 0 is like a matte surface, 1 is like a diamond */
      shiny?: number;
      /** Ensure upscaled tile have the same color histogram as original tile. */
      colorCorrection?: boolean;
      /** Overlap percentage for the output image. */
      overlapPercentage?: number;
      /** The prompt that guided the image generation or editing */
      prompt?: string;
      /** Boolean to able output the cut out object. */
      resultImage?: boolean;
      /** The control image already processed by canny detector. Must reference an existing AssetId. */
      cannyStructureImage?: string;
      /** Apply extra control to the Skybox 360 geometry.
            The higher the value, the more the 360 geometry will influence the generated skybox image.
            
            Use with caution. Default is adapted to the other parameters. */
      geometryEnforcement?: number;
      /** Target width for the upscaled image, take priority over scaling factor */
      targetWidth?: number;
    };
    /** The NSFW labels */
    nsfw?: string[];
    /** Automatic captioning of the asset */
    automaticCaptioning?: string;
    /** The description of the asset */
    description?: string;
    /** The privacy of the asset */
    privacy: "private" | "public" | "unlisted";
    /** The date when the asset will be soft deleted (only for Free plan) */
    softDeletionOn?: string;
    /** The mime type of the asset (example: "image/png") */
    mimeType: string;
    /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
    authorId: string;
    /** The owner (project) ID (example: "proj_23tlk332lkht3kl2" or "team_dlkhgs23tlk3hlkth32lkht3kl2" for old teams) */
    ownerId: string;
    /** Signed URL to get the asset content */
    url: string;
    /** The associated tags (example: ["sci-fi", "landscape"]) */
    tags: string[];
    /** The asset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt: string;
    /** The output index of the asset within the job
        This index is an positive integer that starts at 0
        It is used to differentiate between multiple outputs of the same job
        If the job has only one output, this index is 0
        This is only applicable for generations with: Flux, Skybox, Reframe at the moment */
    outputIndex?: number;
    /** A list of CollectionId this asset belongs to */
    collectionIds: string[];
    /** List of edit capabilities for the asset */
    editCapabilities: (
      | "DETECTION"
      | "GENERATIVE_FILL"
      | "PIXELATE"
      | "PROMPT_EDITING"
      | "REFINE"
      | "REFRAME"
      | "REMOVE_BACKGROUND"
      | "SEGMENTATION"
      | "UPSCALE"
      | "UPSCALE_360"
      | "VECTORIZATION"
    )[];
    /** The embedding of the asset when requested and asset can be embedded
        
        ie: Detection maps don't have embeddings */
    embedding?: number[];
    /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
    id: string;
    /** The status of the asset */
    status: "error" | "pending" | "success";
    /** The asset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    updatedAt: string;
  };
  job?: {
    /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt: string;
    /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
    jobId: string;
    /** Metadata of the job with some additional information */
    metadata: {
      /** The output of the job */
      output?: {};
      /** The inputs for the job */
      input?: {};
      /** List of produced assets for this job */
      assetIds?: string[];
    };
    /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
    statusHistory: {
      date: string;
      status:
        | "canceled"
        | "failure"
        | "in-progress"
        | "queued"
        | "success"
        | "warming-up";
    }[];
    /** Progress of the job (between 0 and 1) */
    progress: number;
    /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
    authorId?: string;
    /** The type of job */
    jobType:
      | "assets-download"
      | "canvas-export"
      | "caption"
      | "caption-llava"
      | "custom"
      | "describe-style"
      | "detection"
      | "embed"
      | "flux"
      | "flux-model-training"
      | "generate-prompt"
      | "image-generation"
      | "image-prompt-editing"
      | "inference"
      | "model-download"
      | "model-import"
      | "model-training"
      | "openai-image-generation"
      | "patch-image"
      | "pixelate"
      | "reframe"
      | "remove-background"
      | "repaint"
      | "restyle"
      | "segment"
      | "skybox-base-360"
      | "skybox-upscale-360"
      | "texture"
      | "translate"
      | "upload"
      | "upscale"
      | "upscale-skybox"
      | "upscale-texture"
      | "vectorize";
    /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
    ownerId?: string;
    /** The current status of the job */
    status:
      | "canceled"
      | "failure"
      | "in-progress"
      | "queued"
      | "success"
      | "warming-up";
    /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    updatedAt: string;
  };
};
export type PostAssetApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** The image to upload in base64 format string. */
    image?: string;
    /** The canvas to upload as a stringified JSON. Ignored if `image` is provided. */
    canvas?: string;
    /** The thumbnail for the canvas in base64 format string. Ignored if `image` is provided. */
    thumbnail?: string;
    /** Toggles the hidden status of the asset. */
    hide?: boolean;
    /** The IDs of the collections to add the asset to. If provided, the new asset will be added to the collections. */
    collectionIds?: string[];
    /** The original file name of the image (example: "low-res-image.jpg"). */
    name: string;
    /** Specifies the parent asset Id for the asset. */
    parentId?: string;
  };
};
export type DeleteAssetApiResponse = /** status 200 200 response */ any;
export type DeleteAssetApiArg = {
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** The ids of the assets to delete. (Max 100 at once) */
    assetIds: string[];
  };
};
export type PostDownloadAssetsApiResponse = /** status 200 200 response */ {
  /** The job id associated with the download request */
  jobId: string;
};
export type PostDownloadAssetsApiArg = {
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    query: {
      /** All assets issued from the provided model ids will be included in the archive */
      modelIds: string[];
      /** All assets issued from the provided inference ids will be included in the archive */
      inferenceIds: string[];
      /** Every individual assets specified will be included in the archive */
      assetIds: string[];
    };
    options: {
      /** A file naming convention as a string with the following available parameters:
            <seed> (seed used to generate the asset)
            <num> (index of the asset in the inference)
            <prompt> (prompt of the inference)
            <generator> (prompt of the generator)
            Example: "<generator>-<prompt>-<num>-<seed>" */
      fileNameTemplate: string;
      /** Flag to prevent grouping assets in directories and store them flat */
      flat?: boolean;
    };
  };
};
export type GetDownloadAssetsApiResponse = /** status 200 200 response */ {
  /** The job id associated with the download request */
  jobId: string;
  /** The current job status */
  jobStatus: string;
  /** The download url */
  downloadUrl?: string;
};
export type GetDownloadAssetsApiArg = {
  /** The job ID to retrieve the download request */
  jobId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
};
export type PostAssetGetBulkApiResponse = /** status 200 200 response */ {
  assets: {
    /** Metadata of the asset with some additional information */
    metadata: {
      maxIterations?: number;
      /** Modality to detect */
      modality?:
        | "canny"
        | "depth"
        | "grayscale"
        | "lineart_anime"
        | "mlsd"
        | "normal"
        | "pose"
        | "scribble"
        | "segmentation"
        | "sketch";
      /** If set to true, during the upscaling process, the model will match tiles of the source image with tiles of the style image(s). This will result in a more coherent restyle. Works best with style images that have a similar composition. */
      tileStyle?: boolean;
      /** The modelId used to generate this asset */
      modelId?: string;
      /** A bounding box around the object of interest, in the format [x1, y1, x2, y2]. */
      bbox?: any[];
      /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
      keypointThreshold?: number;
      /** The type of the asset. Ex: 'inference-txt2img' will represent an asset generated from a text to image model */
      type:
        | "background-removal"
        | "canvas"
        | "canvas-drawing"
        | "canvas-export"
        | "detection"
        | "generative-fill"
        | "image-prompt-editing"
        | "img23d-custom"
        | "img2img-custom"
        | "img2video-custom"
        | "inference-controlnet"
        | "inference-controlnet-img2img"
        | "inference-controlnet-inpaint"
        | "inference-controlnet-inpaint-ip-adapter"
        | "inference-controlnet-ip-adapter"
        | "inference-controlnet-reference"
        | "inference-controlnet-texture"
        | "inference-img2img"
        | "inference-img2img-ip-adapter"
        | "inference-img2img-texture"
        | "inference-inpaint"
        | "inference-inpaint-ip-adapter"
        | "inference-reference"
        | "inference-reference-texture"
        | "inference-txt2img"
        | "inference-txt2img-ip-adapter"
        | "inference-txt2img-texture"
        | "patch"
        | "pixelization"
        | "reframe"
        | "restyle"
        | "segment"
        | "segmentation-image"
        | "segmentation-mask"
        | "skybox-base-360"
        | "texture"
        | "texture-albedo"
        | "texture-ao"
        | "texture-edge"
        | "texture-height"
        | "texture-metallic"
        | "texture-normal"
        | "texture-smoothness"
        | "txt23d-custom"
        | "txt2audio-custom"
        | "txt2img-custom"
        | "unknown-custom"
        | "uploaded"
        | "upscale"
        | "upscale-skybox"
        | "upscale-texture"
        | "vectorization"
        | "video2video-custom";
      /** A textual description / keywords describing the object of interest. */
      text?: string;
      height?: number;
      nbMasks?: number;
      /** Amount of decay in creativity over the upscale process. The lowest the value, the less the creativity will be preserved over the upscale process. */
      creativityDecay?: number;
      layerDifference?: number;
      /** Scaling factor (when `targetWidth` not specified) */
      scalingFactor?: number;
      /** The type of the generator used */
      modelType?:
        | "custom"
        | "flux.1"
        | "flux.1-composition"
        | "flux.1-lora"
        | "flux.1-pro"
        | "flux.1.1-pro-ultra"
        | "flux1.1-pro"
        | "gpt-image-1"
        | "sd-1_5"
        | "sd-1_5-composition"
        | "sd-1_5-lora"
        | "sd-xl"
        | "sd-xl-composition"
        | "sd-xl-lora";
      /** The number of outputs to generate. */
      numOutputs?: number;
      /** How angular is the surface? 0 is like a sphere, 1 is like a mechanical object */
      angular?: number;
      /** The target height of the output image. */
      targetHeight?: number;
      /** Flux LoRa or Composition to style the image. */
      concepts?: {
        weightName: string;
        /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
        modelId: string;
        /** The scale of the model (example: 1.0) */
        scale: number;
      }[];
      size?: number;
      spliceThreshold?: number;
      /** The number of pixels to dilate the result masks. */
      dilate?: number;
      style?:
        | "3d-cartoon"
        | "3d-rendered"
        | "anime"
        | "cartoon"
        | "cinematic"
        | "claymation"
        | "cloud-skydome"
        | "comic"
        | "cyberpunk"
        | "enchanted"
        | "fantasy"
        | "ink"
        | "manga"
        | "manga-color"
        | "minimalist"
        | "neon-tron"
        | "oil-painting"
        | "pastel"
        | "photo"
        | "photography"
        | "psychedelic"
        | "retro-fantasy"
        | "scifi-concept-art"
        | "space"
        | "standard"
        | "whimsical";
      /** Strengthen the similarity to the original image during the upscale. Default: optimized for your preset and style. */
      imageFidelity?: number;
      /** Location of the input image in the output. */
      inputLocation?: "bottom" | "left" | "middle" | "right" | "top";
      /** The seed used to generate this asset */
      seed?: string;
      /** The higher the value the more it will look like the secondary reference image(s) */
      secondaryRefFidelity?: number;
      preset?: string;
      trainingImage?: boolean;
      /** Boolean to able return the masks (binary image) in the response. */
      resultMask?: boolean;
      /** The ISO timestamp when the lock on the canvas will expire */
      lockExpiresAt?: string;
      /** The baseModelId that maybe changed at inference time */
      baseModelId?: string;
      pathPrecision?: number;
      rootParentId?: string;
      /** Sharpen tiles. */
      sharpen?: boolean;
      cornerThreshold?: number;
      /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
      styleImages?: string[];
      /** The asset to convert in texture maps. Must reference an existing AssetId. */
      texture?: string;
      filterSpeckle?: number;
      /** Minimum threshold for Grayscale conversion */
      minThreshold?: number;
      /** Maximum threshold for Grayscale conversion */
      maxThreshold?: number;
      /** Condition the influence of the style image(s). The higher the value, the more the style images will influence the upscaled image. */
      styleImagesFidelity?: number;
      /** The control image processed by depth estimator. Must reference an existing AssetId. */
      depthImage?: string;
      parentId?: string;
      parentJobId?: string;
      /** Optional List of secondary style images. Example: portrait of people. It must be existing AssetIds. */
      secondaryRefImages?: string[];
      /** The width of the rendered image. */
      width?: number;
      /** The checkpoint to use */
      checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
      strength?: number;
      /** The id of the Inference describing how this image was generated */
      inferenceId?: string;
      lengthThreshold?: number;
      /** Int to set between 0 and 255 for the opacity of the background in the result images. */
      backgroundOpacity?: number;
      /** The optional aspect ratio given for the generation, only applicable for some models */
      aspectRatio?: string;
      /** Amount of details to remove or add */
      detailsLevel?: number;
      /** Determine the scale at which the upscale process works.
            - With a small value, the upscale works at the largest scale, resulting in fewer added details and more coherent images. Ideal for portraits, for example.
            - With a large value, the upscale works at the smallest scale, resulting in more added details and more hallucinations. Ideal for landscapes, for example.
            
            (info): A small value is slower and more expensive to run. */
      fractality?: number;
      /** (deprecated) Horizontal expansion ratio. */
      horizontalExpansionRatio?: number;
      /** List of points (label, x, y) in the image where label = 0 for background and 1 for object. */
      points?: any[][];
      mode?: string;
      colorPrecision?: number;
      /** Increase the fidelity to the prompt during upscale. Default: optimized for your preset and style. */
      promptFidelity?: number;
      /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
      betterQuality?: boolean;
      /** Remove background for Grayscale detector */
      removeBackground?: boolean;
      /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your preset and style. */
      creativity?: number;
      /** Strength for the input image structure preservation */
      structureFidelity?: number;
      /** Preserve the seamless properties of skybox or texture images. Input has to be of same type (seamless). */
      imageType?: "seamfull" | "skybox" | "texture";
      /** The input image to process. Must reference an existing AssetId or be a data URL. */
      image?: string;
      /** The thumbnail of the canvas */
      thumbnail?: {
        /** The AssetId of the image used as a thumbnail for the canvas (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        assetId: string;
        /** The url of the image used as a thumbnail for the canvas */
        url: string;
      };
      /** The control image for structure. A canny detector will be applied to this image. Must reference an existing AssetId. */
      structureImage?: string;
      /** To invert the relief */
      invert?: boolean;
      kind: "3d" | "audio" | "document" | "image" | "json" | "video";
      colorMode?: string;
      /** High threshold for Canny detector */
      highThreshold?: number;
      /** (deprecated) Vertical expansion ratio. */
      verticalExpansionRatio?: number;
      halfMode?: boolean;
      name?: string;
      /** Additional refinement steps before scaling.
            
            If scalingFactor == 1, the refinement process will be applied (1 + refinementSteps) times.
            If scalingFactor > 1, the refinement process will be applied refinementSteps times. */
      refinementSteps?: number;
      /** The reference images used for the image generation or editing */
      referenceImages?: string[];
      /** The higher the value the more it will look like the style image(s) */
      styleFidelity?: number;
      /** Boolean to output the contours. */
      resultContours?: boolean;
      /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
      polished?: number;
      /** The scheduler used to generate this asset */
      scheduler?: string;
      /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
      overrideEmbeddings?: boolean;
      progressPercent?: number;
      /** Contrast factor for Grayscale detector */
      factor?: number;
      /** The mask used for the image generation or editing */
      mask?: string;
      /** Low threshold for Canny detector */
      lowThreshold?: number;
      /** The depth fidelity if a depth image provided */
      depthFidelity?: number;
      /** How raised is the surface? 0 is flat like water, 1 is like a very rough rock */
      raised?: number;
      message?: string;
      contours?: number[][][][];
      /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
      negativePrompt?: string;
      /** If true, use the default parameters */
      defaultParameters?: boolean;
      /** Size proportion of the input image in the output. */
      resizeOption?: number;
      outputIndex?: number;
      /** Save a flipbook of the texture. Deactivated when the input texture is larger than 2048x2048px */
      saveFlipbook?: boolean;
      /** The guidance used to generate this asset */
      guidance?: number;
      /** The number of denoising steps for each image generation. */
      numInferenceSteps?: number;
      hdr?: number;
      /** How shiny is the surface? 0 is like a matte surface, 1 is like a diamond */
      shiny?: number;
      /** Ensure upscaled tile have the same color histogram as original tile. */
      colorCorrection?: boolean;
      /** Overlap percentage for the output image. */
      overlapPercentage?: number;
      /** The prompt that guided the image generation or editing */
      prompt?: string;
      /** Boolean to able output the cut out object. */
      resultImage?: boolean;
      /** The control image already processed by canny detector. Must reference an existing AssetId. */
      cannyStructureImage?: string;
      /** Apply extra control to the Skybox 360 geometry.
            The higher the value, the more the 360 geometry will influence the generated skybox image.
            
            Use with caution. Default is adapted to the other parameters. */
      geometryEnforcement?: number;
      /** Target width for the upscaled image, take priority over scaling factor */
      targetWidth?: number;
    };
    /** The NSFW labels */
    nsfw?: string[];
    /** Automatic captioning of the asset */
    automaticCaptioning?: string;
    /** The description of the asset */
    description?: string;
    /** The privacy of the asset */
    privacy: "private" | "public" | "unlisted";
    /** The date when the asset will be soft deleted (only for Free plan) */
    softDeletionOn?: string;
    /** The mime type of the asset (example: "image/png") */
    mimeType: string;
    /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
    authorId: string;
    /** The owner (project) ID (example: "proj_23tlk332lkht3kl2" or "team_dlkhgs23tlk3hlkth32lkht3kl2" for old teams) */
    ownerId: string;
    /** Signed URL to get the asset content */
    url: string;
    /** The associated tags (example: ["sci-fi", "landscape"]) */
    tags: string[];
    /** The asset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt: string;
    /** The output index of the asset within the job
        This index is an positive integer that starts at 0
        It is used to differentiate between multiple outputs of the same job
        If the job has only one output, this index is 0
        This is only applicable for generations with: Flux, Skybox, Reframe at the moment */
    outputIndex?: number;
    /** A list of CollectionId this asset belongs to */
    collectionIds: string[];
    /** List of edit capabilities for the asset */
    editCapabilities: (
      | "DETECTION"
      | "GENERATIVE_FILL"
      | "PIXELATE"
      | "PROMPT_EDITING"
      | "REFINE"
      | "REFRAME"
      | "REMOVE_BACKGROUND"
      | "SEGMENTATION"
      | "UPSCALE"
      | "UPSCALE_360"
      | "VECTORIZATION"
    )[];
    /** The embedding of the asset when requested and asset can be embedded
        
        ie: Detection maps don't have embeddings */
    embedding?: number[];
    /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
    id: string;
    /** The status of the asset */
    status: "error" | "pending" | "success";
    /** The asset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    updatedAt: string;
  }[];
};
export type PostAssetGetBulkApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** The list of asset ids the team has read access to. Limit of 200 assets. */
    assetIds?: string[];
  };
};
export type GetPublicAssetsApiResponse = /** status 200 200 response */ {
  /** A token to query the next page of assets */
  nextPaginationToken?: string;
  assets: {
    /** Metadata of the asset with some additional information */
    metadata: {
      maxIterations?: number;
      /** Modality to detect */
      modality?:
        | "canny"
        | "depth"
        | "grayscale"
        | "lineart_anime"
        | "mlsd"
        | "normal"
        | "pose"
        | "scribble"
        | "segmentation"
        | "sketch";
      /** If set to true, during the upscaling process, the model will match tiles of the source image with tiles of the style image(s). This will result in a more coherent restyle. Works best with style images that have a similar composition. */
      tileStyle?: boolean;
      /** The modelId used to generate this asset */
      modelId?: string;
      /** A bounding box around the object of interest, in the format [x1, y1, x2, y2]. */
      bbox?: any[];
      /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
      keypointThreshold?: number;
      /** The type of the asset. Ex: 'inference-txt2img' will represent an asset generated from a text to image model */
      type:
        | "background-removal"
        | "canvas"
        | "canvas-drawing"
        | "canvas-export"
        | "detection"
        | "generative-fill"
        | "image-prompt-editing"
        | "img23d-custom"
        | "img2img-custom"
        | "img2video-custom"
        | "inference-controlnet"
        | "inference-controlnet-img2img"
        | "inference-controlnet-inpaint"
        | "inference-controlnet-inpaint-ip-adapter"
        | "inference-controlnet-ip-adapter"
        | "inference-controlnet-reference"
        | "inference-controlnet-texture"
        | "inference-img2img"
        | "inference-img2img-ip-adapter"
        | "inference-img2img-texture"
        | "inference-inpaint"
        | "inference-inpaint-ip-adapter"
        | "inference-reference"
        | "inference-reference-texture"
        | "inference-txt2img"
        | "inference-txt2img-ip-adapter"
        | "inference-txt2img-texture"
        | "patch"
        | "pixelization"
        | "reframe"
        | "restyle"
        | "segment"
        | "segmentation-image"
        | "segmentation-mask"
        | "skybox-base-360"
        | "texture"
        | "texture-albedo"
        | "texture-ao"
        | "texture-edge"
        | "texture-height"
        | "texture-metallic"
        | "texture-normal"
        | "texture-smoothness"
        | "txt23d-custom"
        | "txt2audio-custom"
        | "txt2img-custom"
        | "unknown-custom"
        | "uploaded"
        | "upscale"
        | "upscale-skybox"
        | "upscale-texture"
        | "vectorization"
        | "video2video-custom";
      /** A textual description / keywords describing the object of interest. */
      text?: string;
      height?: number;
      nbMasks?: number;
      /** Amount of decay in creativity over the upscale process. The lowest the value, the less the creativity will be preserved over the upscale process. */
      creativityDecay?: number;
      layerDifference?: number;
      /** Scaling factor (when `targetWidth` not specified) */
      scalingFactor?: number;
      /** The type of the generator used */
      modelType?:
        | "custom"
        | "flux.1"
        | "flux.1-composition"
        | "flux.1-lora"
        | "flux.1-pro"
        | "flux.1.1-pro-ultra"
        | "flux1.1-pro"
        | "gpt-image-1"
        | "sd-1_5"
        | "sd-1_5-composition"
        | "sd-1_5-lora"
        | "sd-xl"
        | "sd-xl-composition"
        | "sd-xl-lora";
      /** The number of outputs to generate. */
      numOutputs?: number;
      /** How angular is the surface? 0 is like a sphere, 1 is like a mechanical object */
      angular?: number;
      /** The target height of the output image. */
      targetHeight?: number;
      /** Flux LoRa or Composition to style the image. */
      concepts?: {
        weightName: string;
        /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
        modelId: string;
        /** The scale of the model (example: 1.0) */
        scale: number;
      }[];
      size?: number;
      spliceThreshold?: number;
      /** The number of pixels to dilate the result masks. */
      dilate?: number;
      style?:
        | "3d-cartoon"
        | "3d-rendered"
        | "anime"
        | "cartoon"
        | "cinematic"
        | "claymation"
        | "cloud-skydome"
        | "comic"
        | "cyberpunk"
        | "enchanted"
        | "fantasy"
        | "ink"
        | "manga"
        | "manga-color"
        | "minimalist"
        | "neon-tron"
        | "oil-painting"
        | "pastel"
        | "photo"
        | "photography"
        | "psychedelic"
        | "retro-fantasy"
        | "scifi-concept-art"
        | "space"
        | "standard"
        | "whimsical";
      /** Strengthen the similarity to the original image during the upscale. Default: optimized for your preset and style. */
      imageFidelity?: number;
      /** Location of the input image in the output. */
      inputLocation?: "bottom" | "left" | "middle" | "right" | "top";
      /** The seed used to generate this asset */
      seed?: string;
      /** The higher the value the more it will look like the secondary reference image(s) */
      secondaryRefFidelity?: number;
      preset?: string;
      trainingImage?: boolean;
      /** Boolean to able return the masks (binary image) in the response. */
      resultMask?: boolean;
      /** The ISO timestamp when the lock on the canvas will expire */
      lockExpiresAt?: string;
      /** The baseModelId that maybe changed at inference time */
      baseModelId?: string;
      pathPrecision?: number;
      rootParentId?: string;
      /** Sharpen tiles. */
      sharpen?: boolean;
      cornerThreshold?: number;
      /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
      styleImages?: string[];
      /** The asset to convert in texture maps. Must reference an existing AssetId. */
      texture?: string;
      filterSpeckle?: number;
      /** Minimum threshold for Grayscale conversion */
      minThreshold?: number;
      /** Maximum threshold for Grayscale conversion */
      maxThreshold?: number;
      /** Condition the influence of the style image(s). The higher the value, the more the style images will influence the upscaled image. */
      styleImagesFidelity?: number;
      /** The control image processed by depth estimator. Must reference an existing AssetId. */
      depthImage?: string;
      parentId?: string;
      parentJobId?: string;
      /** Optional List of secondary style images. Example: portrait of people. It must be existing AssetIds. */
      secondaryRefImages?: string[];
      /** The width of the rendered image. */
      width?: number;
      /** The checkpoint to use */
      checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
      strength?: number;
      /** The id of the Inference describing how this image was generated */
      inferenceId?: string;
      lengthThreshold?: number;
      /** Int to set between 0 and 255 for the opacity of the background in the result images. */
      backgroundOpacity?: number;
      /** The optional aspect ratio given for the generation, only applicable for some models */
      aspectRatio?: string;
      /** Amount of details to remove or add */
      detailsLevel?: number;
      /** Determine the scale at which the upscale process works.
            - With a small value, the upscale works at the largest scale, resulting in fewer added details and more coherent images. Ideal for portraits, for example.
            - With a large value, the upscale works at the smallest scale, resulting in more added details and more hallucinations. Ideal for landscapes, for example.
            
            (info): A small value is slower and more expensive to run. */
      fractality?: number;
      /** (deprecated) Horizontal expansion ratio. */
      horizontalExpansionRatio?: number;
      /** List of points (label, x, y) in the image where label = 0 for background and 1 for object. */
      points?: any[][];
      mode?: string;
      colorPrecision?: number;
      /** Increase the fidelity to the prompt during upscale. Default: optimized for your preset and style. */
      promptFidelity?: number;
      /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
      betterQuality?: boolean;
      /** Remove background for Grayscale detector */
      removeBackground?: boolean;
      /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your preset and style. */
      creativity?: number;
      /** Strength for the input image structure preservation */
      structureFidelity?: number;
      /** Preserve the seamless properties of skybox or texture images. Input has to be of same type (seamless). */
      imageType?: "seamfull" | "skybox" | "texture";
      /** The input image to process. Must reference an existing AssetId or be a data URL. */
      image?: string;
      /** The thumbnail of the canvas */
      thumbnail?: {
        /** The AssetId of the image used as a thumbnail for the canvas (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        assetId: string;
        /** The url of the image used as a thumbnail for the canvas */
        url: string;
      };
      /** The control image for structure. A canny detector will be applied to this image. Must reference an existing AssetId. */
      structureImage?: string;
      /** To invert the relief */
      invert?: boolean;
      kind: "3d" | "audio" | "document" | "image" | "json" | "video";
      colorMode?: string;
      /** High threshold for Canny detector */
      highThreshold?: number;
      /** (deprecated) Vertical expansion ratio. */
      verticalExpansionRatio?: number;
      halfMode?: boolean;
      name?: string;
      /** Additional refinement steps before scaling.
            
            If scalingFactor == 1, the refinement process will be applied (1 + refinementSteps) times.
            If scalingFactor > 1, the refinement process will be applied refinementSteps times. */
      refinementSteps?: number;
      /** The reference images used for the image generation or editing */
      referenceImages?: string[];
      /** The higher the value the more it will look like the style image(s) */
      styleFidelity?: number;
      /** Boolean to output the contours. */
      resultContours?: boolean;
      /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
      polished?: number;
      /** The scheduler used to generate this asset */
      scheduler?: string;
      /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
      overrideEmbeddings?: boolean;
      progressPercent?: number;
      /** Contrast factor for Grayscale detector */
      factor?: number;
      /** The mask used for the image generation or editing */
      mask?: string;
      /** Low threshold for Canny detector */
      lowThreshold?: number;
      /** The depth fidelity if a depth image provided */
      depthFidelity?: number;
      /** How raised is the surface? 0 is flat like water, 1 is like a very rough rock */
      raised?: number;
      message?: string;
      contours?: number[][][][];
      /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
      negativePrompt?: string;
      /** If true, use the default parameters */
      defaultParameters?: boolean;
      /** Size proportion of the input image in the output. */
      resizeOption?: number;
      outputIndex?: number;
      /** Save a flipbook of the texture. Deactivated when the input texture is larger than 2048x2048px */
      saveFlipbook?: boolean;
      /** The guidance used to generate this asset */
      guidance?: number;
      /** The number of denoising steps for each image generation. */
      numInferenceSteps?: number;
      hdr?: number;
      /** How shiny is the surface? 0 is like a matte surface, 1 is like a diamond */
      shiny?: number;
      /** Ensure upscaled tile have the same color histogram as original tile. */
      colorCorrection?: boolean;
      /** Overlap percentage for the output image. */
      overlapPercentage?: number;
      /** The prompt that guided the image generation or editing */
      prompt?: string;
      /** Boolean to able output the cut out object. */
      resultImage?: boolean;
      /** The control image already processed by canny detector. Must reference an existing AssetId. */
      cannyStructureImage?: string;
      /** Apply extra control to the Skybox 360 geometry.
            The higher the value, the more the 360 geometry will influence the generated skybox image.
            
            Use with caution. Default is adapted to the other parameters. */
      geometryEnforcement?: number;
      /** Target width for the upscaled image, take priority over scaling factor */
      targetWidth?: number;
    };
    /** The NSFW labels */
    nsfw?: string[];
    /** Automatic captioning of the asset */
    automaticCaptioning?: string;
    /** The description of the asset */
    description?: string;
    /** The privacy of the asset */
    privacy: "private" | "public" | "unlisted";
    /** The date when the asset will be soft deleted (only for Free plan) */
    softDeletionOn?: string;
    /** The mime type of the asset (example: "image/png") */
    mimeType: string;
    /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
    authorId: string;
    /** The owner (project) ID (example: "proj_23tlk332lkht3kl2" or "team_dlkhgs23tlk3hlkth32lkht3kl2" for old teams) */
    ownerId: string;
    /** Signed URL to get the asset content */
    url: string;
    /** The associated tags (example: ["sci-fi", "landscape"]) */
    tags: string[];
    /** The asset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt: string;
    /** The output index of the asset within the job
        This index is an positive integer that starts at 0
        It is used to differentiate between multiple outputs of the same job
        If the job has only one output, this index is 0
        This is only applicable for generations with: Flux, Skybox, Reframe at the moment */
    outputIndex?: number;
    /** A list of CollectionId this asset belongs to */
    collectionIds: string[];
    /** List of edit capabilities for the asset */
    editCapabilities: (
      | "DETECTION"
      | "GENERATIVE_FILL"
      | "PIXELATE"
      | "PROMPT_EDITING"
      | "REFINE"
      | "REFRAME"
      | "REMOVE_BACKGROUND"
      | "SEGMENTATION"
      | "UPSCALE"
      | "UPSCALE_360"
      | "VECTORIZATION"
    )[];
    /** The embedding of the asset when requested and asset can be embedded
        
        ie: Detection maps don't have embeddings */
    embedding?: number[];
    /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
    id: string;
    /** The status of the asset */
    status: "error" | "pending" | "success";
    /** The asset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    updatedAt: string;
  }[];
};
export type GetPublicAssetsApiArg = {
  /** Filter results to only return assets updated before the specified ISO string date (exclusive). Requires the sortBy parameter to be "updatedAt" */
  updatedBefore?: string;
  /** Sort results in ascending (asc) or descending (desc) order */
  sortDirection?: string;
  /** List assets generated from all inferences coming from a specific model (this is not the training images) */
  modelId?: string;
  /** Filter results to only return assets updated after the specified ISO string date (exclusive). Requires the sortBy parameter to be "updatedAt" */
  updatedAfter?: string;
  /** Filter results to only return assets created before the specified ISO string date (exclusive). Requires the sortBy parameter to be "createdAt" */
  createdBefore?: string;
  /** Sort results by the createdAt or updatedAt */
  sortBy?: string;
  /** Filter results to only return assets created after the specified ISO string date (exclusive). Requires the sortBy parameter to be "createdAt" */
  createdAfter?: string;
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The number of items to return in the response. The default value is 50, maximum value is 100, minimum value is 1 */
  pageSize?: string;
  /** List all the assets of a specific type. The parameter "type" and "types" cannot be used together. Can be any of the following values: inference-txt2img, inference-txt2img-ip-adapter, inference-txt2img-texture, inference-img2img, inference-img2img-ip-adapter, inference-img2img-texture, inference-inpaint, inference-inpaint-ip-adapter, inference-reference, inference-reference-texture, inference-controlnet, inference-controlnet-ip-adapter, inference-controlnet-img2img, inference-controlnet-reference, inference-controlnet-inpaint, inference-controlnet-inpaint-ip-adapter, inference-controlnet-texture, background-removal, canvas, canvas-export, canvas-drawing, detection, patch, pixelization, uploaded, upscale, upscale-texture, upscale-skybox, vectorization, segment, segmentation-image, segmentation-mask, skybox-base-360, restyle, reframe, generative-fill, texture, texture-height, texture-normal, texture-smoothness, texture-metallic, texture-edge, texture-ao, texture-albedo, image-prompt-editing, unknown-custom, txt2img-custom, img2img-custom, img23d-custom, txt23d-custom, img2video-custom, txt2audio-custom, video2video-custom, assets with a type starting with "inference-" will be returned */
  type?: string;
  /** A token you received in a previous request to query the next page of items */
  paginationToken?: string;
  /** List of tags, comma separated. Only for public assets on all teams. */
  tags?: string;
  /** List of the asset types to request. The parameter "type" and "types" cannot be used together. Can be any of the following values: inference-txt2img, inference-txt2img-ip-adapter, inference-txt2img-texture, inference-img2img, inference-img2img-ip-adapter, inference-img2img-texture, inference-inpaint, inference-inpaint-ip-adapter, inference-reference, inference-reference-texture, inference-controlnet, inference-controlnet-ip-adapter, inference-controlnet-img2img, inference-controlnet-reference, inference-controlnet-inpaint, inference-controlnet-inpaint-ip-adapter, inference-controlnet-texture, background-removal, canvas, canvas-export, canvas-drawing, detection, patch, pixelization, uploaded, upscale, upscale-texture, upscale-skybox, vectorization, segment, segmentation-image, segmentation-mask, skybox-base-360, restyle, reframe, generative-fill, texture, texture-height, texture-normal, texture-smoothness, texture-metallic, texture-edge, texture-ao, texture-albedo, image-prompt-editing, unknown-custom, txt2img-custom, img2img-custom, img23d-custom, txt23d-custom, img2video-custom, txt2audio-custom, video2video-custom */
  types?: string;
};
export type GetAssetsByAssetIdApiResponse = /** status 200 200 response */ {
  asset: {
    /** Metadata of the asset with some additional information */
    metadata: {
      maxIterations?: number;
      /** Modality to detect */
      modality?:
        | "canny"
        | "depth"
        | "grayscale"
        | "lineart_anime"
        | "mlsd"
        | "normal"
        | "pose"
        | "scribble"
        | "segmentation"
        | "sketch";
      /** If set to true, during the upscaling process, the model will match tiles of the source image with tiles of the style image(s). This will result in a more coherent restyle. Works best with style images that have a similar composition. */
      tileStyle?: boolean;
      /** The modelId used to generate this asset */
      modelId?: string;
      /** A bounding box around the object of interest, in the format [x1, y1, x2, y2]. */
      bbox?: any[];
      /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
      keypointThreshold?: number;
      /** The type of the asset. Ex: 'inference-txt2img' will represent an asset generated from a text to image model */
      type:
        | "background-removal"
        | "canvas"
        | "canvas-drawing"
        | "canvas-export"
        | "detection"
        | "generative-fill"
        | "image-prompt-editing"
        | "img23d-custom"
        | "img2img-custom"
        | "img2video-custom"
        | "inference-controlnet"
        | "inference-controlnet-img2img"
        | "inference-controlnet-inpaint"
        | "inference-controlnet-inpaint-ip-adapter"
        | "inference-controlnet-ip-adapter"
        | "inference-controlnet-reference"
        | "inference-controlnet-texture"
        | "inference-img2img"
        | "inference-img2img-ip-adapter"
        | "inference-img2img-texture"
        | "inference-inpaint"
        | "inference-inpaint-ip-adapter"
        | "inference-reference"
        | "inference-reference-texture"
        | "inference-txt2img"
        | "inference-txt2img-ip-adapter"
        | "inference-txt2img-texture"
        | "patch"
        | "pixelization"
        | "reframe"
        | "restyle"
        | "segment"
        | "segmentation-image"
        | "segmentation-mask"
        | "skybox-base-360"
        | "texture"
        | "texture-albedo"
        | "texture-ao"
        | "texture-edge"
        | "texture-height"
        | "texture-metallic"
        | "texture-normal"
        | "texture-smoothness"
        | "txt23d-custom"
        | "txt2audio-custom"
        | "txt2img-custom"
        | "unknown-custom"
        | "uploaded"
        | "upscale"
        | "upscale-skybox"
        | "upscale-texture"
        | "vectorization"
        | "video2video-custom";
      /** A textual description / keywords describing the object of interest. */
      text?: string;
      height?: number;
      nbMasks?: number;
      /** Amount of decay in creativity over the upscale process. The lowest the value, the less the creativity will be preserved over the upscale process. */
      creativityDecay?: number;
      layerDifference?: number;
      /** Scaling factor (when `targetWidth` not specified) */
      scalingFactor?: number;
      /** The type of the generator used */
      modelType?:
        | "custom"
        | "flux.1"
        | "flux.1-composition"
        | "flux.1-lora"
        | "flux.1-pro"
        | "flux.1.1-pro-ultra"
        | "flux1.1-pro"
        | "gpt-image-1"
        | "sd-1_5"
        | "sd-1_5-composition"
        | "sd-1_5-lora"
        | "sd-xl"
        | "sd-xl-composition"
        | "sd-xl-lora";
      /** The number of outputs to generate. */
      numOutputs?: number;
      /** How angular is the surface? 0 is like a sphere, 1 is like a mechanical object */
      angular?: number;
      /** The target height of the output image. */
      targetHeight?: number;
      /** Flux LoRa or Composition to style the image. */
      concepts?: {
        weightName: string;
        /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
        modelId: string;
        /** The scale of the model (example: 1.0) */
        scale: number;
      }[];
      size?: number;
      spliceThreshold?: number;
      /** The number of pixels to dilate the result masks. */
      dilate?: number;
      style?:
        | "3d-cartoon"
        | "3d-rendered"
        | "anime"
        | "cartoon"
        | "cinematic"
        | "claymation"
        | "cloud-skydome"
        | "comic"
        | "cyberpunk"
        | "enchanted"
        | "fantasy"
        | "ink"
        | "manga"
        | "manga-color"
        | "minimalist"
        | "neon-tron"
        | "oil-painting"
        | "pastel"
        | "photo"
        | "photography"
        | "psychedelic"
        | "retro-fantasy"
        | "scifi-concept-art"
        | "space"
        | "standard"
        | "whimsical";
      /** Strengthen the similarity to the original image during the upscale. Default: optimized for your preset and style. */
      imageFidelity?: number;
      /** Location of the input image in the output. */
      inputLocation?: "bottom" | "left" | "middle" | "right" | "top";
      /** The seed used to generate this asset */
      seed?: string;
      /** The higher the value the more it will look like the secondary reference image(s) */
      secondaryRefFidelity?: number;
      preset?: string;
      trainingImage?: boolean;
      /** Boolean to able return the masks (binary image) in the response. */
      resultMask?: boolean;
      /** The ISO timestamp when the lock on the canvas will expire */
      lockExpiresAt?: string;
      /** The baseModelId that maybe changed at inference time */
      baseModelId?: string;
      pathPrecision?: number;
      rootParentId?: string;
      /** Sharpen tiles. */
      sharpen?: boolean;
      cornerThreshold?: number;
      /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
      styleImages?: string[];
      /** The asset to convert in texture maps. Must reference an existing AssetId. */
      texture?: string;
      filterSpeckle?: number;
      /** Minimum threshold for Grayscale conversion */
      minThreshold?: number;
      /** Maximum threshold for Grayscale conversion */
      maxThreshold?: number;
      /** Condition the influence of the style image(s). The higher the value, the more the style images will influence the upscaled image. */
      styleImagesFidelity?: number;
      /** The control image processed by depth estimator. Must reference an existing AssetId. */
      depthImage?: string;
      parentId?: string;
      parentJobId?: string;
      /** Optional List of secondary style images. Example: portrait of people. It must be existing AssetIds. */
      secondaryRefImages?: string[];
      /** The width of the rendered image. */
      width?: number;
      /** The checkpoint to use */
      checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
      strength?: number;
      /** The id of the Inference describing how this image was generated */
      inferenceId?: string;
      lengthThreshold?: number;
      /** Int to set between 0 and 255 for the opacity of the background in the result images. */
      backgroundOpacity?: number;
      /** The optional aspect ratio given for the generation, only applicable for some models */
      aspectRatio?: string;
      /** Amount of details to remove or add */
      detailsLevel?: number;
      /** Determine the scale at which the upscale process works.
            - With a small value, the upscale works at the largest scale, resulting in fewer added details and more coherent images. Ideal for portraits, for example.
            - With a large value, the upscale works at the smallest scale, resulting in more added details and more hallucinations. Ideal for landscapes, for example.
            
            (info): A small value is slower and more expensive to run. */
      fractality?: number;
      /** (deprecated) Horizontal expansion ratio. */
      horizontalExpansionRatio?: number;
      /** List of points (label, x, y) in the image where label = 0 for background and 1 for object. */
      points?: any[][];
      mode?: string;
      colorPrecision?: number;
      /** Increase the fidelity to the prompt during upscale. Default: optimized for your preset and style. */
      promptFidelity?: number;
      /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
      betterQuality?: boolean;
      /** Remove background for Grayscale detector */
      removeBackground?: boolean;
      /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your preset and style. */
      creativity?: number;
      /** Strength for the input image structure preservation */
      structureFidelity?: number;
      /** Preserve the seamless properties of skybox or texture images. Input has to be of same type (seamless). */
      imageType?: "seamfull" | "skybox" | "texture";
      /** The input image to process. Must reference an existing AssetId or be a data URL. */
      image?: string;
      /** The thumbnail of the canvas */
      thumbnail?: {
        /** The AssetId of the image used as a thumbnail for the canvas (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        assetId: string;
        /** The url of the image used as a thumbnail for the canvas */
        url: string;
      };
      /** The control image for structure. A canny detector will be applied to this image. Must reference an existing AssetId. */
      structureImage?: string;
      /** To invert the relief */
      invert?: boolean;
      kind: "3d" | "audio" | "document" | "image" | "json" | "video";
      colorMode?: string;
      /** High threshold for Canny detector */
      highThreshold?: number;
      /** (deprecated) Vertical expansion ratio. */
      verticalExpansionRatio?: number;
      halfMode?: boolean;
      name?: string;
      /** Additional refinement steps before scaling.
            
            If scalingFactor == 1, the refinement process will be applied (1 + refinementSteps) times.
            If scalingFactor > 1, the refinement process will be applied refinementSteps times. */
      refinementSteps?: number;
      /** The reference images used for the image generation or editing */
      referenceImages?: string[];
      /** The higher the value the more it will look like the style image(s) */
      styleFidelity?: number;
      /** Boolean to output the contours. */
      resultContours?: boolean;
      /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
      polished?: number;
      /** The scheduler used to generate this asset */
      scheduler?: string;
      /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
      overrideEmbeddings?: boolean;
      progressPercent?: number;
      /** Contrast factor for Grayscale detector */
      factor?: number;
      /** The mask used for the image generation or editing */
      mask?: string;
      /** Low threshold for Canny detector */
      lowThreshold?: number;
      /** The depth fidelity if a depth image provided */
      depthFidelity?: number;
      /** How raised is the surface? 0 is flat like water, 1 is like a very rough rock */
      raised?: number;
      message?: string;
      contours?: number[][][][];
      /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
      negativePrompt?: string;
      /** If true, use the default parameters */
      defaultParameters?: boolean;
      /** Size proportion of the input image in the output. */
      resizeOption?: number;
      outputIndex?: number;
      /** Save a flipbook of the texture. Deactivated when the input texture is larger than 2048x2048px */
      saveFlipbook?: boolean;
      /** The guidance used to generate this asset */
      guidance?: number;
      /** The number of denoising steps for each image generation. */
      numInferenceSteps?: number;
      hdr?: number;
      /** How shiny is the surface? 0 is like a matte surface, 1 is like a diamond */
      shiny?: number;
      /** Ensure upscaled tile have the same color histogram as original tile. */
      colorCorrection?: boolean;
      /** Overlap percentage for the output image. */
      overlapPercentage?: number;
      /** The prompt that guided the image generation or editing */
      prompt?: string;
      /** Boolean to able output the cut out object. */
      resultImage?: boolean;
      /** The control image already processed by canny detector. Must reference an existing AssetId. */
      cannyStructureImage?: string;
      /** Apply extra control to the Skybox 360 geometry.
            The higher the value, the more the 360 geometry will influence the generated skybox image.
            
            Use with caution. Default is adapted to the other parameters. */
      geometryEnforcement?: number;
      /** Target width for the upscaled image, take priority over scaling factor */
      targetWidth?: number;
    };
    /** The NSFW labels */
    nsfw?: string[];
    /** Automatic captioning of the asset */
    automaticCaptioning?: string;
    /** The description of the asset */
    description?: string;
    /** The privacy of the asset */
    privacy: "private" | "public" | "unlisted";
    /** The date when the asset will be soft deleted (only for Free plan) */
    softDeletionOn?: string;
    /** The mime type of the asset (example: "image/png") */
    mimeType: string;
    /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
    authorId: string;
    /** The owner (project) ID (example: "proj_23tlk332lkht3kl2" or "team_dlkhgs23tlk3hlkth32lkht3kl2" for old teams) */
    ownerId: string;
    /** Signed URL to get the asset content */
    url: string;
    /** The associated tags (example: ["sci-fi", "landscape"]) */
    tags: string[];
    /** The asset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt: string;
    /** The output index of the asset within the job
        This index is an positive integer that starts at 0
        It is used to differentiate between multiple outputs of the same job
        If the job has only one output, this index is 0
        This is only applicable for generations with: Flux, Skybox, Reframe at the moment */
    outputIndex?: number;
    /** A list of CollectionId this asset belongs to */
    collectionIds: string[];
    /** List of edit capabilities for the asset */
    editCapabilities: (
      | "DETECTION"
      | "GENERATIVE_FILL"
      | "PIXELATE"
      | "PROMPT_EDITING"
      | "REFINE"
      | "REFRAME"
      | "REMOVE_BACKGROUND"
      | "SEGMENTATION"
      | "UPSCALE"
      | "UPSCALE_360"
      | "VECTORIZATION"
    )[];
    /** The embedding of the asset when requested and asset can be embedded
        
        ie: Detection maps don't have embeddings */
    embedding?: number[];
    /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
    id: string;
    /** The status of the asset */
    status: "error" | "pending" | "success";
    /** The asset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    updatedAt: string;
  };
};
export type GetAssetsByAssetIdApiArg = {
  /** Include the embedding in the response */
  withEmbedding?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The asset ID to retrieve */
  assetId: string;
};
export type PutAssetByAssetIdApiResponse = /** status 200 200 response */ {
  asset: {
    /** Metadata of the asset with some additional information */
    metadata: {
      maxIterations?: number;
      /** Modality to detect */
      modality?:
        | "canny"
        | "depth"
        | "grayscale"
        | "lineart_anime"
        | "mlsd"
        | "normal"
        | "pose"
        | "scribble"
        | "segmentation"
        | "sketch";
      /** If set to true, during the upscaling process, the model will match tiles of the source image with tiles of the style image(s). This will result in a more coherent restyle. Works best with style images that have a similar composition. */
      tileStyle?: boolean;
      /** The modelId used to generate this asset */
      modelId?: string;
      /** A bounding box around the object of interest, in the format [x1, y1, x2, y2]. */
      bbox?: any[];
      /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
      keypointThreshold?: number;
      /** The type of the asset. Ex: 'inference-txt2img' will represent an asset generated from a text to image model */
      type:
        | "background-removal"
        | "canvas"
        | "canvas-drawing"
        | "canvas-export"
        | "detection"
        | "generative-fill"
        | "image-prompt-editing"
        | "img23d-custom"
        | "img2img-custom"
        | "img2video-custom"
        | "inference-controlnet"
        | "inference-controlnet-img2img"
        | "inference-controlnet-inpaint"
        | "inference-controlnet-inpaint-ip-adapter"
        | "inference-controlnet-ip-adapter"
        | "inference-controlnet-reference"
        | "inference-controlnet-texture"
        | "inference-img2img"
        | "inference-img2img-ip-adapter"
        | "inference-img2img-texture"
        | "inference-inpaint"
        | "inference-inpaint-ip-adapter"
        | "inference-reference"
        | "inference-reference-texture"
        | "inference-txt2img"
        | "inference-txt2img-ip-adapter"
        | "inference-txt2img-texture"
        | "patch"
        | "pixelization"
        | "reframe"
        | "restyle"
        | "segment"
        | "segmentation-image"
        | "segmentation-mask"
        | "skybox-base-360"
        | "texture"
        | "texture-albedo"
        | "texture-ao"
        | "texture-edge"
        | "texture-height"
        | "texture-metallic"
        | "texture-normal"
        | "texture-smoothness"
        | "txt23d-custom"
        | "txt2audio-custom"
        | "txt2img-custom"
        | "unknown-custom"
        | "uploaded"
        | "upscale"
        | "upscale-skybox"
        | "upscale-texture"
        | "vectorization"
        | "video2video-custom";
      /** A textual description / keywords describing the object of interest. */
      text?: string;
      height?: number;
      nbMasks?: number;
      /** Amount of decay in creativity over the upscale process. The lowest the value, the less the creativity will be preserved over the upscale process. */
      creativityDecay?: number;
      layerDifference?: number;
      /** Scaling factor (when `targetWidth` not specified) */
      scalingFactor?: number;
      /** The type of the generator used */
      modelType?:
        | "custom"
        | "flux.1"
        | "flux.1-composition"
        | "flux.1-lora"
        | "flux.1-pro"
        | "flux.1.1-pro-ultra"
        | "flux1.1-pro"
        | "gpt-image-1"
        | "sd-1_5"
        | "sd-1_5-composition"
        | "sd-1_5-lora"
        | "sd-xl"
        | "sd-xl-composition"
        | "sd-xl-lora";
      /** The number of outputs to generate. */
      numOutputs?: number;
      /** How angular is the surface? 0 is like a sphere, 1 is like a mechanical object */
      angular?: number;
      /** The target height of the output image. */
      targetHeight?: number;
      /** Flux LoRa or Composition to style the image. */
      concepts?: {
        weightName: string;
        /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
        modelId: string;
        /** The scale of the model (example: 1.0) */
        scale: number;
      }[];
      size?: number;
      spliceThreshold?: number;
      /** The number of pixels to dilate the result masks. */
      dilate?: number;
      style?:
        | "3d-cartoon"
        | "3d-rendered"
        | "anime"
        | "cartoon"
        | "cinematic"
        | "claymation"
        | "cloud-skydome"
        | "comic"
        | "cyberpunk"
        | "enchanted"
        | "fantasy"
        | "ink"
        | "manga"
        | "manga-color"
        | "minimalist"
        | "neon-tron"
        | "oil-painting"
        | "pastel"
        | "photo"
        | "photography"
        | "psychedelic"
        | "retro-fantasy"
        | "scifi-concept-art"
        | "space"
        | "standard"
        | "whimsical";
      /** Strengthen the similarity to the original image during the upscale. Default: optimized for your preset and style. */
      imageFidelity?: number;
      /** Location of the input image in the output. */
      inputLocation?: "bottom" | "left" | "middle" | "right" | "top";
      /** The seed used to generate this asset */
      seed?: string;
      /** The higher the value the more it will look like the secondary reference image(s) */
      secondaryRefFidelity?: number;
      preset?: string;
      trainingImage?: boolean;
      /** Boolean to able return the masks (binary image) in the response. */
      resultMask?: boolean;
      /** The ISO timestamp when the lock on the canvas will expire */
      lockExpiresAt?: string;
      /** The baseModelId that maybe changed at inference time */
      baseModelId?: string;
      pathPrecision?: number;
      rootParentId?: string;
      /** Sharpen tiles. */
      sharpen?: boolean;
      cornerThreshold?: number;
      /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
      styleImages?: string[];
      /** The asset to convert in texture maps. Must reference an existing AssetId. */
      texture?: string;
      filterSpeckle?: number;
      /** Minimum threshold for Grayscale conversion */
      minThreshold?: number;
      /** Maximum threshold for Grayscale conversion */
      maxThreshold?: number;
      /** Condition the influence of the style image(s). The higher the value, the more the style images will influence the upscaled image. */
      styleImagesFidelity?: number;
      /** The control image processed by depth estimator. Must reference an existing AssetId. */
      depthImage?: string;
      parentId?: string;
      parentJobId?: string;
      /** Optional List of secondary style images. Example: portrait of people. It must be existing AssetIds. */
      secondaryRefImages?: string[];
      /** The width of the rendered image. */
      width?: number;
      /** The checkpoint to use */
      checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
      strength?: number;
      /** The id of the Inference describing how this image was generated */
      inferenceId?: string;
      lengthThreshold?: number;
      /** Int to set between 0 and 255 for the opacity of the background in the result images. */
      backgroundOpacity?: number;
      /** The optional aspect ratio given for the generation, only applicable for some models */
      aspectRatio?: string;
      /** Amount of details to remove or add */
      detailsLevel?: number;
      /** Determine the scale at which the upscale process works.
            - With a small value, the upscale works at the largest scale, resulting in fewer added details and more coherent images. Ideal for portraits, for example.
            - With a large value, the upscale works at the smallest scale, resulting in more added details and more hallucinations. Ideal for landscapes, for example.
            
            (info): A small value is slower and more expensive to run. */
      fractality?: number;
      /** (deprecated) Horizontal expansion ratio. */
      horizontalExpansionRatio?: number;
      /** List of points (label, x, y) in the image where label = 0 for background and 1 for object. */
      points?: any[][];
      mode?: string;
      colorPrecision?: number;
      /** Increase the fidelity to the prompt during upscale. Default: optimized for your preset and style. */
      promptFidelity?: number;
      /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
      betterQuality?: boolean;
      /** Remove background for Grayscale detector */
      removeBackground?: boolean;
      /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your preset and style. */
      creativity?: number;
      /** Strength for the input image structure preservation */
      structureFidelity?: number;
      /** Preserve the seamless properties of skybox or texture images. Input has to be of same type (seamless). */
      imageType?: "seamfull" | "skybox" | "texture";
      /** The input image to process. Must reference an existing AssetId or be a data URL. */
      image?: string;
      /** The thumbnail of the canvas */
      thumbnail?: {
        /** The AssetId of the image used as a thumbnail for the canvas (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        assetId: string;
        /** The url of the image used as a thumbnail for the canvas */
        url: string;
      };
      /** The control image for structure. A canny detector will be applied to this image. Must reference an existing AssetId. */
      structureImage?: string;
      /** To invert the relief */
      invert?: boolean;
      kind: "3d" | "audio" | "document" | "image" | "json" | "video";
      colorMode?: string;
      /** High threshold for Canny detector */
      highThreshold?: number;
      /** (deprecated) Vertical expansion ratio. */
      verticalExpansionRatio?: number;
      halfMode?: boolean;
      name?: string;
      /** Additional refinement steps before scaling.
            
            If scalingFactor == 1, the refinement process will be applied (1 + refinementSteps) times.
            If scalingFactor > 1, the refinement process will be applied refinementSteps times. */
      refinementSteps?: number;
      /** The reference images used for the image generation or editing */
      referenceImages?: string[];
      /** The higher the value the more it will look like the style image(s) */
      styleFidelity?: number;
      /** Boolean to output the contours. */
      resultContours?: boolean;
      /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
      polished?: number;
      /** The scheduler used to generate this asset */
      scheduler?: string;
      /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
      overrideEmbeddings?: boolean;
      progressPercent?: number;
      /** Contrast factor for Grayscale detector */
      factor?: number;
      /** The mask used for the image generation or editing */
      mask?: string;
      /** Low threshold for Canny detector */
      lowThreshold?: number;
      /** The depth fidelity if a depth image provided */
      depthFidelity?: number;
      /** How raised is the surface? 0 is flat like water, 1 is like a very rough rock */
      raised?: number;
      message?: string;
      contours?: number[][][][];
      /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
      negativePrompt?: string;
      /** If true, use the default parameters */
      defaultParameters?: boolean;
      /** Size proportion of the input image in the output. */
      resizeOption?: number;
      outputIndex?: number;
      /** Save a flipbook of the texture. Deactivated when the input texture is larger than 2048x2048px */
      saveFlipbook?: boolean;
      /** The guidance used to generate this asset */
      guidance?: number;
      /** The number of denoising steps for each image generation. */
      numInferenceSteps?: number;
      hdr?: number;
      /** How shiny is the surface? 0 is like a matte surface, 1 is like a diamond */
      shiny?: number;
      /** Ensure upscaled tile have the same color histogram as original tile. */
      colorCorrection?: boolean;
      /** Overlap percentage for the output image. */
      overlapPercentage?: number;
      /** The prompt that guided the image generation or editing */
      prompt?: string;
      /** Boolean to able output the cut out object. */
      resultImage?: boolean;
      /** The control image already processed by canny detector. Must reference an existing AssetId. */
      cannyStructureImage?: string;
      /** Apply extra control to the Skybox 360 geometry.
            The higher the value, the more the 360 geometry will influence the generated skybox image.
            
            Use with caution. Default is adapted to the other parameters. */
      geometryEnforcement?: number;
      /** Target width for the upscaled image, take priority over scaling factor */
      targetWidth?: number;
    };
    /** The NSFW labels */
    nsfw?: string[];
    /** Automatic captioning of the asset */
    automaticCaptioning?: string;
    /** The description of the asset */
    description?: string;
    /** The privacy of the asset */
    privacy: "private" | "public" | "unlisted";
    /** The date when the asset will be soft deleted (only for Free plan) */
    softDeletionOn?: string;
    /** The mime type of the asset (example: "image/png") */
    mimeType: string;
    /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
    authorId: string;
    /** The owner (project) ID (example: "proj_23tlk332lkht3kl2" or "team_dlkhgs23tlk3hlkth32lkht3kl2" for old teams) */
    ownerId: string;
    /** Signed URL to get the asset content */
    url: string;
    /** The associated tags (example: ["sci-fi", "landscape"]) */
    tags: string[];
    /** The asset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt: string;
    /** The output index of the asset within the job
        This index is an positive integer that starts at 0
        It is used to differentiate between multiple outputs of the same job
        If the job has only one output, this index is 0
        This is only applicable for generations with: Flux, Skybox, Reframe at the moment */
    outputIndex?: number;
    /** A list of CollectionId this asset belongs to */
    collectionIds: string[];
    /** List of edit capabilities for the asset */
    editCapabilities: (
      | "DETECTION"
      | "GENERATIVE_FILL"
      | "PIXELATE"
      | "PROMPT_EDITING"
      | "REFINE"
      | "REFRAME"
      | "REMOVE_BACKGROUND"
      | "SEGMENTATION"
      | "UPSCALE"
      | "UPSCALE_360"
      | "VECTORIZATION"
    )[];
    /** The embedding of the asset when requested and asset can be embedded
        
        ie: Detection maps don't have embeddings */
    embedding?: number[];
    /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
    id: string;
    /** The status of the asset */
    status: "error" | "pending" | "success";
    /** The asset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    updatedAt: string;
  };
};
export type PutAssetByAssetIdApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  assetId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** The value of the lock to use when updating a locked canvas. */
    lockId?: string;
    /** The ISO timestamp when the lock on the canvas will expire. */
    lockExpiresAt?: string;
    /** The new value for the canvas as a stringified JSON. */
    canvas?: string;
    /** The new thumbnail for the canvas in base64 format string. */
    thumbnail?: string;
    /** The new name for the canvas. */
    name?: string;
    /** The new description of the asset. */
    description?: string;
    /** If true, no snapshot will be created for this update. */
    disableSnapshot?: boolean;
  };
};
export type CopyAssetByAssetIdApiResponse = /** status 200 200 response */ {
  asset: {
    /** Metadata of the asset with some additional information */
    metadata: {
      maxIterations?: number;
      /** Modality to detect */
      modality?:
        | "canny"
        | "depth"
        | "grayscale"
        | "lineart_anime"
        | "mlsd"
        | "normal"
        | "pose"
        | "scribble"
        | "segmentation"
        | "sketch";
      /** If set to true, during the upscaling process, the model will match tiles of the source image with tiles of the style image(s). This will result in a more coherent restyle. Works best with style images that have a similar composition. */
      tileStyle?: boolean;
      /** The modelId used to generate this asset */
      modelId?: string;
      /** A bounding box around the object of interest, in the format [x1, y1, x2, y2]. */
      bbox?: any[];
      /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
      keypointThreshold?: number;
      /** The type of the asset. Ex: 'inference-txt2img' will represent an asset generated from a text to image model */
      type:
        | "background-removal"
        | "canvas"
        | "canvas-drawing"
        | "canvas-export"
        | "detection"
        | "generative-fill"
        | "image-prompt-editing"
        | "img23d-custom"
        | "img2img-custom"
        | "img2video-custom"
        | "inference-controlnet"
        | "inference-controlnet-img2img"
        | "inference-controlnet-inpaint"
        | "inference-controlnet-inpaint-ip-adapter"
        | "inference-controlnet-ip-adapter"
        | "inference-controlnet-reference"
        | "inference-controlnet-texture"
        | "inference-img2img"
        | "inference-img2img-ip-adapter"
        | "inference-img2img-texture"
        | "inference-inpaint"
        | "inference-inpaint-ip-adapter"
        | "inference-reference"
        | "inference-reference-texture"
        | "inference-txt2img"
        | "inference-txt2img-ip-adapter"
        | "inference-txt2img-texture"
        | "patch"
        | "pixelization"
        | "reframe"
        | "restyle"
        | "segment"
        | "segmentation-image"
        | "segmentation-mask"
        | "skybox-base-360"
        | "texture"
        | "texture-albedo"
        | "texture-ao"
        | "texture-edge"
        | "texture-height"
        | "texture-metallic"
        | "texture-normal"
        | "texture-smoothness"
        | "txt23d-custom"
        | "txt2audio-custom"
        | "txt2img-custom"
        | "unknown-custom"
        | "uploaded"
        | "upscale"
        | "upscale-skybox"
        | "upscale-texture"
        | "vectorization"
        | "video2video-custom";
      /** A textual description / keywords describing the object of interest. */
      text?: string;
      height?: number;
      nbMasks?: number;
      /** Amount of decay in creativity over the upscale process. The lowest the value, the less the creativity will be preserved over the upscale process. */
      creativityDecay?: number;
      layerDifference?: number;
      /** Scaling factor (when `targetWidth` not specified) */
      scalingFactor?: number;
      /** The type of the generator used */
      modelType?:
        | "custom"
        | "flux.1"
        | "flux.1-composition"
        | "flux.1-lora"
        | "flux.1-pro"
        | "flux.1.1-pro-ultra"
        | "flux1.1-pro"
        | "gpt-image-1"
        | "sd-1_5"
        | "sd-1_5-composition"
        | "sd-1_5-lora"
        | "sd-xl"
        | "sd-xl-composition"
        | "sd-xl-lora";
      /** The number of outputs to generate. */
      numOutputs?: number;
      /** How angular is the surface? 0 is like a sphere, 1 is like a mechanical object */
      angular?: number;
      /** The target height of the output image. */
      targetHeight?: number;
      /** Flux LoRa or Composition to style the image. */
      concepts?: {
        weightName: string;
        /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
        modelId: string;
        /** The scale of the model (example: 1.0) */
        scale: number;
      }[];
      size?: number;
      spliceThreshold?: number;
      /** The number of pixels to dilate the result masks. */
      dilate?: number;
      style?:
        | "3d-cartoon"
        | "3d-rendered"
        | "anime"
        | "cartoon"
        | "cinematic"
        | "claymation"
        | "cloud-skydome"
        | "comic"
        | "cyberpunk"
        | "enchanted"
        | "fantasy"
        | "ink"
        | "manga"
        | "manga-color"
        | "minimalist"
        | "neon-tron"
        | "oil-painting"
        | "pastel"
        | "photo"
        | "photography"
        | "psychedelic"
        | "retro-fantasy"
        | "scifi-concept-art"
        | "space"
        | "standard"
        | "whimsical";
      /** Strengthen the similarity to the original image during the upscale. Default: optimized for your preset and style. */
      imageFidelity?: number;
      /** Location of the input image in the output. */
      inputLocation?: "bottom" | "left" | "middle" | "right" | "top";
      /** The seed used to generate this asset */
      seed?: string;
      /** The higher the value the more it will look like the secondary reference image(s) */
      secondaryRefFidelity?: number;
      preset?: string;
      trainingImage?: boolean;
      /** Boolean to able return the masks (binary image) in the response. */
      resultMask?: boolean;
      /** The ISO timestamp when the lock on the canvas will expire */
      lockExpiresAt?: string;
      /** The baseModelId that maybe changed at inference time */
      baseModelId?: string;
      pathPrecision?: number;
      rootParentId?: string;
      /** Sharpen tiles. */
      sharpen?: boolean;
      cornerThreshold?: number;
      /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
      styleImages?: string[];
      /** The asset to convert in texture maps. Must reference an existing AssetId. */
      texture?: string;
      filterSpeckle?: number;
      /** Minimum threshold for Grayscale conversion */
      minThreshold?: number;
      /** Maximum threshold for Grayscale conversion */
      maxThreshold?: number;
      /** Condition the influence of the style image(s). The higher the value, the more the style images will influence the upscaled image. */
      styleImagesFidelity?: number;
      /** The control image processed by depth estimator. Must reference an existing AssetId. */
      depthImage?: string;
      parentId?: string;
      parentJobId?: string;
      /** Optional List of secondary style images. Example: portrait of people. It must be existing AssetIds. */
      secondaryRefImages?: string[];
      /** The width of the rendered image. */
      width?: number;
      /** The checkpoint to use */
      checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
      strength?: number;
      /** The id of the Inference describing how this image was generated */
      inferenceId?: string;
      lengthThreshold?: number;
      /** Int to set between 0 and 255 for the opacity of the background in the result images. */
      backgroundOpacity?: number;
      /** The optional aspect ratio given for the generation, only applicable for some models */
      aspectRatio?: string;
      /** Amount of details to remove or add */
      detailsLevel?: number;
      /** Determine the scale at which the upscale process works.
            - With a small value, the upscale works at the largest scale, resulting in fewer added details and more coherent images. Ideal for portraits, for example.
            - With a large value, the upscale works at the smallest scale, resulting in more added details and more hallucinations. Ideal for landscapes, for example.
            
            (info): A small value is slower and more expensive to run. */
      fractality?: number;
      /** (deprecated) Horizontal expansion ratio. */
      horizontalExpansionRatio?: number;
      /** List of points (label, x, y) in the image where label = 0 for background and 1 for object. */
      points?: any[][];
      mode?: string;
      colorPrecision?: number;
      /** Increase the fidelity to the prompt during upscale. Default: optimized for your preset and style. */
      promptFidelity?: number;
      /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
      betterQuality?: boolean;
      /** Remove background for Grayscale detector */
      removeBackground?: boolean;
      /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your preset and style. */
      creativity?: number;
      /** Strength for the input image structure preservation */
      structureFidelity?: number;
      /** Preserve the seamless properties of skybox or texture images. Input has to be of same type (seamless). */
      imageType?: "seamfull" | "skybox" | "texture";
      /** The input image to process. Must reference an existing AssetId or be a data URL. */
      image?: string;
      /** The thumbnail of the canvas */
      thumbnail?: {
        /** The AssetId of the image used as a thumbnail for the canvas (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        assetId: string;
        /** The url of the image used as a thumbnail for the canvas */
        url: string;
      };
      /** The control image for structure. A canny detector will be applied to this image. Must reference an existing AssetId. */
      structureImage?: string;
      /** To invert the relief */
      invert?: boolean;
      kind: "3d" | "audio" | "document" | "image" | "json" | "video";
      colorMode?: string;
      /** High threshold for Canny detector */
      highThreshold?: number;
      /** (deprecated) Vertical expansion ratio. */
      verticalExpansionRatio?: number;
      halfMode?: boolean;
      name?: string;
      /** Additional refinement steps before scaling.
            
            If scalingFactor == 1, the refinement process will be applied (1 + refinementSteps) times.
            If scalingFactor > 1, the refinement process will be applied refinementSteps times. */
      refinementSteps?: number;
      /** The reference images used for the image generation or editing */
      referenceImages?: string[];
      /** The higher the value the more it will look like the style image(s) */
      styleFidelity?: number;
      /** Boolean to output the contours. */
      resultContours?: boolean;
      /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
      polished?: number;
      /** The scheduler used to generate this asset */
      scheduler?: string;
      /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
      overrideEmbeddings?: boolean;
      progressPercent?: number;
      /** Contrast factor for Grayscale detector */
      factor?: number;
      /** The mask used for the image generation or editing */
      mask?: string;
      /** Low threshold for Canny detector */
      lowThreshold?: number;
      /** The depth fidelity if a depth image provided */
      depthFidelity?: number;
      /** How raised is the surface? 0 is flat like water, 1 is like a very rough rock */
      raised?: number;
      message?: string;
      contours?: number[][][][];
      /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
      negativePrompt?: string;
      /** If true, use the default parameters */
      defaultParameters?: boolean;
      /** Size proportion of the input image in the output. */
      resizeOption?: number;
      outputIndex?: number;
      /** Save a flipbook of the texture. Deactivated when the input texture is larger than 2048x2048px */
      saveFlipbook?: boolean;
      /** The guidance used to generate this asset */
      guidance?: number;
      /** The number of denoising steps for each image generation. */
      numInferenceSteps?: number;
      hdr?: number;
      /** How shiny is the surface? 0 is like a matte surface, 1 is like a diamond */
      shiny?: number;
      /** Ensure upscaled tile have the same color histogram as original tile. */
      colorCorrection?: boolean;
      /** Overlap percentage for the output image. */
      overlapPercentage?: number;
      /** The prompt that guided the image generation or editing */
      prompt?: string;
      /** Boolean to able output the cut out object. */
      resultImage?: boolean;
      /** The control image already processed by canny detector. Must reference an existing AssetId. */
      cannyStructureImage?: string;
      /** Apply extra control to the Skybox 360 geometry.
            The higher the value, the more the 360 geometry will influence the generated skybox image.
            
            Use with caution. Default is adapted to the other parameters. */
      geometryEnforcement?: number;
      /** Target width for the upscaled image, take priority over scaling factor */
      targetWidth?: number;
    };
    /** The NSFW labels */
    nsfw?: string[];
    /** Automatic captioning of the asset */
    automaticCaptioning?: string;
    /** The description of the asset */
    description?: string;
    /** The privacy of the asset */
    privacy: "private" | "public" | "unlisted";
    /** The date when the asset will be soft deleted (only for Free plan) */
    softDeletionOn?: string;
    /** The mime type of the asset (example: "image/png") */
    mimeType: string;
    /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
    authorId: string;
    /** The owner (project) ID (example: "proj_23tlk332lkht3kl2" or "team_dlkhgs23tlk3hlkth32lkht3kl2" for old teams) */
    ownerId: string;
    /** Signed URL to get the asset content */
    url: string;
    /** The associated tags (example: ["sci-fi", "landscape"]) */
    tags: string[];
    /** The asset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt: string;
    /** The output index of the asset within the job
        This index is an positive integer that starts at 0
        It is used to differentiate between multiple outputs of the same job
        If the job has only one output, this index is 0
        This is only applicable for generations with: Flux, Skybox, Reframe at the moment */
    outputIndex?: number;
    /** A list of CollectionId this asset belongs to */
    collectionIds: string[];
    /** List of edit capabilities for the asset */
    editCapabilities: (
      | "DETECTION"
      | "GENERATIVE_FILL"
      | "PIXELATE"
      | "PROMPT_EDITING"
      | "REFINE"
      | "REFRAME"
      | "REMOVE_BACKGROUND"
      | "SEGMENTATION"
      | "UPSCALE"
      | "UPSCALE_360"
      | "VECTORIZATION"
    )[];
    /** The embedding of the asset when requested and asset can be embedded
        
        ie: Detection maps don't have embeddings */
    embedding?: number[];
    /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
    id: string;
    /** The status of the asset */
    status: "error" | "pending" | "success";
    /** The asset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    updatedAt: string;
  };
};
export type CopyAssetByAssetIdApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The ID of the asset to duplicate */
  assetId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
};
export type LockAssetByAssetIdApiResponse = /** status 200 200 response */ {
  /** The value of the lock to use when updating/unlocking the canvas. */
  lockId?: string;
  asset: {
    /** Metadata of the asset with some additional information */
    metadata: {
      maxIterations?: number;
      /** Modality to detect */
      modality?:
        | "canny"
        | "depth"
        | "grayscale"
        | "lineart_anime"
        | "mlsd"
        | "normal"
        | "pose"
        | "scribble"
        | "segmentation"
        | "sketch";
      /** If set to true, during the upscaling process, the model will match tiles of the source image with tiles of the style image(s). This will result in a more coherent restyle. Works best with style images that have a similar composition. */
      tileStyle?: boolean;
      /** The modelId used to generate this asset */
      modelId?: string;
      /** A bounding box around the object of interest, in the format [x1, y1, x2, y2]. */
      bbox?: any[];
      /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
      keypointThreshold?: number;
      /** The type of the asset. Ex: 'inference-txt2img' will represent an asset generated from a text to image model */
      type:
        | "background-removal"
        | "canvas"
        | "canvas-drawing"
        | "canvas-export"
        | "detection"
        | "generative-fill"
        | "image-prompt-editing"
        | "img23d-custom"
        | "img2img-custom"
        | "img2video-custom"
        | "inference-controlnet"
        | "inference-controlnet-img2img"
        | "inference-controlnet-inpaint"
        | "inference-controlnet-inpaint-ip-adapter"
        | "inference-controlnet-ip-adapter"
        | "inference-controlnet-reference"
        | "inference-controlnet-texture"
        | "inference-img2img"
        | "inference-img2img-ip-adapter"
        | "inference-img2img-texture"
        | "inference-inpaint"
        | "inference-inpaint-ip-adapter"
        | "inference-reference"
        | "inference-reference-texture"
        | "inference-txt2img"
        | "inference-txt2img-ip-adapter"
        | "inference-txt2img-texture"
        | "patch"
        | "pixelization"
        | "reframe"
        | "restyle"
        | "segment"
        | "segmentation-image"
        | "segmentation-mask"
        | "skybox-base-360"
        | "texture"
        | "texture-albedo"
        | "texture-ao"
        | "texture-edge"
        | "texture-height"
        | "texture-metallic"
        | "texture-normal"
        | "texture-smoothness"
        | "txt23d-custom"
        | "txt2audio-custom"
        | "txt2img-custom"
        | "unknown-custom"
        | "uploaded"
        | "upscale"
        | "upscale-skybox"
        | "upscale-texture"
        | "vectorization"
        | "video2video-custom";
      /** A textual description / keywords describing the object of interest. */
      text?: string;
      height?: number;
      nbMasks?: number;
      /** Amount of decay in creativity over the upscale process. The lowest the value, the less the creativity will be preserved over the upscale process. */
      creativityDecay?: number;
      layerDifference?: number;
      /** Scaling factor (when `targetWidth` not specified) */
      scalingFactor?: number;
      /** The type of the generator used */
      modelType?:
        | "custom"
        | "flux.1"
        | "flux.1-composition"
        | "flux.1-lora"
        | "flux.1-pro"
        | "flux.1.1-pro-ultra"
        | "flux1.1-pro"
        | "gpt-image-1"
        | "sd-1_5"
        | "sd-1_5-composition"
        | "sd-1_5-lora"
        | "sd-xl"
        | "sd-xl-composition"
        | "sd-xl-lora";
      /** The number of outputs to generate. */
      numOutputs?: number;
      /** How angular is the surface? 0 is like a sphere, 1 is like a mechanical object */
      angular?: number;
      /** The target height of the output image. */
      targetHeight?: number;
      /** Flux LoRa or Composition to style the image. */
      concepts?: {
        weightName: string;
        /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
        modelId: string;
        /** The scale of the model (example: 1.0) */
        scale: number;
      }[];
      size?: number;
      spliceThreshold?: number;
      /** The number of pixels to dilate the result masks. */
      dilate?: number;
      style?:
        | "3d-cartoon"
        | "3d-rendered"
        | "anime"
        | "cartoon"
        | "cinematic"
        | "claymation"
        | "cloud-skydome"
        | "comic"
        | "cyberpunk"
        | "enchanted"
        | "fantasy"
        | "ink"
        | "manga"
        | "manga-color"
        | "minimalist"
        | "neon-tron"
        | "oil-painting"
        | "pastel"
        | "photo"
        | "photography"
        | "psychedelic"
        | "retro-fantasy"
        | "scifi-concept-art"
        | "space"
        | "standard"
        | "whimsical";
      /** Strengthen the similarity to the original image during the upscale. Default: optimized for your preset and style. */
      imageFidelity?: number;
      /** Location of the input image in the output. */
      inputLocation?: "bottom" | "left" | "middle" | "right" | "top";
      /** The seed used to generate this asset */
      seed?: string;
      /** The higher the value the more it will look like the secondary reference image(s) */
      secondaryRefFidelity?: number;
      preset?: string;
      trainingImage?: boolean;
      /** Boolean to able return the masks (binary image) in the response. */
      resultMask?: boolean;
      /** The ISO timestamp when the lock on the canvas will expire */
      lockExpiresAt?: string;
      /** The baseModelId that maybe changed at inference time */
      baseModelId?: string;
      pathPrecision?: number;
      rootParentId?: string;
      /** Sharpen tiles. */
      sharpen?: boolean;
      cornerThreshold?: number;
      /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
      styleImages?: string[];
      /** The asset to convert in texture maps. Must reference an existing AssetId. */
      texture?: string;
      filterSpeckle?: number;
      /** Minimum threshold for Grayscale conversion */
      minThreshold?: number;
      /** Maximum threshold for Grayscale conversion */
      maxThreshold?: number;
      /** Condition the influence of the style image(s). The higher the value, the more the style images will influence the upscaled image. */
      styleImagesFidelity?: number;
      /** The control image processed by depth estimator. Must reference an existing AssetId. */
      depthImage?: string;
      parentId?: string;
      parentJobId?: string;
      /** Optional List of secondary style images. Example: portrait of people. It must be existing AssetIds. */
      secondaryRefImages?: string[];
      /** The width of the rendered image. */
      width?: number;
      /** The checkpoint to use */
      checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
      strength?: number;
      /** The id of the Inference describing how this image was generated */
      inferenceId?: string;
      lengthThreshold?: number;
      /** Int to set between 0 and 255 for the opacity of the background in the result images. */
      backgroundOpacity?: number;
      /** The optional aspect ratio given for the generation, only applicable for some models */
      aspectRatio?: string;
      /** Amount of details to remove or add */
      detailsLevel?: number;
      /** Determine the scale at which the upscale process works.
            - With a small value, the upscale works at the largest scale, resulting in fewer added details and more coherent images. Ideal for portraits, for example.
            - With a large value, the upscale works at the smallest scale, resulting in more added details and more hallucinations. Ideal for landscapes, for example.
            
            (info): A small value is slower and more expensive to run. */
      fractality?: number;
      /** (deprecated) Horizontal expansion ratio. */
      horizontalExpansionRatio?: number;
      /** List of points (label, x, y) in the image where label = 0 for background and 1 for object. */
      points?: any[][];
      mode?: string;
      colorPrecision?: number;
      /** Increase the fidelity to the prompt during upscale. Default: optimized for your preset and style. */
      promptFidelity?: number;
      /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
      betterQuality?: boolean;
      /** Remove background for Grayscale detector */
      removeBackground?: boolean;
      /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your preset and style. */
      creativity?: number;
      /** Strength for the input image structure preservation */
      structureFidelity?: number;
      /** Preserve the seamless properties of skybox or texture images. Input has to be of same type (seamless). */
      imageType?: "seamfull" | "skybox" | "texture";
      /** The input image to process. Must reference an existing AssetId or be a data URL. */
      image?: string;
      /** The thumbnail of the canvas */
      thumbnail?: {
        /** The AssetId of the image used as a thumbnail for the canvas (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        assetId: string;
        /** The url of the image used as a thumbnail for the canvas */
        url: string;
      };
      /** The control image for structure. A canny detector will be applied to this image. Must reference an existing AssetId. */
      structureImage?: string;
      /** To invert the relief */
      invert?: boolean;
      kind: "3d" | "audio" | "document" | "image" | "json" | "video";
      colorMode?: string;
      /** High threshold for Canny detector */
      highThreshold?: number;
      /** (deprecated) Vertical expansion ratio. */
      verticalExpansionRatio?: number;
      halfMode?: boolean;
      name?: string;
      /** Additional refinement steps before scaling.
            
            If scalingFactor == 1, the refinement process will be applied (1 + refinementSteps) times.
            If scalingFactor > 1, the refinement process will be applied refinementSteps times. */
      refinementSteps?: number;
      /** The reference images used for the image generation or editing */
      referenceImages?: string[];
      /** The higher the value the more it will look like the style image(s) */
      styleFidelity?: number;
      /** Boolean to output the contours. */
      resultContours?: boolean;
      /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
      polished?: number;
      /** The scheduler used to generate this asset */
      scheduler?: string;
      /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
      overrideEmbeddings?: boolean;
      progressPercent?: number;
      /** Contrast factor for Grayscale detector */
      factor?: number;
      /** The mask used for the image generation or editing */
      mask?: string;
      /** Low threshold for Canny detector */
      lowThreshold?: number;
      /** The depth fidelity if a depth image provided */
      depthFidelity?: number;
      /** How raised is the surface? 0 is flat like water, 1 is like a very rough rock */
      raised?: number;
      message?: string;
      contours?: number[][][][];
      /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
      negativePrompt?: string;
      /** If true, use the default parameters */
      defaultParameters?: boolean;
      /** Size proportion of the input image in the output. */
      resizeOption?: number;
      outputIndex?: number;
      /** Save a flipbook of the texture. Deactivated when the input texture is larger than 2048x2048px */
      saveFlipbook?: boolean;
      /** The guidance used to generate this asset */
      guidance?: number;
      /** The number of denoising steps for each image generation. */
      numInferenceSteps?: number;
      hdr?: number;
      /** How shiny is the surface? 0 is like a matte surface, 1 is like a diamond */
      shiny?: number;
      /** Ensure upscaled tile have the same color histogram as original tile. */
      colorCorrection?: boolean;
      /** Overlap percentage for the output image. */
      overlapPercentage?: number;
      /** The prompt that guided the image generation or editing */
      prompt?: string;
      /** Boolean to able output the cut out object. */
      resultImage?: boolean;
      /** The control image already processed by canny detector. Must reference an existing AssetId. */
      cannyStructureImage?: string;
      /** Apply extra control to the Skybox 360 geometry.
            The higher the value, the more the 360 geometry will influence the generated skybox image.
            
            Use with caution. Default is adapted to the other parameters. */
      geometryEnforcement?: number;
      /** Target width for the upscaled image, take priority over scaling factor */
      targetWidth?: number;
    };
    /** The NSFW labels */
    nsfw?: string[];
    /** Automatic captioning of the asset */
    automaticCaptioning?: string;
    /** The description of the asset */
    description?: string;
    /** The privacy of the asset */
    privacy: "private" | "public" | "unlisted";
    /** The date when the asset will be soft deleted (only for Free plan) */
    softDeletionOn?: string;
    /** The mime type of the asset (example: "image/png") */
    mimeType: string;
    /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
    authorId: string;
    /** The owner (project) ID (example: "proj_23tlk332lkht3kl2" or "team_dlkhgs23tlk3hlkth32lkht3kl2" for old teams) */
    ownerId: string;
    /** Signed URL to get the asset content */
    url: string;
    /** The associated tags (example: ["sci-fi", "landscape"]) */
    tags: string[];
    /** The asset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt: string;
    /** The output index of the asset within the job
        This index is an positive integer that starts at 0
        It is used to differentiate between multiple outputs of the same job
        If the job has only one output, this index is 0
        This is only applicable for generations with: Flux, Skybox, Reframe at the moment */
    outputIndex?: number;
    /** A list of CollectionId this asset belongs to */
    collectionIds: string[];
    /** List of edit capabilities for the asset */
    editCapabilities: (
      | "DETECTION"
      | "GENERATIVE_FILL"
      | "PIXELATE"
      | "PROMPT_EDITING"
      | "REFINE"
      | "REFRAME"
      | "REMOVE_BACKGROUND"
      | "SEGMENTATION"
      | "UPSCALE"
      | "UPSCALE_360"
      | "VECTORIZATION"
    )[];
    /** The embedding of the asset when requested and asset can be embedded
        
        ie: Detection maps don't have embeddings */
    embedding?: number[];
    /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
    id: string;
    /** The status of the asset */
    status: "error" | "pending" | "success";
    /** The asset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    updatedAt: string;
  };
};
export type LockAssetByAssetIdApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The ID of the canvas to lock */
  assetId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** The ISO timestamp when the lock on the canvas will expire. */
    lockExpiresAt: string;
  };
};
export type PrivacyAssetByAssetIdApiResponse = /** status 200 200 response */ {
  asset: {
    /** Metadata of the asset with some additional information */
    metadata: {
      maxIterations?: number;
      /** Modality to detect */
      modality?:
        | "canny"
        | "depth"
        | "grayscale"
        | "lineart_anime"
        | "mlsd"
        | "normal"
        | "pose"
        | "scribble"
        | "segmentation"
        | "sketch";
      /** If set to true, during the upscaling process, the model will match tiles of the source image with tiles of the style image(s). This will result in a more coherent restyle. Works best with style images that have a similar composition. */
      tileStyle?: boolean;
      /** The modelId used to generate this asset */
      modelId?: string;
      /** A bounding box around the object of interest, in the format [x1, y1, x2, y2]. */
      bbox?: any[];
      /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
      keypointThreshold?: number;
      /** The type of the asset. Ex: 'inference-txt2img' will represent an asset generated from a text to image model */
      type:
        | "background-removal"
        | "canvas"
        | "canvas-drawing"
        | "canvas-export"
        | "detection"
        | "generative-fill"
        | "image-prompt-editing"
        | "img23d-custom"
        | "img2img-custom"
        | "img2video-custom"
        | "inference-controlnet"
        | "inference-controlnet-img2img"
        | "inference-controlnet-inpaint"
        | "inference-controlnet-inpaint-ip-adapter"
        | "inference-controlnet-ip-adapter"
        | "inference-controlnet-reference"
        | "inference-controlnet-texture"
        | "inference-img2img"
        | "inference-img2img-ip-adapter"
        | "inference-img2img-texture"
        | "inference-inpaint"
        | "inference-inpaint-ip-adapter"
        | "inference-reference"
        | "inference-reference-texture"
        | "inference-txt2img"
        | "inference-txt2img-ip-adapter"
        | "inference-txt2img-texture"
        | "patch"
        | "pixelization"
        | "reframe"
        | "restyle"
        | "segment"
        | "segmentation-image"
        | "segmentation-mask"
        | "skybox-base-360"
        | "texture"
        | "texture-albedo"
        | "texture-ao"
        | "texture-edge"
        | "texture-height"
        | "texture-metallic"
        | "texture-normal"
        | "texture-smoothness"
        | "txt23d-custom"
        | "txt2audio-custom"
        | "txt2img-custom"
        | "unknown-custom"
        | "uploaded"
        | "upscale"
        | "upscale-skybox"
        | "upscale-texture"
        | "vectorization"
        | "video2video-custom";
      /** A textual description / keywords describing the object of interest. */
      text?: string;
      height?: number;
      nbMasks?: number;
      /** Amount of decay in creativity over the upscale process. The lowest the value, the less the creativity will be preserved over the upscale process. */
      creativityDecay?: number;
      layerDifference?: number;
      /** Scaling factor (when `targetWidth` not specified) */
      scalingFactor?: number;
      /** The type of the generator used */
      modelType?:
        | "custom"
        | "flux.1"
        | "flux.1-composition"
        | "flux.1-lora"
        | "flux.1-pro"
        | "flux.1.1-pro-ultra"
        | "flux1.1-pro"
        | "gpt-image-1"
        | "sd-1_5"
        | "sd-1_5-composition"
        | "sd-1_5-lora"
        | "sd-xl"
        | "sd-xl-composition"
        | "sd-xl-lora";
      /** The number of outputs to generate. */
      numOutputs?: number;
      /** How angular is the surface? 0 is like a sphere, 1 is like a mechanical object */
      angular?: number;
      /** The target height of the output image. */
      targetHeight?: number;
      /** Flux LoRa or Composition to style the image. */
      concepts?: {
        weightName: string;
        /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
        modelId: string;
        /** The scale of the model (example: 1.0) */
        scale: number;
      }[];
      size?: number;
      spliceThreshold?: number;
      /** The number of pixels to dilate the result masks. */
      dilate?: number;
      style?:
        | "3d-cartoon"
        | "3d-rendered"
        | "anime"
        | "cartoon"
        | "cinematic"
        | "claymation"
        | "cloud-skydome"
        | "comic"
        | "cyberpunk"
        | "enchanted"
        | "fantasy"
        | "ink"
        | "manga"
        | "manga-color"
        | "minimalist"
        | "neon-tron"
        | "oil-painting"
        | "pastel"
        | "photo"
        | "photography"
        | "psychedelic"
        | "retro-fantasy"
        | "scifi-concept-art"
        | "space"
        | "standard"
        | "whimsical";
      /** Strengthen the similarity to the original image during the upscale. Default: optimized for your preset and style. */
      imageFidelity?: number;
      /** Location of the input image in the output. */
      inputLocation?: "bottom" | "left" | "middle" | "right" | "top";
      /** The seed used to generate this asset */
      seed?: string;
      /** The higher the value the more it will look like the secondary reference image(s) */
      secondaryRefFidelity?: number;
      preset?: string;
      trainingImage?: boolean;
      /** Boolean to able return the masks (binary image) in the response. */
      resultMask?: boolean;
      /** The ISO timestamp when the lock on the canvas will expire */
      lockExpiresAt?: string;
      /** The baseModelId that maybe changed at inference time */
      baseModelId?: string;
      pathPrecision?: number;
      rootParentId?: string;
      /** Sharpen tiles. */
      sharpen?: boolean;
      cornerThreshold?: number;
      /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
      styleImages?: string[];
      /** The asset to convert in texture maps. Must reference an existing AssetId. */
      texture?: string;
      filterSpeckle?: number;
      /** Minimum threshold for Grayscale conversion */
      minThreshold?: number;
      /** Maximum threshold for Grayscale conversion */
      maxThreshold?: number;
      /** Condition the influence of the style image(s). The higher the value, the more the style images will influence the upscaled image. */
      styleImagesFidelity?: number;
      /** The control image processed by depth estimator. Must reference an existing AssetId. */
      depthImage?: string;
      parentId?: string;
      parentJobId?: string;
      /** Optional List of secondary style images. Example: portrait of people. It must be existing AssetIds. */
      secondaryRefImages?: string[];
      /** The width of the rendered image. */
      width?: number;
      /** The checkpoint to use */
      checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
      strength?: number;
      /** The id of the Inference describing how this image was generated */
      inferenceId?: string;
      lengthThreshold?: number;
      /** Int to set between 0 and 255 for the opacity of the background in the result images. */
      backgroundOpacity?: number;
      /** The optional aspect ratio given for the generation, only applicable for some models */
      aspectRatio?: string;
      /** Amount of details to remove or add */
      detailsLevel?: number;
      /** Determine the scale at which the upscale process works.
            - With a small value, the upscale works at the largest scale, resulting in fewer added details and more coherent images. Ideal for portraits, for example.
            - With a large value, the upscale works at the smallest scale, resulting in more added details and more hallucinations. Ideal for landscapes, for example.
            
            (info): A small value is slower and more expensive to run. */
      fractality?: number;
      /** (deprecated) Horizontal expansion ratio. */
      horizontalExpansionRatio?: number;
      /** List of points (label, x, y) in the image where label = 0 for background and 1 for object. */
      points?: any[][];
      mode?: string;
      colorPrecision?: number;
      /** Increase the fidelity to the prompt during upscale. Default: optimized for your preset and style. */
      promptFidelity?: number;
      /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
      betterQuality?: boolean;
      /** Remove background for Grayscale detector */
      removeBackground?: boolean;
      /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your preset and style. */
      creativity?: number;
      /** Strength for the input image structure preservation */
      structureFidelity?: number;
      /** Preserve the seamless properties of skybox or texture images. Input has to be of same type (seamless). */
      imageType?: "seamfull" | "skybox" | "texture";
      /** The input image to process. Must reference an existing AssetId or be a data URL. */
      image?: string;
      /** The thumbnail of the canvas */
      thumbnail?: {
        /** The AssetId of the image used as a thumbnail for the canvas (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        assetId: string;
        /** The url of the image used as a thumbnail for the canvas */
        url: string;
      };
      /** The control image for structure. A canny detector will be applied to this image. Must reference an existing AssetId. */
      structureImage?: string;
      /** To invert the relief */
      invert?: boolean;
      kind: "3d" | "audio" | "document" | "image" | "json" | "video";
      colorMode?: string;
      /** High threshold for Canny detector */
      highThreshold?: number;
      /** (deprecated) Vertical expansion ratio. */
      verticalExpansionRatio?: number;
      halfMode?: boolean;
      name?: string;
      /** Additional refinement steps before scaling.
            
            If scalingFactor == 1, the refinement process will be applied (1 + refinementSteps) times.
            If scalingFactor > 1, the refinement process will be applied refinementSteps times. */
      refinementSteps?: number;
      /** The reference images used for the image generation or editing */
      referenceImages?: string[];
      /** The higher the value the more it will look like the style image(s) */
      styleFidelity?: number;
      /** Boolean to output the contours. */
      resultContours?: boolean;
      /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
      polished?: number;
      /** The scheduler used to generate this asset */
      scheduler?: string;
      /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
      overrideEmbeddings?: boolean;
      progressPercent?: number;
      /** Contrast factor for Grayscale detector */
      factor?: number;
      /** The mask used for the image generation or editing */
      mask?: string;
      /** Low threshold for Canny detector */
      lowThreshold?: number;
      /** The depth fidelity if a depth image provided */
      depthFidelity?: number;
      /** How raised is the surface? 0 is flat like water, 1 is like a very rough rock */
      raised?: number;
      message?: string;
      contours?: number[][][][];
      /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
      negativePrompt?: string;
      /** If true, use the default parameters */
      defaultParameters?: boolean;
      /** Size proportion of the input image in the output. */
      resizeOption?: number;
      outputIndex?: number;
      /** Save a flipbook of the texture. Deactivated when the input texture is larger than 2048x2048px */
      saveFlipbook?: boolean;
      /** The guidance used to generate this asset */
      guidance?: number;
      /** The number of denoising steps for each image generation. */
      numInferenceSteps?: number;
      hdr?: number;
      /** How shiny is the surface? 0 is like a matte surface, 1 is like a diamond */
      shiny?: number;
      /** Ensure upscaled tile have the same color histogram as original tile. */
      colorCorrection?: boolean;
      /** Overlap percentage for the output image. */
      overlapPercentage?: number;
      /** The prompt that guided the image generation or editing */
      prompt?: string;
      /** Boolean to able output the cut out object. */
      resultImage?: boolean;
      /** The control image already processed by canny detector. Must reference an existing AssetId. */
      cannyStructureImage?: string;
      /** Apply extra control to the Skybox 360 geometry.
            The higher the value, the more the 360 geometry will influence the generated skybox image.
            
            Use with caution. Default is adapted to the other parameters. */
      geometryEnforcement?: number;
      /** Target width for the upscaled image, take priority over scaling factor */
      targetWidth?: number;
    };
    /** The NSFW labels */
    nsfw?: string[];
    /** Automatic captioning of the asset */
    automaticCaptioning?: string;
    /** The description of the asset */
    description?: string;
    /** The privacy of the asset */
    privacy: "private" | "public" | "unlisted";
    /** The date when the asset will be soft deleted (only for Free plan) */
    softDeletionOn?: string;
    /** The mime type of the asset (example: "image/png") */
    mimeType: string;
    /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
    authorId: string;
    /** The owner (project) ID (example: "proj_23tlk332lkht3kl2" or "team_dlkhgs23tlk3hlkth32lkht3kl2" for old teams) */
    ownerId: string;
    /** Signed URL to get the asset content */
    url: string;
    /** The associated tags (example: ["sci-fi", "landscape"]) */
    tags: string[];
    /** The asset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt: string;
    /** The output index of the asset within the job
        This index is an positive integer that starts at 0
        It is used to differentiate between multiple outputs of the same job
        If the job has only one output, this index is 0
        This is only applicable for generations with: Flux, Skybox, Reframe at the moment */
    outputIndex?: number;
    /** A list of CollectionId this asset belongs to */
    collectionIds: string[];
    /** List of edit capabilities for the asset */
    editCapabilities: (
      | "DETECTION"
      | "GENERATIVE_FILL"
      | "PIXELATE"
      | "PROMPT_EDITING"
      | "REFINE"
      | "REFRAME"
      | "REMOVE_BACKGROUND"
      | "SEGMENTATION"
      | "UPSCALE"
      | "UPSCALE_360"
      | "VECTORIZATION"
    )[];
    /** The embedding of the asset when requested and asset can be embedded
        
        ie: Detection maps don't have embeddings */
    embedding?: number[];
    /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
    id: string;
    /** The status of the asset */
    status: "error" | "pending" | "success";
    /** The asset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    updatedAt: string;
  };
};
export type PrivacyAssetByAssetIdApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The ID of the asset to change the privacy of */
  assetId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** The privacy of the asset */
    privacy?: "public" | "private";
  };
};
export type GetCanvasAssetSnapshotsApiResponse =
  /** status 200 200 response */ {
    snapshots: {
      takenAt: number;
      rawData: string;
      authorId: string;
      hash: string;
    }[];
    /** A token to query the next page of snapshots */
    nextPaginationToken?: string;
  };
export type GetCanvasAssetSnapshotsApiArg = {
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  /** The number of items to return in the response. The default value is 10, maximum value is 100, minimum value is 10 */
  pageSize?: string;
  /** The ID of the canvas asset to list snapshots for */
  assetId: string;
  /** A token you received in a previous request to query the next page of items */
  paginationToken?: string;
};
export type PutAssetsTagsByAssetIdApiResponse = /** status 200 200 response */ {
  /** The list of deleted tags */
  deleted: string[];
  /** The list of added tags */
  added: string[];
};
export type PutAssetsTagsByAssetIdApiArg = {
  /** The ID of the asset to update its tags */
  assetId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** The list of tags to add */
    add?: string[];
    /** If true, the function will throw an error if:
        - one of the tags to add already exists
        - one of the tags to delete is not found
        If false, the endpoint will behave as if it was idempotent */
    strict?: boolean;
    /** The list of tags to delete */
    delete?: string[];
  };
};
export type UnlockAssetByAssetIdApiResponse = /** status 200 200 response */ {
  asset: {
    /** Metadata of the asset with some additional information */
    metadata: {
      maxIterations?: number;
      /** Modality to detect */
      modality?:
        | "canny"
        | "depth"
        | "grayscale"
        | "lineart_anime"
        | "mlsd"
        | "normal"
        | "pose"
        | "scribble"
        | "segmentation"
        | "sketch";
      /** If set to true, during the upscaling process, the model will match tiles of the source image with tiles of the style image(s). This will result in a more coherent restyle. Works best with style images that have a similar composition. */
      tileStyle?: boolean;
      /** The modelId used to generate this asset */
      modelId?: string;
      /** A bounding box around the object of interest, in the format [x1, y1, x2, y2]. */
      bbox?: any[];
      /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
      keypointThreshold?: number;
      /** The type of the asset. Ex: 'inference-txt2img' will represent an asset generated from a text to image model */
      type:
        | "background-removal"
        | "canvas"
        | "canvas-drawing"
        | "canvas-export"
        | "detection"
        | "generative-fill"
        | "image-prompt-editing"
        | "img23d-custom"
        | "img2img-custom"
        | "img2video-custom"
        | "inference-controlnet"
        | "inference-controlnet-img2img"
        | "inference-controlnet-inpaint"
        | "inference-controlnet-inpaint-ip-adapter"
        | "inference-controlnet-ip-adapter"
        | "inference-controlnet-reference"
        | "inference-controlnet-texture"
        | "inference-img2img"
        | "inference-img2img-ip-adapter"
        | "inference-img2img-texture"
        | "inference-inpaint"
        | "inference-inpaint-ip-adapter"
        | "inference-reference"
        | "inference-reference-texture"
        | "inference-txt2img"
        | "inference-txt2img-ip-adapter"
        | "inference-txt2img-texture"
        | "patch"
        | "pixelization"
        | "reframe"
        | "restyle"
        | "segment"
        | "segmentation-image"
        | "segmentation-mask"
        | "skybox-base-360"
        | "texture"
        | "texture-albedo"
        | "texture-ao"
        | "texture-edge"
        | "texture-height"
        | "texture-metallic"
        | "texture-normal"
        | "texture-smoothness"
        | "txt23d-custom"
        | "txt2audio-custom"
        | "txt2img-custom"
        | "unknown-custom"
        | "uploaded"
        | "upscale"
        | "upscale-skybox"
        | "upscale-texture"
        | "vectorization"
        | "video2video-custom";
      /** A textual description / keywords describing the object of interest. */
      text?: string;
      height?: number;
      nbMasks?: number;
      /** Amount of decay in creativity over the upscale process. The lowest the value, the less the creativity will be preserved over the upscale process. */
      creativityDecay?: number;
      layerDifference?: number;
      /** Scaling factor (when `targetWidth` not specified) */
      scalingFactor?: number;
      /** The type of the generator used */
      modelType?:
        | "custom"
        | "flux.1"
        | "flux.1-composition"
        | "flux.1-lora"
        | "flux.1-pro"
        | "flux.1.1-pro-ultra"
        | "flux1.1-pro"
        | "gpt-image-1"
        | "sd-1_5"
        | "sd-1_5-composition"
        | "sd-1_5-lora"
        | "sd-xl"
        | "sd-xl-composition"
        | "sd-xl-lora";
      /** The number of outputs to generate. */
      numOutputs?: number;
      /** How angular is the surface? 0 is like a sphere, 1 is like a mechanical object */
      angular?: number;
      /** The target height of the output image. */
      targetHeight?: number;
      /** Flux LoRa or Composition to style the image. */
      concepts?: {
        weightName: string;
        /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
        modelId: string;
        /** The scale of the model (example: 1.0) */
        scale: number;
      }[];
      size?: number;
      spliceThreshold?: number;
      /** The number of pixels to dilate the result masks. */
      dilate?: number;
      style?:
        | "3d-cartoon"
        | "3d-rendered"
        | "anime"
        | "cartoon"
        | "cinematic"
        | "claymation"
        | "cloud-skydome"
        | "comic"
        | "cyberpunk"
        | "enchanted"
        | "fantasy"
        | "ink"
        | "manga"
        | "manga-color"
        | "minimalist"
        | "neon-tron"
        | "oil-painting"
        | "pastel"
        | "photo"
        | "photography"
        | "psychedelic"
        | "retro-fantasy"
        | "scifi-concept-art"
        | "space"
        | "standard"
        | "whimsical";
      /** Strengthen the similarity to the original image during the upscale. Default: optimized for your preset and style. */
      imageFidelity?: number;
      /** Location of the input image in the output. */
      inputLocation?: "bottom" | "left" | "middle" | "right" | "top";
      /** The seed used to generate this asset */
      seed?: string;
      /** The higher the value the more it will look like the secondary reference image(s) */
      secondaryRefFidelity?: number;
      preset?: string;
      trainingImage?: boolean;
      /** Boolean to able return the masks (binary image) in the response. */
      resultMask?: boolean;
      /** The ISO timestamp when the lock on the canvas will expire */
      lockExpiresAt?: string;
      /** The baseModelId that maybe changed at inference time */
      baseModelId?: string;
      pathPrecision?: number;
      rootParentId?: string;
      /** Sharpen tiles. */
      sharpen?: boolean;
      cornerThreshold?: number;
      /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
      styleImages?: string[];
      /** The asset to convert in texture maps. Must reference an existing AssetId. */
      texture?: string;
      filterSpeckle?: number;
      /** Minimum threshold for Grayscale conversion */
      minThreshold?: number;
      /** Maximum threshold for Grayscale conversion */
      maxThreshold?: number;
      /** Condition the influence of the style image(s). The higher the value, the more the style images will influence the upscaled image. */
      styleImagesFidelity?: number;
      /** The control image processed by depth estimator. Must reference an existing AssetId. */
      depthImage?: string;
      parentId?: string;
      parentJobId?: string;
      /** Optional List of secondary style images. Example: portrait of people. It must be existing AssetIds. */
      secondaryRefImages?: string[];
      /** The width of the rendered image. */
      width?: number;
      /** The checkpoint to use */
      checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
      strength?: number;
      /** The id of the Inference describing how this image was generated */
      inferenceId?: string;
      lengthThreshold?: number;
      /** Int to set between 0 and 255 for the opacity of the background in the result images. */
      backgroundOpacity?: number;
      /** The optional aspect ratio given for the generation, only applicable for some models */
      aspectRatio?: string;
      /** Amount of details to remove or add */
      detailsLevel?: number;
      /** Determine the scale at which the upscale process works.
            - With a small value, the upscale works at the largest scale, resulting in fewer added details and more coherent images. Ideal for portraits, for example.
            - With a large value, the upscale works at the smallest scale, resulting in more added details and more hallucinations. Ideal for landscapes, for example.
            
            (info): A small value is slower and more expensive to run. */
      fractality?: number;
      /** (deprecated) Horizontal expansion ratio. */
      horizontalExpansionRatio?: number;
      /** List of points (label, x, y) in the image where label = 0 for background and 1 for object. */
      points?: any[][];
      mode?: string;
      colorPrecision?: number;
      /** Increase the fidelity to the prompt during upscale. Default: optimized for your preset and style. */
      promptFidelity?: number;
      /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
      betterQuality?: boolean;
      /** Remove background for Grayscale detector */
      removeBackground?: boolean;
      /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your preset and style. */
      creativity?: number;
      /** Strength for the input image structure preservation */
      structureFidelity?: number;
      /** Preserve the seamless properties of skybox or texture images. Input has to be of same type (seamless). */
      imageType?: "seamfull" | "skybox" | "texture";
      /** The input image to process. Must reference an existing AssetId or be a data URL. */
      image?: string;
      /** The thumbnail of the canvas */
      thumbnail?: {
        /** The AssetId of the image used as a thumbnail for the canvas (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        assetId: string;
        /** The url of the image used as a thumbnail for the canvas */
        url: string;
      };
      /** The control image for structure. A canny detector will be applied to this image. Must reference an existing AssetId. */
      structureImage?: string;
      /** To invert the relief */
      invert?: boolean;
      kind: "3d" | "audio" | "document" | "image" | "json" | "video";
      colorMode?: string;
      /** High threshold for Canny detector */
      highThreshold?: number;
      /** (deprecated) Vertical expansion ratio. */
      verticalExpansionRatio?: number;
      halfMode?: boolean;
      name?: string;
      /** Additional refinement steps before scaling.
            
            If scalingFactor == 1, the refinement process will be applied (1 + refinementSteps) times.
            If scalingFactor > 1, the refinement process will be applied refinementSteps times. */
      refinementSteps?: number;
      /** The reference images used for the image generation or editing */
      referenceImages?: string[];
      /** The higher the value the more it will look like the style image(s) */
      styleFidelity?: number;
      /** Boolean to output the contours. */
      resultContours?: boolean;
      /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
      polished?: number;
      /** The scheduler used to generate this asset */
      scheduler?: string;
      /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
      overrideEmbeddings?: boolean;
      progressPercent?: number;
      /** Contrast factor for Grayscale detector */
      factor?: number;
      /** The mask used for the image generation or editing */
      mask?: string;
      /** Low threshold for Canny detector */
      lowThreshold?: number;
      /** The depth fidelity if a depth image provided */
      depthFidelity?: number;
      /** How raised is the surface? 0 is flat like water, 1 is like a very rough rock */
      raised?: number;
      message?: string;
      contours?: number[][][][];
      /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
      negativePrompt?: string;
      /** If true, use the default parameters */
      defaultParameters?: boolean;
      /** Size proportion of the input image in the output. */
      resizeOption?: number;
      outputIndex?: number;
      /** Save a flipbook of the texture. Deactivated when the input texture is larger than 2048x2048px */
      saveFlipbook?: boolean;
      /** The guidance used to generate this asset */
      guidance?: number;
      /** The number of denoising steps for each image generation. */
      numInferenceSteps?: number;
      hdr?: number;
      /** How shiny is the surface? 0 is like a matte surface, 1 is like a diamond */
      shiny?: number;
      /** Ensure upscaled tile have the same color histogram as original tile. */
      colorCorrection?: boolean;
      /** Overlap percentage for the output image. */
      overlapPercentage?: number;
      /** The prompt that guided the image generation or editing */
      prompt?: string;
      /** Boolean to able output the cut out object. */
      resultImage?: boolean;
      /** The control image already processed by canny detector. Must reference an existing AssetId. */
      cannyStructureImage?: string;
      /** Apply extra control to the Skybox 360 geometry.
            The higher the value, the more the 360 geometry will influence the generated skybox image.
            
            Use with caution. Default is adapted to the other parameters. */
      geometryEnforcement?: number;
      /** Target width for the upscaled image, take priority over scaling factor */
      targetWidth?: number;
    };
    /** The NSFW labels */
    nsfw?: string[];
    /** Automatic captioning of the asset */
    automaticCaptioning?: string;
    /** The description of the asset */
    description?: string;
    /** The privacy of the asset */
    privacy: "private" | "public" | "unlisted";
    /** The date when the asset will be soft deleted (only for Free plan) */
    softDeletionOn?: string;
    /** The mime type of the asset (example: "image/png") */
    mimeType: string;
    /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
    authorId: string;
    /** The owner (project) ID (example: "proj_23tlk332lkht3kl2" or "team_dlkhgs23tlk3hlkth32lkht3kl2" for old teams) */
    ownerId: string;
    /** Signed URL to get the asset content */
    url: string;
    /** The associated tags (example: ["sci-fi", "landscape"]) */
    tags: string[];
    /** The asset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt: string;
    /** The output index of the asset within the job
        This index is an positive integer that starts at 0
        It is used to differentiate between multiple outputs of the same job
        If the job has only one output, this index is 0
        This is only applicable for generations with: Flux, Skybox, Reframe at the moment */
    outputIndex?: number;
    /** A list of CollectionId this asset belongs to */
    collectionIds: string[];
    /** List of edit capabilities for the asset */
    editCapabilities: (
      | "DETECTION"
      | "GENERATIVE_FILL"
      | "PIXELATE"
      | "PROMPT_EDITING"
      | "REFINE"
      | "REFRAME"
      | "REMOVE_BACKGROUND"
      | "SEGMENTATION"
      | "UPSCALE"
      | "UPSCALE_360"
      | "VECTORIZATION"
    )[];
    /** The embedding of the asset when requested and asset can be embedded
        
        ie: Detection maps don't have embeddings */
    embedding?: number[];
    /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
    id: string;
    /** The status of the asset */
    status: "error" | "pending" | "success";
    /** The asset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    updatedAt: string;
  };
};
export type UnlockAssetByAssetIdApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The ID of the canvas to unlock */
  assetId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** The value of the lock on this canvas. */
    lockId?: string;
    /** If true, no need to pass a lockId. */
    forceUnlock?: boolean;
  };
};
export type GetCollectionsApiResponse = /** status 200 200 response */ {
  /** A token to query the next page of collections */
  nextPaginationToken?: string;
  collections: {
    /** The collection creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt: string;
    /** The collection name */
    name: string;
    assetCount: number;
    /** The collection ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
    id: string;
    /** The owner ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
    ownerId: string;
    modelCount: number;
    itemCount: number;
    /** The collection last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    updatedAt: string;
  }[];
};
export type GetCollectionsApiArg = {
  /** The number of items to return in the response. The default value is 10, maximum value is 100, minimum value is 1 */
  pageSize?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  /** A token you received in a previous request to query the next page of items */
  paginationToken?: string;
};
export type PostCollectionApiResponse = /** status 200 200 response */ {
  collection: {
    /** The collection creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt: string;
    /** The collection name */
    name: string;
    assetCount: number;
    /** The collection ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
    id: string;
    /** The owner ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
    ownerId: string;
    modelCount: number;
    itemCount: number;
    /** The collection last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    updatedAt: string;
  };
};
export type PostCollectionApiArg = {
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** The name of the collection. */
    name: string;
  };
};
export type GetCollectionsByCollectionIdApiResponse =
  /** status 200 200 response */ {
    collection: {
      /** The collection creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** The collection name */
      name: string;
      assetCount: number;
      /** The collection ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
      id: string;
      /** The owner ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
      ownerId: string;
      modelCount: number;
      itemCount: number;
      /** The collection last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      updatedAt: string;
    };
  };
export type GetCollectionsByCollectionIdApiArg = {
  /** The collection ID to retrieve */
  collectionId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
};
export type PutCollectionsByCollectionIdApiResponse =
  /** status 200 200 response */ {
    collection: {
      /** The collection creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** The collection name */
      name: string;
      assetCount: number;
      /** The collection ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
      id: string;
      /** The owner ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
      ownerId: string;
      modelCount: number;
      itemCount: number;
      /** The collection last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      updatedAt: string;
    };
  };
export type PutCollectionsByCollectionIdApiArg = {
  /** The collectionId to update */
  collectionId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** The new name for the Collection */
    name: string;
  };
};
export type DeleteCollectionsByCollectionIdApiResponse =
  /** status 200 200 response */ any;
export type DeleteCollectionsByCollectionIdApiArg = {
  /** The collection ID to delete */
  collectionId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
};
export type PutAssetsByCollectionIdApiResponse =
  /** status 200 200 response */ {
    collection: {
      /** The collection creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** The collection name */
      name: string;
      assetCount: number;
      /** The collection ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
      id: string;
      /** The owner ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
      ownerId: string;
      modelCount: number;
      itemCount: number;
      /** The collection last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      updatedAt: string;
    };
  };
export type PutAssetsByCollectionIdApiArg = {
  /** The ID of the collection to add assets to */
  collectionId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** The ids of the assets to add to the collection. (Max 49 at once) */
    assetIds: string[];
  };
};
export type DeleteAssetsByCollectionIdApiResponse =
  /** status 200 200 response */ {
    collection: {
      /** The collection creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** The collection name */
      name: string;
      assetCount: number;
      /** The collection ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
      id: string;
      /** The owner ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
      ownerId: string;
      modelCount: number;
      itemCount: number;
      /** The collection last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      updatedAt: string;
    };
  };
export type DeleteAssetsByCollectionIdApiArg = {
  /** The ID of the collection to remove the assets from */
  collectionId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** The ids of the assets to remove from the collection. (Max 49 at once) */
    assetIds: string[];
  };
};
export type PutModelsByCollectionIdApiResponse =
  /** status 200 200 response */ {
    collection: {
      /** The collection creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** The collection name */
      name: string;
      assetCount: number;
      /** The collection ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
      id: string;
      /** The owner ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
      ownerId: string;
      modelCount: number;
      itemCount: number;
      /** The collection last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      updatedAt: string;
    };
  };
export type PutModelsByCollectionIdApiArg = {
  /** The ID of the collection to add models to */
  collectionId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** The ids of the models to add to the collection. (Max 49 at once) */
    modelIds: string[];
  };
};
export type DeleteModelsByCollectionIdApiResponse =
  /** status 200 200 response */ {
    collection: {
      /** The collection creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** The collection name */
      name: string;
      assetCount: number;
      /** The collection ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
      id: string;
      /** The owner ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
      ownerId: string;
      modelCount: number;
      itemCount: number;
      /** The collection last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      updatedAt: string;
    };
  };
export type DeleteModelsByCollectionIdApiArg = {
  /** The ID of the collection to remove the models from */
  collectionId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** The ids of the models to remove from the collection. (Max 49 at once) */
    modelIds: string[];
  };
};
export type PostCaptionInferencesApiResponse =
  /** status 200 200 response */
  | {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost?: number;
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
      /** The captions for each image. */
      captions: string[];
      /** The details level used to generate the captions. */
      detailsLevel?: "action" | "action+style";
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostCaptionInferencesApiArg = {
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** Whether we try to ensure IP removal for new prompt generation. */
    ensureIPCleared?: boolean;
    /** If specified, the API will make a best effort to produce the same results, such that repeated requests with the same `seed` and parameters should return the same outputs. Must be used along with the same parameters including prompt, model's state, etc.. */
    seed?: number;
    /** Optional list of words sequences that should not be present in the generated prompts. */
    unwantedSequences?: string[];
    /** The modelId used to condition the generation.
        
        When provided, the generation will take into account model's training images, examples. */
    modelId?: string;
    /** The sampling temperature to use. Higher values like `0.8` will make the output more random, while lower values like `0.2` will make it more focused and deterministic.
        
        We generally recommend altering this or `topP` but not both. */
    temperature?: number;
    /** The asset ids used to condition the generation.
        
        Notes: supersedes the `modelId` parameter when provided. */
    assetIds?: string[];
    /** An alternative to sampling with temperature, called nucleus sampling, where the model considers the results of the tokens with top_p probability mass. So `0.1` means only the tokens comprising the top `10%` probability mass are considered.
        
        We generally recommend altering this or `temperature` but not both. */
    topP?: number;
    /** The details level used to generate the captions. */
    detailsLevel?: "action" | "action+style";
  };
};
export type PostControlnetInferencesApiResponse =
  /** status 200 200 response */
  | {
      creativeUnitsCost?: number;
      inference: {
        /** Signed URL to display the input image */
        image: string;
        /** Specifies how long the ControlNet guidance should be applied during the inference process.
        
        Only available for Flux.1-dev based models.
        
        The value represents the percentage of total inference steps where the ControlNet guidance is active.
        For example:
        - 1.0: ControlNet guidance is applied during all inference steps
        - 0.5: ControlNet guidance is only applied during the first half of inference steps
        
        Default values:
        - 0.5 for Canny modality
        - 0.6 for all other modalities */
        controlEnd?: number;
        /** Asset id of the input image */
        imageId: string;
        /** The modality associated with the control image used for the generation: it can either be an object with a combination of maximum
        
        For models of SD1.5 family:
         - up to 3 modalities from `canny`, `pose`, `depth`, `lines`, `seg`, `scribble`, `lineart`, `normal-map`, `illusion`
         - or one of the following presets: `character`, `landscape`, `city`, `interior`.
        
        For models of the SDXL family:
         - up to 3 modalities from `canny`, `pose`, `depth`, `seg`, `illusion`, `scribble`
         - or one of the following presets: `character`, `landscape`.
        
        For models of the FLUX schnell or dev families:
        - one modality from: `canny`, `tile`, `depth`, `blur`, `pose`, `gray`, `low-quality`
        
        Optionally, you can associate a value to these modalities or presets. The value must be within `]0.0, 1.0]`.
        
        Examples:
        - `canny`
        - `depth:0.5,pose:1.0`
        - `canny:0.5,depth:0.5,lines:0.3`
        - `landscape`
        - `character:0.5`
        - `illusion:1`
        
        Note: if you use a value that is not supported by the model family, this will result in an error. */
        modality:
          | "blur"
          | "canny"
          | "depth"
          | "gray"
          | "illusion"
          | "lineart"
          | "lines"
          | "low-quality"
          | "normal-map"
          | "pose"
          | "scribble"
          | "seg"
          | "sketch"
          | "tile";
        /** Used to reproduce previous results. Default: randomly generated number. */
        seed?: string;
        /** If set, generated assets will be hidden and not returned in the list of images of the inference
        or when listing assets (default: false) */
        hideResults?: boolean;
        /** The type of inference to use. Example: txt2img, img2img, etc.
        
        Selecting the right type will condition the expected parameters.
        
        Note: if model.type is `sd-xl*` or `sd-1_5*`, when using the `"inpaint"` inference type, Scenario determines the best available `baseModel` for a given `modelId`: one of `["stable-diffusion-inpainting", "stable-diffusion-xl-1.0-inpainting-0.1"] will be used. */
        type:
          | "txt2img"
          | "txt2img_ip_adapter"
          | "txt2img_texture"
          | "img2img"
          | "img2img_ip_adapter"
          | "img2img_texture"
          | "inpaint"
          | "outpaint"
          | "inpaint_ip_adapter"
          | "controlnet"
          | "controlnet_ip_adapter"
          | "reference"
          | "reference_texture"
          | "controlnet_reference"
          | "controlnet_img2img"
          | "controlnet_inpaint"
          | "controlnet_inpaint_ip_adapter"
          | "controlnet_texture";
        /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
        negativePrompt?: string;
        /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
        scheduler?:
          | "DDIMScheduler"
          | "DDPMScheduler"
          | "DEISMultistepScheduler"
          | "DPMSolverMultistepScheduler"
          | "DPMSolverSinglestepScheduler"
          | "EulerAncestralDiscreteScheduler"
          | "EulerDiscreteScheduler"
          | "HeunDiscreteScheduler"
          | "KDPM2AncestralDiscreteScheduler"
          | "KDPM2DiscreteScheduler"
          | "LCMScheduler"
          | "LMSDiscreteScheduler"
          | "PNDMScheduler"
          | "TCDScheduler"
          | "UniPCMultistepScheduler";
        /** Enable or disable the intermediate images generation (default: false) */
        intermediateImages?: boolean;
        concepts?: {
          /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
          modelId: string;
          /** The scale of the model (example: 1.0) */
          scale: number;
        }[];
        /** If false, the process uses the given image to detect the modality.
        If true (default), the process will not try to detect the modality of the given image.
        
        For example:
        with `pose` modality and `false` value, the process will detect the pose of people in the given image
        with `depth` modality and `false` value, the process will detect the depth of the given image
        with `scribble` modality and `true`value, the process will use the given image as a scribble
        
        ⚠️ For models of the FLUX schnell or dev families, this parameter is ignored. The modality detection is always disabled. ⚠️ */
        disableModalityDetection?: boolean;
        /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
        guidance?: number;
        /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
        numInferenceSteps?: number;
        /** The number of images to generate (within [1, 128], default: 4) */
        numSamples?: number;
        /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
        If model.type is `sd-1_5`, the width must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        width?: number;
        /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
        Allowed values are available in the model's attribute: `compliantModelIds` */
        baseModelId?: string;
        /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
        prompt: string;
        /** Specifies the starting point of the ControlNet guidance during the inference process.
        
        Only available for Flux.1-dev based models.
        
        The value represents the percentage of total inference steps where the ControlNet guidance starts.
        For example:
        - 0.0: ControlNet guidance starts at the beginning of the inference steps
        - 0.5: ControlNet guidance starts at the middle of the inference steps */
        controlStart?: number;
        /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
        If model.type is `sd-1_5`, the height must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        height?: number;
      };
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostControlnetInferencesApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The controlnet input image as an AssetId. Will be ignored if the `controlnet` parameter is provided */
    controlImageId?: string;
    /** The input image as a data URL (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=") or the asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
    image?: string;
    /** Specifies how long the ControlNet guidance should be applied during the inference process.
        
        Only available for Flux.1-dev based models.
        
        The value represents the percentage of total inference steps where the ControlNet guidance is active.
        For example:
        - 1.0: ControlNet guidance is applied during all inference steps
        - 0.5: ControlNet guidance is only applied during the first half of inference steps
        
        Default values:
        - 0.5 for Canny modality
        - 0.6 for all other modalities */
    controlEnd?: number;
    /** Deprecated: The input image as an AssetId. Prefer to use image with the asset ID instead. */
    imageId?: string;
    /** The modality associated with the control image used for the generation: it can either be an object with a combination of maximum
        
        For models of SD1.5 family:
         - up to 3 modalities from `canny`, `pose`, `depth`, `lines`, `seg`, `scribble`, `lineart`, `normal-map`, `illusion`
         - or one of the following presets: `character`, `landscape`, `city`, `interior`.
        
        For models of the SDXL family:
         - up to 3 modalities from `canny`, `pose`, `depth`, `seg`, `illusion`, `scribble`
         - or one of the following presets: `character`, `landscape`.
        
        For models of the FLUX schnell or dev families:
        - one modality from: `canny`, `tile`, `depth`, `blur`, `pose`, `gray`, `low-quality`
        
        Optionally, you can associate a value to these modalities or presets. The value must be within `]0.0, 1.0]`.
        
        Examples:
        - `canny`
        - `depth:0.5,pose:1.0`
        - `canny:0.5,depth:0.5,lines:0.3`
        - `landscape`
        - `character:0.5`
        - `illusion:1`
        
        Note: if you use a value that is not supported by the model family, this will result in an error. */
    modality:
      | "blur"
      | "canny"
      | "depth"
      | "gray"
      | "illusion"
      | "lineart"
      | "lines"
      | "low-quality"
      | "normal-map"
      | "pose"
      | "scribble"
      | "seg"
      | "sketch"
      | "tile"
      | string;
    /** Used to reproduce previous results. Default: randomly generated number. */
    seed?: string;
    /** The model id to use for the inference */
    modelId: string;
    /** If set, generated assets will be hidden and not returned in the list of images of the inference
        or when listing assets (default: false) */
    hideResults?: boolean;
    /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
    negativePrompt?: string;
    /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
    scheduler?:
      | "DDIMScheduler"
      | "DDPMScheduler"
      | "DEISMultistepScheduler"
      | "DPMSolverMultistepScheduler"
      | "DPMSolverSinglestepScheduler"
      | "EulerAncestralDiscreteScheduler"
      | "EulerDiscreteScheduler"
      | "HeunDiscreteScheduler"
      | "KDPM2AncestralDiscreteScheduler"
      | "KDPM2DiscreteScheduler"
      | "LCMScheduler"
      | "LMSDiscreteScheduler"
      | "PNDMScheduler"
      | "TCDScheduler"
      | "UniPCMultistepScheduler";
    /** Enable or disable the intermediate images generation (default: false) */
    intermediateImages?: boolean;
    concepts?: {
      /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
      modelId: string;
      /** The scale of the model (example: 1.0) */
      scale: number;
    }[];
    /** The controlnet input image as a data URL (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=") */
    controlImage?: string;
    /** If false, the process uses the given image to detect the modality.
        If true (default), the process will not try to detect the modality of the given image.
        
        For example:
        with `pose` modality and `false` value, the process will detect the pose of people in the given image
        with `depth` modality and `false` value, the process will detect the depth of the given image
        with `scribble` modality and `true`value, the process will use the given image as a scribble
        
        ⚠️ For models of the FLUX schnell or dev families, this parameter is ignored. The modality detection is always disabled. ⚠️ */
    disableModalityDetection?: boolean;
    /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
    guidance?: number;
    /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
    numInferenceSteps?: number;
    /** The number of images to generate (within [1, 128], default: 4) */
    numSamples?: number;
    /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
        If model.type is `sd-1_5`, the width must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
    width?: number;
    /** Specifies the parent asset Id for the image when provided as a dataurl. */
    imageParentId?: string;
    /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
        Allowed values are available in the model's attribute: `compliantModelIds` */
    baseModelId?: string;
    /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
    prompt: string;
    /** Specifies the starting point of the ControlNet guidance during the inference process.
        
        Only available for Flux.1-dev based models.
        
        The value represents the percentage of total inference steps where the ControlNet guidance starts.
        For example:
        - 0.0: ControlNet guidance starts at the beginning of the inference steps
        - 0.5: ControlNet guidance starts at the middle of the inference steps */
    controlStart?: number;
    /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
        If model.type is `sd-1_5`, the height must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
    height?: number;
    /** Toggles the hidden status of the image when provided as a dataurl. */
    imageHide?: boolean;
  };
};
export type PostControlnetImg2ImgInferencesApiResponse =
  /** status 200 200 response */
  | {
      creativeUnitsCost?: number;
      inference: {
        /** Asset id of the controlnet input image */
        controlImageId: string;
        /** Signed URL to display the input image */
        image: string;
        /** Specifies how long the ControlNet guidance should be applied during the inference process.
        
        Only available for Flux.1-dev based models.
        
        The value represents the percentage of total inference steps where the ControlNet guidance is active.
        For example:
        - 1.0: ControlNet guidance is applied during all inference steps
        - 0.5: ControlNet guidance is only applied during the first half of inference steps
        
        Default values:
        - 0.5 for Canny modality
        - 0.6 for all other modalities */
        controlEnd?: number;
        /** Asset id of the input image */
        imageId: string;
        /** The modality associated with the control image used for the generation: it can either be an object with a combination of maximum
        
        For models of SD1.5 family:
         - up to 3 modalities from `canny`, `pose`, `depth`, `lines`, `seg`, `scribble`, `lineart`, `normal-map`, `illusion`
         - or one of the following presets: `character`, `landscape`, `city`, `interior`.
        
        For models of the SDXL family:
         - up to 3 modalities from `canny`, `pose`, `depth`, `seg`, `illusion`, `scribble`
         - or one of the following presets: `character`, `landscape`.
        
        For models of the FLUX schnell or dev families:
        - one modality from: `canny`, `tile`, `depth`, `blur`, `pose`, `gray`, `low-quality`
        
        Optionally, you can associate a value to these modalities or presets. The value must be within `]0.0, 1.0]`.
        
        Examples:
        - `canny`
        - `depth:0.5,pose:1.0`
        - `canny:0.5,depth:0.5,lines:0.3`
        - `landscape`
        - `character:0.5`
        - `illusion:1`
        
        Note: if you use a value that is not supported by the model family, this will result in an error. */
        modality:
          | "blur"
          | "canny"
          | "depth"
          | "gray"
          | "illusion"
          | "lineart"
          | "lines"
          | "low-quality"
          | "normal-map"
          | "pose"
          | "scribble"
          | "seg"
          | "sketch"
          | "tile";
        /** Used to reproduce previous results. Default: randomly generated number. */
        seed?: string;
        /** Controls the noise intensity introduced to the input image, where a value of 1.0 completely erases the original image's details. Available for img2img and inpainting. (within [0.01, 1.0], default: 0.75) */
        strength?: number;
        /** If set, generated assets will be hidden and not returned in the list of images of the inference
        or when listing assets (default: false) */
        hideResults?: boolean;
        /** The type of inference to use. Example: txt2img, img2img, etc.
        
        Selecting the right type will condition the expected parameters.
        
        Note: if model.type is `sd-xl*` or `sd-1_5*`, when using the `"inpaint"` inference type, Scenario determines the best available `baseModel` for a given `modelId`: one of `["stable-diffusion-inpainting", "stable-diffusion-xl-1.0-inpainting-0.1"] will be used. */
        type:
          | "txt2img"
          | "txt2img_ip_adapter"
          | "txt2img_texture"
          | "img2img"
          | "img2img_ip_adapter"
          | "img2img_texture"
          | "inpaint"
          | "outpaint"
          | "inpaint_ip_adapter"
          | "controlnet"
          | "controlnet_ip_adapter"
          | "reference"
          | "reference_texture"
          | "controlnet_reference"
          | "controlnet_img2img"
          | "controlnet_inpaint"
          | "controlnet_inpaint_ip_adapter"
          | "controlnet_texture";
        /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
        negativePrompt?: string;
        /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
        scheduler?:
          | "DDIMScheduler"
          | "DDPMScheduler"
          | "DEISMultistepScheduler"
          | "DPMSolverMultistepScheduler"
          | "DPMSolverSinglestepScheduler"
          | "EulerAncestralDiscreteScheduler"
          | "EulerDiscreteScheduler"
          | "HeunDiscreteScheduler"
          | "KDPM2AncestralDiscreteScheduler"
          | "KDPM2DiscreteScheduler"
          | "LCMScheduler"
          | "LMSDiscreteScheduler"
          | "PNDMScheduler"
          | "TCDScheduler"
          | "UniPCMultistepScheduler";
        /** Enable or disable the intermediate images generation (default: false) */
        intermediateImages?: boolean;
        concepts?: {
          /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
          modelId: string;
          /** The scale of the model (example: 1.0) */
          scale: number;
        }[];
        /** Signed URL to display the controlnet input image */
        controlImage: string;
        /** If false, the process uses the given image to detect the modality.
        If true (default), the process will not try to detect the modality of the given image.
        
        For example:
        with `pose` modality and `false` value, the process will detect the pose of people in the given image
        with `depth` modality and `false` value, the process will detect the depth of the given image
        with `scribble` modality and `true`value, the process will use the given image as a scribble
        
        ⚠️ For models of the FLUX schnell or dev families, this parameter is ignored. The modality detection is always disabled. ⚠️ */
        disableModalityDetection?: boolean;
        /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
        guidance?: number;
        /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
        numInferenceSteps?: number;
        /** The number of images to generate (within [1, 128], default: 4) */
        numSamples?: number;
        /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
        If model.type is `sd-1_5`, the width must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        width?: number;
        /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
        Allowed values are available in the model's attribute: `compliantModelIds` */
        baseModelId?: string;
        /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
        prompt: string;
        /** Specifies the starting point of the ControlNet guidance during the inference process.
        
        Only available for Flux.1-dev based models.
        
        The value represents the percentage of total inference steps where the ControlNet guidance starts.
        For example:
        - 0.0: ControlNet guidance starts at the beginning of the inference steps
        - 0.5: ControlNet guidance starts at the middle of the inference steps */
        controlStart?: number;
        /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
        If model.type is `sd-1_5`, the height must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        height?: number;
      };
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostControlnetImg2ImgInferencesApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** Specifies how long the ControlNet guidance should be applied during the inference process.
        
        Only available for Flux.1-dev based models.
        
        The value represents the percentage of total inference steps where the ControlNet guidance is active.
        For example:
        - 1.0: ControlNet guidance is applied during all inference steps
        - 0.5: ControlNet guidance is only applied during the first half of inference steps
        
        Default values:
        - 0.5 for Canny modality
        - 0.6 for all other modalities */
    controlEnd?: number;
    /** The modality associated with the control image used for the generation: it can either be an object with a combination of maximum
        
        For models of SD1.5 family:
         - up to 3 modalities from `canny`, `pose`, `depth`, `lines`, `seg`, `scribble`, `lineart`, `normal-map`, `illusion`
         - or one of the following presets: `character`, `landscape`, `city`, `interior`.
        
        For models of the SDXL family:
         - up to 3 modalities from `canny`, `pose`, `depth`, `seg`, `illusion`, `scribble`
         - or one of the following presets: `character`, `landscape`.
        
        For models of the FLUX schnell or dev families:
        - one modality from: `canny`, `tile`, `depth`, `blur`, `pose`, `gray`, `low-quality`
        
        Optionally, you can associate a value to these modalities or presets. The value must be within `]0.0, 1.0]`.
        
        Examples:
        - `canny`
        - `depth:0.5,pose:1.0`
        - `canny:0.5,depth:0.5,lines:0.3`
        - `landscape`
        - `character:0.5`
        - `illusion:1`
        
        Note: if you use a value that is not supported by the model family, this will result in an error. */
    modality:
      | "blur"
      | "canny"
      | "depth"
      | "gray"
      | "illusion"
      | "lineart"
      | "lines"
      | "low-quality"
      | "normal-map"
      | "pose"
      | "scribble"
      | "seg"
      | "sketch"
      | "tile"
      | string;
    /** Used to reproduce previous results. Default: randomly generated number. */
    seed?: string;
    /** Controls the noise intensity introduced to the input image, where a value of 1.0 completely erases the original image's details. Available for img2img and inpainting. (within [0.01, 1.0], default: 0.75) */
    strength?: number;
    /** The model id to use for the inference */
    modelId: string;
    /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
    scheduler?:
      | "DDIMScheduler"
      | "DDPMScheduler"
      | "DEISMultistepScheduler"
      | "DPMSolverMultistepScheduler"
      | "DPMSolverSinglestepScheduler"
      | "EulerAncestralDiscreteScheduler"
      | "EulerDiscreteScheduler"
      | "HeunDiscreteScheduler"
      | "KDPM2AncestralDiscreteScheduler"
      | "KDPM2DiscreteScheduler"
      | "LCMScheduler"
      | "LMSDiscreteScheduler"
      | "PNDMScheduler"
      | "TCDScheduler"
      | "UniPCMultistepScheduler";
    /** If false, the process uses the given image to detect the modality.
        If true (default), the process will not try to detect the modality of the given image.
        
        For example:
        with `pose` modality and `false` value, the process will detect the pose of people in the given image
        with `depth` modality and `false` value, the process will detect the depth of the given image
        with `scribble` modality and `true`value, the process will use the given image as a scribble
        
        ⚠️ For models of the FLUX schnell or dev families, this parameter is ignored. The modality detection is always disabled. ⚠️ */
    disableModalityDetection?: boolean;
    /** Specifies the parent asset Id for the image when provided as a dataurl. */
    imageParentId?: string;
    /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
        Allowed values are available in the model's attribute: `compliantModelIds` */
    baseModelId?: string;
    /** Specifies the starting point of the ControlNet guidance during the inference process.
        
        Only available for Flux.1-dev based models.
        
        The value represents the percentage of total inference steps where the ControlNet guidance starts.
        For example:
        - 0.0: ControlNet guidance starts at the beginning of the inference steps
        - 0.5: ControlNet guidance starts at the middle of the inference steps */
    controlStart?: number;
    /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
        If model.type is `sd-1_5`, the height must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
    height?: number;
    /** Toggles the hidden status of the image when provided as a dataurl. */
    imageHide?: boolean;
    /** The controlnet input image as an AssetId. Will be ignored if the `controlnet` parameter is provided */
    controlImageId?: string;
    /** The input image as a data URL (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=") or the asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
    image?: string;
    /** Deprecated: The input image as an AssetId. Prefer to use image with the asset ID instead. */
    imageId?: string;
    /** If set, generated assets will be hidden and not returned in the list of images of the inference
        or when listing assets (default: false) */
    hideResults?: boolean;
    /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
    negativePrompt?: string;
    /** Enable or disable the intermediate images generation (default: false) */
    intermediateImages?: boolean;
    concepts?: {
      /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
      modelId: string;
      /** The scale of the model (example: 1.0) */
      scale: number;
    }[];
    /** The controlnet input image as a data URL (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=") */
    controlImage?: string;
    /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
    guidance?: number;
    /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
    numInferenceSteps?: number;
    /** The number of images to generate (within [1, 128], default: 4) */
    numSamples?: number;
    /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
        If model.type is `sd-1_5`, the width must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
    width?: number;
    /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
    prompt: string;
  };
};
export type PostControlnetInpaintInferencesApiResponse =
  /** status 200 200 response */
  | {
      creativeUnitsCost?: number;
      inference: {
        /** Specifies how long the ControlNet guidance should be applied during the inference process.
        
        Only available for Flux.1-dev based models.
        
        The value represents the percentage of total inference steps where the ControlNet guidance is active.
        For example:
        - 1.0: ControlNet guidance is applied during all inference steps
        - 0.5: ControlNet guidance is only applied during the first half of inference steps
        
        Default values:
        - 0.5 for Canny modality
        - 0.6 for all other modalities */
        controlEnd?: number;
        /** The modality associated with the control image used for the generation: it can either be an object with a combination of maximum
        
        For models of SD1.5 family:
         - up to 3 modalities from `canny`, `pose`, `depth`, `lines`, `seg`, `scribble`, `lineart`, `normal-map`, `illusion`
         - or one of the following presets: `character`, `landscape`, `city`, `interior`.
        
        For models of the SDXL family:
         - up to 3 modalities from `canny`, `pose`, `depth`, `seg`, `illusion`, `scribble`
         - or one of the following presets: `character`, `landscape`.
        
        For models of the FLUX schnell or dev families:
        - one modality from: `canny`, `tile`, `depth`, `blur`, `pose`, `gray`, `low-quality`
        
        Optionally, you can associate a value to these modalities or presets. The value must be within `]0.0, 1.0]`.
        
        Examples:
        - `canny`
        - `depth:0.5,pose:1.0`
        - `canny:0.5,depth:0.5,lines:0.3`
        - `landscape`
        - `character:0.5`
        - `illusion:1`
        
        Note: if you use a value that is not supported by the model family, this will result in an error. */
        modality:
          | "blur"
          | "canny"
          | "depth"
          | "gray"
          | "illusion"
          | "lineart"
          | "lines"
          | "low-quality"
          | "normal-map"
          | "pose"
          | "scribble"
          | "seg"
          | "sketch"
          | "tile";
        /** Used to reproduce previous results. Default: randomly generated number. */
        seed?: string;
        /** Controls the noise intensity introduced to the input image, where a value of 1.0 completely erases the original image's details. Available for img2img and inpainting. (within [0.01, 1.0], default: 0.75) */
        strength?: number;
        /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
        scheduler?:
          | "DDIMScheduler"
          | "DDPMScheduler"
          | "DEISMultistepScheduler"
          | "DPMSolverMultistepScheduler"
          | "DPMSolverSinglestepScheduler"
          | "EulerAncestralDiscreteScheduler"
          | "EulerDiscreteScheduler"
          | "HeunDiscreteScheduler"
          | "KDPM2AncestralDiscreteScheduler"
          | "KDPM2DiscreteScheduler"
          | "LCMScheduler"
          | "LMSDiscreteScheduler"
          | "PNDMScheduler"
          | "TCDScheduler"
          | "UniPCMultistepScheduler";
        /** If set to true, the entire input image will likely change during inpainting. This results in faster inferences, but the output image will be harder to integrate if the input is just a small part of a larger image. */
        disableMerging?: boolean;
        /** If false, the process uses the given image to detect the modality.
        If true (default), the process will not try to detect the modality of the given image.
        
        For example:
        with `pose` modality and `false` value, the process will detect the pose of people in the given image
        with `depth` modality and `false` value, the process will detect the depth of the given image
        with `scribble` modality and `true`value, the process will use the given image as a scribble
        
        ⚠️ For models of the FLUX schnell or dev families, this parameter is ignored. The modality detection is always disabled. ⚠️ */
        disableModalityDetection?: boolean;
        /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
        Allowed values are available in the model's attribute: `compliantModelIds` */
        baseModelId?: string;
        /** Specifies the starting point of the ControlNet guidance during the inference process.
        
        Only available for Flux.1-dev based models.
        
        The value represents the percentage of total inference steps where the ControlNet guidance starts.
        For example:
        - 0.0: ControlNet guidance starts at the beginning of the inference steps
        - 0.5: ControlNet guidance starts at the middle of the inference steps */
        controlStart?: number;
        /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
        If model.type is `sd-1_5`, the height must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        height?: number;
        /** Signed URL to display the mask image */
        mask: string;
        /** Asset id of the controlnet input image */
        controlImageId: string;
        /** Signed URL to display the input image */
        image: string;
        /** Asset id of the input image */
        imageId: string;
        /** If set, generated assets will be hidden and not returned in the list of images of the inference
        or when listing assets (default: false) */
        hideResults?: boolean;
        /** Asset id of the mask image */
        maskId: string;
        /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
        negativePrompt?: string;
        /** Enable or disable the intermediate images generation (default: false) */
        intermediateImages?: boolean;
        concepts?: {
          /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
          modelId: string;
          /** The scale of the model (example: 1.0) */
          scale: number;
        }[];
        /** Signed URL to display the controlnet input image */
        controlImage: string;
        /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
        guidance?: number;
        /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
        numInferenceSteps?: number;
        /** The number of images to generate (within [1, 128], default: 4) */
        numSamples?: number;
        /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
        If model.type is `sd-1_5`, the width must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        width?: number;
        /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
        prompt: string;
      };
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostControlnetInpaintInferencesApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** Specifies how long the ControlNet guidance should be applied during the inference process.
        
        Only available for Flux.1-dev based models.
        
        The value represents the percentage of total inference steps where the ControlNet guidance is active.
        For example:
        - 1.0: ControlNet guidance is applied during all inference steps
        - 0.5: ControlNet guidance is only applied during the first half of inference steps
        
        Default values:
        - 0.5 for Canny modality
        - 0.6 for all other modalities */
    controlEnd?: number;
    /** The modality associated with the control image used for the generation: it can either be an object with a combination of maximum
        
        For models of SD1.5 family:
         - up to 3 modalities from `canny`, `pose`, `depth`, `lines`, `seg`, `scribble`, `lineart`, `normal-map`, `illusion`
         - or one of the following presets: `character`, `landscape`, `city`, `interior`.
        
        For models of the SDXL family:
         - up to 3 modalities from `canny`, `pose`, `depth`, `seg`, `illusion`, `scribble`
         - or one of the following presets: `character`, `landscape`.
        
        For models of the FLUX schnell or dev families:
        - one modality from: `canny`, `tile`, `depth`, `blur`, `pose`, `gray`, `low-quality`
        
        Optionally, you can associate a value to these modalities or presets. The value must be within `]0.0, 1.0]`.
        
        Examples:
        - `canny`
        - `depth:0.5,pose:1.0`
        - `canny:0.5,depth:0.5,lines:0.3`
        - `landscape`
        - `character:0.5`
        - `illusion:1`
        
        Note: if you use a value that is not supported by the model family, this will result in an error. */
    modality:
      | "blur"
      | "canny"
      | "depth"
      | "gray"
      | "illusion"
      | "lineart"
      | "lines"
      | "low-quality"
      | "normal-map"
      | "pose"
      | "scribble"
      | "seg"
      | "sketch"
      | "tile"
      | string;
    /** Used to reproduce previous results. Default: randomly generated number. */
    seed?: string;
    /** Controls the noise intensity introduced to the input image, where a value of 1.0 completely erases the original image's details. Available for img2img and inpainting. (within [0.01, 1.0], default: 0.75) */
    strength?: number;
    /** The model id to use for the inference */
    modelId: string;
    /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
    scheduler?:
      | "DDIMScheduler"
      | "DDPMScheduler"
      | "DEISMultistepScheduler"
      | "DPMSolverMultistepScheduler"
      | "DPMSolverSinglestepScheduler"
      | "EulerAncestralDiscreteScheduler"
      | "EulerDiscreteScheduler"
      | "HeunDiscreteScheduler"
      | "KDPM2AncestralDiscreteScheduler"
      | "KDPM2DiscreteScheduler"
      | "LCMScheduler"
      | "LMSDiscreteScheduler"
      | "PNDMScheduler"
      | "TCDScheduler"
      | "UniPCMultistepScheduler";
    /** If set to true, the entire input image will likely change during inpainting. This results in faster inferences, but the output image will be harder to integrate if the input is just a small part of a larger image. */
    disableMerging?: boolean;
    /** If false, the process uses the given image to detect the modality.
        If true (default), the process will not try to detect the modality of the given image.
        
        For example:
        with `pose` modality and `false` value, the process will detect the pose of people in the given image
        with `depth` modality and `false` value, the process will detect the depth of the given image
        with `scribble` modality and `true`value, the process will use the given image as a scribble
        
        ⚠️ For models of the FLUX schnell or dev families, this parameter is ignored. The modality detection is always disabled. ⚠️ */
    disableModalityDetection?: boolean;
    /** Specifies the parent asset Id for the image when provided as a dataurl. */
    imageParentId?: string;
    /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
        Allowed values are available in the model's attribute: `compliantModelIds` */
    baseModelId?: string;
    /** Specifies the starting point of the ControlNet guidance during the inference process.
        
        Only available for Flux.1-dev based models.
        
        The value represents the percentage of total inference steps where the ControlNet guidance starts.
        For example:
        - 0.0: ControlNet guidance starts at the beginning of the inference steps
        - 0.5: ControlNet guidance starts at the middle of the inference steps */
    controlStart?: number;
    /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
        If model.type is `sd-1_5`, the height must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
    height?: number;
    /** Toggles the hidden status of the image when provided as a dataurl. */
    imageHide?: boolean;
    /** The mask as a data URL, used to determine the area of change. The mask is a binary mask made out of white and black pixels. The white area is the one that will be replaced. (example: "data:image/png;base64,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") */
    mask?: string;
    /** The controlnet input image as an AssetId. Will be ignored if the `controlnet` parameter is provided */
    controlImageId?: string;
    /** The input image as a data URL (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=") or the asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
    image?: string;
    /** Deprecated: The input image as an AssetId. Prefer to use image with the asset ID instead. */
    imageId?: string;
    /** If set, generated assets will be hidden and not returned in the list of images of the inference
        or when listing assets (default: false) */
    hideResults?: boolean;
    /** The mask as an AssetId. Will be ignored if the `image` parameter is provided */
    maskId?: string;
    /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
    negativePrompt?: string;
    /** Enable or disable the intermediate images generation (default: false) */
    intermediateImages?: boolean;
    concepts?: {
      /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
      modelId: string;
      /** The scale of the model (example: 1.0) */
      scale: number;
    }[];
    /** The controlnet input image as a data URL (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=") */
    controlImage?: string;
    /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
    guidance?: number;
    /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
    numInferenceSteps?: number;
    /** The number of images to generate (within [1, 128], default: 4) */
    numSamples?: number;
    /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
        If model.type is `sd-1_5`, the width must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
    width?: number;
    /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
    prompt: string;
  };
};
export type PostControlnetInpaintIpAdapterInferencesApiResponse =
  /** status 200 200 response */
  | {
      creativeUnitsCost?: number;
      inference: {
        /** Asset id of the input IpAdapter images */
        ipAdapterImageIds?: string[];
        /** Used to reproduce previous results. Default: randomly generated number. */
        seed?: string;
        /** Controls the noise intensity introduced to the input image, where a value of 1.0 completely erases the original image's details. Available for img2img and inpainting. (within [0.01, 1.0], default: 0.75) */
        strength?: number;
        /** The type of IP Adapter model to use. Must be one of [`style`, `character`], default to `style`` */
        ipAdapterType?: "character" | "style";
        /** Signed URL to display the IpAdapter image */
        ipAdapterImage?: string;
        /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
        scheduler?:
          | "DDIMScheduler"
          | "DDPMScheduler"
          | "DEISMultistepScheduler"
          | "DPMSolverMultistepScheduler"
          | "DPMSolverSinglestepScheduler"
          | "EulerAncestralDiscreteScheduler"
          | "EulerDiscreteScheduler"
          | "HeunDiscreteScheduler"
          | "KDPM2AncestralDiscreteScheduler"
          | "KDPM2DiscreteScheduler"
          | "LCMScheduler"
          | "LMSDiscreteScheduler"
          | "PNDMScheduler"
          | "TCDScheduler"
          | "UniPCMultistepScheduler";
        /** If set to true, the entire input image will likely change during inpainting. This results in faster inferences, but the output image will be harder to integrate if the input is just a small part of a larger image. */
        disableMerging?: boolean;
        /** Signed URL to display the IpAdapter images */
        ipAdapterImages?: string[];
        /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
        Allowed values are available in the model's attribute: `compliantModelIds` */
        baseModelId?: string;
        /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
        If model.type is `sd-1_5`, the height must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        height?: number;
        /** Signed URL to display the mask image */
        mask: string;
        /** Asset id of the controlnet input image */
        controlImageId: string;
        /** Signed URL to display the input image */
        image: string;
        /** Asset id of the input image */
        imageId: string;
        /** Asset id of the input IpAdapter image */
        ipAdapterImageId?: string;
        /** IpAdapter scale factor (within [0.0, 1.0], default: 0.9). */
        ipAdapterScale?: number;
        /** If set, generated assets will be hidden and not returned in the list of images of the inference
        or when listing assets (default: false) */
        hideResults?: boolean;
        /** IpAdapter scale factors (within [0.0, 1.0], default: 0.9). */
        ipAdapterScales?: number[];
        /** Asset id of the mask image */
        maskId: string;
        /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
        negativePrompt?: string;
        /** Enable or disable the intermediate images generation (default: false) */
        intermediateImages?: boolean;
        concepts?: {
          /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
          modelId: string;
          /** The scale of the model (example: 1.0) */
          scale: number;
        }[];
        /** Signed URL to display the controlnet input image */
        controlImage: string;
        /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
        guidance?: number;
        /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
        numInferenceSteps?: number;
        /** The number of images to generate (within [1, 128], default: 4) */
        numSamples?: number;
        /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
        If model.type is `sd-1_5`, the width must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        width?: number;
        /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
        prompt: string;
      };
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostControlnetInpaintIpAdapterInferencesApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The IpAdapter images as an AssetId. Will be ignored if the `ipAdapterImages` parameter is provided */
    ipAdapterImageIds?: string[];
    /** Used to reproduce previous results. Default: randomly generated number. */
    seed?: string;
    /** Controls the noise intensity introduced to the input image, where a value of 1.0 completely erases the original image's details. Available for img2img and inpainting. (within [0.01, 1.0], default: 0.75) */
    strength?: number;
    /** The model id to use for the inference */
    modelId: string;
    /** The type of IP Adapter model to use. Must be one of [`style`, `character`], default to `style`` */
    ipAdapterType?: "character" | "style";
    /** Deprecated for type txt2img-ip-adapter and img2img-ip-adapter, use `ipAdapterImages` instead.
        The IpAdapter image as a data url. Will be ignored if the `ipAdapterImages` parameter is provided. */
    ipAdapterImage?: string;
    /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
    scheduler?:
      | "DDIMScheduler"
      | "DDPMScheduler"
      | "DEISMultistepScheduler"
      | "DPMSolverMultistepScheduler"
      | "DPMSolverSinglestepScheduler"
      | "EulerAncestralDiscreteScheduler"
      | "EulerDiscreteScheduler"
      | "HeunDiscreteScheduler"
      | "KDPM2AncestralDiscreteScheduler"
      | "KDPM2DiscreteScheduler"
      | "LCMScheduler"
      | "LMSDiscreteScheduler"
      | "PNDMScheduler"
      | "TCDScheduler"
      | "UniPCMultistepScheduler";
    /** If set to true, the entire input image will likely change during inpainting. This results in faster inferences, but the output image will be harder to integrate if the input is just a small part of a larger image. */
    disableMerging?: boolean;
    /** The IpAdapter images as a data url. */
    ipAdapterImages?: string[];
    /** Specifies the parent asset Id for the image when provided as a dataurl. */
    imageParentId?: string;
    /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
        Allowed values are available in the model's attribute: `compliantModelIds` */
    baseModelId?: string;
    /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
        If model.type is `sd-1_5`, the height must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
    height?: number;
    /** Toggles the hidden status of the image when provided as a dataurl. */
    imageHide?: boolean;
    /** The mask as a data URL, used to determine the area of change. The mask is a binary mask made out of white and black pixels. The white area is the one that will be replaced. (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAMAAADDpiTIAAABiVBMVEUAAADw8PDCwsLExMT5+fn19fX8/Pz////+/v79/f2hoaH6+vrc3NxnZ2dDQ0P4+PhkZGTs7OzOzs6Ojo709PRiYmLd3d1paWkoKCji4uI9PT3n5+fe3t7z8/NISEiysrLg4ODk5OSYmJh/f3/u7u5lZWVRUVHS0tKIiIg+Pj7p6emXl5dUVFQYGBjKysqtra1TU1PT09M8PDwcHBzR0dHq6uoEBAQmJiZ8fHzm5ub7+/swMDCrq6uKioqpqalHR0c3NzdOTk6BgYF7e3uwsLCAgIB3d3empqaNjY06OjrW1tZhYWG0tLQgICBxcXEICAhPT0/o6OgkJCRzc3N5eXnV1dXj4+NKSkobGxtaWlpfX1/a2trBwcF2dnYlJSV9fX3Hx8eSkpJNTU1sbGyWlpYRERGCgoIMDAzPz8+MjIy4uLiTk5PNzc3X19cxMTGDg4MpKSm8vLxGRkavr69QUFAKCgoqKiq2trbt7e329vaGhobl5eVra2tZWVk4ODgzMzNcXFyurq63t7dzhmTOAAAFeElEQVR4nO3dZXMUaRQF4EBIOgkQdFncFhZfZPF1d3d3d3f95TthC6iQTE9kuk+Y93m+MpW6t8+p7mGkZ2gIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACK8MDyR784eTw9BRkj1RU70rPQuvFqmjXpeWjVPdUMn6VnokUz86+qjemhaM3obAWoqvRYtGX2/DWgFA93K8DK9GS0Yku3AlTr06PRht+6FqB6Mj0bLVjfvQCeBpRgb00BRtLD0YKaAjgFlKCuAF4ULsAKp4CyHakrgLcGC1BXAKeAAihA4cbqCnAyPR2N211XgNH0dDRup2tA4RSgcLUFOJaejsbVFuC59HQ0bltdAW5KT0fjVtcV4GB6OppXV4C30sPRvLoCHE0PR/PqCvBEejiaV1eA9Gy0QAEKV5P/WHo2WlBTgHXp2WhBTQFuSM9GCzwFKNv3ngKU7WL3ApxOz0YLXAHKNqwAZavJf0V6NlpQU4Bd6dloXpd7BLkClKImfwUogO+Glu3VuvwVYPDV5q8AA2+lAhTtVH3+CjDoeuRf3ZgekEYt61WAi+kJaVLt98JdAwbe/b3z14ABdn4u+VfVY+k5acbNc8u/qjalJ6UJd881/47t6WHpu2PzyL/yCzID56755T/llvTM9M8H88+/Y5+XhQbE2QXlP2XVg5/cfnrPmvHLtxYcG3nhu+dXp/dhfmpvCLIw4+mdmLtn+59/xzPptZirRvL3AeLrRkP5uwxcJxrL3y8MLSVP/XHr7P/QYP5VtbbdJelm/7RYduza+ebXmzdfakSj+XvrcIn4tOGYu9uQXp2O92P5u5vAUjDnt3mbkF6exi/z9X5Mb89r0QLcl16faP7uLR9X+1XP5qXXJ5u/AqT1/KZHs35J71+8bP5OAGl7svn/nd6/eNn8t6TXJ5r/4fT27Evm/1N6e6InALeVXwKC+b+c3p2h8FOA29Lbc2+0ANXe9P7FO5MtQPVN+gCULpx/VQ2nj0Dh0vl7KTgsHb/vhoSl46+cArLS6XcsTx+Dkv2QTr/jxfRBKNnT6fQ7VqUPQsneS6dfuZ9Y1IZ0+h3b0gehZHU//9eWC+mDULLwB0Iv8b+AoLHe+TQufQyKlg6/8kpgVjr9ygkgK51+Vd2ZPgRlS8dffZ4+AoVL5+9u0mHh/Hem9y9eMv0xNxLPG0k2IL08Q0PLkwXwCkBe9s2gX9PrcyJaABeBvGwBjqfXJ1sAp4A4BShc+BZxbhaf9ki2AI+n9ydbgNfT65MtwD/p9fk5WoAP0+uTPQVsTm9PtgDp5cm+H3QmvTxD0VNAenWmrIvlfzC9OpeE4h87ml6c/2XuF74svTZXBOIfOZVemqv29w6sv/79KL0y00y0m/+59L5ca0u7DUivywyrekQ2+vGhPj5VWJdelxkOdAtrbNvE5ceM960ByU2Z3UMzY1q56cj0x1xQgEG26WpA4wfWfjnrY/p0SxG/FbI0vTP1EcHDq7fWPOTtvhTgfGsr0Xf9uLHUV+klWIQ/F38deCO9A4uz2E+TH0ovwGIt7ovl6enpg4nRBefvi+EDYniBLw29lB6cvhlewNMBN4gfMOcmT9yxfe4XhInef5Hr0dmtk5NbJ799Ze36uvg3/pWek+btXdkl/jW/p0ejLbuufXYwtvvd9EwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPfwHLuRXafg0SKQAAAAASUVORK5CYII=") */
    mask?: string;
    /** The controlnet input image as an AssetId. Will be ignored if the `controlnet` parameter is provided */
    controlImageId?: string;
    /** The input image as a data URL (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=") or the asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
    image?: string;
    /** Deprecated: The input image as an AssetId. Prefer to use image with the asset ID instead. */
    imageId?: string;
    /** Deprecated for type txt2img-ip-adapter and img2img-ip-adapter, use `ipAdapterImageIds` instead.
        The IpAdapter image as an AssetId. Cannot be set if `ipAdapterImage` is provided. Will be ignored if the `ipAdapterImageIds` parameter is provided. */
    ipAdapterImageId?: string;
    /** Deprecated for type txt2img-ip-adapter and img2img-ip-adapter, use `ipAdapterScales` instead.
        IpAdapter scale factor (within [0.0, 1.0], default: 0.9). Will be ignored if the `ipAdapterScales` parameter is provided */
    ipAdapterScale?: number;
    /** If set, generated assets will be hidden and not returned in the list of images of the inference
        or when listing assets (default: false) */
    hideResults?: boolean;
    /** IpAdapter scale factors (within [0.0, 1.0], default: 0.9). */
    ipAdapterScales?: number[];
    /** The mask as an AssetId. Will be ignored if the `image` parameter is provided */
    maskId?: string;
    /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
    negativePrompt?: string;
    /** Enable or disable the intermediate images generation (default: false) */
    intermediateImages?: boolean;
    concepts?: {
      /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
      modelId: string;
      /** The scale of the model (example: 1.0) */
      scale: number;
    }[];
    /** The controlnet input image as a data URL (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=") */
    controlImage?: string;
    /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
    guidance?: number;
    /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
    numInferenceSteps?: number;
    /** The number of images to generate (within [1, 128], default: 4) */
    numSamples?: number;
    /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
        If model.type is `sd-1_5`, the width must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
    width?: number;
    /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
    prompt: string;
  };
};
export type PostControlnetIpAdapterInferencesApiResponse =
  /** status 200 200 response */
  | {
      creativeUnitsCost?: number;
      inference: {
        /** Asset id of the input IpAdapter images */
        ipAdapterImageIds?: string[];
        /** Specifies how long the ControlNet guidance should be applied during the inference process.
        
        Only available for Flux.1-dev based models.
        
        The value represents the percentage of total inference steps where the ControlNet guidance is active.
        For example:
        - 1.0: ControlNet guidance is applied during all inference steps
        - 0.5: ControlNet guidance is only applied during the first half of inference steps
        
        Default values:
        - 0.5 for Canny modality
        - 0.6 for all other modalities */
        controlEnd?: number;
        /** The modality associated with the control image used for the generation: it can either be an object with a combination of maximum
        
        For models of SD1.5 family:
         - up to 3 modalities from `canny`, `pose`, `depth`, `lines`, `seg`, `scribble`, `lineart`, `normal-map`, `illusion`
         - or one of the following presets: `character`, `landscape`, `city`, `interior`.
        
        For models of the SDXL family:
         - up to 3 modalities from `canny`, `pose`, `depth`, `seg`, `illusion`, `scribble`
         - or one of the following presets: `character`, `landscape`.
        
        For models of the FLUX schnell or dev families:
        - one modality from: `canny`, `tile`, `depth`, `blur`, `pose`, `gray`, `low-quality`
        
        Optionally, you can associate a value to these modalities or presets. The value must be within `]0.0, 1.0]`.
        
        Examples:
        - `canny`
        - `depth:0.5,pose:1.0`
        - `canny:0.5,depth:0.5,lines:0.3`
        - `landscape`
        - `character:0.5`
        - `illusion:1`
        
        Note: if you use a value that is not supported by the model family, this will result in an error. */
        modality:
          | "blur"
          | "canny"
          | "depth"
          | "gray"
          | "illusion"
          | "lineart"
          | "lines"
          | "low-quality"
          | "normal-map"
          | "pose"
          | "scribble"
          | "seg"
          | "sketch"
          | "tile";
        /** Used to reproduce previous results. Default: randomly generated number. */
        seed?: string;
        /** The type of IP Adapter model to use. Must be one of [`style`, `character`], default to `style`` */
        ipAdapterType?: "character" | "style";
        /** The type of inference to use. Example: txt2img, img2img, etc.
        
        Selecting the right type will condition the expected parameters.
        
        Note: if model.type is `sd-xl*` or `sd-1_5*`, when using the `"inpaint"` inference type, Scenario determines the best available `baseModel` for a given `modelId`: one of `["stable-diffusion-inpainting", "stable-diffusion-xl-1.0-inpainting-0.1"] will be used. */
        type:
          | "txt2img"
          | "txt2img_ip_adapter"
          | "txt2img_texture"
          | "img2img"
          | "img2img_ip_adapter"
          | "img2img_texture"
          | "inpaint"
          | "outpaint"
          | "inpaint_ip_adapter"
          | "controlnet"
          | "controlnet_ip_adapter"
          | "reference"
          | "reference_texture"
          | "controlnet_reference"
          | "controlnet_img2img"
          | "controlnet_inpaint"
          | "controlnet_inpaint_ip_adapter"
          | "controlnet_texture";
        /** Signed URL to display the IpAdapter image */
        ipAdapterImage?: string;
        /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
        scheduler?:
          | "DDIMScheduler"
          | "DDPMScheduler"
          | "DEISMultistepScheduler"
          | "DPMSolverMultistepScheduler"
          | "DPMSolverSinglestepScheduler"
          | "EulerAncestralDiscreteScheduler"
          | "EulerDiscreteScheduler"
          | "HeunDiscreteScheduler"
          | "KDPM2AncestralDiscreteScheduler"
          | "KDPM2DiscreteScheduler"
          | "LCMScheduler"
          | "LMSDiscreteScheduler"
          | "PNDMScheduler"
          | "TCDScheduler"
          | "UniPCMultistepScheduler";
        /** If false, the process uses the given image to detect the modality.
        If true (default), the process will not try to detect the modality of the given image.
        
        For example:
        with `pose` modality and `false` value, the process will detect the pose of people in the given image
        with `depth` modality and `false` value, the process will detect the depth of the given image
        with `scribble` modality and `true`value, the process will use the given image as a scribble
        
        ⚠️ For models of the FLUX schnell or dev families, this parameter is ignored. The modality detection is always disabled. ⚠️ */
        disableModalityDetection?: boolean;
        /** Signed URL to display the IpAdapter images */
        ipAdapterImages?: string[];
        /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
        Allowed values are available in the model's attribute: `compliantModelIds` */
        baseModelId?: string;
        /** Specifies the starting point of the ControlNet guidance during the inference process.
        
        Only available for Flux.1-dev based models.
        
        The value represents the percentage of total inference steps where the ControlNet guidance starts.
        For example:
        - 0.0: ControlNet guidance starts at the beginning of the inference steps
        - 0.5: ControlNet guidance starts at the middle of the inference steps */
        controlStart?: number;
        /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
        If model.type is `sd-1_5`, the height must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        height?: number;
        /** Signed URL to display the input image */
        image: string;
        /** Asset id of the input image */
        imageId: string;
        /** Asset id of the input IpAdapter image */
        ipAdapterImageId?: string;
        /** IpAdapter scale factor (within [0.0, 1.0], default: 0.9). */
        ipAdapterScale?: number;
        /** If set, generated assets will be hidden and not returned in the list of images of the inference
        or when listing assets (default: false) */
        hideResults?: boolean;
        /** IpAdapter scale factors (within [0.0, 1.0], default: 0.9). */
        ipAdapterScales?: number[];
        /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
        negativePrompt?: string;
        /** Enable or disable the intermediate images generation (default: false) */
        intermediateImages?: boolean;
        concepts?: {
          /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
          modelId: string;
          /** The scale of the model (example: 1.0) */
          scale: number;
        }[];
        /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
        guidance?: number;
        /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
        numInferenceSteps?: number;
        /** The number of images to generate (within [1, 128], default: 4) */
        numSamples?: number;
        /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
        If model.type is `sd-1_5`, the width must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        width?: number;
        /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
        prompt: string;
      };
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostControlnetIpAdapterInferencesApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The IpAdapter images as an AssetId. Will be ignored if the `ipAdapterImages` parameter is provided */
    ipAdapterImageIds?: string[];
    /** Specifies how long the ControlNet guidance should be applied during the inference process.
        
        Only available for Flux.1-dev based models.
        
        The value represents the percentage of total inference steps where the ControlNet guidance is active.
        For example:
        - 1.0: ControlNet guidance is applied during all inference steps
        - 0.5: ControlNet guidance is only applied during the first half of inference steps
        
        Default values:
        - 0.5 for Canny modality
        - 0.6 for all other modalities */
    controlEnd?: number;
    /** The modality associated with the control image used for the generation: it can either be an object with a combination of maximum
        
        For models of SD1.5 family:
         - up to 3 modalities from `canny`, `pose`, `depth`, `lines`, `seg`, `scribble`, `lineart`, `normal-map`, `illusion`
         - or one of the following presets: `character`, `landscape`, `city`, `interior`.
        
        For models of the SDXL family:
         - up to 3 modalities from `canny`, `pose`, `depth`, `seg`, `illusion`, `scribble`
         - or one of the following presets: `character`, `landscape`.
        
        For models of the FLUX schnell or dev families:
        - one modality from: `canny`, `tile`, `depth`, `blur`, `pose`, `gray`, `low-quality`
        
        Optionally, you can associate a value to these modalities or presets. The value must be within `]0.0, 1.0]`.
        
        Examples:
        - `canny`
        - `depth:0.5,pose:1.0`
        - `canny:0.5,depth:0.5,lines:0.3`
        - `landscape`
        - `character:0.5`
        - `illusion:1`
        
        Note: if you use a value that is not supported by the model family, this will result in an error. */
    modality:
      | "blur"
      | "canny"
      | "depth"
      | "gray"
      | "illusion"
      | "lineart"
      | "lines"
      | "low-quality"
      | "normal-map"
      | "pose"
      | "scribble"
      | "seg"
      | "sketch"
      | "tile"
      | string;
    /** Used to reproduce previous results. Default: randomly generated number. */
    seed?: string;
    /** The model id to use for the inference */
    modelId: string;
    /** The type of IP Adapter model to use. Must be one of [`style`, `character`], default to `style`` */
    ipAdapterType?: "character" | "style";
    /** Deprecated for type txt2img-ip-adapter and img2img-ip-adapter, use `ipAdapterImages` instead.
        The IpAdapter image as a data url. Will be ignored if the `ipAdapterImages` parameter is provided. */
    ipAdapterImage?: string;
    /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
    scheduler?:
      | "DDIMScheduler"
      | "DDPMScheduler"
      | "DEISMultistepScheduler"
      | "DPMSolverMultistepScheduler"
      | "DPMSolverSinglestepScheduler"
      | "EulerAncestralDiscreteScheduler"
      | "EulerDiscreteScheduler"
      | "HeunDiscreteScheduler"
      | "KDPM2AncestralDiscreteScheduler"
      | "KDPM2DiscreteScheduler"
      | "LCMScheduler"
      | "LMSDiscreteScheduler"
      | "PNDMScheduler"
      | "TCDScheduler"
      | "UniPCMultistepScheduler";
    /** If false, the process uses the given image to detect the modality.
        If true (default), the process will not try to detect the modality of the given image.
        
        For example:
        with `pose` modality and `false` value, the process will detect the pose of people in the given image
        with `depth` modality and `false` value, the process will detect the depth of the given image
        with `scribble` modality and `true`value, the process will use the given image as a scribble
        
        ⚠️ For models of the FLUX schnell or dev families, this parameter is ignored. The modality detection is always disabled. ⚠️ */
    disableModalityDetection?: boolean;
    /** The IpAdapter images as a data url. */
    ipAdapterImages?: string[];
    /** Specifies the parent asset Id for the image when provided as a dataurl. */
    imageParentId?: string;
    /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
        Allowed values are available in the model's attribute: `compliantModelIds` */
    baseModelId?: string;
    /** Specifies the starting point of the ControlNet guidance during the inference process.
        
        Only available for Flux.1-dev based models.
        
        The value represents the percentage of total inference steps where the ControlNet guidance starts.
        For example:
        - 0.0: ControlNet guidance starts at the beginning of the inference steps
        - 0.5: ControlNet guidance starts at the middle of the inference steps */
    controlStart?: number;
    /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
        If model.type is `sd-1_5`, the height must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
    height?: number;
    /** Toggles the hidden status of the image when provided as a dataurl. */
    imageHide?: boolean;
    /** The controlnet input image as an AssetId. Will be ignored if the `controlnet` parameter is provided */
    controlImageId?: string;
    /** The input image as a data URL (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=") or the asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
    image?: string;
    /** Deprecated: The input image as an AssetId. Prefer to use image with the asset ID instead. */
    imageId?: string;
    /** Deprecated for type txt2img-ip-adapter and img2img-ip-adapter, use `ipAdapterImageIds` instead.
        The IpAdapter image as an AssetId. Cannot be set if `ipAdapterImage` is provided. Will be ignored if the `ipAdapterImageIds` parameter is provided. */
    ipAdapterImageId?: string;
    /** Deprecated for type txt2img-ip-adapter and img2img-ip-adapter, use `ipAdapterScales` instead.
        IpAdapter scale factor (within [0.0, 1.0], default: 0.9). Will be ignored if the `ipAdapterScales` parameter is provided */
    ipAdapterScale?: number;
    /** If set, generated assets will be hidden and not returned in the list of images of the inference
        or when listing assets (default: false) */
    hideResults?: boolean;
    /** IpAdapter scale factors (within [0.0, 1.0], default: 0.9). */
    ipAdapterScales?: number[];
    /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
    negativePrompt?: string;
    /** Enable or disable the intermediate images generation (default: false) */
    intermediateImages?: boolean;
    concepts?: {
      /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
      modelId: string;
      /** The scale of the model (example: 1.0) */
      scale: number;
    }[];
    /** The controlnet input image as a data URL (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=") */
    controlImage?: string;
    /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
    guidance?: number;
    /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
    numInferenceSteps?: number;
    /** The number of images to generate (within [1, 128], default: 4) */
    numSamples?: number;
    /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
        If model.type is `sd-1_5`, the width must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
    width?: number;
    /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
    prompt: string;
  };
};
export type PostControlnetTextureInferencesApiResponse =
  /** status 200 200 response */
  | {
      creativeUnitsCost?: number;
      inference: {
        /** Signed URL to display the input image */
        image: string;
        /** Specifies how long the ControlNet guidance should be applied during the inference process.
        
        Only available for Flux.1-dev based models.
        
        The value represents the percentage of total inference steps where the ControlNet guidance is active.
        For example:
        - 1.0: ControlNet guidance is applied during all inference steps
        - 0.5: ControlNet guidance is only applied during the first half of inference steps
        
        Default values:
        - 0.5 for Canny modality
        - 0.6 for all other modalities */
        controlEnd?: number;
        /** Asset id of the input image */
        imageId: string;
        /** The modality associated with the control image used for the generation: it can either be an object with a combination of maximum
        
        For models of SD1.5 family:
         - up to 3 modalities from `canny`, `pose`, `depth`, `lines`, `seg`, `scribble`, `lineart`, `normal-map`, `illusion`
         - or one of the following presets: `character`, `landscape`, `city`, `interior`.
        
        For models of the SDXL family:
         - up to 3 modalities from `canny`, `pose`, `depth`, `seg`, `illusion`, `scribble`
         - or one of the following presets: `character`, `landscape`.
        
        For models of the FLUX schnell or dev families:
        - one modality from: `canny`, `tile`, `depth`, `blur`, `pose`, `gray`, `low-quality`
        
        Optionally, you can associate a value to these modalities or presets. The value must be within `]0.0, 1.0]`.
        
        Examples:
        - `canny`
        - `depth:0.5,pose:1.0`
        - `canny:0.5,depth:0.5,lines:0.3`
        - `landscape`
        - `character:0.5`
        - `illusion:1`
        
        Note: if you use a value that is not supported by the model family, this will result in an error. */
        modality:
          | "blur"
          | "canny"
          | "depth"
          | "gray"
          | "illusion"
          | "lineart"
          | "lines"
          | "low-quality"
          | "normal-map"
          | "pose"
          | "scribble"
          | "seg"
          | "sketch"
          | "tile";
        /** Used to reproduce previous results. Default: randomly generated number. */
        seed?: string;
        /** If set, generated assets will be hidden and not returned in the list of images of the inference
        or when listing assets (default: false) */
        hideResults?: boolean;
        /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
        negativePrompt?: string;
        /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
        scheduler?:
          | "DDIMScheduler"
          | "DDPMScheduler"
          | "DEISMultistepScheduler"
          | "DPMSolverMultistepScheduler"
          | "DPMSolverSinglestepScheduler"
          | "EulerAncestralDiscreteScheduler"
          | "EulerDiscreteScheduler"
          | "HeunDiscreteScheduler"
          | "KDPM2AncestralDiscreteScheduler"
          | "KDPM2DiscreteScheduler"
          | "LCMScheduler"
          | "LMSDiscreteScheduler"
          | "PNDMScheduler"
          | "TCDScheduler"
          | "UniPCMultistepScheduler";
        /** Enable or disable the intermediate images generation (default: false) */
        intermediateImages?: boolean;
        concepts?: {
          /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
          modelId: string;
          /** The scale of the model (example: 1.0) */
          scale: number;
        }[];
        /** If false, the process uses the given image to detect the modality.
        If true (default), the process will not try to detect the modality of the given image.
        
        For example:
        with `pose` modality and `false` value, the process will detect the pose of people in the given image
        with `depth` modality and `false` value, the process will detect the depth of the given image
        with `scribble` modality and `true`value, the process will use the given image as a scribble
        
        ⚠️ For models of the FLUX schnell or dev families, this parameter is ignored. The modality detection is always disabled. ⚠️ */
        disableModalityDetection?: boolean;
        /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
        guidance?: number;
        /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
        numInferenceSteps?: number;
        /** The number of images to generate (within [1, 128], default: 4) */
        numSamples?: number;
        /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
        If model.type is `sd-1_5`, the width must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        width?: number;
        /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
        Allowed values are available in the model's attribute: `compliantModelIds` */
        baseModelId?: string;
        /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
        prompt: string;
        /** Specifies the starting point of the ControlNet guidance during the inference process.
        
        Only available for Flux.1-dev based models.
        
        The value represents the percentage of total inference steps where the ControlNet guidance starts.
        For example:
        - 0.0: ControlNet guidance starts at the beginning of the inference steps
        - 0.5: ControlNet guidance starts at the middle of the inference steps */
        controlStart?: number;
        /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
        If model.type is `sd-1_5`, the height must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        height?: number;
      };
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostControlnetTextureInferencesApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The controlnet input image as an AssetId. Will be ignored if the `controlnet` parameter is provided */
    controlImageId?: string;
    /** The input image as a data URL (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=") or the asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
    image?: string;
    /** Specifies how long the ControlNet guidance should be applied during the inference process.
        
        Only available for Flux.1-dev based models.
        
        The value represents the percentage of total inference steps where the ControlNet guidance is active.
        For example:
        - 1.0: ControlNet guidance is applied during all inference steps
        - 0.5: ControlNet guidance is only applied during the first half of inference steps
        
        Default values:
        - 0.5 for Canny modality
        - 0.6 for all other modalities */
    controlEnd?: number;
    /** Deprecated: The input image as an AssetId. Prefer to use image with the asset ID instead. */
    imageId?: string;
    /** The modality associated with the control image used for the generation: it can either be an object with a combination of maximum
        
        For models of SD1.5 family:
         - up to 3 modalities from `canny`, `pose`, `depth`, `lines`, `seg`, `scribble`, `lineart`, `normal-map`, `illusion`
         - or one of the following presets: `character`, `landscape`, `city`, `interior`.
        
        For models of the SDXL family:
         - up to 3 modalities from `canny`, `pose`, `depth`, `seg`, `illusion`, `scribble`
         - or one of the following presets: `character`, `landscape`.
        
        For models of the FLUX schnell or dev families:
        - one modality from: `canny`, `tile`, `depth`, `blur`, `pose`, `gray`, `low-quality`
        
        Optionally, you can associate a value to these modalities or presets. The value must be within `]0.0, 1.0]`.
        
        Examples:
        - `canny`
        - `depth:0.5,pose:1.0`
        - `canny:0.5,depth:0.5,lines:0.3`
        - `landscape`
        - `character:0.5`
        - `illusion:1`
        
        Note: if you use a value that is not supported by the model family, this will result in an error. */
    modality:
      | "blur"
      | "canny"
      | "depth"
      | "gray"
      | "illusion"
      | "lineart"
      | "lines"
      | "low-quality"
      | "normal-map"
      | "pose"
      | "scribble"
      | "seg"
      | "sketch"
      | "tile"
      | string;
    /** Used to reproduce previous results. Default: randomly generated number. */
    seed?: string;
    /** The model id to use for the inference */
    modelId: string;
    /** If set, generated assets will be hidden and not returned in the list of images of the inference
        or when listing assets (default: false) */
    hideResults?: boolean;
    /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
    negativePrompt?: string;
    /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
    scheduler?:
      | "DDIMScheduler"
      | "DDPMScheduler"
      | "DEISMultistepScheduler"
      | "DPMSolverMultistepScheduler"
      | "DPMSolverSinglestepScheduler"
      | "EulerAncestralDiscreteScheduler"
      | "EulerDiscreteScheduler"
      | "HeunDiscreteScheduler"
      | "KDPM2AncestralDiscreteScheduler"
      | "KDPM2DiscreteScheduler"
      | "LCMScheduler"
      | "LMSDiscreteScheduler"
      | "PNDMScheduler"
      | "TCDScheduler"
      | "UniPCMultistepScheduler";
    /** Enable or disable the intermediate images generation (default: false) */
    intermediateImages?: boolean;
    concepts?: {
      /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
      modelId: string;
      /** The scale of the model (example: 1.0) */
      scale: number;
    }[];
    /** The controlnet input image as a data URL (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=") */
    controlImage?: string;
    /** If false, the process uses the given image to detect the modality.
        If true (default), the process will not try to detect the modality of the given image.
        
        For example:
        with `pose` modality and `false` value, the process will detect the pose of people in the given image
        with `depth` modality and `false` value, the process will detect the depth of the given image
        with `scribble` modality and `true`value, the process will use the given image as a scribble
        
        ⚠️ For models of the FLUX schnell or dev families, this parameter is ignored. The modality detection is always disabled. ⚠️ */
    disableModalityDetection?: boolean;
    /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
    guidance?: number;
    /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
    numInferenceSteps?: number;
    /** The number of images to generate (within [1, 128], default: 4) */
    numSamples?: number;
    /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
        If model.type is `sd-1_5`, the width must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
    width?: number;
    /** Specifies the parent asset Id for the image when provided as a dataurl. */
    imageParentId?: string;
    /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
        Allowed values are available in the model's attribute: `compliantModelIds` */
    baseModelId?: string;
    /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
    prompt: string;
    /** Specifies the starting point of the ControlNet guidance during the inference process.
        
        Only available for Flux.1-dev based models.
        
        The value represents the percentage of total inference steps where the ControlNet guidance starts.
        For example:
        - 0.0: ControlNet guidance starts at the beginning of the inference steps
        - 0.5: ControlNet guidance starts at the middle of the inference steps */
    controlStart?: number;
    /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
        If model.type is `sd-1_5`, the height must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
    height?: number;
    /** Toggles the hidden status of the image when provided as a dataurl. */
    imageHide?: boolean;
  };
};
export type PostGenerateCustomApiResponse = /** status 200 200 response */ {
  /** The number of creative units consumed for this action. */
  creativeUnitsCost?: number;
  job: {
    /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt: string;
    /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
    jobId: string;
    /** Metadata of the job with some additional information */
    metadata: {
      /** The output of the job */
      output?: {};
      /** The inputs for the job */
      input?: {};
      /** List of produced assets for this job */
      assetIds?: string[];
    };
    /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
    statusHistory: {
      date: string;
      status:
        | "canceled"
        | "failure"
        | "in-progress"
        | "queued"
        | "success"
        | "warming-up";
    }[];
    /** Progress of the job (between 0 and 1) */
    progress: number;
    /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
    authorId?: string;
    /** The type of job */
    jobType:
      | "assets-download"
      | "canvas-export"
      | "caption"
      | "caption-llava"
      | "custom"
      | "describe-style"
      | "detection"
      | "embed"
      | "flux"
      | "flux-model-training"
      | "generate-prompt"
      | "image-generation"
      | "image-prompt-editing"
      | "inference"
      | "model-download"
      | "model-import"
      | "model-training"
      | "openai-image-generation"
      | "patch-image"
      | "pixelate"
      | "reframe"
      | "remove-background"
      | "repaint"
      | "restyle"
      | "segment"
      | "skybox-base-360"
      | "skybox-upscale-360"
      | "texture"
      | "translate"
      | "upload"
      | "upscale"
      | "upscale-skybox"
      | "upscale-texture"
      | "vectorize";
    /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
    ownerId?: string;
    /** The current status of the job */
    status:
      | "canceled"
      | "failure"
      | "in-progress"
      | "queued"
      | "success"
      | "warming-up";
    /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    updatedAt: string;
  };
};
export type PostGenerateCustomApiArg = {
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  modelId: string;
  body: any;
};
export type PostDescribeStyleInferencesApiResponse =
  /** status 200 200 response */
  | {
      /** A short synthesis that describes the given asset(s) or asset(s) model. */
      synthesis: string;
      /** The number of creative units consumed for this action. */
      creativeUnitsCost?: number;
      /** The style of the given images. */
      description: string;
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostDescribeStyleInferencesApiArg = {
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** Whether we try to ensure IP removal for new prompt generation. */
    ensureIPCleared?: boolean;
    /** If specified, the API will make a best effort to produce the same results, such that repeated requests with the same `seed` and parameters should return the same outputs. Must be used along with the same parameters including prompt, model's state, etc.. */
    seed?: number;
    /** Optional list of words sequences that should not be present in the generated prompts. */
    unwantedSequences?: string[];
    /** The modelId used to condition the generation.
        
        When provided, the generation will take into account model's training images, examples. */
    modelId?: string;
    /** The sampling temperature to use. Higher values like `0.8` will make the output more random, while lower values like `0.2` will make it more focused and deterministic.
        
        We generally recommend altering this or `topP` but not both. */
    temperature?: number;
    /** The asset ids used to condition the generation.
        
        Notes: supersedes the `modelId` parameter when provided. */
    assetIds?: string[];
    /** An alternative to sampling with temperature, called nucleus sampling, where the model considers the results of the tokens with top_p probability mass. So `0.1` means only the tokens comprising the top `10%` probability mass are considered.
        
        We generally recommend altering this or `temperature` but not both. */
    topP?: number;
  };
};
export type PostDetectInferencesApiResponse =
  /** status 200 200 response */
  | {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost?: number;
      asset?: {
        /** Metadata of the asset with some additional information */
        metadata: {
          maxIterations?: number;
          /** Modality to detect */
          modality?:
            | "canny"
            | "depth"
            | "grayscale"
            | "lineart_anime"
            | "mlsd"
            | "normal"
            | "pose"
            | "scribble"
            | "segmentation"
            | "sketch";
          /** If set to true, during the upscaling process, the model will match tiles of the source image with tiles of the style image(s). This will result in a more coherent restyle. Works best with style images that have a similar composition. */
          tileStyle?: boolean;
          /** The modelId used to generate this asset */
          modelId?: string;
          /** A bounding box around the object of interest, in the format [x1, y1, x2, y2]. */
          bbox?: any[];
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          keypointThreshold?: number;
          /** The type of the asset. Ex: 'inference-txt2img' will represent an asset generated from a text to image model */
          type:
            | "background-removal"
            | "canvas"
            | "canvas-drawing"
            | "canvas-export"
            | "detection"
            | "generative-fill"
            | "image-prompt-editing"
            | "img23d-custom"
            | "img2img-custom"
            | "img2video-custom"
            | "inference-controlnet"
            | "inference-controlnet-img2img"
            | "inference-controlnet-inpaint"
            | "inference-controlnet-inpaint-ip-adapter"
            | "inference-controlnet-ip-adapter"
            | "inference-controlnet-reference"
            | "inference-controlnet-texture"
            | "inference-img2img"
            | "inference-img2img-ip-adapter"
            | "inference-img2img-texture"
            | "inference-inpaint"
            | "inference-inpaint-ip-adapter"
            | "inference-reference"
            | "inference-reference-texture"
            | "inference-txt2img"
            | "inference-txt2img-ip-adapter"
            | "inference-txt2img-texture"
            | "patch"
            | "pixelization"
            | "reframe"
            | "restyle"
            | "segment"
            | "segmentation-image"
            | "segmentation-mask"
            | "skybox-base-360"
            | "texture"
            | "texture-albedo"
            | "texture-ao"
            | "texture-edge"
            | "texture-height"
            | "texture-metallic"
            | "texture-normal"
            | "texture-smoothness"
            | "txt23d-custom"
            | "txt2audio-custom"
            | "txt2img-custom"
            | "unknown-custom"
            | "uploaded"
            | "upscale"
            | "upscale-skybox"
            | "upscale-texture"
            | "vectorization"
            | "video2video-custom";
          /** A textual description / keywords describing the object of interest. */
          text?: string;
          height?: number;
          nbMasks?: number;
          /** Amount of decay in creativity over the upscale process. The lowest the value, the less the creativity will be preserved over the upscale process. */
          creativityDecay?: number;
          layerDifference?: number;
          /** Scaling factor (when `targetWidth` not specified) */
          scalingFactor?: number;
          /** The type of the generator used */
          modelType?:
            | "custom"
            | "flux.1"
            | "flux.1-composition"
            | "flux.1-lora"
            | "flux.1-pro"
            | "flux.1.1-pro-ultra"
            | "flux1.1-pro"
            | "gpt-image-1"
            | "sd-1_5"
            | "sd-1_5-composition"
            | "sd-1_5-lora"
            | "sd-xl"
            | "sd-xl-composition"
            | "sd-xl-lora";
          /** The number of outputs to generate. */
          numOutputs?: number;
          /** How angular is the surface? 0 is like a sphere, 1 is like a mechanical object */
          angular?: number;
          /** The target height of the output image. */
          targetHeight?: number;
          /** Flux LoRa or Composition to style the image. */
          concepts?: {
            weightName: string;
            /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
            modelId: string;
            /** The scale of the model (example: 1.0) */
            scale: number;
          }[];
          size?: number;
          spliceThreshold?: number;
          /** The number of pixels to dilate the result masks. */
          dilate?: number;
          style?:
            | "3d-cartoon"
            | "3d-rendered"
            | "anime"
            | "cartoon"
            | "cinematic"
            | "claymation"
            | "cloud-skydome"
            | "comic"
            | "cyberpunk"
            | "enchanted"
            | "fantasy"
            | "ink"
            | "manga"
            | "manga-color"
            | "minimalist"
            | "neon-tron"
            | "oil-painting"
            | "pastel"
            | "photo"
            | "photography"
            | "psychedelic"
            | "retro-fantasy"
            | "scifi-concept-art"
            | "space"
            | "standard"
            | "whimsical";
          /** Strengthen the similarity to the original image during the upscale. Default: optimized for your preset and style. */
          imageFidelity?: number;
          /** Location of the input image in the output. */
          inputLocation?: "bottom" | "left" | "middle" | "right" | "top";
          /** The seed used to generate this asset */
          seed?: string;
          /** The higher the value the more it will look like the secondary reference image(s) */
          secondaryRefFidelity?: number;
          preset?: string;
          trainingImage?: boolean;
          /** Boolean to able return the masks (binary image) in the response. */
          resultMask?: boolean;
          /** The ISO timestamp when the lock on the canvas will expire */
          lockExpiresAt?: string;
          /** The baseModelId that maybe changed at inference time */
          baseModelId?: string;
          pathPrecision?: number;
          rootParentId?: string;
          /** Sharpen tiles. */
          sharpen?: boolean;
          cornerThreshold?: number;
          /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
          styleImages?: string[];
          /** The asset to convert in texture maps. Must reference an existing AssetId. */
          texture?: string;
          filterSpeckle?: number;
          /** Minimum threshold for Grayscale conversion */
          minThreshold?: number;
          /** Maximum threshold for Grayscale conversion */
          maxThreshold?: number;
          /** Condition the influence of the style image(s). The higher the value, the more the style images will influence the upscaled image. */
          styleImagesFidelity?: number;
          /** The control image processed by depth estimator. Must reference an existing AssetId. */
          depthImage?: string;
          parentId?: string;
          parentJobId?: string;
          /** Optional List of secondary style images. Example: portrait of people. It must be existing AssetIds. */
          secondaryRefImages?: string[];
          /** The width of the rendered image. */
          width?: number;
          /** The checkpoint to use */
          checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
          strength?: number;
          /** The id of the Inference describing how this image was generated */
          inferenceId?: string;
          lengthThreshold?: number;
          /** Int to set between 0 and 255 for the opacity of the background in the result images. */
          backgroundOpacity?: number;
          /** The optional aspect ratio given for the generation, only applicable for some models */
          aspectRatio?: string;
          /** Amount of details to remove or add */
          detailsLevel?: number;
          /** Determine the scale at which the upscale process works.
            - With a small value, the upscale works at the largest scale, resulting in fewer added details and more coherent images. Ideal for portraits, for example.
            - With a large value, the upscale works at the smallest scale, resulting in more added details and more hallucinations. Ideal for landscapes, for example.
            
            (info): A small value is slower and more expensive to run. */
          fractality?: number;
          /** (deprecated) Horizontal expansion ratio. */
          horizontalExpansionRatio?: number;
          /** List of points (label, x, y) in the image where label = 0 for background and 1 for object. */
          points?: any[][];
          mode?: string;
          colorPrecision?: number;
          /** Increase the fidelity to the prompt during upscale. Default: optimized for your preset and style. */
          promptFidelity?: number;
          /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
          betterQuality?: boolean;
          /** Remove background for Grayscale detector */
          removeBackground?: boolean;
          /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your preset and style. */
          creativity?: number;
          /** Strength for the input image structure preservation */
          structureFidelity?: number;
          /** Preserve the seamless properties of skybox or texture images. Input has to be of same type (seamless). */
          imageType?: "seamfull" | "skybox" | "texture";
          /** The input image to process. Must reference an existing AssetId or be a data URL. */
          image?: string;
          /** The thumbnail of the canvas */
          thumbnail?: {
            /** The AssetId of the image used as a thumbnail for the canvas (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
            assetId: string;
            /** The url of the image used as a thumbnail for the canvas */
            url: string;
          };
          /** The control image for structure. A canny detector will be applied to this image. Must reference an existing AssetId. */
          structureImage?: string;
          /** To invert the relief */
          invert?: boolean;
          kind: "3d" | "audio" | "document" | "image" | "json" | "video";
          colorMode?: string;
          /** High threshold for Canny detector */
          highThreshold?: number;
          /** (deprecated) Vertical expansion ratio. */
          verticalExpansionRatio?: number;
          halfMode?: boolean;
          name?: string;
          /** Additional refinement steps before scaling.
            
            If scalingFactor == 1, the refinement process will be applied (1 + refinementSteps) times.
            If scalingFactor > 1, the refinement process will be applied refinementSteps times. */
          refinementSteps?: number;
          /** The reference images used for the image generation or editing */
          referenceImages?: string[];
          /** The higher the value the more it will look like the style image(s) */
          styleFidelity?: number;
          /** Boolean to output the contours. */
          resultContours?: boolean;
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          polished?: number;
          /** The scheduler used to generate this asset */
          scheduler?: string;
          /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
          overrideEmbeddings?: boolean;
          progressPercent?: number;
          /** Contrast factor for Grayscale detector */
          factor?: number;
          /** The mask used for the image generation or editing */
          mask?: string;
          /** Low threshold for Canny detector */
          lowThreshold?: number;
          /** The depth fidelity if a depth image provided */
          depthFidelity?: number;
          /** How raised is the surface? 0 is flat like water, 1 is like a very rough rock */
          raised?: number;
          message?: string;
          contours?: number[][][][];
          /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
          negativePrompt?: string;
          /** If true, use the default parameters */
          defaultParameters?: boolean;
          /** Size proportion of the input image in the output. */
          resizeOption?: number;
          outputIndex?: number;
          /** Save a flipbook of the texture. Deactivated when the input texture is larger than 2048x2048px */
          saveFlipbook?: boolean;
          /** The guidance used to generate this asset */
          guidance?: number;
          /** The number of denoising steps for each image generation. */
          numInferenceSteps?: number;
          hdr?: number;
          /** How shiny is the surface? 0 is like a matte surface, 1 is like a diamond */
          shiny?: number;
          /** Ensure upscaled tile have the same color histogram as original tile. */
          colorCorrection?: boolean;
          /** Overlap percentage for the output image. */
          overlapPercentage?: number;
          /** The prompt that guided the image generation or editing */
          prompt?: string;
          /** Boolean to able output the cut out object. */
          resultImage?: boolean;
          /** The control image already processed by canny detector. Must reference an existing AssetId. */
          cannyStructureImage?: string;
          /** Apply extra control to the Skybox 360 geometry.
            The higher the value, the more the 360 geometry will influence the generated skybox image.
            
            Use with caution. Default is adapted to the other parameters. */
          geometryEnforcement?: number;
          /** Target width for the upscaled image, take priority over scaling factor */
          targetWidth?: number;
        };
        /** The NSFW labels */
        nsfw?: string[];
        /** Automatic captioning of the asset */
        automaticCaptioning?: string;
        /** The description of the asset */
        description?: string;
        /** The privacy of the asset */
        privacy: "private" | "public" | "unlisted";
        /** The date when the asset will be soft deleted (only for Free plan) */
        softDeletionOn?: string;
        /** The mime type of the asset (example: "image/png") */
        mimeType: string;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId: string;
        /** The owner (project) ID (example: "proj_23tlk332lkht3kl2" or "team_dlkhgs23tlk3hlkth32lkht3kl2" for old teams) */
        ownerId: string;
        /** Signed URL to get the asset content */
        url: string;
        /** The associated tags (example: ["sci-fi", "landscape"]) */
        tags: string[];
        /** The asset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The output index of the asset within the job
        This index is an positive integer that starts at 0
        It is used to differentiate between multiple outputs of the same job
        If the job has only one output, this index is 0
        This is only applicable for generations with: Flux, Skybox, Reframe at the moment */
        outputIndex?: number;
        /** A list of CollectionId this asset belongs to */
        collectionIds: string[];
        /** List of edit capabilities for the asset */
        editCapabilities: (
          | "DETECTION"
          | "GENERATIVE_FILL"
          | "PIXELATE"
          | "PROMPT_EDITING"
          | "REFINE"
          | "REFRAME"
          | "REMOVE_BACKGROUND"
          | "SEGMENTATION"
          | "UPSCALE"
          | "UPSCALE_360"
          | "VECTORIZATION"
        )[];
        /** The embedding of the asset when requested and asset can be embedded
        
        ie: Detection maps don't have embeddings */
        embedding?: number[];
        /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        id: string;
        /** The status of the asset */
        status: "error" | "pending" | "success";
        /** The asset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostDetectInferencesApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The image to be used to detect. Must reference an existing AssetId or be a data URL. */
    image: string;
    /** Modality to detect */
    modality:
      | "canny"
      | "depth"
      | "grayscale"
      | "lineart_anime"
      | "mlsd"
      | "normal"
      | "pose"
      | "scribble"
      | "segmentation"
      | "sketch"
      | "lines"
      | "seg"
      | "normal-map"
      | "lineart";
    /** Low threshold for Canny detector */
    lowThreshold?: number;
    /** Remove background for Grayscale detector */
    removeBackground?: boolean;
    /** Minimum threshold for Grayscale conversion */
    minThreshold?: number;
    /** Maximum threshold for Grayscale conversion */
    maxThreshold?: number;
    /** Contrast factor for Grayscale detector */
    factor?: number;
    /** High threshold for Canny detector */
    highThreshold?: number;
    /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
    keypointThreshold?: number;
  };
};
export type PostEmbedInferencesApiResponse =
  /** status 200 200 response */
  | {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost?: number;
      /** The embedding
    
    A 1_024 dimension vector */
      embedding: number[];
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostEmbedInferencesApiArg = {
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The text to embed. Must be a non-empty string. */
    text: string;
  };
};
export type PostGenerativeFillInferencesApiResponse =
  /** status 200 200 response */
  | {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost?: number;
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostGenerativeFillInferencesApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The image from which the mask will be refilled generatively. Must reference an existing AssetId or be a data URL. */
    image: string;
    /** The target height of the output image. */
    targetHeight?: number;
    /** Used to reproduce previous results. Default: randomly generated number. */
    seed?: number;
    /** The number of denoising steps for each image generation. */
    numInferenceSteps?: number;
    /** Increase the fidelity to the prompt during the restyle. */
    promptFidelity?: number;
    /** The mask as an AssetId, used to determine the area to refill generatively. Will be ignored if the `mask` parameter is provided. Must reference an existing AssetId. */
    maskId?: string;
    /** A full text prompt to guide the repaint process. */
    prompt?: string;
    /** The mask as a data URL, used to determine the area of change. The mask is a binary mask made out of white and black pixels. The white area is the one that will be replaced. (example: "data:image/png;base64,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") */
    mask?: string;
    /** A negative full text prompt that discourages the repaint from generating certain characteristics. It is recommended to test without using a negative prompt. */
    negativePrompt?: string;
    /** The target width of the output image. */
    targetWidth?: number;
  };
};
export type PostImg2ImgInferencesApiResponse =
  /** status 200 200 response */
  | {
      creativeUnitsCost?: number;
      inference: {
        /** Signed URL to display the input image */
        image: string;
        /** Asset id of the input image */
        imageId: string;
        /** Used to reproduce previous results. Default: randomly generated number. */
        seed?: string;
        /** Controls the noise intensity introduced to the input image, where a value of 1.0 completely erases the original image's details. Available for img2img and inpainting. (within [0.01, 1.0], default: 0.75) */
        strength?: number;
        /** If set, generated assets will be hidden and not returned in the list of images of the inference
        or when listing assets (default: false) */
        hideResults?: boolean;
        /** Asset id of the mask image */
        maskId?: string;
        /** The type of inference to use. Example: txt2img, img2img, etc.
        
        Selecting the right type will condition the expected parameters.
        
        Note: if model.type is `sd-xl*` or `sd-1_5*`, when using the `"inpaint"` inference type, Scenario determines the best available `baseModel` for a given `modelId`: one of `["stable-diffusion-inpainting", "stable-diffusion-xl-1.0-inpainting-0.1"] will be used. */
        type:
          | "txt2img"
          | "txt2img_ip_adapter"
          | "txt2img_texture"
          | "img2img"
          | "img2img_ip_adapter"
          | "img2img_texture"
          | "inpaint"
          | "outpaint"
          | "inpaint_ip_adapter"
          | "controlnet"
          | "controlnet_ip_adapter"
          | "reference"
          | "reference_texture"
          | "controlnet_reference"
          | "controlnet_img2img"
          | "controlnet_inpaint"
          | "controlnet_inpaint_ip_adapter"
          | "controlnet_texture";
        /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
        negativePrompt?: string;
        /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
        scheduler?:
          | "DDIMScheduler"
          | "DDPMScheduler"
          | "DEISMultistepScheduler"
          | "DPMSolverMultistepScheduler"
          | "DPMSolverSinglestepScheduler"
          | "EulerAncestralDiscreteScheduler"
          | "EulerDiscreteScheduler"
          | "HeunDiscreteScheduler"
          | "KDPM2AncestralDiscreteScheduler"
          | "KDPM2DiscreteScheduler"
          | "LCMScheduler"
          | "LMSDiscreteScheduler"
          | "PNDMScheduler"
          | "TCDScheduler"
          | "UniPCMultistepScheduler";
        /** Enable or disable the intermediate images generation (default: false) */
        intermediateImages?: boolean;
        concepts?: {
          /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
          modelId: string;
          /** The scale of the model (example: 1.0) */
          scale: number;
        }[];
        /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
        guidance?: number;
        /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
        numInferenceSteps?: number;
        /** The number of images to generate (within [1, 128], default: 4) */
        numSamples?: number;
        /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
        If model.type is `sd-1_5`, the width must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        width?: number;
        /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
        Allowed values are available in the model's attribute: `compliantModelIds` */
        baseModelId?: string;
        /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
        prompt: string;
        /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
        If model.type is `sd-1_5`, the height must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        height?: number;
        /** Signed URL to display the mask image */
        mask?: string;
      };
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostImg2ImgInferencesApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The input image as a data URL (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=") or the asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
    image?: string;
    /** Deprecated: The input image as an AssetId. Prefer to use image with the asset ID instead. */
    imageId?: string;
    /** Used to reproduce previous results. Default: randomly generated number. */
    seed?: string;
    /** Controls the noise intensity introduced to the input image, where a value of 1.0 completely erases the original image's details. Available for img2img and inpainting. (within [0.01, 1.0], default: 0.75) */
    strength?: number;
    /** The model id to use for the inference */
    modelId: string;
    /** If set, generated assets will be hidden and not returned in the list of images of the inference
        or when listing assets (default: false) */
    hideResults?: boolean;
    /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
    negativePrompt?: string;
    /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
    scheduler?:
      | "DDIMScheduler"
      | "DDPMScheduler"
      | "DEISMultistepScheduler"
      | "DPMSolverMultistepScheduler"
      | "DPMSolverSinglestepScheduler"
      | "EulerAncestralDiscreteScheduler"
      | "EulerDiscreteScheduler"
      | "HeunDiscreteScheduler"
      | "KDPM2AncestralDiscreteScheduler"
      | "KDPM2DiscreteScheduler"
      | "LCMScheduler"
      | "LMSDiscreteScheduler"
      | "PNDMScheduler"
      | "TCDScheduler"
      | "UniPCMultistepScheduler";
    /** Enable or disable the intermediate images generation (default: false) */
    intermediateImages?: boolean;
    concepts?: {
      /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
      modelId: string;
      /** The scale of the model (example: 1.0) */
      scale: number;
    }[];
    /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
    guidance?: number;
    /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
    numInferenceSteps?: number;
    /** The number of images to generate (within [1, 128], default: 4) */
    numSamples?: number;
    /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
        If model.type is `sd-1_5`, the width must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
    width?: number;
    /** Specifies the parent asset Id for the image when provided as a dataurl. */
    imageParentId?: string;
    /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
        Allowed values are available in the model's attribute: `compliantModelIds` */
    baseModelId?: string;
    /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
    prompt: string;
    /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
        If model.type is `sd-1_5`, the height must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
    height?: number;
    /** Toggles the hidden status of the image when provided as a dataurl. */
    imageHide?: boolean;
  };
};
export type PostImg2ImgIpAdapterInferencesApiResponse =
  /** status 200 200 response */
  | {
      creativeUnitsCost?: number;
      inference: {
        /** Asset id of the input IpAdapter images */
        ipAdapterImageIds?: string[];
        /** Used to reproduce previous results. Default: randomly generated number. */
        seed?: string;
        /** Controls the noise intensity introduced to the input image, where a value of 1.0 completely erases the original image's details. Available for img2img and inpainting. (within [0.01, 1.0], default: 0.75) */
        strength?: number;
        /** The type of IP Adapter model to use. Must be one of [`style`, `character`], default to `style`` */
        ipAdapterType?: "character" | "style";
        /** The type of inference to use. Example: txt2img, img2img, etc.
        
        Selecting the right type will condition the expected parameters.
        
        Note: if model.type is `sd-xl*` or `sd-1_5*`, when using the `"inpaint"` inference type, Scenario determines the best available `baseModel` for a given `modelId`: one of `["stable-diffusion-inpainting", "stable-diffusion-xl-1.0-inpainting-0.1"] will be used. */
        type:
          | "txt2img"
          | "txt2img_ip_adapter"
          | "txt2img_texture"
          | "img2img"
          | "img2img_ip_adapter"
          | "img2img_texture"
          | "inpaint"
          | "outpaint"
          | "inpaint_ip_adapter"
          | "controlnet"
          | "controlnet_ip_adapter"
          | "reference"
          | "reference_texture"
          | "controlnet_reference"
          | "controlnet_img2img"
          | "controlnet_inpaint"
          | "controlnet_inpaint_ip_adapter"
          | "controlnet_texture";
        /** Signed URL to display the IpAdapter image */
        ipAdapterImage?: string;
        /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
        scheduler?:
          | "DDIMScheduler"
          | "DDPMScheduler"
          | "DEISMultistepScheduler"
          | "DPMSolverMultistepScheduler"
          | "DPMSolverSinglestepScheduler"
          | "EulerAncestralDiscreteScheduler"
          | "EulerDiscreteScheduler"
          | "HeunDiscreteScheduler"
          | "KDPM2AncestralDiscreteScheduler"
          | "KDPM2DiscreteScheduler"
          | "LCMScheduler"
          | "LMSDiscreteScheduler"
          | "PNDMScheduler"
          | "TCDScheduler"
          | "UniPCMultistepScheduler";
        /** Signed URL to display the IpAdapter images */
        ipAdapterImages?: string[];
        /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
        Allowed values are available in the model's attribute: `compliantModelIds` */
        baseModelId?: string;
        /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
        If model.type is `sd-1_5`, the height must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        height?: number;
        /** Signed URL to display the mask image */
        mask?: string;
        /** Signed URL to display the input image */
        image: string;
        /** Asset id of the input image */
        imageId: string;
        /** Asset id of the input IpAdapter image */
        ipAdapterImageId?: string;
        /** IpAdapter scale factor (within [0.0, 1.0], default: 0.9). */
        ipAdapterScale?: number;
        /** If set, generated assets will be hidden and not returned in the list of images of the inference
        or when listing assets (default: false) */
        hideResults?: boolean;
        /** IpAdapter scale factors (within [0.0, 1.0], default: 0.9). */
        ipAdapterScales?: number[];
        /** Asset id of the mask image */
        maskId?: string;
        /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
        negativePrompt?: string;
        /** Enable or disable the intermediate images generation (default: false) */
        intermediateImages?: boolean;
        concepts?: {
          /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
          modelId: string;
          /** The scale of the model (example: 1.0) */
          scale: number;
        }[];
        /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
        guidance?: number;
        /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
        numInferenceSteps?: number;
        /** The number of images to generate (within [1, 128], default: 4) */
        numSamples?: number;
        /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
        If model.type is `sd-1_5`, the width must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        width?: number;
        /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
        prompt: string;
      };
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostImg2ImgIpAdapterInferencesApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The IpAdapter images as an AssetId. Will be ignored if the `ipAdapterImages` parameter is provided */
    ipAdapterImageIds?: string[];
    /** Used to reproduce previous results. Default: randomly generated number. */
    seed?: string;
    /** Controls the noise intensity introduced to the input image, where a value of 1.0 completely erases the original image's details. Available for img2img and inpainting. (within [0.01, 1.0], default: 0.75) */
    strength?: number;
    /** The model id to use for the inference */
    modelId: string;
    /** The type of IP Adapter model to use. Must be one of [`style`, `character`], default to `style`` */
    ipAdapterType?: "character" | "style";
    /** Deprecated for type txt2img-ip-adapter and img2img-ip-adapter, use `ipAdapterImages` instead.
        The IpAdapter image as a data url. Will be ignored if the `ipAdapterImages` parameter is provided. */
    ipAdapterImage?: string;
    /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
    scheduler?:
      | "DDIMScheduler"
      | "DDPMScheduler"
      | "DEISMultistepScheduler"
      | "DPMSolverMultistepScheduler"
      | "DPMSolverSinglestepScheduler"
      | "EulerAncestralDiscreteScheduler"
      | "EulerDiscreteScheduler"
      | "HeunDiscreteScheduler"
      | "KDPM2AncestralDiscreteScheduler"
      | "KDPM2DiscreteScheduler"
      | "LCMScheduler"
      | "LMSDiscreteScheduler"
      | "PNDMScheduler"
      | "TCDScheduler"
      | "UniPCMultistepScheduler";
    /** The IpAdapter images as a data url. */
    ipAdapterImages?: string[];
    /** Specifies the parent asset Id for the image when provided as a dataurl. */
    imageParentId?: string;
    /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
        Allowed values are available in the model's attribute: `compliantModelIds` */
    baseModelId?: string;
    /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
        If model.type is `sd-1_5`, the height must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
    height?: number;
    /** Toggles the hidden status of the image when provided as a dataurl. */
    imageHide?: boolean;
    /** The mask as a data URL, used to determine the area of change. The mask is a binary mask made out of white and black pixels. The white area is the one that will be replaced. (example: "data:image/png;base64,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") */
    mask?: string;
    /** The input image as a data URL (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=") or the asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
    image?: string;
    /** Deprecated: The input image as an AssetId. Prefer to use image with the asset ID instead. */
    imageId?: string;
    /** Deprecated for type txt2img-ip-adapter and img2img-ip-adapter, use `ipAdapterImageIds` instead.
        The IpAdapter image as an AssetId. Cannot be set if `ipAdapterImage` is provided. Will be ignored if the `ipAdapterImageIds` parameter is provided. */
    ipAdapterImageId?: string;
    /** Deprecated for type txt2img-ip-adapter and img2img-ip-adapter, use `ipAdapterScales` instead.
        IpAdapter scale factor (within [0.0, 1.0], default: 0.9). Will be ignored if the `ipAdapterScales` parameter is provided */
    ipAdapterScale?: number;
    /** If set, generated assets will be hidden and not returned in the list of images of the inference
        or when listing assets (default: false) */
    hideResults?: boolean;
    /** IpAdapter scale factors (within [0.0, 1.0], default: 0.9). */
    ipAdapterScales?: number[];
    /** The mask as an AssetId. Will be ignored if the `image` parameter is provided */
    maskId?: string;
    /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
    negativePrompt?: string;
    /** Enable or disable the intermediate images generation (default: false) */
    intermediateImages?: boolean;
    concepts?: {
      /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
      modelId: string;
      /** The scale of the model (example: 1.0) */
      scale: number;
    }[];
    /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
    guidance?: number;
    /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
    numInferenceSteps?: number;
    /** The number of images to generate (within [1, 128], default: 4) */
    numSamples?: number;
    /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
        If model.type is `sd-1_5`, the width must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
    width?: number;
    /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
    prompt: string;
  };
};
export type PostImg2ImgTextureInferencesApiResponse =
  /** status 200 200 response */
  | {
      creativeUnitsCost?: number;
      inference: {
        /** Signed URL to display the input image */
        image: string;
        /** Asset id of the input image */
        imageId: string;
        /** Used to reproduce previous results. Default: randomly generated number. */
        seed?: string;
        /** Controls the noise intensity introduced to the input image, where a value of 1.0 completely erases the original image's details. Available for img2img and inpainting. (within [0.01, 1.0], default: 0.75) */
        strength?: number;
        /** If set, generated assets will be hidden and not returned in the list of images of the inference
        or when listing assets (default: false) */
        hideResults?: boolean;
        /** Asset id of the mask image */
        maskId?: string;
        /** The type of inference to use. Example: txt2img, img2img, etc.
        
        Selecting the right type will condition the expected parameters.
        
        Note: if model.type is `sd-xl*` or `sd-1_5*`, when using the `"inpaint"` inference type, Scenario determines the best available `baseModel` for a given `modelId`: one of `["stable-diffusion-inpainting", "stable-diffusion-xl-1.0-inpainting-0.1"] will be used. */
        type:
          | "txt2img"
          | "txt2img_ip_adapter"
          | "txt2img_texture"
          | "img2img"
          | "img2img_ip_adapter"
          | "img2img_texture"
          | "inpaint"
          | "outpaint"
          | "inpaint_ip_adapter"
          | "controlnet"
          | "controlnet_ip_adapter"
          | "reference"
          | "reference_texture"
          | "controlnet_reference"
          | "controlnet_img2img"
          | "controlnet_inpaint"
          | "controlnet_inpaint_ip_adapter"
          | "controlnet_texture";
        /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
        negativePrompt?: string;
        /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
        scheduler?:
          | "DDIMScheduler"
          | "DDPMScheduler"
          | "DEISMultistepScheduler"
          | "DPMSolverMultistepScheduler"
          | "DPMSolverSinglestepScheduler"
          | "EulerAncestralDiscreteScheduler"
          | "EulerDiscreteScheduler"
          | "HeunDiscreteScheduler"
          | "KDPM2AncestralDiscreteScheduler"
          | "KDPM2DiscreteScheduler"
          | "LCMScheduler"
          | "LMSDiscreteScheduler"
          | "PNDMScheduler"
          | "TCDScheduler"
          | "UniPCMultistepScheduler";
        /** Enable or disable the intermediate images generation (default: false) */
        intermediateImages?: boolean;
        concepts?: {
          /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
          modelId: string;
          /** The scale of the model (example: 1.0) */
          scale: number;
        }[];
        /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
        guidance?: number;
        /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
        numInferenceSteps?: number;
        /** The number of images to generate (within [1, 128], default: 4) */
        numSamples?: number;
        /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
        If model.type is `sd-1_5`, the width must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        width?: number;
        /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
        Allowed values are available in the model's attribute: `compliantModelIds` */
        baseModelId?: string;
        /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
        prompt: string;
        /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
        If model.type is `sd-1_5`, the height must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        height?: number;
        /** Signed URL to display the mask image */
        mask?: string;
      };
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostImg2ImgTextureInferencesApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The input image as a data URL (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=") or the asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
    image?: string;
    /** Deprecated: The input image as an AssetId. Prefer to use image with the asset ID instead. */
    imageId?: string;
    /** Used to reproduce previous results. Default: randomly generated number. */
    seed?: string;
    /** Controls the noise intensity introduced to the input image, where a value of 1.0 completely erases the original image's details. Available for img2img and inpainting. (within [0.01, 1.0], default: 0.75) */
    strength?: number;
    /** The model id to use for the inference */
    modelId: string;
    /** If set, generated assets will be hidden and not returned in the list of images of the inference
        or when listing assets (default: false) */
    hideResults?: boolean;
    /** The mask as an AssetId. Will be ignored if the `image` parameter is provided */
    maskId?: string;
    /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
    negativePrompt?: string;
    /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
    scheduler?:
      | "DDIMScheduler"
      | "DDPMScheduler"
      | "DEISMultistepScheduler"
      | "DPMSolverMultistepScheduler"
      | "DPMSolverSinglestepScheduler"
      | "EulerAncestralDiscreteScheduler"
      | "EulerDiscreteScheduler"
      | "HeunDiscreteScheduler"
      | "KDPM2AncestralDiscreteScheduler"
      | "KDPM2DiscreteScheduler"
      | "LCMScheduler"
      | "LMSDiscreteScheduler"
      | "PNDMScheduler"
      | "TCDScheduler"
      | "UniPCMultistepScheduler";
    /** Enable or disable the intermediate images generation (default: false) */
    intermediateImages?: boolean;
    concepts?: {
      /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
      modelId: string;
      /** The scale of the model (example: 1.0) */
      scale: number;
    }[];
    /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
    guidance?: number;
    /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
    numInferenceSteps?: number;
    /** The number of images to generate (within [1, 128], default: 4) */
    numSamples?: number;
    /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
        If model.type is `sd-1_5`, the width must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
    width?: number;
    /** Specifies the parent asset Id for the image when provided as a dataurl. */
    imageParentId?: string;
    /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
        Allowed values are available in the model's attribute: `compliantModelIds` */
    baseModelId?: string;
    /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
    prompt: string;
    /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
        If model.type is `sd-1_5`, the height must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
    height?: number;
    /** Toggles the hidden status of the image when provided as a dataurl. */
    imageHide?: boolean;
    /** The mask as a data URL, used to determine the area of change. The mask is a binary mask made out of white and black pixels. The white area is the one that will be replaced. (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAMAAADDpiTIAAABiVBMVEUAAADw8PDCwsLExMT5+fn19fX8/Pz////+/v79/f2hoaH6+vrc3NxnZ2dDQ0P4+PhkZGTs7OzOzs6Ojo709PRiYmLd3d1paWkoKCji4uI9PT3n5+fe3t7z8/NISEiysrLg4ODk5OSYmJh/f3/u7u5lZWVRUVHS0tKIiIg+Pj7p6emXl5dUVFQYGBjKysqtra1TU1PT09M8PDwcHBzR0dHq6uoEBAQmJiZ8fHzm5ub7+/swMDCrq6uKioqpqalHR0c3NzdOTk6BgYF7e3uwsLCAgIB3d3empqaNjY06OjrW1tZhYWG0tLQgICBxcXEICAhPT0/o6OgkJCRzc3N5eXnV1dXj4+NKSkobGxtaWlpfX1/a2trBwcF2dnYlJSV9fX3Hx8eSkpJNTU1sbGyWlpYRERGCgoIMDAzPz8+MjIy4uLiTk5PNzc3X19cxMTGDg4MpKSm8vLxGRkavr69QUFAKCgoqKiq2trbt7e329vaGhobl5eVra2tZWVk4ODgzMzNcXFyurq63t7dzhmTOAAAFeElEQVR4nO3dZXMUaRQF4EBIOgkQdFncFhZfZPF1d3d3d3f95TthC6iQTE9kuk+Y93m+MpW6t8+p7mGkZ2gIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACK8MDyR784eTw9BRkj1RU70rPQuvFqmjXpeWjVPdUMn6VnokUz86+qjemhaM3obAWoqvRYtGX2/DWgFA93K8DK9GS0Yku3AlTr06PRht+6FqB6Mj0bLVjfvQCeBpRgb00BRtLD0YKaAjgFlKCuAF4ULsAKp4CyHakrgLcGC1BXAKeAAihA4cbqCnAyPR2N211XgNH0dDRup2tA4RSgcLUFOJaejsbVFuC59HQ0bltdAW5KT0fjVtcV4GB6OppXV4C30sPRvLoCHE0PR/PqCvBEejiaV1eA9Gy0QAEKV5P/WHo2WlBTgHXp2WhBTQFuSM9GCzwFKNv3ngKU7WL3ApxOz0YLXAHKNqwAZavJf0V6NlpQU4Bd6dloXpd7BLkClKImfwUogO+Glu3VuvwVYPDV5q8AA2+lAhTtVH3+CjDoeuRf3ZgekEYt61WAi+kJaVLt98JdAwbe/b3z14ABdn4u+VfVY+k5acbNc8u/qjalJ6UJd881/47t6WHpu2PzyL/yCzID56755T/llvTM9M8H88+/Y5+XhQbE2QXlP2XVg5/cfnrPmvHLtxYcG3nhu+dXp/dhfmpvCLIw4+mdmLtn+59/xzPptZirRvL3AeLrRkP5uwxcJxrL3y8MLSVP/XHr7P/QYP5VtbbdJelm/7RYduza+ebXmzdfakSj+XvrcIn4tOGYu9uQXp2O92P5u5vAUjDnt3mbkF6exi/z9X5Mb89r0QLcl16faP7uLR9X+1XP5qXXJ5u/AqT1/KZHs35J71+8bP5OAGl7svn/nd6/eNn8t6TXJ5r/4fT27Evm/1N6e6InALeVXwKC+b+c3p2h8FOA29Lbc2+0ANXe9P7FO5MtQPVN+gCULpx/VQ2nj0Dh0vl7KTgsHb/vhoSl46+cArLS6XcsTx+Dkv2QTr/jxfRBKNnT6fQ7VqUPQsneS6dfuZ9Y1IZ0+h3b0gehZHU//9eWC+mDULLwB0Iv8b+AoLHe+TQufQyKlg6/8kpgVjr9ygkgK51+Vd2ZPgRlS8dffZ4+AoVL5+9u0mHh/Hem9y9eMv0xNxLPG0k2IL08Q0PLkwXwCkBe9s2gX9PrcyJaABeBvGwBjqfXJ1sAp4A4BShc+BZxbhaf9ki2AI+n9ydbgNfT65MtwD/p9fk5WoAP0+uTPQVsTm9PtgDp5cm+H3QmvTxD0VNAenWmrIvlfzC9OpeE4h87ml6c/2XuF74svTZXBOIfOZVemqv29w6sv/79KL0y00y0m/+59L5ca0u7DUivywyrekQ2+vGhPj5VWJdelxkOdAtrbNvE5ceM960ByU2Z3UMzY1q56cj0x1xQgEG26WpA4wfWfjnrY/p0SxG/FbI0vTP1EcHDq7fWPOTtvhTgfGsr0Xf9uLHUV+klWIQ/F38deCO9A4uz2E+TH0ovwGIt7ovl6enpg4nRBefvi+EDYniBLw29lB6cvhlewNMBN4gfMOcmT9yxfe4XhInef5Hr0dmtk5NbJ799Ze36uvg3/pWek+btXdkl/jW/p0ejLbuufXYwtvvd9EwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPfwHLuRXafg0SKQAAAAASUVORK5CYII=") */
    mask?: string;
  };
};
export type PostInpaintInferencesApiResponse =
  /** status 200 200 response */
  | {
      creativeUnitsCost?: number;
      inference: {
        /** Signed URL to display the input image */
        image: string;
        /** Asset id of the input image */
        imageId: string;
        /** Used to reproduce previous results. Default: randomly generated number. */
        seed?: string;
        /** Controls the noise intensity introduced to the input image, where a value of 1.0 completely erases the original image's details. Available for img2img and inpainting. (within [0.01, 1.0], default: 0.75) */
        strength?: number;
        /** If set, generated assets will be hidden and not returned in the list of images of the inference
        or when listing assets (default: false) */
        hideResults?: boolean;
        /** Asset id of the mask image */
        maskId: string;
        /** The type of inference to use. Example: txt2img, img2img, etc.
        
        Selecting the right type will condition the expected parameters.
        
        Note: if model.type is `sd-xl*` or `sd-1_5*`, when using the `"inpaint"` inference type, Scenario determines the best available `baseModel` for a given `modelId`: one of `["stable-diffusion-inpainting", "stable-diffusion-xl-1.0-inpainting-0.1"] will be used. */
        type:
          | "txt2img"
          | "txt2img_ip_adapter"
          | "txt2img_texture"
          | "img2img"
          | "img2img_ip_adapter"
          | "img2img_texture"
          | "inpaint"
          | "outpaint"
          | "inpaint_ip_adapter"
          | "controlnet"
          | "controlnet_ip_adapter"
          | "reference"
          | "reference_texture"
          | "controlnet_reference"
          | "controlnet_img2img"
          | "controlnet_inpaint"
          | "controlnet_inpaint_ip_adapter"
          | "controlnet_texture";
        /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
        negativePrompt?: string;
        /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
        scheduler?:
          | "DDIMScheduler"
          | "DDPMScheduler"
          | "DEISMultistepScheduler"
          | "DPMSolverMultistepScheduler"
          | "DPMSolverSinglestepScheduler"
          | "EulerAncestralDiscreteScheduler"
          | "EulerDiscreteScheduler"
          | "HeunDiscreteScheduler"
          | "KDPM2AncestralDiscreteScheduler"
          | "KDPM2DiscreteScheduler"
          | "LCMScheduler"
          | "LMSDiscreteScheduler"
          | "PNDMScheduler"
          | "TCDScheduler"
          | "UniPCMultistepScheduler";
        /** Enable or disable the intermediate images generation (default: false) */
        intermediateImages?: boolean;
        concepts?: {
          /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
          modelId: string;
          /** The scale of the model (example: 1.0) */
          scale: number;
        }[];
        /** If set to true, the entire input image will likely change during inpainting. This results in faster inferences, but the output image will be harder to integrate if the input is just a small part of a larger image. */
        disableMerging?: boolean;
        /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
        guidance?: number;
        /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
        numInferenceSteps?: number;
        /** The number of images to generate (within [1, 128], default: 4) */
        numSamples?: number;
        /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
        If model.type is `sd-1_5`, the width must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        width?: number;
        /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
        Allowed values are available in the model's attribute: `compliantModelIds` */
        baseModelId?: string;
        /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
        prompt: string;
        /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
        If model.type is `sd-1_5`, the height must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        height?: number;
        /** Signed URL to display the mask image */
        mask: string;
      };
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostInpaintInferencesApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The input image as a data URL (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=") or the asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
    image?: string;
    /** Deprecated: The input image as an AssetId. Prefer to use image with the asset ID instead. */
    imageId?: string;
    /** Used to reproduce previous results. Default: randomly generated number. */
    seed?: string;
    /** Controls the noise intensity introduced to the input image, where a value of 1.0 completely erases the original image's details. Available for img2img and inpainting. (within [0.01, 1.0], default: 0.75) */
    strength?: number;
    /** The model id to use for the inference */
    modelId: string;
    /** If set, generated assets will be hidden and not returned in the list of images of the inference
        or when listing assets (default: false) */
    hideResults?: boolean;
    /** The mask as an AssetId. Will be ignored if the `image` parameter is provided */
    maskId?: string;
    /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
    negativePrompt?: string;
    /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
    scheduler?:
      | "DDIMScheduler"
      | "DDPMScheduler"
      | "DEISMultistepScheduler"
      | "DPMSolverMultistepScheduler"
      | "DPMSolverSinglestepScheduler"
      | "EulerAncestralDiscreteScheduler"
      | "EulerDiscreteScheduler"
      | "HeunDiscreteScheduler"
      | "KDPM2AncestralDiscreteScheduler"
      | "KDPM2DiscreteScheduler"
      | "LCMScheduler"
      | "LMSDiscreteScheduler"
      | "PNDMScheduler"
      | "TCDScheduler"
      | "UniPCMultistepScheduler";
    /** Enable or disable the intermediate images generation (default: false) */
    intermediateImages?: boolean;
    concepts?: {
      /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
      modelId: string;
      /** The scale of the model (example: 1.0) */
      scale: number;
    }[];
    /** If set to true, the entire input image will likely change during inpainting. This results in faster inferences, but the output image will be harder to integrate if the input is just a small part of a larger image. */
    disableMerging?: boolean;
    /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
    guidance?: number;
    /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
    numInferenceSteps?: number;
    /** The number of images to generate (within [1, 128], default: 4) */
    numSamples?: number;
    /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
        If model.type is `sd-1_5`, the width must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
    width?: number;
    /** Specifies the parent asset Id for the image when provided as a dataurl. */
    imageParentId?: string;
    /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
        Allowed values are available in the model's attribute: `compliantModelIds` */
    baseModelId?: string;
    /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
    prompt: string;
    /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
        If model.type is `sd-1_5`, the height must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
    height?: number;
    /** Toggles the hidden status of the image when provided as a dataurl. */
    imageHide?: boolean;
    /** The mask as a data URL, used to determine the area of change. The mask is a binary mask made out of white and black pixels. The white area is the one that will be replaced. (example: "data:image/png;base64,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") */
    mask?: string;
  };
};
export type PostInpaintIpAdapterInferencesApiResponse =
  /** status 200 200 response */
  | {
      creativeUnitsCost?: number;
      inference: {
        /** Asset id of the input IpAdapter images */
        ipAdapterImageIds?: string[];
        /** Used to reproduce previous results. Default: randomly generated number. */
        seed?: string;
        /** Controls the noise intensity introduced to the input image, where a value of 1.0 completely erases the original image's details. Available for img2img and inpainting. (within [0.01, 1.0], default: 0.75) */
        strength?: number;
        /** The type of IP Adapter model to use. Must be one of [`style`, `character`], default to `style`` */
        ipAdapterType?: "character" | "style";
        /** The type of inference to use. Example: txt2img, img2img, etc.
        
        Selecting the right type will condition the expected parameters.
        
        Note: if model.type is `sd-xl*` or `sd-1_5*`, when using the `"inpaint"` inference type, Scenario determines the best available `baseModel` for a given `modelId`: one of `["stable-diffusion-inpainting", "stable-diffusion-xl-1.0-inpainting-0.1"] will be used. */
        type:
          | "txt2img"
          | "txt2img_ip_adapter"
          | "txt2img_texture"
          | "img2img"
          | "img2img_ip_adapter"
          | "img2img_texture"
          | "inpaint"
          | "outpaint"
          | "inpaint_ip_adapter"
          | "controlnet"
          | "controlnet_ip_adapter"
          | "reference"
          | "reference_texture"
          | "controlnet_reference"
          | "controlnet_img2img"
          | "controlnet_inpaint"
          | "controlnet_inpaint_ip_adapter"
          | "controlnet_texture";
        /** Signed URL to display the IpAdapter image */
        ipAdapterImage?: string;
        /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
        scheduler?:
          | "DDIMScheduler"
          | "DDPMScheduler"
          | "DEISMultistepScheduler"
          | "DPMSolverMultistepScheduler"
          | "DPMSolverSinglestepScheduler"
          | "EulerAncestralDiscreteScheduler"
          | "EulerDiscreteScheduler"
          | "HeunDiscreteScheduler"
          | "KDPM2AncestralDiscreteScheduler"
          | "KDPM2DiscreteScheduler"
          | "LCMScheduler"
          | "LMSDiscreteScheduler"
          | "PNDMScheduler"
          | "TCDScheduler"
          | "UniPCMultistepScheduler";
        /** If set to true, the entire input image will likely change during inpainting. This results in faster inferences, but the output image will be harder to integrate if the input is just a small part of a larger image. */
        disableMerging?: boolean;
        /** Signed URL to display the IpAdapter images */
        ipAdapterImages?: string[];
        /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
        Allowed values are available in the model's attribute: `compliantModelIds` */
        baseModelId?: string;
        /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
        If model.type is `sd-1_5`, the height must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        height?: number;
        /** Signed URL to display the mask image */
        mask: string;
        /** Signed URL to display the input image */
        image: string;
        /** Asset id of the input image */
        imageId: string;
        /** Asset id of the input IpAdapter image */
        ipAdapterImageId?: string;
        /** IpAdapter scale factor (within [0.0, 1.0], default: 0.9). */
        ipAdapterScale?: number;
        /** If set, generated assets will be hidden and not returned in the list of images of the inference
        or when listing assets (default: false) */
        hideResults?: boolean;
        /** IpAdapter scale factors (within [0.0, 1.0], default: 0.9). */
        ipAdapterScales?: number[];
        /** Asset id of the mask image */
        maskId: string;
        /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
        negativePrompt?: string;
        /** Enable or disable the intermediate images generation (default: false) */
        intermediateImages?: boolean;
        concepts?: {
          /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
          modelId: string;
          /** The scale of the model (example: 1.0) */
          scale: number;
        }[];
        /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
        guidance?: number;
        /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
        numInferenceSteps?: number;
        /** The number of images to generate (within [1, 128], default: 4) */
        numSamples?: number;
        /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
        If model.type is `sd-1_5`, the width must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        width?: number;
        /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
        prompt: string;
      };
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostInpaintIpAdapterInferencesApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The IpAdapter images as an AssetId. Will be ignored if the `ipAdapterImages` parameter is provided */
    ipAdapterImageIds?: string[];
    /** Used to reproduce previous results. Default: randomly generated number. */
    seed?: string;
    /** Controls the noise intensity introduced to the input image, where a value of 1.0 completely erases the original image's details. Available for img2img and inpainting. (within [0.01, 1.0], default: 0.75) */
    strength?: number;
    /** The model id to use for the inference */
    modelId: string;
    /** The type of IP Adapter model to use. Must be one of [`style`, `character`], default to `style`` */
    ipAdapterType?: "character" | "style";
    /** Deprecated for type txt2img-ip-adapter and img2img-ip-adapter, use `ipAdapterImages` instead.
        The IpAdapter image as a data url. Will be ignored if the `ipAdapterImages` parameter is provided. */
    ipAdapterImage?: string;
    /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
    scheduler?:
      | "DDIMScheduler"
      | "DDPMScheduler"
      | "DEISMultistepScheduler"
      | "DPMSolverMultistepScheduler"
      | "DPMSolverSinglestepScheduler"
      | "EulerAncestralDiscreteScheduler"
      | "EulerDiscreteScheduler"
      | "HeunDiscreteScheduler"
      | "KDPM2AncestralDiscreteScheduler"
      | "KDPM2DiscreteScheduler"
      | "LCMScheduler"
      | "LMSDiscreteScheduler"
      | "PNDMScheduler"
      | "TCDScheduler"
      | "UniPCMultistepScheduler";
    /** If set to true, the entire input image will likely change during inpainting. This results in faster inferences, but the output image will be harder to integrate if the input is just a small part of a larger image. */
    disableMerging?: boolean;
    /** The IpAdapter images as a data url. */
    ipAdapterImages?: string[];
    /** Specifies the parent asset Id for the image when provided as a dataurl. */
    imageParentId?: string;
    /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
        Allowed values are available in the model's attribute: `compliantModelIds` */
    baseModelId?: string;
    /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
        If model.type is `sd-1_5`, the height must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
    height?: number;
    /** Toggles the hidden status of the image when provided as a dataurl. */
    imageHide?: boolean;
    /** The mask as a data URL, used to determine the area of change. The mask is a binary mask made out of white and black pixels. The white area is the one that will be replaced. (example: "data:image/png;base64,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") */
    mask?: string;
    /** The input image as a data URL (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=") or the asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
    image?: string;
    /** Deprecated: The input image as an AssetId. Prefer to use image with the asset ID instead. */
    imageId?: string;
    /** Deprecated for type txt2img-ip-adapter and img2img-ip-adapter, use `ipAdapterImageIds` instead.
        The IpAdapter image as an AssetId. Cannot be set if `ipAdapterImage` is provided. Will be ignored if the `ipAdapterImageIds` parameter is provided. */
    ipAdapterImageId?: string;
    /** Deprecated for type txt2img-ip-adapter and img2img-ip-adapter, use `ipAdapterScales` instead.
        IpAdapter scale factor (within [0.0, 1.0], default: 0.9). Will be ignored if the `ipAdapterScales` parameter is provided */
    ipAdapterScale?: number;
    /** If set, generated assets will be hidden and not returned in the list of images of the inference
        or when listing assets (default: false) */
    hideResults?: boolean;
    /** IpAdapter scale factors (within [0.0, 1.0], default: 0.9). */
    ipAdapterScales?: number[];
    /** The mask as an AssetId. Will be ignored if the `image` parameter is provided */
    maskId?: string;
    /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
    negativePrompt?: string;
    /** Enable or disable the intermediate images generation (default: false) */
    intermediateImages?: boolean;
    concepts?: {
      /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
      modelId: string;
      /** The scale of the model (example: 1.0) */
      scale: number;
    }[];
    /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
    guidance?: number;
    /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
    numInferenceSteps?: number;
    /** The number of images to generate (within [1, 128], default: 4) */
    numSamples?: number;
    /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
        If model.type is `sd-1_5`, the width must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
    width?: number;
    /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
    prompt: string;
  };
};
export type PostPatchInferencesApiResponse =
  /** status 200 200 response */
  | {
      asset?: {
        /** Metadata of the asset with some additional information */
        metadata: {
          maxIterations?: number;
          /** Modality to detect */
          modality?:
            | "canny"
            | "depth"
            | "grayscale"
            | "lineart_anime"
            | "mlsd"
            | "normal"
            | "pose"
            | "scribble"
            | "segmentation"
            | "sketch";
          /** If set to true, during the upscaling process, the model will match tiles of the source image with tiles of the style image(s). This will result in a more coherent restyle. Works best with style images that have a similar composition. */
          tileStyle?: boolean;
          /** The modelId used to generate this asset */
          modelId?: string;
          /** A bounding box around the object of interest, in the format [x1, y1, x2, y2]. */
          bbox?: any[];
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          keypointThreshold?: number;
          /** The type of the asset. Ex: 'inference-txt2img' will represent an asset generated from a text to image model */
          type:
            | "background-removal"
            | "canvas"
            | "canvas-drawing"
            | "canvas-export"
            | "detection"
            | "generative-fill"
            | "image-prompt-editing"
            | "img23d-custom"
            | "img2img-custom"
            | "img2video-custom"
            | "inference-controlnet"
            | "inference-controlnet-img2img"
            | "inference-controlnet-inpaint"
            | "inference-controlnet-inpaint-ip-adapter"
            | "inference-controlnet-ip-adapter"
            | "inference-controlnet-reference"
            | "inference-controlnet-texture"
            | "inference-img2img"
            | "inference-img2img-ip-adapter"
            | "inference-img2img-texture"
            | "inference-inpaint"
            | "inference-inpaint-ip-adapter"
            | "inference-reference"
            | "inference-reference-texture"
            | "inference-txt2img"
            | "inference-txt2img-ip-adapter"
            | "inference-txt2img-texture"
            | "patch"
            | "pixelization"
            | "reframe"
            | "restyle"
            | "segment"
            | "segmentation-image"
            | "segmentation-mask"
            | "skybox-base-360"
            | "texture"
            | "texture-albedo"
            | "texture-ao"
            | "texture-edge"
            | "texture-height"
            | "texture-metallic"
            | "texture-normal"
            | "texture-smoothness"
            | "txt23d-custom"
            | "txt2audio-custom"
            | "txt2img-custom"
            | "unknown-custom"
            | "uploaded"
            | "upscale"
            | "upscale-skybox"
            | "upscale-texture"
            | "vectorization"
            | "video2video-custom";
          /** A textual description / keywords describing the object of interest. */
          text?: string;
          height?: number;
          nbMasks?: number;
          /** Amount of decay in creativity over the upscale process. The lowest the value, the less the creativity will be preserved over the upscale process. */
          creativityDecay?: number;
          layerDifference?: number;
          /** Scaling factor (when `targetWidth` not specified) */
          scalingFactor?: number;
          /** The type of the generator used */
          modelType?:
            | "custom"
            | "flux.1"
            | "flux.1-composition"
            | "flux.1-lora"
            | "flux.1-pro"
            | "flux.1.1-pro-ultra"
            | "flux1.1-pro"
            | "gpt-image-1"
            | "sd-1_5"
            | "sd-1_5-composition"
            | "sd-1_5-lora"
            | "sd-xl"
            | "sd-xl-composition"
            | "sd-xl-lora";
          /** The number of outputs to generate. */
          numOutputs?: number;
          /** How angular is the surface? 0 is like a sphere, 1 is like a mechanical object */
          angular?: number;
          /** The target height of the output image. */
          targetHeight?: number;
          /** Flux LoRa or Composition to style the image. */
          concepts?: {
            weightName: string;
            /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
            modelId: string;
            /** The scale of the model (example: 1.0) */
            scale: number;
          }[];
          size?: number;
          spliceThreshold?: number;
          /** The number of pixels to dilate the result masks. */
          dilate?: number;
          style?:
            | "3d-cartoon"
            | "3d-rendered"
            | "anime"
            | "cartoon"
            | "cinematic"
            | "claymation"
            | "cloud-skydome"
            | "comic"
            | "cyberpunk"
            | "enchanted"
            | "fantasy"
            | "ink"
            | "manga"
            | "manga-color"
            | "minimalist"
            | "neon-tron"
            | "oil-painting"
            | "pastel"
            | "photo"
            | "photography"
            | "psychedelic"
            | "retro-fantasy"
            | "scifi-concept-art"
            | "space"
            | "standard"
            | "whimsical";
          /** Strengthen the similarity to the original image during the upscale. Default: optimized for your preset and style. */
          imageFidelity?: number;
          /** Location of the input image in the output. */
          inputLocation?: "bottom" | "left" | "middle" | "right" | "top";
          /** The seed used to generate this asset */
          seed?: string;
          /** The higher the value the more it will look like the secondary reference image(s) */
          secondaryRefFidelity?: number;
          preset?: string;
          trainingImage?: boolean;
          /** Boolean to able return the masks (binary image) in the response. */
          resultMask?: boolean;
          /** The ISO timestamp when the lock on the canvas will expire */
          lockExpiresAt?: string;
          /** The baseModelId that maybe changed at inference time */
          baseModelId?: string;
          pathPrecision?: number;
          rootParentId?: string;
          /** Sharpen tiles. */
          sharpen?: boolean;
          cornerThreshold?: number;
          /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
          styleImages?: string[];
          /** The asset to convert in texture maps. Must reference an existing AssetId. */
          texture?: string;
          filterSpeckle?: number;
          /** Minimum threshold for Grayscale conversion */
          minThreshold?: number;
          /** Maximum threshold for Grayscale conversion */
          maxThreshold?: number;
          /** Condition the influence of the style image(s). The higher the value, the more the style images will influence the upscaled image. */
          styleImagesFidelity?: number;
          /** The control image processed by depth estimator. Must reference an existing AssetId. */
          depthImage?: string;
          parentId?: string;
          parentJobId?: string;
          /** Optional List of secondary style images. Example: portrait of people. It must be existing AssetIds. */
          secondaryRefImages?: string[];
          /** The width of the rendered image. */
          width?: number;
          /** The checkpoint to use */
          checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
          strength?: number;
          /** The id of the Inference describing how this image was generated */
          inferenceId?: string;
          lengthThreshold?: number;
          /** Int to set between 0 and 255 for the opacity of the background in the result images. */
          backgroundOpacity?: number;
          /** The optional aspect ratio given for the generation, only applicable for some models */
          aspectRatio?: string;
          /** Amount of details to remove or add */
          detailsLevel?: number;
          /** Determine the scale at which the upscale process works.
            - With a small value, the upscale works at the largest scale, resulting in fewer added details and more coherent images. Ideal for portraits, for example.
            - With a large value, the upscale works at the smallest scale, resulting in more added details and more hallucinations. Ideal for landscapes, for example.
            
            (info): A small value is slower and more expensive to run. */
          fractality?: number;
          /** (deprecated) Horizontal expansion ratio. */
          horizontalExpansionRatio?: number;
          /** List of points (label, x, y) in the image where label = 0 for background and 1 for object. */
          points?: any[][];
          mode?: string;
          colorPrecision?: number;
          /** Increase the fidelity to the prompt during upscale. Default: optimized for your preset and style. */
          promptFidelity?: number;
          /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
          betterQuality?: boolean;
          /** Remove background for Grayscale detector */
          removeBackground?: boolean;
          /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your preset and style. */
          creativity?: number;
          /** Strength for the input image structure preservation */
          structureFidelity?: number;
          /** Preserve the seamless properties of skybox or texture images. Input has to be of same type (seamless). */
          imageType?: "seamfull" | "skybox" | "texture";
          /** The input image to process. Must reference an existing AssetId or be a data URL. */
          image?: string;
          /** The thumbnail of the canvas */
          thumbnail?: {
            /** The AssetId of the image used as a thumbnail for the canvas (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
            assetId: string;
            /** The url of the image used as a thumbnail for the canvas */
            url: string;
          };
          /** The control image for structure. A canny detector will be applied to this image. Must reference an existing AssetId. */
          structureImage?: string;
          /** To invert the relief */
          invert?: boolean;
          kind: "3d" | "audio" | "document" | "image" | "json" | "video";
          colorMode?: string;
          /** High threshold for Canny detector */
          highThreshold?: number;
          /** (deprecated) Vertical expansion ratio. */
          verticalExpansionRatio?: number;
          halfMode?: boolean;
          name?: string;
          /** Additional refinement steps before scaling.
            
            If scalingFactor == 1, the refinement process will be applied (1 + refinementSteps) times.
            If scalingFactor > 1, the refinement process will be applied refinementSteps times. */
          refinementSteps?: number;
          /** The reference images used for the image generation or editing */
          referenceImages?: string[];
          /** The higher the value the more it will look like the style image(s) */
          styleFidelity?: number;
          /** Boolean to output the contours. */
          resultContours?: boolean;
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          polished?: number;
          /** The scheduler used to generate this asset */
          scheduler?: string;
          /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
          overrideEmbeddings?: boolean;
          progressPercent?: number;
          /** Contrast factor for Grayscale detector */
          factor?: number;
          /** The mask used for the image generation or editing */
          mask?: string;
          /** Low threshold for Canny detector */
          lowThreshold?: number;
          /** The depth fidelity if a depth image provided */
          depthFidelity?: number;
          /** How raised is the surface? 0 is flat like water, 1 is like a very rough rock */
          raised?: number;
          message?: string;
          contours?: number[][][][];
          /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
          negativePrompt?: string;
          /** If true, use the default parameters */
          defaultParameters?: boolean;
          /** Size proportion of the input image in the output. */
          resizeOption?: number;
          outputIndex?: number;
          /** Save a flipbook of the texture. Deactivated when the input texture is larger than 2048x2048px */
          saveFlipbook?: boolean;
          /** The guidance used to generate this asset */
          guidance?: number;
          /** The number of denoising steps for each image generation. */
          numInferenceSteps?: number;
          hdr?: number;
          /** How shiny is the surface? 0 is like a matte surface, 1 is like a diamond */
          shiny?: number;
          /** Ensure upscaled tile have the same color histogram as original tile. */
          colorCorrection?: boolean;
          /** Overlap percentage for the output image. */
          overlapPercentage?: number;
          /** The prompt that guided the image generation or editing */
          prompt?: string;
          /** Boolean to able output the cut out object. */
          resultImage?: boolean;
          /** The control image already processed by canny detector. Must reference an existing AssetId. */
          cannyStructureImage?: string;
          /** Apply extra control to the Skybox 360 geometry.
            The higher the value, the more the 360 geometry will influence the generated skybox image.
            
            Use with caution. Default is adapted to the other parameters. */
          geometryEnforcement?: number;
          /** Target width for the upscaled image, take priority over scaling factor */
          targetWidth?: number;
        };
        /** The NSFW labels */
        nsfw?: string[];
        /** Automatic captioning of the asset */
        automaticCaptioning?: string;
        /** The description of the asset */
        description?: string;
        /** The privacy of the asset */
        privacy: "private" | "public" | "unlisted";
        /** The date when the asset will be soft deleted (only for Free plan) */
        softDeletionOn?: string;
        /** The mime type of the asset (example: "image/png") */
        mimeType: string;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId: string;
        /** The owner (project) ID (example: "proj_23tlk332lkht3kl2" or "team_dlkhgs23tlk3hlkth32lkht3kl2" for old teams) */
        ownerId: string;
        /** Signed URL to get the asset content */
        url: string;
        /** The associated tags (example: ["sci-fi", "landscape"]) */
        tags: string[];
        /** The asset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The output index of the asset within the job
        This index is an positive integer that starts at 0
        It is used to differentiate between multiple outputs of the same job
        If the job has only one output, this index is 0
        This is only applicable for generations with: Flux, Skybox, Reframe at the moment */
        outputIndex?: number;
        /** A list of CollectionId this asset belongs to */
        collectionIds: string[];
        /** List of edit capabilities for the asset */
        editCapabilities: (
          | "DETECTION"
          | "GENERATIVE_FILL"
          | "PIXELATE"
          | "PROMPT_EDITING"
          | "REFINE"
          | "REFRAME"
          | "REMOVE_BACKGROUND"
          | "SEGMENTATION"
          | "UPSCALE"
          | "UPSCALE_360"
          | "VECTORIZATION"
        )[];
        /** The embedding of the asset when requested and asset can be embedded
        
        ie: Detection maps don't have embeddings */
        embedding?: number[];
        /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        id: string;
        /** The status of the asset */
        status: "error" | "pending" | "success";
        /** The asset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostPatchInferencesApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The image to be merged. */
    patch?: {
      /** The mode of merging the images: `override` or `erase`. */
      mode: "erase" | "override";
      /** The source of the image to be merged, in base64 format (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII="). */
      image: string;
    };
    /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") to vectorize. */
    image: string;
    /** The background color as an hexadecimal code (ex: "#FFFFFF"), an html color (ex: "red") or "transparent" if "format" is "png". Default to "white" */
    backgroundColor?: string;
    /** The output format. Default to "png" */
    format?: "jpeg" | "png";
    /** The position of the image to be merged. */
    position?: {
      /** The X position of the image to be merged, in pixels. */
      x: number;
      /** The Y position of the image to be merged, in pixels. */
      y: number;
    };
    /** Whether to allow the merged image to extend the size of the original (when x or y are negative or merged image is bigger) */
    allowOverflow?: boolean;
    /** The crop operation to apply to the image. Applied before any operation. For the backgroundColor: rgba, hex or named color are supported. */
    crop?: {
      backgroundColor?: string;
      top: number;
      left: number;
      width: number;
      height: number;
    };
  };
};
export type PostPixelateInferencesApiResponse =
  /** status 200 200 response */
  | {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost?: number;
      asset?: {
        /** Metadata of the asset with some additional information */
        metadata: {
          maxIterations?: number;
          /** Modality to detect */
          modality?:
            | "canny"
            | "depth"
            | "grayscale"
            | "lineart_anime"
            | "mlsd"
            | "normal"
            | "pose"
            | "scribble"
            | "segmentation"
            | "sketch";
          /** If set to true, during the upscaling process, the model will match tiles of the source image with tiles of the style image(s). This will result in a more coherent restyle. Works best with style images that have a similar composition. */
          tileStyle?: boolean;
          /** The modelId used to generate this asset */
          modelId?: string;
          /** A bounding box around the object of interest, in the format [x1, y1, x2, y2]. */
          bbox?: any[];
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          keypointThreshold?: number;
          /** The type of the asset. Ex: 'inference-txt2img' will represent an asset generated from a text to image model */
          type:
            | "background-removal"
            | "canvas"
            | "canvas-drawing"
            | "canvas-export"
            | "detection"
            | "generative-fill"
            | "image-prompt-editing"
            | "img23d-custom"
            | "img2img-custom"
            | "img2video-custom"
            | "inference-controlnet"
            | "inference-controlnet-img2img"
            | "inference-controlnet-inpaint"
            | "inference-controlnet-inpaint-ip-adapter"
            | "inference-controlnet-ip-adapter"
            | "inference-controlnet-reference"
            | "inference-controlnet-texture"
            | "inference-img2img"
            | "inference-img2img-ip-adapter"
            | "inference-img2img-texture"
            | "inference-inpaint"
            | "inference-inpaint-ip-adapter"
            | "inference-reference"
            | "inference-reference-texture"
            | "inference-txt2img"
            | "inference-txt2img-ip-adapter"
            | "inference-txt2img-texture"
            | "patch"
            | "pixelization"
            | "reframe"
            | "restyle"
            | "segment"
            | "segmentation-image"
            | "segmentation-mask"
            | "skybox-base-360"
            | "texture"
            | "texture-albedo"
            | "texture-ao"
            | "texture-edge"
            | "texture-height"
            | "texture-metallic"
            | "texture-normal"
            | "texture-smoothness"
            | "txt23d-custom"
            | "txt2audio-custom"
            | "txt2img-custom"
            | "unknown-custom"
            | "uploaded"
            | "upscale"
            | "upscale-skybox"
            | "upscale-texture"
            | "vectorization"
            | "video2video-custom";
          /** A textual description / keywords describing the object of interest. */
          text?: string;
          height?: number;
          nbMasks?: number;
          /** Amount of decay in creativity over the upscale process. The lowest the value, the less the creativity will be preserved over the upscale process. */
          creativityDecay?: number;
          layerDifference?: number;
          /** Scaling factor (when `targetWidth` not specified) */
          scalingFactor?: number;
          /** The type of the generator used */
          modelType?:
            | "custom"
            | "flux.1"
            | "flux.1-composition"
            | "flux.1-lora"
            | "flux.1-pro"
            | "flux.1.1-pro-ultra"
            | "flux1.1-pro"
            | "gpt-image-1"
            | "sd-1_5"
            | "sd-1_5-composition"
            | "sd-1_5-lora"
            | "sd-xl"
            | "sd-xl-composition"
            | "sd-xl-lora";
          /** The number of outputs to generate. */
          numOutputs?: number;
          /** How angular is the surface? 0 is like a sphere, 1 is like a mechanical object */
          angular?: number;
          /** The target height of the output image. */
          targetHeight?: number;
          /** Flux LoRa or Composition to style the image. */
          concepts?: {
            weightName: string;
            /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
            modelId: string;
            /** The scale of the model (example: 1.0) */
            scale: number;
          }[];
          size?: number;
          spliceThreshold?: number;
          /** The number of pixels to dilate the result masks. */
          dilate?: number;
          style?:
            | "3d-cartoon"
            | "3d-rendered"
            | "anime"
            | "cartoon"
            | "cinematic"
            | "claymation"
            | "cloud-skydome"
            | "comic"
            | "cyberpunk"
            | "enchanted"
            | "fantasy"
            | "ink"
            | "manga"
            | "manga-color"
            | "minimalist"
            | "neon-tron"
            | "oil-painting"
            | "pastel"
            | "photo"
            | "photography"
            | "psychedelic"
            | "retro-fantasy"
            | "scifi-concept-art"
            | "space"
            | "standard"
            | "whimsical";
          /** Strengthen the similarity to the original image during the upscale. Default: optimized for your preset and style. */
          imageFidelity?: number;
          /** Location of the input image in the output. */
          inputLocation?: "bottom" | "left" | "middle" | "right" | "top";
          /** The seed used to generate this asset */
          seed?: string;
          /** The higher the value the more it will look like the secondary reference image(s) */
          secondaryRefFidelity?: number;
          preset?: string;
          trainingImage?: boolean;
          /** Boolean to able return the masks (binary image) in the response. */
          resultMask?: boolean;
          /** The ISO timestamp when the lock on the canvas will expire */
          lockExpiresAt?: string;
          /** The baseModelId that maybe changed at inference time */
          baseModelId?: string;
          pathPrecision?: number;
          rootParentId?: string;
          /** Sharpen tiles. */
          sharpen?: boolean;
          cornerThreshold?: number;
          /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
          styleImages?: string[];
          /** The asset to convert in texture maps. Must reference an existing AssetId. */
          texture?: string;
          filterSpeckle?: number;
          /** Minimum threshold for Grayscale conversion */
          minThreshold?: number;
          /** Maximum threshold for Grayscale conversion */
          maxThreshold?: number;
          /** Condition the influence of the style image(s). The higher the value, the more the style images will influence the upscaled image. */
          styleImagesFidelity?: number;
          /** The control image processed by depth estimator. Must reference an existing AssetId. */
          depthImage?: string;
          parentId?: string;
          parentJobId?: string;
          /** Optional List of secondary style images. Example: portrait of people. It must be existing AssetIds. */
          secondaryRefImages?: string[];
          /** The width of the rendered image. */
          width?: number;
          /** The checkpoint to use */
          checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
          strength?: number;
          /** The id of the Inference describing how this image was generated */
          inferenceId?: string;
          lengthThreshold?: number;
          /** Int to set between 0 and 255 for the opacity of the background in the result images. */
          backgroundOpacity?: number;
          /** The optional aspect ratio given for the generation, only applicable for some models */
          aspectRatio?: string;
          /** Amount of details to remove or add */
          detailsLevel?: number;
          /** Determine the scale at which the upscale process works.
            - With a small value, the upscale works at the largest scale, resulting in fewer added details and more coherent images. Ideal for portraits, for example.
            - With a large value, the upscale works at the smallest scale, resulting in more added details and more hallucinations. Ideal for landscapes, for example.
            
            (info): A small value is slower and more expensive to run. */
          fractality?: number;
          /** (deprecated) Horizontal expansion ratio. */
          horizontalExpansionRatio?: number;
          /** List of points (label, x, y) in the image where label = 0 for background and 1 for object. */
          points?: any[][];
          mode?: string;
          colorPrecision?: number;
          /** Increase the fidelity to the prompt during upscale. Default: optimized for your preset and style. */
          promptFidelity?: number;
          /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
          betterQuality?: boolean;
          /** Remove background for Grayscale detector */
          removeBackground?: boolean;
          /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your preset and style. */
          creativity?: number;
          /** Strength for the input image structure preservation */
          structureFidelity?: number;
          /** Preserve the seamless properties of skybox or texture images. Input has to be of same type (seamless). */
          imageType?: "seamfull" | "skybox" | "texture";
          /** The input image to process. Must reference an existing AssetId or be a data URL. */
          image?: string;
          /** The thumbnail of the canvas */
          thumbnail?: {
            /** The AssetId of the image used as a thumbnail for the canvas (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
            assetId: string;
            /** The url of the image used as a thumbnail for the canvas */
            url: string;
          };
          /** The control image for structure. A canny detector will be applied to this image. Must reference an existing AssetId. */
          structureImage?: string;
          /** To invert the relief */
          invert?: boolean;
          kind: "3d" | "audio" | "document" | "image" | "json" | "video";
          colorMode?: string;
          /** High threshold for Canny detector */
          highThreshold?: number;
          /** (deprecated) Vertical expansion ratio. */
          verticalExpansionRatio?: number;
          halfMode?: boolean;
          name?: string;
          /** Additional refinement steps before scaling.
            
            If scalingFactor == 1, the refinement process will be applied (1 + refinementSteps) times.
            If scalingFactor > 1, the refinement process will be applied refinementSteps times. */
          refinementSteps?: number;
          /** The reference images used for the image generation or editing */
          referenceImages?: string[];
          /** The higher the value the more it will look like the style image(s) */
          styleFidelity?: number;
          /** Boolean to output the contours. */
          resultContours?: boolean;
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          polished?: number;
          /** The scheduler used to generate this asset */
          scheduler?: string;
          /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
          overrideEmbeddings?: boolean;
          progressPercent?: number;
          /** Contrast factor for Grayscale detector */
          factor?: number;
          /** The mask used for the image generation or editing */
          mask?: string;
          /** Low threshold for Canny detector */
          lowThreshold?: number;
          /** The depth fidelity if a depth image provided */
          depthFidelity?: number;
          /** How raised is the surface? 0 is flat like water, 1 is like a very rough rock */
          raised?: number;
          message?: string;
          contours?: number[][][][];
          /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
          negativePrompt?: string;
          /** If true, use the default parameters */
          defaultParameters?: boolean;
          /** Size proportion of the input image in the output. */
          resizeOption?: number;
          outputIndex?: number;
          /** Save a flipbook of the texture. Deactivated when the input texture is larger than 2048x2048px */
          saveFlipbook?: boolean;
          /** The guidance used to generate this asset */
          guidance?: number;
          /** The number of denoising steps for each image generation. */
          numInferenceSteps?: number;
          hdr?: number;
          /** How shiny is the surface? 0 is like a matte surface, 1 is like a diamond */
          shiny?: number;
          /** Ensure upscaled tile have the same color histogram as original tile. */
          colorCorrection?: boolean;
          /** Overlap percentage for the output image. */
          overlapPercentage?: number;
          /** The prompt that guided the image generation or editing */
          prompt?: string;
          /** Boolean to able output the cut out object. */
          resultImage?: boolean;
          /** The control image already processed by canny detector. Must reference an existing AssetId. */
          cannyStructureImage?: string;
          /** Apply extra control to the Skybox 360 geometry.
            The higher the value, the more the 360 geometry will influence the generated skybox image.
            
            Use with caution. Default is adapted to the other parameters. */
          geometryEnforcement?: number;
          /** Target width for the upscaled image, take priority over scaling factor */
          targetWidth?: number;
        };
        /** The NSFW labels */
        nsfw?: string[];
        /** Automatic captioning of the asset */
        automaticCaptioning?: string;
        /** The description of the asset */
        description?: string;
        /** The privacy of the asset */
        privacy: "private" | "public" | "unlisted";
        /** The date when the asset will be soft deleted (only for Free plan) */
        softDeletionOn?: string;
        /** The mime type of the asset (example: "image/png") */
        mimeType: string;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId: string;
        /** The owner (project) ID (example: "proj_23tlk332lkht3kl2" or "team_dlkhgs23tlk3hlkth32lkht3kl2" for old teams) */
        ownerId: string;
        /** Signed URL to get the asset content */
        url: string;
        /** The associated tags (example: ["sci-fi", "landscape"]) */
        tags: string[];
        /** The asset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The output index of the asset within the job
        This index is an positive integer that starts at 0
        It is used to differentiate between multiple outputs of the same job
        If the job has only one output, this index is 0
        This is only applicable for generations with: Flux, Skybox, Reframe at the moment */
        outputIndex?: number;
        /** A list of CollectionId this asset belongs to */
        collectionIds: string[];
        /** List of edit capabilities for the asset */
        editCapabilities: (
          | "DETECTION"
          | "GENERATIVE_FILL"
          | "PIXELATE"
          | "PROMPT_EDITING"
          | "REFINE"
          | "REFRAME"
          | "REMOVE_BACKGROUND"
          | "SEGMENTATION"
          | "UPSCALE"
          | "UPSCALE_360"
          | "VECTORIZATION"
        )[];
        /** The embedding of the asset when requested and asset can be embedded
        
        ie: Detection maps don't have embeddings */
        embedding?: number[];
        /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        id: string;
        /** The status of the asset */
        status: "error" | "pending" | "success";
        /** The asset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostPixelateInferencesApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") to pixelate. */
    image: string;
    /** The size of the pixel grid in the output image. Should be 16, 32, 64, 128, or 256. */
    pixelGridSize: number;
    /** Reduce pixel art artifacts. */
    removeNoise: boolean;
    /** Remove the background from the image. */
    removeBackground?: boolean;
    /** The color palette to use for the pixel art. */
    colorPalette?: number[][];
    /** If no colorPalette is provided, you can provide a palette size. Value should be between 2 and 256. */
    colorPaletteSize?: number;
  };
};
export type PostPromptInferencesApiResponse =
  /** status 200 200 response */
  | {
      /** The mode used to generate new prompt(s). */
      mode?: "completion" | "image-editing" | "inventive" | "structured";
      /** The number of creative units consumed for this action. */
      creativeUnitsCost?: number;
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
      /** The generated prompts. */
      prompts: string[];
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostPromptInferencesApiArg = {
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The mode used to generate new prompt(s). */
    mode: "completion" | "image-editing" | "inventive" | "structured";
    /** Whether we try to ensure IP removal for new prompt generation. */
    ensureIPCleared?: boolean;
    /** The input image as a data URL (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=") or the asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw")
        
        Required when `mode` is `image-editing-prompt`. */
    image?: string;
    /** If specified, the API will make a best effort to produce the same results, such that repeated requests with the same `seed` and parameters should return the same outputs. Must be used along with the same parameters including prompt, model's state, etc.. */
    seed?: number;
    /** The modelId used to condition the generation.
        
        When provided, the generation will take into account model's training images, examples.
        
        Only supports 'gemini-2.0-flash' for now when `mode` is `image-editing-prompt`. */
    modelId?: string;
    /** The sampling temperature to use. Higher values like `0.8` will make the output more random, while lower values like `0.2` will make it more focused and deterministic.
        
        We generally recommend altering this or `topP` but not both. */
    temperature?: number;
    /** The asset ids used to condition the generation.
        
        Notes:
        - supersedes the `modelId` parameter when provided.
        - ignored when `mode` is `image-editing-prompt`. */
    assetIds?: string[];
    /** The number of results to return. */
    numResults?: number;
    /** The initial prompt spark feed to `completion`, `inventive` or `structured` modes. */
    prompt?: string;
    /** An alternative to sampling with temperature, called nucleus sampling, where the model considers the results of the tokens with top_p probability mass. So `0.1` means only the tokens comprising the top `10%` probability mass are considered.
        
        We generally recommend altering this or `temperature` but not both. */
    topP?: number;
  };
};
export type PostPromptEditingInferencesApiResponse =
  /** status 200 200 response */
  | {
      assets?: {
        /** Metadata of the asset with some additional information */
        metadata: {
          maxIterations?: number;
          /** Modality to detect */
          modality?:
            | "canny"
            | "depth"
            | "grayscale"
            | "lineart_anime"
            | "mlsd"
            | "normal"
            | "pose"
            | "scribble"
            | "segmentation"
            | "sketch";
          /** If set to true, during the upscaling process, the model will match tiles of the source image with tiles of the style image(s). This will result in a more coherent restyle. Works best with style images that have a similar composition. */
          tileStyle?: boolean;
          /** The modelId used to generate this asset */
          modelId?: string;
          /** A bounding box around the object of interest, in the format [x1, y1, x2, y2]. */
          bbox?: any[];
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          keypointThreshold?: number;
          /** The type of the asset. Ex: 'inference-txt2img' will represent an asset generated from a text to image model */
          type:
            | "background-removal"
            | "canvas"
            | "canvas-drawing"
            | "canvas-export"
            | "detection"
            | "generative-fill"
            | "image-prompt-editing"
            | "img23d-custom"
            | "img2img-custom"
            | "img2video-custom"
            | "inference-controlnet"
            | "inference-controlnet-img2img"
            | "inference-controlnet-inpaint"
            | "inference-controlnet-inpaint-ip-adapter"
            | "inference-controlnet-ip-adapter"
            | "inference-controlnet-reference"
            | "inference-controlnet-texture"
            | "inference-img2img"
            | "inference-img2img-ip-adapter"
            | "inference-img2img-texture"
            | "inference-inpaint"
            | "inference-inpaint-ip-adapter"
            | "inference-reference"
            | "inference-reference-texture"
            | "inference-txt2img"
            | "inference-txt2img-ip-adapter"
            | "inference-txt2img-texture"
            | "patch"
            | "pixelization"
            | "reframe"
            | "restyle"
            | "segment"
            | "segmentation-image"
            | "segmentation-mask"
            | "skybox-base-360"
            | "texture"
            | "texture-albedo"
            | "texture-ao"
            | "texture-edge"
            | "texture-height"
            | "texture-metallic"
            | "texture-normal"
            | "texture-smoothness"
            | "txt23d-custom"
            | "txt2audio-custom"
            | "txt2img-custom"
            | "unknown-custom"
            | "uploaded"
            | "upscale"
            | "upscale-skybox"
            | "upscale-texture"
            | "vectorization"
            | "video2video-custom";
          /** A textual description / keywords describing the object of interest. */
          text?: string;
          height?: number;
          nbMasks?: number;
          /** Amount of decay in creativity over the upscale process. The lowest the value, the less the creativity will be preserved over the upscale process. */
          creativityDecay?: number;
          layerDifference?: number;
          /** Scaling factor (when `targetWidth` not specified) */
          scalingFactor?: number;
          /** The type of the generator used */
          modelType?:
            | "custom"
            | "flux.1"
            | "flux.1-composition"
            | "flux.1-lora"
            | "flux.1-pro"
            | "flux.1.1-pro-ultra"
            | "flux1.1-pro"
            | "gpt-image-1"
            | "sd-1_5"
            | "sd-1_5-composition"
            | "sd-1_5-lora"
            | "sd-xl"
            | "sd-xl-composition"
            | "sd-xl-lora";
          /** The number of outputs to generate. */
          numOutputs?: number;
          /** How angular is the surface? 0 is like a sphere, 1 is like a mechanical object */
          angular?: number;
          /** The target height of the output image. */
          targetHeight?: number;
          /** Flux LoRa or Composition to style the image. */
          concepts?: {
            weightName: string;
            /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
            modelId: string;
            /** The scale of the model (example: 1.0) */
            scale: number;
          }[];
          size?: number;
          spliceThreshold?: number;
          /** The number of pixels to dilate the result masks. */
          dilate?: number;
          style?:
            | "3d-cartoon"
            | "3d-rendered"
            | "anime"
            | "cartoon"
            | "cinematic"
            | "claymation"
            | "cloud-skydome"
            | "comic"
            | "cyberpunk"
            | "enchanted"
            | "fantasy"
            | "ink"
            | "manga"
            | "manga-color"
            | "minimalist"
            | "neon-tron"
            | "oil-painting"
            | "pastel"
            | "photo"
            | "photography"
            | "psychedelic"
            | "retro-fantasy"
            | "scifi-concept-art"
            | "space"
            | "standard"
            | "whimsical";
          /** Strengthen the similarity to the original image during the upscale. Default: optimized for your preset and style. */
          imageFidelity?: number;
          /** Location of the input image in the output. */
          inputLocation?: "bottom" | "left" | "middle" | "right" | "top";
          /** The seed used to generate this asset */
          seed?: string;
          /** The higher the value the more it will look like the secondary reference image(s) */
          secondaryRefFidelity?: number;
          preset?: string;
          trainingImage?: boolean;
          /** Boolean to able return the masks (binary image) in the response. */
          resultMask?: boolean;
          /** The ISO timestamp when the lock on the canvas will expire */
          lockExpiresAt?: string;
          /** The baseModelId that maybe changed at inference time */
          baseModelId?: string;
          pathPrecision?: number;
          rootParentId?: string;
          /** Sharpen tiles. */
          sharpen?: boolean;
          cornerThreshold?: number;
          /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
          styleImages?: string[];
          /** The asset to convert in texture maps. Must reference an existing AssetId. */
          texture?: string;
          filterSpeckle?: number;
          /** Minimum threshold for Grayscale conversion */
          minThreshold?: number;
          /** Maximum threshold for Grayscale conversion */
          maxThreshold?: number;
          /** Condition the influence of the style image(s). The higher the value, the more the style images will influence the upscaled image. */
          styleImagesFidelity?: number;
          /** The control image processed by depth estimator. Must reference an existing AssetId. */
          depthImage?: string;
          parentId?: string;
          parentJobId?: string;
          /** Optional List of secondary style images. Example: portrait of people. It must be existing AssetIds. */
          secondaryRefImages?: string[];
          /** The width of the rendered image. */
          width?: number;
          /** The checkpoint to use */
          checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
          strength?: number;
          /** The id of the Inference describing how this image was generated */
          inferenceId?: string;
          lengthThreshold?: number;
          /** Int to set between 0 and 255 for the opacity of the background in the result images. */
          backgroundOpacity?: number;
          /** The optional aspect ratio given for the generation, only applicable for some models */
          aspectRatio?: string;
          /** Amount of details to remove or add */
          detailsLevel?: number;
          /** Determine the scale at which the upscale process works.
            - With a small value, the upscale works at the largest scale, resulting in fewer added details and more coherent images. Ideal for portraits, for example.
            - With a large value, the upscale works at the smallest scale, resulting in more added details and more hallucinations. Ideal for landscapes, for example.
            
            (info): A small value is slower and more expensive to run. */
          fractality?: number;
          /** (deprecated) Horizontal expansion ratio. */
          horizontalExpansionRatio?: number;
          /** List of points (label, x, y) in the image where label = 0 for background and 1 for object. */
          points?: any[][];
          mode?: string;
          colorPrecision?: number;
          /** Increase the fidelity to the prompt during upscale. Default: optimized for your preset and style. */
          promptFidelity?: number;
          /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
          betterQuality?: boolean;
          /** Remove background for Grayscale detector */
          removeBackground?: boolean;
          /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your preset and style. */
          creativity?: number;
          /** Strength for the input image structure preservation */
          structureFidelity?: number;
          /** Preserve the seamless properties of skybox or texture images. Input has to be of same type (seamless). */
          imageType?: "seamfull" | "skybox" | "texture";
          /** The input image to process. Must reference an existing AssetId or be a data URL. */
          image?: string;
          /** The thumbnail of the canvas */
          thumbnail?: {
            /** The AssetId of the image used as a thumbnail for the canvas (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
            assetId: string;
            /** The url of the image used as a thumbnail for the canvas */
            url: string;
          };
          /** The control image for structure. A canny detector will be applied to this image. Must reference an existing AssetId. */
          structureImage?: string;
          /** To invert the relief */
          invert?: boolean;
          kind: "3d" | "audio" | "document" | "image" | "json" | "video";
          colorMode?: string;
          /** High threshold for Canny detector */
          highThreshold?: number;
          /** (deprecated) Vertical expansion ratio. */
          verticalExpansionRatio?: number;
          halfMode?: boolean;
          name?: string;
          /** Additional refinement steps before scaling.
            
            If scalingFactor == 1, the refinement process will be applied (1 + refinementSteps) times.
            If scalingFactor > 1, the refinement process will be applied refinementSteps times. */
          refinementSteps?: number;
          /** The reference images used for the image generation or editing */
          referenceImages?: string[];
          /** The higher the value the more it will look like the style image(s) */
          styleFidelity?: number;
          /** Boolean to output the contours. */
          resultContours?: boolean;
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          polished?: number;
          /** The scheduler used to generate this asset */
          scheduler?: string;
          /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
          overrideEmbeddings?: boolean;
          progressPercent?: number;
          /** Contrast factor for Grayscale detector */
          factor?: number;
          /** The mask used for the image generation or editing */
          mask?: string;
          /** Low threshold for Canny detector */
          lowThreshold?: number;
          /** The depth fidelity if a depth image provided */
          depthFidelity?: number;
          /** How raised is the surface? 0 is flat like water, 1 is like a very rough rock */
          raised?: number;
          message?: string;
          contours?: number[][][][];
          /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
          negativePrompt?: string;
          /** If true, use the default parameters */
          defaultParameters?: boolean;
          /** Size proportion of the input image in the output. */
          resizeOption?: number;
          outputIndex?: number;
          /** Save a flipbook of the texture. Deactivated when the input texture is larger than 2048x2048px */
          saveFlipbook?: boolean;
          /** The guidance used to generate this asset */
          guidance?: number;
          /** The number of denoising steps for each image generation. */
          numInferenceSteps?: number;
          hdr?: number;
          /** How shiny is the surface? 0 is like a matte surface, 1 is like a diamond */
          shiny?: number;
          /** Ensure upscaled tile have the same color histogram as original tile. */
          colorCorrection?: boolean;
          /** Overlap percentage for the output image. */
          overlapPercentage?: number;
          /** The prompt that guided the image generation or editing */
          prompt?: string;
          /** Boolean to able output the cut out object. */
          resultImage?: boolean;
          /** The control image already processed by canny detector. Must reference an existing AssetId. */
          cannyStructureImage?: string;
          /** Apply extra control to the Skybox 360 geometry.
            The higher the value, the more the 360 geometry will influence the generated skybox image.
            
            Use with caution. Default is adapted to the other parameters. */
          geometryEnforcement?: number;
          /** Target width for the upscaled image, take priority over scaling factor */
          targetWidth?: number;
        };
        /** The NSFW labels */
        nsfw?: string[];
        /** Automatic captioning of the asset */
        automaticCaptioning?: string;
        /** The description of the asset */
        description?: string;
        /** The privacy of the asset */
        privacy: "private" | "public" | "unlisted";
        /** The date when the asset will be soft deleted (only for Free plan) */
        softDeletionOn?: string;
        /** The mime type of the asset (example: "image/png") */
        mimeType: string;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId: string;
        /** The owner (project) ID (example: "proj_23tlk332lkht3kl2" or "team_dlkhgs23tlk3hlkth32lkht3kl2" for old teams) */
        ownerId: string;
        /** Signed URL to get the asset content */
        url: string;
        /** The associated tags (example: ["sci-fi", "landscape"]) */
        tags: string[];
        /** The asset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The output index of the asset within the job
        This index is an positive integer that starts at 0
        It is used to differentiate between multiple outputs of the same job
        If the job has only one output, this index is 0
        This is only applicable for generations with: Flux, Skybox, Reframe at the moment */
        outputIndex?: number;
        /** A list of CollectionId this asset belongs to */
        collectionIds: string[];
        /** List of edit capabilities for the asset */
        editCapabilities: (
          | "DETECTION"
          | "GENERATIVE_FILL"
          | "PIXELATE"
          | "PROMPT_EDITING"
          | "REFINE"
          | "REFRAME"
          | "REMOVE_BACKGROUND"
          | "SEGMENTATION"
          | "UPSCALE"
          | "UPSCALE_360"
          | "VECTORIZATION"
        )[];
        /** The embedding of the asset when requested and asset can be embedded
        
        ie: Detection maps don't have embeddings */
        embedding?: number[];
        /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        id: string;
        /** The status of the asset */
        status: "error" | "pending" | "success";
        /** The asset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostPromptEditingInferencesApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The image to edit. Must reference an existing AssetId or be a data URL. */
    image: string;
    /** List of additional reference images. */
    referenceImages?: string[];
    /** The number of samples to generate
        
        Maximum depends on the subscription tier. */
    numSamples?: number;
    /** The format of the generated image(s). Only available for the `gpt-image-1` model. */
    format?: "jpeg" | "png" | "webp";
    /** The aspect ratio of the generated image(s). Only available for the `gpt-image-1` model.
        Will default to `auto` for other models and unknown ratios. */
    aspectRatio?: "1:1" | "2:3" | "3:2" | "auto";
    /** The model to use. Can be "gemini-2.0-flash" or "gpt-image-1". */
    model?: "gemini-2.0-flash" | "gpt-image-1";
    /** The compression level (0-100%) for the generated images. This parameter is only supported for
        the `gpt-image-1` model with the `webp` or `jpeg` output formats, and defaults to 100. */
    compression?: number;
    /** The prompt to edit the given image. */
    prompt: string;
    /** You can provide a mask to indicate where the image should be edited. The black area of the mask
        will be replaced, while the filled areas will be kept as is.
        
        Must reference an existing AssetId or be a data URL.
        
        Only available for the `gpt-image-1` model. Will be ignored for other models. */
    mask?: string;
    /** The quality of the generated image(s). Only available for the `gpt-image-1` model. */
    quality?: "high" | "low" | "medium";
  };
};
export type PostReframeInferencesApiResponse =
  /** status 200 200 response */
  | {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost?: number;
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostReframeInferencesApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The image to reframe. Must reference an existing AssetId or be a data URL. */
    image: string;
    /** Location of the input image in the output. */
    inputLocation?: "bottom" | "left" | "middle" | "right" | "top";
    /** Used to reproduce previous results. Default: randomly generated number. */
    seed?: number;
    /** (deprecated) Horizontal expansion ratio. */
    horizontalExpansionRatio?: number;
    /** (deprecated) A negative full text prompt that discourages the repaint from generating certain characteristics. It is recommended to test without using a negative prompt. */
    negativePrompt?: string;
    /** Size proportion of the input image in the output. */
    resizeOption?: number;
    /** (deprecated) Vertical expansion ratio. */
    verticalExpansionRatio?: number;
    /** The target height of the output image. */
    targetHeight: number;
    /** Flux LoRa or Composition to style the image. */
    concepts?: {
      weightName: string;
      /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
      modelId: string;
      /** The scale of the model (example: 1.0) */
      scale: number;
    }[];
    /** The number of denoising steps for each image generation. */
    numInferenceSteps?: number;
    /** Increase the fidelity to the prompt during the restyle. */
    promptFidelity?: number;
    /** Overlap percentage for the output image. */
    overlapPercentage?: number;
    /** A full text prompt to guide the repaint process. */
    prompt?: string;
    /** The target width of the output image. */
    targetWidth: number;
  };
};
export type PostRemoveBackgroundInferencesApiResponse =
  /** status 200 200 response */
  | {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost?: number;
      asset?: {
        /** Metadata of the asset with some additional information */
        metadata: {
          maxIterations?: number;
          /** Modality to detect */
          modality?:
            | "canny"
            | "depth"
            | "grayscale"
            | "lineart_anime"
            | "mlsd"
            | "normal"
            | "pose"
            | "scribble"
            | "segmentation"
            | "sketch";
          /** If set to true, during the upscaling process, the model will match tiles of the source image with tiles of the style image(s). This will result in a more coherent restyle. Works best with style images that have a similar composition. */
          tileStyle?: boolean;
          /** The modelId used to generate this asset */
          modelId?: string;
          /** A bounding box around the object of interest, in the format [x1, y1, x2, y2]. */
          bbox?: any[];
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          keypointThreshold?: number;
          /** The type of the asset. Ex: 'inference-txt2img' will represent an asset generated from a text to image model */
          type:
            | "background-removal"
            | "canvas"
            | "canvas-drawing"
            | "canvas-export"
            | "detection"
            | "generative-fill"
            | "image-prompt-editing"
            | "img23d-custom"
            | "img2img-custom"
            | "img2video-custom"
            | "inference-controlnet"
            | "inference-controlnet-img2img"
            | "inference-controlnet-inpaint"
            | "inference-controlnet-inpaint-ip-adapter"
            | "inference-controlnet-ip-adapter"
            | "inference-controlnet-reference"
            | "inference-controlnet-texture"
            | "inference-img2img"
            | "inference-img2img-ip-adapter"
            | "inference-img2img-texture"
            | "inference-inpaint"
            | "inference-inpaint-ip-adapter"
            | "inference-reference"
            | "inference-reference-texture"
            | "inference-txt2img"
            | "inference-txt2img-ip-adapter"
            | "inference-txt2img-texture"
            | "patch"
            | "pixelization"
            | "reframe"
            | "restyle"
            | "segment"
            | "segmentation-image"
            | "segmentation-mask"
            | "skybox-base-360"
            | "texture"
            | "texture-albedo"
            | "texture-ao"
            | "texture-edge"
            | "texture-height"
            | "texture-metallic"
            | "texture-normal"
            | "texture-smoothness"
            | "txt23d-custom"
            | "txt2audio-custom"
            | "txt2img-custom"
            | "unknown-custom"
            | "uploaded"
            | "upscale"
            | "upscale-skybox"
            | "upscale-texture"
            | "vectorization"
            | "video2video-custom";
          /** A textual description / keywords describing the object of interest. */
          text?: string;
          height?: number;
          nbMasks?: number;
          /** Amount of decay in creativity over the upscale process. The lowest the value, the less the creativity will be preserved over the upscale process. */
          creativityDecay?: number;
          layerDifference?: number;
          /** Scaling factor (when `targetWidth` not specified) */
          scalingFactor?: number;
          /** The type of the generator used */
          modelType?:
            | "custom"
            | "flux.1"
            | "flux.1-composition"
            | "flux.1-lora"
            | "flux.1-pro"
            | "flux.1.1-pro-ultra"
            | "flux1.1-pro"
            | "gpt-image-1"
            | "sd-1_5"
            | "sd-1_5-composition"
            | "sd-1_5-lora"
            | "sd-xl"
            | "sd-xl-composition"
            | "sd-xl-lora";
          /** The number of outputs to generate. */
          numOutputs?: number;
          /** How angular is the surface? 0 is like a sphere, 1 is like a mechanical object */
          angular?: number;
          /** The target height of the output image. */
          targetHeight?: number;
          /** Flux LoRa or Composition to style the image. */
          concepts?: {
            weightName: string;
            /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
            modelId: string;
            /** The scale of the model (example: 1.0) */
            scale: number;
          }[];
          size?: number;
          spliceThreshold?: number;
          /** The number of pixels to dilate the result masks. */
          dilate?: number;
          style?:
            | "3d-cartoon"
            | "3d-rendered"
            | "anime"
            | "cartoon"
            | "cinematic"
            | "claymation"
            | "cloud-skydome"
            | "comic"
            | "cyberpunk"
            | "enchanted"
            | "fantasy"
            | "ink"
            | "manga"
            | "manga-color"
            | "minimalist"
            | "neon-tron"
            | "oil-painting"
            | "pastel"
            | "photo"
            | "photography"
            | "psychedelic"
            | "retro-fantasy"
            | "scifi-concept-art"
            | "space"
            | "standard"
            | "whimsical";
          /** Strengthen the similarity to the original image during the upscale. Default: optimized for your preset and style. */
          imageFidelity?: number;
          /** Location of the input image in the output. */
          inputLocation?: "bottom" | "left" | "middle" | "right" | "top";
          /** The seed used to generate this asset */
          seed?: string;
          /** The higher the value the more it will look like the secondary reference image(s) */
          secondaryRefFidelity?: number;
          preset?: string;
          trainingImage?: boolean;
          /** Boolean to able return the masks (binary image) in the response. */
          resultMask?: boolean;
          /** The ISO timestamp when the lock on the canvas will expire */
          lockExpiresAt?: string;
          /** The baseModelId that maybe changed at inference time */
          baseModelId?: string;
          pathPrecision?: number;
          rootParentId?: string;
          /** Sharpen tiles. */
          sharpen?: boolean;
          cornerThreshold?: number;
          /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
          styleImages?: string[];
          /** The asset to convert in texture maps. Must reference an existing AssetId. */
          texture?: string;
          filterSpeckle?: number;
          /** Minimum threshold for Grayscale conversion */
          minThreshold?: number;
          /** Maximum threshold for Grayscale conversion */
          maxThreshold?: number;
          /** Condition the influence of the style image(s). The higher the value, the more the style images will influence the upscaled image. */
          styleImagesFidelity?: number;
          /** The control image processed by depth estimator. Must reference an existing AssetId. */
          depthImage?: string;
          parentId?: string;
          parentJobId?: string;
          /** Optional List of secondary style images. Example: portrait of people. It must be existing AssetIds. */
          secondaryRefImages?: string[];
          /** The width of the rendered image. */
          width?: number;
          /** The checkpoint to use */
          checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
          strength?: number;
          /** The id of the Inference describing how this image was generated */
          inferenceId?: string;
          lengthThreshold?: number;
          /** Int to set between 0 and 255 for the opacity of the background in the result images. */
          backgroundOpacity?: number;
          /** The optional aspect ratio given for the generation, only applicable for some models */
          aspectRatio?: string;
          /** Amount of details to remove or add */
          detailsLevel?: number;
          /** Determine the scale at which the upscale process works.
            - With a small value, the upscale works at the largest scale, resulting in fewer added details and more coherent images. Ideal for portraits, for example.
            - With a large value, the upscale works at the smallest scale, resulting in more added details and more hallucinations. Ideal for landscapes, for example.
            
            (info): A small value is slower and more expensive to run. */
          fractality?: number;
          /** (deprecated) Horizontal expansion ratio. */
          horizontalExpansionRatio?: number;
          /** List of points (label, x, y) in the image where label = 0 for background and 1 for object. */
          points?: any[][];
          mode?: string;
          colorPrecision?: number;
          /** Increase the fidelity to the prompt during upscale. Default: optimized for your preset and style. */
          promptFidelity?: number;
          /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
          betterQuality?: boolean;
          /** Remove background for Grayscale detector */
          removeBackground?: boolean;
          /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your preset and style. */
          creativity?: number;
          /** Strength for the input image structure preservation */
          structureFidelity?: number;
          /** Preserve the seamless properties of skybox or texture images. Input has to be of same type (seamless). */
          imageType?: "seamfull" | "skybox" | "texture";
          /** The input image to process. Must reference an existing AssetId or be a data URL. */
          image?: string;
          /** The thumbnail of the canvas */
          thumbnail?: {
            /** The AssetId of the image used as a thumbnail for the canvas (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
            assetId: string;
            /** The url of the image used as a thumbnail for the canvas */
            url: string;
          };
          /** The control image for structure. A canny detector will be applied to this image. Must reference an existing AssetId. */
          structureImage?: string;
          /** To invert the relief */
          invert?: boolean;
          kind: "3d" | "audio" | "document" | "image" | "json" | "video";
          colorMode?: string;
          /** High threshold for Canny detector */
          highThreshold?: number;
          /** (deprecated) Vertical expansion ratio. */
          verticalExpansionRatio?: number;
          halfMode?: boolean;
          name?: string;
          /** Additional refinement steps before scaling.
            
            If scalingFactor == 1, the refinement process will be applied (1 + refinementSteps) times.
            If scalingFactor > 1, the refinement process will be applied refinementSteps times. */
          refinementSteps?: number;
          /** The reference images used for the image generation or editing */
          referenceImages?: string[];
          /** The higher the value the more it will look like the style image(s) */
          styleFidelity?: number;
          /** Boolean to output the contours. */
          resultContours?: boolean;
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          polished?: number;
          /** The scheduler used to generate this asset */
          scheduler?: string;
          /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
          overrideEmbeddings?: boolean;
          progressPercent?: number;
          /** Contrast factor for Grayscale detector */
          factor?: number;
          /** The mask used for the image generation or editing */
          mask?: string;
          /** Low threshold for Canny detector */
          lowThreshold?: number;
          /** The depth fidelity if a depth image provided */
          depthFidelity?: number;
          /** How raised is the surface? 0 is flat like water, 1 is like a very rough rock */
          raised?: number;
          message?: string;
          contours?: number[][][][];
          /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
          negativePrompt?: string;
          /** If true, use the default parameters */
          defaultParameters?: boolean;
          /** Size proportion of the input image in the output. */
          resizeOption?: number;
          outputIndex?: number;
          /** Save a flipbook of the texture. Deactivated when the input texture is larger than 2048x2048px */
          saveFlipbook?: boolean;
          /** The guidance used to generate this asset */
          guidance?: number;
          /** The number of denoising steps for each image generation. */
          numInferenceSteps?: number;
          hdr?: number;
          /** How shiny is the surface? 0 is like a matte surface, 1 is like a diamond */
          shiny?: number;
          /** Ensure upscaled tile have the same color histogram as original tile. */
          colorCorrection?: boolean;
          /** Overlap percentage for the output image. */
          overlapPercentage?: number;
          /** The prompt that guided the image generation or editing */
          prompt?: string;
          /** Boolean to able output the cut out object. */
          resultImage?: boolean;
          /** The control image already processed by canny detector. Must reference an existing AssetId. */
          cannyStructureImage?: string;
          /** Apply extra control to the Skybox 360 geometry.
            The higher the value, the more the 360 geometry will influence the generated skybox image.
            
            Use with caution. Default is adapted to the other parameters. */
          geometryEnforcement?: number;
          /** Target width for the upscaled image, take priority over scaling factor */
          targetWidth?: number;
        };
        /** The NSFW labels */
        nsfw?: string[];
        /** Automatic captioning of the asset */
        automaticCaptioning?: string;
        /** The description of the asset */
        description?: string;
        /** The privacy of the asset */
        privacy: "private" | "public" | "unlisted";
        /** The date when the asset will be soft deleted (only for Free plan) */
        softDeletionOn?: string;
        /** The mime type of the asset (example: "image/png") */
        mimeType: string;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId: string;
        /** The owner (project) ID (example: "proj_23tlk332lkht3kl2" or "team_dlkhgs23tlk3hlkth32lkht3kl2" for old teams) */
        ownerId: string;
        /** Signed URL to get the asset content */
        url: string;
        /** The associated tags (example: ["sci-fi", "landscape"]) */
        tags: string[];
        /** The asset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The output index of the asset within the job
        This index is an positive integer that starts at 0
        It is used to differentiate between multiple outputs of the same job
        If the job has only one output, this index is 0
        This is only applicable for generations with: Flux, Skybox, Reframe at the moment */
        outputIndex?: number;
        /** A list of CollectionId this asset belongs to */
        collectionIds: string[];
        /** List of edit capabilities for the asset */
        editCapabilities: (
          | "DETECTION"
          | "GENERATIVE_FILL"
          | "PIXELATE"
          | "PROMPT_EDITING"
          | "REFINE"
          | "REFRAME"
          | "REMOVE_BACKGROUND"
          | "SEGMENTATION"
          | "UPSCALE"
          | "UPSCALE_360"
          | "VECTORIZATION"
        )[];
        /** The embedding of the asset when requested and asset can be embedded
        
        ie: Detection maps don't have embeddings */
        embedding?: number[];
        /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        id: string;
        /** The status of the asset */
        status: "error" | "pending" | "success";
        /** The asset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostRemoveBackgroundInferencesApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw"). If provided, image and name will be ignored. */
    image: string;
    /** The background color as an hexadecimal code (ex: "#FFFFFF"), an html color (ex: "red") or "transparent" if "format" is "png" */
    backgroundColor?: string;
    /** The output format. Default is 'png' */
    format?: "jpeg" | "png";
  };
};
export type PostRestyleInferencesApiResponse =
  /** status 200 200 response */
  | {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost?: number;
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostRestyleInferencesApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The image to restyle. Must reference an existing AssetId or be a data URL. */
    image: string;
    /** The higher the value the more it will look like the style image(s) */
    styleFidelity?: number;
    /** Used to reproduce previous results. Default: randomly generated number. */
    seed?: number;
    /** The number of denoising steps for each image generation. */
    numInferenceSteps?: number;
    /** The higher the value the more it will look like the secondary reference image(s) */
    secondaryRefFidelity?: number;
    /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
    overrideEmbeddings?: boolean;
    /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
    styleImages: string[];
    /** Increase the fidelity to the prompt during the restyle. */
    promptFidelity?: number;
    /** Optional List of secondary style images. Example: portrait of people. It must be existing AssetIds. */
    secondaryRefImages?: string[];
    /** Strength for the input image structure preservation */
    structureFidelity?: number;
    /** A full text prompt to guide the restyle process. Default: empty string. Example: "cute++ chibi character" */
    prompt?: string;
    /** A negative full text prompt that discourages the restyle from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
    negativePrompt?: string;
  };
};
export type PostSegmentInferencesApiResponse =
  /** status 200 200 response */
  | {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost?: number;
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
      segments?: {
        checkpoint: "fastsam_x" | "sam_b" | "sam_h";
        nbMasks: number;
        images?: string[];
        bbox: any[];
        masks?: string[];
        message: string;
        contours?: number[][][][];
      }[];
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostSegmentInferencesApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The checkpoint to use */
    checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
    /** The input image to process. Must reference an existing AssetId or be a data URL. */
    image: string;
    /** Boolean to output the contours. */
    resultContours?: boolean;
    /** The number of pixels to dilate the result masks. */
    dilate?: number;
    /** A bounding box around the object of interest, in the format [x1, y1, x2, y2]. */
    bbox?: any[];
    /** Int to set between 0 and 255 for the opacity of the background in the result images. */
    backgroundOpacity?: number;
    /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
    betterQuality?: boolean;
    /** A textual description / keywords describing the object of interest. */
    text?: string;
    /** Boolean to able output the cut out object. */
    resultImage?: boolean;
    /** List of points (label, x, y) in the image where label = 0 for background and 1 for object. */
    points?: any[][];
    /** Boolean to able return the masks (binary image) in the response. */
    resultMask?: boolean;
  };
};
export type PostSkyboxBase360InferencesApiResponse =
  /** status 200 200 response */
  | {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost?: number;
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostSkyboxBase360InferencesApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The image to use as a starting point for the skybox generation. Must reference an existing AssetId or be a data URL. */
    image?: string;
    /** (deprecated) Condition the influence of the style image. The higher the value, the more the style image will influence the generated skybox image. */
    styleFidelity?: number;
    /** The control image for structure. A canny detector will be applied to this image. Must reference an existing AssetId. */
    structureImage?: string;
    /** Used to reproduce previous results. Default: randomly generated number. */
    seed?: number;
    /** Controls the noise intensity introduced to the input image, where a value of 1.0 completely erases the original image's details. Available for img2img and inpainting. (within [0.01, 1.0], default: 0.75) */
    strength?: number;
    /** (deprecated) List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
    styleImages?: string[];
    /** The depth fidelity if a depth image provided */
    depthFidelity?: number;
    /** The number of outputs to generate. */
    numOutputs?: number;
    /** The control image processed by depth estimator. Must reference an existing AssetId. */
    depthImage?: string;
    /** (Deprecated) A negative full text prompt that discourages the skybox model from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
    negativePrompt?: string;
    /** The number of denoising steps for each image generation. */
    numInferenceSteps?: number;
    /** (deprecated) Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
    overrideEmbeddings?: boolean;
    /** Increase the fidelity to the prompt during upscale. */
    promptFidelity?: number;
    /** The width of the rendered image. */
    width?: number;
    /** Style to apply for generation. */
    style?:
      | "3d-cartoon"
      | "cartoon"
      | "cinematic"
      | "claymation"
      | "cloud-skydome"
      | "comic"
      | "cyberpunk"
      | "enchanted"
      | "fantasy"
      | "ink"
      | "manga"
      | "manga-color"
      | "neon-tron"
      | "oil-painting"
      | "pastel"
      | "photo"
      | "psychedelic"
      | "retro-fantasy"
      | "scifi-concept-art"
      | "space"
      | "standard"
      | "whimsical";
    /** The structure fidelity if a structureImage or a cannyStructureImage image is provided. */
    structureFidelity?: number;
    /** A full text prompt to guide the skybox generation process. Default: empty string. Example: "a mountain landscape" */
    prompt: string;
    /** The control image already processed by canny detector. Must reference an existing AssetId. */
    cannyStructureImage?: string;
    /** Apply extra control to the Skybox 360 geometry.
        The higher the value, the more the 360 geometry will influence the generated skybox image.
        
        Use with caution. Default is adapted to the other parameters. */
    geometryEnforcement?: number;
  };
};
export type PostSkyboxUpscale360InferencesApiResponse =
  /** status 200 200 response */
  | {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost?: number;
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostSkyboxUpscale360InferencesApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The 360 image to upscale. Must reference an existing AssetId or a data URL. */
    image: string;
    /** Condition the influence of the style image. The higher the value, the more the style image will influence the upscaled skybox image. Default: 80 */
    styleFidelity?: number;
    /** Sharpen tiles. */
    sharpen?: boolean;
    /** Used to reproduce previous results. Default: randomly generated number. */
    seed?: number;
    /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
    styleImages?: string[];
    /** Scaling factor (when `targetWidth` not specified) */
    scalingFactor?: number;
    /** Amount of details to remove or add */
    detailsLevel?: number;
    /** A negative full text prompt that discourages the skybox upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
    negativePrompt?: string;
    /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
    overrideEmbeddings?: boolean;
    /** Increase the fidelity to the prompt during upscale. */
    promptFidelity?: number;
    /** Ensure upscaled tile have the same color histogram as original tile. */
    colorCorrection?: boolean;
    /** A full text prompt to guide the skybox upscale. Default: empty string. Example: "a mountain landscape" */
    prompt?: string;
    /** Target width for the upscaled image, take priority over scaling factor */
    targetWidth?: number;
  };
};
export type PostTextureInferencesApiResponse =
  /** status 200 200 response */
  | {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost?: number;
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostTextureInferencesApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** If true, use the default parameters */
    defaultParameters?: boolean;
    /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
    polished?: number;
    /** How angular is the surface? 0 is like a sphere, 1 is like a mechanical object */
    angular?: number;
    /** To invert the relief */
    invert?: boolean;
    /** Save a flipbook of the texture. Deactivated when the input texture is larger than 2048x2048px */
    saveFlipbook?: boolean;
    /** The asset to convert in texture maps. Must reference an existing AssetId. */
    texture: string;
    /** How raised is the surface? 0 is flat like water, 1 is like a very rough rock */
    raised?: number;
    /** How shiny is the surface? 0 is like a matte surface, 1 is like a diamond */
    shiny?: number;
  };
};
export type PostTranslateInferencesApiResponse =
  /** status 200 200 response */
  | {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost?: number;
      /** The translated prompt. */
      translation: string;
      /** Detected language of the input. */
      detectedLanguage: string;
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostTranslateInferencesApiArg = {
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** Whether we try to ensure IP removal for new prompt generation. */
    ensureIPCleared?: boolean;
    /** If specified, the API will make a best effort to produce the same results, such that repeated requests with the same `seed` and parameters should return the same outputs. Must be used along with the same parameters including prompt, model's state, etc.. */
    seed?: number;
    /** The sampling temperature to use. Higher values like `0.8` will make the output more random, while lower values like `0.2` will make it more focused and deterministic.
        
        We generally recommend altering this or `topP` but not both. */
    temperature?: number;
    /** The prompt to translate. */
    prompt: string;
    /** An alternative to sampling with temperature, called nucleus sampling, where the model considers the results of the tokens with top_p probability mass. So `0.1` means only the tokens comprising the top `10%` probability mass are considered.
        
        We generally recommend altering this or `temperature` but not both. */
    topP?: number;
  };
};
export type PostTxt2ImgInferencesApiResponse =
  /** status 200 200 response */
  | {
      creativeUnitsCost?: number;
      inference: {
        /** Used to reproduce previous results. Default: randomly generated number. */
        seed?: string;
        /** If set, generated assets will be hidden and not returned in the list of images of the inference
        or when listing assets (default: false) */
        hideResults?: boolean;
        /** The aspect ratio of the generated images. Only used for the model flux.1.1-pro-ultra.
        The aspect ratio is a string formatted as "width:height" (example: "16:9"). */
        aspectRatio?:
          | "16:9"
          | "1:1"
          | "21:9"
          | "2:3"
          | "3:2"
          | "3:4"
          | "4:3"
          | "4:5"
          | "5:4"
          | "9:16"
          | "9:21";
        /** The type of inference to use. Example: txt2img, img2img, etc.
        
        Selecting the right type will condition the expected parameters.
        
        Note: if model.type is `sd-xl*` or `sd-1_5*`, when using the `"inpaint"` inference type, Scenario determines the best available `baseModel` for a given `modelId`: one of `["stable-diffusion-inpainting", "stable-diffusion-xl-1.0-inpainting-0.1"] will be used. */
        type:
          | "txt2img"
          | "txt2img_ip_adapter"
          | "txt2img_texture"
          | "img2img"
          | "img2img_ip_adapter"
          | "img2img_texture"
          | "inpaint"
          | "outpaint"
          | "inpaint_ip_adapter"
          | "controlnet"
          | "controlnet_ip_adapter"
          | "reference"
          | "reference_texture"
          | "controlnet_reference"
          | "controlnet_img2img"
          | "controlnet_inpaint"
          | "controlnet_inpaint_ip_adapter"
          | "controlnet_texture";
        /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
        negativePrompt?: string;
        /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
        scheduler?:
          | "DDIMScheduler"
          | "DDPMScheduler"
          | "DEISMultistepScheduler"
          | "DPMSolverMultistepScheduler"
          | "DPMSolverSinglestepScheduler"
          | "EulerAncestralDiscreteScheduler"
          | "EulerDiscreteScheduler"
          | "HeunDiscreteScheduler"
          | "KDPM2AncestralDiscreteScheduler"
          | "KDPM2DiscreteScheduler"
          | "LCMScheduler"
          | "LMSDiscreteScheduler"
          | "PNDMScheduler"
          | "TCDScheduler"
          | "UniPCMultistepScheduler";
        /** Enable or disable the intermediate images generation (default: false) */
        intermediateImages?: boolean;
        concepts?: {
          /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
          modelId: string;
          /** The scale of the model (example: 1.0) */
          scale: number;
        }[];
        /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
        guidance?: number;
        /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
        numInferenceSteps?: number;
        /** The number of images to generate (within [1, 128], default: 4) */
        numSamples?: number;
        /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
        If model.type is `sd-1_5`, the width must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        width?: number;
        /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
        Allowed values are available in the model's attribute: `compliantModelIds` */
        baseModelId?: string;
        /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
        prompt: string;
        /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
        If model.type is `sd-1_5`, the height must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        height?: number;
      };
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostTxt2ImgInferencesApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** Used to reproduce previous results. Default: randomly generated number. */
    seed?: string;
    /** The model id to use for the inference */
    modelId: string;
    /** If set, generated assets will be hidden and not returned in the list of images of the inference
        or when listing assets (default: false) */
    hideResults?: boolean;
    /** The aspect ratio of the generated images. Only used for the model flux.1.1-pro-ultra.
        The aspect ratio is a string formatted as "width:height" (example: "16:9"). */
    aspectRatio?:
      | "16:9"
      | "1:1"
      | "21:9"
      | "2:3"
      | "3:2"
      | "3:4"
      | "4:3"
      | "4:5"
      | "5:4"
      | "9:16"
      | "9:21";
    /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
    negativePrompt?: string;
    /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
    scheduler?:
      | "DDIMScheduler"
      | "DDPMScheduler"
      | "DEISMultistepScheduler"
      | "DPMSolverMultistepScheduler"
      | "DPMSolverSinglestepScheduler"
      | "EulerAncestralDiscreteScheduler"
      | "EulerDiscreteScheduler"
      | "HeunDiscreteScheduler"
      | "KDPM2AncestralDiscreteScheduler"
      | "KDPM2DiscreteScheduler"
      | "LCMScheduler"
      | "LMSDiscreteScheduler"
      | "PNDMScheduler"
      | "TCDScheduler"
      | "UniPCMultistepScheduler";
    /** Enable or disable the intermediate images generation (default: false) */
    intermediateImages?: boolean;
    concepts?: {
      /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
      modelId: string;
      /** The scale of the model (example: 1.0) */
      scale: number;
    }[];
    /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
    guidance?: number;
    /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
    numInferenceSteps?: number;
    /** The number of images to generate (within [1, 128], default: 4) */
    numSamples?: number;
    /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
        If model.type is `sd-1_5`, the width must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
    width?: number;
    /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
        Allowed values are available in the model's attribute: `compliantModelIds` */
    baseModelId?: string;
    /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
    prompt: string;
    /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
        If model.type is `sd-1_5`, the height must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
    height?: number;
  };
};
export type PostTxt2ImgIpAdapterInferencesApiResponse =
  /** status 200 200 response */
  | {
      creativeUnitsCost?: number;
      inference: {
        /** Asset id of the input IpAdapter images */
        ipAdapterImageIds?: string[];
        /** Asset id of the input IpAdapter image */
        ipAdapterImageId?: string;
        /** IpAdapter scale factor (within [0.0, 1.0], default: 0.9). */
        ipAdapterScale?: number;
        /** Used to reproduce previous results. Default: randomly generated number. */
        seed?: string;
        /** The type of IP Adapter model to use. Must be one of [`style`, `character`], default to `style`` */
        ipAdapterType?: "character" | "style";
        /** If set, generated assets will be hidden and not returned in the list of images of the inference
        or when listing assets (default: false) */
        hideResults?: boolean;
        /** The aspect ratio of the generated images. Only used for the model flux.1.1-pro-ultra.
        The aspect ratio is a string formatted as "width:height" (example: "16:9"). */
        aspectRatio?:
          | "16:9"
          | "1:1"
          | "21:9"
          | "2:3"
          | "3:2"
          | "3:4"
          | "4:3"
          | "4:5"
          | "5:4"
          | "9:16"
          | "9:21";
        /** IpAdapter scale factors (within [0.0, 1.0], default: 0.9). */
        ipAdapterScales?: number[];
        /** The type of inference to use. Example: txt2img, img2img, etc.
        
        Selecting the right type will condition the expected parameters.
        
        Note: if model.type is `sd-xl*` or `sd-1_5*`, when using the `"inpaint"` inference type, Scenario determines the best available `baseModel` for a given `modelId`: one of `["stable-diffusion-inpainting", "stable-diffusion-xl-1.0-inpainting-0.1"] will be used. */
        type:
          | "txt2img"
          | "txt2img_ip_adapter"
          | "txt2img_texture"
          | "img2img"
          | "img2img_ip_adapter"
          | "img2img_texture"
          | "inpaint"
          | "outpaint"
          | "inpaint_ip_adapter"
          | "controlnet"
          | "controlnet_ip_adapter"
          | "reference"
          | "reference_texture"
          | "controlnet_reference"
          | "controlnet_img2img"
          | "controlnet_inpaint"
          | "controlnet_inpaint_ip_adapter"
          | "controlnet_texture";
        /** Signed URL to display the IpAdapter image */
        ipAdapterImage?: string;
        /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
        negativePrompt?: string;
        /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
        scheduler?:
          | "DDIMScheduler"
          | "DDPMScheduler"
          | "DEISMultistepScheduler"
          | "DPMSolverMultistepScheduler"
          | "DPMSolverSinglestepScheduler"
          | "EulerAncestralDiscreteScheduler"
          | "EulerDiscreteScheduler"
          | "HeunDiscreteScheduler"
          | "KDPM2AncestralDiscreteScheduler"
          | "KDPM2DiscreteScheduler"
          | "LCMScheduler"
          | "LMSDiscreteScheduler"
          | "PNDMScheduler"
          | "TCDScheduler"
          | "UniPCMultistepScheduler";
        /** Enable or disable the intermediate images generation (default: false) */
        intermediateImages?: boolean;
        concepts?: {
          /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
          modelId: string;
          /** The scale of the model (example: 1.0) */
          scale: number;
        }[];
        /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
        guidance?: number;
        /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
        numInferenceSteps?: number;
        /** The number of images to generate (within [1, 128], default: 4) */
        numSamples?: number;
        /** Signed URL to display the IpAdapter images */
        ipAdapterImages?: string[];
        /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
        If model.type is `sd-1_5`, the width must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        width?: number;
        /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
        Allowed values are available in the model's attribute: `compliantModelIds` */
        baseModelId?: string;
        /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
        prompt: string;
        /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
        If model.type is `sd-1_5`, the height must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        height?: number;
      };
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostTxt2ImgIpAdapterInferencesApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The IpAdapter images as an AssetId. Will be ignored if the `ipAdapterImages` parameter is provided */
    ipAdapterImageIds?: string[];
    /** Deprecated for type txt2img-ip-adapter and img2img-ip-adapter, use `ipAdapterImageIds` instead.
        The IpAdapter image as an AssetId. Cannot be set if `ipAdapterImage` is provided. Will be ignored if the `ipAdapterImageIds` parameter is provided. */
    ipAdapterImageId?: string;
    /** Deprecated for type txt2img-ip-adapter and img2img-ip-adapter, use `ipAdapterScales` instead.
        IpAdapter scale factor (within [0.0, 1.0], default: 0.9). Will be ignored if the `ipAdapterScales` parameter is provided */
    ipAdapterScale?: number;
    /** Used to reproduce previous results. Default: randomly generated number. */
    seed?: string;
    /** The model id to use for the inference */
    modelId: string;
    /** The type of IP Adapter model to use. Must be one of [`style`, `character`], default to `style`` */
    ipAdapterType?: "character" | "style";
    /** If set, generated assets will be hidden and not returned in the list of images of the inference
        or when listing assets (default: false) */
    hideResults?: boolean;
    /** The aspect ratio of the generated images. Only used for the model flux.1.1-pro-ultra.
        The aspect ratio is a string formatted as "width:height" (example: "16:9"). */
    aspectRatio?:
      | "16:9"
      | "1:1"
      | "21:9"
      | "2:3"
      | "3:2"
      | "3:4"
      | "4:3"
      | "4:5"
      | "5:4"
      | "9:16"
      | "9:21";
    /** IpAdapter scale factors (within [0.0, 1.0], default: 0.9). */
    ipAdapterScales?: number[];
    /** Deprecated for type txt2img-ip-adapter and img2img-ip-adapter, use `ipAdapterImages` instead.
        The IpAdapter image as a data url. Will be ignored if the `ipAdapterImages` parameter is provided. */
    ipAdapterImage?: string;
    /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
    negativePrompt?: string;
    /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
    scheduler?:
      | "DDIMScheduler"
      | "DDPMScheduler"
      | "DEISMultistepScheduler"
      | "DPMSolverMultistepScheduler"
      | "DPMSolverSinglestepScheduler"
      | "EulerAncestralDiscreteScheduler"
      | "EulerDiscreteScheduler"
      | "HeunDiscreteScheduler"
      | "KDPM2AncestralDiscreteScheduler"
      | "KDPM2DiscreteScheduler"
      | "LCMScheduler"
      | "LMSDiscreteScheduler"
      | "PNDMScheduler"
      | "TCDScheduler"
      | "UniPCMultistepScheduler";
    /** Enable or disable the intermediate images generation (default: false) */
    intermediateImages?: boolean;
    concepts?: {
      /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
      modelId: string;
      /** The scale of the model (example: 1.0) */
      scale: number;
    }[];
    /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
    guidance?: number;
    /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
    numInferenceSteps?: number;
    /** The number of images to generate (within [1, 128], default: 4) */
    numSamples?: number;
    /** The IpAdapter images as a data url. */
    ipAdapterImages?: string[];
    /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
        If model.type is `sd-1_5`, the width must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
    width?: number;
    /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
        Allowed values are available in the model's attribute: `compliantModelIds` */
    baseModelId?: string;
    /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
    prompt: string;
    /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
        If model.type is `sd-1_5`, the height must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
    height?: number;
  };
};
export type PostTxt2ImgTextureInferencesApiResponse =
  /** status 200 200 response */
  | {
      creativeUnitsCost?: number;
      inference: {
        /** Used to reproduce previous results. Default: randomly generated number. */
        seed?: string;
        /** If set, generated assets will be hidden and not returned in the list of images of the inference
        or when listing assets (default: false) */
        hideResults?: boolean;
        /** The type of inference to use. Example: txt2img, img2img, etc.
        
        Selecting the right type will condition the expected parameters.
        
        Note: if model.type is `sd-xl*` or `sd-1_5*`, when using the `"inpaint"` inference type, Scenario determines the best available `baseModel` for a given `modelId`: one of `["stable-diffusion-inpainting", "stable-diffusion-xl-1.0-inpainting-0.1"] will be used. */
        type:
          | "txt2img"
          | "txt2img_ip_adapter"
          | "txt2img_texture"
          | "img2img"
          | "img2img_ip_adapter"
          | "img2img_texture"
          | "inpaint"
          | "outpaint"
          | "inpaint_ip_adapter"
          | "controlnet"
          | "controlnet_ip_adapter"
          | "reference"
          | "reference_texture"
          | "controlnet_reference"
          | "controlnet_img2img"
          | "controlnet_inpaint"
          | "controlnet_inpaint_ip_adapter"
          | "controlnet_texture";
        /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
        negativePrompt?: string;
        /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
        scheduler?:
          | "DDIMScheduler"
          | "DDPMScheduler"
          | "DEISMultistepScheduler"
          | "DPMSolverMultistepScheduler"
          | "DPMSolverSinglestepScheduler"
          | "EulerAncestralDiscreteScheduler"
          | "EulerDiscreteScheduler"
          | "HeunDiscreteScheduler"
          | "KDPM2AncestralDiscreteScheduler"
          | "KDPM2DiscreteScheduler"
          | "LCMScheduler"
          | "LMSDiscreteScheduler"
          | "PNDMScheduler"
          | "TCDScheduler"
          | "UniPCMultistepScheduler";
        /** Enable or disable the intermediate images generation (default: false) */
        intermediateImages?: boolean;
        concepts?: {
          /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
          modelId: string;
          /** The scale of the model (example: 1.0) */
          scale: number;
        }[];
        /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
        guidance?: number;
        /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
        numInferenceSteps?: number;
        /** The number of images to generate (within [1, 128], default: 4) */
        numSamples?: number;
        /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
        If model.type is `sd-1_5`, the width must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        width?: number;
        /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
        Allowed values are available in the model's attribute: `compliantModelIds` */
        baseModelId?: string;
        /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
        prompt: string;
        /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
        If model.type is `sd-1_5`, the height must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        height?: number;
      };
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostTxt2ImgTextureInferencesApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** Used to reproduce previous results. Default: randomly generated number. */
    seed?: string;
    /** The model id to use for the inference */
    modelId: string;
    /** If set, generated assets will be hidden and not returned in the list of images of the inference
        or when listing assets (default: false) */
    hideResults?: boolean;
    /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
    negativePrompt?: string;
    /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
    scheduler?:
      | "DDIMScheduler"
      | "DDPMScheduler"
      | "DEISMultistepScheduler"
      | "DPMSolverMultistepScheduler"
      | "DPMSolverSinglestepScheduler"
      | "EulerAncestralDiscreteScheduler"
      | "EulerDiscreteScheduler"
      | "HeunDiscreteScheduler"
      | "KDPM2AncestralDiscreteScheduler"
      | "KDPM2DiscreteScheduler"
      | "LCMScheduler"
      | "LMSDiscreteScheduler"
      | "PNDMScheduler"
      | "TCDScheduler"
      | "UniPCMultistepScheduler";
    /** Enable or disable the intermediate images generation (default: false) */
    intermediateImages?: boolean;
    concepts?: {
      /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
      modelId: string;
      /** The scale of the model (example: 1.0) */
      scale: number;
    }[];
    /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
    guidance?: number;
    /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
    numInferenceSteps?: number;
    /** The number of images to generate (within [1, 128], default: 4) */
    numSamples?: number;
    /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
        If model.type is `sd-1_5`, the width must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
    width?: number;
    /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
        Allowed values are available in the model's attribute: `compliantModelIds` */
    baseModelId?: string;
    /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
    prompt: string;
    /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
        If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
        If model.type is `sd-1_5`, the height must be within [64, 1024]
        If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
    height?: number;
  };
};
export type PostUpscaleInferencesApiResponse =
  /** status 200 200 response */
  | {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost?: number;
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostUpscaleInferencesApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** Image to upscale. Must reference an existing AssetId or be a data URL. */
    image: string;
    /** Amount of decay in creativity over the upscale process. The lowest the value, the less the creativity will be preserved over the upscale process. */
    creativityDecay?: number;
    /** If set to true, during the upscaling process, the model will match tiles of the source image with tiles of the style image(s). This will result in a more coherent restyle. Works best with style images that have a similar composition. */
    tileStyle?: boolean;
    /** Used to reproduce previous results. Default: randomly generated number. */
    seed?: number;
    /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
    styleImages?: string[];
    /** Scaling factor (when `targetWidth` not specified) */
    scalingFactor?: number;
    /** Optimize the upscale for a specific use case. Precise: Upscale for high fidelity. Balanced: Upscale for a balance between fidelity and creativity. Creative: Upscale for creativity. */
    preset?: "balanced" | "creative" | "precise";
    /** Condition the influence of the style image(s). The higher the value, the more the style images will influence the upscaled image. */
    styleImagesFidelity?: number;
    /** Amount of details to remove or add */
    detailsLevel?: number;
    /** Determine the scale at which the upscale process works.
        - With a small value, the upscale works at the largest scale, resulting in fewer added details and more coherent images. Ideal for portraits, for example.
        - With a large value, the upscale works at the smallest scale, resulting in more added details and more hallucinations. Ideal for landscapes, for example.
        
        (info): A small value is slower and more expensive to run. */
    fractality?: number;
    /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
    negativePrompt?: string;
    /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
    overrideEmbeddings?: boolean;
    /** Increase the fidelity to the prompt during upscale. Default: optimized for your preset and style. */
    promptFidelity?: number;
    /** Optimize the upscale for a specific style. standard works in most cases. Use one of the other styles to refine the outputs. */
    style?:
      | "3d-rendered"
      | "anime"
      | "cartoon"
      | "comic"
      | "minimalist"
      | "photography"
      | "standard";
    /** Additional refinement steps before scaling.
        
        If scalingFactor == 1, the refinement process will be applied (1 + refinementSteps) times.
        If scalingFactor > 1, the refinement process will be applied refinementSteps times. */
    refinementSteps?: number;
    /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your preset and style. */
    creativity?: number;
    /** Strengthen the similarity to the original image during the upscale. Default: optimized for your preset and style. */
    imageFidelity?: number;
    /** Preserve the seamless properties of skybox or texture images. Input has to be of same type (seamless). */
    imageType?: "seamfull" | "skybox" | "texture";
    /** A full text prompt to guide the upscale and forcing the generation of certain characteristics. Default: empty string. Example: "UHD 8K hyper detailed studio photo of man face with yellow skin, anatomical++, disturbing+++, black background. Bloody++." */
    prompt?: string;
    /** Target width for the upscaled image, take priority over scaling factor */
    targetWidth?: number;
  };
};
export type PostVectorizeInferencesApiResponse =
  /** status 200 200 response */
  | {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost?: number;
      asset?: {
        /** Metadata of the asset with some additional information */
        metadata: {
          maxIterations?: number;
          /** Modality to detect */
          modality?:
            | "canny"
            | "depth"
            | "grayscale"
            | "lineart_anime"
            | "mlsd"
            | "normal"
            | "pose"
            | "scribble"
            | "segmentation"
            | "sketch";
          /** If set to true, during the upscaling process, the model will match tiles of the source image with tiles of the style image(s). This will result in a more coherent restyle. Works best with style images that have a similar composition. */
          tileStyle?: boolean;
          /** The modelId used to generate this asset */
          modelId?: string;
          /** A bounding box around the object of interest, in the format [x1, y1, x2, y2]. */
          bbox?: any[];
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          keypointThreshold?: number;
          /** The type of the asset. Ex: 'inference-txt2img' will represent an asset generated from a text to image model */
          type:
            | "background-removal"
            | "canvas"
            | "canvas-drawing"
            | "canvas-export"
            | "detection"
            | "generative-fill"
            | "image-prompt-editing"
            | "img23d-custom"
            | "img2img-custom"
            | "img2video-custom"
            | "inference-controlnet"
            | "inference-controlnet-img2img"
            | "inference-controlnet-inpaint"
            | "inference-controlnet-inpaint-ip-adapter"
            | "inference-controlnet-ip-adapter"
            | "inference-controlnet-reference"
            | "inference-controlnet-texture"
            | "inference-img2img"
            | "inference-img2img-ip-adapter"
            | "inference-img2img-texture"
            | "inference-inpaint"
            | "inference-inpaint-ip-adapter"
            | "inference-reference"
            | "inference-reference-texture"
            | "inference-txt2img"
            | "inference-txt2img-ip-adapter"
            | "inference-txt2img-texture"
            | "patch"
            | "pixelization"
            | "reframe"
            | "restyle"
            | "segment"
            | "segmentation-image"
            | "segmentation-mask"
            | "skybox-base-360"
            | "texture"
            | "texture-albedo"
            | "texture-ao"
            | "texture-edge"
            | "texture-height"
            | "texture-metallic"
            | "texture-normal"
            | "texture-smoothness"
            | "txt23d-custom"
            | "txt2audio-custom"
            | "txt2img-custom"
            | "unknown-custom"
            | "uploaded"
            | "upscale"
            | "upscale-skybox"
            | "upscale-texture"
            | "vectorization"
            | "video2video-custom";
          /** A textual description / keywords describing the object of interest. */
          text?: string;
          height?: number;
          nbMasks?: number;
          /** Amount of decay in creativity over the upscale process. The lowest the value, the less the creativity will be preserved over the upscale process. */
          creativityDecay?: number;
          layerDifference?: number;
          /** Scaling factor (when `targetWidth` not specified) */
          scalingFactor?: number;
          /** The type of the generator used */
          modelType?:
            | "custom"
            | "flux.1"
            | "flux.1-composition"
            | "flux.1-lora"
            | "flux.1-pro"
            | "flux.1.1-pro-ultra"
            | "flux1.1-pro"
            | "gpt-image-1"
            | "sd-1_5"
            | "sd-1_5-composition"
            | "sd-1_5-lora"
            | "sd-xl"
            | "sd-xl-composition"
            | "sd-xl-lora";
          /** The number of outputs to generate. */
          numOutputs?: number;
          /** How angular is the surface? 0 is like a sphere, 1 is like a mechanical object */
          angular?: number;
          /** The target height of the output image. */
          targetHeight?: number;
          /** Flux LoRa or Composition to style the image. */
          concepts?: {
            weightName: string;
            /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
            modelId: string;
            /** The scale of the model (example: 1.0) */
            scale: number;
          }[];
          size?: number;
          spliceThreshold?: number;
          /** The number of pixels to dilate the result masks. */
          dilate?: number;
          style?:
            | "3d-cartoon"
            | "3d-rendered"
            | "anime"
            | "cartoon"
            | "cinematic"
            | "claymation"
            | "cloud-skydome"
            | "comic"
            | "cyberpunk"
            | "enchanted"
            | "fantasy"
            | "ink"
            | "manga"
            | "manga-color"
            | "minimalist"
            | "neon-tron"
            | "oil-painting"
            | "pastel"
            | "photo"
            | "photography"
            | "psychedelic"
            | "retro-fantasy"
            | "scifi-concept-art"
            | "space"
            | "standard"
            | "whimsical";
          /** Strengthen the similarity to the original image during the upscale. Default: optimized for your preset and style. */
          imageFidelity?: number;
          /** Location of the input image in the output. */
          inputLocation?: "bottom" | "left" | "middle" | "right" | "top";
          /** The seed used to generate this asset */
          seed?: string;
          /** The higher the value the more it will look like the secondary reference image(s) */
          secondaryRefFidelity?: number;
          preset?: string;
          trainingImage?: boolean;
          /** Boolean to able return the masks (binary image) in the response. */
          resultMask?: boolean;
          /** The ISO timestamp when the lock on the canvas will expire */
          lockExpiresAt?: string;
          /** The baseModelId that maybe changed at inference time */
          baseModelId?: string;
          pathPrecision?: number;
          rootParentId?: string;
          /** Sharpen tiles. */
          sharpen?: boolean;
          cornerThreshold?: number;
          /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
          styleImages?: string[];
          /** The asset to convert in texture maps. Must reference an existing AssetId. */
          texture?: string;
          filterSpeckle?: number;
          /** Minimum threshold for Grayscale conversion */
          minThreshold?: number;
          /** Maximum threshold for Grayscale conversion */
          maxThreshold?: number;
          /** Condition the influence of the style image(s). The higher the value, the more the style images will influence the upscaled image. */
          styleImagesFidelity?: number;
          /** The control image processed by depth estimator. Must reference an existing AssetId. */
          depthImage?: string;
          parentId?: string;
          parentJobId?: string;
          /** Optional List of secondary style images. Example: portrait of people. It must be existing AssetIds. */
          secondaryRefImages?: string[];
          /** The width of the rendered image. */
          width?: number;
          /** The checkpoint to use */
          checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
          strength?: number;
          /** The id of the Inference describing how this image was generated */
          inferenceId?: string;
          lengthThreshold?: number;
          /** Int to set between 0 and 255 for the opacity of the background in the result images. */
          backgroundOpacity?: number;
          /** The optional aspect ratio given for the generation, only applicable for some models */
          aspectRatio?: string;
          /** Amount of details to remove or add */
          detailsLevel?: number;
          /** Determine the scale at which the upscale process works.
            - With a small value, the upscale works at the largest scale, resulting in fewer added details and more coherent images. Ideal for portraits, for example.
            - With a large value, the upscale works at the smallest scale, resulting in more added details and more hallucinations. Ideal for landscapes, for example.
            
            (info): A small value is slower and more expensive to run. */
          fractality?: number;
          /** (deprecated) Horizontal expansion ratio. */
          horizontalExpansionRatio?: number;
          /** List of points (label, x, y) in the image where label = 0 for background and 1 for object. */
          points?: any[][];
          mode?: string;
          colorPrecision?: number;
          /** Increase the fidelity to the prompt during upscale. Default: optimized for your preset and style. */
          promptFidelity?: number;
          /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
          betterQuality?: boolean;
          /** Remove background for Grayscale detector */
          removeBackground?: boolean;
          /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your preset and style. */
          creativity?: number;
          /** Strength for the input image structure preservation */
          structureFidelity?: number;
          /** Preserve the seamless properties of skybox or texture images. Input has to be of same type (seamless). */
          imageType?: "seamfull" | "skybox" | "texture";
          /** The input image to process. Must reference an existing AssetId or be a data URL. */
          image?: string;
          /** The thumbnail of the canvas */
          thumbnail?: {
            /** The AssetId of the image used as a thumbnail for the canvas (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
            assetId: string;
            /** The url of the image used as a thumbnail for the canvas */
            url: string;
          };
          /** The control image for structure. A canny detector will be applied to this image. Must reference an existing AssetId. */
          structureImage?: string;
          /** To invert the relief */
          invert?: boolean;
          kind: "3d" | "audio" | "document" | "image" | "json" | "video";
          colorMode?: string;
          /** High threshold for Canny detector */
          highThreshold?: number;
          /** (deprecated) Vertical expansion ratio. */
          verticalExpansionRatio?: number;
          halfMode?: boolean;
          name?: string;
          /** Additional refinement steps before scaling.
            
            If scalingFactor == 1, the refinement process will be applied (1 + refinementSteps) times.
            If scalingFactor > 1, the refinement process will be applied refinementSteps times. */
          refinementSteps?: number;
          /** The reference images used for the image generation or editing */
          referenceImages?: string[];
          /** The higher the value the more it will look like the style image(s) */
          styleFidelity?: number;
          /** Boolean to output the contours. */
          resultContours?: boolean;
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          polished?: number;
          /** The scheduler used to generate this asset */
          scheduler?: string;
          /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
          overrideEmbeddings?: boolean;
          progressPercent?: number;
          /** Contrast factor for Grayscale detector */
          factor?: number;
          /** The mask used for the image generation or editing */
          mask?: string;
          /** Low threshold for Canny detector */
          lowThreshold?: number;
          /** The depth fidelity if a depth image provided */
          depthFidelity?: number;
          /** How raised is the surface? 0 is flat like water, 1 is like a very rough rock */
          raised?: number;
          message?: string;
          contours?: number[][][][];
          /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
          negativePrompt?: string;
          /** If true, use the default parameters */
          defaultParameters?: boolean;
          /** Size proportion of the input image in the output. */
          resizeOption?: number;
          outputIndex?: number;
          /** Save a flipbook of the texture. Deactivated when the input texture is larger than 2048x2048px */
          saveFlipbook?: boolean;
          /** The guidance used to generate this asset */
          guidance?: number;
          /** The number of denoising steps for each image generation. */
          numInferenceSteps?: number;
          hdr?: number;
          /** How shiny is the surface? 0 is like a matte surface, 1 is like a diamond */
          shiny?: number;
          /** Ensure upscaled tile have the same color histogram as original tile. */
          colorCorrection?: boolean;
          /** Overlap percentage for the output image. */
          overlapPercentage?: number;
          /** The prompt that guided the image generation or editing */
          prompt?: string;
          /** Boolean to able output the cut out object. */
          resultImage?: boolean;
          /** The control image already processed by canny detector. Must reference an existing AssetId. */
          cannyStructureImage?: string;
          /** Apply extra control to the Skybox 360 geometry.
            The higher the value, the more the 360 geometry will influence the generated skybox image.
            
            Use with caution. Default is adapted to the other parameters. */
          geometryEnforcement?: number;
          /** Target width for the upscaled image, take priority over scaling factor */
          targetWidth?: number;
        };
        /** The NSFW labels */
        nsfw?: string[];
        /** Automatic captioning of the asset */
        automaticCaptioning?: string;
        /** The description of the asset */
        description?: string;
        /** The privacy of the asset */
        privacy: "private" | "public" | "unlisted";
        /** The date when the asset will be soft deleted (only for Free plan) */
        softDeletionOn?: string;
        /** The mime type of the asset (example: "image/png") */
        mimeType: string;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId: string;
        /** The owner (project) ID (example: "proj_23tlk332lkht3kl2" or "team_dlkhgs23tlk3hlkth32lkht3kl2" for old teams) */
        ownerId: string;
        /** Signed URL to get the asset content */
        url: string;
        /** The associated tags (example: ["sci-fi", "landscape"]) */
        tags: string[];
        /** The asset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The output index of the asset within the job
        This index is an positive integer that starts at 0
        It is used to differentiate between multiple outputs of the same job
        If the job has only one output, this index is 0
        This is only applicable for generations with: Flux, Skybox, Reframe at the moment */
        outputIndex?: number;
        /** A list of CollectionId this asset belongs to */
        collectionIds: string[];
        /** List of edit capabilities for the asset */
        editCapabilities: (
          | "DETECTION"
          | "GENERATIVE_FILL"
          | "PIXELATE"
          | "PROMPT_EDITING"
          | "REFINE"
          | "REFRAME"
          | "REMOVE_BACKGROUND"
          | "SEGMENTATION"
          | "UPSCALE"
          | "UPSCALE_360"
          | "VECTORIZATION"
        )[];
        /** The embedding of the asset when requested and asset can be embedded
        
        ie: Detection maps don't have embeddings */
        embedding?: number[];
        /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        id: string;
        /** The status of the asset */
        status: "error" | "pending" | "success";
        /** The asset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostVectorizeInferencesApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** Curver fitting mode `none`, `polygon`, `spline` */
    mode?: "none" | "polygon" | "spline";
    /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") to vectorize. */
    image: string;
    /** Represents the color difference between gradient layers (higher value will reduce the number of layers)
        
        Only applicable to `color` colorMode. */
    layerDifference?: number;
    /** Max iterations for rendering */
    maxIterations?: number;
    /** Minimum momentary angle (degree) to be considered a corner (higher value will smooth corners)
        
        Only applicable to `spline` mode. */
    cornerThreshold?: number;
    /** Number of significant bits to use in an RGB channel, min 1, max 16 (higher value will increase precision)
        
        Only applicable to `color` colorMode. */
    colorPrecision?: number;
    /** Minimum angle displacement (degree) to splice a spline (higher value reduce accuracy)
        
        Only applicable to `spline` mode. */
    spliceThreshold?: number;
    /** Minimum length of a segment (higher value will generate more coarse output)
        
        Only applicable to `spline` mode. */
    lengthThreshold?: number;
    /** Color mode `bw`, `color`. If `bw`, the image will be considered as black and white. */
    colorMode?: "bw" | "color";
    /** Discard patches smaller than X px in size (higher value will reduce the number of patches, cleaner output) */
    filterSpeckle?: number;
    /** If preset given, all other parameters will be ignored (mode, colorMode, filterSpeckle, ...), except for custom. */
    preset?: "asset" | "bw" | "custom" | "photo" | "pixelart" | "poster";
    /** Number of decimal places to use in path string */
    pathPrecision?: number;
  };
};
export type PutImagesDetectionApiResponse =
  /** status 200 200 response */
  | {
      asset: {
        /** Metadata of the asset with some additional information */
        metadata: {
          maxIterations?: number;
          /** Modality to detect */
          modality?:
            | "canny"
            | "depth"
            | "grayscale"
            | "lineart_anime"
            | "mlsd"
            | "normal"
            | "pose"
            | "scribble"
            | "segmentation"
            | "sketch";
          /** If set to true, during the upscaling process, the model will match tiles of the source image with tiles of the style image(s). This will result in a more coherent restyle. Works best with style images that have a similar composition. */
          tileStyle?: boolean;
          /** The modelId used to generate this asset */
          modelId?: string;
          /** A bounding box around the object of interest, in the format [x1, y1, x2, y2]. */
          bbox?: any[];
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          keypointThreshold?: number;
          /** The type of the asset. Ex: 'inference-txt2img' will represent an asset generated from a text to image model */
          type:
            | "background-removal"
            | "canvas"
            | "canvas-drawing"
            | "canvas-export"
            | "detection"
            | "generative-fill"
            | "image-prompt-editing"
            | "img23d-custom"
            | "img2img-custom"
            | "img2video-custom"
            | "inference-controlnet"
            | "inference-controlnet-img2img"
            | "inference-controlnet-inpaint"
            | "inference-controlnet-inpaint-ip-adapter"
            | "inference-controlnet-ip-adapter"
            | "inference-controlnet-reference"
            | "inference-controlnet-texture"
            | "inference-img2img"
            | "inference-img2img-ip-adapter"
            | "inference-img2img-texture"
            | "inference-inpaint"
            | "inference-inpaint-ip-adapter"
            | "inference-reference"
            | "inference-reference-texture"
            | "inference-txt2img"
            | "inference-txt2img-ip-adapter"
            | "inference-txt2img-texture"
            | "patch"
            | "pixelization"
            | "reframe"
            | "restyle"
            | "segment"
            | "segmentation-image"
            | "segmentation-mask"
            | "skybox-base-360"
            | "texture"
            | "texture-albedo"
            | "texture-ao"
            | "texture-edge"
            | "texture-height"
            | "texture-metallic"
            | "texture-normal"
            | "texture-smoothness"
            | "txt23d-custom"
            | "txt2audio-custom"
            | "txt2img-custom"
            | "unknown-custom"
            | "uploaded"
            | "upscale"
            | "upscale-skybox"
            | "upscale-texture"
            | "vectorization"
            | "video2video-custom";
          /** A textual description / keywords describing the object of interest. */
          text?: string;
          height?: number;
          nbMasks?: number;
          /** Amount of decay in creativity over the upscale process. The lowest the value, the less the creativity will be preserved over the upscale process. */
          creativityDecay?: number;
          layerDifference?: number;
          /** Scaling factor (when `targetWidth` not specified) */
          scalingFactor?: number;
          /** The type of the generator used */
          modelType?:
            | "custom"
            | "flux.1"
            | "flux.1-composition"
            | "flux.1-lora"
            | "flux.1-pro"
            | "flux.1.1-pro-ultra"
            | "flux1.1-pro"
            | "gpt-image-1"
            | "sd-1_5"
            | "sd-1_5-composition"
            | "sd-1_5-lora"
            | "sd-xl"
            | "sd-xl-composition"
            | "sd-xl-lora";
          /** The number of outputs to generate. */
          numOutputs?: number;
          /** How angular is the surface? 0 is like a sphere, 1 is like a mechanical object */
          angular?: number;
          /** The target height of the output image. */
          targetHeight?: number;
          /** Flux LoRa or Composition to style the image. */
          concepts?: {
            weightName: string;
            /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
            modelId: string;
            /** The scale of the model (example: 1.0) */
            scale: number;
          }[];
          size?: number;
          spliceThreshold?: number;
          /** The number of pixels to dilate the result masks. */
          dilate?: number;
          style?:
            | "3d-cartoon"
            | "3d-rendered"
            | "anime"
            | "cartoon"
            | "cinematic"
            | "claymation"
            | "cloud-skydome"
            | "comic"
            | "cyberpunk"
            | "enchanted"
            | "fantasy"
            | "ink"
            | "manga"
            | "manga-color"
            | "minimalist"
            | "neon-tron"
            | "oil-painting"
            | "pastel"
            | "photo"
            | "photography"
            | "psychedelic"
            | "retro-fantasy"
            | "scifi-concept-art"
            | "space"
            | "standard"
            | "whimsical";
          /** Strengthen the similarity to the original image during the upscale. Default: optimized for your preset and style. */
          imageFidelity?: number;
          /** Location of the input image in the output. */
          inputLocation?: "bottom" | "left" | "middle" | "right" | "top";
          /** The seed used to generate this asset */
          seed?: string;
          /** The higher the value the more it will look like the secondary reference image(s) */
          secondaryRefFidelity?: number;
          preset?: string;
          trainingImage?: boolean;
          /** Boolean to able return the masks (binary image) in the response. */
          resultMask?: boolean;
          /** The ISO timestamp when the lock on the canvas will expire */
          lockExpiresAt?: string;
          /** The baseModelId that maybe changed at inference time */
          baseModelId?: string;
          pathPrecision?: number;
          rootParentId?: string;
          /** Sharpen tiles. */
          sharpen?: boolean;
          cornerThreshold?: number;
          /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
          styleImages?: string[];
          /** The asset to convert in texture maps. Must reference an existing AssetId. */
          texture?: string;
          filterSpeckle?: number;
          /** Minimum threshold for Grayscale conversion */
          minThreshold?: number;
          /** Maximum threshold for Grayscale conversion */
          maxThreshold?: number;
          /** Condition the influence of the style image(s). The higher the value, the more the style images will influence the upscaled image. */
          styleImagesFidelity?: number;
          /** The control image processed by depth estimator. Must reference an existing AssetId. */
          depthImage?: string;
          parentId?: string;
          parentJobId?: string;
          /** Optional List of secondary style images. Example: portrait of people. It must be existing AssetIds. */
          secondaryRefImages?: string[];
          /** The width of the rendered image. */
          width?: number;
          /** The checkpoint to use */
          checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
          strength?: number;
          /** The id of the Inference describing how this image was generated */
          inferenceId?: string;
          lengthThreshold?: number;
          /** Int to set between 0 and 255 for the opacity of the background in the result images. */
          backgroundOpacity?: number;
          /** The optional aspect ratio given for the generation, only applicable for some models */
          aspectRatio?: string;
          /** Amount of details to remove or add */
          detailsLevel?: number;
          /** Determine the scale at which the upscale process works.
            - With a small value, the upscale works at the largest scale, resulting in fewer added details and more coherent images. Ideal for portraits, for example.
            - With a large value, the upscale works at the smallest scale, resulting in more added details and more hallucinations. Ideal for landscapes, for example.
            
            (info): A small value is slower and more expensive to run. */
          fractality?: number;
          /** (deprecated) Horizontal expansion ratio. */
          horizontalExpansionRatio?: number;
          /** List of points (label, x, y) in the image where label = 0 for background and 1 for object. */
          points?: any[][];
          mode?: string;
          colorPrecision?: number;
          /** Increase the fidelity to the prompt during upscale. Default: optimized for your preset and style. */
          promptFidelity?: number;
          /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
          betterQuality?: boolean;
          /** Remove background for Grayscale detector */
          removeBackground?: boolean;
          /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your preset and style. */
          creativity?: number;
          /** Strength for the input image structure preservation */
          structureFidelity?: number;
          /** Preserve the seamless properties of skybox or texture images. Input has to be of same type (seamless). */
          imageType?: "seamfull" | "skybox" | "texture";
          /** The input image to process. Must reference an existing AssetId or be a data URL. */
          image?: string;
          /** The thumbnail of the canvas */
          thumbnail?: {
            /** The AssetId of the image used as a thumbnail for the canvas (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
            assetId: string;
            /** The url of the image used as a thumbnail for the canvas */
            url: string;
          };
          /** The control image for structure. A canny detector will be applied to this image. Must reference an existing AssetId. */
          structureImage?: string;
          /** To invert the relief */
          invert?: boolean;
          kind: "3d" | "audio" | "document" | "image" | "json" | "video";
          colorMode?: string;
          /** High threshold for Canny detector */
          highThreshold?: number;
          /** (deprecated) Vertical expansion ratio. */
          verticalExpansionRatio?: number;
          halfMode?: boolean;
          name?: string;
          /** Additional refinement steps before scaling.
            
            If scalingFactor == 1, the refinement process will be applied (1 + refinementSteps) times.
            If scalingFactor > 1, the refinement process will be applied refinementSteps times. */
          refinementSteps?: number;
          /** The reference images used for the image generation or editing */
          referenceImages?: string[];
          /** The higher the value the more it will look like the style image(s) */
          styleFidelity?: number;
          /** Boolean to output the contours. */
          resultContours?: boolean;
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          polished?: number;
          /** The scheduler used to generate this asset */
          scheduler?: string;
          /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
          overrideEmbeddings?: boolean;
          progressPercent?: number;
          /** Contrast factor for Grayscale detector */
          factor?: number;
          /** The mask used for the image generation or editing */
          mask?: string;
          /** Low threshold for Canny detector */
          lowThreshold?: number;
          /** The depth fidelity if a depth image provided */
          depthFidelity?: number;
          /** How raised is the surface? 0 is flat like water, 1 is like a very rough rock */
          raised?: number;
          message?: string;
          contours?: number[][][][];
          /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
          negativePrompt?: string;
          /** If true, use the default parameters */
          defaultParameters?: boolean;
          /** Size proportion of the input image in the output. */
          resizeOption?: number;
          outputIndex?: number;
          /** Save a flipbook of the texture. Deactivated when the input texture is larger than 2048x2048px */
          saveFlipbook?: boolean;
          /** The guidance used to generate this asset */
          guidance?: number;
          /** The number of denoising steps for each image generation. */
          numInferenceSteps?: number;
          hdr?: number;
          /** How shiny is the surface? 0 is like a matte surface, 1 is like a diamond */
          shiny?: number;
          /** Ensure upscaled tile have the same color histogram as original tile. */
          colorCorrection?: boolean;
          /** Overlap percentage for the output image. */
          overlapPercentage?: number;
          /** The prompt that guided the image generation or editing */
          prompt?: string;
          /** Boolean to able output the cut out object. */
          resultImage?: boolean;
          /** The control image already processed by canny detector. Must reference an existing AssetId. */
          cannyStructureImage?: string;
          /** Apply extra control to the Skybox 360 geometry.
            The higher the value, the more the 360 geometry will influence the generated skybox image.
            
            Use with caution. Default is adapted to the other parameters. */
          geometryEnforcement?: number;
          /** Target width for the upscaled image, take priority over scaling factor */
          targetWidth?: number;
        };
        /** The NSFW labels */
        nsfw?: string[];
        /** Automatic captioning of the asset */
        automaticCaptioning?: string;
        /** The description of the asset */
        description?: string;
        /** The privacy of the asset */
        privacy: "private" | "public" | "unlisted";
        /** The date when the asset will be soft deleted (only for Free plan) */
        softDeletionOn?: string;
        /** The mime type of the asset (example: "image/png") */
        mimeType: string;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId: string;
        /** The owner (project) ID (example: "proj_23tlk332lkht3kl2" or "team_dlkhgs23tlk3hlkth32lkht3kl2" for old teams) */
        ownerId: string;
        /** Signed URL to get the asset content */
        url: string;
        /** The associated tags (example: ["sci-fi", "landscape"]) */
        tags: string[];
        /** The asset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The output index of the asset within the job
        This index is an positive integer that starts at 0
        It is used to differentiate between multiple outputs of the same job
        If the job has only one output, this index is 0
        This is only applicable for generations with: Flux, Skybox, Reframe at the moment */
        outputIndex?: number;
        /** A list of CollectionId this asset belongs to */
        collectionIds: string[];
        /** List of edit capabilities for the asset */
        editCapabilities: (
          | "DETECTION"
          | "GENERATIVE_FILL"
          | "PIXELATE"
          | "PROMPT_EDITING"
          | "REFINE"
          | "REFRAME"
          | "REMOVE_BACKGROUND"
          | "SEGMENTATION"
          | "UPSCALE"
          | "UPSCALE_360"
          | "VECTORIZATION"
        )[];
        /** The embedding of the asset when requested and asset can be embedded
        
        ie: Detection maps don't have embeddings */
        embedding?: number[];
        /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        id: string;
        /** The status of the asset */
        status: "error" | "pending" | "success";
        /** The asset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PutImagesDetectionApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The input image as a data URL (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=") or the asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw"). */
    image?: string;
    modality:
      | "canny"
      | "depth"
      | "grayscale"
      | "lineart"
      | "lines"
      | "normal-map"
      | "pose"
      | "scribble"
      | "seg";
    /** Deprecated: The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw"). Prefer to use image with the asset ID instead. */
    assetId?: string;
    /** The original file name of the image (example: "low-res-image.jpg"). It will be ignored if assetId is provided. */
    name?: string;
    parameters?: {
      /** For Grayscale modality
            The minimum threshold to apply to the grayscale (example: 10). */
      thresholdMin?: number;
      /** For Canny modality
            The threshold for the hysteresis procedure (example: 100). */
      lowThreshold?: number;
      /** For Grayscale modality
            Whether to remove the background (example: true). */
      removeBackground?: boolean;
      /** For Grayscale modality
            The factor to apply to the grayscale (example: 5). */
      factor?: number;
      /** For Canny modality
            The threshold for the hysteresis procedure (example: 200).
            It must be larger than lowThreshold.
            It is recommended to be 2 or 3 times larger than lowThreshold.
            If not provided, it will be set to 2 * lowThreshold. */
      highThreshold?: number;
      /** For Grayscale modality
            The maximum threshold to apply to the grayscale (example: 90). */
      thresholdMax?: number;
    };
  };
};
export type PutImagesEraseBackgroundApiResponse =
  /** status 200 200 response */
  | {
      /** The image without background in base64 format string only if returnImage is true. */
      image?: string;
      asset: {
        /** Metadata of the asset with some additional information */
        metadata: {
          maxIterations?: number;
          /** Modality to detect */
          modality?:
            | "canny"
            | "depth"
            | "grayscale"
            | "lineart_anime"
            | "mlsd"
            | "normal"
            | "pose"
            | "scribble"
            | "segmentation"
            | "sketch";
          /** If set to true, during the upscaling process, the model will match tiles of the source image with tiles of the style image(s). This will result in a more coherent restyle. Works best with style images that have a similar composition. */
          tileStyle?: boolean;
          /** The modelId used to generate this asset */
          modelId?: string;
          /** A bounding box around the object of interest, in the format [x1, y1, x2, y2]. */
          bbox?: any[];
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          keypointThreshold?: number;
          /** The type of the asset. Ex: 'inference-txt2img' will represent an asset generated from a text to image model */
          type:
            | "background-removal"
            | "canvas"
            | "canvas-drawing"
            | "canvas-export"
            | "detection"
            | "generative-fill"
            | "image-prompt-editing"
            | "img23d-custom"
            | "img2img-custom"
            | "img2video-custom"
            | "inference-controlnet"
            | "inference-controlnet-img2img"
            | "inference-controlnet-inpaint"
            | "inference-controlnet-inpaint-ip-adapter"
            | "inference-controlnet-ip-adapter"
            | "inference-controlnet-reference"
            | "inference-controlnet-texture"
            | "inference-img2img"
            | "inference-img2img-ip-adapter"
            | "inference-img2img-texture"
            | "inference-inpaint"
            | "inference-inpaint-ip-adapter"
            | "inference-reference"
            | "inference-reference-texture"
            | "inference-txt2img"
            | "inference-txt2img-ip-adapter"
            | "inference-txt2img-texture"
            | "patch"
            | "pixelization"
            | "reframe"
            | "restyle"
            | "segment"
            | "segmentation-image"
            | "segmentation-mask"
            | "skybox-base-360"
            | "texture"
            | "texture-albedo"
            | "texture-ao"
            | "texture-edge"
            | "texture-height"
            | "texture-metallic"
            | "texture-normal"
            | "texture-smoothness"
            | "txt23d-custom"
            | "txt2audio-custom"
            | "txt2img-custom"
            | "unknown-custom"
            | "uploaded"
            | "upscale"
            | "upscale-skybox"
            | "upscale-texture"
            | "vectorization"
            | "video2video-custom";
          /** A textual description / keywords describing the object of interest. */
          text?: string;
          height?: number;
          nbMasks?: number;
          /** Amount of decay in creativity over the upscale process. The lowest the value, the less the creativity will be preserved over the upscale process. */
          creativityDecay?: number;
          layerDifference?: number;
          /** Scaling factor (when `targetWidth` not specified) */
          scalingFactor?: number;
          /** The type of the generator used */
          modelType?:
            | "custom"
            | "flux.1"
            | "flux.1-composition"
            | "flux.1-lora"
            | "flux.1-pro"
            | "flux.1.1-pro-ultra"
            | "flux1.1-pro"
            | "gpt-image-1"
            | "sd-1_5"
            | "sd-1_5-composition"
            | "sd-1_5-lora"
            | "sd-xl"
            | "sd-xl-composition"
            | "sd-xl-lora";
          /** The number of outputs to generate. */
          numOutputs?: number;
          /** How angular is the surface? 0 is like a sphere, 1 is like a mechanical object */
          angular?: number;
          /** The target height of the output image. */
          targetHeight?: number;
          /** Flux LoRa or Composition to style the image. */
          concepts?: {
            weightName: string;
            /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
            modelId: string;
            /** The scale of the model (example: 1.0) */
            scale: number;
          }[];
          size?: number;
          spliceThreshold?: number;
          /** The number of pixels to dilate the result masks. */
          dilate?: number;
          style?:
            | "3d-cartoon"
            | "3d-rendered"
            | "anime"
            | "cartoon"
            | "cinematic"
            | "claymation"
            | "cloud-skydome"
            | "comic"
            | "cyberpunk"
            | "enchanted"
            | "fantasy"
            | "ink"
            | "manga"
            | "manga-color"
            | "minimalist"
            | "neon-tron"
            | "oil-painting"
            | "pastel"
            | "photo"
            | "photography"
            | "psychedelic"
            | "retro-fantasy"
            | "scifi-concept-art"
            | "space"
            | "standard"
            | "whimsical";
          /** Strengthen the similarity to the original image during the upscale. Default: optimized for your preset and style. */
          imageFidelity?: number;
          /** Location of the input image in the output. */
          inputLocation?: "bottom" | "left" | "middle" | "right" | "top";
          /** The seed used to generate this asset */
          seed?: string;
          /** The higher the value the more it will look like the secondary reference image(s) */
          secondaryRefFidelity?: number;
          preset?: string;
          trainingImage?: boolean;
          /** Boolean to able return the masks (binary image) in the response. */
          resultMask?: boolean;
          /** The ISO timestamp when the lock on the canvas will expire */
          lockExpiresAt?: string;
          /** The baseModelId that maybe changed at inference time */
          baseModelId?: string;
          pathPrecision?: number;
          rootParentId?: string;
          /** Sharpen tiles. */
          sharpen?: boolean;
          cornerThreshold?: number;
          /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
          styleImages?: string[];
          /** The asset to convert in texture maps. Must reference an existing AssetId. */
          texture?: string;
          filterSpeckle?: number;
          /** Minimum threshold for Grayscale conversion */
          minThreshold?: number;
          /** Maximum threshold for Grayscale conversion */
          maxThreshold?: number;
          /** Condition the influence of the style image(s). The higher the value, the more the style images will influence the upscaled image. */
          styleImagesFidelity?: number;
          /** The control image processed by depth estimator. Must reference an existing AssetId. */
          depthImage?: string;
          parentId?: string;
          parentJobId?: string;
          /** Optional List of secondary style images. Example: portrait of people. It must be existing AssetIds. */
          secondaryRefImages?: string[];
          /** The width of the rendered image. */
          width?: number;
          /** The checkpoint to use */
          checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
          strength?: number;
          /** The id of the Inference describing how this image was generated */
          inferenceId?: string;
          lengthThreshold?: number;
          /** Int to set between 0 and 255 for the opacity of the background in the result images. */
          backgroundOpacity?: number;
          /** The optional aspect ratio given for the generation, only applicable for some models */
          aspectRatio?: string;
          /** Amount of details to remove or add */
          detailsLevel?: number;
          /** Determine the scale at which the upscale process works.
            - With a small value, the upscale works at the largest scale, resulting in fewer added details and more coherent images. Ideal for portraits, for example.
            - With a large value, the upscale works at the smallest scale, resulting in more added details and more hallucinations. Ideal for landscapes, for example.
            
            (info): A small value is slower and more expensive to run. */
          fractality?: number;
          /** (deprecated) Horizontal expansion ratio. */
          horizontalExpansionRatio?: number;
          /** List of points (label, x, y) in the image where label = 0 for background and 1 for object. */
          points?: any[][];
          mode?: string;
          colorPrecision?: number;
          /** Increase the fidelity to the prompt during upscale. Default: optimized for your preset and style. */
          promptFidelity?: number;
          /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
          betterQuality?: boolean;
          /** Remove background for Grayscale detector */
          removeBackground?: boolean;
          /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your preset and style. */
          creativity?: number;
          /** Strength for the input image structure preservation */
          structureFidelity?: number;
          /** Preserve the seamless properties of skybox or texture images. Input has to be of same type (seamless). */
          imageType?: "seamfull" | "skybox" | "texture";
          /** The input image to process. Must reference an existing AssetId or be a data URL. */
          image?: string;
          /** The thumbnail of the canvas */
          thumbnail?: {
            /** The AssetId of the image used as a thumbnail for the canvas (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
            assetId: string;
            /** The url of the image used as a thumbnail for the canvas */
            url: string;
          };
          /** The control image for structure. A canny detector will be applied to this image. Must reference an existing AssetId. */
          structureImage?: string;
          /** To invert the relief */
          invert?: boolean;
          kind: "3d" | "audio" | "document" | "image" | "json" | "video";
          colorMode?: string;
          /** High threshold for Canny detector */
          highThreshold?: number;
          /** (deprecated) Vertical expansion ratio. */
          verticalExpansionRatio?: number;
          halfMode?: boolean;
          name?: string;
          /** Additional refinement steps before scaling.
            
            If scalingFactor == 1, the refinement process will be applied (1 + refinementSteps) times.
            If scalingFactor > 1, the refinement process will be applied refinementSteps times. */
          refinementSteps?: number;
          /** The reference images used for the image generation or editing */
          referenceImages?: string[];
          /** The higher the value the more it will look like the style image(s) */
          styleFidelity?: number;
          /** Boolean to output the contours. */
          resultContours?: boolean;
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          polished?: number;
          /** The scheduler used to generate this asset */
          scheduler?: string;
          /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
          overrideEmbeddings?: boolean;
          progressPercent?: number;
          /** Contrast factor for Grayscale detector */
          factor?: number;
          /** The mask used for the image generation or editing */
          mask?: string;
          /** Low threshold for Canny detector */
          lowThreshold?: number;
          /** The depth fidelity if a depth image provided */
          depthFidelity?: number;
          /** How raised is the surface? 0 is flat like water, 1 is like a very rough rock */
          raised?: number;
          message?: string;
          contours?: number[][][][];
          /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
          negativePrompt?: string;
          /** If true, use the default parameters */
          defaultParameters?: boolean;
          /** Size proportion of the input image in the output. */
          resizeOption?: number;
          outputIndex?: number;
          /** Save a flipbook of the texture. Deactivated when the input texture is larger than 2048x2048px */
          saveFlipbook?: boolean;
          /** The guidance used to generate this asset */
          guidance?: number;
          /** The number of denoising steps for each image generation. */
          numInferenceSteps?: number;
          hdr?: number;
          /** How shiny is the surface? 0 is like a matte surface, 1 is like a diamond */
          shiny?: number;
          /** Ensure upscaled tile have the same color histogram as original tile. */
          colorCorrection?: boolean;
          /** Overlap percentage for the output image. */
          overlapPercentage?: number;
          /** The prompt that guided the image generation or editing */
          prompt?: string;
          /** Boolean to able output the cut out object. */
          resultImage?: boolean;
          /** The control image already processed by canny detector. Must reference an existing AssetId. */
          cannyStructureImage?: string;
          /** Apply extra control to the Skybox 360 geometry.
            The higher the value, the more the 360 geometry will influence the generated skybox image.
            
            Use with caution. Default is adapted to the other parameters. */
          geometryEnforcement?: number;
          /** Target width for the upscaled image, take priority over scaling factor */
          targetWidth?: number;
        };
        /** The NSFW labels */
        nsfw?: string[];
        /** Automatic captioning of the asset */
        automaticCaptioning?: string;
        /** The description of the asset */
        description?: string;
        /** The privacy of the asset */
        privacy: "private" | "public" | "unlisted";
        /** The date when the asset will be soft deleted (only for Free plan) */
        softDeletionOn?: string;
        /** The mime type of the asset (example: "image/png") */
        mimeType: string;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId: string;
        /** The owner (project) ID (example: "proj_23tlk332lkht3kl2" or "team_dlkhgs23tlk3hlkth32lkht3kl2" for old teams) */
        ownerId: string;
        /** Signed URL to get the asset content */
        url: string;
        /** The associated tags (example: ["sci-fi", "landscape"]) */
        tags: string[];
        /** The asset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The output index of the asset within the job
        This index is an positive integer that starts at 0
        It is used to differentiate between multiple outputs of the same job
        If the job has only one output, this index is 0
        This is only applicable for generations with: Flux, Skybox, Reframe at the moment */
        outputIndex?: number;
        /** A list of CollectionId this asset belongs to */
        collectionIds: string[];
        /** List of edit capabilities for the asset */
        editCapabilities: (
          | "DETECTION"
          | "GENERATIVE_FILL"
          | "PIXELATE"
          | "PROMPT_EDITING"
          | "REFINE"
          | "REFRAME"
          | "REMOVE_BACKGROUND"
          | "SEGMENTATION"
          | "UPSCALE"
          | "UPSCALE_360"
          | "VECTORIZATION"
        )[];
        /** The embedding of the asset when requested and asset can be embedded
        
        ie: Detection maps don't have embeddings */
        embedding?: number[];
        /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        id: string;
        /** The status of the asset */
        status: "error" | "pending" | "success";
        /** The asset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PutImagesEraseBackgroundApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The input image as a data URL (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=") or the asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
    image?: string;
    /** The background color as an hexadecimal code (ex: "#FFFFff"), an html color (ex: "red") or "transparent" if "format" is "png" */
    backgroundColor?: string;
    /** Deprecated: The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw"). Prefer to use image with the asset ID instead. */
    assetId?: string;
    /** The output format */
    format?: "jpeg" | "png";
    /** The original file name of the image (example: "low-res-image.jpg"). It will be ignored if assetId is provided. */
    name?: string;
    /** If true, the image will be returned in the response. */
    returnImage?: boolean;
  };
};
export type PutImagePatchApiResponse =
  /** status 200 200 response */
  | {
      asset: {
        /** Metadata of the asset with some additional information */
        metadata: {
          maxIterations?: number;
          /** Modality to detect */
          modality?:
            | "canny"
            | "depth"
            | "grayscale"
            | "lineart_anime"
            | "mlsd"
            | "normal"
            | "pose"
            | "scribble"
            | "segmentation"
            | "sketch";
          /** If set to true, during the upscaling process, the model will match tiles of the source image with tiles of the style image(s). This will result in a more coherent restyle. Works best with style images that have a similar composition. */
          tileStyle?: boolean;
          /** The modelId used to generate this asset */
          modelId?: string;
          /** A bounding box around the object of interest, in the format [x1, y1, x2, y2]. */
          bbox?: any[];
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          keypointThreshold?: number;
          /** The type of the asset. Ex: 'inference-txt2img' will represent an asset generated from a text to image model */
          type:
            | "background-removal"
            | "canvas"
            | "canvas-drawing"
            | "canvas-export"
            | "detection"
            | "generative-fill"
            | "image-prompt-editing"
            | "img23d-custom"
            | "img2img-custom"
            | "img2video-custom"
            | "inference-controlnet"
            | "inference-controlnet-img2img"
            | "inference-controlnet-inpaint"
            | "inference-controlnet-inpaint-ip-adapter"
            | "inference-controlnet-ip-adapter"
            | "inference-controlnet-reference"
            | "inference-controlnet-texture"
            | "inference-img2img"
            | "inference-img2img-ip-adapter"
            | "inference-img2img-texture"
            | "inference-inpaint"
            | "inference-inpaint-ip-adapter"
            | "inference-reference"
            | "inference-reference-texture"
            | "inference-txt2img"
            | "inference-txt2img-ip-adapter"
            | "inference-txt2img-texture"
            | "patch"
            | "pixelization"
            | "reframe"
            | "restyle"
            | "segment"
            | "segmentation-image"
            | "segmentation-mask"
            | "skybox-base-360"
            | "texture"
            | "texture-albedo"
            | "texture-ao"
            | "texture-edge"
            | "texture-height"
            | "texture-metallic"
            | "texture-normal"
            | "texture-smoothness"
            | "txt23d-custom"
            | "txt2audio-custom"
            | "txt2img-custom"
            | "unknown-custom"
            | "uploaded"
            | "upscale"
            | "upscale-skybox"
            | "upscale-texture"
            | "vectorization"
            | "video2video-custom";
          /** A textual description / keywords describing the object of interest. */
          text?: string;
          height?: number;
          nbMasks?: number;
          /** Amount of decay in creativity over the upscale process. The lowest the value, the less the creativity will be preserved over the upscale process. */
          creativityDecay?: number;
          layerDifference?: number;
          /** Scaling factor (when `targetWidth` not specified) */
          scalingFactor?: number;
          /** The type of the generator used */
          modelType?:
            | "custom"
            | "flux.1"
            | "flux.1-composition"
            | "flux.1-lora"
            | "flux.1-pro"
            | "flux.1.1-pro-ultra"
            | "flux1.1-pro"
            | "gpt-image-1"
            | "sd-1_5"
            | "sd-1_5-composition"
            | "sd-1_5-lora"
            | "sd-xl"
            | "sd-xl-composition"
            | "sd-xl-lora";
          /** The number of outputs to generate. */
          numOutputs?: number;
          /** How angular is the surface? 0 is like a sphere, 1 is like a mechanical object */
          angular?: number;
          /** The target height of the output image. */
          targetHeight?: number;
          /** Flux LoRa or Composition to style the image. */
          concepts?: {
            weightName: string;
            /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
            modelId: string;
            /** The scale of the model (example: 1.0) */
            scale: number;
          }[];
          size?: number;
          spliceThreshold?: number;
          /** The number of pixels to dilate the result masks. */
          dilate?: number;
          style?:
            | "3d-cartoon"
            | "3d-rendered"
            | "anime"
            | "cartoon"
            | "cinematic"
            | "claymation"
            | "cloud-skydome"
            | "comic"
            | "cyberpunk"
            | "enchanted"
            | "fantasy"
            | "ink"
            | "manga"
            | "manga-color"
            | "minimalist"
            | "neon-tron"
            | "oil-painting"
            | "pastel"
            | "photo"
            | "photography"
            | "psychedelic"
            | "retro-fantasy"
            | "scifi-concept-art"
            | "space"
            | "standard"
            | "whimsical";
          /** Strengthen the similarity to the original image during the upscale. Default: optimized for your preset and style. */
          imageFidelity?: number;
          /** Location of the input image in the output. */
          inputLocation?: "bottom" | "left" | "middle" | "right" | "top";
          /** The seed used to generate this asset */
          seed?: string;
          /** The higher the value the more it will look like the secondary reference image(s) */
          secondaryRefFidelity?: number;
          preset?: string;
          trainingImage?: boolean;
          /** Boolean to able return the masks (binary image) in the response. */
          resultMask?: boolean;
          /** The ISO timestamp when the lock on the canvas will expire */
          lockExpiresAt?: string;
          /** The baseModelId that maybe changed at inference time */
          baseModelId?: string;
          pathPrecision?: number;
          rootParentId?: string;
          /** Sharpen tiles. */
          sharpen?: boolean;
          cornerThreshold?: number;
          /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
          styleImages?: string[];
          /** The asset to convert in texture maps. Must reference an existing AssetId. */
          texture?: string;
          filterSpeckle?: number;
          /** Minimum threshold for Grayscale conversion */
          minThreshold?: number;
          /** Maximum threshold for Grayscale conversion */
          maxThreshold?: number;
          /** Condition the influence of the style image(s). The higher the value, the more the style images will influence the upscaled image. */
          styleImagesFidelity?: number;
          /** The control image processed by depth estimator. Must reference an existing AssetId. */
          depthImage?: string;
          parentId?: string;
          parentJobId?: string;
          /** Optional List of secondary style images. Example: portrait of people. It must be existing AssetIds. */
          secondaryRefImages?: string[];
          /** The width of the rendered image. */
          width?: number;
          /** The checkpoint to use */
          checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
          strength?: number;
          /** The id of the Inference describing how this image was generated */
          inferenceId?: string;
          lengthThreshold?: number;
          /** Int to set between 0 and 255 for the opacity of the background in the result images. */
          backgroundOpacity?: number;
          /** The optional aspect ratio given for the generation, only applicable for some models */
          aspectRatio?: string;
          /** Amount of details to remove or add */
          detailsLevel?: number;
          /** Determine the scale at which the upscale process works.
            - With a small value, the upscale works at the largest scale, resulting in fewer added details and more coherent images. Ideal for portraits, for example.
            - With a large value, the upscale works at the smallest scale, resulting in more added details and more hallucinations. Ideal for landscapes, for example.
            
            (info): A small value is slower and more expensive to run. */
          fractality?: number;
          /** (deprecated) Horizontal expansion ratio. */
          horizontalExpansionRatio?: number;
          /** List of points (label, x, y) in the image where label = 0 for background and 1 for object. */
          points?: any[][];
          mode?: string;
          colorPrecision?: number;
          /** Increase the fidelity to the prompt during upscale. Default: optimized for your preset and style. */
          promptFidelity?: number;
          /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
          betterQuality?: boolean;
          /** Remove background for Grayscale detector */
          removeBackground?: boolean;
          /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your preset and style. */
          creativity?: number;
          /** Strength for the input image structure preservation */
          structureFidelity?: number;
          /** Preserve the seamless properties of skybox or texture images. Input has to be of same type (seamless). */
          imageType?: "seamfull" | "skybox" | "texture";
          /** The input image to process. Must reference an existing AssetId or be a data URL. */
          image?: string;
          /** The thumbnail of the canvas */
          thumbnail?: {
            /** The AssetId of the image used as a thumbnail for the canvas (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
            assetId: string;
            /** The url of the image used as a thumbnail for the canvas */
            url: string;
          };
          /** The control image for structure. A canny detector will be applied to this image. Must reference an existing AssetId. */
          structureImage?: string;
          /** To invert the relief */
          invert?: boolean;
          kind: "3d" | "audio" | "document" | "image" | "json" | "video";
          colorMode?: string;
          /** High threshold for Canny detector */
          highThreshold?: number;
          /** (deprecated) Vertical expansion ratio. */
          verticalExpansionRatio?: number;
          halfMode?: boolean;
          name?: string;
          /** Additional refinement steps before scaling.
            
            If scalingFactor == 1, the refinement process will be applied (1 + refinementSteps) times.
            If scalingFactor > 1, the refinement process will be applied refinementSteps times. */
          refinementSteps?: number;
          /** The reference images used for the image generation or editing */
          referenceImages?: string[];
          /** The higher the value the more it will look like the style image(s) */
          styleFidelity?: number;
          /** Boolean to output the contours. */
          resultContours?: boolean;
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          polished?: number;
          /** The scheduler used to generate this asset */
          scheduler?: string;
          /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
          overrideEmbeddings?: boolean;
          progressPercent?: number;
          /** Contrast factor for Grayscale detector */
          factor?: number;
          /** The mask used for the image generation or editing */
          mask?: string;
          /** Low threshold for Canny detector */
          lowThreshold?: number;
          /** The depth fidelity if a depth image provided */
          depthFidelity?: number;
          /** How raised is the surface? 0 is flat like water, 1 is like a very rough rock */
          raised?: number;
          message?: string;
          contours?: number[][][][];
          /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
          negativePrompt?: string;
          /** If true, use the default parameters */
          defaultParameters?: boolean;
          /** Size proportion of the input image in the output. */
          resizeOption?: number;
          outputIndex?: number;
          /** Save a flipbook of the texture. Deactivated when the input texture is larger than 2048x2048px */
          saveFlipbook?: boolean;
          /** The guidance used to generate this asset */
          guidance?: number;
          /** The number of denoising steps for each image generation. */
          numInferenceSteps?: number;
          hdr?: number;
          /** How shiny is the surface? 0 is like a matte surface, 1 is like a diamond */
          shiny?: number;
          /** Ensure upscaled tile have the same color histogram as original tile. */
          colorCorrection?: boolean;
          /** Overlap percentage for the output image. */
          overlapPercentage?: number;
          /** The prompt that guided the image generation or editing */
          prompt?: string;
          /** Boolean to able output the cut out object. */
          resultImage?: boolean;
          /** The control image already processed by canny detector. Must reference an existing AssetId. */
          cannyStructureImage?: string;
          /** Apply extra control to the Skybox 360 geometry.
            The higher the value, the more the 360 geometry will influence the generated skybox image.
            
            Use with caution. Default is adapted to the other parameters. */
          geometryEnforcement?: number;
          /** Target width for the upscaled image, take priority over scaling factor */
          targetWidth?: number;
        };
        /** The NSFW labels */
        nsfw?: string[];
        /** Automatic captioning of the asset */
        automaticCaptioning?: string;
        /** The description of the asset */
        description?: string;
        /** The privacy of the asset */
        privacy: "private" | "public" | "unlisted";
        /** The date when the asset will be soft deleted (only for Free plan) */
        softDeletionOn?: string;
        /** The mime type of the asset (example: "image/png") */
        mimeType: string;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId: string;
        /** The owner (project) ID (example: "proj_23tlk332lkht3kl2" or "team_dlkhgs23tlk3hlkth32lkht3kl2" for old teams) */
        ownerId: string;
        /** Signed URL to get the asset content */
        url: string;
        /** The associated tags (example: ["sci-fi", "landscape"]) */
        tags: string[];
        /** The asset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The output index of the asset within the job
        This index is an positive integer that starts at 0
        It is used to differentiate between multiple outputs of the same job
        If the job has only one output, this index is 0
        This is only applicable for generations with: Flux, Skybox, Reframe at the moment */
        outputIndex?: number;
        /** A list of CollectionId this asset belongs to */
        collectionIds: string[];
        /** List of edit capabilities for the asset */
        editCapabilities: (
          | "DETECTION"
          | "GENERATIVE_FILL"
          | "PIXELATE"
          | "PROMPT_EDITING"
          | "REFINE"
          | "REFRAME"
          | "REMOVE_BACKGROUND"
          | "SEGMENTATION"
          | "UPSCALE"
          | "UPSCALE_360"
          | "VECTORIZATION"
        )[];
        /** The embedding of the asset when requested and asset can be embedded
        
        ie: Detection maps don't have embeddings */
        embedding?: number[];
        /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        id: string;
        /** The status of the asset */
        status: "error" | "pending" | "success";
        /** The asset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PutImagePatchApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The image to be merged. */
    patch?: {
      /** The mode of merging the images: `override` or `erase`. */
      mode: "erase" | "override";
      /** The source of the image to be merged, in base64 format (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII="). */
      image: string;
    };
    /** The background color as an hexadecimal code (ex: "#FFFFFF"), an html color (ex: "red") or "transparent" if "format" is "png". Default to "white" */
    backgroundColor?: string;
    /** The original asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw"). */
    assetId: string;
    /** The output format. Default to "png" */
    format?: "jpeg" | "png";
    /** The position of the image to be merged. */
    position?: {
      /** The X position of the image to be merged, in pixels. */
      x: number;
      /** The Y position of the image to be merged, in pixels. */
      y: number;
    };
    /** Whether to allow the merged image to extend the size of the original (when x or y are negative or merged image is bigger) */
    allowOverflow?: boolean;
    /** The crop operation to apply to the image. Applied before any operation. For the backgroundColor: rgba, hex or named color are supported. */
    crop?: {
      backgroundColor?: string;
      top: number;
      left: number;
      width: number;
      height: number;
    };
  };
};
export type PutImagesPixelateApiResponse =
  /** status 200 200 response */
  | any
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PutImagesPixelateApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The input image as a data URL (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=") or the asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
    image?: string;
    /** Deprecated: The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw"). Prefer to use image with the asset ID instead. */
    assetId?: string;
    /** The size of the pixel grid in the output image. Should be 16, 32, 64, 128, or 256. */
    pixelGridSize: number;
    /** The original file name of the image (example: "low-res-image.jpg"). It will be ignored if assetId is provided. */
    name?: string;
    /** Reduce pixel art artifacts. */
    removeNoise: boolean;
    /** Remove the background from the image. */
    removeBackground?: boolean;
    /** If true, the image will be returned in the response. */
    returnImage: boolean;
    /** The color palette to use for the pixel art. */
    colorPalette?: number[][];
    /** If no colorPalette is provided, you can provide a palette size. Value should be between 2 and 256. */
    colorPaletteSize?: number;
  };
};
export type PutImagesSegmentationApiResponse =
  /** status 200 200 response */
  | {
      sourceAsset: {
        /** Metadata of the asset with some additional information */
        metadata: {
          maxIterations?: number;
          /** Modality to detect */
          modality?:
            | "canny"
            | "depth"
            | "grayscale"
            | "lineart_anime"
            | "mlsd"
            | "normal"
            | "pose"
            | "scribble"
            | "segmentation"
            | "sketch";
          /** If set to true, during the upscaling process, the model will match tiles of the source image with tiles of the style image(s). This will result in a more coherent restyle. Works best with style images that have a similar composition. */
          tileStyle?: boolean;
          /** The modelId used to generate this asset */
          modelId?: string;
          /** A bounding box around the object of interest, in the format [x1, y1, x2, y2]. */
          bbox?: any[];
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          keypointThreshold?: number;
          /** The type of the asset. Ex: 'inference-txt2img' will represent an asset generated from a text to image model */
          type:
            | "background-removal"
            | "canvas"
            | "canvas-drawing"
            | "canvas-export"
            | "detection"
            | "generative-fill"
            | "image-prompt-editing"
            | "img23d-custom"
            | "img2img-custom"
            | "img2video-custom"
            | "inference-controlnet"
            | "inference-controlnet-img2img"
            | "inference-controlnet-inpaint"
            | "inference-controlnet-inpaint-ip-adapter"
            | "inference-controlnet-ip-adapter"
            | "inference-controlnet-reference"
            | "inference-controlnet-texture"
            | "inference-img2img"
            | "inference-img2img-ip-adapter"
            | "inference-img2img-texture"
            | "inference-inpaint"
            | "inference-inpaint-ip-adapter"
            | "inference-reference"
            | "inference-reference-texture"
            | "inference-txt2img"
            | "inference-txt2img-ip-adapter"
            | "inference-txt2img-texture"
            | "patch"
            | "pixelization"
            | "reframe"
            | "restyle"
            | "segment"
            | "segmentation-image"
            | "segmentation-mask"
            | "skybox-base-360"
            | "texture"
            | "texture-albedo"
            | "texture-ao"
            | "texture-edge"
            | "texture-height"
            | "texture-metallic"
            | "texture-normal"
            | "texture-smoothness"
            | "txt23d-custom"
            | "txt2audio-custom"
            | "txt2img-custom"
            | "unknown-custom"
            | "uploaded"
            | "upscale"
            | "upscale-skybox"
            | "upscale-texture"
            | "vectorization"
            | "video2video-custom";
          /** A textual description / keywords describing the object of interest. */
          text?: string;
          height?: number;
          nbMasks?: number;
          /** Amount of decay in creativity over the upscale process. The lowest the value, the less the creativity will be preserved over the upscale process. */
          creativityDecay?: number;
          layerDifference?: number;
          /** Scaling factor (when `targetWidth` not specified) */
          scalingFactor?: number;
          /** The type of the generator used */
          modelType?:
            | "custom"
            | "flux.1"
            | "flux.1-composition"
            | "flux.1-lora"
            | "flux.1-pro"
            | "flux.1.1-pro-ultra"
            | "flux1.1-pro"
            | "gpt-image-1"
            | "sd-1_5"
            | "sd-1_5-composition"
            | "sd-1_5-lora"
            | "sd-xl"
            | "sd-xl-composition"
            | "sd-xl-lora";
          /** The number of outputs to generate. */
          numOutputs?: number;
          /** How angular is the surface? 0 is like a sphere, 1 is like a mechanical object */
          angular?: number;
          /** The target height of the output image. */
          targetHeight?: number;
          /** Flux LoRa or Composition to style the image. */
          concepts?: {
            weightName: string;
            /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
            modelId: string;
            /** The scale of the model (example: 1.0) */
            scale: number;
          }[];
          size?: number;
          spliceThreshold?: number;
          /** The number of pixels to dilate the result masks. */
          dilate?: number;
          style?:
            | "3d-cartoon"
            | "3d-rendered"
            | "anime"
            | "cartoon"
            | "cinematic"
            | "claymation"
            | "cloud-skydome"
            | "comic"
            | "cyberpunk"
            | "enchanted"
            | "fantasy"
            | "ink"
            | "manga"
            | "manga-color"
            | "minimalist"
            | "neon-tron"
            | "oil-painting"
            | "pastel"
            | "photo"
            | "photography"
            | "psychedelic"
            | "retro-fantasy"
            | "scifi-concept-art"
            | "space"
            | "standard"
            | "whimsical";
          /** Strengthen the similarity to the original image during the upscale. Default: optimized for your preset and style. */
          imageFidelity?: number;
          /** Location of the input image in the output. */
          inputLocation?: "bottom" | "left" | "middle" | "right" | "top";
          /** The seed used to generate this asset */
          seed?: string;
          /** The higher the value the more it will look like the secondary reference image(s) */
          secondaryRefFidelity?: number;
          preset?: string;
          trainingImage?: boolean;
          /** Boolean to able return the masks (binary image) in the response. */
          resultMask?: boolean;
          /** The ISO timestamp when the lock on the canvas will expire */
          lockExpiresAt?: string;
          /** The baseModelId that maybe changed at inference time */
          baseModelId?: string;
          pathPrecision?: number;
          rootParentId?: string;
          /** Sharpen tiles. */
          sharpen?: boolean;
          cornerThreshold?: number;
          /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
          styleImages?: string[];
          /** The asset to convert in texture maps. Must reference an existing AssetId. */
          texture?: string;
          filterSpeckle?: number;
          /** Minimum threshold for Grayscale conversion */
          minThreshold?: number;
          /** Maximum threshold for Grayscale conversion */
          maxThreshold?: number;
          /** Condition the influence of the style image(s). The higher the value, the more the style images will influence the upscaled image. */
          styleImagesFidelity?: number;
          /** The control image processed by depth estimator. Must reference an existing AssetId. */
          depthImage?: string;
          parentId?: string;
          parentJobId?: string;
          /** Optional List of secondary style images. Example: portrait of people. It must be existing AssetIds. */
          secondaryRefImages?: string[];
          /** The width of the rendered image. */
          width?: number;
          /** The checkpoint to use */
          checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
          strength?: number;
          /** The id of the Inference describing how this image was generated */
          inferenceId?: string;
          lengthThreshold?: number;
          /** Int to set between 0 and 255 for the opacity of the background in the result images. */
          backgroundOpacity?: number;
          /** The optional aspect ratio given for the generation, only applicable for some models */
          aspectRatio?: string;
          /** Amount of details to remove or add */
          detailsLevel?: number;
          /** Determine the scale at which the upscale process works.
            - With a small value, the upscale works at the largest scale, resulting in fewer added details and more coherent images. Ideal for portraits, for example.
            - With a large value, the upscale works at the smallest scale, resulting in more added details and more hallucinations. Ideal for landscapes, for example.
            
            (info): A small value is slower and more expensive to run. */
          fractality?: number;
          /** (deprecated) Horizontal expansion ratio. */
          horizontalExpansionRatio?: number;
          /** List of points (label, x, y) in the image where label = 0 for background and 1 for object. */
          points?: any[][];
          mode?: string;
          colorPrecision?: number;
          /** Increase the fidelity to the prompt during upscale. Default: optimized for your preset and style. */
          promptFidelity?: number;
          /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
          betterQuality?: boolean;
          /** Remove background for Grayscale detector */
          removeBackground?: boolean;
          /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your preset and style. */
          creativity?: number;
          /** Strength for the input image structure preservation */
          structureFidelity?: number;
          /** Preserve the seamless properties of skybox or texture images. Input has to be of same type (seamless). */
          imageType?: "seamfull" | "skybox" | "texture";
          /** The input image to process. Must reference an existing AssetId or be a data URL. */
          image?: string;
          /** The thumbnail of the canvas */
          thumbnail?: {
            /** The AssetId of the image used as a thumbnail for the canvas (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
            assetId: string;
            /** The url of the image used as a thumbnail for the canvas */
            url: string;
          };
          /** The control image for structure. A canny detector will be applied to this image. Must reference an existing AssetId. */
          structureImage?: string;
          /** To invert the relief */
          invert?: boolean;
          kind: "3d" | "audio" | "document" | "image" | "json" | "video";
          colorMode?: string;
          /** High threshold for Canny detector */
          highThreshold?: number;
          /** (deprecated) Vertical expansion ratio. */
          verticalExpansionRatio?: number;
          halfMode?: boolean;
          name?: string;
          /** Additional refinement steps before scaling.
            
            If scalingFactor == 1, the refinement process will be applied (1 + refinementSteps) times.
            If scalingFactor > 1, the refinement process will be applied refinementSteps times. */
          refinementSteps?: number;
          /** The reference images used for the image generation or editing */
          referenceImages?: string[];
          /** The higher the value the more it will look like the style image(s) */
          styleFidelity?: number;
          /** Boolean to output the contours. */
          resultContours?: boolean;
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          polished?: number;
          /** The scheduler used to generate this asset */
          scheduler?: string;
          /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
          overrideEmbeddings?: boolean;
          progressPercent?: number;
          /** Contrast factor for Grayscale detector */
          factor?: number;
          /** The mask used for the image generation or editing */
          mask?: string;
          /** Low threshold for Canny detector */
          lowThreshold?: number;
          /** The depth fidelity if a depth image provided */
          depthFidelity?: number;
          /** How raised is the surface? 0 is flat like water, 1 is like a very rough rock */
          raised?: number;
          message?: string;
          contours?: number[][][][];
          /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
          negativePrompt?: string;
          /** If true, use the default parameters */
          defaultParameters?: boolean;
          /** Size proportion of the input image in the output. */
          resizeOption?: number;
          outputIndex?: number;
          /** Save a flipbook of the texture. Deactivated when the input texture is larger than 2048x2048px */
          saveFlipbook?: boolean;
          /** The guidance used to generate this asset */
          guidance?: number;
          /** The number of denoising steps for each image generation. */
          numInferenceSteps?: number;
          hdr?: number;
          /** How shiny is the surface? 0 is like a matte surface, 1 is like a diamond */
          shiny?: number;
          /** Ensure upscaled tile have the same color histogram as original tile. */
          colorCorrection?: boolean;
          /** Overlap percentage for the output image. */
          overlapPercentage?: number;
          /** The prompt that guided the image generation or editing */
          prompt?: string;
          /** Boolean to able output the cut out object. */
          resultImage?: boolean;
          /** The control image already processed by canny detector. Must reference an existing AssetId. */
          cannyStructureImage?: string;
          /** Apply extra control to the Skybox 360 geometry.
            The higher the value, the more the 360 geometry will influence the generated skybox image.
            
            Use with caution. Default is adapted to the other parameters. */
          geometryEnforcement?: number;
          /** Target width for the upscaled image, take priority over scaling factor */
          targetWidth?: number;
        };
        /** The NSFW labels */
        nsfw?: string[];
        /** Automatic captioning of the asset */
        automaticCaptioning?: string;
        /** The description of the asset */
        description?: string;
        /** The privacy of the asset */
        privacy: "private" | "public" | "unlisted";
        /** The date when the asset will be soft deleted (only for Free plan) */
        softDeletionOn?: string;
        /** The mime type of the asset (example: "image/png") */
        mimeType: string;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId: string;
        /** The owner (project) ID (example: "proj_23tlk332lkht3kl2" or "team_dlkhgs23tlk3hlkth32lkht3kl2" for old teams) */
        ownerId: string;
        /** Signed URL to get the asset content */
        url: string;
        /** The associated tags (example: ["sci-fi", "landscape"]) */
        tags: string[];
        /** The asset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The output index of the asset within the job
        This index is an positive integer that starts at 0
        It is used to differentiate between multiple outputs of the same job
        If the job has only one output, this index is 0
        This is only applicable for generations with: Flux, Skybox, Reframe at the moment */
        outputIndex?: number;
        /** A list of CollectionId this asset belongs to */
        collectionIds: string[];
        /** List of edit capabilities for the asset */
        editCapabilities: (
          | "DETECTION"
          | "GENERATIVE_FILL"
          | "PIXELATE"
          | "PROMPT_EDITING"
          | "REFINE"
          | "REFRAME"
          | "REMOVE_BACKGROUND"
          | "SEGMENTATION"
          | "UPSCALE"
          | "UPSCALE_360"
          | "VECTORIZATION"
        )[];
        /** The embedding of the asset when requested and asset can be embedded
        
        ie: Detection maps don't have embeddings */
        embedding?: number[];
        /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        id: string;
        /** The status of the asset */
        status: "error" | "pending" | "success";
        /** The asset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
      segments: {
        checkpoint: "fastsam_x" | "sam_b" | "sam_h";
        nbMasks: number;
        images?: string[];
        bbox: any[];
        masks?: string[];
        message: string;
        contours?: number[][][][];
      }[];
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PutImagesSegmentationApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The input image as a data URL (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=") or the asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
    image?: string;
    /** Deprecated: The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw"). Prefer to use image with the asset ID instead. */
    assetId?: string;
    /** A bounding box around the object of interest, in the format [x1, y1, x2, y2] */
    bbox?: number[];
    /** The original file name of the image (example: "low-res-image.jpg"). It will be ignored if assetId is provided. */
    name?: string;
    /** A textual description / keywords describing the object of interest */
    text?: string;
    /** *** LEGACY TYPES **** */
    parameters?: {
      /** The checkpoint to use */
      checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
      /** Boolean to output the contours. */
      resultContours?: boolean;
      /** The number of pixels to dilate the result masks. */
      dilate?: number;
      /** Int to set between 0 and 255 for the opacity of the background in the result images. */
      backgroundOpacity?: number;
      /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
      betterQuality?: boolean;
      /** Boolean to able output the cut out object. */
      resultImage?: boolean;
      /** Boolean to able return the masks (binary image) in the response. */
      resultMask?: boolean;
    };
    /** List of points, either on the object, or on the background, in the format (label, x, y) in the image where label = 0 for a point on the background and 1 a point on the object of interest. */
    points?: any[][];
  };
};
export type PutImageUpscaleApiResponse =
  /** status 200 200 response */
  | {
      /** The upscaled image in base64 format string only if returnImage is true. */
      image?: string;
      asset: {
        /** Metadata of the asset with some additional information */
        metadata: {
          maxIterations?: number;
          /** Modality to detect */
          modality?:
            | "canny"
            | "depth"
            | "grayscale"
            | "lineart_anime"
            | "mlsd"
            | "normal"
            | "pose"
            | "scribble"
            | "segmentation"
            | "sketch";
          /** If set to true, during the upscaling process, the model will match tiles of the source image with tiles of the style image(s). This will result in a more coherent restyle. Works best with style images that have a similar composition. */
          tileStyle?: boolean;
          /** The modelId used to generate this asset */
          modelId?: string;
          /** A bounding box around the object of interest, in the format [x1, y1, x2, y2]. */
          bbox?: any[];
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          keypointThreshold?: number;
          /** The type of the asset. Ex: 'inference-txt2img' will represent an asset generated from a text to image model */
          type:
            | "background-removal"
            | "canvas"
            | "canvas-drawing"
            | "canvas-export"
            | "detection"
            | "generative-fill"
            | "image-prompt-editing"
            | "img23d-custom"
            | "img2img-custom"
            | "img2video-custom"
            | "inference-controlnet"
            | "inference-controlnet-img2img"
            | "inference-controlnet-inpaint"
            | "inference-controlnet-inpaint-ip-adapter"
            | "inference-controlnet-ip-adapter"
            | "inference-controlnet-reference"
            | "inference-controlnet-texture"
            | "inference-img2img"
            | "inference-img2img-ip-adapter"
            | "inference-img2img-texture"
            | "inference-inpaint"
            | "inference-inpaint-ip-adapter"
            | "inference-reference"
            | "inference-reference-texture"
            | "inference-txt2img"
            | "inference-txt2img-ip-adapter"
            | "inference-txt2img-texture"
            | "patch"
            | "pixelization"
            | "reframe"
            | "restyle"
            | "segment"
            | "segmentation-image"
            | "segmentation-mask"
            | "skybox-base-360"
            | "texture"
            | "texture-albedo"
            | "texture-ao"
            | "texture-edge"
            | "texture-height"
            | "texture-metallic"
            | "texture-normal"
            | "texture-smoothness"
            | "txt23d-custom"
            | "txt2audio-custom"
            | "txt2img-custom"
            | "unknown-custom"
            | "uploaded"
            | "upscale"
            | "upscale-skybox"
            | "upscale-texture"
            | "vectorization"
            | "video2video-custom";
          /** A textual description / keywords describing the object of interest. */
          text?: string;
          height?: number;
          nbMasks?: number;
          /** Amount of decay in creativity over the upscale process. The lowest the value, the less the creativity will be preserved over the upscale process. */
          creativityDecay?: number;
          layerDifference?: number;
          /** Scaling factor (when `targetWidth` not specified) */
          scalingFactor?: number;
          /** The type of the generator used */
          modelType?:
            | "custom"
            | "flux.1"
            | "flux.1-composition"
            | "flux.1-lora"
            | "flux.1-pro"
            | "flux.1.1-pro-ultra"
            | "flux1.1-pro"
            | "gpt-image-1"
            | "sd-1_5"
            | "sd-1_5-composition"
            | "sd-1_5-lora"
            | "sd-xl"
            | "sd-xl-composition"
            | "sd-xl-lora";
          /** The number of outputs to generate. */
          numOutputs?: number;
          /** How angular is the surface? 0 is like a sphere, 1 is like a mechanical object */
          angular?: number;
          /** The target height of the output image. */
          targetHeight?: number;
          /** Flux LoRa or Composition to style the image. */
          concepts?: {
            weightName: string;
            /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
            modelId: string;
            /** The scale of the model (example: 1.0) */
            scale: number;
          }[];
          size?: number;
          spliceThreshold?: number;
          /** The number of pixels to dilate the result masks. */
          dilate?: number;
          style?:
            | "3d-cartoon"
            | "3d-rendered"
            | "anime"
            | "cartoon"
            | "cinematic"
            | "claymation"
            | "cloud-skydome"
            | "comic"
            | "cyberpunk"
            | "enchanted"
            | "fantasy"
            | "ink"
            | "manga"
            | "manga-color"
            | "minimalist"
            | "neon-tron"
            | "oil-painting"
            | "pastel"
            | "photo"
            | "photography"
            | "psychedelic"
            | "retro-fantasy"
            | "scifi-concept-art"
            | "space"
            | "standard"
            | "whimsical";
          /** Strengthen the similarity to the original image during the upscale. Default: optimized for your preset and style. */
          imageFidelity?: number;
          /** Location of the input image in the output. */
          inputLocation?: "bottom" | "left" | "middle" | "right" | "top";
          /** The seed used to generate this asset */
          seed?: string;
          /** The higher the value the more it will look like the secondary reference image(s) */
          secondaryRefFidelity?: number;
          preset?: string;
          trainingImage?: boolean;
          /** Boolean to able return the masks (binary image) in the response. */
          resultMask?: boolean;
          /** The ISO timestamp when the lock on the canvas will expire */
          lockExpiresAt?: string;
          /** The baseModelId that maybe changed at inference time */
          baseModelId?: string;
          pathPrecision?: number;
          rootParentId?: string;
          /** Sharpen tiles. */
          sharpen?: boolean;
          cornerThreshold?: number;
          /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
          styleImages?: string[];
          /** The asset to convert in texture maps. Must reference an existing AssetId. */
          texture?: string;
          filterSpeckle?: number;
          /** Minimum threshold for Grayscale conversion */
          minThreshold?: number;
          /** Maximum threshold for Grayscale conversion */
          maxThreshold?: number;
          /** Condition the influence of the style image(s). The higher the value, the more the style images will influence the upscaled image. */
          styleImagesFidelity?: number;
          /** The control image processed by depth estimator. Must reference an existing AssetId. */
          depthImage?: string;
          parentId?: string;
          parentJobId?: string;
          /** Optional List of secondary style images. Example: portrait of people. It must be existing AssetIds. */
          secondaryRefImages?: string[];
          /** The width of the rendered image. */
          width?: number;
          /** The checkpoint to use */
          checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
          strength?: number;
          /** The id of the Inference describing how this image was generated */
          inferenceId?: string;
          lengthThreshold?: number;
          /** Int to set between 0 and 255 for the opacity of the background in the result images. */
          backgroundOpacity?: number;
          /** The optional aspect ratio given for the generation, only applicable for some models */
          aspectRatio?: string;
          /** Amount of details to remove or add */
          detailsLevel?: number;
          /** Determine the scale at which the upscale process works.
            - With a small value, the upscale works at the largest scale, resulting in fewer added details and more coherent images. Ideal for portraits, for example.
            - With a large value, the upscale works at the smallest scale, resulting in more added details and more hallucinations. Ideal for landscapes, for example.
            
            (info): A small value is slower and more expensive to run. */
          fractality?: number;
          /** (deprecated) Horizontal expansion ratio. */
          horizontalExpansionRatio?: number;
          /** List of points (label, x, y) in the image where label = 0 for background and 1 for object. */
          points?: any[][];
          mode?: string;
          colorPrecision?: number;
          /** Increase the fidelity to the prompt during upscale. Default: optimized for your preset and style. */
          promptFidelity?: number;
          /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
          betterQuality?: boolean;
          /** Remove background for Grayscale detector */
          removeBackground?: boolean;
          /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your preset and style. */
          creativity?: number;
          /** Strength for the input image structure preservation */
          structureFidelity?: number;
          /** Preserve the seamless properties of skybox or texture images. Input has to be of same type (seamless). */
          imageType?: "seamfull" | "skybox" | "texture";
          /** The input image to process. Must reference an existing AssetId or be a data URL. */
          image?: string;
          /** The thumbnail of the canvas */
          thumbnail?: {
            /** The AssetId of the image used as a thumbnail for the canvas (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
            assetId: string;
            /** The url of the image used as a thumbnail for the canvas */
            url: string;
          };
          /** The control image for structure. A canny detector will be applied to this image. Must reference an existing AssetId. */
          structureImage?: string;
          /** To invert the relief */
          invert?: boolean;
          kind: "3d" | "audio" | "document" | "image" | "json" | "video";
          colorMode?: string;
          /** High threshold for Canny detector */
          highThreshold?: number;
          /** (deprecated) Vertical expansion ratio. */
          verticalExpansionRatio?: number;
          halfMode?: boolean;
          name?: string;
          /** Additional refinement steps before scaling.
            
            If scalingFactor == 1, the refinement process will be applied (1 + refinementSteps) times.
            If scalingFactor > 1, the refinement process will be applied refinementSteps times. */
          refinementSteps?: number;
          /** The reference images used for the image generation or editing */
          referenceImages?: string[];
          /** The higher the value the more it will look like the style image(s) */
          styleFidelity?: number;
          /** Boolean to output the contours. */
          resultContours?: boolean;
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          polished?: number;
          /** The scheduler used to generate this asset */
          scheduler?: string;
          /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
          overrideEmbeddings?: boolean;
          progressPercent?: number;
          /** Contrast factor for Grayscale detector */
          factor?: number;
          /** The mask used for the image generation or editing */
          mask?: string;
          /** Low threshold for Canny detector */
          lowThreshold?: number;
          /** The depth fidelity if a depth image provided */
          depthFidelity?: number;
          /** How raised is the surface? 0 is flat like water, 1 is like a very rough rock */
          raised?: number;
          message?: string;
          contours?: number[][][][];
          /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
          negativePrompt?: string;
          /** If true, use the default parameters */
          defaultParameters?: boolean;
          /** Size proportion of the input image in the output. */
          resizeOption?: number;
          outputIndex?: number;
          /** Save a flipbook of the texture. Deactivated when the input texture is larger than 2048x2048px */
          saveFlipbook?: boolean;
          /** The guidance used to generate this asset */
          guidance?: number;
          /** The number of denoising steps for each image generation. */
          numInferenceSteps?: number;
          hdr?: number;
          /** How shiny is the surface? 0 is like a matte surface, 1 is like a diamond */
          shiny?: number;
          /** Ensure upscaled tile have the same color histogram as original tile. */
          colorCorrection?: boolean;
          /** Overlap percentage for the output image. */
          overlapPercentage?: number;
          /** The prompt that guided the image generation or editing */
          prompt?: string;
          /** Boolean to able output the cut out object. */
          resultImage?: boolean;
          /** The control image already processed by canny detector. Must reference an existing AssetId. */
          cannyStructureImage?: string;
          /** Apply extra control to the Skybox 360 geometry.
            The higher the value, the more the 360 geometry will influence the generated skybox image.
            
            Use with caution. Default is adapted to the other parameters. */
          geometryEnforcement?: number;
          /** Target width for the upscaled image, take priority over scaling factor */
          targetWidth?: number;
        };
        /** The NSFW labels */
        nsfw?: string[];
        /** Automatic captioning of the asset */
        automaticCaptioning?: string;
        /** The description of the asset */
        description?: string;
        /** The privacy of the asset */
        privacy: "private" | "public" | "unlisted";
        /** The date when the asset will be soft deleted (only for Free plan) */
        softDeletionOn?: string;
        /** The mime type of the asset (example: "image/png") */
        mimeType: string;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId: string;
        /** The owner (project) ID (example: "proj_23tlk332lkht3kl2" or "team_dlkhgs23tlk3hlkth32lkht3kl2" for old teams) */
        ownerId: string;
        /** Signed URL to get the asset content */
        url: string;
        /** The associated tags (example: ["sci-fi", "landscape"]) */
        tags: string[];
        /** The asset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The output index of the asset within the job
        This index is an positive integer that starts at 0
        It is used to differentiate between multiple outputs of the same job
        If the job has only one output, this index is 0
        This is only applicable for generations with: Flux, Skybox, Reframe at the moment */
        outputIndex?: number;
        /** A list of CollectionId this asset belongs to */
        collectionIds: string[];
        /** List of edit capabilities for the asset */
        editCapabilities: (
          | "DETECTION"
          | "GENERATIVE_FILL"
          | "PIXELATE"
          | "PROMPT_EDITING"
          | "REFINE"
          | "REFRAME"
          | "REMOVE_BACKGROUND"
          | "SEGMENTATION"
          | "UPSCALE"
          | "UPSCALE_360"
          | "VECTORIZATION"
        )[];
        /** The embedding of the asset when requested and asset can be embedded
        
        ie: Detection maps don't have embeddings */
        embedding?: number[];
        /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        id: string;
        /** The status of the asset */
        status: "error" | "pending" | "success";
        /** The asset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PutImageUpscaleApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The image to upscale in base64 format string. It will be ignored if assetId is provided. */
    image?: string;
    /** Reproduce a preceding result. Default: randomly generated number. If set, "seed" must be an integer between 0 and 2147483647 sent as string */
    seed?: string;
    /** The scaling factor to apply to the image. One of 1, 2, 4, 8, 16. */
    scalingFactor?: number;
    /** Optimize the upscale for a specific use case. Precise: Upscale for high fidelity. Balanced: Upscale for a balance between fidelity and creativity. Creative: Upscale for creativity. Default: Balanced. */
    preset?: "precise" | "balanced" | "creative";
    /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy */
    negativePrompt?: string;
    /** Optimize tiling so centered props and characters on an image get better results. Setting it to false will enhance performances. Default: false. */
    halfMode?: boolean;
    /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw"). If provided, image and name will be ignored. */
    assetId?: string;
    /** Override the embeddings of the model. Default: false. Use with caution. */
    overrideEmbeddings?: boolean;
    /** Increase definition and details. High value can lead to a loss of realism. Default: optimized for your `preset` and `style`. */
    hdr?: number;
    /** The original file name of the image (example: "low-res-image.jpg"). It will be ignored if assetId is provided. */
    name?: string;
    /** Increase the fidelity to the prompt during upscale. Default: optimized for your `preset` and `style`. */
    promptFidelity?: number;
    /** Optimize the upscale for a specific style. `standard` works in most cases. Use one of the other `styles` to refine the outputs. Default: `standard`. */
    style?:
      | "standard"
      | "cartoon"
      | "anime"
      | "3d-rendered"
      | "comic"
      | "minimalist"
      | "photography";
    /** If true, a placeholder version of the image being processed will be returned in the response. */
    returnImage?: boolean;
    /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your `preset` and `style`. */
    creativity?: number;
    /** Apply a color correction to the resulting image hence increasing ressemblance. Default: true. */
    colorCorrection?: boolean;
    /** A full text prompt to guide the upscale and forcing the generation of certain characteristics. Default: empty string. Example: "UHD 8K hyper detailed studio photo of man face with yellow skin, anatomical++, disturbing+++, black background. Exploding brain. Bloody. Use the perspective of a standard lens to produce an image that is similar to what the human eye sees, creating a natural and realistic look." */
    prompt?: string;
    /** Strengthen the similarity to the original image during the upscale. Default: optimized for your `preset` and `style`. */
    imageFidelity?: number;
  };
};
export type PutImageVectorizationApiResponse =
  /** status 200 200 response */
  | {
      /** The vectorized image in base64 format string only if returnImage is true. */
      image?: string;
      asset: {
        /** Metadata of the asset with some additional information */
        metadata: {
          maxIterations?: number;
          /** Modality to detect */
          modality?:
            | "canny"
            | "depth"
            | "grayscale"
            | "lineart_anime"
            | "mlsd"
            | "normal"
            | "pose"
            | "scribble"
            | "segmentation"
            | "sketch";
          /** If set to true, during the upscaling process, the model will match tiles of the source image with tiles of the style image(s). This will result in a more coherent restyle. Works best with style images that have a similar composition. */
          tileStyle?: boolean;
          /** The modelId used to generate this asset */
          modelId?: string;
          /** A bounding box around the object of interest, in the format [x1, y1, x2, y2]. */
          bbox?: any[];
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          keypointThreshold?: number;
          /** The type of the asset. Ex: 'inference-txt2img' will represent an asset generated from a text to image model */
          type:
            | "background-removal"
            | "canvas"
            | "canvas-drawing"
            | "canvas-export"
            | "detection"
            | "generative-fill"
            | "image-prompt-editing"
            | "img23d-custom"
            | "img2img-custom"
            | "img2video-custom"
            | "inference-controlnet"
            | "inference-controlnet-img2img"
            | "inference-controlnet-inpaint"
            | "inference-controlnet-inpaint-ip-adapter"
            | "inference-controlnet-ip-adapter"
            | "inference-controlnet-reference"
            | "inference-controlnet-texture"
            | "inference-img2img"
            | "inference-img2img-ip-adapter"
            | "inference-img2img-texture"
            | "inference-inpaint"
            | "inference-inpaint-ip-adapter"
            | "inference-reference"
            | "inference-reference-texture"
            | "inference-txt2img"
            | "inference-txt2img-ip-adapter"
            | "inference-txt2img-texture"
            | "patch"
            | "pixelization"
            | "reframe"
            | "restyle"
            | "segment"
            | "segmentation-image"
            | "segmentation-mask"
            | "skybox-base-360"
            | "texture"
            | "texture-albedo"
            | "texture-ao"
            | "texture-edge"
            | "texture-height"
            | "texture-metallic"
            | "texture-normal"
            | "texture-smoothness"
            | "txt23d-custom"
            | "txt2audio-custom"
            | "txt2img-custom"
            | "unknown-custom"
            | "uploaded"
            | "upscale"
            | "upscale-skybox"
            | "upscale-texture"
            | "vectorization"
            | "video2video-custom";
          /** A textual description / keywords describing the object of interest. */
          text?: string;
          height?: number;
          nbMasks?: number;
          /** Amount of decay in creativity over the upscale process. The lowest the value, the less the creativity will be preserved over the upscale process. */
          creativityDecay?: number;
          layerDifference?: number;
          /** Scaling factor (when `targetWidth` not specified) */
          scalingFactor?: number;
          /** The type of the generator used */
          modelType?:
            | "custom"
            | "flux.1"
            | "flux.1-composition"
            | "flux.1-lora"
            | "flux.1-pro"
            | "flux.1.1-pro-ultra"
            | "flux1.1-pro"
            | "gpt-image-1"
            | "sd-1_5"
            | "sd-1_5-composition"
            | "sd-1_5-lora"
            | "sd-xl"
            | "sd-xl-composition"
            | "sd-xl-lora";
          /** The number of outputs to generate. */
          numOutputs?: number;
          /** How angular is the surface? 0 is like a sphere, 1 is like a mechanical object */
          angular?: number;
          /** The target height of the output image. */
          targetHeight?: number;
          /** Flux LoRa or Composition to style the image. */
          concepts?: {
            weightName: string;
            /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
            modelId: string;
            /** The scale of the model (example: 1.0) */
            scale: number;
          }[];
          size?: number;
          spliceThreshold?: number;
          /** The number of pixels to dilate the result masks. */
          dilate?: number;
          style?:
            | "3d-cartoon"
            | "3d-rendered"
            | "anime"
            | "cartoon"
            | "cinematic"
            | "claymation"
            | "cloud-skydome"
            | "comic"
            | "cyberpunk"
            | "enchanted"
            | "fantasy"
            | "ink"
            | "manga"
            | "manga-color"
            | "minimalist"
            | "neon-tron"
            | "oil-painting"
            | "pastel"
            | "photo"
            | "photography"
            | "psychedelic"
            | "retro-fantasy"
            | "scifi-concept-art"
            | "space"
            | "standard"
            | "whimsical";
          /** Strengthen the similarity to the original image during the upscale. Default: optimized for your preset and style. */
          imageFidelity?: number;
          /** Location of the input image in the output. */
          inputLocation?: "bottom" | "left" | "middle" | "right" | "top";
          /** The seed used to generate this asset */
          seed?: string;
          /** The higher the value the more it will look like the secondary reference image(s) */
          secondaryRefFidelity?: number;
          preset?: string;
          trainingImage?: boolean;
          /** Boolean to able return the masks (binary image) in the response. */
          resultMask?: boolean;
          /** The ISO timestamp when the lock on the canvas will expire */
          lockExpiresAt?: string;
          /** The baseModelId that maybe changed at inference time */
          baseModelId?: string;
          pathPrecision?: number;
          rootParentId?: string;
          /** Sharpen tiles. */
          sharpen?: boolean;
          cornerThreshold?: number;
          /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
          styleImages?: string[];
          /** The asset to convert in texture maps. Must reference an existing AssetId. */
          texture?: string;
          filterSpeckle?: number;
          /** Minimum threshold for Grayscale conversion */
          minThreshold?: number;
          /** Maximum threshold for Grayscale conversion */
          maxThreshold?: number;
          /** Condition the influence of the style image(s). The higher the value, the more the style images will influence the upscaled image. */
          styleImagesFidelity?: number;
          /** The control image processed by depth estimator. Must reference an existing AssetId. */
          depthImage?: string;
          parentId?: string;
          parentJobId?: string;
          /** Optional List of secondary style images. Example: portrait of people. It must be existing AssetIds. */
          secondaryRefImages?: string[];
          /** The width of the rendered image. */
          width?: number;
          /** The checkpoint to use */
          checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
          strength?: number;
          /** The id of the Inference describing how this image was generated */
          inferenceId?: string;
          lengthThreshold?: number;
          /** Int to set between 0 and 255 for the opacity of the background in the result images. */
          backgroundOpacity?: number;
          /** The optional aspect ratio given for the generation, only applicable for some models */
          aspectRatio?: string;
          /** Amount of details to remove or add */
          detailsLevel?: number;
          /** Determine the scale at which the upscale process works.
            - With a small value, the upscale works at the largest scale, resulting in fewer added details and more coherent images. Ideal for portraits, for example.
            - With a large value, the upscale works at the smallest scale, resulting in more added details and more hallucinations. Ideal for landscapes, for example.
            
            (info): A small value is slower and more expensive to run. */
          fractality?: number;
          /** (deprecated) Horizontal expansion ratio. */
          horizontalExpansionRatio?: number;
          /** List of points (label, x, y) in the image where label = 0 for background and 1 for object. */
          points?: any[][];
          mode?: string;
          colorPrecision?: number;
          /** Increase the fidelity to the prompt during upscale. Default: optimized for your preset and style. */
          promptFidelity?: number;
          /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
          betterQuality?: boolean;
          /** Remove background for Grayscale detector */
          removeBackground?: boolean;
          /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your preset and style. */
          creativity?: number;
          /** Strength for the input image structure preservation */
          structureFidelity?: number;
          /** Preserve the seamless properties of skybox or texture images. Input has to be of same type (seamless). */
          imageType?: "seamfull" | "skybox" | "texture";
          /** The input image to process. Must reference an existing AssetId or be a data URL. */
          image?: string;
          /** The thumbnail of the canvas */
          thumbnail?: {
            /** The AssetId of the image used as a thumbnail for the canvas (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
            assetId: string;
            /** The url of the image used as a thumbnail for the canvas */
            url: string;
          };
          /** The control image for structure. A canny detector will be applied to this image. Must reference an existing AssetId. */
          structureImage?: string;
          /** To invert the relief */
          invert?: boolean;
          kind: "3d" | "audio" | "document" | "image" | "json" | "video";
          colorMode?: string;
          /** High threshold for Canny detector */
          highThreshold?: number;
          /** (deprecated) Vertical expansion ratio. */
          verticalExpansionRatio?: number;
          halfMode?: boolean;
          name?: string;
          /** Additional refinement steps before scaling.
            
            If scalingFactor == 1, the refinement process will be applied (1 + refinementSteps) times.
            If scalingFactor > 1, the refinement process will be applied refinementSteps times. */
          refinementSteps?: number;
          /** The reference images used for the image generation or editing */
          referenceImages?: string[];
          /** The higher the value the more it will look like the style image(s) */
          styleFidelity?: number;
          /** Boolean to output the contours. */
          resultContours?: boolean;
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          polished?: number;
          /** The scheduler used to generate this asset */
          scheduler?: string;
          /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
          overrideEmbeddings?: boolean;
          progressPercent?: number;
          /** Contrast factor for Grayscale detector */
          factor?: number;
          /** The mask used for the image generation or editing */
          mask?: string;
          /** Low threshold for Canny detector */
          lowThreshold?: number;
          /** The depth fidelity if a depth image provided */
          depthFidelity?: number;
          /** How raised is the surface? 0 is flat like water, 1 is like a very rough rock */
          raised?: number;
          message?: string;
          contours?: number[][][][];
          /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
          negativePrompt?: string;
          /** If true, use the default parameters */
          defaultParameters?: boolean;
          /** Size proportion of the input image in the output. */
          resizeOption?: number;
          outputIndex?: number;
          /** Save a flipbook of the texture. Deactivated when the input texture is larger than 2048x2048px */
          saveFlipbook?: boolean;
          /** The guidance used to generate this asset */
          guidance?: number;
          /** The number of denoising steps for each image generation. */
          numInferenceSteps?: number;
          hdr?: number;
          /** How shiny is the surface? 0 is like a matte surface, 1 is like a diamond */
          shiny?: number;
          /** Ensure upscaled tile have the same color histogram as original tile. */
          colorCorrection?: boolean;
          /** Overlap percentage for the output image. */
          overlapPercentage?: number;
          /** The prompt that guided the image generation or editing */
          prompt?: string;
          /** Boolean to able output the cut out object. */
          resultImage?: boolean;
          /** The control image already processed by canny detector. Must reference an existing AssetId. */
          cannyStructureImage?: string;
          /** Apply extra control to the Skybox 360 geometry.
            The higher the value, the more the 360 geometry will influence the generated skybox image.
            
            Use with caution. Default is adapted to the other parameters. */
          geometryEnforcement?: number;
          /** Target width for the upscaled image, take priority over scaling factor */
          targetWidth?: number;
        };
        /** The NSFW labels */
        nsfw?: string[];
        /** Automatic captioning of the asset */
        automaticCaptioning?: string;
        /** The description of the asset */
        description?: string;
        /** The privacy of the asset */
        privacy: "private" | "public" | "unlisted";
        /** The date when the asset will be soft deleted (only for Free plan) */
        softDeletionOn?: string;
        /** The mime type of the asset (example: "image/png") */
        mimeType: string;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId: string;
        /** The owner (project) ID (example: "proj_23tlk332lkht3kl2" or "team_dlkhgs23tlk3hlkth32lkht3kl2" for old teams) */
        ownerId: string;
        /** Signed URL to get the asset content */
        url: string;
        /** The associated tags (example: ["sci-fi", "landscape"]) */
        tags: string[];
        /** The asset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The output index of the asset within the job
        This index is an positive integer that starts at 0
        It is used to differentiate between multiple outputs of the same job
        If the job has only one output, this index is 0
        This is only applicable for generations with: Flux, Skybox, Reframe at the moment */
        outputIndex?: number;
        /** A list of CollectionId this asset belongs to */
        collectionIds: string[];
        /** List of edit capabilities for the asset */
        editCapabilities: (
          | "DETECTION"
          | "GENERATIVE_FILL"
          | "PIXELATE"
          | "PROMPT_EDITING"
          | "REFINE"
          | "REFRAME"
          | "REMOVE_BACKGROUND"
          | "SEGMENTATION"
          | "UPSCALE"
          | "UPSCALE_360"
          | "VECTORIZATION"
        )[];
        /** The embedding of the asset when requested and asset can be embedded
        
        ie: Detection maps don't have embeddings */
        embedding?: number[];
        /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        id: string;
        /** The status of the asset */
        status: "error" | "pending" | "success";
        /** The asset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PutImageVectorizationApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The input image as a data URL (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=") or the asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
    image?: string;
    /** Represents the color difference between gradient layers (higher value will reduce the number of layers)
        
        Only applicable to `color` colorMode. */
    layerDifference?: number;
    /** Max iterations for rendering */
    maxIterations?: number;
    /** Minimum momentary angle (degree) to be considered a corner (higher value will smooth corners)
        
        Only applicable to `spline` mode. */
    cornerThreshold?: number;
    /** Minimum length of a segment (higher value will generate more coarse output)
        
        Only applicable to `spline` mode. */
    lengthThreshold?: number;
    /** Color mode `bw`, `color`. If `bw`, the image will be considered as black and white. */
    colorMode?: "bw" | "color";
    /** Discard patches smaller than X px in size (higher value will reduce the number of patches, cleaner output) */
    filterSpeckle?: number;
    /** If preset given, all other parameters will be ignored (mode, colorMode, filterSpeckle, ...), except for custom. */
    preset?: "asset" | "bw" | "custom" | "photo" | "pixelart" | "poster";
    /** Curver fitting mode `none`, `polygon`, `spline` */
    mode?: "none" | "polygon" | "spline";
    /** Number of significant bits to use in an RGB channel, min 1, max 16 (higher value will increase precision)
        
        Only applicable to `color` colorMode. */
    colorPrecision?: number;
    /** Minimum angle displacement (degree) to splice a spline (higher value reduce accuracy)
        
        Only applicable to `spline` mode. */
    spliceThreshold?: number;
    /** Deprecated: The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw"). Prefer to use image with the asset ID instead. */
    assetId?: string;
    /** The original file name of the image (example: "low-res-image.jpg"). It will be ignored if assetId is provided. */
    name?: string;
    /** If true, the image will be returned in the response. */
    returnImage: boolean;
    /** Number of decimal places to use in path string */
    pathPrecision?: number;
  };
};
export type GetInferencesApiResponse = /** status 200 200 response */ {
  /** A token to query the next page of inferences */
  nextPaginationToken?: string;
  inferences: {
    /** The result images URLs (can change over time when inference is in progress) */
    images: {
      /** The seed used to generate this image */
      seed: string;
      /** The image ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
      id: string;
      /** The image URL */
      url: string;
    }[];
    /** The model ID on which the inference was done (example: "model_GTrL3mq4SXWyMxkOHRxlpw") */
    modelId: string;
    /** The author user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
    authorId: string;
    /** The human-friendly prompt (without token) */
    displayPrompt: string;
    /** The owner user ID (example: "team_VFhihHKMRZyDDnZAJwLb2Q") */
    ownerId: string;
    /** (Deprecated) The user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
    userId: string;
    /** The inference creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt: string;
    /** The inference progress (within [0, 1]) */
    progress?: number;
    /** The inference ID (example: "inf_GTrL3mq4SXWyMxkOHRxlpw") */
    id: string;
    /** The total number of result images */
    imagesNumber: number;
    /** The inference parameters */
    parameters: {
      /** Asset id of the input IpAdapter images */
      ipAdapterImageIds?: string[];
      /** If style_fidelity=1.0, control more important, else if style_fidelity=0.0, prompt more important, else balanced
            Only for "reference" inference type */
      styleFidelity?: number;
      /** Specifies how long the ControlNet guidance should be applied during the inference process.
            
            Only available for Flux.1-dev based models.
            
            The value represents the percentage of total inference steps where the ControlNet guidance is active.
            For example:
            - 1.0: ControlNet guidance is applied during all inference steps
            - 0.5: ControlNet guidance is only applied during the first half of inference steps
            
            Default values:
            - 0.5 for Canny modality
            - 0.6 for all other modalities */
      controlEnd?: number;
      /** The modality associated with the control image used for the generation: it can either be an object with a combination of maximum
            
            For models of SD1.5 family:
             - up to 3 modalities from `canny`, `pose`, `depth`, `lines`, `seg`, `scribble`, `lineart`, `normal-map`, `illusion`
             - or one of the following presets: `character`, `landscape`, `city`, `interior`.
            
            For models of the SDXL family:
             - up to 3 modalities from `canny`, `pose`, `depth`, `seg`, `illusion`, `scribble`
             - or one of the following presets: `character`, `landscape`.
            
            For models of the FLUX schnell or dev families:
            - one modality from: `canny`, `tile`, `depth`, `blur`, `pose`, `gray`, `low-quality`
            
            Optionally, you can associate a value to these modalities or presets. The value must be within `]0.0, 1.0]`.
            
            Examples:
            - `canny`
            - `depth:0.5,pose:1.0`
            - `canny:0.5,depth:0.5,lines:0.3`
            - `landscape`
            - `character:0.5`
            - `illusion:1`
            
            Note: if you use a value that is not supported by the model family, this will result in an error. */
      modality?:
        | "blur"
        | "canny"
        | "depth"
        | "gray"
        | "illusion"
        | "lineart"
        | "lines"
        | "low-quality"
        | "normal-map"
        | "pose"
        | "scribble"
        | "seg"
        | "sketch"
        | "tile";
      /** Used to reproduce previous results. Default: randomly generated number. */
      seed?: string;
      /** Controls the noise intensity introduced to the input image, where a value of 1.0 completely erases the original image's details. Available for img2img and inpainting. (within [0.01, 1.0], default: 0.75) */
      strength?: number;
      /** The type of IP Adapter model to use. Must be one of [`style`, `character`], default to `style`` */
      ipAdapterType?: "character" | "style";
      /** The aspect ratio of the generated images. Only used for the model flux.1.1-pro-ultra.
            The aspect ratio is a string formatted as "width:height" (example: "16:9"). */
      aspectRatio?:
        | "16:9"
        | "1:1"
        | "21:9"
        | "2:3"
        | "3:2"
        | "3:4"
        | "4:3"
        | "4:5"
        | "5:4"
        | "9:16"
        | "9:21";
      /** The type of inference to use. Example: txt2img, img2img, etc.
            
            Selecting the right type will condition the expected parameters.
            
            Note: if model.type is `sd-xl*` or `sd-1_5*`, when using the `"inpaint"` inference type, Scenario determines the best available `baseModel` for a given `modelId`: one of `["stable-diffusion-inpainting", "stable-diffusion-xl-1.0-inpainting-0.1"] will be used. */
      type:
        | "controlnet"
        | "controlnet_img2img"
        | "controlnet_inpaint"
        | "controlnet_inpaint_ip_adapter"
        | "controlnet_ip_adapter"
        | "controlnet_reference"
        | "controlnet_texture"
        | "img2img"
        | "img2img_ip_adapter"
        | "img2img_texture"
        | "inpaint"
        | "inpaint_ip_adapter"
        | "outpaint"
        | "reference"
        | "reference_texture"
        | "txt2img"
        | "txt2img_ip_adapter"
        | "txt2img_texture";
      /** Signed URL to display the IpAdapter image */
      ipAdapterImage?: string;
      /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
      scheduler?:
        | "DDIMScheduler"
        | "DDPMScheduler"
        | "DEISMultistepScheduler"
        | "DPMSolverMultistepScheduler"
        | "DPMSolverSinglestepScheduler"
        | "EulerAncestralDiscreteScheduler"
        | "EulerDiscreteScheduler"
        | "HeunDiscreteScheduler"
        | "KDPM2AncestralDiscreteScheduler"
        | "KDPM2DiscreteScheduler"
        | "LCMScheduler"
        | "LMSDiscreteScheduler"
        | "PNDMScheduler"
        | "TCDScheduler"
        | "UniPCMultistepScheduler";
      /** If set to true, the entire input image will likely change during inpainting. This results in faster inferences, but the output image will be harder to integrate if the input is just a small part of a larger image. */
      disableMerging?: boolean;
      /** If false, the process uses the given image to detect the modality.
            If true (default), the process will not try to detect the modality of the given image.
            
            For example:
            with `pose` modality and `false` value, the process will detect the pose of people in the given image
            with `depth` modality and `false` value, the process will detect the depth of the given image
            with `scribble` modality and `true`value, the process will use the given image as a scribble
            
            ⚠️ For models of the FLUX schnell or dev families, this parameter is ignored. The modality detection is always disabled. ⚠️ */
      disableModalityDetection?: boolean;
      /** Signed URL to display the IpAdapter images */
      ipAdapterImages?: string[];
      /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
            Allowed values are available in the model's attribute: `compliantModelIds` */
      baseModelId?: string;
      /** Specifies the starting point of the ControlNet guidance during the inference process.
            
            Only available for Flux.1-dev based models.
            
            The value represents the percentage of total inference steps where the ControlNet guidance starts.
            For example:
            - 0.0: ControlNet guidance starts at the beginning of the inference steps
            - 0.5: ControlNet guidance starts at the middle of the inference steps */
      controlStart?: number;
      /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
            If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
            If model.type is `sd-1_5`, the height must be within [64, 1024]
            If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
      height?: number;
      /** Signed URL to display the mask image */
      mask?: string;
      /** Asset id of the controlnet input image */
      controlImageId?: string;
      /** Signed URL to display the input image */
      image?: string;
      /** Asset id of the input image */
      imageId?: string;
      /** Asset id of the input IpAdapter image */
      ipAdapterImageId?: string;
      /** IpAdapter scale factor (within [0.0, 1.0], default: 0.9). */
      ipAdapterScale?: number;
      /** If set, generated assets will be hidden and not returned in the list of images of the inference
            or when listing assets (default: false) */
      hideResults?: boolean;
      /** IpAdapter scale factors (within [0.0, 1.0], default: 0.9). */
      ipAdapterScales?: number[];
      /** Asset id of the mask image */
      maskId?: string;
      /** Whether to use reference adain
            Only for "reference" inference type */
      referenceAdain?: boolean;
      /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
      negativePrompt?: string;
      /** Enable or disable the intermediate images generation (default: false) */
      intermediateImages?: boolean;
      concepts?: {
        /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
        modelId: string;
        /** The scale of the model (example: 1.0) */
        scale: number;
      }[];
      /** Signed URL to display the controlnet input image */
      controlImage?: string;
      /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
      guidance?: number;
      /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
      numInferenceSteps?: number;
      /** The number of images to generate (within [1, 128], default: 4) */
      numSamples?: number;
      /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
            If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
            If model.type is `sd-1_5`, the width must be within [64, 1024]
            If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
      width?: number;
      /** Whether to use reference query for self attention's context
            Only for "reference" inference type */
      referenceAttn?: boolean;
      /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
      prompt: string;
    };
    /** The generation queue information (for generations with the "queued" status) */
    queue?: {
      /** The approximate number of requests in the generation queue */
      approximateNumberOfRequests: number;
      /** The approximate position in the generation queue */
      approximatePosition: number;
    };
    /** The inference status */
    status:
      | "canceled"
      | "failed"
      | "in-progress"
      | "model-loading"
      | "new"
      | "queued"
      | "succeeded";
  }[];
};
export type GetInferencesApiArg = {
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The number of items to return in the response. The default value is 10, maximum value is 50, minimum value is 1 */
  pageSize?: string;
  /** A token you received in a previous request to query the next page of items */
  paginationToken?: string;
};
export type GetJobsApiResponse = /** status 200 200 response */ {
  /** A token to query the next page of jobs */
  nextPaginationToken?: string;
  jobs: {
    /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt: string;
    /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
    jobId: string;
    /** Metadata of the job with some additional information */
    metadata: {
      /** The output of the job */
      output?: {};
      /** The inputs for the job */
      input?: {};
      /** List of produced assets for this job */
      assetIds?: string[];
    };
    /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
    statusHistory: {
      date: string;
      status:
        | "canceled"
        | "failure"
        | "in-progress"
        | "queued"
        | "success"
        | "warming-up";
    }[];
    /** Progress of the job (between 0 and 1) */
    progress: number;
    /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
    authorId?: string;
    /** The type of job */
    jobType:
      | "assets-download"
      | "canvas-export"
      | "caption"
      | "caption-llava"
      | "custom"
      | "describe-style"
      | "detection"
      | "embed"
      | "flux"
      | "flux-model-training"
      | "generate-prompt"
      | "image-generation"
      | "image-prompt-editing"
      | "inference"
      | "model-download"
      | "model-import"
      | "model-training"
      | "openai-image-generation"
      | "patch-image"
      | "pixelate"
      | "reframe"
      | "remove-background"
      | "repaint"
      | "restyle"
      | "segment"
      | "skybox-base-360"
      | "skybox-upscale-360"
      | "texture"
      | "translate"
      | "upload"
      | "upscale"
      | "upscale-skybox"
      | "upscale-texture"
      | "vectorize";
    /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
    ownerId?: string;
    /** The current status of the job */
    status:
      | "canceled"
      | "failure"
      | "in-progress"
      | "queued"
      | "success"
      | "warming-up";
    /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    updatedAt: string;
  }[];
};
export type GetJobsApiArg = {
  /** The authorId of the jobs to return. Optional. */
  authorId?: string;
  /** If false, jobs containing the hideResults param will be not returned. Optional. */
  hideResults?: string;
  projectId: string;
  /** The number of items to return in the response. The default value is 10, maximum value is 200, minimum value is 1 */
  pageSize?: string;
  /** The type of the jobs to return. If "types" is defined, "type" will be ignored. Optional. */
  type?: string;
  /** A token you received in a previous request to query the next page of items */
  paginationToken?: string;
  /** The types of the jobs to return. If "types" is defined, "type" will be ignored. Optional. */
  types?: string;
  /** The status of the jobs to return. Optional. */
  status?: string;
};
export type GetJobIdApiResponse = /** status 200 200 response */ {
  job: {
    /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt: string;
    /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
    jobId: string;
    /** Metadata of the job with some additional information */
    metadata: {
      /** The output of the job */
      output?: {};
      /** The inputs for the job */
      input?: {};
      /** List of produced assets for this job */
      assetIds?: string[];
      error?: string;
    };
    /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
    statusHistory: {
      date: string;
      status:
        | "canceled"
        | "failure"
        | "in-progress"
        | "queued"
        | "success"
        | "warming-up";
    }[];
    /** Progress of the job (between 0 and 1) */
    progress: number;
    /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
    authorId?: string;
    /** The type of job */
    jobType:
      | "assets-download"
      | "canvas-export"
      | "caption"
      | "caption-llava"
      | "custom"
      | "describe-style"
      | "detection"
      | "embed"
      | "flux"
      | "flux-model-training"
      | "generate-prompt"
      | "image-generation"
      | "image-prompt-editing"
      | "inference"
      | "model-download"
      | "model-import"
      | "model-training"
      | "openai-image-generation"
      | "patch-image"
      | "pixelate"
      | "reframe"
      | "remove-background"
      | "repaint"
      | "restyle"
      | "segment"
      | "skybox-base-360"
      | "skybox-upscale-360"
      | "texture"
      | "translate"
      | "upload"
      | "upscale"
      | "upscale-skybox"
      | "upscale-texture"
      | "vectorize";
    /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
    ownerId?: string;
    /** The current status of the job */
    status:
      | "canceled"
      | "failure"
      | "in-progress"
      | "queued"
      | "success"
      | "warming-up";
    /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    updatedAt: string;
  };
};
export type GetJobIdApiArg = {
  projectId: string;
  jobId: string;
};
export type PostJobActionByJobIdApiResponse = /** status 200 200 response */ {
  job: {
    /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt: string;
    /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
    jobId: string;
    /** Metadata of the job with some additional information */
    metadata: {
      /** The output of the job */
      output?: {};
      /** The inputs for the job */
      input?: {};
      /** List of produced assets for this job */
      assetIds?: string[];
    };
    /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
    statusHistory: {
      date: string;
      status:
        | "canceled"
        | "failure"
        | "in-progress"
        | "queued"
        | "success"
        | "warming-up";
    }[];
    /** Progress of the job (between 0 and 1) */
    progress: number;
    /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
    authorId?: string;
    /** The type of job */
    jobType:
      | "assets-download"
      | "canvas-export"
      | "caption"
      | "caption-llava"
      | "custom"
      | "describe-style"
      | "detection"
      | "embed"
      | "flux"
      | "flux-model-training"
      | "generate-prompt"
      | "image-generation"
      | "image-prompt-editing"
      | "inference"
      | "model-download"
      | "model-import"
      | "model-training"
      | "openai-image-generation"
      | "patch-image"
      | "pixelate"
      | "reframe"
      | "remove-background"
      | "repaint"
      | "restyle"
      | "segment"
      | "skybox-base-360"
      | "skybox-upscale-360"
      | "texture"
      | "translate"
      | "upload"
      | "upscale"
      | "upscale-skybox"
      | "upscale-texture"
      | "vectorize";
    /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
    ownerId?: string;
    /** The current status of the job */
    status:
      | "canceled"
      | "failure"
      | "in-progress"
      | "queued"
      | "success"
      | "warming-up";
    /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    updatedAt: string;
  };
};
export type PostJobActionByJobIdApiArg = {
  /** The job Id */
  jobId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** The action to execute on the job, such as canceling it. Today only cancel on inference jobs is supported. */
    action?: "cancel";
  };
};
export type GetMeApiResponse = /** status 200 200 response */ {
  user: {
    /** The user settings (example: { "key": "value" }) */
    settings: object;
    /** The list of the user project ids */
    projects: {
      role: "admin" | "editor" | "reader";
      teamId: string;
      projectId: string;
    }[];
    /** The list of the user team ids */
    teams: string[];
    /** The user full name (example: "John Doe") */
    fullName?: string;
    /** The user creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt: string;
    /** The list of features behind a flag available for the user (example: ["custom-class-option"]) */
    features: string[];
    /** The phone number in the E164 format (example: "+13125050405") */
    phoneNumber?: string;
    /** The country code in the ISO 3166 ALPHA-2 format (example: "US") */
    countryCode?: string;
    /** The user referral code (example: "eyVcnFJcR92BxBkz7N6g5w") */
    referralCode: string;
    /** The user ID (example: "eyVcnFJcR92BxBkz7N6g5w") */
    id: string;
    /** The user email (example: "herve@scenario.com") */
    email: string;
    /** The user notification settings (example: { "model-transfer": { "email": true, "mobile": false } }) */
    notifications?: {
      "model-validation-failed": {
        mobile: boolean;
        email: boolean;
      };
      "creative-units-threshold-50": {
        mobile: boolean;
        email: boolean;
      };
      "model-transfer": {
        mobile: boolean;
        email: boolean;
      };
      "auto-refill-disabled": {
        mobile: boolean;
        email: boolean;
      };
      "soft-deletion-first-call": {
        mobile: boolean;
        email: boolean;
      };
      "creative-units-threshold-90": {
        mobile: boolean;
        email: boolean;
      };
      "soft-deletion-last-call": {
        mobile: boolean;
        email: boolean;
      };
      "creative-units-threshold-100": {
        mobile: boolean;
        email: boolean;
      };
      "model-train-succeeded": {
        mobile: boolean;
        email: boolean;
      };
    };
    /** The user status */
    status: "active" | "deletion-in-progress" | "error";
    /** The user last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    updatedAt: string;
    /** The user's username (example: "eurv-scenario") */
    username: string;
  };
  /** Token to unsubscribe from notifications */
  notificationsToken?: string;
};
export type GetMeApiArg = void;
export type PutMeApiResponse = /** status 200 200 response */ any;
export type PutMeApiArg = {
  body: {
    /** The user settings (example: { "key": "value" }). The object cannot be larger than 100kb. */
    settings?: object;
    /** The user phone number (example: "+13125050405") */
    phoneNumber?: string;
    /** The user country code (example: "US") */
    countryCode?: string;
    /** The user full name (example: "John Doe") */
    fullName?: string;
    /** The user notification settings (example: { "model-transfer": { "email": true, "mobile": false } }) */
    notifications?: {
      "model-validation-failed": {
        mobile: boolean;
        email: boolean;
      };
      "creative-units-threshold-50": {
        mobile: boolean;
        email: boolean;
      };
      "model-transfer": {
        mobile: boolean;
        email: boolean;
      };
      "auto-refill-disabled": {
        mobile: boolean;
        email: boolean;
      };
      "soft-deletion-first-call": {
        mobile: boolean;
        email: boolean;
      };
      "creative-units-threshold-90": {
        mobile: boolean;
        email: boolean;
      };
      "soft-deletion-last-call": {
        mobile: boolean;
        email: boolean;
      };
      "creative-units-threshold-100": {
        mobile: boolean;
        email: boolean;
      };
      "model-train-succeeded": {
        mobile: boolean;
        email: boolean;
      };
    };
  };
};
export type DeleteMeApiResponse = /** status 202 202 response */ {
  /** The URL to confirm the deletion if the confirmMethod is "email" */
  confirmUrl?: string;
};
export type DeleteMeApiArg = {
  /** Specify which kind of confirmation you want. Allowed values are: "email" or "none". If not provided, the default value is "email". When set to "none", the user will be deleted without any confirmation otherwise an email will be sent to the user with a confirmation link. */
  confirmMethod?: string;
  authorization: string;
};
export type GetUserConfirmDeletionApiResponse = unknown;
export type GetUserConfirmDeletionApiArg = {
  /** Added in the url sent by email to the user. */
  token: string;
};
export type GetUserConfirmInvitationApiResponse = unknown;
export type GetUserConfirmInvitationApiArg = {
  hash: string;
};
export type GetUserNotificationsByTokenApiResponse =
  /** status 200 200 response */ {
    notifications: {
      "model-validation-failed": {
        mobile: boolean;
        email: boolean;
      };
      "creative-units-threshold-50": {
        mobile: boolean;
        email: boolean;
      };
      "model-transfer": {
        mobile: boolean;
        email: boolean;
      };
      "auto-refill-disabled": {
        mobile: boolean;
        email: boolean;
      };
      "soft-deletion-first-call": {
        mobile: boolean;
        email: boolean;
      };
      "creative-units-threshold-90": {
        mobile: boolean;
        email: boolean;
      };
      "soft-deletion-last-call": {
        mobile: boolean;
        email: boolean;
      };
      "creative-units-threshold-100": {
        mobile: boolean;
        email: boolean;
      };
      "model-train-succeeded": {
        mobile: boolean;
        email: boolean;
      };
    };
  };
export type GetUserNotificationsByTokenApiArg = {
  authorization: string;
};
export type PutUserNotificationsByTokenApiResponse =
  /** status 200 200 response */ {
    notifications: {
      "model-validation-failed": {
        mobile: boolean;
        email: boolean;
      };
      "creative-units-threshold-50": {
        mobile: boolean;
        email: boolean;
      };
      "model-transfer": {
        mobile: boolean;
        email: boolean;
      };
      "auto-refill-disabled": {
        mobile: boolean;
        email: boolean;
      };
      "soft-deletion-first-call": {
        mobile: boolean;
        email: boolean;
      };
      "creative-units-threshold-90": {
        mobile: boolean;
        email: boolean;
      };
      "soft-deletion-last-call": {
        mobile: boolean;
        email: boolean;
      };
      "creative-units-threshold-100": {
        mobile: boolean;
        email: boolean;
      };
      "model-train-succeeded": {
        mobile: boolean;
        email: boolean;
      };
    };
  };
export type PutUserNotificationsByTokenApiArg = {
  authorization: string;
  body: {
    "model-validation-failed": {
      mobile: boolean;
      email: boolean;
    };
    "creative-units-threshold-50": {
      mobile: boolean;
      email: boolean;
    };
    "model-transfer": {
      mobile: boolean;
      email: boolean;
    };
    "auto-refill-disabled": {
      mobile: boolean;
      email: boolean;
    };
    "soft-deletion-first-call": {
      mobile: boolean;
      email: boolean;
    };
    "creative-units-threshold-90": {
      mobile: boolean;
      email: boolean;
    };
    "soft-deletion-last-call": {
      mobile: boolean;
      email: boolean;
    };
    "creative-units-threshold-100": {
      mobile: boolean;
      email: boolean;
    };
    "model-train-succeeded": {
      mobile: boolean;
      email: boolean;
    };
  };
};
export type GetModelsApiResponse = /** status 200 200 response */ {
  models: {
    /** The training caption words of the model */
    captionWords?: string[];
    /** The URLs of the first 3 training images of the model. To retrieve the full set of images, get it by modelId */
    trainingImages?: {
      /** The training image upload date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** Automatic captioning of the image */
      automaticCaptioning: string;
      /** The URL of the image */
      downloadUrl: string;
      /** The original file name of the image (example: "my-training-image.jpg") */
      name: string;
      /** Description for the image */
      description: string;
      /** The training image ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
      id: string;
    }[];
    /** The inputs of the model. Only used for custom models. To retrieve this list, get it by modelId with GET /models/{modelId} */
    inputs?: {
      /** The allowed values of the input of type 'string' or 'string_array'
            In case of string, it's a single value select list
            In case of string_array, it's a multi value select list */
      allowedValues?: string[];
      /** The maximum value of the input (only available for inputs of type 'number' and inputs as array) */
      max?: number;
      /** The kind of the input. Only available for inputs of type 'file' (and 'file_array') */
      kind?: "3d" | "audio" | "document" | "image" | "json" | "video";
      /** The minimum length of the input where the input is a string (also available for each item in string_array) */
      minLength?: number;
      /** The description of the input, to display in the UI as an help text adding information about the input */
      description?: string;
      /** The label of the input displayed in the UI */
      label?: string;
      /** The type of the input */
      type:
        | "boolean"
        | "file"
        | "file_array"
        | "number"
        | "number_array"
        | "string"
        | "string_array";
      /** Whether the input is required */
      required: boolean;
      /** The minimum value of the input (only available for inputs of type 'number' and inputs as array) */
      min?: number;
      /** A hint to the user about the input, to display in the UI with a tooltip */
      hint?: string;
      /** The name of the input internally used by the model and API */
      name: string;
      /** The maximum length of the input where the input is a string (also available for each item in string_array) */
      maxLength?: number;
      /** The group of the input. If 2 inputs have the same group, they will be displayed in the same group in the UI
            They will be always together in this list of inputs */
      group?: string;
    }[];
    /** List of all example asset IDs setup by the model owner */
    exampleAssetIds: string[];
    /** The privacy of the model (default: private) */
    privacy: "private" | "public" | "unlisted";
    /** The date when the model will be soft deleted (only for Free plan) */
    softDeletionOn?: string;
    /** The UI configuration for the model */
    uiConfig?: {
      triggerGenerate?: {
        /** The 'name' of the input where the trigger generate button will be displayed (after the input).
                Do not specify both position and after. */
        after?: string;
        label: string;
        /** The position of the trigger generate button. If position specified, the button will be displayed at the specified position.
                Do not specify both position and after. */
        position?: "bottom" | "top";
      };
    };
    /** The source of the model */
    source: "civitai" | "huggingface" | "other" | "scenario";
    /** The owner ID (example: "team_VFhihHKMRZyDDnZAJwLb2Q") */
    ownerId?: string;
    /** The model type (example: sd-1_5) */
    type:
      | "custom"
      | "flux.1"
      | "flux.1-composition"
      | "flux.1-lora"
      | "flux.1-pro"
      | "flux.1.1-pro-ultra"
      | "flux1.1-pro"
      | "gpt-image-1"
      | "sd-1_5"
      | "sd-1_5-composition"
      | "sd-1_5-lora"
      | "sd-xl"
      | "sd-xl-composition"
      | "sd-xl-lora";
    /** The model creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt: string;
    /** Additional information about the model's training */
    trainingStats?: {
      /** The training duration in seconds */
      trainDuration?: number;
      /** The training queued duration in seconds */
      queueDuration?: number;
      /** The training end time as an ISO date string */
      endedAt?: string;
      /** The training start time as an ISO date string */
      startedAt?: string;
    };
    /** Fine-tune the model's inferences with prompt embedding */
    promptEmbedding?: string;
    /** Additional information about the training progress of the model */
    trainingProgress?: {
      /** The stage of the request */
      stage:
        | "pending"
        | "queued-for-train"
        | "running-train"
        | "starting-train";
      /** The remaining time in milliseconds */
      remainingTimeMs?: number;
      /** The progress of the job */
      progress?: number;
      /** The timestamp in millisecond marking the start of the process */
      startedAt?: number;
      /** Position of the job in the queue (ie. the number of job in the queue before this one) */
      position?: number;
      /** Timestamp in milliseconds of the last time the training progress was updated */
      updatedAt: number;
    };
    /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
    id: string;
    /** The class of the model */
    class?: {
      /** The model ID of the class (example: "stable-diffusion-v1-5") */
      modelId: string;
      /** The class name (example: "Character Design") */
      name: string;
      /** The category slug of the class (example: "art-style") */
      category: string;
      /** Some example images URLs to showcase the class */
      thumbnails: string[];
      /** The class prompt (example: "a character design") */
      prompt: string;
      /** The concept prompt of the class (example: "a sks character design") */
      conceptPrompt: string;
      /** The class slug (example: "art-style-character-design") */
      slug: string;
      /** The class status (only published classes are listed, but unpublished classes can still appear in existing models) */
      status: "published" | "unpublished";
    };
    /** The model last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    updatedAt: string;
    /** A thumbnail for your model */
    thumbnail?: {
      /** The AssetId of the image used as a thumbnail for your model (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
      assetId: string;
      /** The url of the image used as a thumbnail for your model */
      url: string;
    };
    /** List of model capabilities (example: ["txt2img", "img2img", "txt2img_ip_adapter", ...]) */
    capabilities: (
      | "controlnet"
      | "controlnet_img2img"
      | "controlnet_inpaint"
      | "controlnet_inpaint_ip_adapter"
      | "controlnet_ip_adapter"
      | "controlnet_reference"
      | "controlnet_texture"
      | "img2img"
      | "img2img_ip_adapter"
      | "img2img_texture"
      | "inpaint"
      | "inpaint_ip_adapter"
      | "outpaint"
      | "reference"
      | "reference_texture"
      | "txt2img"
      | "txt2img_ip_adapter"
      | "txt2img_texture"
    )[];
    /** The id of the parent model */
    parentModelId?: string;
    /** The total number of training images */
    trainingImagesNumber: number;
    /** Whether the model is a custom model and can be used only with POST /generate/custom/{modelId} endpoint */
    custom: boolean;
    /** The model keyword, this is a legacy parameter, please use conceptPrompt in parameters */
    modelKeyword?: string;
    /** The author user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
    authorId?: string;
    /** (Deprecated) The user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
    userId?: string;
    /** The associated tags (example: ["sci-fi", "landscape"]) */
    tags: string[];
    /** Fine-tune the model's inferences with negative prompt embedding */
    negativePromptEmbedding?: string;
    /** The concepts is required for the type model: composition */
    concepts?: {
      /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
      modelId: string;
      /** The scale of the model (example: 1.0) */
      scale: number;
    }[];
    /** A list of CollectionId this model belongs to */
    collectionIds: string[];
    /** The model name (example: "Low-poly dwarf") */
    name?: string;
    /** The model's training parameters */
    parameters?: {
      /** Whether to train the text encoder or not
            
            Example: For 100 steps and a value of 0.2, it means that the text encoder will be trained for 20 steps and then the UNet for 80 steps
            
            Note: Legacy parameter, please use `numTextTrainSteps` and `numUNetTrainSteps`
            
            Only available for SD15 and SDXL LoRA training */
      textEncoderTrainingRatio?: number;
      /** The weight of prior preservation loss
            
            Only available for SD15 and SDXL LoRA training */
      priorLossWeight?: number;
      /** Used to reproduce previous results. Default: randomly generated number.
            
            Only available for SD15 and SDXL LoRA training */
      seed?: number;
      /** The number of training steps for the UNet
            
            Only available for SDXL LoRA training */
      numUNetTrainSteps?: number;
      /** Validation frequency. Cannot be greater than maxTrainSteps value
            
            Only available for SD15 and SDXL LoRA training */
      validationFrequency?: number;
      /** Ratio of random crops
            
            Only available for SD15 and SDXL LoRA training */
      randomCropRatio?: number;
      /** Initial learning rate (after the potential warmup period)
            
            Default value varies depending on the model type:
            - For SD1.5 and SDXL: 0.000005
            - For Flux: 0.0004 */
      learningRate?: number;
      /** Optimize the model training task for a specific type of input images. The available values are:
            - "likeness": optimize training for likeness or portrait
            
            Only available for Flux LoRA training */
      optimizeFor?: "likeness" | null;
      /** Whether to random crop or center crop images before resizing to the working resolution
            
            Only available for SD15 and SDXL LoRA training */
      randomCrop?: boolean;
      /** The prompt to specify images in the same class as provided instance images
            
            Only available for SD15 training */
      classPrompt?: string;
      /** The number of training steps for the text encoder
            
            Only available for SDXL LoRA training */
      numTextTrainSteps?: number;
      /** Initial learning rate (after the potential warmup period) for the text encoder
            
            Only available for SDXL LoRA training */
      learningRateTextEncoder?: number;
      /** The Weights And Bias key to use for logging. The maximum length is 40 characters */
      wandbKey?: string;
      /** Whether to scale the learning rate
            
            Note: Legacy parameter, will be ignored
            
            Only available for SD15 and SDXL LoRA training */
      scaleLr?: boolean;
      /** Scale of random crops
            
            Only available for SD15 and SDXL LoRA training */
      randomCropScale?: number;
      /** The scheduler type to use (default: "constant")
            
            Only available for SD15 and SDXL LoRA training */
      lrScheduler?:
        | "constant"
        | "constant-with-warmup"
        | "cosine"
        | "cosine-with-restarts"
        | "linear"
        | "polynomial";
      /** The dimension of the LoRA update matrices
            
            Only available for SDXL and Flux LoRA training
            
            Default value varies depending on the model type:
            - For SDXL: 64
            - For Flux: 16 */
      rank?: number;
      /** Initial learning rate (after the potential warmup period) for the UNet
            
            Only available for SDXL LoRA training */
      learningRateUnet?: number;
      /** Validation prompt
            
            Only available for SD15 and SDXL LoRA training */
      validationPrompt?: string;
      /** The prompt with identifier specifying the instance (or subject) of the class (example: "a daiton dog")
            
            Default value varies depending on the model type:
            - For SD1.5: "daiton" if no class is associated with the model
            - For SDXL: "daiton"
            - For Flux: "" */
      conceptPrompt?: string | null;
      /** Maximum number of training steps to execute (default: varies depending on the model type)
            
            For SDXL LoRA training, please use `numTextTrainSteps` and `numUNetTrainSteps` instead
            
            Default value varies depending on the model type:
            - For SD1.5: round((number of training images * 225) / 3)
            - For SDXL: number of training images * 175
            - For Flux: number of training images * 100
            
            Maximum value varies depending on the model type:
            - For SD1.5 and SDXL: [0, 40000]
            - For Flux: [0, 10000] */
      maxTrainSteps?: number;
    };
    /** List of base model IDs compliant with the model (example: ["flux.1-dev", "flux.1-schnell"])
        This attribute is mainly used for Flux LoRA models */
    compliantModelIds?: string[];
    /** The model status */
    status:
      | "copying"
      | "failed"
      | "new"
      | "trained"
      | "training"
      | "training-canceled";
  }[];
  /** A token to query the next page of models */
  nextPaginationToken?: string;
};
export type GetModelsApiArg = {
  /** The privacy of the models to return. The default value is `private`, possible values are `private` and `public` */
  privacy?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The number of items to return in the response. The default value is 100, maximum value is 500, minimum value is 1 */
  pageSize?: string;
  /** A token you received in a previous request to query the next page of items */
  paginationToken?: string;
  /** The status of the models to return */
  status?: string;
  /** When provided, only the models in the Collection will be returned */
  collectionId?: string;
  /** If set to true, returns the list of models currently loaded on GPU */
  loadedOnly?: string;
};
export type PostModelsApiResponse = /** status 200 200 response */ {
  model: {
    /** The training caption words of the model */
    captionWords?: string[];
    /** The URLs of the first 3 training images of the model. To retrieve the full set of images, get it by modelId */
    trainingImages?: {
      /** The training image upload date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** Automatic captioning of the image */
      automaticCaptioning: string;
      /** The URL of the image */
      downloadUrl: string;
      /** The original file name of the image (example: "my-training-image.jpg") */
      name: string;
      /** Description for the image */
      description: string;
      /** The training image ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
      id: string;
    }[];
    /** The inputs of the model. Only used for custom models. To retrieve this list, get it by modelId with GET /models/{modelId} */
    inputs?: {
      /** The allowed values of the input of type 'string' or 'string_array'
            In case of string, it's a single value select list
            In case of string_array, it's a multi value select list */
      allowedValues?: string[];
      /** The maximum value of the input (only available for inputs of type 'number' and inputs as array) */
      max?: number;
      /** The kind of the input. Only available for inputs of type 'file' (and 'file_array') */
      kind?: "3d" | "audio" | "document" | "image" | "json" | "video";
      /** The minimum length of the input where the input is a string (also available for each item in string_array) */
      minLength?: number;
      /** The description of the input, to display in the UI as an help text adding information about the input */
      description?: string;
      /** The label of the input displayed in the UI */
      label?: string;
      /** The type of the input */
      type:
        | "boolean"
        | "file"
        | "file_array"
        | "number"
        | "number_array"
        | "string"
        | "string_array";
      /** Whether the input is required */
      required: boolean;
      /** The minimum value of the input (only available for inputs of type 'number' and inputs as array) */
      min?: number;
      /** A hint to the user about the input, to display in the UI with a tooltip */
      hint?: string;
      /** The name of the input internally used by the model and API */
      name: string;
      /** The maximum length of the input where the input is a string (also available for each item in string_array) */
      maxLength?: number;
      /** The group of the input. If 2 inputs have the same group, they will be displayed in the same group in the UI
            They will be always together in this list of inputs */
      group?: string;
    }[];
    /** List of all example asset IDs setup by the model owner */
    exampleAssetIds: string[];
    /** The privacy of the model (default: private) */
    privacy: "private" | "public" | "unlisted";
    /** The date when the model will be soft deleted (only for Free plan) */
    softDeletionOn?: string;
    /** The UI configuration for the model */
    uiConfig?: {
      triggerGenerate?: {
        /** The 'name' of the input where the trigger generate button will be displayed (after the input).
                Do not specify both position and after. */
        after?: string;
        label: string;
        /** The position of the trigger generate button. If position specified, the button will be displayed at the specified position.
                Do not specify both position and after. */
        position?: "bottom" | "top";
      };
    };
    /** The source of the model */
    source: "civitai" | "huggingface" | "other" | "scenario";
    /** The owner ID (example: "team_VFhihHKMRZyDDnZAJwLb2Q") */
    ownerId?: string;
    /** The model type (example: sd-1_5) */
    type:
      | "custom"
      | "flux.1"
      | "flux.1-composition"
      | "flux.1-lora"
      | "flux.1-pro"
      | "flux.1.1-pro-ultra"
      | "flux1.1-pro"
      | "gpt-image-1"
      | "sd-1_5"
      | "sd-1_5-composition"
      | "sd-1_5-lora"
      | "sd-xl"
      | "sd-xl-composition"
      | "sd-xl-lora";
    /** The model creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt: string;
    /** Additional information about the model's training */
    trainingStats?: {
      /** The training duration in seconds */
      trainDuration?: number;
      /** The training queued duration in seconds */
      queueDuration?: number;
      /** The training end time as an ISO date string */
      endedAt?: string;
      /** The training start time as an ISO date string */
      startedAt?: string;
    };
    /** Fine-tune the model's inferences with prompt embedding */
    promptEmbedding?: string;
    /** Additional information about the training progress of the model */
    trainingProgress?: {
      /** The stage of the request */
      stage:
        | "pending"
        | "queued-for-train"
        | "running-train"
        | "starting-train";
      /** The remaining time in milliseconds */
      remainingTimeMs?: number;
      /** The progress of the job */
      progress?: number;
      /** The timestamp in millisecond marking the start of the process */
      startedAt?: number;
      /** Position of the job in the queue (ie. the number of job in the queue before this one) */
      position?: number;
      /** Timestamp in milliseconds of the last time the training progress was updated */
      updatedAt: number;
    };
    /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
    id: string;
    /** The class of the model */
    class?: {
      /** The model ID of the class (example: "stable-diffusion-v1-5") */
      modelId: string;
      /** The class name (example: "Character Design") */
      name: string;
      /** The category slug of the class (example: "art-style") */
      category: string;
      /** Some example images URLs to showcase the class */
      thumbnails: string[];
      /** The class prompt (example: "a character design") */
      prompt: string;
      /** The concept prompt of the class (example: "a sks character design") */
      conceptPrompt: string;
      /** The class slug (example: "art-style-character-design") */
      slug: string;
      /** The class status (only published classes are listed, but unpublished classes can still appear in existing models) */
      status: "published" | "unpublished";
    };
    /** The model last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    updatedAt: string;
    /** A thumbnail for your model */
    thumbnail?: {
      /** The AssetId of the image used as a thumbnail for your model (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
      assetId: string;
      /** The url of the image used as a thumbnail for your model */
      url: string;
    };
    /** List of model capabilities (example: ["txt2img", "img2img", "txt2img_ip_adapter", ...]) */
    capabilities: (
      | "controlnet"
      | "controlnet_img2img"
      | "controlnet_inpaint"
      | "controlnet_inpaint_ip_adapter"
      | "controlnet_ip_adapter"
      | "controlnet_reference"
      | "controlnet_texture"
      | "img2img"
      | "img2img_ip_adapter"
      | "img2img_texture"
      | "inpaint"
      | "inpaint_ip_adapter"
      | "outpaint"
      | "reference"
      | "reference_texture"
      | "txt2img"
      | "txt2img_ip_adapter"
      | "txt2img_texture"
    )[];
    /** The id of the parent model */
    parentModelId?: string;
    /** The total number of training images */
    trainingImagesNumber: number;
    /** Whether the model is a custom model and can be used only with POST /generate/custom/{modelId} endpoint */
    custom: boolean;
    /** The model keyword, this is a legacy parameter, please use conceptPrompt in parameters */
    modelKeyword?: string;
    /** The author user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
    authorId?: string;
    /** (Deprecated) The user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
    userId?: string;
    /** The associated tags (example: ["sci-fi", "landscape"]) */
    tags: string[];
    /** Fine-tune the model's inferences with negative prompt embedding */
    negativePromptEmbedding?: string;
    /** The concepts is required for the type model: composition */
    concepts?: {
      /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
      modelId: string;
      /** The scale of the model (example: 1.0) */
      scale: number;
    }[];
    /** A list of CollectionId this model belongs to */
    collectionIds: string[];
    /** The model name (example: "Low-poly dwarf") */
    name?: string;
    /** The model's training parameters */
    parameters?: {
      /** Whether to train the text encoder or not
            
            Example: For 100 steps and a value of 0.2, it means that the text encoder will be trained for 20 steps and then the UNet for 80 steps
            
            Note: Legacy parameter, please use `numTextTrainSteps` and `numUNetTrainSteps`
            
            Only available for SD15 and SDXL LoRA training */
      textEncoderTrainingRatio?: number;
      /** The weight of prior preservation loss
            
            Only available for SD15 and SDXL LoRA training */
      priorLossWeight?: number;
      /** Used to reproduce previous results. Default: randomly generated number.
            
            Only available for SD15 and SDXL LoRA training */
      seed?: number;
      /** The number of training steps for the UNet
            
            Only available for SDXL LoRA training */
      numUNetTrainSteps?: number;
      /** Validation frequency. Cannot be greater than maxTrainSteps value
            
            Only available for SD15 and SDXL LoRA training */
      validationFrequency?: number;
      /** Ratio of random crops
            
            Only available for SD15 and SDXL LoRA training */
      randomCropRatio?: number;
      /** Initial learning rate (after the potential warmup period)
            
            Default value varies depending on the model type:
            - For SD1.5 and SDXL: 0.000005
            - For Flux: 0.0004 */
      learningRate?: number;
      /** Optimize the model training task for a specific type of input images. The available values are:
            - "likeness": optimize training for likeness or portrait
            
            Only available for Flux LoRA training */
      optimizeFor?: "likeness" | null;
      /** Whether to random crop or center crop images before resizing to the working resolution
            
            Only available for SD15 and SDXL LoRA training */
      randomCrop?: boolean;
      /** The prompt to specify images in the same class as provided instance images
            
            Only available for SD15 training */
      classPrompt?: string;
      /** The number of training steps for the text encoder
            
            Only available for SDXL LoRA training */
      numTextTrainSteps?: number;
      /** Initial learning rate (after the potential warmup period) for the text encoder
            
            Only available for SDXL LoRA training */
      learningRateTextEncoder?: number;
      /** The Weights And Bias key to use for logging. The maximum length is 40 characters */
      wandbKey?: string;
      /** Whether to scale the learning rate
            
            Note: Legacy parameter, will be ignored
            
            Only available for SD15 and SDXL LoRA training */
      scaleLr?: boolean;
      /** Scale of random crops
            
            Only available for SD15 and SDXL LoRA training */
      randomCropScale?: number;
      /** The scheduler type to use (default: "constant")
            
            Only available for SD15 and SDXL LoRA training */
      lrScheduler?:
        | "constant"
        | "constant-with-warmup"
        | "cosine"
        | "cosine-with-restarts"
        | "linear"
        | "polynomial";
      /** The dimension of the LoRA update matrices
            
            Only available for SDXL and Flux LoRA training
            
            Default value varies depending on the model type:
            - For SDXL: 64
            - For Flux: 16 */
      rank?: number;
      /** Initial learning rate (after the potential warmup period) for the UNet
            
            Only available for SDXL LoRA training */
      learningRateUnet?: number;
      /** Validation prompt
            
            Only available for SD15 and SDXL LoRA training */
      validationPrompt?: string;
      /** The prompt with identifier specifying the instance (or subject) of the class (example: "a daiton dog")
            
            Default value varies depending on the model type:
            - For SD1.5: "daiton" if no class is associated with the model
            - For SDXL: "daiton"
            - For Flux: "" */
      conceptPrompt?: string | null;
      /** Maximum number of training steps to execute (default: varies depending on the model type)
            
            For SDXL LoRA training, please use `numTextTrainSteps` and `numUNetTrainSteps` instead
            
            Default value varies depending on the model type:
            - For SD1.5: round((number of training images * 225) / 3)
            - For SDXL: number of training images * 175
            - For Flux: number of training images * 100
            
            Maximum value varies depending on the model type:
            - For SD1.5 and SDXL: [0, 40000]
            - For Flux: [0, 10000] */
      maxTrainSteps?: number;
    };
    /** List of base model IDs compliant with the model (example: ["flux.1-dev", "flux.1-schnell"])
        This attribute is mainly used for Flux LoRA models */
    compliantModelIds?: string[];
    /** The model status */
    status:
      | "copying"
      | "failed"
      | "new"
      | "trained"
      | "training"
      | "training-canceled";
  };
};
export type PostModelsApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** The concepts is required for the type model: composition */
    concepts?: {
      /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
      modelId: string;
      /** The scale of the model (example: 1.0) */
      scale: number;
    }[];
    /** List of collection IDs to add the model to */
    collectionIds?: string[];
    /** The slug of the class you want to use (ex: "characters-npcs-mobs-characters"). Set to null to unset the class */
    classSlug?: string | null;
    /** The name of your model (ex: "Low-poly dwarf"). */
    name?: string;
    /** The ID of the base model to use as a starting point for the training (example: "stable-diffusion-xl-base-1.0") */
    baseModelId?: string;
    /** The new type of the model (ex: "sd-1_5").
        The type can only be changed if the model has the "new" status. */
    type?:
      | "custom"
      | "flux.1"
      | "flux.1-composition"
      | "flux.1-lora"
      | "flux.1-pro"
      | "flux.1.1-pro-ultra"
      | "flux1.1-pro"
      | "gpt-image-1"
      | "sd-1_5"
      | "sd-1_5-composition"
      | "sd-1_5-lora"
      | "sd-xl"
      | "sd-xl-composition"
      | "sd-xl-lora";
  };
};
export type PostModelsGetBulkApiResponse = /** status 200 200 response */ {
  models: {
    /** The training caption words of the model */
    captionWords?: string[];
    /** The URLs of the first 3 training images of the model. To retrieve the full set of images, get it by modelId */
    trainingImages?: {
      /** The training image upload date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** Automatic captioning of the image */
      automaticCaptioning: string;
      /** The URL of the image */
      downloadUrl: string;
      /** The original file name of the image (example: "my-training-image.jpg") */
      name: string;
      /** Description for the image */
      description: string;
      /** The training image ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
      id: string;
    }[];
    /** The inputs of the model. Only used for custom models. To retrieve this list, get it by modelId with GET /models/{modelId} */
    inputs?: {
      /** The allowed values of the input of type 'string' or 'string_array'
            In case of string, it's a single value select list
            In case of string_array, it's a multi value select list */
      allowedValues?: string[];
      /** The maximum value of the input (only available for inputs of type 'number' and inputs as array) */
      max?: number;
      /** The kind of the input. Only available for inputs of type 'file' (and 'file_array') */
      kind?: "3d" | "audio" | "document" | "image" | "json" | "video";
      /** The minimum length of the input where the input is a string (also available for each item in string_array) */
      minLength?: number;
      /** The description of the input, to display in the UI as an help text adding information about the input */
      description?: string;
      /** The label of the input displayed in the UI */
      label?: string;
      /** The type of the input */
      type:
        | "boolean"
        | "file"
        | "file_array"
        | "number"
        | "number_array"
        | "string"
        | "string_array";
      /** Whether the input is required */
      required: boolean;
      /** The minimum value of the input (only available for inputs of type 'number' and inputs as array) */
      min?: number;
      /** A hint to the user about the input, to display in the UI with a tooltip */
      hint?: string;
      /** The name of the input internally used by the model and API */
      name: string;
      /** The maximum length of the input where the input is a string (also available for each item in string_array) */
      maxLength?: number;
      /** The group of the input. If 2 inputs have the same group, they will be displayed in the same group in the UI
            They will be always together in this list of inputs */
      group?: string;
    }[];
    /** List of all example asset IDs setup by the model owner */
    exampleAssetIds?: string[];
    /** The privacy of the model (default: private) */
    privacy?: "private" | "public" | "unlisted";
    /** The date when the model will be soft deleted (only for Free plan) */
    softDeletionOn?: string;
    /** The UI configuration for the model */
    uiConfig?: {
      triggerGenerate?: {
        /** The 'name' of the input where the trigger generate button will be displayed (after the input).
                Do not specify both position and after. */
        after?: string;
        label: string;
        /** The position of the trigger generate button. If position specified, the button will be displayed at the specified position.
                Do not specify both position and after. */
        position?: "bottom" | "top";
      };
    };
    /** The source of the model */
    source?: "civitai" | "huggingface" | "other" | "scenario";
    /** The owner ID (example: "team_VFhihHKMRZyDDnZAJwLb2Q") */
    ownerId?: string;
    /** The model type (example: sd-1_5) */
    type:
      | "custom"
      | "flux.1"
      | "flux.1-composition"
      | "flux.1-lora"
      | "flux.1-pro"
      | "flux.1.1-pro-ultra"
      | "flux1.1-pro"
      | "gpt-image-1"
      | "sd-1_5"
      | "sd-1_5-composition"
      | "sd-1_5-lora"
      | "sd-xl"
      | "sd-xl-composition"
      | "sd-xl-lora";
    /** The model creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt?: string;
    /** Additional information about the model's training */
    trainingStats?: {
      /** The training duration in seconds */
      trainDuration?: number;
      /** The training queued duration in seconds */
      queueDuration?: number;
      /** The training end time as an ISO date string */
      endedAt?: string;
      /** The training start time as an ISO date string */
      startedAt?: string;
    };
    /** Fine-tune the model's inferences with prompt embedding */
    promptEmbedding?: string;
    /** Additional information about the training progress of the model */
    trainingProgress?: {
      /** The stage of the request */
      stage:
        | "pending"
        | "queued-for-train"
        | "running-train"
        | "starting-train";
      /** The remaining time in milliseconds */
      remainingTimeMs?: number;
      /** The progress of the job */
      progress?: number;
      /** The timestamp in millisecond marking the start of the process */
      startedAt?: number;
      /** Position of the job in the queue (ie. the number of job in the queue before this one) */
      position?: number;
      /** Timestamp in milliseconds of the last time the training progress was updated */
      updatedAt: number;
    };
    /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
    id: string;
    /** The class of the model */
    class?: {
      /** The model ID of the class (example: "stable-diffusion-v1-5") */
      modelId: string;
      /** The class name (example: "Character Design") */
      name: string;
      /** The category slug of the class (example: "art-style") */
      category: string;
      /** Some example images URLs to showcase the class */
      thumbnails: string[];
      /** The class prompt (example: "a character design") */
      prompt: string;
      /** The concept prompt of the class (example: "a sks character design") */
      conceptPrompt: string;
      /** The class slug (example: "art-style-character-design") */
      slug: string;
      /** The class status (only published classes are listed, but unpublished classes can still appear in existing models) */
      status: "published" | "unpublished";
    };
    /** The model last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    updatedAt?: string;
    /** A thumbnail for your model */
    thumbnail?: {
      /** The AssetId of the image used as a thumbnail for your model (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
      assetId: string;
      /** The url of the image used as a thumbnail for your model */
      url: string;
    };
    /** List of model capabilities (example: ["txt2img", "img2img", "txt2img_ip_adapter", ...]) */
    capabilities?: (
      | "controlnet"
      | "controlnet_img2img"
      | "controlnet_inpaint"
      | "controlnet_inpaint_ip_adapter"
      | "controlnet_ip_adapter"
      | "controlnet_reference"
      | "controlnet_texture"
      | "img2img"
      | "img2img_ip_adapter"
      | "img2img_texture"
      | "inpaint"
      | "inpaint_ip_adapter"
      | "outpaint"
      | "reference"
      | "reference_texture"
      | "txt2img"
      | "txt2img_ip_adapter"
      | "txt2img_texture"
    )[];
    /** The id of the parent model */
    parentModelId?: string;
    /** The total number of training images */
    trainingImagesNumber?: number;
    /** Whether the model is a custom model and can be used only with POST /generate/custom/{modelId} endpoint */
    custom?: boolean;
    /** The model keyword, this is a legacy parameter, please use conceptPrompt in parameters */
    modelKeyword?: string;
    /** The author user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
    authorId?: string;
    /** (Deprecated) The user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
    userId?: string;
    /** The associated tags (example: ["sci-fi", "landscape"]) */
    tags?: string[];
    /** Fine-tune the model's inferences with negative prompt embedding */
    negativePromptEmbedding?: string;
    /** The concepts is required for the type model: composition */
    concepts?: {
      /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
      modelId: string;
      /** The scale of the model (example: 1.0) */
      scale: number;
    }[];
    /** A list of CollectionId this model belongs to */
    collectionIds?: string[];
    /** The model name (example: "Low-poly dwarf") */
    name?: string;
    /** The model's training parameters */
    parameters?: {
      /** Whether to train the text encoder or not
            
            Example: For 100 steps and a value of 0.2, it means that the text encoder will be trained for 20 steps and then the UNet for 80 steps
            
            Note: Legacy parameter, please use `numTextTrainSteps` and `numUNetTrainSteps`
            
            Only available for SD15 and SDXL LoRA training */
      textEncoderTrainingRatio?: number;
      /** The weight of prior preservation loss
            
            Only available for SD15 and SDXL LoRA training */
      priorLossWeight?: number;
      /** Used to reproduce previous results. Default: randomly generated number.
            
            Only available for SD15 and SDXL LoRA training */
      seed?: number;
      /** The number of training steps for the UNet
            
            Only available for SDXL LoRA training */
      numUNetTrainSteps?: number;
      /** Validation frequency. Cannot be greater than maxTrainSteps value
            
            Only available for SD15 and SDXL LoRA training */
      validationFrequency?: number;
      /** Ratio of random crops
            
            Only available for SD15 and SDXL LoRA training */
      randomCropRatio?: number;
      /** Initial learning rate (after the potential warmup period)
            
            Default value varies depending on the model type:
            - For SD1.5 and SDXL: 0.000005
            - For Flux: 0.0004 */
      learningRate?: number;
      /** Optimize the model training task for a specific type of input images. The available values are:
            - "likeness": optimize training for likeness or portrait
            
            Only available for Flux LoRA training */
      optimizeFor?: "likeness" | null;
      /** Whether to random crop or center crop images before resizing to the working resolution
            
            Only available for SD15 and SDXL LoRA training */
      randomCrop?: boolean;
      /** The prompt to specify images in the same class as provided instance images
            
            Only available for SD15 training */
      classPrompt?: string;
      /** The number of training steps for the text encoder
            
            Only available for SDXL LoRA training */
      numTextTrainSteps?: number;
      /** Initial learning rate (after the potential warmup period) for the text encoder
            
            Only available for SDXL LoRA training */
      learningRateTextEncoder?: number;
      /** The Weights And Bias key to use for logging. The maximum length is 40 characters */
      wandbKey?: string;
      /** Whether to scale the learning rate
            
            Note: Legacy parameter, will be ignored
            
            Only available for SD15 and SDXL LoRA training */
      scaleLr?: boolean;
      /** Scale of random crops
            
            Only available for SD15 and SDXL LoRA training */
      randomCropScale?: number;
      /** The scheduler type to use (default: "constant")
            
            Only available for SD15 and SDXL LoRA training */
      lrScheduler?:
        | "constant"
        | "constant-with-warmup"
        | "cosine"
        | "cosine-with-restarts"
        | "linear"
        | "polynomial";
      /** The dimension of the LoRA update matrices
            
            Only available for SDXL and Flux LoRA training
            
            Default value varies depending on the model type:
            - For SDXL: 64
            - For Flux: 16 */
      rank?: number;
      /** Initial learning rate (after the potential warmup period) for the UNet
            
            Only available for SDXL LoRA training */
      learningRateUnet?: number;
      /** Validation prompt
            
            Only available for SD15 and SDXL LoRA training */
      validationPrompt?: string;
      /** The prompt with identifier specifying the instance (or subject) of the class (example: "a daiton dog")
            
            Default value varies depending on the model type:
            - For SD1.5: "daiton" if no class is associated with the model
            - For SDXL: "daiton"
            - For Flux: "" */
      conceptPrompt?: string | null;
      /** Maximum number of training steps to execute (default: varies depending on the model type)
            
            For SDXL LoRA training, please use `numTextTrainSteps` and `numUNetTrainSteps` instead
            
            Default value varies depending on the model type:
            - For SD1.5: round((number of training images * 225) / 3)
            - For SDXL: number of training images * 175
            - For Flux: number of training images * 100
            
            Maximum value varies depending on the model type:
            - For SD1.5 and SDXL: [0, 40000]
            - For Flux: [0, 10000] */
      maxTrainSteps?: number;
    };
    /** List of base model IDs compliant with the model (example: ["flux.1-dev", "flux.1-schnell"])
        This attribute is mainly used for Flux LoRA models */
    compliantModelIds?: string[];
    /** The model status */
    status?:
      | "copying"
      | "failed"
      | "new"
      | "trained"
      | "training"
      | "training-canceled";
  }[];
};
export type PostModelsGetBulkApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** If true, will return the settings: `promptEmbedding` and `negativePromptEmbedding`. */
    settings?: boolean;
    /** If true will return the first 3 training images; otherwise returns the full training images.
        
        If `allTrainingImages` set to true, this parameter is ignored. */
    trainingImagesPreview?: boolean;
    /** If true will return only the base details of the model (id, name, type)
        
        if true, all other parameters are ignored */
    minimal?: boolean;
    /** If true will return the thumbnail, when no thumbnail is set, will try to fetch the first training image instead. */
    thumbnail?: boolean;
    /** If true will return all training images; otherwise returns only the first 3 training images.
        
        If `trainingImagesPreview` set to true, this parameter is ignored. */
    allTrainingImages?: boolean;
    /** The list of model IDs to include in the response */
    modelIds?: string[];
  };
};
export type GetModelsByModelIdApiResponse = /** status 200 200 response */ {
  model: {
    /** The training caption words of the model */
    captionWords?: string[];
    /** The URLs of the first 3 training images of the model. To retrieve the full set of images, get it by modelId */
    trainingImages?: {
      /** The training image upload date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** Automatic captioning of the image */
      automaticCaptioning: string;
      /** The URL of the image */
      downloadUrl: string;
      /** The original file name of the image (example: "my-training-image.jpg") */
      name: string;
      /** Description for the image */
      description: string;
      /** The training image ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
      id: string;
    }[];
    /** The inputs of the model. Only used for custom models. To retrieve this list, get it by modelId with GET /models/{modelId} */
    inputs?: {
      default?: any;
      /** The allowed values of the input of type 'string' or 'string_array'
            In case of string, it's a single value select list
            In case of string_array, it's a multi value select list */
      allowedValues?: string[];
      /** The maximum value of the input (only available for inputs of type 'number' and inputs as array) */
      max?: number;
      /** The kind of the input. Only available for inputs of type 'file' (and 'file_array') */
      kind?: "3d" | "audio" | "document" | "image" | "json" | "video";
      /** The minimum length of the input where the input is a string (also available for each item in string_array) */
      minLength?: number;
      /** The description of the input, to display in the UI as an help text adding information about the input */
      description?: string;
      /** The label of the input displayed in the UI */
      label?: string;
      /** The type of the input */
      type:
        | "boolean"
        | "file"
        | "file_array"
        | "number"
        | "number_array"
        | "string"
        | "string_array";
      /** Whether the input is required */
      required: boolean;
      /** The minimum value of the input (only available for inputs of type 'number' and inputs as array) */
      min?: number;
      /** A hint to the user about the input, to display in the UI with a tooltip */
      hint?: string;
      /** The name of the input internally used by the model and API */
      name: string;
      /** The maximum length of the input where the input is a string (also available for each item in string_array) */
      maxLength?: number;
      /** The group of the input. If 2 inputs have the same group, they will be displayed in the same group in the UI
            They will be always together in this list of inputs */
      group?: string;
    }[];
    /** List of all example asset IDs setup by the model owner */
    exampleAssetIds: string[];
    /** The privacy of the model (default: private) */
    privacy: "private" | "public" | "unlisted";
    /** The date when the model will be soft deleted (only for Free plan) */
    softDeletionOn?: string;
    /** The UI configuration for the model */
    uiConfig?: {
      triggerGenerate?: {
        /** The 'name' of the input where the trigger generate button will be displayed (after the input).
                Do not specify both position and after. */
        after?: string;
        label: string;
        /** The position of the trigger generate button. If position specified, the button will be displayed at the specified position.
                Do not specify both position and after. */
        position?: "bottom" | "top";
      };
    };
    /** The source of the model */
    source: "civitai" | "huggingface" | "other" | "scenario";
    /** The owner ID (example: "team_VFhihHKMRZyDDnZAJwLb2Q") */
    ownerId?: string;
    /** The model type (example: sd-1_5) */
    type:
      | "custom"
      | "flux.1"
      | "flux.1-composition"
      | "flux.1-lora"
      | "flux.1-pro"
      | "flux.1.1-pro-ultra"
      | "flux1.1-pro"
      | "gpt-image-1"
      | "sd-1_5"
      | "sd-1_5-composition"
      | "sd-1_5-lora"
      | "sd-xl"
      | "sd-xl-composition"
      | "sd-xl-lora";
    /** The model creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt: string;
    /** Additional information about the model's training */
    trainingStats?: {
      /** The training duration in seconds */
      trainDuration?: number;
      /** The training queued duration in seconds */
      queueDuration?: number;
      /** The training end time as an ISO date string */
      endedAt?: string;
      /** The training start time as an ISO date string */
      startedAt?: string;
    };
    /** Fine-tune the model's inferences with prompt embedding */
    promptEmbedding?: string;
    /** Additional information about the training progress of the model */
    trainingProgress?: {
      /** The stage of the request */
      stage:
        | "pending"
        | "queued-for-train"
        | "running-train"
        | "starting-train";
      /** The remaining time in milliseconds */
      remainingTimeMs?: number;
      /** The progress of the job */
      progress?: number;
      /** The timestamp in millisecond marking the start of the process */
      startedAt?: number;
      /** Position of the job in the queue (ie. the number of job in the queue before this one) */
      position?: number;
      /** Timestamp in milliseconds of the last time the training progress was updated */
      updatedAt: number;
    };
    /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
    id: string;
    /** The class of the model */
    class?: {
      /** The model ID of the class (example: "stable-diffusion-v1-5") */
      modelId: string;
      /** The class name (example: "Character Design") */
      name: string;
      /** The category slug of the class (example: "art-style") */
      category: string;
      /** Some example images URLs to showcase the class */
      thumbnails: string[];
      /** The class prompt (example: "a character design") */
      prompt: string;
      /** The concept prompt of the class (example: "a sks character design") */
      conceptPrompt: string;
      /** The class slug (example: "art-style-character-design") */
      slug: string;
      /** The class status (only published classes are listed, but unpublished classes can still appear in existing models) */
      status: "published" | "unpublished";
    };
    /** The model last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    updatedAt: string;
    /** A thumbnail for your model */
    thumbnail?: {
      /** The AssetId of the image used as a thumbnail for your model (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
      assetId: string;
      /** The url of the image used as a thumbnail for your model */
      url: string;
    };
    /** List of model capabilities (example: ["txt2img", "img2img", "txt2img_ip_adapter", ...]) */
    capabilities: (
      | "controlnet"
      | "controlnet_img2img"
      | "controlnet_inpaint"
      | "controlnet_inpaint_ip_adapter"
      | "controlnet_ip_adapter"
      | "controlnet_reference"
      | "controlnet_texture"
      | "img2img"
      | "img2img_ip_adapter"
      | "img2img_texture"
      | "inpaint"
      | "inpaint_ip_adapter"
      | "outpaint"
      | "reference"
      | "reference_texture"
      | "txt2img"
      | "txt2img_ip_adapter"
      | "txt2img_texture"
    )[];
    /** The id of the parent model */
    parentModelId?: string;
    /** The total number of training images */
    trainingImagesNumber: number;
    /** Whether the model is a custom model and can be used only with POST /generate/custom/{modelId} endpoint */
    custom: boolean;
    /** The model keyword, this is a legacy parameter, please use conceptPrompt in parameters */
    modelKeyword?: string;
    /** The author user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
    authorId?: string;
    /** (Deprecated) The user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
    userId?: string;
    /** The associated tags (example: ["sci-fi", "landscape"]) */
    tags: string[];
    /** Fine-tune the model's inferences with negative prompt embedding */
    negativePromptEmbedding?: string;
    /** The concepts is required for the type model: composition */
    concepts?: {
      /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
      modelId: string;
      /** The scale of the model (example: 1.0) */
      scale: number;
    }[];
    /** A list of CollectionId this model belongs to */
    collectionIds: string[];
    /** The model name (example: "Low-poly dwarf") */
    name?: string;
    /** The model's training parameters */
    parameters?: {
      /** Whether to train the text encoder or not
            
            Example: For 100 steps and a value of 0.2, it means that the text encoder will be trained for 20 steps and then the UNet for 80 steps
            
            Note: Legacy parameter, please use `numTextTrainSteps` and `numUNetTrainSteps`
            
            Only available for SD15 and SDXL LoRA training */
      textEncoderTrainingRatio?: number;
      /** The weight of prior preservation loss
            
            Only available for SD15 and SDXL LoRA training */
      priorLossWeight?: number;
      /** Used to reproduce previous results. Default: randomly generated number.
            
            Only available for SD15 and SDXL LoRA training */
      seed?: number;
      /** The number of training steps for the UNet
            
            Only available for SDXL LoRA training */
      numUNetTrainSteps?: number;
      /** Validation frequency. Cannot be greater than maxTrainSteps value
            
            Only available for SD15 and SDXL LoRA training */
      validationFrequency?: number;
      /** Ratio of random crops
            
            Only available for SD15 and SDXL LoRA training */
      randomCropRatio?: number;
      /** Initial learning rate (after the potential warmup period)
            
            Default value varies depending on the model type:
            - For SD1.5 and SDXL: 0.000005
            - For Flux: 0.0004 */
      learningRate?: number;
      /** Optimize the model training task for a specific type of input images. The available values are:
            - "likeness": optimize training for likeness or portrait
            
            Only available for Flux LoRA training */
      optimizeFor?: "likeness" | null;
      /** Whether to random crop or center crop images before resizing to the working resolution
            
            Only available for SD15 and SDXL LoRA training */
      randomCrop?: boolean;
      /** The prompt to specify images in the same class as provided instance images
            
            Only available for SD15 training */
      classPrompt?: string;
      /** The number of training steps for the text encoder
            
            Only available for SDXL LoRA training */
      numTextTrainSteps?: number;
      /** Initial learning rate (after the potential warmup period) for the text encoder
            
            Only available for SDXL LoRA training */
      learningRateTextEncoder?: number;
      /** The Weights And Bias key to use for logging. The maximum length is 40 characters */
      wandbKey?: string;
      /** Whether to scale the learning rate
            
            Note: Legacy parameter, will be ignored
            
            Only available for SD15 and SDXL LoRA training */
      scaleLr?: boolean;
      /** Scale of random crops
            
            Only available for SD15 and SDXL LoRA training */
      randomCropScale?: number;
      /** The scheduler type to use (default: "constant")
            
            Only available for SD15 and SDXL LoRA training */
      lrScheduler?:
        | "constant"
        | "constant-with-warmup"
        | "cosine"
        | "cosine-with-restarts"
        | "linear"
        | "polynomial";
      /** The dimension of the LoRA update matrices
            
            Only available for SDXL and Flux LoRA training
            
            Default value varies depending on the model type:
            - For SDXL: 64
            - For Flux: 16 */
      rank?: number;
      /** Initial learning rate (after the potential warmup period) for the UNet
            
            Only available for SDXL LoRA training */
      learningRateUnet?: number;
      /** Validation prompt
            
            Only available for SD15 and SDXL LoRA training */
      validationPrompt?: string;
      /** The prompt with identifier specifying the instance (or subject) of the class (example: "a daiton dog")
            
            Default value varies depending on the model type:
            - For SD1.5: "daiton" if no class is associated with the model
            - For SDXL: "daiton"
            - For Flux: "" */
      conceptPrompt?: string | null;
      /** Maximum number of training steps to execute (default: varies depending on the model type)
            
            For SDXL LoRA training, please use `numTextTrainSteps` and `numUNetTrainSteps` instead
            
            Default value varies depending on the model type:
            - For SD1.5: round((number of training images * 225) / 3)
            - For SDXL: number of training images * 175
            - For Flux: number of training images * 100
            
            Maximum value varies depending on the model type:
            - For SD1.5 and SDXL: [0, 40000]
            - For Flux: [0, 10000] */
      maxTrainSteps?: number;
    };
    /** List of base model IDs compliant with the model (example: ["flux.1-dev", "flux.1-schnell"])
        This attribute is mainly used for Flux LoRA models */
    compliantModelIds?: string[];
    /** The model status */
    status:
      | "copying"
      | "failed"
      | "new"
      | "trained"
      | "training"
      | "training-canceled";
  };
};
export type GetModelsByModelIdApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The modelId to retrieve */
  modelId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
};
export type PutModelsByModelIdApiResponse = /** status 200 200 response */ {
  model: {
    /** The training caption words of the model */
    captionWords?: string[];
    /** The URLs of the first 3 training images of the model. To retrieve the full set of images, get it by modelId */
    trainingImages?: {
      /** The training image upload date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** Automatic captioning of the image */
      automaticCaptioning: string;
      /** The URL of the image */
      downloadUrl: string;
      /** The original file name of the image (example: "my-training-image.jpg") */
      name: string;
      /** Description for the image */
      description: string;
      /** The training image ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
      id: string;
    }[];
    /** The inputs of the model. Only used for custom models. To retrieve this list, get it by modelId with GET /models/{modelId} */
    inputs?: {
      /** The allowed values of the input of type 'string' or 'string_array'
            In case of string, it's a single value select list
            In case of string_array, it's a multi value select list */
      allowedValues?: string[];
      /** The maximum value of the input (only available for inputs of type 'number' and inputs as array) */
      max?: number;
      /** The kind of the input. Only available for inputs of type 'file' (and 'file_array') */
      kind?: "3d" | "audio" | "document" | "image" | "json" | "video";
      /** The minimum length of the input where the input is a string (also available for each item in string_array) */
      minLength?: number;
      /** The description of the input, to display in the UI as an help text adding information about the input */
      description?: string;
      /** The label of the input displayed in the UI */
      label?: string;
      /** The type of the input */
      type:
        | "boolean"
        | "file"
        | "file_array"
        | "number"
        | "number_array"
        | "string"
        | "string_array";
      /** Whether the input is required */
      required: boolean;
      /** The minimum value of the input (only available for inputs of type 'number' and inputs as array) */
      min?: number;
      /** A hint to the user about the input, to display in the UI with a tooltip */
      hint?: string;
      /** The name of the input internally used by the model and API */
      name: string;
      /** The maximum length of the input where the input is a string (also available for each item in string_array) */
      maxLength?: number;
      /** The group of the input. If 2 inputs have the same group, they will be displayed in the same group in the UI
            They will be always together in this list of inputs */
      group?: string;
    }[];
    /** List of all example asset IDs setup by the model owner */
    exampleAssetIds: string[];
    /** The privacy of the model (default: private) */
    privacy: "private" | "public" | "unlisted";
    /** The date when the model will be soft deleted (only for Free plan) */
    softDeletionOn?: string;
    /** The UI configuration for the model */
    uiConfig?: {
      triggerGenerate?: {
        /** The 'name' of the input where the trigger generate button will be displayed (after the input).
                Do not specify both position and after. */
        after?: string;
        label: string;
        /** The position of the trigger generate button. If position specified, the button will be displayed at the specified position.
                Do not specify both position and after. */
        position?: "bottom" | "top";
      };
    };
    /** The source of the model */
    source: "civitai" | "huggingface" | "other" | "scenario";
    /** The owner ID (example: "team_VFhihHKMRZyDDnZAJwLb2Q") */
    ownerId?: string;
    /** The model type (example: sd-1_5) */
    type:
      | "custom"
      | "flux.1"
      | "flux.1-composition"
      | "flux.1-lora"
      | "flux.1-pro"
      | "flux.1.1-pro-ultra"
      | "flux1.1-pro"
      | "gpt-image-1"
      | "sd-1_5"
      | "sd-1_5-composition"
      | "sd-1_5-lora"
      | "sd-xl"
      | "sd-xl-composition"
      | "sd-xl-lora";
    /** The model creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt: string;
    /** Additional information about the model's training */
    trainingStats?: {
      /** The training duration in seconds */
      trainDuration?: number;
      /** The training queued duration in seconds */
      queueDuration?: number;
      /** The training end time as an ISO date string */
      endedAt?: string;
      /** The training start time as an ISO date string */
      startedAt?: string;
    };
    /** Fine-tune the model's inferences with prompt embedding */
    promptEmbedding?: string;
    /** Additional information about the training progress of the model */
    trainingProgress?: {
      /** The stage of the request */
      stage:
        | "pending"
        | "queued-for-train"
        | "running-train"
        | "starting-train";
      /** The remaining time in milliseconds */
      remainingTimeMs?: number;
      /** The progress of the job */
      progress?: number;
      /** The timestamp in millisecond marking the start of the process */
      startedAt?: number;
      /** Position of the job in the queue (ie. the number of job in the queue before this one) */
      position?: number;
      /** Timestamp in milliseconds of the last time the training progress was updated */
      updatedAt: number;
    };
    /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
    id: string;
    /** The class of the model */
    class?: {
      /** The model ID of the class (example: "stable-diffusion-v1-5") */
      modelId: string;
      /** The class name (example: "Character Design") */
      name: string;
      /** The category slug of the class (example: "art-style") */
      category: string;
      /** Some example images URLs to showcase the class */
      thumbnails: string[];
      /** The class prompt (example: "a character design") */
      prompt: string;
      /** The concept prompt of the class (example: "a sks character design") */
      conceptPrompt: string;
      /** The class slug (example: "art-style-character-design") */
      slug: string;
      /** The class status (only published classes are listed, but unpublished classes can still appear in existing models) */
      status: "published" | "unpublished";
    };
    /** The model last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    updatedAt: string;
    /** A thumbnail for your model */
    thumbnail?: {
      /** The AssetId of the image used as a thumbnail for your model (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
      assetId: string;
      /** The url of the image used as a thumbnail for your model */
      url: string;
    };
    /** List of model capabilities (example: ["txt2img", "img2img", "txt2img_ip_adapter", ...]) */
    capabilities: (
      | "controlnet"
      | "controlnet_img2img"
      | "controlnet_inpaint"
      | "controlnet_inpaint_ip_adapter"
      | "controlnet_ip_adapter"
      | "controlnet_reference"
      | "controlnet_texture"
      | "img2img"
      | "img2img_ip_adapter"
      | "img2img_texture"
      | "inpaint"
      | "inpaint_ip_adapter"
      | "outpaint"
      | "reference"
      | "reference_texture"
      | "txt2img"
      | "txt2img_ip_adapter"
      | "txt2img_texture"
    )[];
    /** The id of the parent model */
    parentModelId?: string;
    /** The total number of training images */
    trainingImagesNumber: number;
    /** Whether the model is a custom model and can be used only with POST /generate/custom/{modelId} endpoint */
    custom: boolean;
    /** The model keyword, this is a legacy parameter, please use conceptPrompt in parameters */
    modelKeyword?: string;
    /** The author user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
    authorId?: string;
    /** (Deprecated) The user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
    userId?: string;
    /** The associated tags (example: ["sci-fi", "landscape"]) */
    tags: string[];
    /** Fine-tune the model's inferences with negative prompt embedding */
    negativePromptEmbedding?: string;
    /** The concepts is required for the type model: composition */
    concepts?: {
      /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
      modelId: string;
      /** The scale of the model (example: 1.0) */
      scale: number;
    }[];
    /** A list of CollectionId this model belongs to */
    collectionIds: string[];
    /** The model name (example: "Low-poly dwarf") */
    name?: string;
    /** The model's training parameters */
    parameters?: {
      /** Whether to train the text encoder or not
            
            Example: For 100 steps and a value of 0.2, it means that the text encoder will be trained for 20 steps and then the UNet for 80 steps
            
            Note: Legacy parameter, please use `numTextTrainSteps` and `numUNetTrainSteps`
            
            Only available for SD15 and SDXL LoRA training */
      textEncoderTrainingRatio?: number;
      /** The weight of prior preservation loss
            
            Only available for SD15 and SDXL LoRA training */
      priorLossWeight?: number;
      /** Used to reproduce previous results. Default: randomly generated number.
            
            Only available for SD15 and SDXL LoRA training */
      seed?: number;
      /** The number of training steps for the UNet
            
            Only available for SDXL LoRA training */
      numUNetTrainSteps?: number;
      /** Validation frequency. Cannot be greater than maxTrainSteps value
            
            Only available for SD15 and SDXL LoRA training */
      validationFrequency?: number;
      /** Ratio of random crops
            
            Only available for SD15 and SDXL LoRA training */
      randomCropRatio?: number;
      /** Initial learning rate (after the potential warmup period)
            
            Default value varies depending on the model type:
            - For SD1.5 and SDXL: 0.000005
            - For Flux: 0.0004 */
      learningRate?: number;
      /** Optimize the model training task for a specific type of input images. The available values are:
            - "likeness": optimize training for likeness or portrait
            
            Only available for Flux LoRA training */
      optimizeFor?: "likeness" | null;
      /** Whether to random crop or center crop images before resizing to the working resolution
            
            Only available for SD15 and SDXL LoRA training */
      randomCrop?: boolean;
      /** The prompt to specify images in the same class as provided instance images
            
            Only available for SD15 training */
      classPrompt?: string;
      /** The number of training steps for the text encoder
            
            Only available for SDXL LoRA training */
      numTextTrainSteps?: number;
      /** Initial learning rate (after the potential warmup period) for the text encoder
            
            Only available for SDXL LoRA training */
      learningRateTextEncoder?: number;
      /** The Weights And Bias key to use for logging. The maximum length is 40 characters */
      wandbKey?: string;
      /** Whether to scale the learning rate
            
            Note: Legacy parameter, will be ignored
            
            Only available for SD15 and SDXL LoRA training */
      scaleLr?: boolean;
      /** Scale of random crops
            
            Only available for SD15 and SDXL LoRA training */
      randomCropScale?: number;
      /** The scheduler type to use (default: "constant")
            
            Only available for SD15 and SDXL LoRA training */
      lrScheduler?:
        | "constant"
        | "constant-with-warmup"
        | "cosine"
        | "cosine-with-restarts"
        | "linear"
        | "polynomial";
      /** The dimension of the LoRA update matrices
            
            Only available for SDXL and Flux LoRA training
            
            Default value varies depending on the model type:
            - For SDXL: 64
            - For Flux: 16 */
      rank?: number;
      /** Initial learning rate (after the potential warmup period) for the UNet
            
            Only available for SDXL LoRA training */
      learningRateUnet?: number;
      /** Validation prompt
            
            Only available for SD15 and SDXL LoRA training */
      validationPrompt?: string;
      /** The prompt with identifier specifying the instance (or subject) of the class (example: "a daiton dog")
            
            Default value varies depending on the model type:
            - For SD1.5: "daiton" if no class is associated with the model
            - For SDXL: "daiton"
            - For Flux: "" */
      conceptPrompt?: string | null;
      /** Maximum number of training steps to execute (default: varies depending on the model type)
            
            For SDXL LoRA training, please use `numTextTrainSteps` and `numUNetTrainSteps` instead
            
            Default value varies depending on the model type:
            - For SD1.5: round((number of training images * 225) / 3)
            - For SDXL: number of training images * 175
            - For Flux: number of training images * 100
            
            Maximum value varies depending on the model type:
            - For SD1.5 and SDXL: [0, 40000]
            - For Flux: [0, 10000] */
      maxTrainSteps?: number;
    };
    /** List of base model IDs compliant with the model (example: ["flux.1-dev", "flux.1-schnell"])
        This attribute is mainly used for Flux LoRA models */
    compliantModelIds?: string[];
    /** The model status */
    status:
      | "copying"
      | "failed"
      | "new"
      | "trained"
      | "training"
      | "training-canceled";
  };
};
export type PutModelsByModelIdApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The modelId to update */
  modelId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** Fine-tune the model's inferences with negative prompt embedding */
    negativePromptEmbedding?: string;
    /** The AssetId of the image you want to use as a thumbnail for your model (example: "asset_GTrL3mq4SXWyMxkOHRxlpw"). Set to null to unset the thumbnail */
    thumbnail?: string;
    /** The concepts is required for the type model: composition */
    concepts?: {
      /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
      modelId: string;
      /** The scale of the model (example: 1.0) */
      scale: number;
    }[];
    /** The slug of the class you want to use (ex: "characters-npcs-mobs-characters"). Set to null to unset the class */
    classSlug?: string | null;
    /** The name of your model (ex: "Low-poly dwarf"). */
    name?: string;
    /** Fine-tune the model's inferences with prompt embedding */
    promptEmbedding?: string;
    /** The new type of the model (ex: "sd-1_5").
        The type can only be changed if the model has the "new" status. */
    type?:
      | "custom"
      | "flux.1"
      | "flux.1-composition"
      | "flux.1-lora"
      | "flux.1-pro"
      | "flux.1.1-pro-ultra"
      | "flux1.1-pro"
      | "gpt-image-1"
      | "sd-1_5"
      | "sd-1_5-composition"
      | "sd-1_5-lora"
      | "sd-xl"
      | "sd-xl-composition"
      | "sd-xl-lora";
    /** The parameters to use for the training */
    parameters?: {
      /** Whether to train the text encoder or not
            
            Example: For 100 steps and a value of 0.2, it means that the text encoder will be trained for 20 steps and then the UNet for 80 steps
            
            Note: Legacy parameter, please use `numTextTrainSteps` and `numUNetTrainSteps`
            
            Only available for SD15 and SDXL LoRA training */
      textEncoderTrainingRatio?: number;
      /** The weight of prior preservation loss
            
            Only available for SD15 and SDXL LoRA training */
      priorLossWeight?: number;
      /** Used to reproduce previous results. Default: randomly generated number.
            
            Only available for SD15 and SDXL LoRA training */
      seed?: number;
      /** The number of training steps for the UNet
            
            Only available for SDXL LoRA training */
      numUNetTrainSteps?: number;
      /** Validation frequency. Cannot be greater than maxTrainSteps value
            
            Only available for SD15 and SDXL LoRA training */
      validationFrequency?: number;
      /** Ratio of random crops
            
            Only available for SD15 and SDXL LoRA training */
      randomCropRatio?: number;
      /** Initial learning rate (after the potential warmup period)
            
            Default value varies depending on the model type:
            - For SD1.5 and SDXL: 0.000005
            - For Flux: 0.0004 */
      learningRate?: number;
      /** Optimize the model training task for a specific type of input images. The available values are:
            - "likeness": optimize training for likeness or portrait
            
            Only available for Flux LoRA training */
      optimizeFor?: "likeness" | null;
      /** Whether to random crop or center crop images before resizing to the working resolution
            
            Only available for SD15 and SDXL LoRA training */
      randomCrop?: boolean;
      /** The prompt to specify images in the same class as provided instance images
            
            Only available for SD15 training */
      classPrompt?: string;
      /** The number of training steps for the text encoder
            
            Only available for SDXL LoRA training */
      numTextTrainSteps?: number;
      /** Initial learning rate (after the potential warmup period) for the text encoder
            
            Only available for SDXL LoRA training */
      learningRateTextEncoder?: number;
      /** The Weights And Bias key to use for logging. The maximum length is 40 characters */
      wandbKey?: string;
      /** Whether to scale the learning rate
            
            Note: Legacy parameter, will be ignored
            
            Only available for SD15 and SDXL LoRA training */
      scaleLr?: boolean;
      /** Scale of random crops
            
            Only available for SD15 and SDXL LoRA training */
      randomCropScale?: number;
      /** The scheduler type to use (default: "constant")
            
            Only available for SD15 and SDXL LoRA training */
      lrScheduler?:
        | "constant"
        | "constant-with-warmup"
        | "cosine"
        | "cosine-with-restarts"
        | "linear"
        | "polynomial";
      /** The dimension of the LoRA update matrices
            
            Only available for SDXL and Flux LoRA training
            
            Default value varies depending on the model type:
            - For SDXL: 64
            - For Flux: 16 */
      rank?: number;
      /** Initial learning rate (after the potential warmup period) for the UNet
            
            Only available for SDXL LoRA training */
      learningRateUnet?: number;
      /** Validation prompt
            
            Only available for SD15 and SDXL LoRA training */
      validationPrompt?: string;
      /** The prompt with identifier specifying the instance (or subject) of the class (example: "a daiton dog")
            
            Default value varies depending on the model type:
            - For SD1.5: "daiton" if no class is associated with the model
            - For SDXL: "daiton"
            - For Flux: "" */
      conceptPrompt?: string | null;
      /** Maximum number of training steps to execute (default: varies depending on the model type)
            
            For SDXL LoRA training, please use `numTextTrainSteps` and `numUNetTrainSteps` instead
            
            Default value varies depending on the model type:
            - For SD1.5: round((number of training images * 225) / 3)
            - For SDXL: number of training images * 175
            - For Flux: number of training images * 100
            
            Maximum value varies depending on the model type:
            - For SD1.5 and SDXL: [0, 40000]
            - For Flux: [0, 10000] */
      maxTrainSteps?: number;
    };
  };
};
export type DeleteModelsByModelIdApiResponse =
  /** status 200 200 response */ any;
export type DeleteModelsByModelIdApiArg = {
  /** The modelId to delete */
  modelId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
};
export type PostModelActionByModelIdApiResponse =
  /** status 200 200 response */ {
    model: {
      /** The training caption words of the model */
      captionWords?: string[];
      /** The URLs of the first 3 training images of the model. To retrieve the full set of images, get it by modelId */
      trainingImages?: {
        /** The training image upload date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** Automatic captioning of the image */
        automaticCaptioning: string;
        /** The URL of the image */
        downloadUrl: string;
        /** The original file name of the image (example: "my-training-image.jpg") */
        name: string;
        /** Description for the image */
        description: string;
        /** The training image ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        id: string;
      }[];
      /** The inputs of the model. Only used for custom models. To retrieve this list, get it by modelId with GET /models/{modelId} */
      inputs?: {
        /** The allowed values of the input of type 'string' or 'string_array'
            In case of string, it's a single value select list
            In case of string_array, it's a multi value select list */
        allowedValues?: string[];
        /** The maximum value of the input (only available for inputs of type 'number' and inputs as array) */
        max?: number;
        /** The kind of the input. Only available for inputs of type 'file' (and 'file_array') */
        kind?: "3d" | "audio" | "document" | "image" | "json" | "video";
        /** The minimum length of the input where the input is a string (also available for each item in string_array) */
        minLength?: number;
        /** The description of the input, to display in the UI as an help text adding information about the input */
        description?: string;
        /** The label of the input displayed in the UI */
        label?: string;
        /** The type of the input */
        type:
          | "boolean"
          | "file"
          | "file_array"
          | "number"
          | "number_array"
          | "string"
          | "string_array";
        /** Whether the input is required */
        required: boolean;
        /** The minimum value of the input (only available for inputs of type 'number' and inputs as array) */
        min?: number;
        /** A hint to the user about the input, to display in the UI with a tooltip */
        hint?: string;
        /** The name of the input internally used by the model and API */
        name: string;
        /** The maximum length of the input where the input is a string (also available for each item in string_array) */
        maxLength?: number;
        /** The group of the input. If 2 inputs have the same group, they will be displayed in the same group in the UI
            They will be always together in this list of inputs */
        group?: string;
      }[];
      /** List of all example asset IDs setup by the model owner */
      exampleAssetIds: string[];
      /** The privacy of the model (default: private) */
      privacy: "private" | "public" | "unlisted";
      /** The date when the model will be soft deleted (only for Free plan) */
      softDeletionOn?: string;
      /** The UI configuration for the model */
      uiConfig?: {
        triggerGenerate?: {
          /** The 'name' of the input where the trigger generate button will be displayed (after the input).
                Do not specify both position and after. */
          after?: string;
          label: string;
          /** The position of the trigger generate button. If position specified, the button will be displayed at the specified position.
                Do not specify both position and after. */
          position?: "bottom" | "top";
        };
      };
      /** The source of the model */
      source: "civitai" | "huggingface" | "other" | "scenario";
      /** The owner ID (example: "team_VFhihHKMRZyDDnZAJwLb2Q") */
      ownerId?: string;
      /** The model type (example: sd-1_5) */
      type:
        | "custom"
        | "flux.1"
        | "flux.1-composition"
        | "flux.1-lora"
        | "flux.1-pro"
        | "flux.1.1-pro-ultra"
        | "flux1.1-pro"
        | "gpt-image-1"
        | "sd-1_5"
        | "sd-1_5-composition"
        | "sd-1_5-lora"
        | "sd-xl"
        | "sd-xl-composition"
        | "sd-xl-lora";
      /** The model creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** Additional information about the model's training */
      trainingStats?: {
        /** The training duration in seconds */
        trainDuration?: number;
        /** The training queued duration in seconds */
        queueDuration?: number;
        /** The training end time as an ISO date string */
        endedAt?: string;
        /** The training start time as an ISO date string */
        startedAt?: string;
      };
      /** Fine-tune the model's inferences with prompt embedding */
      promptEmbedding?: string;
      /** Additional information about the training progress of the model */
      trainingProgress?: {
        /** The stage of the request */
        stage:
          | "pending"
          | "queued-for-train"
          | "running-train"
          | "starting-train";
        /** The remaining time in milliseconds */
        remainingTimeMs?: number;
        /** The progress of the job */
        progress?: number;
        /** The timestamp in millisecond marking the start of the process */
        startedAt?: number;
        /** Position of the job in the queue (ie. the number of job in the queue before this one) */
        position?: number;
        /** Timestamp in milliseconds of the last time the training progress was updated */
        updatedAt: number;
      };
      /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
      id: string;
      /** The class of the model */
      class?: {
        /** The model ID of the class (example: "stable-diffusion-v1-5") */
        modelId: string;
        /** The class name (example: "Character Design") */
        name: string;
        /** The category slug of the class (example: "art-style") */
        category: string;
        /** Some example images URLs to showcase the class */
        thumbnails: string[];
        /** The class prompt (example: "a character design") */
        prompt: string;
        /** The concept prompt of the class (example: "a sks character design") */
        conceptPrompt: string;
        /** The class slug (example: "art-style-character-design") */
        slug: string;
        /** The class status (only published classes are listed, but unpublished classes can still appear in existing models) */
        status: "published" | "unpublished";
      };
      /** The model last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      updatedAt: string;
      /** A thumbnail for your model */
      thumbnail?: {
        /** The AssetId of the image used as a thumbnail for your model (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        assetId: string;
        /** The url of the image used as a thumbnail for your model */
        url: string;
      };
      /** List of model capabilities (example: ["txt2img", "img2img", "txt2img_ip_adapter", ...]) */
      capabilities: (
        | "controlnet"
        | "controlnet_img2img"
        | "controlnet_inpaint"
        | "controlnet_inpaint_ip_adapter"
        | "controlnet_ip_adapter"
        | "controlnet_reference"
        | "controlnet_texture"
        | "img2img"
        | "img2img_ip_adapter"
        | "img2img_texture"
        | "inpaint"
        | "inpaint_ip_adapter"
        | "outpaint"
        | "reference"
        | "reference_texture"
        | "txt2img"
        | "txt2img_ip_adapter"
        | "txt2img_texture"
      )[];
      /** The id of the parent model */
      parentModelId?: string;
      /** The total number of training images */
      trainingImagesNumber: number;
      /** Whether the model is a custom model and can be used only with POST /generate/custom/{modelId} endpoint */
      custom: boolean;
      /** The model keyword, this is a legacy parameter, please use conceptPrompt in parameters */
      modelKeyword?: string;
      /** The author user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
      authorId?: string;
      /** (Deprecated) The user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
      userId?: string;
      /** The associated tags (example: ["sci-fi", "landscape"]) */
      tags: string[];
      /** Fine-tune the model's inferences with negative prompt embedding */
      negativePromptEmbedding?: string;
      /** The concepts is required for the type model: composition */
      concepts?: {
        /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
        modelId: string;
        /** The scale of the model (example: 1.0) */
        scale: number;
      }[];
      /** A list of CollectionId this model belongs to */
      collectionIds: string[];
      /** The model name (example: "Low-poly dwarf") */
      name?: string;
      /** The model's training parameters */
      parameters?: {
        /** Whether to train the text encoder or not
            
            Example: For 100 steps and a value of 0.2, it means that the text encoder will be trained for 20 steps and then the UNet for 80 steps
            
            Note: Legacy parameter, please use `numTextTrainSteps` and `numUNetTrainSteps`
            
            Only available for SD15 and SDXL LoRA training */
        textEncoderTrainingRatio?: number;
        /** The weight of prior preservation loss
            
            Only available for SD15 and SDXL LoRA training */
        priorLossWeight?: number;
        /** Used to reproduce previous results. Default: randomly generated number.
            
            Only available for SD15 and SDXL LoRA training */
        seed?: number;
        /** The number of training steps for the UNet
            
            Only available for SDXL LoRA training */
        numUNetTrainSteps?: number;
        /** Validation frequency. Cannot be greater than maxTrainSteps value
            
            Only available for SD15 and SDXL LoRA training */
        validationFrequency?: number;
        /** Ratio of random crops
            
            Only available for SD15 and SDXL LoRA training */
        randomCropRatio?: number;
        /** Initial learning rate (after the potential warmup period)
            
            Default value varies depending on the model type:
            - For SD1.5 and SDXL: 0.000005
            - For Flux: 0.0004 */
        learningRate?: number;
        /** Optimize the model training task for a specific type of input images. The available values are:
            - "likeness": optimize training for likeness or portrait
            
            Only available for Flux LoRA training */
        optimizeFor?: "likeness" | null;
        /** Whether to random crop or center crop images before resizing to the working resolution
            
            Only available for SD15 and SDXL LoRA training */
        randomCrop?: boolean;
        /** The prompt to specify images in the same class as provided instance images
            
            Only available for SD15 training */
        classPrompt?: string;
        /** The number of training steps for the text encoder
            
            Only available for SDXL LoRA training */
        numTextTrainSteps?: number;
        /** Initial learning rate (after the potential warmup period) for the text encoder
            
            Only available for SDXL LoRA training */
        learningRateTextEncoder?: number;
        /** The Weights And Bias key to use for logging. The maximum length is 40 characters */
        wandbKey?: string;
        /** Whether to scale the learning rate
            
            Note: Legacy parameter, will be ignored
            
            Only available for SD15 and SDXL LoRA training */
        scaleLr?: boolean;
        /** Scale of random crops
            
            Only available for SD15 and SDXL LoRA training */
        randomCropScale?: number;
        /** The scheduler type to use (default: "constant")
            
            Only available for SD15 and SDXL LoRA training */
        lrScheduler?:
          | "constant"
          | "constant-with-warmup"
          | "cosine"
          | "cosine-with-restarts"
          | "linear"
          | "polynomial";
        /** The dimension of the LoRA update matrices
            
            Only available for SDXL and Flux LoRA training
            
            Default value varies depending on the model type:
            - For SDXL: 64
            - For Flux: 16 */
        rank?: number;
        /** Initial learning rate (after the potential warmup period) for the UNet
            
            Only available for SDXL LoRA training */
        learningRateUnet?: number;
        /** Validation prompt
            
            Only available for SD15 and SDXL LoRA training */
        validationPrompt?: string;
        /** The prompt with identifier specifying the instance (or subject) of the class (example: "a daiton dog")
            
            Default value varies depending on the model type:
            - For SD1.5: "daiton" if no class is associated with the model
            - For SDXL: "daiton"
            - For Flux: "" */
        conceptPrompt?: string | null;
        /** Maximum number of training steps to execute (default: varies depending on the model type)
            
            For SDXL LoRA training, please use `numTextTrainSteps` and `numUNetTrainSteps` instead
            
            Default value varies depending on the model type:
            - For SD1.5: round((number of training images * 225) / 3)
            - For SDXL: number of training images * 175
            - For Flux: number of training images * 100
            
            Maximum value varies depending on the model type:
            - For SD1.5 and SDXL: [0, 40000]
            - For Flux: [0, 10000] */
        maxTrainSteps?: number;
      };
      /** List of base model IDs compliant with the model (example: ["flux.1-dev", "flux.1-schnell"])
        This attribute is mainly used for Flux LoRA models */
      compliantModelIds?: string[];
      /** The model status */
      status:
        | "copying"
        | "failed"
        | "new"
        | "trained"
        | "training"
        | "training-canceled";
    };
  };
export type PostModelActionByModelIdApiArg = {
  /** The model Id */
  modelId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** The action to perform on the model */
    action: "publish" | "unload" | "unpublish";
  };
};
export type GetModelsCategoriesByModelIdApiResponse =
  /** status 200 200 response */ {
    categories: {
      /** The category name (example: "Art style") */
      name: string;
      /** The number of published classes within this category. */
      publishedClassesNumber: number;
      /** The category slug (example: "art-style") */
      slug: string;
    }[];
  };
export type GetModelsCategoriesByModelIdApiArg = {
  /** The categories available for that modelId */
  modelId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
};
export type GetModelsClassesByModelIdApiResponse =
  /** status 200 200 response */ {
    /** A token to query the next page of classes */
    nextPaginationToken?: string;
    classes: {
      /** The model ID of the class (example: "stable-diffusion-v1-5") */
      modelId: string;
      /** The class name (example: "Character Design") */
      name: string;
      /** The category slug of the class (example: "art-style") */
      category: string;
      /** Some example images URLs to showcase the class */
      thumbnails: string[];
      /** The class prompt (example: "a character design") */
      prompt: string;
      /** The concept prompt of the class (example: "a sks character design") */
      conceptPrompt: string;
      /** The class slug (example: "art-style-character-design") */
      slug: string;
      /** The class status (only published classes are listed, but unpublished classes can still appear in existing models) */
      status: "published" | "unpublished";
    }[];
  };
export type GetModelsClassesByModelIdApiArg = {
  /** The modelId of the category */
  modelId: string;
  /** The category of the classes */
  category?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  /** The number of items to return in the response. The default value is 10, maximum value is 50, minimum value is 1 */
  pageSize?: string;
  /** A token you received in a previous request to query the next page of items */
  paginationToken?: string;
};
export type PostModelsCopyByModelIdApiResponse =
  /** status 200 200 response */ {
    model: {
      /** The training caption words of the model */
      captionWords?: string[];
      /** The URLs of the first 3 training images of the model. To retrieve the full set of images, get it by modelId */
      trainingImages?: {
        /** The training image upload date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** Automatic captioning of the image */
        automaticCaptioning: string;
        /** The URL of the image */
        downloadUrl: string;
        /** The original file name of the image (example: "my-training-image.jpg") */
        name: string;
        /** Description for the image */
        description: string;
        /** The training image ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        id: string;
      }[];
      /** The inputs of the model. Only used for custom models. To retrieve this list, get it by modelId with GET /models/{modelId} */
      inputs?: {
        /** The allowed values of the input of type 'string' or 'string_array'
            In case of string, it's a single value select list
            In case of string_array, it's a multi value select list */
        allowedValues?: string[];
        /** The maximum value of the input (only available for inputs of type 'number' and inputs as array) */
        max?: number;
        /** The kind of the input. Only available for inputs of type 'file' (and 'file_array') */
        kind?: "3d" | "audio" | "document" | "image" | "json" | "video";
        /** The minimum length of the input where the input is a string (also available for each item in string_array) */
        minLength?: number;
        /** The description of the input, to display in the UI as an help text adding information about the input */
        description?: string;
        /** The label of the input displayed in the UI */
        label?: string;
        /** The type of the input */
        type:
          | "boolean"
          | "file"
          | "file_array"
          | "number"
          | "number_array"
          | "string"
          | "string_array";
        /** Whether the input is required */
        required: boolean;
        /** The minimum value of the input (only available for inputs of type 'number' and inputs as array) */
        min?: number;
        /** A hint to the user about the input, to display in the UI with a tooltip */
        hint?: string;
        /** The name of the input internally used by the model and API */
        name: string;
        /** The maximum length of the input where the input is a string (also available for each item in string_array) */
        maxLength?: number;
        /** The group of the input. If 2 inputs have the same group, they will be displayed in the same group in the UI
            They will be always together in this list of inputs */
        group?: string;
      }[];
      /** List of all example asset IDs setup by the model owner */
      exampleAssetIds: string[];
      /** The privacy of the model (default: private) */
      privacy: "private" | "public" | "unlisted";
      /** The date when the model will be soft deleted (only for Free plan) */
      softDeletionOn?: string;
      /** The UI configuration for the model */
      uiConfig?: {
        triggerGenerate?: {
          /** The 'name' of the input where the trigger generate button will be displayed (after the input).
                Do not specify both position and after. */
          after?: string;
          label: string;
          /** The position of the trigger generate button. If position specified, the button will be displayed at the specified position.
                Do not specify both position and after. */
          position?: "bottom" | "top";
        };
      };
      /** The source of the model */
      source: "civitai" | "huggingface" | "other" | "scenario";
      /** The owner ID (example: "team_VFhihHKMRZyDDnZAJwLb2Q") */
      ownerId?: string;
      /** The model type (example: sd-1_5) */
      type:
        | "custom"
        | "flux.1"
        | "flux.1-composition"
        | "flux.1-lora"
        | "flux.1-pro"
        | "flux.1.1-pro-ultra"
        | "flux1.1-pro"
        | "gpt-image-1"
        | "sd-1_5"
        | "sd-1_5-composition"
        | "sd-1_5-lora"
        | "sd-xl"
        | "sd-xl-composition"
        | "sd-xl-lora";
      /** The model creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** Additional information about the model's training */
      trainingStats?: {
        /** The training duration in seconds */
        trainDuration?: number;
        /** The training queued duration in seconds */
        queueDuration?: number;
        /** The training end time as an ISO date string */
        endedAt?: string;
        /** The training start time as an ISO date string */
        startedAt?: string;
      };
      /** Fine-tune the model's inferences with prompt embedding */
      promptEmbedding?: string;
      /** Additional information about the training progress of the model */
      trainingProgress?: {
        /** The stage of the request */
        stage:
          | "pending"
          | "queued-for-train"
          | "running-train"
          | "starting-train";
        /** The remaining time in milliseconds */
        remainingTimeMs?: number;
        /** The progress of the job */
        progress?: number;
        /** The timestamp in millisecond marking the start of the process */
        startedAt?: number;
        /** Position of the job in the queue (ie. the number of job in the queue before this one) */
        position?: number;
        /** Timestamp in milliseconds of the last time the training progress was updated */
        updatedAt: number;
      };
      /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
      id: string;
      /** The class of the model */
      class?: {
        /** The model ID of the class (example: "stable-diffusion-v1-5") */
        modelId: string;
        /** The class name (example: "Character Design") */
        name: string;
        /** The category slug of the class (example: "art-style") */
        category: string;
        /** Some example images URLs to showcase the class */
        thumbnails: string[];
        /** The class prompt (example: "a character design") */
        prompt: string;
        /** The concept prompt of the class (example: "a sks character design") */
        conceptPrompt: string;
        /** The class slug (example: "art-style-character-design") */
        slug: string;
        /** The class status (only published classes are listed, but unpublished classes can still appear in existing models) */
        status: "published" | "unpublished";
      };
      /** The model last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      updatedAt: string;
      /** A thumbnail for your model */
      thumbnail?: {
        /** The AssetId of the image used as a thumbnail for your model (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        assetId: string;
        /** The url of the image used as a thumbnail for your model */
        url: string;
      };
      /** List of model capabilities (example: ["txt2img", "img2img", "txt2img_ip_adapter", ...]) */
      capabilities: (
        | "controlnet"
        | "controlnet_img2img"
        | "controlnet_inpaint"
        | "controlnet_inpaint_ip_adapter"
        | "controlnet_ip_adapter"
        | "controlnet_reference"
        | "controlnet_texture"
        | "img2img"
        | "img2img_ip_adapter"
        | "img2img_texture"
        | "inpaint"
        | "inpaint_ip_adapter"
        | "outpaint"
        | "reference"
        | "reference_texture"
        | "txt2img"
        | "txt2img_ip_adapter"
        | "txt2img_texture"
      )[];
      /** The id of the parent model */
      parentModelId?: string;
      /** The total number of training images */
      trainingImagesNumber: number;
      /** Whether the model is a custom model and can be used only with POST /generate/custom/{modelId} endpoint */
      custom: boolean;
      /** The model keyword, this is a legacy parameter, please use conceptPrompt in parameters */
      modelKeyword?: string;
      /** The author user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
      authorId?: string;
      /** (Deprecated) The user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
      userId?: string;
      /** The associated tags (example: ["sci-fi", "landscape"]) */
      tags: string[];
      /** Fine-tune the model's inferences with negative prompt embedding */
      negativePromptEmbedding?: string;
      /** The concepts is required for the type model: composition */
      concepts?: {
        /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
        modelId: string;
        /** The scale of the model (example: 1.0) */
        scale: number;
      }[];
      /** A list of CollectionId this model belongs to */
      collectionIds: string[];
      /** The model name (example: "Low-poly dwarf") */
      name?: string;
      /** The model's training parameters */
      parameters?: {
        /** Whether to train the text encoder or not
            
            Example: For 100 steps and a value of 0.2, it means that the text encoder will be trained for 20 steps and then the UNet for 80 steps
            
            Note: Legacy parameter, please use `numTextTrainSteps` and `numUNetTrainSteps`
            
            Only available for SD15 and SDXL LoRA training */
        textEncoderTrainingRatio?: number;
        /** The weight of prior preservation loss
            
            Only available for SD15 and SDXL LoRA training */
        priorLossWeight?: number;
        /** Used to reproduce previous results. Default: randomly generated number.
            
            Only available for SD15 and SDXL LoRA training */
        seed?: number;
        /** The number of training steps for the UNet
            
            Only available for SDXL LoRA training */
        numUNetTrainSteps?: number;
        /** Validation frequency. Cannot be greater than maxTrainSteps value
            
            Only available for SD15 and SDXL LoRA training */
        validationFrequency?: number;
        /** Ratio of random crops
            
            Only available for SD15 and SDXL LoRA training */
        randomCropRatio?: number;
        /** Initial learning rate (after the potential warmup period)
            
            Default value varies depending on the model type:
            - For SD1.5 and SDXL: 0.000005
            - For Flux: 0.0004 */
        learningRate?: number;
        /** Optimize the model training task for a specific type of input images. The available values are:
            - "likeness": optimize training for likeness or portrait
            
            Only available for Flux LoRA training */
        optimizeFor?: "likeness" | null;
        /** Whether to random crop or center crop images before resizing to the working resolution
            
            Only available for SD15 and SDXL LoRA training */
        randomCrop?: boolean;
        /** The prompt to specify images in the same class as provided instance images
            
            Only available for SD15 training */
        classPrompt?: string;
        /** The number of training steps for the text encoder
            
            Only available for SDXL LoRA training */
        numTextTrainSteps?: number;
        /** Initial learning rate (after the potential warmup period) for the text encoder
            
            Only available for SDXL LoRA training */
        learningRateTextEncoder?: number;
        /** The Weights And Bias key to use for logging. The maximum length is 40 characters */
        wandbKey?: string;
        /** Whether to scale the learning rate
            
            Note: Legacy parameter, will be ignored
            
            Only available for SD15 and SDXL LoRA training */
        scaleLr?: boolean;
        /** Scale of random crops
            
            Only available for SD15 and SDXL LoRA training */
        randomCropScale?: number;
        /** The scheduler type to use (default: "constant")
            
            Only available for SD15 and SDXL LoRA training */
        lrScheduler?:
          | "constant"
          | "constant-with-warmup"
          | "cosine"
          | "cosine-with-restarts"
          | "linear"
          | "polynomial";
        /** The dimension of the LoRA update matrices
            
            Only available for SDXL and Flux LoRA training
            
            Default value varies depending on the model type:
            - For SDXL: 64
            - For Flux: 16 */
        rank?: number;
        /** Initial learning rate (after the potential warmup period) for the UNet
            
            Only available for SDXL LoRA training */
        learningRateUnet?: number;
        /** Validation prompt
            
            Only available for SD15 and SDXL LoRA training */
        validationPrompt?: string;
        /** The prompt with identifier specifying the instance (or subject) of the class (example: "a daiton dog")
            
            Default value varies depending on the model type:
            - For SD1.5: "daiton" if no class is associated with the model
            - For SDXL: "daiton"
            - For Flux: "" */
        conceptPrompt?: string | null;
        /** Maximum number of training steps to execute (default: varies depending on the model type)
            
            For SDXL LoRA training, please use `numTextTrainSteps` and `numUNetTrainSteps` instead
            
            Default value varies depending on the model type:
            - For SD1.5: round((number of training images * 225) / 3)
            - For SDXL: number of training images * 175
            - For Flux: number of training images * 100
            
            Maximum value varies depending on the model type:
            - For SD1.5 and SDXL: [0, 40000]
            - For Flux: [0, 10000] */
        maxTrainSteps?: number;
      };
      /** List of base model IDs compliant with the model (example: ["flux.1-dev", "flux.1-schnell"])
        This attribute is mainly used for Flux LoRA models */
      compliantModelIds?: string[];
      /** The model status */
      status:
        | "copying"
        | "failed"
        | "new"
        | "trained"
        | "training"
        | "training-canceled";
    };
  };
export type PostModelsCopyByModelIdApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  /** The modelId to copy */
  modelId: string;
  body: {
    /** true by default, the example images will be copied */
    copyExamples?: boolean;
    /** If set to true, the training data will be copied */
    copyAsTrained?: boolean;
  };
};
export type GetModelsDescriptionByModelIdApiResponse =
  /** status 200 200 response */ {
    description: {
      /** The list of models referenced by the Markdown `{model}` tag in the description. */
      models: {
        /** The training caption words of the model */
        captionWords?: string[];
        /** The URLs of the first 3 training images of the model. To retrieve the full set of images, get it by modelId */
        trainingImages?: {
          /** The training image upload date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
          createdAt: string;
          /** Automatic captioning of the image */
          automaticCaptioning: string;
          /** The URL of the image */
          downloadUrl: string;
          /** The original file name of the image (example: "my-training-image.jpg") */
          name: string;
          /** Description for the image */
          description: string;
          /** The training image ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
          id: string;
        }[];
        /** The inputs of the model. Only used for custom models. To retrieve this list, get it by modelId with GET /models/{modelId} */
        inputs?: {
          /** The allowed values of the input of type 'string' or 'string_array'
                In case of string, it's a single value select list
                In case of string_array, it's a multi value select list */
          allowedValues?: string[];
          /** The maximum value of the input (only available for inputs of type 'number' and inputs as array) */
          max?: number;
          /** The kind of the input. Only available for inputs of type 'file' (and 'file_array') */
          kind?: "3d" | "audio" | "document" | "image" | "json" | "video";
          /** The minimum length of the input where the input is a string (also available for each item in string_array) */
          minLength?: number;
          /** The description of the input, to display in the UI as an help text adding information about the input */
          description?: string;
          /** The label of the input displayed in the UI */
          label?: string;
          /** The type of the input */
          type:
            | "boolean"
            | "file"
            | "file_array"
            | "number"
            | "number_array"
            | "string"
            | "string_array";
          /** Whether the input is required */
          required: boolean;
          /** The minimum value of the input (only available for inputs of type 'number' and inputs as array) */
          min?: number;
          /** A hint to the user about the input, to display in the UI with a tooltip */
          hint?: string;
          /** The name of the input internally used by the model and API */
          name: string;
          /** The maximum length of the input where the input is a string (also available for each item in string_array) */
          maxLength?: number;
          /** The group of the input. If 2 inputs have the same group, they will be displayed in the same group in the UI
                They will be always together in this list of inputs */
          group?: string;
        }[];
        /** List of all example asset IDs setup by the model owner */
        exampleAssetIds: string[];
        /** The privacy of the model (default: private) */
        privacy: "private" | "public" | "unlisted";
        /** The date when the model will be soft deleted (only for Free plan) */
        softDeletionOn?: string;
        /** The UI configuration for the model */
        uiConfig?: {
          triggerGenerate?: {
            /** The 'name' of the input where the trigger generate button will be displayed (after the input).
                    Do not specify both position and after. */
            after?: string;
            label: string;
            /** The position of the trigger generate button. If position specified, the button will be displayed at the specified position.
                    Do not specify both position and after. */
            position?: "bottom" | "top";
          };
        };
        /** The source of the model */
        source: "civitai" | "huggingface" | "other" | "scenario";
        /** The owner ID (example: "team_VFhihHKMRZyDDnZAJwLb2Q") */
        ownerId?: string;
        /** The model type (example: sd-1_5) */
        type:
          | "custom"
          | "flux.1"
          | "flux.1-composition"
          | "flux.1-lora"
          | "flux.1-pro"
          | "flux.1.1-pro-ultra"
          | "flux1.1-pro"
          | "gpt-image-1"
          | "sd-1_5"
          | "sd-1_5-composition"
          | "sd-1_5-lora"
          | "sd-xl"
          | "sd-xl-composition"
          | "sd-xl-lora";
        /** The model creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** Additional information about the model's training */
        trainingStats?: {
          /** The training duration in seconds */
          trainDuration?: number;
          /** The training queued duration in seconds */
          queueDuration?: number;
          /** The training end time as an ISO date string */
          endedAt?: string;
          /** The training start time as an ISO date string */
          startedAt?: string;
        };
        /** Fine-tune the model's inferences with prompt embedding */
        promptEmbedding?: string;
        /** Additional information about the training progress of the model */
        trainingProgress?: {
          /** The stage of the request */
          stage:
            | "pending"
            | "queued-for-train"
            | "running-train"
            | "starting-train";
          /** The remaining time in milliseconds */
          remainingTimeMs?: number;
          /** The progress of the job */
          progress?: number;
          /** The timestamp in millisecond marking the start of the process */
          startedAt?: number;
          /** Position of the job in the queue (ie. the number of job in the queue before this one) */
          position?: number;
          /** Timestamp in milliseconds of the last time the training progress was updated */
          updatedAt: number;
        };
        /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
        id: string;
        /** The class of the model */
        class?: {
          /** The model ID of the class (example: "stable-diffusion-v1-5") */
          modelId: string;
          /** The class name (example: "Character Design") */
          name: string;
          /** The category slug of the class (example: "art-style") */
          category: string;
          /** Some example images URLs to showcase the class */
          thumbnails: string[];
          /** The class prompt (example: "a character design") */
          prompt: string;
          /** The concept prompt of the class (example: "a sks character design") */
          conceptPrompt: string;
          /** The class slug (example: "art-style-character-design") */
          slug: string;
          /** The class status (only published classes are listed, but unpublished classes can still appear in existing models) */
          status: "published" | "unpublished";
        };
        /** The model last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
        /** A thumbnail for your model */
        thumbnail?: {
          /** The AssetId of the image used as a thumbnail for your model (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
          assetId: string;
          /** The url of the image used as a thumbnail for your model */
          url: string;
        };
        /** List of model capabilities (example: ["txt2img", "img2img", "txt2img_ip_adapter", ...]) */
        capabilities: (
          | "controlnet"
          | "controlnet_img2img"
          | "controlnet_inpaint"
          | "controlnet_inpaint_ip_adapter"
          | "controlnet_ip_adapter"
          | "controlnet_reference"
          | "controlnet_texture"
          | "img2img"
          | "img2img_ip_adapter"
          | "img2img_texture"
          | "inpaint"
          | "inpaint_ip_adapter"
          | "outpaint"
          | "reference"
          | "reference_texture"
          | "txt2img"
          | "txt2img_ip_adapter"
          | "txt2img_texture"
        )[];
        /** The id of the parent model */
        parentModelId?: string;
        /** The total number of training images */
        trainingImagesNumber: number;
        /** Whether the model is a custom model and can be used only with POST /generate/custom/{modelId} endpoint */
        custom: boolean;
        /** The model keyword, this is a legacy parameter, please use conceptPrompt in parameters */
        modelKeyword?: string;
        /** The author user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
        authorId?: string;
        /** (Deprecated) The user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
        userId?: string;
        /** The associated tags (example: ["sci-fi", "landscape"]) */
        tags: string[];
        /** Fine-tune the model's inferences with negative prompt embedding */
        negativePromptEmbedding?: string;
        /** The concepts is required for the type model: composition */
        concepts?: {
          /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
          modelId: string;
          /** The scale of the model (example: 1.0) */
          scale: number;
        }[];
        /** A list of CollectionId this model belongs to */
        collectionIds: string[];
        /** The model name (example: "Low-poly dwarf") */
        name?: string;
        /** The model's training parameters */
        parameters?: {
          /** Whether to train the text encoder or not
                
                Example: For 100 steps and a value of 0.2, it means that the text encoder will be trained for 20 steps and then the UNet for 80 steps
                
                Note: Legacy parameter, please use `numTextTrainSteps` and `numUNetTrainSteps`
                
                Only available for SD15 and SDXL LoRA training */
          textEncoderTrainingRatio?: number;
          /** The weight of prior preservation loss
                
                Only available for SD15 and SDXL LoRA training */
          priorLossWeight?: number;
          /** Used to reproduce previous results. Default: randomly generated number.
                
                Only available for SD15 and SDXL LoRA training */
          seed?: number;
          /** The number of training steps for the UNet
                
                Only available for SDXL LoRA training */
          numUNetTrainSteps?: number;
          /** Validation frequency. Cannot be greater than maxTrainSteps value
                
                Only available for SD15 and SDXL LoRA training */
          validationFrequency?: number;
          /** Ratio of random crops
                
                Only available for SD15 and SDXL LoRA training */
          randomCropRatio?: number;
          /** Initial learning rate (after the potential warmup period)
                
                Default value varies depending on the model type:
                - For SD1.5 and SDXL: 0.000005
                - For Flux: 0.0004 */
          learningRate?: number;
          /** Optimize the model training task for a specific type of input images. The available values are:
                - "likeness": optimize training for likeness or portrait
                
                Only available for Flux LoRA training */
          optimizeFor?: "likeness" | null;
          /** Whether to random crop or center crop images before resizing to the working resolution
                
                Only available for SD15 and SDXL LoRA training */
          randomCrop?: boolean;
          /** The prompt to specify images in the same class as provided instance images
                
                Only available for SD15 training */
          classPrompt?: string;
          /** The number of training steps for the text encoder
                
                Only available for SDXL LoRA training */
          numTextTrainSteps?: number;
          /** Initial learning rate (after the potential warmup period) for the text encoder
                
                Only available for SDXL LoRA training */
          learningRateTextEncoder?: number;
          /** The Weights And Bias key to use for logging. The maximum length is 40 characters */
          wandbKey?: string;
          /** Whether to scale the learning rate
                
                Note: Legacy parameter, will be ignored
                
                Only available for SD15 and SDXL LoRA training */
          scaleLr?: boolean;
          /** Scale of random crops
                
                Only available for SD15 and SDXL LoRA training */
          randomCropScale?: number;
          /** The scheduler type to use (default: "constant")
                
                Only available for SD15 and SDXL LoRA training */
          lrScheduler?:
            | "constant"
            | "constant-with-warmup"
            | "cosine"
            | "cosine-with-restarts"
            | "linear"
            | "polynomial";
          /** The dimension of the LoRA update matrices
                
                Only available for SDXL and Flux LoRA training
                
                Default value varies depending on the model type:
                - For SDXL: 64
                - For Flux: 16 */
          rank?: number;
          /** Initial learning rate (after the potential warmup period) for the UNet
                
                Only available for SDXL LoRA training */
          learningRateUnet?: number;
          /** Validation prompt
                
                Only available for SD15 and SDXL LoRA training */
          validationPrompt?: string;
          /** The prompt with identifier specifying the instance (or subject) of the class (example: "a daiton dog")
                
                Default value varies depending on the model type:
                - For SD1.5: "daiton" if no class is associated with the model
                - For SDXL: "daiton"
                - For Flux: "" */
          conceptPrompt?: string | null;
          /** Maximum number of training steps to execute (default: varies depending on the model type)
                
                For SDXL LoRA training, please use `numTextTrainSteps` and `numUNetTrainSteps` instead
                
                Default value varies depending on the model type:
                - For SD1.5: round((number of training images * 225) / 3)
                - For SDXL: number of training images * 175
                - For Flux: number of training images * 100
                
                Maximum value varies depending on the model type:
                - For SD1.5 and SDXL: [0, 40000]
                - For Flux: [0, 10000] */
          maxTrainSteps?: number;
        };
        /** List of base model IDs compliant with the model (example: ["flux.1-dev", "flux.1-schnell"])
            This attribute is mainly used for Flux LoRA models */
        compliantModelIds?: string[];
        /** The model status */
        status:
          | "copying"
          | "failed"
          | "new"
          | "trained"
          | "training"
          | "training-canceled";
      }[];
      /** The list of assets referenced by the Markdown `{asset}` tag in the description. */
      assets: {
        /** Metadata of the asset with some additional information */
        metadata: {
          maxIterations?: number;
          /** Modality to detect */
          modality?:
            | "canny"
            | "depth"
            | "grayscale"
            | "lineart_anime"
            | "mlsd"
            | "normal"
            | "pose"
            | "scribble"
            | "segmentation"
            | "sketch";
          /** If set to true, during the upscaling process, the model will match tiles of the source image with tiles of the style image(s). This will result in a more coherent restyle. Works best with style images that have a similar composition. */
          tileStyle?: boolean;
          /** The modelId used to generate this asset */
          modelId?: string;
          /** A bounding box around the object of interest, in the format [x1, y1, x2, y2]. */
          bbox?: any[];
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          keypointThreshold?: number;
          /** The type of the asset. Ex: 'inference-txt2img' will represent an asset generated from a text to image model */
          type:
            | "background-removal"
            | "canvas"
            | "canvas-drawing"
            | "canvas-export"
            | "detection"
            | "generative-fill"
            | "image-prompt-editing"
            | "img23d-custom"
            | "img2img-custom"
            | "img2video-custom"
            | "inference-controlnet"
            | "inference-controlnet-img2img"
            | "inference-controlnet-inpaint"
            | "inference-controlnet-inpaint-ip-adapter"
            | "inference-controlnet-ip-adapter"
            | "inference-controlnet-reference"
            | "inference-controlnet-texture"
            | "inference-img2img"
            | "inference-img2img-ip-adapter"
            | "inference-img2img-texture"
            | "inference-inpaint"
            | "inference-inpaint-ip-adapter"
            | "inference-reference"
            | "inference-reference-texture"
            | "inference-txt2img"
            | "inference-txt2img-ip-adapter"
            | "inference-txt2img-texture"
            | "patch"
            | "pixelization"
            | "reframe"
            | "restyle"
            | "segment"
            | "segmentation-image"
            | "segmentation-mask"
            | "skybox-base-360"
            | "texture"
            | "texture-albedo"
            | "texture-ao"
            | "texture-edge"
            | "texture-height"
            | "texture-metallic"
            | "texture-normal"
            | "texture-smoothness"
            | "txt23d-custom"
            | "txt2audio-custom"
            | "txt2img-custom"
            | "unknown-custom"
            | "uploaded"
            | "upscale"
            | "upscale-skybox"
            | "upscale-texture"
            | "vectorization"
            | "video2video-custom";
          /** A textual description / keywords describing the object of interest. */
          text?: string;
          height?: number;
          nbMasks?: number;
          /** Amount of decay in creativity over the upscale process. The lowest the value, the less the creativity will be preserved over the upscale process. */
          creativityDecay?: number;
          layerDifference?: number;
          /** Scaling factor (when `targetWidth` not specified) */
          scalingFactor?: number;
          /** The type of the generator used */
          modelType?:
            | "custom"
            | "flux.1"
            | "flux.1-composition"
            | "flux.1-lora"
            | "flux.1-pro"
            | "flux.1.1-pro-ultra"
            | "flux1.1-pro"
            | "gpt-image-1"
            | "sd-1_5"
            | "sd-1_5-composition"
            | "sd-1_5-lora"
            | "sd-xl"
            | "sd-xl-composition"
            | "sd-xl-lora";
          /** The number of outputs to generate. */
          numOutputs?: number;
          /** How angular is the surface? 0 is like a sphere, 1 is like a mechanical object */
          angular?: number;
          /** The target height of the output image. */
          targetHeight?: number;
          /** Flux LoRa or Composition to style the image. */
          concepts?: {
            weightName: string;
            /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
            modelId: string;
            /** The scale of the model (example: 1.0) */
            scale: number;
          }[];
          size?: number;
          spliceThreshold?: number;
          /** The number of pixels to dilate the result masks. */
          dilate?: number;
          style?:
            | "3d-cartoon"
            | "3d-rendered"
            | "anime"
            | "cartoon"
            | "cinematic"
            | "claymation"
            | "cloud-skydome"
            | "comic"
            | "cyberpunk"
            | "enchanted"
            | "fantasy"
            | "ink"
            | "manga"
            | "manga-color"
            | "minimalist"
            | "neon-tron"
            | "oil-painting"
            | "pastel"
            | "photo"
            | "photography"
            | "psychedelic"
            | "retro-fantasy"
            | "scifi-concept-art"
            | "space"
            | "standard"
            | "whimsical";
          /** Strengthen the similarity to the original image during the upscale. Default: optimized for your preset and style. */
          imageFidelity?: number;
          /** Location of the input image in the output. */
          inputLocation?: "bottom" | "left" | "middle" | "right" | "top";
          /** The seed used to generate this asset */
          seed?: string;
          /** The higher the value the more it will look like the secondary reference image(s) */
          secondaryRefFidelity?: number;
          preset?: string;
          trainingImage?: boolean;
          /** Boolean to able return the masks (binary image) in the response. */
          resultMask?: boolean;
          /** The ISO timestamp when the lock on the canvas will expire */
          lockExpiresAt?: string;
          /** The baseModelId that maybe changed at inference time */
          baseModelId?: string;
          pathPrecision?: number;
          rootParentId?: string;
          /** Sharpen tiles. */
          sharpen?: boolean;
          cornerThreshold?: number;
          /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
          styleImages?: string[];
          /** The asset to convert in texture maps. Must reference an existing AssetId. */
          texture?: string;
          filterSpeckle?: number;
          /** Minimum threshold for Grayscale conversion */
          minThreshold?: number;
          /** Maximum threshold for Grayscale conversion */
          maxThreshold?: number;
          /** Condition the influence of the style image(s). The higher the value, the more the style images will influence the upscaled image. */
          styleImagesFidelity?: number;
          /** The control image processed by depth estimator. Must reference an existing AssetId. */
          depthImage?: string;
          parentId?: string;
          parentJobId?: string;
          /** Optional List of secondary style images. Example: portrait of people. It must be existing AssetIds. */
          secondaryRefImages?: string[];
          /** The width of the rendered image. */
          width?: number;
          /** The checkpoint to use */
          checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
          strength?: number;
          /** The id of the Inference describing how this image was generated */
          inferenceId?: string;
          lengthThreshold?: number;
          /** Int to set between 0 and 255 for the opacity of the background in the result images. */
          backgroundOpacity?: number;
          /** The optional aspect ratio given for the generation, only applicable for some models */
          aspectRatio?: string;
          /** Amount of details to remove or add */
          detailsLevel?: number;
          /** Determine the scale at which the upscale process works.
                - With a small value, the upscale works at the largest scale, resulting in fewer added details and more coherent images. Ideal for portraits, for example.
                - With a large value, the upscale works at the smallest scale, resulting in more added details and more hallucinations. Ideal for landscapes, for example.
                
                (info): A small value is slower and more expensive to run. */
          fractality?: number;
          /** (deprecated) Horizontal expansion ratio. */
          horizontalExpansionRatio?: number;
          /** List of points (label, x, y) in the image where label = 0 for background and 1 for object. */
          points?: any[][];
          mode?: string;
          colorPrecision?: number;
          /** Increase the fidelity to the prompt during upscale. Default: optimized for your preset and style. */
          promptFidelity?: number;
          /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
          betterQuality?: boolean;
          /** Remove background for Grayscale detector */
          removeBackground?: boolean;
          /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your preset and style. */
          creativity?: number;
          /** Strength for the input image structure preservation */
          structureFidelity?: number;
          /** Preserve the seamless properties of skybox or texture images. Input has to be of same type (seamless). */
          imageType?: "seamfull" | "skybox" | "texture";
          /** The input image to process. Must reference an existing AssetId or be a data URL. */
          image?: string;
          /** The thumbnail of the canvas */
          thumbnail?: {
            /** The AssetId of the image used as a thumbnail for the canvas (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
            assetId: string;
            /** The url of the image used as a thumbnail for the canvas */
            url: string;
          };
          /** The control image for structure. A canny detector will be applied to this image. Must reference an existing AssetId. */
          structureImage?: string;
          /** To invert the relief */
          invert?: boolean;
          kind: "3d" | "audio" | "document" | "image" | "json" | "video";
          colorMode?: string;
          /** High threshold for Canny detector */
          highThreshold?: number;
          /** (deprecated) Vertical expansion ratio. */
          verticalExpansionRatio?: number;
          halfMode?: boolean;
          name?: string;
          /** Additional refinement steps before scaling.
                
                If scalingFactor == 1, the refinement process will be applied (1 + refinementSteps) times.
                If scalingFactor > 1, the refinement process will be applied refinementSteps times. */
          refinementSteps?: number;
          /** The reference images used for the image generation or editing */
          referenceImages?: string[];
          /** The higher the value the more it will look like the style image(s) */
          styleFidelity?: number;
          /** Boolean to output the contours. */
          resultContours?: boolean;
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          polished?: number;
          /** The scheduler used to generate this asset */
          scheduler?: string;
          /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
          overrideEmbeddings?: boolean;
          progressPercent?: number;
          /** Contrast factor for Grayscale detector */
          factor?: number;
          /** The mask used for the image generation or editing */
          mask?: string;
          /** Low threshold for Canny detector */
          lowThreshold?: number;
          /** The depth fidelity if a depth image provided */
          depthFidelity?: number;
          /** How raised is the surface? 0 is flat like water, 1 is like a very rough rock */
          raised?: number;
          message?: string;
          contours?: number[][][][];
          /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
          negativePrompt?: string;
          /** If true, use the default parameters */
          defaultParameters?: boolean;
          /** Size proportion of the input image in the output. */
          resizeOption?: number;
          outputIndex?: number;
          /** Save a flipbook of the texture. Deactivated when the input texture is larger than 2048x2048px */
          saveFlipbook?: boolean;
          /** The guidance used to generate this asset */
          guidance?: number;
          /** The number of denoising steps for each image generation. */
          numInferenceSteps?: number;
          hdr?: number;
          /** How shiny is the surface? 0 is like a matte surface, 1 is like a diamond */
          shiny?: number;
          /** Ensure upscaled tile have the same color histogram as original tile. */
          colorCorrection?: boolean;
          /** Overlap percentage for the output image. */
          overlapPercentage?: number;
          /** The prompt that guided the image generation or editing */
          prompt?: string;
          /** Boolean to able output the cut out object. */
          resultImage?: boolean;
          /** The control image already processed by canny detector. Must reference an existing AssetId. */
          cannyStructureImage?: string;
          /** Apply extra control to the Skybox 360 geometry.
                The higher the value, the more the 360 geometry will influence the generated skybox image.
                
                Use with caution. Default is adapted to the other parameters. */
          geometryEnforcement?: number;
          /** Target width for the upscaled image, take priority over scaling factor */
          targetWidth?: number;
        };
        /** The NSFW labels */
        nsfw?: string[];
        /** Automatic captioning of the asset */
        automaticCaptioning?: string;
        /** The description of the asset */
        description?: string;
        /** The privacy of the asset */
        privacy: "private" | "public" | "unlisted";
        /** The date when the asset will be soft deleted (only for Free plan) */
        softDeletionOn?: string;
        /** The mime type of the asset (example: "image/png") */
        mimeType: string;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId: string;
        /** The owner (project) ID (example: "proj_23tlk332lkht3kl2" or "team_dlkhgs23tlk3hlkth32lkht3kl2" for old teams) */
        ownerId: string;
        /** Signed URL to get the asset content */
        url: string;
        /** The associated tags (example: ["sci-fi", "landscape"]) */
        tags: string[];
        /** The asset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The output index of the asset within the job
            This index is an positive integer that starts at 0
            It is used to differentiate between multiple outputs of the same job
            If the job has only one output, this index is 0
            This is only applicable for generations with: Flux, Skybox, Reframe at the moment */
        outputIndex?: number;
        /** A list of CollectionId this asset belongs to */
        collectionIds: string[];
        /** List of edit capabilities for the asset */
        editCapabilities: (
          | "DETECTION"
          | "GENERATIVE_FILL"
          | "PIXELATE"
          | "PROMPT_EDITING"
          | "REFINE"
          | "REFRAME"
          | "REMOVE_BACKGROUND"
          | "SEGMENTATION"
          | "UPSCALE"
          | "UPSCALE_360"
          | "VECTORIZATION"
        )[];
        /** The embedding of the asset when requested and asset can be embedded
            
            ie: Detection maps don't have embeddings */
        embedding?: number[];
        /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        id: string;
        /** The status of the asset */
        status: "error" | "pending" | "success";
        /** The asset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      }[];
      /** The markdown description of the model (ex: `# My model`).
        We allow the `{asset:<assetId>}` and `{model:<modelId>}` tags. */
      value: string;
    };
  };
export type GetModelsDescriptionByModelIdApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The modelId of the description */
  modelId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
};
export type PutModelsDescriptionByModelIdApiResponse =
  /** status 200 200 response */ {
    description: {
      /** The list of models referenced by the Markdown `{model}` tag in the description. */
      models: {
        /** The training caption words of the model */
        captionWords?: string[];
        /** The URLs of the first 3 training images of the model. To retrieve the full set of images, get it by modelId */
        trainingImages?: {
          /** The training image upload date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
          createdAt: string;
          /** Automatic captioning of the image */
          automaticCaptioning: string;
          /** The URL of the image */
          downloadUrl: string;
          /** The original file name of the image (example: "my-training-image.jpg") */
          name: string;
          /** Description for the image */
          description: string;
          /** The training image ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
          id: string;
        }[];
        /** The inputs of the model. Only used for custom models. To retrieve this list, get it by modelId with GET /models/{modelId} */
        inputs?: {
          /** The allowed values of the input of type 'string' or 'string_array'
                In case of string, it's a single value select list
                In case of string_array, it's a multi value select list */
          allowedValues?: string[];
          /** The maximum value of the input (only available for inputs of type 'number' and inputs as array) */
          max?: number;
          /** The kind of the input. Only available for inputs of type 'file' (and 'file_array') */
          kind?: "3d" | "audio" | "document" | "image" | "json" | "video";
          /** The minimum length of the input where the input is a string (also available for each item in string_array) */
          minLength?: number;
          /** The description of the input, to display in the UI as an help text adding information about the input */
          description?: string;
          /** The label of the input displayed in the UI */
          label?: string;
          /** The type of the input */
          type:
            | "boolean"
            | "file"
            | "file_array"
            | "number"
            | "number_array"
            | "string"
            | "string_array";
          /** Whether the input is required */
          required: boolean;
          /** The minimum value of the input (only available for inputs of type 'number' and inputs as array) */
          min?: number;
          /** A hint to the user about the input, to display in the UI with a tooltip */
          hint?: string;
          /** The name of the input internally used by the model and API */
          name: string;
          /** The maximum length of the input where the input is a string (also available for each item in string_array) */
          maxLength?: number;
          /** The group of the input. If 2 inputs have the same group, they will be displayed in the same group in the UI
                They will be always together in this list of inputs */
          group?: string;
        }[];
        /** List of all example asset IDs setup by the model owner */
        exampleAssetIds: string[];
        /** The privacy of the model (default: private) */
        privacy: "private" | "public" | "unlisted";
        /** The date when the model will be soft deleted (only for Free plan) */
        softDeletionOn?: string;
        /** The UI configuration for the model */
        uiConfig?: {
          triggerGenerate?: {
            /** The 'name' of the input where the trigger generate button will be displayed (after the input).
                    Do not specify both position and after. */
            after?: string;
            label: string;
            /** The position of the trigger generate button. If position specified, the button will be displayed at the specified position.
                    Do not specify both position and after. */
            position?: "bottom" | "top";
          };
        };
        /** The source of the model */
        source: "civitai" | "huggingface" | "other" | "scenario";
        /** The owner ID (example: "team_VFhihHKMRZyDDnZAJwLb2Q") */
        ownerId?: string;
        /** The model type (example: sd-1_5) */
        type:
          | "custom"
          | "flux.1"
          | "flux.1-composition"
          | "flux.1-lora"
          | "flux.1-pro"
          | "flux.1.1-pro-ultra"
          | "flux1.1-pro"
          | "gpt-image-1"
          | "sd-1_5"
          | "sd-1_5-composition"
          | "sd-1_5-lora"
          | "sd-xl"
          | "sd-xl-composition"
          | "sd-xl-lora";
        /** The model creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** Additional information about the model's training */
        trainingStats?: {
          /** The training duration in seconds */
          trainDuration?: number;
          /** The training queued duration in seconds */
          queueDuration?: number;
          /** The training end time as an ISO date string */
          endedAt?: string;
          /** The training start time as an ISO date string */
          startedAt?: string;
        };
        /** Fine-tune the model's inferences with prompt embedding */
        promptEmbedding?: string;
        /** Additional information about the training progress of the model */
        trainingProgress?: {
          /** The stage of the request */
          stage:
            | "pending"
            | "queued-for-train"
            | "running-train"
            | "starting-train";
          /** The remaining time in milliseconds */
          remainingTimeMs?: number;
          /** The progress of the job */
          progress?: number;
          /** The timestamp in millisecond marking the start of the process */
          startedAt?: number;
          /** Position of the job in the queue (ie. the number of job in the queue before this one) */
          position?: number;
          /** Timestamp in milliseconds of the last time the training progress was updated */
          updatedAt: number;
        };
        /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
        id: string;
        /** The class of the model */
        class?: {
          /** The model ID of the class (example: "stable-diffusion-v1-5") */
          modelId: string;
          /** The class name (example: "Character Design") */
          name: string;
          /** The category slug of the class (example: "art-style") */
          category: string;
          /** Some example images URLs to showcase the class */
          thumbnails: string[];
          /** The class prompt (example: "a character design") */
          prompt: string;
          /** The concept prompt of the class (example: "a sks character design") */
          conceptPrompt: string;
          /** The class slug (example: "art-style-character-design") */
          slug: string;
          /** The class status (only published classes are listed, but unpublished classes can still appear in existing models) */
          status: "published" | "unpublished";
        };
        /** The model last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
        /** A thumbnail for your model */
        thumbnail?: {
          /** The AssetId of the image used as a thumbnail for your model (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
          assetId: string;
          /** The url of the image used as a thumbnail for your model */
          url: string;
        };
        /** List of model capabilities (example: ["txt2img", "img2img", "txt2img_ip_adapter", ...]) */
        capabilities: (
          | "controlnet"
          | "controlnet_img2img"
          | "controlnet_inpaint"
          | "controlnet_inpaint_ip_adapter"
          | "controlnet_ip_adapter"
          | "controlnet_reference"
          | "controlnet_texture"
          | "img2img"
          | "img2img_ip_adapter"
          | "img2img_texture"
          | "inpaint"
          | "inpaint_ip_adapter"
          | "outpaint"
          | "reference"
          | "reference_texture"
          | "txt2img"
          | "txt2img_ip_adapter"
          | "txt2img_texture"
        )[];
        /** The id of the parent model */
        parentModelId?: string;
        /** The total number of training images */
        trainingImagesNumber: number;
        /** Whether the model is a custom model and can be used only with POST /generate/custom/{modelId} endpoint */
        custom: boolean;
        /** The model keyword, this is a legacy parameter, please use conceptPrompt in parameters */
        modelKeyword?: string;
        /** The author user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
        authorId?: string;
        /** (Deprecated) The user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
        userId?: string;
        /** The associated tags (example: ["sci-fi", "landscape"]) */
        tags: string[];
        /** Fine-tune the model's inferences with negative prompt embedding */
        negativePromptEmbedding?: string;
        /** The concepts is required for the type model: composition */
        concepts?: {
          /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
          modelId: string;
          /** The scale of the model (example: 1.0) */
          scale: number;
        }[];
        /** A list of CollectionId this model belongs to */
        collectionIds: string[];
        /** The model name (example: "Low-poly dwarf") */
        name?: string;
        /** The model's training parameters */
        parameters?: {
          /** Whether to train the text encoder or not
                
                Example: For 100 steps and a value of 0.2, it means that the text encoder will be trained for 20 steps and then the UNet for 80 steps
                
                Note: Legacy parameter, please use `numTextTrainSteps` and `numUNetTrainSteps`
                
                Only available for SD15 and SDXL LoRA training */
          textEncoderTrainingRatio?: number;
          /** The weight of prior preservation loss
                
                Only available for SD15 and SDXL LoRA training */
          priorLossWeight?: number;
          /** Used to reproduce previous results. Default: randomly generated number.
                
                Only available for SD15 and SDXL LoRA training */
          seed?: number;
          /** The number of training steps for the UNet
                
                Only available for SDXL LoRA training */
          numUNetTrainSteps?: number;
          /** Validation frequency. Cannot be greater than maxTrainSteps value
                
                Only available for SD15 and SDXL LoRA training */
          validationFrequency?: number;
          /** Ratio of random crops
                
                Only available for SD15 and SDXL LoRA training */
          randomCropRatio?: number;
          /** Initial learning rate (after the potential warmup period)
                
                Default value varies depending on the model type:
                - For SD1.5 and SDXL: 0.000005
                - For Flux: 0.0004 */
          learningRate?: number;
          /** Optimize the model training task for a specific type of input images. The available values are:
                - "likeness": optimize training for likeness or portrait
                
                Only available for Flux LoRA training */
          optimizeFor?: "likeness" | null;
          /** Whether to random crop or center crop images before resizing to the working resolution
                
                Only available for SD15 and SDXL LoRA training */
          randomCrop?: boolean;
          /** The prompt to specify images in the same class as provided instance images
                
                Only available for SD15 training */
          classPrompt?: string;
          /** The number of training steps for the text encoder
                
                Only available for SDXL LoRA training */
          numTextTrainSteps?: number;
          /** Initial learning rate (after the potential warmup period) for the text encoder
                
                Only available for SDXL LoRA training */
          learningRateTextEncoder?: number;
          /** The Weights And Bias key to use for logging. The maximum length is 40 characters */
          wandbKey?: string;
          /** Whether to scale the learning rate
                
                Note: Legacy parameter, will be ignored
                
                Only available for SD15 and SDXL LoRA training */
          scaleLr?: boolean;
          /** Scale of random crops
                
                Only available for SD15 and SDXL LoRA training */
          randomCropScale?: number;
          /** The scheduler type to use (default: "constant")
                
                Only available for SD15 and SDXL LoRA training */
          lrScheduler?:
            | "constant"
            | "constant-with-warmup"
            | "cosine"
            | "cosine-with-restarts"
            | "linear"
            | "polynomial";
          /** The dimension of the LoRA update matrices
                
                Only available for SDXL and Flux LoRA training
                
                Default value varies depending on the model type:
                - For SDXL: 64
                - For Flux: 16 */
          rank?: number;
          /** Initial learning rate (after the potential warmup period) for the UNet
                
                Only available for SDXL LoRA training */
          learningRateUnet?: number;
          /** Validation prompt
                
                Only available for SD15 and SDXL LoRA training */
          validationPrompt?: string;
          /** The prompt with identifier specifying the instance (or subject) of the class (example: "a daiton dog")
                
                Default value varies depending on the model type:
                - For SD1.5: "daiton" if no class is associated with the model
                - For SDXL: "daiton"
                - For Flux: "" */
          conceptPrompt?: string | null;
          /** Maximum number of training steps to execute (default: varies depending on the model type)
                
                For SDXL LoRA training, please use `numTextTrainSteps` and `numUNetTrainSteps` instead
                
                Default value varies depending on the model type:
                - For SD1.5: round((number of training images * 225) / 3)
                - For SDXL: number of training images * 175
                - For Flux: number of training images * 100
                
                Maximum value varies depending on the model type:
                - For SD1.5 and SDXL: [0, 40000]
                - For Flux: [0, 10000] */
          maxTrainSteps?: number;
        };
        /** List of base model IDs compliant with the model (example: ["flux.1-dev", "flux.1-schnell"])
            This attribute is mainly used for Flux LoRA models */
        compliantModelIds?: string[];
        /** The model status */
        status:
          | "copying"
          | "failed"
          | "new"
          | "trained"
          | "training"
          | "training-canceled";
      }[];
      /** The list of assets referenced by the Markdown `{asset}` tag in the description. */
      assets: {
        /** Metadata of the asset with some additional information */
        metadata: {
          maxIterations?: number;
          /** Modality to detect */
          modality?:
            | "canny"
            | "depth"
            | "grayscale"
            | "lineart_anime"
            | "mlsd"
            | "normal"
            | "pose"
            | "scribble"
            | "segmentation"
            | "sketch";
          /** If set to true, during the upscaling process, the model will match tiles of the source image with tiles of the style image(s). This will result in a more coherent restyle. Works best with style images that have a similar composition. */
          tileStyle?: boolean;
          /** The modelId used to generate this asset */
          modelId?: string;
          /** A bounding box around the object of interest, in the format [x1, y1, x2, y2]. */
          bbox?: any[];
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          keypointThreshold?: number;
          /** The type of the asset. Ex: 'inference-txt2img' will represent an asset generated from a text to image model */
          type:
            | "background-removal"
            | "canvas"
            | "canvas-drawing"
            | "canvas-export"
            | "detection"
            | "generative-fill"
            | "image-prompt-editing"
            | "img23d-custom"
            | "img2img-custom"
            | "img2video-custom"
            | "inference-controlnet"
            | "inference-controlnet-img2img"
            | "inference-controlnet-inpaint"
            | "inference-controlnet-inpaint-ip-adapter"
            | "inference-controlnet-ip-adapter"
            | "inference-controlnet-reference"
            | "inference-controlnet-texture"
            | "inference-img2img"
            | "inference-img2img-ip-adapter"
            | "inference-img2img-texture"
            | "inference-inpaint"
            | "inference-inpaint-ip-adapter"
            | "inference-reference"
            | "inference-reference-texture"
            | "inference-txt2img"
            | "inference-txt2img-ip-adapter"
            | "inference-txt2img-texture"
            | "patch"
            | "pixelization"
            | "reframe"
            | "restyle"
            | "segment"
            | "segmentation-image"
            | "segmentation-mask"
            | "skybox-base-360"
            | "texture"
            | "texture-albedo"
            | "texture-ao"
            | "texture-edge"
            | "texture-height"
            | "texture-metallic"
            | "texture-normal"
            | "texture-smoothness"
            | "txt23d-custom"
            | "txt2audio-custom"
            | "txt2img-custom"
            | "unknown-custom"
            | "uploaded"
            | "upscale"
            | "upscale-skybox"
            | "upscale-texture"
            | "vectorization"
            | "video2video-custom";
          /** A textual description / keywords describing the object of interest. */
          text?: string;
          height?: number;
          nbMasks?: number;
          /** Amount of decay in creativity over the upscale process. The lowest the value, the less the creativity will be preserved over the upscale process. */
          creativityDecay?: number;
          layerDifference?: number;
          /** Scaling factor (when `targetWidth` not specified) */
          scalingFactor?: number;
          /** The type of the generator used */
          modelType?:
            | "custom"
            | "flux.1"
            | "flux.1-composition"
            | "flux.1-lora"
            | "flux.1-pro"
            | "flux.1.1-pro-ultra"
            | "flux1.1-pro"
            | "gpt-image-1"
            | "sd-1_5"
            | "sd-1_5-composition"
            | "sd-1_5-lora"
            | "sd-xl"
            | "sd-xl-composition"
            | "sd-xl-lora";
          /** The number of outputs to generate. */
          numOutputs?: number;
          /** How angular is the surface? 0 is like a sphere, 1 is like a mechanical object */
          angular?: number;
          /** The target height of the output image. */
          targetHeight?: number;
          /** Flux LoRa or Composition to style the image. */
          concepts?: {
            weightName: string;
            /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
            modelId: string;
            /** The scale of the model (example: 1.0) */
            scale: number;
          }[];
          size?: number;
          spliceThreshold?: number;
          /** The number of pixels to dilate the result masks. */
          dilate?: number;
          style?:
            | "3d-cartoon"
            | "3d-rendered"
            | "anime"
            | "cartoon"
            | "cinematic"
            | "claymation"
            | "cloud-skydome"
            | "comic"
            | "cyberpunk"
            | "enchanted"
            | "fantasy"
            | "ink"
            | "manga"
            | "manga-color"
            | "minimalist"
            | "neon-tron"
            | "oil-painting"
            | "pastel"
            | "photo"
            | "photography"
            | "psychedelic"
            | "retro-fantasy"
            | "scifi-concept-art"
            | "space"
            | "standard"
            | "whimsical";
          /** Strengthen the similarity to the original image during the upscale. Default: optimized for your preset and style. */
          imageFidelity?: number;
          /** Location of the input image in the output. */
          inputLocation?: "bottom" | "left" | "middle" | "right" | "top";
          /** The seed used to generate this asset */
          seed?: string;
          /** The higher the value the more it will look like the secondary reference image(s) */
          secondaryRefFidelity?: number;
          preset?: string;
          trainingImage?: boolean;
          /** Boolean to able return the masks (binary image) in the response. */
          resultMask?: boolean;
          /** The ISO timestamp when the lock on the canvas will expire */
          lockExpiresAt?: string;
          /** The baseModelId that maybe changed at inference time */
          baseModelId?: string;
          pathPrecision?: number;
          rootParentId?: string;
          /** Sharpen tiles. */
          sharpen?: boolean;
          cornerThreshold?: number;
          /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
          styleImages?: string[];
          /** The asset to convert in texture maps. Must reference an existing AssetId. */
          texture?: string;
          filterSpeckle?: number;
          /** Minimum threshold for Grayscale conversion */
          minThreshold?: number;
          /** Maximum threshold for Grayscale conversion */
          maxThreshold?: number;
          /** Condition the influence of the style image(s). The higher the value, the more the style images will influence the upscaled image. */
          styleImagesFidelity?: number;
          /** The control image processed by depth estimator. Must reference an existing AssetId. */
          depthImage?: string;
          parentId?: string;
          parentJobId?: string;
          /** Optional List of secondary style images. Example: portrait of people. It must be existing AssetIds. */
          secondaryRefImages?: string[];
          /** The width of the rendered image. */
          width?: number;
          /** The checkpoint to use */
          checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
          strength?: number;
          /** The id of the Inference describing how this image was generated */
          inferenceId?: string;
          lengthThreshold?: number;
          /** Int to set between 0 and 255 for the opacity of the background in the result images. */
          backgroundOpacity?: number;
          /** The optional aspect ratio given for the generation, only applicable for some models */
          aspectRatio?: string;
          /** Amount of details to remove or add */
          detailsLevel?: number;
          /** Determine the scale at which the upscale process works.
                - With a small value, the upscale works at the largest scale, resulting in fewer added details and more coherent images. Ideal for portraits, for example.
                - With a large value, the upscale works at the smallest scale, resulting in more added details and more hallucinations. Ideal for landscapes, for example.
                
                (info): A small value is slower and more expensive to run. */
          fractality?: number;
          /** (deprecated) Horizontal expansion ratio. */
          horizontalExpansionRatio?: number;
          /** List of points (label, x, y) in the image where label = 0 for background and 1 for object. */
          points?: any[][];
          mode?: string;
          colorPrecision?: number;
          /** Increase the fidelity to the prompt during upscale. Default: optimized for your preset and style. */
          promptFidelity?: number;
          /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
          betterQuality?: boolean;
          /** Remove background for Grayscale detector */
          removeBackground?: boolean;
          /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your preset and style. */
          creativity?: number;
          /** Strength for the input image structure preservation */
          structureFidelity?: number;
          /** Preserve the seamless properties of skybox or texture images. Input has to be of same type (seamless). */
          imageType?: "seamfull" | "skybox" | "texture";
          /** The input image to process. Must reference an existing AssetId or be a data URL. */
          image?: string;
          /** The thumbnail of the canvas */
          thumbnail?: {
            /** The AssetId of the image used as a thumbnail for the canvas (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
            assetId: string;
            /** The url of the image used as a thumbnail for the canvas */
            url: string;
          };
          /** The control image for structure. A canny detector will be applied to this image. Must reference an existing AssetId. */
          structureImage?: string;
          /** To invert the relief */
          invert?: boolean;
          kind: "3d" | "audio" | "document" | "image" | "json" | "video";
          colorMode?: string;
          /** High threshold for Canny detector */
          highThreshold?: number;
          /** (deprecated) Vertical expansion ratio. */
          verticalExpansionRatio?: number;
          halfMode?: boolean;
          name?: string;
          /** Additional refinement steps before scaling.
                
                If scalingFactor == 1, the refinement process will be applied (1 + refinementSteps) times.
                If scalingFactor > 1, the refinement process will be applied refinementSteps times. */
          refinementSteps?: number;
          /** The reference images used for the image generation or editing */
          referenceImages?: string[];
          /** The higher the value the more it will look like the style image(s) */
          styleFidelity?: number;
          /** Boolean to output the contours. */
          resultContours?: boolean;
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          polished?: number;
          /** The scheduler used to generate this asset */
          scheduler?: string;
          /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
          overrideEmbeddings?: boolean;
          progressPercent?: number;
          /** Contrast factor for Grayscale detector */
          factor?: number;
          /** The mask used for the image generation or editing */
          mask?: string;
          /** Low threshold for Canny detector */
          lowThreshold?: number;
          /** The depth fidelity if a depth image provided */
          depthFidelity?: number;
          /** How raised is the surface? 0 is flat like water, 1 is like a very rough rock */
          raised?: number;
          message?: string;
          contours?: number[][][][];
          /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
          negativePrompt?: string;
          /** If true, use the default parameters */
          defaultParameters?: boolean;
          /** Size proportion of the input image in the output. */
          resizeOption?: number;
          outputIndex?: number;
          /** Save a flipbook of the texture. Deactivated when the input texture is larger than 2048x2048px */
          saveFlipbook?: boolean;
          /** The guidance used to generate this asset */
          guidance?: number;
          /** The number of denoising steps for each image generation. */
          numInferenceSteps?: number;
          hdr?: number;
          /** How shiny is the surface? 0 is like a matte surface, 1 is like a diamond */
          shiny?: number;
          /** Ensure upscaled tile have the same color histogram as original tile. */
          colorCorrection?: boolean;
          /** Overlap percentage for the output image. */
          overlapPercentage?: number;
          /** The prompt that guided the image generation or editing */
          prompt?: string;
          /** Boolean to able output the cut out object. */
          resultImage?: boolean;
          /** The control image already processed by canny detector. Must reference an existing AssetId. */
          cannyStructureImage?: string;
          /** Apply extra control to the Skybox 360 geometry.
                The higher the value, the more the 360 geometry will influence the generated skybox image.
                
                Use with caution. Default is adapted to the other parameters. */
          geometryEnforcement?: number;
          /** Target width for the upscaled image, take priority over scaling factor */
          targetWidth?: number;
        };
        /** The NSFW labels */
        nsfw?: string[];
        /** Automatic captioning of the asset */
        automaticCaptioning?: string;
        /** The description of the asset */
        description?: string;
        /** The privacy of the asset */
        privacy: "private" | "public" | "unlisted";
        /** The date when the asset will be soft deleted (only for Free plan) */
        softDeletionOn?: string;
        /** The mime type of the asset (example: "image/png") */
        mimeType: string;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId: string;
        /** The owner (project) ID (example: "proj_23tlk332lkht3kl2" or "team_dlkhgs23tlk3hlkth32lkht3kl2" for old teams) */
        ownerId: string;
        /** Signed URL to get the asset content */
        url: string;
        /** The associated tags (example: ["sci-fi", "landscape"]) */
        tags: string[];
        /** The asset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The output index of the asset within the job
            This index is an positive integer that starts at 0
            It is used to differentiate between multiple outputs of the same job
            If the job has only one output, this index is 0
            This is only applicable for generations with: Flux, Skybox, Reframe at the moment */
        outputIndex?: number;
        /** A list of CollectionId this asset belongs to */
        collectionIds: string[];
        /** List of edit capabilities for the asset */
        editCapabilities: (
          | "DETECTION"
          | "GENERATIVE_FILL"
          | "PIXELATE"
          | "PROMPT_EDITING"
          | "REFINE"
          | "REFRAME"
          | "REMOVE_BACKGROUND"
          | "SEGMENTATION"
          | "UPSCALE"
          | "UPSCALE_360"
          | "VECTORIZATION"
        )[];
        /** The embedding of the asset when requested and asset can be embedded
            
            ie: Detection maps don't have embeddings */
        embedding?: number[];
        /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        id: string;
        /** The status of the asset */
        status: "error" | "pending" | "success";
        /** The asset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      }[];
      /** The markdown description of the model (ex: `# My model`).
        We allow the `{asset:<assetId>}` and `{model:<modelId>}` tags. */
      value: string;
    };
  };
export type PutModelsDescriptionByModelIdApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The model Id for which the training will be triggered */
  modelId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** The markdown description of the model (ex: `# My model`). Set to `null` to delete the description. */
    description: string;
  };
};
export type PostDownloadModelApiResponse = /** status 200 200 response */ {
  /** The job id associated with the download request */
  jobId: string;
};
export type PostDownloadModelApiArg = {
  modelId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
};
export type GetModelsExamplesByModelIdApiResponse =
  /** status 200 200 response */ {
    examples: {
      /** Model id of the model used to generate the asset */
      modelId: string;
      /** The inference parameters used to generate the asset */
      inferenceParameters: {
        /** Asset id of the input IpAdapter images */
        ipAdapterImageIds?: string[];
        /** If style_fidelity=1.0, control more important, else if style_fidelity=0.0, prompt more important, else balanced
            Only for "reference" inference type */
        styleFidelity?: number;
        /** Specifies how long the ControlNet guidance should be applied during the inference process.
            
            Only available for Flux.1-dev based models.
            
            The value represents the percentage of total inference steps where the ControlNet guidance is active.
            For example:
            - 1.0: ControlNet guidance is applied during all inference steps
            - 0.5: ControlNet guidance is only applied during the first half of inference steps
            
            Default values:
            - 0.5 for Canny modality
            - 0.6 for all other modalities */
        controlEnd?: number;
        /** The modality associated with the control image used for the generation: it can either be an object with a combination of maximum
            
            For models of SD1.5 family:
             - up to 3 modalities from `canny`, `pose`, `depth`, `lines`, `seg`, `scribble`, `lineart`, `normal-map`, `illusion`
             - or one of the following presets: `character`, `landscape`, `city`, `interior`.
            
            For models of the SDXL family:
             - up to 3 modalities from `canny`, `pose`, `depth`, `seg`, `illusion`, `scribble`
             - or one of the following presets: `character`, `landscape`.
            
            For models of the FLUX schnell or dev families:
            - one modality from: `canny`, `tile`, `depth`, `blur`, `pose`, `gray`, `low-quality`
            
            Optionally, you can associate a value to these modalities or presets. The value must be within `]0.0, 1.0]`.
            
            Examples:
            - `canny`
            - `depth:0.5,pose:1.0`
            - `canny:0.5,depth:0.5,lines:0.3`
            - `landscape`
            - `character:0.5`
            - `illusion:1`
            
            Note: if you use a value that is not supported by the model family, this will result in an error. */
        modality?:
          | "blur"
          | "canny"
          | "depth"
          | "gray"
          | "illusion"
          | "lineart"
          | "lines"
          | "low-quality"
          | "normal-map"
          | "pose"
          | "scribble"
          | "seg"
          | "sketch"
          | "tile";
        /** Used to reproduce previous results. Default: randomly generated number. */
        seed?: string;
        /** Controls the noise intensity introduced to the input image, where a value of 1.0 completely erases the original image's details. Available for img2img and inpainting. (within [0.01, 1.0], default: 0.75) */
        strength?: number;
        /** The type of IP Adapter model to use. Must be one of [`style`, `character`], default to `style`` */
        ipAdapterType?: "character" | "style";
        /** The aspect ratio of the generated images. Only used for the model flux.1.1-pro-ultra.
            The aspect ratio is a string formatted as "width:height" (example: "16:9"). */
        aspectRatio?:
          | "16:9"
          | "1:1"
          | "21:9"
          | "2:3"
          | "3:2"
          | "3:4"
          | "4:3"
          | "4:5"
          | "5:4"
          | "9:16"
          | "9:21";
        /** The type of inference to use. Example: txt2img, img2img, etc.
            
            Selecting the right type will condition the expected parameters.
            
            Note: if model.type is `sd-xl*` or `sd-1_5*`, when using the `"inpaint"` inference type, Scenario determines the best available `baseModel` for a given `modelId`: one of `["stable-diffusion-inpainting", "stable-diffusion-xl-1.0-inpainting-0.1"] will be used. */
        type:
          | "controlnet"
          | "controlnet_img2img"
          | "controlnet_inpaint"
          | "controlnet_inpaint_ip_adapter"
          | "controlnet_ip_adapter"
          | "controlnet_reference"
          | "controlnet_texture"
          | "img2img"
          | "img2img_ip_adapter"
          | "img2img_texture"
          | "inpaint"
          | "inpaint_ip_adapter"
          | "outpaint"
          | "reference"
          | "reference_texture"
          | "txt2img"
          | "txt2img_ip_adapter"
          | "txt2img_texture";
        /** Signed URL to display the IpAdapter image */
        ipAdapterImage?: string;
        /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
        scheduler?:
          | "DDIMScheduler"
          | "DDPMScheduler"
          | "DEISMultistepScheduler"
          | "DPMSolverMultistepScheduler"
          | "DPMSolverSinglestepScheduler"
          | "EulerAncestralDiscreteScheduler"
          | "EulerDiscreteScheduler"
          | "HeunDiscreteScheduler"
          | "KDPM2AncestralDiscreteScheduler"
          | "KDPM2DiscreteScheduler"
          | "LCMScheduler"
          | "LMSDiscreteScheduler"
          | "PNDMScheduler"
          | "TCDScheduler"
          | "UniPCMultistepScheduler";
        /** If set to true, the entire input image will likely change during inpainting. This results in faster inferences, but the output image will be harder to integrate if the input is just a small part of a larger image. */
        disableMerging?: boolean;
        /** If false, the process uses the given image to detect the modality.
            If true (default), the process will not try to detect the modality of the given image.
            
            For example:
            with `pose` modality and `false` value, the process will detect the pose of people in the given image
            with `depth` modality and `false` value, the process will detect the depth of the given image
            with `scribble` modality and `true`value, the process will use the given image as a scribble
            
            ⚠️ For models of the FLUX schnell or dev families, this parameter is ignored. The modality detection is always disabled. ⚠️ */
        disableModalityDetection?: boolean;
        /** Signed URL to display the IpAdapter images */
        ipAdapterImages?: string[];
        /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
            Allowed values are available in the model's attribute: `compliantModelIds` */
        baseModelId?: string;
        /** Specifies the starting point of the ControlNet guidance during the inference process.
            
            Only available for Flux.1-dev based models.
            
            The value represents the percentage of total inference steps where the ControlNet guidance starts.
            For example:
            - 0.0: ControlNet guidance starts at the beginning of the inference steps
            - 0.5: ControlNet guidance starts at the middle of the inference steps */
        controlStart?: number;
        /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
            If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
            If model.type is `sd-1_5`, the height must be within [64, 1024]
            If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        height?: number;
        /** Signed URL to display the mask image */
        mask?: string;
        /** Asset id of the controlnet input image */
        controlImageId?: string;
        /** Signed URL to display the input image */
        image?: string;
        /** Asset id of the input image */
        imageId?: string;
        /** Asset id of the input IpAdapter image */
        ipAdapterImageId?: string;
        /** IpAdapter scale factor (within [0.0, 1.0], default: 0.9). */
        ipAdapterScale?: number;
        /** If set, generated assets will be hidden and not returned in the list of images of the inference
            or when listing assets (default: false) */
        hideResults?: boolean;
        /** IpAdapter scale factors (within [0.0, 1.0], default: 0.9). */
        ipAdapterScales?: number[];
        /** Asset id of the mask image */
        maskId?: string;
        /** Whether to use reference adain
            Only for "reference" inference type */
        referenceAdain?: boolean;
        /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
        negativePrompt?: string;
        /** Enable or disable the intermediate images generation (default: false) */
        intermediateImages?: boolean;
        concepts?: {
          /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
          modelId: string;
          /** The scale of the model (example: 1.0) */
          scale: number;
        }[];
        /** Signed URL to display the controlnet input image */
        controlImage?: string;
        /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
        guidance?: number;
        /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
        numInferenceSteps?: number;
        /** The number of images to generate (within [1, 128], default: 4) */
        numSamples?: number;
        /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
            If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
            If model.type is `sd-1_5`, the width must be within [64, 1024]
            If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        width?: number;
        /** Whether to use reference query for self attention's context
            Only for "reference" inference type */
        referenceAttn?: boolean;
        /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
        prompt: string;
      };
      /** Inference id of the inference used to generate the asset */
      inferenceId: string;
      /** Asset generated by the inference */
      asset: {
        /** Metadata of the asset with some additional information */
        metadata: {
          maxIterations?: number;
          /** Modality to detect */
          modality?:
            | "canny"
            | "depth"
            | "grayscale"
            | "lineart_anime"
            | "mlsd"
            | "normal"
            | "pose"
            | "scribble"
            | "segmentation"
            | "sketch";
          /** If set to true, during the upscaling process, the model will match tiles of the source image with tiles of the style image(s). This will result in a more coherent restyle. Works best with style images that have a similar composition. */
          tileStyle?: boolean;
          /** The modelId used to generate this asset */
          modelId?: string;
          /** A bounding box around the object of interest, in the format [x1, y1, x2, y2]. */
          bbox?: any[];
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          keypointThreshold?: number;
          /** The type of the asset. Ex: 'inference-txt2img' will represent an asset generated from a text to image model */
          type:
            | "background-removal"
            | "canvas"
            | "canvas-drawing"
            | "canvas-export"
            | "detection"
            | "generative-fill"
            | "image-prompt-editing"
            | "img23d-custom"
            | "img2img-custom"
            | "img2video-custom"
            | "inference-controlnet"
            | "inference-controlnet-img2img"
            | "inference-controlnet-inpaint"
            | "inference-controlnet-inpaint-ip-adapter"
            | "inference-controlnet-ip-adapter"
            | "inference-controlnet-reference"
            | "inference-controlnet-texture"
            | "inference-img2img"
            | "inference-img2img-ip-adapter"
            | "inference-img2img-texture"
            | "inference-inpaint"
            | "inference-inpaint-ip-adapter"
            | "inference-reference"
            | "inference-reference-texture"
            | "inference-txt2img"
            | "inference-txt2img-ip-adapter"
            | "inference-txt2img-texture"
            | "patch"
            | "pixelization"
            | "reframe"
            | "restyle"
            | "segment"
            | "segmentation-image"
            | "segmentation-mask"
            | "skybox-base-360"
            | "texture"
            | "texture-albedo"
            | "texture-ao"
            | "texture-edge"
            | "texture-height"
            | "texture-metallic"
            | "texture-normal"
            | "texture-smoothness"
            | "txt23d-custom"
            | "txt2audio-custom"
            | "txt2img-custom"
            | "unknown-custom"
            | "uploaded"
            | "upscale"
            | "upscale-skybox"
            | "upscale-texture"
            | "vectorization"
            | "video2video-custom";
          /** A textual description / keywords describing the object of interest. */
          text?: string;
          height?: number;
          nbMasks?: number;
          /** Amount of decay in creativity over the upscale process. The lowest the value, the less the creativity will be preserved over the upscale process. */
          creativityDecay?: number;
          layerDifference?: number;
          /** Scaling factor (when `targetWidth` not specified) */
          scalingFactor?: number;
          /** The type of the generator used */
          modelType?:
            | "custom"
            | "flux.1"
            | "flux.1-composition"
            | "flux.1-lora"
            | "flux.1-pro"
            | "flux.1.1-pro-ultra"
            | "flux1.1-pro"
            | "gpt-image-1"
            | "sd-1_5"
            | "sd-1_5-composition"
            | "sd-1_5-lora"
            | "sd-xl"
            | "sd-xl-composition"
            | "sd-xl-lora";
          /** The number of outputs to generate. */
          numOutputs?: number;
          /** How angular is the surface? 0 is like a sphere, 1 is like a mechanical object */
          angular?: number;
          /** The target height of the output image. */
          targetHeight?: number;
          /** Flux LoRa or Composition to style the image. */
          concepts?: {
            weightName: string;
            /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
            modelId: string;
            /** The scale of the model (example: 1.0) */
            scale: number;
          }[];
          size?: number;
          spliceThreshold?: number;
          /** The number of pixels to dilate the result masks. */
          dilate?: number;
          style?:
            | "3d-cartoon"
            | "3d-rendered"
            | "anime"
            | "cartoon"
            | "cinematic"
            | "claymation"
            | "cloud-skydome"
            | "comic"
            | "cyberpunk"
            | "enchanted"
            | "fantasy"
            | "ink"
            | "manga"
            | "manga-color"
            | "minimalist"
            | "neon-tron"
            | "oil-painting"
            | "pastel"
            | "photo"
            | "photography"
            | "psychedelic"
            | "retro-fantasy"
            | "scifi-concept-art"
            | "space"
            | "standard"
            | "whimsical";
          /** Strengthen the similarity to the original image during the upscale. Default: optimized for your preset and style. */
          imageFidelity?: number;
          /** Location of the input image in the output. */
          inputLocation?: "bottom" | "left" | "middle" | "right" | "top";
          /** The seed used to generate this asset */
          seed?: string;
          /** The higher the value the more it will look like the secondary reference image(s) */
          secondaryRefFidelity?: number;
          preset?: string;
          trainingImage?: boolean;
          /** Boolean to able return the masks (binary image) in the response. */
          resultMask?: boolean;
          /** The ISO timestamp when the lock on the canvas will expire */
          lockExpiresAt?: string;
          /** The baseModelId that maybe changed at inference time */
          baseModelId?: string;
          pathPrecision?: number;
          rootParentId?: string;
          /** Sharpen tiles. */
          sharpen?: boolean;
          cornerThreshold?: number;
          /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
          styleImages?: string[];
          /** The asset to convert in texture maps. Must reference an existing AssetId. */
          texture?: string;
          filterSpeckle?: number;
          /** Minimum threshold for Grayscale conversion */
          minThreshold?: number;
          /** Maximum threshold for Grayscale conversion */
          maxThreshold?: number;
          /** Condition the influence of the style image(s). The higher the value, the more the style images will influence the upscaled image. */
          styleImagesFidelity?: number;
          /** The control image processed by depth estimator. Must reference an existing AssetId. */
          depthImage?: string;
          parentId?: string;
          parentJobId?: string;
          /** Optional List of secondary style images. Example: portrait of people. It must be existing AssetIds. */
          secondaryRefImages?: string[];
          /** The width of the rendered image. */
          width?: number;
          /** The checkpoint to use */
          checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
          strength?: number;
          /** The id of the Inference describing how this image was generated */
          inferenceId?: string;
          lengthThreshold?: number;
          /** Int to set between 0 and 255 for the opacity of the background in the result images. */
          backgroundOpacity?: number;
          /** The optional aspect ratio given for the generation, only applicable for some models */
          aspectRatio?: string;
          /** Amount of details to remove or add */
          detailsLevel?: number;
          /** Determine the scale at which the upscale process works.
                - With a small value, the upscale works at the largest scale, resulting in fewer added details and more coherent images. Ideal for portraits, for example.
                - With a large value, the upscale works at the smallest scale, resulting in more added details and more hallucinations. Ideal for landscapes, for example.
                
                (info): A small value is slower and more expensive to run. */
          fractality?: number;
          /** (deprecated) Horizontal expansion ratio. */
          horizontalExpansionRatio?: number;
          /** List of points (label, x, y) in the image where label = 0 for background and 1 for object. */
          points?: any[][];
          mode?: string;
          colorPrecision?: number;
          /** Increase the fidelity to the prompt during upscale. Default: optimized for your preset and style. */
          promptFidelity?: number;
          /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
          betterQuality?: boolean;
          /** Remove background for Grayscale detector */
          removeBackground?: boolean;
          /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your preset and style. */
          creativity?: number;
          /** Strength for the input image structure preservation */
          structureFidelity?: number;
          /** Preserve the seamless properties of skybox or texture images. Input has to be of same type (seamless). */
          imageType?: "seamfull" | "skybox" | "texture";
          /** The input image to process. Must reference an existing AssetId or be a data URL. */
          image?: string;
          /** The thumbnail of the canvas */
          thumbnail?: {
            /** The AssetId of the image used as a thumbnail for the canvas (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
            assetId: string;
            /** The url of the image used as a thumbnail for the canvas */
            url: string;
          };
          /** The control image for structure. A canny detector will be applied to this image. Must reference an existing AssetId. */
          structureImage?: string;
          /** To invert the relief */
          invert?: boolean;
          kind: "3d" | "audio" | "document" | "image" | "json" | "video";
          colorMode?: string;
          /** High threshold for Canny detector */
          highThreshold?: number;
          /** (deprecated) Vertical expansion ratio. */
          verticalExpansionRatio?: number;
          halfMode?: boolean;
          name?: string;
          /** Additional refinement steps before scaling.
                
                If scalingFactor == 1, the refinement process will be applied (1 + refinementSteps) times.
                If scalingFactor > 1, the refinement process will be applied refinementSteps times. */
          refinementSteps?: number;
          /** The reference images used for the image generation or editing */
          referenceImages?: string[];
          /** The higher the value the more it will look like the style image(s) */
          styleFidelity?: number;
          /** Boolean to output the contours. */
          resultContours?: boolean;
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          polished?: number;
          /** The scheduler used to generate this asset */
          scheduler?: string;
          /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
          overrideEmbeddings?: boolean;
          progressPercent?: number;
          /** Contrast factor for Grayscale detector */
          factor?: number;
          /** The mask used for the image generation or editing */
          mask?: string;
          /** Low threshold for Canny detector */
          lowThreshold?: number;
          /** The depth fidelity if a depth image provided */
          depthFidelity?: number;
          /** How raised is the surface? 0 is flat like water, 1 is like a very rough rock */
          raised?: number;
          message?: string;
          contours?: number[][][][];
          /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
          negativePrompt?: string;
          /** If true, use the default parameters */
          defaultParameters?: boolean;
          /** Size proportion of the input image in the output. */
          resizeOption?: number;
          outputIndex?: number;
          /** Save a flipbook of the texture. Deactivated when the input texture is larger than 2048x2048px */
          saveFlipbook?: boolean;
          /** The guidance used to generate this asset */
          guidance?: number;
          /** The number of denoising steps for each image generation. */
          numInferenceSteps?: number;
          hdr?: number;
          /** How shiny is the surface? 0 is like a matte surface, 1 is like a diamond */
          shiny?: number;
          /** Ensure upscaled tile have the same color histogram as original tile. */
          colorCorrection?: boolean;
          /** Overlap percentage for the output image. */
          overlapPercentage?: number;
          /** The prompt that guided the image generation or editing */
          prompt?: string;
          /** Boolean to able output the cut out object. */
          resultImage?: boolean;
          /** The control image already processed by canny detector. Must reference an existing AssetId. */
          cannyStructureImage?: string;
          /** Apply extra control to the Skybox 360 geometry.
                The higher the value, the more the 360 geometry will influence the generated skybox image.
                
                Use with caution. Default is adapted to the other parameters. */
          geometryEnforcement?: number;
          /** Target width for the upscaled image, take priority over scaling factor */
          targetWidth?: number;
        };
        /** The NSFW labels */
        nsfw?: string[];
        /** Automatic captioning of the asset */
        automaticCaptioning?: string;
        /** The description of the asset */
        description?: string;
        /** The privacy of the asset */
        privacy: "private" | "public" | "unlisted";
        /** The date when the asset will be soft deleted (only for Free plan) */
        softDeletionOn?: string;
        /** The mime type of the asset (example: "image/png") */
        mimeType: string;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId: string;
        /** The owner (project) ID (example: "proj_23tlk332lkht3kl2" or "team_dlkhgs23tlk3hlkth32lkht3kl2" for old teams) */
        ownerId: string;
        /** Signed URL to get the asset content */
        url: string;
        /** The associated tags (example: ["sci-fi", "landscape"]) */
        tags: string[];
        /** The asset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The output index of the asset within the job
            This index is an positive integer that starts at 0
            It is used to differentiate between multiple outputs of the same job
            If the job has only one output, this index is 0
            This is only applicable for generations with: Flux, Skybox, Reframe at the moment */
        outputIndex?: number;
        /** A list of CollectionId this asset belongs to */
        collectionIds: string[];
        /** List of edit capabilities for the asset */
        editCapabilities: (
          | "DETECTION"
          | "GENERATIVE_FILL"
          | "PIXELATE"
          | "PROMPT_EDITING"
          | "REFINE"
          | "REFRAME"
          | "REMOVE_BACKGROUND"
          | "SEGMENTATION"
          | "UPSCALE"
          | "UPSCALE_360"
          | "VECTORIZATION"
        )[];
        /** The embedding of the asset when requested and asset can be embedded
            
            ie: Detection maps don't have embeddings */
        embedding?: number[];
        /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        id: string;
        /** The status of the asset */
        status: "error" | "pending" | "success";
        /** The asset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }[];
  };
export type GetModelsExamplesByModelIdApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The modelId of the examples */
  modelId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
};
export type PutModelsExamplesByModelIdApiResponse =
  /** status 200 200 response */ {
    examples: {
      /** Model id of the model used to generate the asset */
      modelId: string;
      /** The inference parameters used to generate the asset */
      inferenceParameters: {
        /** Asset id of the input IpAdapter images */
        ipAdapterImageIds?: string[];
        /** If style_fidelity=1.0, control more important, else if style_fidelity=0.0, prompt more important, else balanced
            Only for "reference" inference type */
        styleFidelity?: number;
        /** Specifies how long the ControlNet guidance should be applied during the inference process.
            
            Only available for Flux.1-dev based models.
            
            The value represents the percentage of total inference steps where the ControlNet guidance is active.
            For example:
            - 1.0: ControlNet guidance is applied during all inference steps
            - 0.5: ControlNet guidance is only applied during the first half of inference steps
            
            Default values:
            - 0.5 for Canny modality
            - 0.6 for all other modalities */
        controlEnd?: number;
        /** The modality associated with the control image used for the generation: it can either be an object with a combination of maximum
            
            For models of SD1.5 family:
             - up to 3 modalities from `canny`, `pose`, `depth`, `lines`, `seg`, `scribble`, `lineart`, `normal-map`, `illusion`
             - or one of the following presets: `character`, `landscape`, `city`, `interior`.
            
            For models of the SDXL family:
             - up to 3 modalities from `canny`, `pose`, `depth`, `seg`, `illusion`, `scribble`
             - or one of the following presets: `character`, `landscape`.
            
            For models of the FLUX schnell or dev families:
            - one modality from: `canny`, `tile`, `depth`, `blur`, `pose`, `gray`, `low-quality`
            
            Optionally, you can associate a value to these modalities or presets. The value must be within `]0.0, 1.0]`.
            
            Examples:
            - `canny`
            - `depth:0.5,pose:1.0`
            - `canny:0.5,depth:0.5,lines:0.3`
            - `landscape`
            - `character:0.5`
            - `illusion:1`
            
            Note: if you use a value that is not supported by the model family, this will result in an error. */
        modality?:
          | "blur"
          | "canny"
          | "depth"
          | "gray"
          | "illusion"
          | "lineart"
          | "lines"
          | "low-quality"
          | "normal-map"
          | "pose"
          | "scribble"
          | "seg"
          | "sketch"
          | "tile";
        /** Used to reproduce previous results. Default: randomly generated number. */
        seed?: string;
        /** Controls the noise intensity introduced to the input image, where a value of 1.0 completely erases the original image's details. Available for img2img and inpainting. (within [0.01, 1.0], default: 0.75) */
        strength?: number;
        /** The type of IP Adapter model to use. Must be one of [`style`, `character`], default to `style`` */
        ipAdapterType?: "character" | "style";
        /** The aspect ratio of the generated images. Only used for the model flux.1.1-pro-ultra.
            The aspect ratio is a string formatted as "width:height" (example: "16:9"). */
        aspectRatio?:
          | "16:9"
          | "1:1"
          | "21:9"
          | "2:3"
          | "3:2"
          | "3:4"
          | "4:3"
          | "4:5"
          | "5:4"
          | "9:16"
          | "9:21";
        /** The type of inference to use. Example: txt2img, img2img, etc.
            
            Selecting the right type will condition the expected parameters.
            
            Note: if model.type is `sd-xl*` or `sd-1_5*`, when using the `"inpaint"` inference type, Scenario determines the best available `baseModel` for a given `modelId`: one of `["stable-diffusion-inpainting", "stable-diffusion-xl-1.0-inpainting-0.1"] will be used. */
        type:
          | "controlnet"
          | "controlnet_img2img"
          | "controlnet_inpaint"
          | "controlnet_inpaint_ip_adapter"
          | "controlnet_ip_adapter"
          | "controlnet_reference"
          | "controlnet_texture"
          | "img2img"
          | "img2img_ip_adapter"
          | "img2img_texture"
          | "inpaint"
          | "inpaint_ip_adapter"
          | "outpaint"
          | "reference"
          | "reference_texture"
          | "txt2img"
          | "txt2img_ip_adapter"
          | "txt2img_texture";
        /** Signed URL to display the IpAdapter image */
        ipAdapterImage?: string;
        /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
        scheduler?:
          | "DDIMScheduler"
          | "DDPMScheduler"
          | "DEISMultistepScheduler"
          | "DPMSolverMultistepScheduler"
          | "DPMSolverSinglestepScheduler"
          | "EulerAncestralDiscreteScheduler"
          | "EulerDiscreteScheduler"
          | "HeunDiscreteScheduler"
          | "KDPM2AncestralDiscreteScheduler"
          | "KDPM2DiscreteScheduler"
          | "LCMScheduler"
          | "LMSDiscreteScheduler"
          | "PNDMScheduler"
          | "TCDScheduler"
          | "UniPCMultistepScheduler";
        /** If set to true, the entire input image will likely change during inpainting. This results in faster inferences, but the output image will be harder to integrate if the input is just a small part of a larger image. */
        disableMerging?: boolean;
        /** If false, the process uses the given image to detect the modality.
            If true (default), the process will not try to detect the modality of the given image.
            
            For example:
            with `pose` modality and `false` value, the process will detect the pose of people in the given image
            with `depth` modality and `false` value, the process will detect the depth of the given image
            with `scribble` modality and `true`value, the process will use the given image as a scribble
            
            ⚠️ For models of the FLUX schnell or dev families, this parameter is ignored. The modality detection is always disabled. ⚠️ */
        disableModalityDetection?: boolean;
        /** Signed URL to display the IpAdapter images */
        ipAdapterImages?: string[];
        /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
            Allowed values are available in the model's attribute: `compliantModelIds` */
        baseModelId?: string;
        /** Specifies the starting point of the ControlNet guidance during the inference process.
            
            Only available for Flux.1-dev based models.
            
            The value represents the percentage of total inference steps where the ControlNet guidance starts.
            For example:
            - 0.0: ControlNet guidance starts at the beginning of the inference steps
            - 0.5: ControlNet guidance starts at the middle of the inference steps */
        controlStart?: number;
        /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
            If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
            If model.type is `sd-1_5`, the height must be within [64, 1024]
            If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        height?: number;
        /** Signed URL to display the mask image */
        mask?: string;
        /** Asset id of the controlnet input image */
        controlImageId?: string;
        /** Signed URL to display the input image */
        image?: string;
        /** Asset id of the input image */
        imageId?: string;
        /** Asset id of the input IpAdapter image */
        ipAdapterImageId?: string;
        /** IpAdapter scale factor (within [0.0, 1.0], default: 0.9). */
        ipAdapterScale?: number;
        /** If set, generated assets will be hidden and not returned in the list of images of the inference
            or when listing assets (default: false) */
        hideResults?: boolean;
        /** IpAdapter scale factors (within [0.0, 1.0], default: 0.9). */
        ipAdapterScales?: number[];
        /** Asset id of the mask image */
        maskId?: string;
        /** Whether to use reference adain
            Only for "reference" inference type */
        referenceAdain?: boolean;
        /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
        negativePrompt?: string;
        /** Enable or disable the intermediate images generation (default: false) */
        intermediateImages?: boolean;
        concepts?: {
          /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
          modelId: string;
          /** The scale of the model (example: 1.0) */
          scale: number;
        }[];
        /** Signed URL to display the controlnet input image */
        controlImage?: string;
        /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
        guidance?: number;
        /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
        numInferenceSteps?: number;
        /** The number of images to generate (within [1, 128], default: 4) */
        numSamples?: number;
        /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
            If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
            If model.type is `sd-1_5`, the width must be within [64, 1024]
            If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        width?: number;
        /** Whether to use reference query for self attention's context
            Only for "reference" inference type */
        referenceAttn?: boolean;
        /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
        prompt: string;
      };
      /** Inference id of the inference used to generate the asset */
      inferenceId: string;
      /** Asset generated by the inference */
      asset: {
        /** Metadata of the asset with some additional information */
        metadata: {
          maxIterations?: number;
          /** Modality to detect */
          modality?:
            | "canny"
            | "depth"
            | "grayscale"
            | "lineart_anime"
            | "mlsd"
            | "normal"
            | "pose"
            | "scribble"
            | "segmentation"
            | "sketch";
          /** If set to true, during the upscaling process, the model will match tiles of the source image with tiles of the style image(s). This will result in a more coherent restyle. Works best with style images that have a similar composition. */
          tileStyle?: boolean;
          /** The modelId used to generate this asset */
          modelId?: string;
          /** A bounding box around the object of interest, in the format [x1, y1, x2, y2]. */
          bbox?: any[];
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          keypointThreshold?: number;
          /** The type of the asset. Ex: 'inference-txt2img' will represent an asset generated from a text to image model */
          type:
            | "background-removal"
            | "canvas"
            | "canvas-drawing"
            | "canvas-export"
            | "detection"
            | "generative-fill"
            | "image-prompt-editing"
            | "img23d-custom"
            | "img2img-custom"
            | "img2video-custom"
            | "inference-controlnet"
            | "inference-controlnet-img2img"
            | "inference-controlnet-inpaint"
            | "inference-controlnet-inpaint-ip-adapter"
            | "inference-controlnet-ip-adapter"
            | "inference-controlnet-reference"
            | "inference-controlnet-texture"
            | "inference-img2img"
            | "inference-img2img-ip-adapter"
            | "inference-img2img-texture"
            | "inference-inpaint"
            | "inference-inpaint-ip-adapter"
            | "inference-reference"
            | "inference-reference-texture"
            | "inference-txt2img"
            | "inference-txt2img-ip-adapter"
            | "inference-txt2img-texture"
            | "patch"
            | "pixelization"
            | "reframe"
            | "restyle"
            | "segment"
            | "segmentation-image"
            | "segmentation-mask"
            | "skybox-base-360"
            | "texture"
            | "texture-albedo"
            | "texture-ao"
            | "texture-edge"
            | "texture-height"
            | "texture-metallic"
            | "texture-normal"
            | "texture-smoothness"
            | "txt23d-custom"
            | "txt2audio-custom"
            | "txt2img-custom"
            | "unknown-custom"
            | "uploaded"
            | "upscale"
            | "upscale-skybox"
            | "upscale-texture"
            | "vectorization"
            | "video2video-custom";
          /** A textual description / keywords describing the object of interest. */
          text?: string;
          height?: number;
          nbMasks?: number;
          /** Amount of decay in creativity over the upscale process. The lowest the value, the less the creativity will be preserved over the upscale process. */
          creativityDecay?: number;
          layerDifference?: number;
          /** Scaling factor (when `targetWidth` not specified) */
          scalingFactor?: number;
          /** The type of the generator used */
          modelType?:
            | "custom"
            | "flux.1"
            | "flux.1-composition"
            | "flux.1-lora"
            | "flux.1-pro"
            | "flux.1.1-pro-ultra"
            | "flux1.1-pro"
            | "gpt-image-1"
            | "sd-1_5"
            | "sd-1_5-composition"
            | "sd-1_5-lora"
            | "sd-xl"
            | "sd-xl-composition"
            | "sd-xl-lora";
          /** The number of outputs to generate. */
          numOutputs?: number;
          /** How angular is the surface? 0 is like a sphere, 1 is like a mechanical object */
          angular?: number;
          /** The target height of the output image. */
          targetHeight?: number;
          /** Flux LoRa or Composition to style the image. */
          concepts?: {
            weightName: string;
            /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
            modelId: string;
            /** The scale of the model (example: 1.0) */
            scale: number;
          }[];
          size?: number;
          spliceThreshold?: number;
          /** The number of pixels to dilate the result masks. */
          dilate?: number;
          style?:
            | "3d-cartoon"
            | "3d-rendered"
            | "anime"
            | "cartoon"
            | "cinematic"
            | "claymation"
            | "cloud-skydome"
            | "comic"
            | "cyberpunk"
            | "enchanted"
            | "fantasy"
            | "ink"
            | "manga"
            | "manga-color"
            | "minimalist"
            | "neon-tron"
            | "oil-painting"
            | "pastel"
            | "photo"
            | "photography"
            | "psychedelic"
            | "retro-fantasy"
            | "scifi-concept-art"
            | "space"
            | "standard"
            | "whimsical";
          /** Strengthen the similarity to the original image during the upscale. Default: optimized for your preset and style. */
          imageFidelity?: number;
          /** Location of the input image in the output. */
          inputLocation?: "bottom" | "left" | "middle" | "right" | "top";
          /** The seed used to generate this asset */
          seed?: string;
          /** The higher the value the more it will look like the secondary reference image(s) */
          secondaryRefFidelity?: number;
          preset?: string;
          trainingImage?: boolean;
          /** Boolean to able return the masks (binary image) in the response. */
          resultMask?: boolean;
          /** The ISO timestamp when the lock on the canvas will expire */
          lockExpiresAt?: string;
          /** The baseModelId that maybe changed at inference time */
          baseModelId?: string;
          pathPrecision?: number;
          rootParentId?: string;
          /** Sharpen tiles. */
          sharpen?: boolean;
          cornerThreshold?: number;
          /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
          styleImages?: string[];
          /** The asset to convert in texture maps. Must reference an existing AssetId. */
          texture?: string;
          filterSpeckle?: number;
          /** Minimum threshold for Grayscale conversion */
          minThreshold?: number;
          /** Maximum threshold for Grayscale conversion */
          maxThreshold?: number;
          /** Condition the influence of the style image(s). The higher the value, the more the style images will influence the upscaled image. */
          styleImagesFidelity?: number;
          /** The control image processed by depth estimator. Must reference an existing AssetId. */
          depthImage?: string;
          parentId?: string;
          parentJobId?: string;
          /** Optional List of secondary style images. Example: portrait of people. It must be existing AssetIds. */
          secondaryRefImages?: string[];
          /** The width of the rendered image. */
          width?: number;
          /** The checkpoint to use */
          checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
          strength?: number;
          /** The id of the Inference describing how this image was generated */
          inferenceId?: string;
          lengthThreshold?: number;
          /** Int to set between 0 and 255 for the opacity of the background in the result images. */
          backgroundOpacity?: number;
          /** The optional aspect ratio given for the generation, only applicable for some models */
          aspectRatio?: string;
          /** Amount of details to remove or add */
          detailsLevel?: number;
          /** Determine the scale at which the upscale process works.
                - With a small value, the upscale works at the largest scale, resulting in fewer added details and more coherent images. Ideal for portraits, for example.
                - With a large value, the upscale works at the smallest scale, resulting in more added details and more hallucinations. Ideal for landscapes, for example.
                
                (info): A small value is slower and more expensive to run. */
          fractality?: number;
          /** (deprecated) Horizontal expansion ratio. */
          horizontalExpansionRatio?: number;
          /** List of points (label, x, y) in the image where label = 0 for background and 1 for object. */
          points?: any[][];
          mode?: string;
          colorPrecision?: number;
          /** Increase the fidelity to the prompt during upscale. Default: optimized for your preset and style. */
          promptFidelity?: number;
          /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
          betterQuality?: boolean;
          /** Remove background for Grayscale detector */
          removeBackground?: boolean;
          /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your preset and style. */
          creativity?: number;
          /** Strength for the input image structure preservation */
          structureFidelity?: number;
          /** Preserve the seamless properties of skybox or texture images. Input has to be of same type (seamless). */
          imageType?: "seamfull" | "skybox" | "texture";
          /** The input image to process. Must reference an existing AssetId or be a data URL. */
          image?: string;
          /** The thumbnail of the canvas */
          thumbnail?: {
            /** The AssetId of the image used as a thumbnail for the canvas (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
            assetId: string;
            /** The url of the image used as a thumbnail for the canvas */
            url: string;
          };
          /** The control image for structure. A canny detector will be applied to this image. Must reference an existing AssetId. */
          structureImage?: string;
          /** To invert the relief */
          invert?: boolean;
          kind: "3d" | "audio" | "document" | "image" | "json" | "video";
          colorMode?: string;
          /** High threshold for Canny detector */
          highThreshold?: number;
          /** (deprecated) Vertical expansion ratio. */
          verticalExpansionRatio?: number;
          halfMode?: boolean;
          name?: string;
          /** Additional refinement steps before scaling.
                
                If scalingFactor == 1, the refinement process will be applied (1 + refinementSteps) times.
                If scalingFactor > 1, the refinement process will be applied refinementSteps times. */
          refinementSteps?: number;
          /** The reference images used for the image generation or editing */
          referenceImages?: string[];
          /** The higher the value the more it will look like the style image(s) */
          styleFidelity?: number;
          /** Boolean to output the contours. */
          resultContours?: boolean;
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          polished?: number;
          /** The scheduler used to generate this asset */
          scheduler?: string;
          /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
          overrideEmbeddings?: boolean;
          progressPercent?: number;
          /** Contrast factor for Grayscale detector */
          factor?: number;
          /** The mask used for the image generation or editing */
          mask?: string;
          /** Low threshold for Canny detector */
          lowThreshold?: number;
          /** The depth fidelity if a depth image provided */
          depthFidelity?: number;
          /** How raised is the surface? 0 is flat like water, 1 is like a very rough rock */
          raised?: number;
          message?: string;
          contours?: number[][][][];
          /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
          negativePrompt?: string;
          /** If true, use the default parameters */
          defaultParameters?: boolean;
          /** Size proportion of the input image in the output. */
          resizeOption?: number;
          outputIndex?: number;
          /** Save a flipbook of the texture. Deactivated when the input texture is larger than 2048x2048px */
          saveFlipbook?: boolean;
          /** The guidance used to generate this asset */
          guidance?: number;
          /** The number of denoising steps for each image generation. */
          numInferenceSteps?: number;
          hdr?: number;
          /** How shiny is the surface? 0 is like a matte surface, 1 is like a diamond */
          shiny?: number;
          /** Ensure upscaled tile have the same color histogram as original tile. */
          colorCorrection?: boolean;
          /** Overlap percentage for the output image. */
          overlapPercentage?: number;
          /** The prompt that guided the image generation or editing */
          prompt?: string;
          /** Boolean to able output the cut out object. */
          resultImage?: boolean;
          /** The control image already processed by canny detector. Must reference an existing AssetId. */
          cannyStructureImage?: string;
          /** Apply extra control to the Skybox 360 geometry.
                The higher the value, the more the 360 geometry will influence the generated skybox image.
                
                Use with caution. Default is adapted to the other parameters. */
          geometryEnforcement?: number;
          /** Target width for the upscaled image, take priority over scaling factor */
          targetWidth?: number;
        };
        /** The NSFW labels */
        nsfw?: string[];
        /** Automatic captioning of the asset */
        automaticCaptioning?: string;
        /** The description of the asset */
        description?: string;
        /** The privacy of the asset */
        privacy: "private" | "public" | "unlisted";
        /** The date when the asset will be soft deleted (only for Free plan) */
        softDeletionOn?: string;
        /** The mime type of the asset (example: "image/png") */
        mimeType: string;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId: string;
        /** The owner (project) ID (example: "proj_23tlk332lkht3kl2" or "team_dlkhgs23tlk3hlkth32lkht3kl2" for old teams) */
        ownerId: string;
        /** Signed URL to get the asset content */
        url: string;
        /** The associated tags (example: ["sci-fi", "landscape"]) */
        tags: string[];
        /** The asset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The output index of the asset within the job
            This index is an positive integer that starts at 0
            It is used to differentiate between multiple outputs of the same job
            If the job has only one output, this index is 0
            This is only applicable for generations with: Flux, Skybox, Reframe at the moment */
        outputIndex?: number;
        /** A list of CollectionId this asset belongs to */
        collectionIds: string[];
        /** List of edit capabilities for the asset */
        editCapabilities: (
          | "DETECTION"
          | "GENERATIVE_FILL"
          | "PIXELATE"
          | "PROMPT_EDITING"
          | "REFINE"
          | "REFRAME"
          | "REMOVE_BACKGROUND"
          | "SEGMENTATION"
          | "UPSCALE"
          | "UPSCALE_360"
          | "VECTORIZATION"
        )[];
        /** The embedding of the asset when requested and asset can be embedded
            
            ie: Detection maps don't have embeddings */
        embedding?: number[];
        /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        id: string;
        /** The status of the asset */
        status: "error" | "pending" | "success";
        /** The asset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }[];
  };
export type PutModelsExamplesByModelIdApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The ID of the model to update its examples */
  modelId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** The list of asset ids to use as examples of the model */
    assetIds: string[];
  };
};
export type DeleteModelsImagesByModelIdApiResponse =
  /** status 200 200 response */ any;
export type DeleteModelsImagesByModelIdApiArg = {
  /** The modelId for which images will be deleted */
  modelId: string;
  /** The ids of the images to delete */
  ids: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
};
export type GetModelsInferencesByModelIdApiResponse =
  /** status 200 200 response */ {
    /** A token to query the next page of inferences */
    nextPaginationToken?: string;
    inferences: {
      /** The result images URLs (can change over time when inference is in progress) */
      images: {
        /** The seed used to generate this image */
        seed: string;
        /** The image ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        id: string;
        /** The image URL */
        url: string;
      }[];
      /** The model ID on which the inference was done (example: "model_GTrL3mq4SXWyMxkOHRxlpw") */
      modelId: string;
      /** The author user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
      authorId: string;
      /** The human-friendly prompt (without token) */
      displayPrompt: string;
      /** The owner user ID (example: "team_VFhihHKMRZyDDnZAJwLb2Q") */
      ownerId: string;
      /** (Deprecated) The user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
      userId: string;
      /** The inference creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** The inference progress (within [0, 1]) */
      progress?: number;
      /** The inference ID (example: "inf_GTrL3mq4SXWyMxkOHRxlpw") */
      id: string;
      /** The total number of result images */
      imagesNumber: number;
      /** The inference parameters */
      parameters: {
        /** Asset id of the input IpAdapter images */
        ipAdapterImageIds?: string[];
        /** If style_fidelity=1.0, control more important, else if style_fidelity=0.0, prompt more important, else balanced
            Only for "reference" inference type */
        styleFidelity?: number;
        /** Specifies how long the ControlNet guidance should be applied during the inference process.
            
            Only available for Flux.1-dev based models.
            
            The value represents the percentage of total inference steps where the ControlNet guidance is active.
            For example:
            - 1.0: ControlNet guidance is applied during all inference steps
            - 0.5: ControlNet guidance is only applied during the first half of inference steps
            
            Default values:
            - 0.5 for Canny modality
            - 0.6 for all other modalities */
        controlEnd?: number;
        /** The modality associated with the control image used for the generation: it can either be an object with a combination of maximum
            
            For models of SD1.5 family:
             - up to 3 modalities from `canny`, `pose`, `depth`, `lines`, `seg`, `scribble`, `lineart`, `normal-map`, `illusion`
             - or one of the following presets: `character`, `landscape`, `city`, `interior`.
            
            For models of the SDXL family:
             - up to 3 modalities from `canny`, `pose`, `depth`, `seg`, `illusion`, `scribble`
             - or one of the following presets: `character`, `landscape`.
            
            For models of the FLUX schnell or dev families:
            - one modality from: `canny`, `tile`, `depth`, `blur`, `pose`, `gray`, `low-quality`
            
            Optionally, you can associate a value to these modalities or presets. The value must be within `]0.0, 1.0]`.
            
            Examples:
            - `canny`
            - `depth:0.5,pose:1.0`
            - `canny:0.5,depth:0.5,lines:0.3`
            - `landscape`
            - `character:0.5`
            - `illusion:1`
            
            Note: if you use a value that is not supported by the model family, this will result in an error. */
        modality?:
          | "blur"
          | "canny"
          | "depth"
          | "gray"
          | "illusion"
          | "lineart"
          | "lines"
          | "low-quality"
          | "normal-map"
          | "pose"
          | "scribble"
          | "seg"
          | "sketch"
          | "tile";
        /** Used to reproduce previous results. Default: randomly generated number. */
        seed?: string;
        /** Controls the noise intensity introduced to the input image, where a value of 1.0 completely erases the original image's details. Available for img2img and inpainting. (within [0.01, 1.0], default: 0.75) */
        strength?: number;
        /** The type of IP Adapter model to use. Must be one of [`style`, `character`], default to `style`` */
        ipAdapterType?: "character" | "style";
        /** The aspect ratio of the generated images. Only used for the model flux.1.1-pro-ultra.
            The aspect ratio is a string formatted as "width:height" (example: "16:9"). */
        aspectRatio?:
          | "16:9"
          | "1:1"
          | "21:9"
          | "2:3"
          | "3:2"
          | "3:4"
          | "4:3"
          | "4:5"
          | "5:4"
          | "9:16"
          | "9:21";
        /** The type of inference to use. Example: txt2img, img2img, etc.
            
            Selecting the right type will condition the expected parameters.
            
            Note: if model.type is `sd-xl*` or `sd-1_5*`, when using the `"inpaint"` inference type, Scenario determines the best available `baseModel` for a given `modelId`: one of `["stable-diffusion-inpainting", "stable-diffusion-xl-1.0-inpainting-0.1"] will be used. */
        type:
          | "controlnet"
          | "controlnet_img2img"
          | "controlnet_inpaint"
          | "controlnet_inpaint_ip_adapter"
          | "controlnet_ip_adapter"
          | "controlnet_reference"
          | "controlnet_texture"
          | "img2img"
          | "img2img_ip_adapter"
          | "img2img_texture"
          | "inpaint"
          | "inpaint_ip_adapter"
          | "outpaint"
          | "reference"
          | "reference_texture"
          | "txt2img"
          | "txt2img_ip_adapter"
          | "txt2img_texture";
        /** Signed URL to display the IpAdapter image */
        ipAdapterImage?: string;
        /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
        scheduler?:
          | "DDIMScheduler"
          | "DDPMScheduler"
          | "DEISMultistepScheduler"
          | "DPMSolverMultistepScheduler"
          | "DPMSolverSinglestepScheduler"
          | "EulerAncestralDiscreteScheduler"
          | "EulerDiscreteScheduler"
          | "HeunDiscreteScheduler"
          | "KDPM2AncestralDiscreteScheduler"
          | "KDPM2DiscreteScheduler"
          | "LCMScheduler"
          | "LMSDiscreteScheduler"
          | "PNDMScheduler"
          | "TCDScheduler"
          | "UniPCMultistepScheduler";
        /** If set to true, the entire input image will likely change during inpainting. This results in faster inferences, but the output image will be harder to integrate if the input is just a small part of a larger image. */
        disableMerging?: boolean;
        /** If false, the process uses the given image to detect the modality.
            If true (default), the process will not try to detect the modality of the given image.
            
            For example:
            with `pose` modality and `false` value, the process will detect the pose of people in the given image
            with `depth` modality and `false` value, the process will detect the depth of the given image
            with `scribble` modality and `true`value, the process will use the given image as a scribble
            
            ⚠️ For models of the FLUX schnell or dev families, this parameter is ignored. The modality detection is always disabled. ⚠️ */
        disableModalityDetection?: boolean;
        /** Signed URL to display the IpAdapter images */
        ipAdapterImages?: string[];
        /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
            Allowed values are available in the model's attribute: `compliantModelIds` */
        baseModelId?: string;
        /** Specifies the starting point of the ControlNet guidance during the inference process.
            
            Only available for Flux.1-dev based models.
            
            The value represents the percentage of total inference steps where the ControlNet guidance starts.
            For example:
            - 0.0: ControlNet guidance starts at the beginning of the inference steps
            - 0.5: ControlNet guidance starts at the middle of the inference steps */
        controlStart?: number;
        /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
            If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
            If model.type is `sd-1_5`, the height must be within [64, 1024]
            If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        height?: number;
        /** Signed URL to display the mask image */
        mask?: string;
        /** Asset id of the controlnet input image */
        controlImageId?: string;
        /** Signed URL to display the input image */
        image?: string;
        /** Asset id of the input image */
        imageId?: string;
        /** Asset id of the input IpAdapter image */
        ipAdapterImageId?: string;
        /** IpAdapter scale factor (within [0.0, 1.0], default: 0.9). */
        ipAdapterScale?: number;
        /** If set, generated assets will be hidden and not returned in the list of images of the inference
            or when listing assets (default: false) */
        hideResults?: boolean;
        /** IpAdapter scale factors (within [0.0, 1.0], default: 0.9). */
        ipAdapterScales?: number[];
        /** Asset id of the mask image */
        maskId?: string;
        /** Whether to use reference adain
            Only for "reference" inference type */
        referenceAdain?: boolean;
        /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
        negativePrompt?: string;
        /** Enable or disable the intermediate images generation (default: false) */
        intermediateImages?: boolean;
        concepts?: {
          /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
          modelId: string;
          /** The scale of the model (example: 1.0) */
          scale: number;
        }[];
        /** Signed URL to display the controlnet input image */
        controlImage?: string;
        /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
        guidance?: number;
        /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
        numInferenceSteps?: number;
        /** The number of images to generate (within [1, 128], default: 4) */
        numSamples?: number;
        /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
            If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
            If model.type is `sd-1_5`, the width must be within [64, 1024]
            If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        width?: number;
        /** Whether to use reference query for self attention's context
            Only for "reference" inference type */
        referenceAttn?: boolean;
        /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
        prompt: string;
      };
      /** The generation queue information (for generations with the "queued" status) */
      queue?: {
        /** The approximate number of requests in the generation queue */
        approximateNumberOfRequests: number;
        /** The approximate position in the generation queue */
        approximatePosition: number;
      };
      /** The inference status */
      status:
        | "canceled"
        | "failed"
        | "in-progress"
        | "model-loading"
        | "new"
        | "queued"
        | "succeeded";
    }[];
  };
export type GetModelsInferencesByModelIdApiArg = {
  /** The modelId for which to get Images */
  modelId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The number of items to return in the response. The default value is 10, maximum value is 50, minimum value is 1 */
  pageSize?: string;
  /** A token you received in a previous request to query the next page of items */
  paginationToken?: string;
};
export type PostModelsInferencesByModelIdApiResponse =
  /** status 200 200 response */
  | {
      creativeUnitsCost?: number;
      inference: {
        /** The result images URLs (can change over time when inference is in progress) */
        images: {
          /** The seed used to generate this image */
          seed: string;
          /** The image ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
          id: string;
          /** The image URL */
          url: string;
        }[];
        /** The model ID on which the inference was done (example: "model_GTrL3mq4SXWyMxkOHRxlpw") */
        modelId: string;
        /** The author user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
        authorId: string;
        /** The human-friendly prompt (without token) */
        displayPrompt: string;
        /** The owner user ID (example: "team_VFhihHKMRZyDDnZAJwLb2Q") */
        ownerId: string;
        /** (Deprecated) The user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
        userId: string;
        /** The inference creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The inference progress (within [0, 1]) */
        progress?: number;
        /** The inference ID (example: "inf_GTrL3mq4SXWyMxkOHRxlpw") */
        id: string;
        /** The total number of result images */
        imagesNumber: number;
        /** The inference parameters */
        parameters: {
          /** Asset id of the input IpAdapter images */
          ipAdapterImageIds?: string[];
          /** If style_fidelity=1.0, control more important, else if style_fidelity=0.0, prompt more important, else balanced
            Only for "reference" inference type */
          styleFidelity?: number;
          /** Specifies how long the ControlNet guidance should be applied during the inference process.
            
            Only available for Flux.1-dev based models.
            
            The value represents the percentage of total inference steps where the ControlNet guidance is active.
            For example:
            - 1.0: ControlNet guidance is applied during all inference steps
            - 0.5: ControlNet guidance is only applied during the first half of inference steps
            
            Default values:
            - 0.5 for Canny modality
            - 0.6 for all other modalities */
          controlEnd?: number;
          /** The modality associated with the control image used for the generation: it can either be an object with a combination of maximum
            
            For models of SD1.5 family:
             - up to 3 modalities from `canny`, `pose`, `depth`, `lines`, `seg`, `scribble`, `lineart`, `normal-map`, `illusion`
             - or one of the following presets: `character`, `landscape`, `city`, `interior`.
            
            For models of the SDXL family:
             - up to 3 modalities from `canny`, `pose`, `depth`, `seg`, `illusion`, `scribble`
             - or one of the following presets: `character`, `landscape`.
            
            For models of the FLUX schnell or dev families:
            - one modality from: `canny`, `tile`, `depth`, `blur`, `pose`, `gray`, `low-quality`
            
            Optionally, you can associate a value to these modalities or presets. The value must be within `]0.0, 1.0]`.
            
            Examples:
            - `canny`
            - `depth:0.5,pose:1.0`
            - `canny:0.5,depth:0.5,lines:0.3`
            - `landscape`
            - `character:0.5`
            - `illusion:1`
            
            Note: if you use a value that is not supported by the model family, this will result in an error. */
          modality?:
            | "blur"
            | "canny"
            | "depth"
            | "gray"
            | "illusion"
            | "lineart"
            | "lines"
            | "low-quality"
            | "normal-map"
            | "pose"
            | "scribble"
            | "seg"
            | "sketch"
            | "tile";
          /** Used to reproduce previous results. Default: randomly generated number. */
          seed?: string;
          /** Controls the noise intensity introduced to the input image, where a value of 1.0 completely erases the original image's details. Available for img2img and inpainting. (within [0.01, 1.0], default: 0.75) */
          strength?: number;
          /** The type of IP Adapter model to use. Must be one of [`style`, `character`], default to `style`` */
          ipAdapterType?: "character" | "style";
          /** The aspect ratio of the generated images. Only used for the model flux.1.1-pro-ultra.
            The aspect ratio is a string formatted as "width:height" (example: "16:9"). */
          aspectRatio?:
            | "16:9"
            | "1:1"
            | "21:9"
            | "2:3"
            | "3:2"
            | "3:4"
            | "4:3"
            | "4:5"
            | "5:4"
            | "9:16"
            | "9:21";
          /** The type of inference to use. Example: txt2img, img2img, etc.
            
            Selecting the right type will condition the expected parameters.
            
            Note: if model.type is `sd-xl*` or `sd-1_5*`, when using the `"inpaint"` inference type, Scenario determines the best available `baseModel` for a given `modelId`: one of `["stable-diffusion-inpainting", "stable-diffusion-xl-1.0-inpainting-0.1"] will be used. */
          type:
            | "controlnet"
            | "controlnet_img2img"
            | "controlnet_inpaint"
            | "controlnet_inpaint_ip_adapter"
            | "controlnet_ip_adapter"
            | "controlnet_reference"
            | "controlnet_texture"
            | "img2img"
            | "img2img_ip_adapter"
            | "img2img_texture"
            | "inpaint"
            | "inpaint_ip_adapter"
            | "outpaint"
            | "reference"
            | "reference_texture"
            | "txt2img"
            | "txt2img_ip_adapter"
            | "txt2img_texture";
          /** Signed URL to display the IpAdapter image */
          ipAdapterImage?: string;
          /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
          scheduler?:
            | "DDIMScheduler"
            | "DDPMScheduler"
            | "DEISMultistepScheduler"
            | "DPMSolverMultistepScheduler"
            | "DPMSolverSinglestepScheduler"
            | "EulerAncestralDiscreteScheduler"
            | "EulerDiscreteScheduler"
            | "HeunDiscreteScheduler"
            | "KDPM2AncestralDiscreteScheduler"
            | "KDPM2DiscreteScheduler"
            | "LCMScheduler"
            | "LMSDiscreteScheduler"
            | "PNDMScheduler"
            | "TCDScheduler"
            | "UniPCMultistepScheduler";
          /** If set to true, the entire input image will likely change during inpainting. This results in faster inferences, but the output image will be harder to integrate if the input is just a small part of a larger image. */
          disableMerging?: boolean;
          /** If false, the process uses the given image to detect the modality.
            If true (default), the process will not try to detect the modality of the given image.
            
            For example:
            with `pose` modality and `false` value, the process will detect the pose of people in the given image
            with `depth` modality and `false` value, the process will detect the depth of the given image
            with `scribble` modality and `true`value, the process will use the given image as a scribble
            
            ⚠️ For models of the FLUX schnell or dev families, this parameter is ignored. The modality detection is always disabled. ⚠️ */
          disableModalityDetection?: boolean;
          /** Signed URL to display the IpAdapter images */
          ipAdapterImages?: string[];
          /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
            Allowed values are available in the model's attribute: `compliantModelIds` */
          baseModelId?: string;
          /** Specifies the starting point of the ControlNet guidance during the inference process.
            
            Only available for Flux.1-dev based models.
            
            The value represents the percentage of total inference steps where the ControlNet guidance starts.
            For example:
            - 0.0: ControlNet guidance starts at the beginning of the inference steps
            - 0.5: ControlNet guidance starts at the middle of the inference steps */
          controlStart?: number;
          /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
            If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
            If model.type is `sd-1_5`, the height must be within [64, 1024]
            If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
          height?: number;
          /** Signed URL to display the mask image */
          mask?: string;
          /** Asset id of the controlnet input image */
          controlImageId?: string;
          /** Signed URL to display the input image */
          image?: string;
          /** Asset id of the input image */
          imageId?: string;
          /** Asset id of the input IpAdapter image */
          ipAdapterImageId?: string;
          /** IpAdapter scale factor (within [0.0, 1.0], default: 0.9). */
          ipAdapterScale?: number;
          /** If set, generated assets will be hidden and not returned in the list of images of the inference
            or when listing assets (default: false) */
          hideResults?: boolean;
          /** IpAdapter scale factors (within [0.0, 1.0], default: 0.9). */
          ipAdapterScales?: number[];
          /** Asset id of the mask image */
          maskId?: string;
          /** Whether to use reference adain
            Only for "reference" inference type */
          referenceAdain?: boolean;
          /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
          negativePrompt?: string;
          /** Enable or disable the intermediate images generation (default: false) */
          intermediateImages?: boolean;
          concepts?: {
            /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
            modelId: string;
            /** The scale of the model (example: 1.0) */
            scale: number;
          }[];
          /** Signed URL to display the controlnet input image */
          controlImage?: string;
          /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
          guidance?: number;
          /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
          numInferenceSteps?: number;
          /** The number of images to generate (within [1, 128], default: 4) */
          numSamples?: number;
          /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
            If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
            If model.type is `sd-1_5`, the width must be within [64, 1024]
            If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
          width?: number;
          /** Whether to use reference query for self attention's context
            Only for "reference" inference type */
          referenceAttn?: boolean;
          /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
          prompt: string;
        };
        /** The generation queue information (for generations with the "queued" status) */
        queue?: {
          /** The approximate number of requests in the generation queue */
          approximateNumberOfRequests: number;
          /** The approximate position in the generation queue */
          approximatePosition: number;
        };
        /** The inference status */
        status:
          | "canceled"
          | "failed"
          | "in-progress"
          | "model-loading"
          | "new"
          | "queued"
          | "succeeded";
      };
      job: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PostModelsInferencesByModelIdApiArg = {
  /** The modelId used to generate new images */
  modelId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  dryRun?: string;
  body: {
    parameters: {
      /** The IpAdapter images as an AssetId. Will be ignored if the `ipAdapterImages` parameter is provided */
      ipAdapterImageIds?: string[];
      /** If style_fidelity=1.0, control more important, else if style_fidelity=0.0, prompt more important, else balanced
            Only for "reference" inference type */
      styleFidelity?: number;
      /** Specifies how long the ControlNet guidance should be applied during the inference process.
            
            Only available for Flux.1-dev based models.
            
            The value represents the percentage of total inference steps where the ControlNet guidance is active.
            For example:
            - 1.0: ControlNet guidance is applied during all inference steps
            - 0.5: ControlNet guidance is only applied during the first half of inference steps
            
            Default values:
            - 0.5 for Canny modality
            - 0.6 for all other modalities */
      controlEnd?: number;
      /** The modality associated with the control image used for the generation: it can either be an object with a combination of maximum
            
            For models of SD1.5 family:
             - up to 3 modalities from `canny`, `pose`, `depth`, `lines`, `seg`, `scribble`, `lineart`, `normal-map`, `illusion`
             - or one of the following presets: `character`, `landscape`, `city`, `interior`.
            
            For models of the SDXL family:
             - up to 3 modalities from `canny`, `pose`, `depth`, `seg`, `illusion`, `scribble`
             - or one of the following presets: `character`, `landscape`.
            
            For models of the FLUX schnell or dev families:
            - one modality from: `canny`, `tile`, `depth`, `blur`, `pose`, `gray`, `low-quality`
            
            Optionally, you can associate a value to these modalities or presets. The value must be within `]0.0, 1.0]`.
            
            Examples:
            - `canny`
            - `depth:0.5,pose:1.0`
            - `canny:0.5,depth:0.5,lines:0.3`
            - `landscape`
            - `character:0.5`
            - `illusion:1`
            
            Note: if you use a value that is not supported by the model family, this will result in an error. */
      modality?:
        | "blur"
        | "canny"
        | "depth"
        | "gray"
        | "illusion"
        | "lineart"
        | "lines"
        | "low-quality"
        | "normal-map"
        | "pose"
        | "scribble"
        | "seg"
        | "sketch"
        | "tile";
      /** Used to reproduce previous results. Default: randomly generated number. */
      seed?: string;
      /** Controls the noise intensity introduced to the input image, where a value of 1.0 completely erases the original image's details. Available for img2img and inpainting. (within [0.01, 1.0], default: 0.75) */
      strength?: number;
      /** The model id to use for the inference */
      modelId?: string;
      /** The type of IP Adapter model to use. Must be one of [`style`, `character`], default to `style`` */
      ipAdapterType?: "character" | "style";
      /** The aspect ratio of the generated images. Only used for the model flux.1.1-pro-ultra.
            The aspect ratio is a string formatted as "width:height" (example: "16:9"). */
      aspectRatio?:
        | "16:9"
        | "1:1"
        | "21:9"
        | "2:3"
        | "3:2"
        | "3:4"
        | "4:3"
        | "4:5"
        | "5:4"
        | "9:16"
        | "9:21";
      /** The type of inference to use. Example: txt2img, img2img, etc.
            
            Selecting the right type will condition the expected parameters.
            
            Note: if model.type is `sd-xl*` or `sd-1_5*`, when using the `"inpaint"` inference type, Scenario determines the best available `baseModel` for a given `modelId`: one of `["stable-diffusion-inpainting", "stable-diffusion-xl-1.0-inpainting-0.1"] will be used. */
      type:
        | "controlnet"
        | "controlnet_img2img"
        | "controlnet_inpaint"
        | "controlnet_inpaint_ip_adapter"
        | "controlnet_ip_adapter"
        | "controlnet_reference"
        | "controlnet_texture"
        | "img2img"
        | "img2img_ip_adapter"
        | "img2img_texture"
        | "inpaint"
        | "inpaint_ip_adapter"
        | "outpaint"
        | "reference"
        | "reference_texture"
        | "txt2img"
        | "txt2img_ip_adapter"
        | "txt2img_texture";
      /** Deprecated for type txt2img-ip-adapter and img2img-ip-adapter, use `ipAdapterImages` instead.
            The IpAdapter image as a data url. Will be ignored if the `ipAdapterImages` parameter is provided. */
      ipAdapterImage?: string;
      /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
      scheduler?:
        | "DDIMScheduler"
        | "DDPMScheduler"
        | "DEISMultistepScheduler"
        | "DPMSolverMultistepScheduler"
        | "DPMSolverSinglestepScheduler"
        | "EulerAncestralDiscreteScheduler"
        | "EulerDiscreteScheduler"
        | "HeunDiscreteScheduler"
        | "KDPM2AncestralDiscreteScheduler"
        | "KDPM2DiscreteScheduler"
        | "LCMScheduler"
        | "LMSDiscreteScheduler"
        | "PNDMScheduler"
        | "TCDScheduler"
        | "UniPCMultistepScheduler";
      /** If set to true, the entire input image will likely change during inpainting. This results in faster inferences, but the output image will be harder to integrate if the input is just a small part of a larger image. */
      disableMerging?: boolean;
      /** If false, the process uses the given image to detect the modality.
            If true (default), the process will not try to detect the modality of the given image.
            
            For example:
            with `pose` modality and `false` value, the process will detect the pose of people in the given image
            with `depth` modality and `false` value, the process will detect the depth of the given image
            with `scribble` modality and `true`value, the process will use the given image as a scribble
            
            ⚠️ For models of the FLUX schnell or dev families, this parameter is ignored. The modality detection is always disabled. ⚠️ */
      disableModalityDetection?: boolean;
      /** The IpAdapter images as a data url. */
      ipAdapterImages?: string[];
      /** Specifies the parent asset Id for the image when provided as a dataurl. */
      imageParentId?: string;
      /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
            Allowed values are available in the model's attribute: `compliantModelIds` */
      baseModelId?: string;
      /** Specifies the starting point of the ControlNet guidance during the inference process.
            
            Only available for Flux.1-dev based models.
            
            The value represents the percentage of total inference steps where the ControlNet guidance starts.
            For example:
            - 0.0: ControlNet guidance starts at the beginning of the inference steps
            - 0.5: ControlNet guidance starts at the middle of the inference steps */
      controlStart?: number;
      /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
            If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
            If model.type is `sd-1_5`, the height must be within [64, 1024]
            If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
      height?: number;
      /** Toggles the hidden status of the image when provided as a dataurl. */
      imageHide?: boolean;
      /** The mask as a data URL, used to determine the area of change. The mask is a binary mask made out of white and black pixels. The white area is the one that will be replaced. (example: "data:image/png;base64,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") */
      mask?: string;
      /** The controlnet input image as an AssetId. Will be ignored if the `controlnet` parameter is provided */
      controlImageId?: string;
      /** The input image as a data URL (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=") or the asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
      image?: string;
      /** Deprecated: The input image as an AssetId. Prefer to use image with the asset ID instead. */
      imageId?: string;
      /** Deprecated for type txt2img-ip-adapter and img2img-ip-adapter, use `ipAdapterImageIds` instead.
            The IpAdapter image as an AssetId. Cannot be set if `ipAdapterImage` is provided. Will be ignored if the `ipAdapterImageIds` parameter is provided. */
      ipAdapterImageId?: string;
      /** Deprecated for type txt2img-ip-adapter and img2img-ip-adapter, use `ipAdapterScales` instead.
            IpAdapter scale factor (within [0.0, 1.0], default: 0.9). Will be ignored if the `ipAdapterScales` parameter is provided */
      ipAdapterScale?: number;
      /** If set, generated assets will be hidden and not returned in the list of images of the inference
            or when listing assets (default: false) */
      hideResults?: boolean;
      /** IpAdapter scale factors (within [0.0, 1.0], default: 0.9). */
      ipAdapterScales?: number[];
      /** The mask as an AssetId. Will be ignored if the `image` parameter is provided */
      maskId?: string;
      /** Whether to use reference adain
            Only for "reference" inference type */
      referenceAdain?: boolean;
      /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
      negativePrompt?: string;
      /** Enable or disable the intermediate images generation (default: false) */
      intermediateImages?: boolean;
      concepts?: {
        /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
        modelId: string;
        /** The scale of the model (example: 1.0) */
        scale: number;
      }[];
      /** The controlnet input image as a data URL (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=") */
      controlImage?: string;
      /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
      guidance?: number;
      /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
      numInferenceSteps?: number;
      /** The number of images to generate (within [1, 128], default: 4) */
      numSamples?: number;
      /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
            If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
            If model.type is `sd-1_5`, the width must be within [64, 1024]
            If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
      width?: number;
      /** Whether to use reference query for self attention's context
            Only for "reference" inference type */
      referenceAttn?: boolean;
      /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
      prompt: string;
    };
  };
};
export type DeleteModelsInferencesByModelIdApiResponse =
  /** status 200 200 response */ any;
export type DeleteModelsInferencesByModelIdApiArg = {
  inferenceIds?: string;
  /** The modelId of the generated images to delete */
  modelId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
};
export type DeleteModelsInferencesAllByModelIdApiResponse =
  /** status 202 202 response */ any;
export type DeleteModelsInferencesAllByModelIdApiArg = {
  /** The modelId for which all inferences will be deleted */
  modelId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
};
export type GetModelsInferencesByModelIdAndInferenceIdApiResponse =
  /** status 200 200 response */ {
    inference: {
      /** The result images URLs (can change over time when inference is in progress) */
      images: {
        /** The seed used to generate this image */
        seed: string;
        /** The image ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        id: string;
        /** The image URL */
        url: string;
      }[];
      /** The model ID on which the inference was done (example: "model_GTrL3mq4SXWyMxkOHRxlpw") */
      modelId: string;
      /** The author user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
      authorId: string;
      /** The human-friendly prompt (without token) */
      displayPrompt: string;
      /** The owner user ID (example: "team_VFhihHKMRZyDDnZAJwLb2Q") */
      ownerId: string;
      /** (Deprecated) The user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
      userId: string;
      /** The inference creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** The inference progress (within [0, 1]) */
      progress?: number;
      /** The inference ID (example: "inf_GTrL3mq4SXWyMxkOHRxlpw") */
      id: string;
      /** The total number of result images */
      imagesNumber: number;
      /** The inference parameters */
      parameters: {
        /** Asset id of the input IpAdapter images */
        ipAdapterImageIds?: string[];
        /** If style_fidelity=1.0, control more important, else if style_fidelity=0.0, prompt more important, else balanced
            Only for "reference" inference type */
        styleFidelity?: number;
        /** Specifies how long the ControlNet guidance should be applied during the inference process.
            
            Only available for Flux.1-dev based models.
            
            The value represents the percentage of total inference steps where the ControlNet guidance is active.
            For example:
            - 1.0: ControlNet guidance is applied during all inference steps
            - 0.5: ControlNet guidance is only applied during the first half of inference steps
            
            Default values:
            - 0.5 for Canny modality
            - 0.6 for all other modalities */
        controlEnd?: number;
        /** The modality associated with the control image used for the generation: it can either be an object with a combination of maximum
            
            For models of SD1.5 family:
             - up to 3 modalities from `canny`, `pose`, `depth`, `lines`, `seg`, `scribble`, `lineart`, `normal-map`, `illusion`
             - or one of the following presets: `character`, `landscape`, `city`, `interior`.
            
            For models of the SDXL family:
             - up to 3 modalities from `canny`, `pose`, `depth`, `seg`, `illusion`, `scribble`
             - or one of the following presets: `character`, `landscape`.
            
            For models of the FLUX schnell or dev families:
            - one modality from: `canny`, `tile`, `depth`, `blur`, `pose`, `gray`, `low-quality`
            
            Optionally, you can associate a value to these modalities or presets. The value must be within `]0.0, 1.0]`.
            
            Examples:
            - `canny`
            - `depth:0.5,pose:1.0`
            - `canny:0.5,depth:0.5,lines:0.3`
            - `landscape`
            - `character:0.5`
            - `illusion:1`
            
            Note: if you use a value that is not supported by the model family, this will result in an error. */
        modality?:
          | "blur"
          | "canny"
          | "depth"
          | "gray"
          | "illusion"
          | "lineart"
          | "lines"
          | "low-quality"
          | "normal-map"
          | "pose"
          | "scribble"
          | "seg"
          | "sketch"
          | "tile";
        /** Used to reproduce previous results. Default: randomly generated number. */
        seed?: string;
        /** Controls the noise intensity introduced to the input image, where a value of 1.0 completely erases the original image's details. Available for img2img and inpainting. (within [0.01, 1.0], default: 0.75) */
        strength?: number;
        /** The type of IP Adapter model to use. Must be one of [`style`, `character`], default to `style`` */
        ipAdapterType?: "character" | "style";
        /** The aspect ratio of the generated images. Only used for the model flux.1.1-pro-ultra.
            The aspect ratio is a string formatted as "width:height" (example: "16:9"). */
        aspectRatio?:
          | "16:9"
          | "1:1"
          | "21:9"
          | "2:3"
          | "3:2"
          | "3:4"
          | "4:3"
          | "4:5"
          | "5:4"
          | "9:16"
          | "9:21";
        /** The type of inference to use. Example: txt2img, img2img, etc.
            
            Selecting the right type will condition the expected parameters.
            
            Note: if model.type is `sd-xl*` or `sd-1_5*`, when using the `"inpaint"` inference type, Scenario determines the best available `baseModel` for a given `modelId`: one of `["stable-diffusion-inpainting", "stable-diffusion-xl-1.0-inpainting-0.1"] will be used. */
        type:
          | "controlnet"
          | "controlnet_img2img"
          | "controlnet_inpaint"
          | "controlnet_inpaint_ip_adapter"
          | "controlnet_ip_adapter"
          | "controlnet_reference"
          | "controlnet_texture"
          | "img2img"
          | "img2img_ip_adapter"
          | "img2img_texture"
          | "inpaint"
          | "inpaint_ip_adapter"
          | "outpaint"
          | "reference"
          | "reference_texture"
          | "txt2img"
          | "txt2img_ip_adapter"
          | "txt2img_texture";
        /** Signed URL to display the IpAdapter image */
        ipAdapterImage?: string;
        /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
        scheduler?:
          | "DDIMScheduler"
          | "DDPMScheduler"
          | "DEISMultistepScheduler"
          | "DPMSolverMultistepScheduler"
          | "DPMSolverSinglestepScheduler"
          | "EulerAncestralDiscreteScheduler"
          | "EulerDiscreteScheduler"
          | "HeunDiscreteScheduler"
          | "KDPM2AncestralDiscreteScheduler"
          | "KDPM2DiscreteScheduler"
          | "LCMScheduler"
          | "LMSDiscreteScheduler"
          | "PNDMScheduler"
          | "TCDScheduler"
          | "UniPCMultistepScheduler";
        /** If set to true, the entire input image will likely change during inpainting. This results in faster inferences, but the output image will be harder to integrate if the input is just a small part of a larger image. */
        disableMerging?: boolean;
        /** If false, the process uses the given image to detect the modality.
            If true (default), the process will not try to detect the modality of the given image.
            
            For example:
            with `pose` modality and `false` value, the process will detect the pose of people in the given image
            with `depth` modality and `false` value, the process will detect the depth of the given image
            with `scribble` modality and `true`value, the process will use the given image as a scribble
            
            ⚠️ For models of the FLUX schnell or dev families, this parameter is ignored. The modality detection is always disabled. ⚠️ */
        disableModalityDetection?: boolean;
        /** Signed URL to display the IpAdapter images */
        ipAdapterImages?: string[];
        /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
            Allowed values are available in the model's attribute: `compliantModelIds` */
        baseModelId?: string;
        /** Specifies the starting point of the ControlNet guidance during the inference process.
            
            Only available for Flux.1-dev based models.
            
            The value represents the percentage of total inference steps where the ControlNet guidance starts.
            For example:
            - 0.0: ControlNet guidance starts at the beginning of the inference steps
            - 0.5: ControlNet guidance starts at the middle of the inference steps */
        controlStart?: number;
        /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
            If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
            If model.type is `sd-1_5`, the height must be within [64, 1024]
            If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        height?: number;
        /** Signed URL to display the mask image */
        mask?: string;
        /** Asset id of the controlnet input image */
        controlImageId?: string;
        /** Signed URL to display the input image */
        image?: string;
        /** Asset id of the input image */
        imageId?: string;
        /** Asset id of the input IpAdapter image */
        ipAdapterImageId?: string;
        /** IpAdapter scale factor (within [0.0, 1.0], default: 0.9). */
        ipAdapterScale?: number;
        /** If set, generated assets will be hidden and not returned in the list of images of the inference
            or when listing assets (default: false) */
        hideResults?: boolean;
        /** IpAdapter scale factors (within [0.0, 1.0], default: 0.9). */
        ipAdapterScales?: number[];
        /** Asset id of the mask image */
        maskId?: string;
        /** Whether to use reference adain
            Only for "reference" inference type */
        referenceAdain?: boolean;
        /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
        negativePrompt?: string;
        /** Enable or disable the intermediate images generation (default: false) */
        intermediateImages?: boolean;
        concepts?: {
          /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
          modelId: string;
          /** The scale of the model (example: 1.0) */
          scale: number;
        }[];
        /** Signed URL to display the controlnet input image */
        controlImage?: string;
        /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
        guidance?: number;
        /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
        numInferenceSteps?: number;
        /** The number of images to generate (within [1, 128], default: 4) */
        numSamples?: number;
        /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
            If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
            If model.type is `sd-1_5`, the width must be within [64, 1024]
            If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        width?: number;
        /** Whether to use reference query for self attention's context
            Only for "reference" inference type */
        referenceAttn?: boolean;
        /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
        prompt: string;
      };
      /** The generation queue information (for generations with the "queued" status) */
      queue?: {
        /** The approximate number of requests in the generation queue */
        approximateNumberOfRequests: number;
        /** The approximate position in the generation queue */
        approximatePosition: number;
      };
      /** The inference status */
      status:
        | "canceled"
        | "failed"
        | "in-progress"
        | "model-loading"
        | "new"
        | "queued"
        | "succeeded";
    };
  };
export type GetModelsInferencesByModelIdAndInferenceIdApiArg = {
  /** The inferenceId to retrieve */
  inferenceId: string;
  /** The modelId for that inferenceId */
  modelId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
};
export type DeleteModelsInferencesByModelIdAndInferenceIdApiResponse =
  /** status 200 200 response */ any;
export type DeleteModelsInferencesByModelIdAndInferenceIdApiArg = {
  /** The inferenceId to delete */
  inferenceId: string;
  /** The modelId for that inferenceId */
  modelId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
};
export type PostModelsInferencesActionByModelIdAndInferenceIdApiResponse =
  /** status 200 200 response */ {
    inference: {
      /** The result images URLs (can change over time when inference is in progress) */
      images: {
        /** The seed used to generate this image */
        seed: string;
        /** The image ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        id: string;
        /** The image URL */
        url: string;
      }[];
      /** The model ID on which the inference was done (example: "model_GTrL3mq4SXWyMxkOHRxlpw") */
      modelId: string;
      /** The author user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
      authorId: string;
      /** The human-friendly prompt (without token) */
      displayPrompt: string;
      /** The owner user ID (example: "team_VFhihHKMRZyDDnZAJwLb2Q") */
      ownerId: string;
      /** (Deprecated) The user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
      userId: string;
      /** The inference creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** The inference progress (within [0, 1]) */
      progress?: number;
      /** The inference ID (example: "inf_GTrL3mq4SXWyMxkOHRxlpw") */
      id: string;
      /** The total number of result images */
      imagesNumber: number;
      /** The inference parameters */
      parameters: {
        /** Asset id of the input IpAdapter images */
        ipAdapterImageIds?: string[];
        /** If style_fidelity=1.0, control more important, else if style_fidelity=0.0, prompt more important, else balanced
            Only for "reference" inference type */
        styleFidelity?: number;
        /** Specifies how long the ControlNet guidance should be applied during the inference process.
            
            Only available for Flux.1-dev based models.
            
            The value represents the percentage of total inference steps where the ControlNet guidance is active.
            For example:
            - 1.0: ControlNet guidance is applied during all inference steps
            - 0.5: ControlNet guidance is only applied during the first half of inference steps
            
            Default values:
            - 0.5 for Canny modality
            - 0.6 for all other modalities */
        controlEnd?: number;
        /** The modality associated with the control image used for the generation: it can either be an object with a combination of maximum
            
            For models of SD1.5 family:
             - up to 3 modalities from `canny`, `pose`, `depth`, `lines`, `seg`, `scribble`, `lineart`, `normal-map`, `illusion`
             - or one of the following presets: `character`, `landscape`, `city`, `interior`.
            
            For models of the SDXL family:
             - up to 3 modalities from `canny`, `pose`, `depth`, `seg`, `illusion`, `scribble`
             - or one of the following presets: `character`, `landscape`.
            
            For models of the FLUX schnell or dev families:
            - one modality from: `canny`, `tile`, `depth`, `blur`, `pose`, `gray`, `low-quality`
            
            Optionally, you can associate a value to these modalities or presets. The value must be within `]0.0, 1.0]`.
            
            Examples:
            - `canny`
            - `depth:0.5,pose:1.0`
            - `canny:0.5,depth:0.5,lines:0.3`
            - `landscape`
            - `character:0.5`
            - `illusion:1`
            
            Note: if you use a value that is not supported by the model family, this will result in an error. */
        modality?:
          | "blur"
          | "canny"
          | "depth"
          | "gray"
          | "illusion"
          | "lineart"
          | "lines"
          | "low-quality"
          | "normal-map"
          | "pose"
          | "scribble"
          | "seg"
          | "sketch"
          | "tile";
        /** Used to reproduce previous results. Default: randomly generated number. */
        seed?: string;
        /** Controls the noise intensity introduced to the input image, where a value of 1.0 completely erases the original image's details. Available for img2img and inpainting. (within [0.01, 1.0], default: 0.75) */
        strength?: number;
        /** The type of IP Adapter model to use. Must be one of [`style`, `character`], default to `style`` */
        ipAdapterType?: "character" | "style";
        /** The aspect ratio of the generated images. Only used for the model flux.1.1-pro-ultra.
            The aspect ratio is a string formatted as "width:height" (example: "16:9"). */
        aspectRatio?:
          | "16:9"
          | "1:1"
          | "21:9"
          | "2:3"
          | "3:2"
          | "3:4"
          | "4:3"
          | "4:5"
          | "5:4"
          | "9:16"
          | "9:21";
        /** The type of inference to use. Example: txt2img, img2img, etc.
            
            Selecting the right type will condition the expected parameters.
            
            Note: if model.type is `sd-xl*` or `sd-1_5*`, when using the `"inpaint"` inference type, Scenario determines the best available `baseModel` for a given `modelId`: one of `["stable-diffusion-inpainting", "stable-diffusion-xl-1.0-inpainting-0.1"] will be used. */
        type:
          | "controlnet"
          | "controlnet_img2img"
          | "controlnet_inpaint"
          | "controlnet_inpaint_ip_adapter"
          | "controlnet_ip_adapter"
          | "controlnet_reference"
          | "controlnet_texture"
          | "img2img"
          | "img2img_ip_adapter"
          | "img2img_texture"
          | "inpaint"
          | "inpaint_ip_adapter"
          | "outpaint"
          | "reference"
          | "reference_texture"
          | "txt2img"
          | "txt2img_ip_adapter"
          | "txt2img_texture";
        /** Signed URL to display the IpAdapter image */
        ipAdapterImage?: string;
        /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
        scheduler?:
          | "DDIMScheduler"
          | "DDPMScheduler"
          | "DEISMultistepScheduler"
          | "DPMSolverMultistepScheduler"
          | "DPMSolverSinglestepScheduler"
          | "EulerAncestralDiscreteScheduler"
          | "EulerDiscreteScheduler"
          | "HeunDiscreteScheduler"
          | "KDPM2AncestralDiscreteScheduler"
          | "KDPM2DiscreteScheduler"
          | "LCMScheduler"
          | "LMSDiscreteScheduler"
          | "PNDMScheduler"
          | "TCDScheduler"
          | "UniPCMultistepScheduler";
        /** If set to true, the entire input image will likely change during inpainting. This results in faster inferences, but the output image will be harder to integrate if the input is just a small part of a larger image. */
        disableMerging?: boolean;
        /** If false, the process uses the given image to detect the modality.
            If true (default), the process will not try to detect the modality of the given image.
            
            For example:
            with `pose` modality and `false` value, the process will detect the pose of people in the given image
            with `depth` modality and `false` value, the process will detect the depth of the given image
            with `scribble` modality and `true`value, the process will use the given image as a scribble
            
            ⚠️ For models of the FLUX schnell or dev families, this parameter is ignored. The modality detection is always disabled. ⚠️ */
        disableModalityDetection?: boolean;
        /** Signed URL to display the IpAdapter images */
        ipAdapterImages?: string[];
        /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
            Allowed values are available in the model's attribute: `compliantModelIds` */
        baseModelId?: string;
        /** Specifies the starting point of the ControlNet guidance during the inference process.
            
            Only available for Flux.1-dev based models.
            
            The value represents the percentage of total inference steps where the ControlNet guidance starts.
            For example:
            - 0.0: ControlNet guidance starts at the beginning of the inference steps
            - 0.5: ControlNet guidance starts at the middle of the inference steps */
        controlStart?: number;
        /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
            If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
            If model.type is `sd-1_5`, the height must be within [64, 1024]
            If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        height?: number;
        /** Signed URL to display the mask image */
        mask?: string;
        /** Asset id of the controlnet input image */
        controlImageId?: string;
        /** Signed URL to display the input image */
        image?: string;
        /** Asset id of the input image */
        imageId?: string;
        /** Asset id of the input IpAdapter image */
        ipAdapterImageId?: string;
        /** IpAdapter scale factor (within [0.0, 1.0], default: 0.9). */
        ipAdapterScale?: number;
        /** If set, generated assets will be hidden and not returned in the list of images of the inference
            or when listing assets (default: false) */
        hideResults?: boolean;
        /** IpAdapter scale factors (within [0.0, 1.0], default: 0.9). */
        ipAdapterScales?: number[];
        /** Asset id of the mask image */
        maskId?: string;
        /** Whether to use reference adain
            Only for "reference" inference type */
        referenceAdain?: boolean;
        /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
        negativePrompt?: string;
        /** Enable or disable the intermediate images generation (default: false) */
        intermediateImages?: boolean;
        concepts?: {
          /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
          modelId: string;
          /** The scale of the model (example: 1.0) */
          scale: number;
        }[];
        /** Signed URL to display the controlnet input image */
        controlImage?: string;
        /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
        guidance?: number;
        /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
        numInferenceSteps?: number;
        /** The number of images to generate (within [1, 128], default: 4) */
        numSamples?: number;
        /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
            If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
            If model.type is `sd-1_5`, the width must be within [64, 1024]
            If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        width?: number;
        /** Whether to use reference query for self attention's context
            Only for "reference" inference type */
        referenceAttn?: boolean;
        /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
        prompt: string;
      };
      /** The generation queue information (for generations with the "queued" status) */
      queue?: {
        /** The approximate number of requests in the generation queue */
        approximateNumberOfRequests: number;
        /** The approximate position in the generation queue */
        approximatePosition: number;
      };
      /** The inference status */
      status:
        | "canceled"
        | "failed"
        | "in-progress"
        | "model-loading"
        | "new"
        | "queued"
        | "succeeded";
    };
  };
export type PostModelsInferencesActionByModelIdAndInferenceIdApiArg = {
  /** The inferenceId to delete */
  inferenceId: string;
  /** The modelId for that inferenceId */
  modelId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** The action to execute on the inference, such as canceling it */
    action?: "cancel";
  };
};
export type GetModelsInferencesImagesByModelIdAndInferenceIdAndImageIdApiResponse =
  /** status 200 200 response */ {
    image: {
      /** The seed used to generate this image */
      seed: string;
      /** The image ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
      id: string;
      /** The image URL */
      url: string;
    };
  };
export type GetModelsInferencesImagesByModelIdAndInferenceIdAndImageIdApiArg = {
  /** The inferenceId for that imageId */
  inferenceId: string;
  /** The modelId for that inferenceId */
  modelId: string;
  /** The imageId to retrieve */
  imageId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
};
export type DeleteModelsInferencesImagesByModelIdAndInferenceIdAndImageIdApiResponse =
  /** status 200 200 response */ any;
export type DeleteModelsInferencesImagesByModelIdAndInferenceIdAndImageIdApiArg =
  {
    /** The inferenceId for that imageId */
    inferenceId: string;
    /** The modelId for that inferenceId */
    modelId: string;
    /** The imageId to delete */
    imageId: string;
    /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
    projectId: string;
  };
export type GetModelPresetsByModelIdApiResponse =
  /** status 200 200 response */ {
    presets: {
      /** The preset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** Whether the preset is the default preset of the model (example: true) */
      isDefault: boolean;
      /** The model ID (example: "eyVcnFJcR92BxBkz7N6g5w") */
      modelId: string;
      /** The preset ID (example: "eyVcnFJcR92BxBkz7N6g5w") */
      id: string;
      /** The author user ID (example: "VFhihHKMRZyDDnZAJwLb2Q") */
      authorId: string;
      /** The owner ID (example: "VFhihHKMRZyDDnZAJwLb2Q") */
      ownerId: string;
      /** The inference parameters */
      parameters: {
        /** Asset id of the input IpAdapter images */
        ipAdapterImageIds?: string[];
        /** If style_fidelity=1.0, control more important, else if style_fidelity=0.0, prompt more important, else balanced
            Only for "reference" inference type */
        styleFidelity?: number;
        /** Specifies how long the ControlNet guidance should be applied during the inference process.
            
            Only available for Flux.1-dev based models.
            
            The value represents the percentage of total inference steps where the ControlNet guidance is active.
            For example:
            - 1.0: ControlNet guidance is applied during all inference steps
            - 0.5: ControlNet guidance is only applied during the first half of inference steps
            
            Default values:
            - 0.5 for Canny modality
            - 0.6 for all other modalities */
        controlEnd?: number;
        /** The modality associated with the control image used for the generation: it can either be an object with a combination of maximum
            
            For models of SD1.5 family:
             - up to 3 modalities from `canny`, `pose`, `depth`, `lines`, `seg`, `scribble`, `lineart`, `normal-map`, `illusion`
             - or one of the following presets: `character`, `landscape`, `city`, `interior`.
            
            For models of the SDXL family:
             - up to 3 modalities from `canny`, `pose`, `depth`, `seg`, `illusion`, `scribble`
             - or one of the following presets: `character`, `landscape`.
            
            For models of the FLUX schnell or dev families:
            - one modality from: `canny`, `tile`, `depth`, `blur`, `pose`, `gray`, `low-quality`
            
            Optionally, you can associate a value to these modalities or presets. The value must be within `]0.0, 1.0]`.
            
            Examples:
            - `canny`
            - `depth:0.5,pose:1.0`
            - `canny:0.5,depth:0.5,lines:0.3`
            - `landscape`
            - `character:0.5`
            - `illusion:1`
            
            Note: if you use a value that is not supported by the model family, this will result in an error. */
        modality?:
          | "blur"
          | "canny"
          | "depth"
          | "gray"
          | "illusion"
          | "lineart"
          | "lines"
          | "low-quality"
          | "normal-map"
          | "pose"
          | "scribble"
          | "seg"
          | "sketch"
          | "tile";
        /** Used to reproduce previous results. Default: randomly generated number. */
        seed?: string;
        /** Controls the noise intensity introduced to the input image, where a value of 1.0 completely erases the original image's details. Available for img2img and inpainting. (within [0.01, 1.0], default: 0.75) */
        strength?: number;
        /** The type of IP Adapter model to use. Must be one of [`style`, `character`], default to `style`` */
        ipAdapterType?: "character" | "style";
        /** The aspect ratio of the generated images. Only used for the model flux.1.1-pro-ultra.
            The aspect ratio is a string formatted as "width:height" (example: "16:9"). */
        aspectRatio?:
          | "16:9"
          | "1:1"
          | "21:9"
          | "2:3"
          | "3:2"
          | "3:4"
          | "4:3"
          | "4:5"
          | "5:4"
          | "9:16"
          | "9:21";
        /** The type of inference to use. Example: txt2img, img2img, etc.
            
            Selecting the right type will condition the expected parameters.
            
            Note: if model.type is `sd-xl*` or `sd-1_5*`, when using the `"inpaint"` inference type, Scenario determines the best available `baseModel` for a given `modelId`: one of `["stable-diffusion-inpainting", "stable-diffusion-xl-1.0-inpainting-0.1"] will be used. */
        type:
          | "controlnet"
          | "controlnet_img2img"
          | "controlnet_inpaint"
          | "controlnet_inpaint_ip_adapter"
          | "controlnet_ip_adapter"
          | "controlnet_reference"
          | "controlnet_texture"
          | "img2img"
          | "img2img_ip_adapter"
          | "img2img_texture"
          | "inpaint"
          | "inpaint_ip_adapter"
          | "outpaint"
          | "reference"
          | "reference_texture"
          | "txt2img"
          | "txt2img_ip_adapter"
          | "txt2img_texture";
        /** Signed URL to display the IpAdapter image */
        ipAdapterImage?: string;
        /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
        scheduler?:
          | "DDIMScheduler"
          | "DDPMScheduler"
          | "DEISMultistepScheduler"
          | "DPMSolverMultistepScheduler"
          | "DPMSolverSinglestepScheduler"
          | "EulerAncestralDiscreteScheduler"
          | "EulerDiscreteScheduler"
          | "HeunDiscreteScheduler"
          | "KDPM2AncestralDiscreteScheduler"
          | "KDPM2DiscreteScheduler"
          | "LCMScheduler"
          | "LMSDiscreteScheduler"
          | "PNDMScheduler"
          | "TCDScheduler"
          | "UniPCMultistepScheduler";
        /** If set to true, the entire input image will likely change during inpainting. This results in faster inferences, but the output image will be harder to integrate if the input is just a small part of a larger image. */
        disableMerging?: boolean;
        /** If false, the process uses the given image to detect the modality.
            If true (default), the process will not try to detect the modality of the given image.
            
            For example:
            with `pose` modality and `false` value, the process will detect the pose of people in the given image
            with `depth` modality and `false` value, the process will detect the depth of the given image
            with `scribble` modality and `true`value, the process will use the given image as a scribble
            
            ⚠️ For models of the FLUX schnell or dev families, this parameter is ignored. The modality detection is always disabled. ⚠️ */
        disableModalityDetection?: boolean;
        /** Signed URL to display the IpAdapter images */
        ipAdapterImages?: string[];
        /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
            Allowed values are available in the model's attribute: `compliantModelIds` */
        baseModelId?: string;
        /** Specifies the starting point of the ControlNet guidance during the inference process.
            
            Only available for Flux.1-dev based models.
            
            The value represents the percentage of total inference steps where the ControlNet guidance starts.
            For example:
            - 0.0: ControlNet guidance starts at the beginning of the inference steps
            - 0.5: ControlNet guidance starts at the middle of the inference steps */
        controlStart?: number;
        /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
            If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
            If model.type is `sd-1_5`, the height must be within [64, 1024]
            If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        height?: number;
        /** Signed URL to display the mask image */
        mask?: string;
        /** Asset id of the controlnet input image */
        controlImageId?: string;
        /** Signed URL to display the input image */
        image?: string;
        /** Asset id of the input image */
        imageId?: string;
        /** Asset id of the input IpAdapter image */
        ipAdapterImageId?: string;
        /** IpAdapter scale factor (within [0.0, 1.0], default: 0.9). */
        ipAdapterScale?: number;
        /** If set, generated assets will be hidden and not returned in the list of images of the inference
            or when listing assets (default: false) */
        hideResults?: boolean;
        /** IpAdapter scale factors (within [0.0, 1.0], default: 0.9). */
        ipAdapterScales?: number[];
        /** Asset id of the mask image */
        maskId?: string;
        /** Whether to use reference adain
            Only for "reference" inference type */
        referenceAdain?: boolean;
        /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
        negativePrompt?: string;
        /** Enable or disable the intermediate images generation (default: false) */
        intermediateImages?: boolean;
        concepts?: {
          /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
          modelId: string;
          /** The scale of the model (example: 1.0) */
          scale: number;
        }[];
        /** Signed URL to display the controlnet input image */
        controlImage?: string;
        /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
        guidance?: number;
        /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
        numInferenceSteps?: number;
        /** The number of images to generate (within [1, 128], default: 4) */
        numSamples?: number;
        /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
            If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
            If model.type is `sd-1_5`, the width must be within [64, 1024]
            If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        width?: number;
        /** Whether to use reference query for self attention's context
            Only for "reference" inference type */
        referenceAttn?: boolean;
        /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
        prompt: string;
      };
      /** The preset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      updatedAt: string;
    }[];
  };
export type GetModelPresetsByModelIdApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The modelId of the presets */
  modelId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
};
export type PostModelPresetByModelIdApiResponse =
  /** status 200 200 response */ {
    preset: {
      /** The preset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** Whether the preset is the default preset of the model (example: true) */
      isDefault: boolean;
      /** The model ID (example: "eyVcnFJcR92BxBkz7N6g5w") */
      modelId: string;
      /** The preset ID (example: "eyVcnFJcR92BxBkz7N6g5w") */
      id: string;
      /** The author user ID (example: "VFhihHKMRZyDDnZAJwLb2Q") */
      authorId: string;
      /** The owner ID (example: "VFhihHKMRZyDDnZAJwLb2Q") */
      ownerId: string;
      /** The inference parameters */
      parameters: {
        /** Asset id of the input IpAdapter images */
        ipAdapterImageIds?: string[];
        /** If style_fidelity=1.0, control more important, else if style_fidelity=0.0, prompt more important, else balanced
            Only for "reference" inference type */
        styleFidelity?: number;
        /** Specifies how long the ControlNet guidance should be applied during the inference process.
            
            Only available for Flux.1-dev based models.
            
            The value represents the percentage of total inference steps where the ControlNet guidance is active.
            For example:
            - 1.0: ControlNet guidance is applied during all inference steps
            - 0.5: ControlNet guidance is only applied during the first half of inference steps
            
            Default values:
            - 0.5 for Canny modality
            - 0.6 for all other modalities */
        controlEnd?: number;
        /** The modality associated with the control image used for the generation: it can either be an object with a combination of maximum
            
            For models of SD1.5 family:
             - up to 3 modalities from `canny`, `pose`, `depth`, `lines`, `seg`, `scribble`, `lineart`, `normal-map`, `illusion`
             - or one of the following presets: `character`, `landscape`, `city`, `interior`.
            
            For models of the SDXL family:
             - up to 3 modalities from `canny`, `pose`, `depth`, `seg`, `illusion`, `scribble`
             - or one of the following presets: `character`, `landscape`.
            
            For models of the FLUX schnell or dev families:
            - one modality from: `canny`, `tile`, `depth`, `blur`, `pose`, `gray`, `low-quality`
            
            Optionally, you can associate a value to these modalities or presets. The value must be within `]0.0, 1.0]`.
            
            Examples:
            - `canny`
            - `depth:0.5,pose:1.0`
            - `canny:0.5,depth:0.5,lines:0.3`
            - `landscape`
            - `character:0.5`
            - `illusion:1`
            
            Note: if you use a value that is not supported by the model family, this will result in an error. */
        modality?:
          | "blur"
          | "canny"
          | "depth"
          | "gray"
          | "illusion"
          | "lineart"
          | "lines"
          | "low-quality"
          | "normal-map"
          | "pose"
          | "scribble"
          | "seg"
          | "sketch"
          | "tile";
        /** Used to reproduce previous results. Default: randomly generated number. */
        seed?: string;
        /** Controls the noise intensity introduced to the input image, where a value of 1.0 completely erases the original image's details. Available for img2img and inpainting. (within [0.01, 1.0], default: 0.75) */
        strength?: number;
        /** The type of IP Adapter model to use. Must be one of [`style`, `character`], default to `style`` */
        ipAdapterType?: "character" | "style";
        /** The aspect ratio of the generated images. Only used for the model flux.1.1-pro-ultra.
            The aspect ratio is a string formatted as "width:height" (example: "16:9"). */
        aspectRatio?:
          | "16:9"
          | "1:1"
          | "21:9"
          | "2:3"
          | "3:2"
          | "3:4"
          | "4:3"
          | "4:5"
          | "5:4"
          | "9:16"
          | "9:21";
        /** The type of inference to use. Example: txt2img, img2img, etc.
            
            Selecting the right type will condition the expected parameters.
            
            Note: if model.type is `sd-xl*` or `sd-1_5*`, when using the `"inpaint"` inference type, Scenario determines the best available `baseModel` for a given `modelId`: one of `["stable-diffusion-inpainting", "stable-diffusion-xl-1.0-inpainting-0.1"] will be used. */
        type:
          | "controlnet"
          | "controlnet_img2img"
          | "controlnet_inpaint"
          | "controlnet_inpaint_ip_adapter"
          | "controlnet_ip_adapter"
          | "controlnet_reference"
          | "controlnet_texture"
          | "img2img"
          | "img2img_ip_adapter"
          | "img2img_texture"
          | "inpaint"
          | "inpaint_ip_adapter"
          | "outpaint"
          | "reference"
          | "reference_texture"
          | "txt2img"
          | "txt2img_ip_adapter"
          | "txt2img_texture";
        /** Signed URL to display the IpAdapter image */
        ipAdapterImage?: string;
        /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
        scheduler?:
          | "DDIMScheduler"
          | "DDPMScheduler"
          | "DEISMultistepScheduler"
          | "DPMSolverMultistepScheduler"
          | "DPMSolverSinglestepScheduler"
          | "EulerAncestralDiscreteScheduler"
          | "EulerDiscreteScheduler"
          | "HeunDiscreteScheduler"
          | "KDPM2AncestralDiscreteScheduler"
          | "KDPM2DiscreteScheduler"
          | "LCMScheduler"
          | "LMSDiscreteScheduler"
          | "PNDMScheduler"
          | "TCDScheduler"
          | "UniPCMultistepScheduler";
        /** If set to true, the entire input image will likely change during inpainting. This results in faster inferences, but the output image will be harder to integrate if the input is just a small part of a larger image. */
        disableMerging?: boolean;
        /** If false, the process uses the given image to detect the modality.
            If true (default), the process will not try to detect the modality of the given image.
            
            For example:
            with `pose` modality and `false` value, the process will detect the pose of people in the given image
            with `depth` modality and `false` value, the process will detect the depth of the given image
            with `scribble` modality and `true`value, the process will use the given image as a scribble
            
            ⚠️ For models of the FLUX schnell or dev families, this parameter is ignored. The modality detection is always disabled. ⚠️ */
        disableModalityDetection?: boolean;
        /** Signed URL to display the IpAdapter images */
        ipAdapterImages?: string[];
        /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
            Allowed values are available in the model's attribute: `compliantModelIds` */
        baseModelId?: string;
        /** Specifies the starting point of the ControlNet guidance during the inference process.
            
            Only available for Flux.1-dev based models.
            
            The value represents the percentage of total inference steps where the ControlNet guidance starts.
            For example:
            - 0.0: ControlNet guidance starts at the beginning of the inference steps
            - 0.5: ControlNet guidance starts at the middle of the inference steps */
        controlStart?: number;
        /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
            If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
            If model.type is `sd-1_5`, the height must be within [64, 1024]
            If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        height?: number;
        /** Signed URL to display the mask image */
        mask?: string;
        /** Asset id of the controlnet input image */
        controlImageId?: string;
        /** Signed URL to display the input image */
        image?: string;
        /** Asset id of the input image */
        imageId?: string;
        /** Asset id of the input IpAdapter image */
        ipAdapterImageId?: string;
        /** IpAdapter scale factor (within [0.0, 1.0], default: 0.9). */
        ipAdapterScale?: number;
        /** If set, generated assets will be hidden and not returned in the list of images of the inference
            or when listing assets (default: false) */
        hideResults?: boolean;
        /** IpAdapter scale factors (within [0.0, 1.0], default: 0.9). */
        ipAdapterScales?: number[];
        /** Asset id of the mask image */
        maskId?: string;
        /** Whether to use reference adain
            Only for "reference" inference type */
        referenceAdain?: boolean;
        /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
        negativePrompt?: string;
        /** Enable or disable the intermediate images generation (default: false) */
        intermediateImages?: boolean;
        concepts?: {
          /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
          modelId: string;
          /** The scale of the model (example: 1.0) */
          scale: number;
        }[];
        /** Signed URL to display the controlnet input image */
        controlImage?: string;
        /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
        guidance?: number;
        /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
        numInferenceSteps?: number;
        /** The number of images to generate (within [1, 128], default: 4) */
        numSamples?: number;
        /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
            If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
            If model.type is `sd-1_5`, the width must be within [64, 1024]
            If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        width?: number;
        /** Whether to use reference query for self attention's context
            Only for "reference" inference type */
        referenceAttn?: boolean;
        /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
        prompt: string;
      };
      /** The preset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      updatedAt: string;
    };
  };
export type PostModelPresetByModelIdApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The modelId used to generate new images */
  modelId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** Whether this preset should be the default preset for the model */
    isDefault?: boolean;
    /** The inference ID used to generate new images */
    inferenceId: string;
  };
};
export type PutModelPresetByModelIdAndPresetIdApiResponse =
  /** status 200 200 response */ {
    preset: {
      /** The preset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** Whether the preset is the default preset of the model (example: true) */
      isDefault: boolean;
      /** The model ID (example: "eyVcnFJcR92BxBkz7N6g5w") */
      modelId: string;
      /** The preset ID (example: "eyVcnFJcR92BxBkz7N6g5w") */
      id: string;
      /** The author user ID (example: "VFhihHKMRZyDDnZAJwLb2Q") */
      authorId: string;
      /** The owner ID (example: "VFhihHKMRZyDDnZAJwLb2Q") */
      ownerId: string;
      /** The inference parameters */
      parameters: {
        /** Asset id of the input IpAdapter images */
        ipAdapterImageIds?: string[];
        /** If style_fidelity=1.0, control more important, else if style_fidelity=0.0, prompt more important, else balanced
            Only for "reference" inference type */
        styleFidelity?: number;
        /** Specifies how long the ControlNet guidance should be applied during the inference process.
            
            Only available for Flux.1-dev based models.
            
            The value represents the percentage of total inference steps where the ControlNet guidance is active.
            For example:
            - 1.0: ControlNet guidance is applied during all inference steps
            - 0.5: ControlNet guidance is only applied during the first half of inference steps
            
            Default values:
            - 0.5 for Canny modality
            - 0.6 for all other modalities */
        controlEnd?: number;
        /** The modality associated with the control image used for the generation: it can either be an object with a combination of maximum
            
            For models of SD1.5 family:
             - up to 3 modalities from `canny`, `pose`, `depth`, `lines`, `seg`, `scribble`, `lineart`, `normal-map`, `illusion`
             - or one of the following presets: `character`, `landscape`, `city`, `interior`.
            
            For models of the SDXL family:
             - up to 3 modalities from `canny`, `pose`, `depth`, `seg`, `illusion`, `scribble`
             - or one of the following presets: `character`, `landscape`.
            
            For models of the FLUX schnell or dev families:
            - one modality from: `canny`, `tile`, `depth`, `blur`, `pose`, `gray`, `low-quality`
            
            Optionally, you can associate a value to these modalities or presets. The value must be within `]0.0, 1.0]`.
            
            Examples:
            - `canny`
            - `depth:0.5,pose:1.0`
            - `canny:0.5,depth:0.5,lines:0.3`
            - `landscape`
            - `character:0.5`
            - `illusion:1`
            
            Note: if you use a value that is not supported by the model family, this will result in an error. */
        modality?:
          | "blur"
          | "canny"
          | "depth"
          | "gray"
          | "illusion"
          | "lineart"
          | "lines"
          | "low-quality"
          | "normal-map"
          | "pose"
          | "scribble"
          | "seg"
          | "sketch"
          | "tile";
        /** Used to reproduce previous results. Default: randomly generated number. */
        seed?: string;
        /** Controls the noise intensity introduced to the input image, where a value of 1.0 completely erases the original image's details. Available for img2img and inpainting. (within [0.01, 1.0], default: 0.75) */
        strength?: number;
        /** The type of IP Adapter model to use. Must be one of [`style`, `character`], default to `style`` */
        ipAdapterType?: "character" | "style";
        /** The aspect ratio of the generated images. Only used for the model flux.1.1-pro-ultra.
            The aspect ratio is a string formatted as "width:height" (example: "16:9"). */
        aspectRatio?:
          | "16:9"
          | "1:1"
          | "21:9"
          | "2:3"
          | "3:2"
          | "3:4"
          | "4:3"
          | "4:5"
          | "5:4"
          | "9:16"
          | "9:21";
        /** The type of inference to use. Example: txt2img, img2img, etc.
            
            Selecting the right type will condition the expected parameters.
            
            Note: if model.type is `sd-xl*` or `sd-1_5*`, when using the `"inpaint"` inference type, Scenario determines the best available `baseModel` for a given `modelId`: one of `["stable-diffusion-inpainting", "stable-diffusion-xl-1.0-inpainting-0.1"] will be used. */
        type:
          | "controlnet"
          | "controlnet_img2img"
          | "controlnet_inpaint"
          | "controlnet_inpaint_ip_adapter"
          | "controlnet_ip_adapter"
          | "controlnet_reference"
          | "controlnet_texture"
          | "img2img"
          | "img2img_ip_adapter"
          | "img2img_texture"
          | "inpaint"
          | "inpaint_ip_adapter"
          | "outpaint"
          | "reference"
          | "reference_texture"
          | "txt2img"
          | "txt2img_ip_adapter"
          | "txt2img_texture";
        /** Signed URL to display the IpAdapter image */
        ipAdapterImage?: string;
        /** The scheduler to use to override the default configured for the model. See detailed documentation for more details. */
        scheduler?:
          | "DDIMScheduler"
          | "DDPMScheduler"
          | "DEISMultistepScheduler"
          | "DPMSolverMultistepScheduler"
          | "DPMSolverSinglestepScheduler"
          | "EulerAncestralDiscreteScheduler"
          | "EulerDiscreteScheduler"
          | "HeunDiscreteScheduler"
          | "KDPM2AncestralDiscreteScheduler"
          | "KDPM2DiscreteScheduler"
          | "LCMScheduler"
          | "LMSDiscreteScheduler"
          | "PNDMScheduler"
          | "TCDScheduler"
          | "UniPCMultistepScheduler";
        /** If set to true, the entire input image will likely change during inpainting. This results in faster inferences, but the output image will be harder to integrate if the input is just a small part of a larger image. */
        disableMerging?: boolean;
        /** If false, the process uses the given image to detect the modality.
            If true (default), the process will not try to detect the modality of the given image.
            
            For example:
            with `pose` modality and `false` value, the process will detect the pose of people in the given image
            with `depth` modality and `false` value, the process will detect the depth of the given image
            with `scribble` modality and `true`value, the process will use the given image as a scribble
            
            ⚠️ For models of the FLUX schnell or dev families, this parameter is ignored. The modality detection is always disabled. ⚠️ */
        disableModalityDetection?: boolean;
        /** Signed URL to display the IpAdapter images */
        ipAdapterImages?: string[];
        /** The base model to use for the inference. Only Flux LoRA models can use this parameter.
            Allowed values are available in the model's attribute: `compliantModelIds` */
        baseModelId?: string;
        /** Specifies the starting point of the ControlNet guidance during the inference process.
            
            Only available for Flux.1-dev based models.
            
            The value represents the percentage of total inference steps where the ControlNet guidance starts.
            For example:
            - 0.0: ControlNet guidance starts at the beginning of the inference steps
            - 0.5: ControlNet guidance starts at the middle of the inference steps */
        controlStart?: number;
        /** The height of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
            If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the height must be within [512, 2048]
            If model.type is `sd-1_5`, the height must be within [64, 1024]
            If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        height?: number;
        /** Signed URL to display the mask image */
        mask?: string;
        /** Asset id of the controlnet input image */
        controlImageId?: string;
        /** Signed URL to display the input image */
        image?: string;
        /** Asset id of the input image */
        imageId?: string;
        /** Asset id of the input IpAdapter image */
        ipAdapterImageId?: string;
        /** IpAdapter scale factor (within [0.0, 1.0], default: 0.9). */
        ipAdapterScale?: number;
        /** If set, generated assets will be hidden and not returned in the list of images of the inference
            or when listing assets (default: false) */
        hideResults?: boolean;
        /** IpAdapter scale factors (within [0.0, 1.0], default: 0.9). */
        ipAdapterScales?: number[];
        /** Asset id of the mask image */
        maskId?: string;
        /** Whether to use reference adain
            Only for "reference" inference type */
        referenceAdain?: boolean;
        /** The prompt not to guide the image generation, ignored when guidance < 1 (example: "((ugly face))") */
        negativePrompt?: string;
        /** Enable or disable the intermediate images generation (default: false) */
        intermediateImages?: boolean;
        concepts?: {
          /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
          modelId: string;
          /** The scale of the model (example: 1.0) */
          scale: number;
        }[];
        /** Signed URL to display the controlnet input image */
        controlImage?: string;
        /** The degree of freedom given to the model: The highest the number will be, the closer to the prompt the result will be (within [0, 20], default: 7.5) */
        guidance?: number;
        /** The number of denoising steps for each image generation (within [1, 150], default: 30) */
        numInferenceSteps?: number;
        /** The number of images to generate (within [1, 128], default: 4) */
        numSamples?: number;
        /** The width of the generated images, must be a 8 multiple (within [64, 2048], default: 512)
            If model.type is `sd-xl`, `sd-xl-lora`, `sd-xl-composition` the width must be within [512, 2048]
            If model.type is `sd-1_5`, the width must be within [64, 1024]
            If model.type is `flux.1.1-pro-ultra`, you can use the aspectRatio parameter instead */
        width?: number;
        /** Whether to use reference query for self attention's context
            Only for "reference" inference type */
        referenceAttn?: boolean;
        /** Full text prompt including the model placeholder. (example: "an illustration of phoenix in a fantasy world, flying over a mountain, 8k, bokeh effect") */
        prompt: string;
      };
      /** The preset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      updatedAt: string;
    };
  };
export type PutModelPresetByModelIdAndPresetIdApiArg = {
  /** The ID of the model to update its examples */
  modelId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  presetId: string;
  body: {
    /** Whether this preset should be the default preset for the model */
    isDefault: boolean;
  };
};
export type DeleteModelPresetByModelIdAndPresetIdApiResponse =
  /** status 200 200 response */ any;
export type DeleteModelPresetByModelIdAndPresetIdApiArg = {
  /** The modelId for that preset */
  modelId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  /** The id of the preset to delete */
  presetId: string;
};
export type GetModelsScoresPromptByModelIdApiResponse =
  /** status 200 200 response */ {
    /** The prompt's score for the input modelId
    
    The score is a number between 0 and 1. The higher the score, the better the prompt is for the model */
    score: number;
    /** Present only if the prompt has one or more syntax errors
    
    The API checks several syntax errors in the prompt */
    syntaxError?:
      | "Prompt weight should be between 0 and 2"
      | "Prompt weight symbol should be - or + with a maximum length of 5. Ex: --, ++, ---, +++++"
      | "Unsupported prompt syntax: '[to:when], [from::when]'"
      | "Unsupported prompt syntax: 'word:<weight>' or '(word):<weight>'. Please use 'word<weight>' or '(word)<weight>' instead"
      | "Unsupported prompt syntax: --(s|c)ref"
      | "Unsupported prompt syntax: <name:weight> or <lora:name:weight>"
      | "Unsupported url in prompt";
    /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
    modelId: string;
    /** Different components used to compute the final score */
    details: {
      /** The Dice-Sørensen similarity between the prompt and each captions from the model's training images
        
        The values are between 0 and 1. The higher the value, the more similar the prompt is to the training images' captions */
      captionsSimilarity: {
        min: number;
        median: number;
        mean: number;
      };
      /** The cosine similarity between the prompt and the model's caption embedding
        
        The value is a number between -1 and 1. The higher the value, the more similar the prompt is to the model's caption embedding */
      embeddingSimilarity: number;
      /** The Dice-Sørensen similarity between the prompt and each prompts from the model's examples
        
        The values are between 0 and 1. The higher the value, the more similar the prompt is to the prompts' examples */
      promptsSimilarity?: {
        min: number;
        median: number;
        mean: number;
      };
    };
    /** The status of the prompt's score
    
    Details if all the necessary data is present to compute the score */
    status: "complete" | "incomplete" | "unknown";
  };
export type GetModelsScoresPromptByModelIdApiArg = {
  /** The modelId to retrieve */
  modelId: string;
  prompt?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
};
export type GetModelsScoresTrainingDatasetByModelIdApiResponse =
  /** status 200 200 response */ {
    /** The training dataset's score for the input modelId
    
    The score is a number between 0 and 1. The higher the score, the most chance the model has to train well */
    score: number;
    /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
    modelId: string;
    /** Present only if the training image assets of the modelId have one or more warnings */
    assetsWarnings?: {
      /** The AssetId which has a warning (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
      assetId: string;
      /** An indicative message concerning the asset */
      message: (
        | "Captions are identical"
        | "Captions are too close"
        | "Empty caption"
        | "Missing caption"
        | "Missing metadata"
        | "Same asset"
        | "Similarity is too high"
        | "Similarity with other assets is too low"
        | "Width and height must be larger than 1024"
      )[];
    }[];
    /** Present only if their is a warning between the assets of the couples */
    assetCouplesWarnings?: {
      /** The couple of AssetIds (example: ['asset_GTrL3mq4SXWyMxkOHRxlpw', 'asset_6VrLs8nC1DHWCfKGaVne0gBn']) */
      couple: any[];
      /** An indicative message concerning the couple of assets */
      message: (
        | "Captions are identical"
        | "Captions are too close"
        | "Empty caption"
        | "Missing caption"
        | "Missing metadata"
        | "Same asset"
        | "Similarity is too high"
        | "Similarity with other assets is too low"
        | "Width and height must be larger than 1024"
      )[];
    }[];
    /** Different components used to compute the final score */
    details: {
      /** The min, mean, median of the assetCouplesCaptionsDistance */
      couplesCaptionsDistance: {
        min: number;
        median: number;
        mean: number;
      };
      /** For each couple of assets in the training dataset, the distance between the captions */
      assetCouplesCaptionsDistance: {
        /** The couple of AssetIds (example: ['asset_GTrL3mq4SXWyMxkOHRxlpw', 'asset_6VrLs8nC1DHWCfKGaVne0gBn']) */
        couple: any[];
        /** The Dice-Sørensen distance between the captions of the assetIds of the couple. */
        distance: number;
      }[];
      /** The min, mean, median of the assetCouplesSimilarity */
      couplesSimilarity: {
        min: number;
        median: number;
        mean: number;
      };
      /** For each asset, the similarity with the model's embedding (excluding the current asset) */
      assetsEmbeddingSimilarity: {
        /** The AssetId associated with their similarity (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        assetId: string;
        /** The cosine similarity between the assetId and the model's embedding minus the asset's embedding
            
            The value is a number between -1 and 1. The higher the value, the more similar the asset is to the model's embedding */
        similarity: number;
      }[];
      /** Takes into account all missing data and warnings to compute a metadata score */
      metadataScore: number;
      /** For each couple of assets in the training dataset, the similarity between the assets */
      assetCouplesSimilarity: {
        /** The couple of AssetIds (example: ['asset_GTrL3mq4SXWyMxkOHRxlpw', 'asset_6VrLs8nC1DHWCfKGaVne0gBn']) */
        couple: any[];
        /** The cosine similarity between the assetIds of the couple.
            
            The value is a number between -1 and 1. The higher the value, the more similar the assets are to each other */
        similarity: number;
      }[];
      /** The min, mean, median of the assetsEmbeddingSimilarity */
      assetsSimilarity: {
        min: number;
        median: number;
        mean: number;
      };
    };
    /** The status of the training dataset's score
    
    Details if all the necessary data is present to compute the score */
    status: "complete" | "incomplete" | "unknown";
  };
export type GetModelsScoresTrainingDatasetByModelIdApiArg = {
  /** The modelId to retrieve */
  modelId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
};
export type PutModelsTagsByModelIdApiResponse = /** status 200 200 response */ {
  /** The list of deleted tags */
  deleted: string[];
  /** The list of added tags */
  added: string[];
};
export type PutModelsTagsByModelIdApiArg = {
  /** The ID of the model to update its tags */
  modelId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** The list of tags to add */
    add?: string[];
    /** If true, the function will throw an error if:
        - one of the tags to add already exists
        - one of the tags to delete is not found
        If false, the endpoint will behave as if it was idempotent */
    strict?: boolean;
    /** The list of tags to delete */
    delete?: string[];
  };
};
export type PutModelsTrainByModelIdApiResponse =
  /** status 200 200 response */ {
    creativeUnitsCost?: number;
    model: {
      /** The training caption words of the model */
      captionWords?: string[];
      /** The URLs of the first 3 training images of the model. To retrieve the full set of images, get it by modelId */
      trainingImages?: {
        /** The training image upload date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** Automatic captioning of the image */
        automaticCaptioning: string;
        /** The URL of the image */
        downloadUrl: string;
        /** The original file name of the image (example: "my-training-image.jpg") */
        name: string;
        /** Description for the image */
        description: string;
        /** The training image ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        id: string;
      }[];
      /** The inputs of the model. Only used for custom models. To retrieve this list, get it by modelId with GET /models/{modelId} */
      inputs?: {
        /** The allowed values of the input of type 'string' or 'string_array'
            In case of string, it's a single value select list
            In case of string_array, it's a multi value select list */
        allowedValues?: string[];
        /** The maximum value of the input (only available for inputs of type 'number' and inputs as array) */
        max?: number;
        /** The kind of the input. Only available for inputs of type 'file' (and 'file_array') */
        kind?: "3d" | "audio" | "document" | "image" | "json" | "video";
        /** The minimum length of the input where the input is a string (also available for each item in string_array) */
        minLength?: number;
        /** The description of the input, to display in the UI as an help text adding information about the input */
        description?: string;
        /** The label of the input displayed in the UI */
        label?: string;
        /** The type of the input */
        type:
          | "boolean"
          | "file"
          | "file_array"
          | "number"
          | "number_array"
          | "string"
          | "string_array";
        /** Whether the input is required */
        required: boolean;
        /** The minimum value of the input (only available for inputs of type 'number' and inputs as array) */
        min?: number;
        /** A hint to the user about the input, to display in the UI with a tooltip */
        hint?: string;
        /** The name of the input internally used by the model and API */
        name: string;
        /** The maximum length of the input where the input is a string (also available for each item in string_array) */
        maxLength?: number;
        /** The group of the input. If 2 inputs have the same group, they will be displayed in the same group in the UI
            They will be always together in this list of inputs */
        group?: string;
      }[];
      /** List of all example asset IDs setup by the model owner */
      exampleAssetIds: string[];
      /** The privacy of the model (default: private) */
      privacy: "private" | "public" | "unlisted";
      /** The date when the model will be soft deleted (only for Free plan) */
      softDeletionOn?: string;
      /** The UI configuration for the model */
      uiConfig?: {
        triggerGenerate?: {
          /** The 'name' of the input where the trigger generate button will be displayed (after the input).
                Do not specify both position and after. */
          after?: string;
          label: string;
          /** The position of the trigger generate button. If position specified, the button will be displayed at the specified position.
                Do not specify both position and after. */
          position?: "bottom" | "top";
        };
      };
      /** The source of the model */
      source: "civitai" | "huggingface" | "other" | "scenario";
      /** The owner ID (example: "team_VFhihHKMRZyDDnZAJwLb2Q") */
      ownerId?: string;
      /** The model type (example: sd-1_5) */
      type:
        | "custom"
        | "flux.1"
        | "flux.1-composition"
        | "flux.1-lora"
        | "flux.1-pro"
        | "flux.1.1-pro-ultra"
        | "flux1.1-pro"
        | "gpt-image-1"
        | "sd-1_5"
        | "sd-1_5-composition"
        | "sd-1_5-lora"
        | "sd-xl"
        | "sd-xl-composition"
        | "sd-xl-lora";
      /** The model creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** Additional information about the model's training */
      trainingStats?: {
        /** The training duration in seconds */
        trainDuration?: number;
        /** The training queued duration in seconds */
        queueDuration?: number;
        /** The training end time as an ISO date string */
        endedAt?: string;
        /** The training start time as an ISO date string */
        startedAt?: string;
      };
      /** Fine-tune the model's inferences with prompt embedding */
      promptEmbedding?: string;
      /** Additional information about the training progress of the model */
      trainingProgress?: {
        /** The stage of the request */
        stage:
          | "pending"
          | "queued-for-train"
          | "running-train"
          | "starting-train";
        /** The remaining time in milliseconds */
        remainingTimeMs?: number;
        /** The progress of the job */
        progress?: number;
        /** The timestamp in millisecond marking the start of the process */
        startedAt?: number;
        /** Position of the job in the queue (ie. the number of job in the queue before this one) */
        position?: number;
        /** Timestamp in milliseconds of the last time the training progress was updated */
        updatedAt: number;
      };
      /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
      id: string;
      /** The class of the model */
      class?: {
        /** The model ID of the class (example: "stable-diffusion-v1-5") */
        modelId: string;
        /** The class name (example: "Character Design") */
        name: string;
        /** The category slug of the class (example: "art-style") */
        category: string;
        /** Some example images URLs to showcase the class */
        thumbnails: string[];
        /** The class prompt (example: "a character design") */
        prompt: string;
        /** The concept prompt of the class (example: "a sks character design") */
        conceptPrompt: string;
        /** The class slug (example: "art-style-character-design") */
        slug: string;
        /** The class status (only published classes are listed, but unpublished classes can still appear in existing models) */
        status: "published" | "unpublished";
      };
      /** The model last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      updatedAt: string;
      /** A thumbnail for your model */
      thumbnail?: {
        /** The AssetId of the image used as a thumbnail for your model (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        assetId: string;
        /** The url of the image used as a thumbnail for your model */
        url: string;
      };
      /** List of model capabilities (example: ["txt2img", "img2img", "txt2img_ip_adapter", ...]) */
      capabilities: (
        | "controlnet"
        | "controlnet_img2img"
        | "controlnet_inpaint"
        | "controlnet_inpaint_ip_adapter"
        | "controlnet_ip_adapter"
        | "controlnet_reference"
        | "controlnet_texture"
        | "img2img"
        | "img2img_ip_adapter"
        | "img2img_texture"
        | "inpaint"
        | "inpaint_ip_adapter"
        | "outpaint"
        | "reference"
        | "reference_texture"
        | "txt2img"
        | "txt2img_ip_adapter"
        | "txt2img_texture"
      )[];
      /** The id of the parent model */
      parentModelId?: string;
      /** The total number of training images */
      trainingImagesNumber: number;
      /** Whether the model is a custom model and can be used only with POST /generate/custom/{modelId} endpoint */
      custom: boolean;
      /** The model keyword, this is a legacy parameter, please use conceptPrompt in parameters */
      modelKeyword?: string;
      /** The author user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
      authorId?: string;
      /** (Deprecated) The user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
      userId?: string;
      /** The associated tags (example: ["sci-fi", "landscape"]) */
      tags: string[];
      /** Fine-tune the model's inferences with negative prompt embedding */
      negativePromptEmbedding?: string;
      /** The concepts is required for the type model: composition */
      concepts?: {
        /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
        modelId: string;
        /** The scale of the model (example: 1.0) */
        scale: number;
      }[];
      /** A list of CollectionId this model belongs to */
      collectionIds: string[];
      /** The model name (example: "Low-poly dwarf") */
      name?: string;
      /** The model's training parameters */
      parameters?: {
        /** Whether to train the text encoder or not
            
            Example: For 100 steps and a value of 0.2, it means that the text encoder will be trained for 20 steps and then the UNet for 80 steps
            
            Note: Legacy parameter, please use `numTextTrainSteps` and `numUNetTrainSteps`
            
            Only available for SD15 and SDXL LoRA training */
        textEncoderTrainingRatio?: number;
        /** The weight of prior preservation loss
            
            Only available for SD15 and SDXL LoRA training */
        priorLossWeight?: number;
        /** Used to reproduce previous results. Default: randomly generated number.
            
            Only available for SD15 and SDXL LoRA training */
        seed?: number;
        /** The number of training steps for the UNet
            
            Only available for SDXL LoRA training */
        numUNetTrainSteps?: number;
        /** Validation frequency. Cannot be greater than maxTrainSteps value
            
            Only available for SD15 and SDXL LoRA training */
        validationFrequency?: number;
        /** Ratio of random crops
            
            Only available for SD15 and SDXL LoRA training */
        randomCropRatio?: number;
        /** Initial learning rate (after the potential warmup period)
            
            Default value varies depending on the model type:
            - For SD1.5 and SDXL: 0.000005
            - For Flux: 0.0004 */
        learningRate?: number;
        /** Optimize the model training task for a specific type of input images. The available values are:
            - "likeness": optimize training for likeness or portrait
            
            Only available for Flux LoRA training */
        optimizeFor?: "likeness" | null;
        /** Whether to random crop or center crop images before resizing to the working resolution
            
            Only available for SD15 and SDXL LoRA training */
        randomCrop?: boolean;
        /** The prompt to specify images in the same class as provided instance images
            
            Only available for SD15 training */
        classPrompt?: string;
        /** The number of training steps for the text encoder
            
            Only available for SDXL LoRA training */
        numTextTrainSteps?: number;
        /** Initial learning rate (after the potential warmup period) for the text encoder
            
            Only available for SDXL LoRA training */
        learningRateTextEncoder?: number;
        /** The Weights And Bias key to use for logging. The maximum length is 40 characters */
        wandbKey?: string;
        /** Whether to scale the learning rate
            
            Note: Legacy parameter, will be ignored
            
            Only available for SD15 and SDXL LoRA training */
        scaleLr?: boolean;
        /** Scale of random crops
            
            Only available for SD15 and SDXL LoRA training */
        randomCropScale?: number;
        /** The scheduler type to use (default: "constant")
            
            Only available for SD15 and SDXL LoRA training */
        lrScheduler?:
          | "constant"
          | "constant-with-warmup"
          | "cosine"
          | "cosine-with-restarts"
          | "linear"
          | "polynomial";
        /** The dimension of the LoRA update matrices
            
            Only available for SDXL and Flux LoRA training
            
            Default value varies depending on the model type:
            - For SDXL: 64
            - For Flux: 16 */
        rank?: number;
        /** Initial learning rate (after the potential warmup period) for the UNet
            
            Only available for SDXL LoRA training */
        learningRateUnet?: number;
        /** Validation prompt
            
            Only available for SD15 and SDXL LoRA training */
        validationPrompt?: string;
        /** The prompt with identifier specifying the instance (or subject) of the class (example: "a daiton dog")
            
            Default value varies depending on the model type:
            - For SD1.5: "daiton" if no class is associated with the model
            - For SDXL: "daiton"
            - For Flux: "" */
        conceptPrompt?: string | null;
        /** Maximum number of training steps to execute (default: varies depending on the model type)
            
            For SDXL LoRA training, please use `numTextTrainSteps` and `numUNetTrainSteps` instead
            
            Default value varies depending on the model type:
            - For SD1.5: round((number of training images * 225) / 3)
            - For SDXL: number of training images * 175
            - For Flux: number of training images * 100
            
            Maximum value varies depending on the model type:
            - For SD1.5 and SDXL: [0, 40000]
            - For Flux: [0, 10000] */
        maxTrainSteps?: number;
      };
      /** List of base model IDs compliant with the model (example: ["flux.1-dev", "flux.1-schnell"])
        This attribute is mainly used for Flux LoRA models */
      compliantModelIds?: string[];
      /** The model status */
      status:
        | "copying"
        | "failed"
        | "new"
        | "trained"
        | "training"
        | "training-canceled";
    };
    job: {
      /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
      jobId: string;
      /** Metadata of the job with some additional information */
      metadata: {
        /** The output of the job */
        output?: {};
        /** The inputs for the job */
        input?: {};
        /** List of produced assets for this job */
        assetIds?: string[];
      };
      /** The history of the different statuses the job went through with the ISO string date
        of when the job reached each statuses. */
      statusHistory: {
        date: string;
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
      }[];
      /** Progress of the job (between 0 and 1) */
      progress: number;
      /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
      authorId?: string;
      /** The type of job */
      jobType:
        | "assets-download"
        | "canvas-export"
        | "caption"
        | "caption-llava"
        | "custom"
        | "describe-style"
        | "detection"
        | "embed"
        | "flux"
        | "flux-model-training"
        | "generate-prompt"
        | "image-generation"
        | "image-prompt-editing"
        | "inference"
        | "model-download"
        | "model-import"
        | "model-training"
        | "openai-image-generation"
        | "patch-image"
        | "pixelate"
        | "reframe"
        | "remove-background"
        | "repaint"
        | "restyle"
        | "segment"
        | "skybox-base-360"
        | "skybox-upscale-360"
        | "texture"
        | "translate"
        | "upload"
        | "upscale"
        | "upscale-skybox"
        | "upscale-texture"
        | "vectorize";
      /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
      ownerId?: string;
      /** The current status of the job */
      status:
        | "canceled"
        | "failure"
        | "in-progress"
        | "queued"
        | "success"
        | "warming-up";
      /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      updatedAt: string;
    };
  };
export type PutModelsTrainByModelIdApiArg = {
  /** The model Id for which the training will be triggered */
  modelId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  dryRun?: string;
  trainingImagesCount?: number;
  body: {
    parameters?: {
      /** Whether to train the text encoder or not
            
            Example: For 100 steps and a value of 0.2, it means that the text encoder will be trained for 20 steps and then the UNet for 80 steps
            
            Note: Legacy parameter, please use `numTextTrainSteps` and `numUNetTrainSteps`
            
            Only available for SD15 and SDXL LoRA training */
      textEncoderTrainingRatio?: number;
      /** The weight of prior preservation loss
            
            Only available for SD15 and SDXL LoRA training */
      priorLossWeight?: number;
      /** Used to reproduce previous results. Default: randomly generated number.
            
            Only available for SD15 and SDXL LoRA training */
      seed?: number;
      /** The number of training steps for the UNet
            
            Only available for SDXL LoRA training */
      numUNetTrainSteps?: number;
      /** Validation frequency. Cannot be greater than maxTrainSteps value
            
            Only available for SD15 and SDXL LoRA training */
      validationFrequency?: number;
      /** Ratio of random crops
            
            Only available for SD15 and SDXL LoRA training */
      randomCropRatio?: number;
      /** Initial learning rate (after the potential warmup period)
            
            Default value varies depending on the model type:
            - For SD1.5 and SDXL: 0.000005
            - For Flux: 0.0004 */
      learningRate?: number;
      /** Optimize the model training task for a specific type of input images. The available values are:
            - "likeness": optimize training for likeness or portrait
            
            Only available for Flux LoRA training */
      optimizeFor?: "likeness" | null;
      /** Whether to random crop or center crop images before resizing to the working resolution
            
            Only available for SD15 and SDXL LoRA training */
      randomCrop?: boolean;
      /** The prompt to specify images in the same class as provided instance images
            
            Only available for SD15 training */
      classPrompt?: string;
      /** The number of training steps for the text encoder
            
            Only available for SDXL LoRA training */
      numTextTrainSteps?: number;
      /** Initial learning rate (after the potential warmup period) for the text encoder
            
            Only available for SDXL LoRA training */
      learningRateTextEncoder?: number;
      /** The Weights And Bias key to use for logging. The maximum length is 40 characters */
      wandbKey?: string;
      /** Whether to scale the learning rate
            
            Note: Legacy parameter, will be ignored
            
            Only available for SD15 and SDXL LoRA training */
      scaleLr?: boolean;
      /** Scale of random crops
            
            Only available for SD15 and SDXL LoRA training */
      randomCropScale?: number;
      /** The scheduler type to use (default: "constant")
            
            Only available for SD15 and SDXL LoRA training */
      lrScheduler?:
        | "constant"
        | "constant-with-warmup"
        | "cosine"
        | "cosine-with-restarts"
        | "linear"
        | "polynomial";
      /** The dimension of the LoRA update matrices
            
            Only available for SDXL and Flux LoRA training
            
            Default value varies depending on the model type:
            - For SDXL: 64
            - For Flux: 16 */
      rank?: number;
      /** Initial learning rate (after the potential warmup period) for the UNet
            
            Only available for SDXL LoRA training */
      learningRateUnet?: number;
      /** Validation prompt
            
            Only available for SD15 and SDXL LoRA training */
      validationPrompt?: string;
      /** The prompt with identifier specifying the instance (or subject) of the class (example: "a daiton dog")
            
            Default value varies depending on the model type:
            - For SD1.5: "daiton" if no class is associated with the model
            - For SDXL: "daiton"
            - For Flux: "" */
      conceptPrompt?: string | null;
      /** Maximum number of training steps to execute (default: varies depending on the model type)
            
            For SDXL LoRA training, please use `numTextTrainSteps` and `numUNetTrainSteps` instead
            
            Default value varies depending on the model type:
            - For SD1.5: round((number of training images * 225) / 3)
            - For SDXL: number of training images * 175
            - For Flux: number of training images * 100
            
            Maximum value varies depending on the model type:
            - For SD1.5 and SDXL: [0, 40000]
            - For Flux: [0, 10000] */
      maxTrainSteps?: number;
    };
  };
};
export type PostModelTrainingActionByModelIdApiResponse =
  /** status 200 200 response */ {
    model: {
      /** The training caption words of the model */
      captionWords?: string[];
      /** The URLs of the first 3 training images of the model. To retrieve the full set of images, get it by modelId */
      trainingImages?: {
        /** The training image upload date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** Automatic captioning of the image */
        automaticCaptioning: string;
        /** The URL of the image */
        downloadUrl: string;
        /** The original file name of the image (example: "my-training-image.jpg") */
        name: string;
        /** Description for the image */
        description: string;
        /** The training image ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        id: string;
      }[];
      /** The inputs of the model. Only used for custom models. To retrieve this list, get it by modelId with GET /models/{modelId} */
      inputs?: {
        /** The allowed values of the input of type 'string' or 'string_array'
            In case of string, it's a single value select list
            In case of string_array, it's a multi value select list */
        allowedValues?: string[];
        /** The maximum value of the input (only available for inputs of type 'number' and inputs as array) */
        max?: number;
        /** The kind of the input. Only available for inputs of type 'file' (and 'file_array') */
        kind?: "3d" | "audio" | "document" | "image" | "json" | "video";
        /** The minimum length of the input where the input is a string (also available for each item in string_array) */
        minLength?: number;
        /** The description of the input, to display in the UI as an help text adding information about the input */
        description?: string;
        /** The label of the input displayed in the UI */
        label?: string;
        /** The type of the input */
        type:
          | "boolean"
          | "file"
          | "file_array"
          | "number"
          | "number_array"
          | "string"
          | "string_array";
        /** Whether the input is required */
        required: boolean;
        /** The minimum value of the input (only available for inputs of type 'number' and inputs as array) */
        min?: number;
        /** A hint to the user about the input, to display in the UI with a tooltip */
        hint?: string;
        /** The name of the input internally used by the model and API */
        name: string;
        /** The maximum length of the input where the input is a string (also available for each item in string_array) */
        maxLength?: number;
        /** The group of the input. If 2 inputs have the same group, they will be displayed in the same group in the UI
            They will be always together in this list of inputs */
        group?: string;
      }[];
      /** List of all example asset IDs setup by the model owner */
      exampleAssetIds: string[];
      /** The privacy of the model (default: private) */
      privacy: "private" | "public" | "unlisted";
      /** The date when the model will be soft deleted (only for Free plan) */
      softDeletionOn?: string;
      /** The UI configuration for the model */
      uiConfig?: {
        triggerGenerate?: {
          /** The 'name' of the input where the trigger generate button will be displayed (after the input).
                Do not specify both position and after. */
          after?: string;
          label: string;
          /** The position of the trigger generate button. If position specified, the button will be displayed at the specified position.
                Do not specify both position and after. */
          position?: "bottom" | "top";
        };
      };
      /** The source of the model */
      source: "civitai" | "huggingface" | "other" | "scenario";
      /** The owner ID (example: "team_VFhihHKMRZyDDnZAJwLb2Q") */
      ownerId?: string;
      /** The model type (example: sd-1_5) */
      type:
        | "custom"
        | "flux.1"
        | "flux.1-composition"
        | "flux.1-lora"
        | "flux.1-pro"
        | "flux.1.1-pro-ultra"
        | "flux1.1-pro"
        | "gpt-image-1"
        | "sd-1_5"
        | "sd-1_5-composition"
        | "sd-1_5-lora"
        | "sd-xl"
        | "sd-xl-composition"
        | "sd-xl-lora";
      /** The model creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** Additional information about the model's training */
      trainingStats?: {
        /** The training duration in seconds */
        trainDuration?: number;
        /** The training queued duration in seconds */
        queueDuration?: number;
        /** The training end time as an ISO date string */
        endedAt?: string;
        /** The training start time as an ISO date string */
        startedAt?: string;
      };
      /** Fine-tune the model's inferences with prompt embedding */
      promptEmbedding?: string;
      /** Additional information about the training progress of the model */
      trainingProgress?: {
        /** The stage of the request */
        stage:
          | "pending"
          | "queued-for-train"
          | "running-train"
          | "starting-train";
        /** The remaining time in milliseconds */
        remainingTimeMs?: number;
        /** The progress of the job */
        progress?: number;
        /** The timestamp in millisecond marking the start of the process */
        startedAt?: number;
        /** Position of the job in the queue (ie. the number of job in the queue before this one) */
        position?: number;
        /** Timestamp in milliseconds of the last time the training progress was updated */
        updatedAt: number;
      };
      /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
      id: string;
      /** The class of the model */
      class?: {
        /** The model ID of the class (example: "stable-diffusion-v1-5") */
        modelId: string;
        /** The class name (example: "Character Design") */
        name: string;
        /** The category slug of the class (example: "art-style") */
        category: string;
        /** Some example images URLs to showcase the class */
        thumbnails: string[];
        /** The class prompt (example: "a character design") */
        prompt: string;
        /** The concept prompt of the class (example: "a sks character design") */
        conceptPrompt: string;
        /** The class slug (example: "art-style-character-design") */
        slug: string;
        /** The class status (only published classes are listed, but unpublished classes can still appear in existing models) */
        status: "published" | "unpublished";
      };
      /** The model last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      updatedAt: string;
      /** A thumbnail for your model */
      thumbnail?: {
        /** The AssetId of the image used as a thumbnail for your model (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        assetId: string;
        /** The url of the image used as a thumbnail for your model */
        url: string;
      };
      /** List of model capabilities (example: ["txt2img", "img2img", "txt2img_ip_adapter", ...]) */
      capabilities: (
        | "controlnet"
        | "controlnet_img2img"
        | "controlnet_inpaint"
        | "controlnet_inpaint_ip_adapter"
        | "controlnet_ip_adapter"
        | "controlnet_reference"
        | "controlnet_texture"
        | "img2img"
        | "img2img_ip_adapter"
        | "img2img_texture"
        | "inpaint"
        | "inpaint_ip_adapter"
        | "outpaint"
        | "reference"
        | "reference_texture"
        | "txt2img"
        | "txt2img_ip_adapter"
        | "txt2img_texture"
      )[];
      /** The id of the parent model */
      parentModelId?: string;
      /** The total number of training images */
      trainingImagesNumber: number;
      /** Whether the model is a custom model and can be used only with POST /generate/custom/{modelId} endpoint */
      custom: boolean;
      /** The model keyword, this is a legacy parameter, please use conceptPrompt in parameters */
      modelKeyword?: string;
      /** The author user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
      authorId?: string;
      /** (Deprecated) The user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
      userId?: string;
      /** The associated tags (example: ["sci-fi", "landscape"]) */
      tags: string[];
      /** Fine-tune the model's inferences with negative prompt embedding */
      negativePromptEmbedding?: string;
      /** The concepts is required for the type model: composition */
      concepts?: {
        /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
        modelId: string;
        /** The scale of the model (example: 1.0) */
        scale: number;
      }[];
      /** A list of CollectionId this model belongs to */
      collectionIds: string[];
      /** The model name (example: "Low-poly dwarf") */
      name?: string;
      /** The model's training parameters */
      parameters?: {
        /** Whether to train the text encoder or not
            
            Example: For 100 steps and a value of 0.2, it means that the text encoder will be trained for 20 steps and then the UNet for 80 steps
            
            Note: Legacy parameter, please use `numTextTrainSteps` and `numUNetTrainSteps`
            
            Only available for SD15 and SDXL LoRA training */
        textEncoderTrainingRatio?: number;
        /** The weight of prior preservation loss
            
            Only available for SD15 and SDXL LoRA training */
        priorLossWeight?: number;
        /** Used to reproduce previous results. Default: randomly generated number.
            
            Only available for SD15 and SDXL LoRA training */
        seed?: number;
        /** The number of training steps for the UNet
            
            Only available for SDXL LoRA training */
        numUNetTrainSteps?: number;
        /** Validation frequency. Cannot be greater than maxTrainSteps value
            
            Only available for SD15 and SDXL LoRA training */
        validationFrequency?: number;
        /** Ratio of random crops
            
            Only available for SD15 and SDXL LoRA training */
        randomCropRatio?: number;
        /** Initial learning rate (after the potential warmup period)
            
            Default value varies depending on the model type:
            - For SD1.5 and SDXL: 0.000005
            - For Flux: 0.0004 */
        learningRate?: number;
        /** Optimize the model training task for a specific type of input images. The available values are:
            - "likeness": optimize training for likeness or portrait
            
            Only available for Flux LoRA training */
        optimizeFor?: "likeness" | null;
        /** Whether to random crop or center crop images before resizing to the working resolution
            
            Only available for SD15 and SDXL LoRA training */
        randomCrop?: boolean;
        /** The prompt to specify images in the same class as provided instance images
            
            Only available for SD15 training */
        classPrompt?: string;
        /** The number of training steps for the text encoder
            
            Only available for SDXL LoRA training */
        numTextTrainSteps?: number;
        /** Initial learning rate (after the potential warmup period) for the text encoder
            
            Only available for SDXL LoRA training */
        learningRateTextEncoder?: number;
        /** The Weights And Bias key to use for logging. The maximum length is 40 characters */
        wandbKey?: string;
        /** Whether to scale the learning rate
            
            Note: Legacy parameter, will be ignored
            
            Only available for SD15 and SDXL LoRA training */
        scaleLr?: boolean;
        /** Scale of random crops
            
            Only available for SD15 and SDXL LoRA training */
        randomCropScale?: number;
        /** The scheduler type to use (default: "constant")
            
            Only available for SD15 and SDXL LoRA training */
        lrScheduler?:
          | "constant"
          | "constant-with-warmup"
          | "cosine"
          | "cosine-with-restarts"
          | "linear"
          | "polynomial";
        /** The dimension of the LoRA update matrices
            
            Only available for SDXL and Flux LoRA training
            
            Default value varies depending on the model type:
            - For SDXL: 64
            - For Flux: 16 */
        rank?: number;
        /** Initial learning rate (after the potential warmup period) for the UNet
            
            Only available for SDXL LoRA training */
        learningRateUnet?: number;
        /** Validation prompt
            
            Only available for SD15 and SDXL LoRA training */
        validationPrompt?: string;
        /** The prompt with identifier specifying the instance (or subject) of the class (example: "a daiton dog")
            
            Default value varies depending on the model type:
            - For SD1.5: "daiton" if no class is associated with the model
            - For SDXL: "daiton"
            - For Flux: "" */
        conceptPrompt?: string | null;
        /** Maximum number of training steps to execute (default: varies depending on the model type)
            
            For SDXL LoRA training, please use `numTextTrainSteps` and `numUNetTrainSteps` instead
            
            Default value varies depending on the model type:
            - For SD1.5: round((number of training images * 225) / 3)
            - For SDXL: number of training images * 175
            - For Flux: number of training images * 100
            
            Maximum value varies depending on the model type:
            - For SD1.5 and SDXL: [0, 40000]
            - For Flux: [0, 10000] */
        maxTrainSteps?: number;
      };
      /** List of base model IDs compliant with the model (example: ["flux.1-dev", "flux.1-schnell"])
        This attribute is mainly used for Flux LoRA models */
      compliantModelIds?: string[];
      /** The model status */
      status:
        | "copying"
        | "failed"
        | "new"
        | "trained"
        | "training"
        | "training-canceled";
    };
  };
export type PostModelTrainingActionByModelIdApiArg = {
  /** The model Id for which the training will be triggered */
  modelId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** The action to perform on the model training */
    action: "cancel";
  };
};
export type PostModelsTrainingImagesByModelIdApiResponse =
  /** status 200 200 response */ {
    trainingImage: {
      /** The training image upload date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** Automatic captioning of the image */
      automaticCaptioning: string;
      /** The URL of the image */
      downloadUrl: string;
      /** The original file name of the image (example: "my-training-image.jpg") */
      name: string;
      /** Description for the image */
      description: string;
      /** The training image ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
      id: string;
    };
  };
export type PostModelsTrainingImagesByModelIdApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The model Id where the training image will be stored */
  modelId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** The training image as a data URL (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=") */
    data?: string;
    /** The asset ID to use as a training image (example: "asset_GTrL3mq4SXWyMxkOHRxlpw"). If provided, "data" and "name" parameters will be ignored. */
    assetId?: string;
    /** The original file name of the image (example: "my-training-image.jpg") */
    name?: string;
    /** The preset to use for training images */
    preset?: "default" | "style" | "subject";
  };
};
export type PutModelsTrainingImagesByModelIdAndTrainingImageIdApiResponse =
  /** status 200 200 response */ {
    trainingImage: {
      /** The training image upload date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** Automatic captioning of the image */
      automaticCaptioning: string;
      /** The URL of the image */
      downloadUrl: string;
      /** The original file name of the image (example: "my-training-image.jpg") */
      name: string;
      /** Description for the image */
      description: string;
      /** The training image ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
      id: string;
    };
  };
export type PutModelsTrainingImagesByModelIdAndTrainingImageIdApiArg = {
  /** The model Id of the training image id */
  modelId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The training image Id that will be replaced */
  trainingImageId: string;
  body: {
    /** The training image as a data URL (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=") */
    data?: string;
    /** The asset ID to use as a training image (example: "asset_GTrL3mq4SXWyMxkOHRxlpw"). If provided, "data" and "name" parameters will be ignored. */
    assetId?: string;
    /** The original file name of the image (example: "my-training-image.jpg") */
    name?: string;
    /** The preset to use for training images */
    preset?: "default" | "style" | "subject";
  };
};
export type DeleteModelsTrainingImagesByModelIdAndTrainingImageIdApiResponse =
  /** status 200 200 response */ any;
export type DeleteModelsTrainingImagesByModelIdAndTrainingImageIdApiArg = {
  /** The model Id of the training image id */
  modelId: string;
  /** The training image Id that will be deleted */
  trainingImageId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
};
export type PostModelsTransferByModelIdApiResponse =
  /** status 200 200 response */ {
    model: {
      /** The training caption words of the model */
      captionWords?: string[];
      /** The URLs of the first 3 training images of the model. To retrieve the full set of images, get it by modelId */
      trainingImages?: {
        /** The training image upload date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** Automatic captioning of the image */
        automaticCaptioning: string;
        /** The URL of the image */
        downloadUrl: string;
        /** The original file name of the image (example: "my-training-image.jpg") */
        name: string;
        /** Description for the image */
        description: string;
        /** The training image ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        id: string;
      }[];
      /** The inputs of the model. Only used for custom models. To retrieve this list, get it by modelId with GET /models/{modelId} */
      inputs?: {
        /** The allowed values of the input of type 'string' or 'string_array'
            In case of string, it's a single value select list
            In case of string_array, it's a multi value select list */
        allowedValues?: string[];
        /** The maximum value of the input (only available for inputs of type 'number' and inputs as array) */
        max?: number;
        /** The kind of the input. Only available for inputs of type 'file' (and 'file_array') */
        kind?: "3d" | "audio" | "document" | "image" | "json" | "video";
        /** The minimum length of the input where the input is a string (also available for each item in string_array) */
        minLength?: number;
        /** The description of the input, to display in the UI as an help text adding information about the input */
        description?: string;
        /** The label of the input displayed in the UI */
        label?: string;
        /** The type of the input */
        type:
          | "boolean"
          | "file"
          | "file_array"
          | "number"
          | "number_array"
          | "string"
          | "string_array";
        /** Whether the input is required */
        required: boolean;
        /** The minimum value of the input (only available for inputs of type 'number' and inputs as array) */
        min?: number;
        /** A hint to the user about the input, to display in the UI with a tooltip */
        hint?: string;
        /** The name of the input internally used by the model and API */
        name: string;
        /** The maximum length of the input where the input is a string (also available for each item in string_array) */
        maxLength?: number;
        /** The group of the input. If 2 inputs have the same group, they will be displayed in the same group in the UI
            They will be always together in this list of inputs */
        group?: string;
      }[];
      /** List of all example asset IDs setup by the model owner */
      exampleAssetIds: string[];
      /** The privacy of the model (default: private) */
      privacy: "private" | "public" | "unlisted";
      /** The date when the model will be soft deleted (only for Free plan) */
      softDeletionOn?: string;
      /** The UI configuration for the model */
      uiConfig?: {
        triggerGenerate?: {
          /** The 'name' of the input where the trigger generate button will be displayed (after the input).
                Do not specify both position and after. */
          after?: string;
          label: string;
          /** The position of the trigger generate button. If position specified, the button will be displayed at the specified position.
                Do not specify both position and after. */
          position?: "bottom" | "top";
        };
      };
      /** The source of the model */
      source: "civitai" | "huggingface" | "other" | "scenario";
      /** The owner ID (example: "team_VFhihHKMRZyDDnZAJwLb2Q") */
      ownerId?: string;
      /** The model type (example: sd-1_5) */
      type:
        | "custom"
        | "flux.1"
        | "flux.1-composition"
        | "flux.1-lora"
        | "flux.1-pro"
        | "flux.1.1-pro-ultra"
        | "flux1.1-pro"
        | "gpt-image-1"
        | "sd-1_5"
        | "sd-1_5-composition"
        | "sd-1_5-lora"
        | "sd-xl"
        | "sd-xl-composition"
        | "sd-xl-lora";
      /** The model creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** Additional information about the model's training */
      trainingStats?: {
        /** The training duration in seconds */
        trainDuration?: number;
        /** The training queued duration in seconds */
        queueDuration?: number;
        /** The training end time as an ISO date string */
        endedAt?: string;
        /** The training start time as an ISO date string */
        startedAt?: string;
      };
      /** Fine-tune the model's inferences with prompt embedding */
      promptEmbedding?: string;
      /** Additional information about the training progress of the model */
      trainingProgress?: {
        /** The stage of the request */
        stage:
          | "pending"
          | "queued-for-train"
          | "running-train"
          | "starting-train";
        /** The remaining time in milliseconds */
        remainingTimeMs?: number;
        /** The progress of the job */
        progress?: number;
        /** The timestamp in millisecond marking the start of the process */
        startedAt?: number;
        /** Position of the job in the queue (ie. the number of job in the queue before this one) */
        position?: number;
        /** Timestamp in milliseconds of the last time the training progress was updated */
        updatedAt: number;
      };
      /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
      id: string;
      /** The class of the model */
      class?: {
        /** The model ID of the class (example: "stable-diffusion-v1-5") */
        modelId: string;
        /** The class name (example: "Character Design") */
        name: string;
        /** The category slug of the class (example: "art-style") */
        category: string;
        /** Some example images URLs to showcase the class */
        thumbnails: string[];
        /** The class prompt (example: "a character design") */
        prompt: string;
        /** The concept prompt of the class (example: "a sks character design") */
        conceptPrompt: string;
        /** The class slug (example: "art-style-character-design") */
        slug: string;
        /** The class status (only published classes are listed, but unpublished classes can still appear in existing models) */
        status: "published" | "unpublished";
      };
      /** The model last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      updatedAt: string;
      /** A thumbnail for your model */
      thumbnail?: {
        /** The AssetId of the image used as a thumbnail for your model (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        assetId: string;
        /** The url of the image used as a thumbnail for your model */
        url: string;
      };
      /** List of model capabilities (example: ["txt2img", "img2img", "txt2img_ip_adapter", ...]) */
      capabilities: (
        | "controlnet"
        | "controlnet_img2img"
        | "controlnet_inpaint"
        | "controlnet_inpaint_ip_adapter"
        | "controlnet_ip_adapter"
        | "controlnet_reference"
        | "controlnet_texture"
        | "img2img"
        | "img2img_ip_adapter"
        | "img2img_texture"
        | "inpaint"
        | "inpaint_ip_adapter"
        | "outpaint"
        | "reference"
        | "reference_texture"
        | "txt2img"
        | "txt2img_ip_adapter"
        | "txt2img_texture"
      )[];
      /** The id of the parent model */
      parentModelId?: string;
      /** The total number of training images */
      trainingImagesNumber: number;
      /** Whether the model is a custom model and can be used only with POST /generate/custom/{modelId} endpoint */
      custom: boolean;
      /** The model keyword, this is a legacy parameter, please use conceptPrompt in parameters */
      modelKeyword?: string;
      /** The author user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
      authorId?: string;
      /** (Deprecated) The user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
      userId?: string;
      /** The associated tags (example: ["sci-fi", "landscape"]) */
      tags: string[];
      /** Fine-tune the model's inferences with negative prompt embedding */
      negativePromptEmbedding?: string;
      /** The concepts is required for the type model: composition */
      concepts?: {
        /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
        modelId: string;
        /** The scale of the model (example: 1.0) */
        scale: number;
      }[];
      /** A list of CollectionId this model belongs to */
      collectionIds: string[];
      /** The model name (example: "Low-poly dwarf") */
      name?: string;
      /** The model's training parameters */
      parameters?: {
        /** Whether to train the text encoder or not
            
            Example: For 100 steps and a value of 0.2, it means that the text encoder will be trained for 20 steps and then the UNet for 80 steps
            
            Note: Legacy parameter, please use `numTextTrainSteps` and `numUNetTrainSteps`
            
            Only available for SD15 and SDXL LoRA training */
        textEncoderTrainingRatio?: number;
        /** The weight of prior preservation loss
            
            Only available for SD15 and SDXL LoRA training */
        priorLossWeight?: number;
        /** Used to reproduce previous results. Default: randomly generated number.
            
            Only available for SD15 and SDXL LoRA training */
        seed?: number;
        /** The number of training steps for the UNet
            
            Only available for SDXL LoRA training */
        numUNetTrainSteps?: number;
        /** Validation frequency. Cannot be greater than maxTrainSteps value
            
            Only available for SD15 and SDXL LoRA training */
        validationFrequency?: number;
        /** Ratio of random crops
            
            Only available for SD15 and SDXL LoRA training */
        randomCropRatio?: number;
        /** Initial learning rate (after the potential warmup period)
            
            Default value varies depending on the model type:
            - For SD1.5 and SDXL: 0.000005
            - For Flux: 0.0004 */
        learningRate?: number;
        /** Optimize the model training task for a specific type of input images. The available values are:
            - "likeness": optimize training for likeness or portrait
            
            Only available for Flux LoRA training */
        optimizeFor?: "likeness" | null;
        /** Whether to random crop or center crop images before resizing to the working resolution
            
            Only available for SD15 and SDXL LoRA training */
        randomCrop?: boolean;
        /** The prompt to specify images in the same class as provided instance images
            
            Only available for SD15 training */
        classPrompt?: string;
        /** The number of training steps for the text encoder
            
            Only available for SDXL LoRA training */
        numTextTrainSteps?: number;
        /** Initial learning rate (after the potential warmup period) for the text encoder
            
            Only available for SDXL LoRA training */
        learningRateTextEncoder?: number;
        /** The Weights And Bias key to use for logging. The maximum length is 40 characters */
        wandbKey?: string;
        /** Whether to scale the learning rate
            
            Note: Legacy parameter, will be ignored
            
            Only available for SD15 and SDXL LoRA training */
        scaleLr?: boolean;
        /** Scale of random crops
            
            Only available for SD15 and SDXL LoRA training */
        randomCropScale?: number;
        /** The scheduler type to use (default: "constant")
            
            Only available for SD15 and SDXL LoRA training */
        lrScheduler?:
          | "constant"
          | "constant-with-warmup"
          | "cosine"
          | "cosine-with-restarts"
          | "linear"
          | "polynomial";
        /** The dimension of the LoRA update matrices
            
            Only available for SDXL and Flux LoRA training
            
            Default value varies depending on the model type:
            - For SDXL: 64
            - For Flux: 16 */
        rank?: number;
        /** Initial learning rate (after the potential warmup period) for the UNet
            
            Only available for SDXL LoRA training */
        learningRateUnet?: number;
        /** Validation prompt
            
            Only available for SD15 and SDXL LoRA training */
        validationPrompt?: string;
        /** The prompt with identifier specifying the instance (or subject) of the class (example: "a daiton dog")
            
            Default value varies depending on the model type:
            - For SD1.5: "daiton" if no class is associated with the model
            - For SDXL: "daiton"
            - For Flux: "" */
        conceptPrompt?: string | null;
        /** Maximum number of training steps to execute (default: varies depending on the model type)
            
            For SDXL LoRA training, please use `numTextTrainSteps` and `numUNetTrainSteps` instead
            
            Default value varies depending on the model type:
            - For SD1.5: round((number of training images * 225) / 3)
            - For SDXL: number of training images * 175
            - For Flux: number of training images * 100
            
            Maximum value varies depending on the model type:
            - For SD1.5 and SDXL: [0, 40000]
            - For Flux: [0, 10000] */
        maxTrainSteps?: number;
      };
      /** List of base model IDs compliant with the model (example: ["flux.1-dev", "flux.1-schnell"])
        This attribute is mainly used for Flux LoRA models */
      compliantModelIds?: string[];
      /** The model status */
      status:
        | "copying"
        | "failed"
        | "new"
        | "trained"
        | "training"
        | "training-canceled";
    };
  };
export type PostModelsTransferByModelIdApiArg = {
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  modelId: string;
  body: {
    /** The id of the project to copy and transfer the model to */
    destinationProjectId: string;
    /** The id of the team to copy and transfer the model to */
    destinationTeamId?: string;
  };
};
export type GetProjectsApiResponse = /** status 200 200 response */ {
  /** A token to query the next page of projects */
  nextPaginationToken?: string;
  projects: {
    createdAt: string;
    /** The keys of the project (get from the ProjectRoles table) */
    keys: {
      /** The API key creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** The status of the API key */
      apiKeyStatus: "active" | "inactive";
      role: "admin" | "editor" | "reader";
      /** The API key name (example: "eurv-scenario") */
      name: string;
      /** The API key ID (example: "eyVcnFJcR92BxBkz7N6g5w") */
      apiKeyId: string;
      /** The identifier of the API key (example: "eyVcnFJcR92BxBkz7N6g5w") */
      id: string;
      /** The API key last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      updatedAt: string;
    }[];
    /** The team ID (example: "team_eyVcnFJcR92BxBkz7N6g5w") */
    teamId: string;
    /** The project name (example: "Default Project") */
    name: string;
    /** The project ID (example: "project_eyVcnFJcR92BxBkz7N6g5w") */
    id: string;
    /** The users of the project (get from the ProjectRoles table) */
    users: {
      /** The user creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      role: "admin" | "editor" | "reader";
      /** The user ID (example: "eyVcnFJcR92BxBkz7N6g5w") */
      id: string;
      /** The user email (example: "herve@scenario.com") */
      email: string;
      /** The user last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      updatedAt: string;
    }[];
    updatedAt: string;
  }[];
};
export type GetProjectsApiArg = {
  /** The number of items to return in the response. The default value is 10, maximum value is 100, minimum value is 1 */
  pageSize?: string;
  /** The teamId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  teamId: string;
  /** A token you received in a previous request to query the next page of items */
  paginationToken?: string;
};
export type PostProjectApiResponse = /** status 200 200 response */ {
  project: {
    createdAt: string;
    /** The keys of the project (get from the ProjectRoles table) */
    keys: {
      /** The API key creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** The status of the API key */
      apiKeyStatus: "active" | "inactive";
      role: "admin" | "editor" | "reader";
      /** The API key name (example: "eurv-scenario") */
      name: string;
      /** The API key ID (example: "eyVcnFJcR92BxBkz7N6g5w") */
      apiKeyId: string;
      /** The identifier of the API key (example: "eyVcnFJcR92BxBkz7N6g5w") */
      id: string;
      /** The API key last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      updatedAt: string;
    }[];
    /** The team ID (example: "team_eyVcnFJcR92BxBkz7N6g5w") */
    teamId: string;
    /** The project name (example: "Default Project") */
    name: string;
    /** The project ID (example: "project_eyVcnFJcR92BxBkz7N6g5w") */
    id: string;
    /** The users of the project (get from the ProjectRoles table) */
    users: {
      /** The user creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      role: "admin" | "editor" | "reader";
      /** The user ID (example: "eyVcnFJcR92BxBkz7N6g5w") */
      id: string;
      /** The user email (example: "herve@scenario.com") */
      email: string;
      /** The user last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      updatedAt: string;
    }[];
    updatedAt: string;
  };
};
export type PostProjectApiArg = {
  /** The teamId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  teamId: string;
  body: {
    /** Whether to automatically join the project as admin. */
    autoJoin?: boolean;
    /** The name of the project. */
    name: string;
  };
};
export type GetProjectsByProjectIdApiResponse = /** status 200 200 response */ {
  project: {
    createdAt: string;
    /** The keys of the project (get from the ProjectRoles table) */
    keys: {
      /** The API key creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** The status of the API key */
      apiKeyStatus: "active" | "inactive";
      role: "admin" | "editor" | "reader";
      /** The API key name (example: "eurv-scenario") */
      name: string;
      /** The API key ID (example: "eyVcnFJcR92BxBkz7N6g5w") */
      apiKeyId: string;
      /** The identifier of the API key (example: "eyVcnFJcR92BxBkz7N6g5w") */
      id: string;
      /** The API key last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      updatedAt: string;
    }[];
    /** The team ID (example: "team_eyVcnFJcR92BxBkz7N6g5w") */
    teamId: string;
    /** The project name (example: "Default Project") */
    name: string;
    /** The project ID (example: "project_eyVcnFJcR92BxBkz7N6g5w") */
    id: string;
    /** The users of the project (get from the ProjectRoles table) */
    users: {
      /** The user creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      role: "admin" | "editor" | "reader";
      /** The user ID (example: "eyVcnFJcR92BxBkz7N6g5w") */
      id: string;
      /** The user email (example: "herve@scenario.com") */
      email: string;
      /** The user last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      updatedAt: string;
    }[];
    updatedAt: string;
  };
};
export type GetProjectsByProjectIdApiArg = {
  /** The projectId to get */
  projectId: string;
};
export type PutProjectsByProjectIdApiResponse = /** status 200 200 response */ {
  project: {
    createdAt: string;
    /** The keys of the project (get from the ProjectRoles table) */
    keys: {
      /** The API key creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** The status of the API key */
      apiKeyStatus: "active" | "inactive";
      role: "admin" | "editor" | "reader";
      /** The API key name (example: "eurv-scenario") */
      name: string;
      /** The API key ID (example: "eyVcnFJcR92BxBkz7N6g5w") */
      apiKeyId: string;
      /** The identifier of the API key (example: "eyVcnFJcR92BxBkz7N6g5w") */
      id: string;
      /** The API key last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      updatedAt: string;
    }[];
    /** The team ID (example: "team_eyVcnFJcR92BxBkz7N6g5w") */
    teamId: string;
    /** The project name (example: "Default Project") */
    name: string;
    /** The project ID (example: "project_eyVcnFJcR92BxBkz7N6g5w") */
    id: string;
    /** The users of the project (get from the ProjectRoles table) */
    users: {
      /** The user creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      role: "admin" | "editor" | "reader";
      /** The user ID (example: "eyVcnFJcR92BxBkz7N6g5w") */
      id: string;
      /** The user email (example: "herve@scenario.com") */
      email: string;
      /** The user last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      updatedAt: string;
    }[];
    updatedAt: string;
  };
};
export type PutProjectsByProjectIdApiArg = {
  /** The projectId to update */
  projectId: string;
  body: {
    /** The new name for the Project */
    name: string;
  };
};
export type DeleteProjectsByProjectIdApiResponse =
  /** status 200 200 response */ any;
export type DeleteProjectsByProjectIdApiArg = {
  /** The project Id to delete */
  projectId: string;
};
export type PostProjectsApiKeysByProjectIdApiResponse =
  /** status 200 200 response */ {
    createdAt: string;
    id: string;
    secret: string;
    authorId: string;
    ownerId: string;
  };
export type PostProjectsApiKeysByProjectIdApiArg = {
  /** The project Id on which an api key will be created */
  projectId: string;
  body: {
    /** The API Key name */
    name?: string;
  };
};
export type DeleteProjectsApiKeyByProjectIdAndKeyIdApiResponse =
  /** status 200 200 response */ object;
export type DeleteProjectsApiKeyByProjectIdAndKeyIdApiArg = {
  /** The key Id to delete */
  keyId: string;
  /** The project Id on which the api key exists */
  projectId: string;
};
export type PostProjectsMembersByProjectIdApiResponse =
  /** status 200 200 response */ {
    project: {
      createdAt: string;
      /** The keys of the project (get from the ProjectRoles table) */
      keys: {
        /** The API key creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The status of the API key */
        apiKeyStatus: "active" | "inactive";
        role: "admin" | "editor" | "reader";
        /** The API key name (example: "eurv-scenario") */
        name: string;
        /** The API key ID (example: "eyVcnFJcR92BxBkz7N6g5w") */
        apiKeyId: string;
        /** The identifier of the API key (example: "eyVcnFJcR92BxBkz7N6g5w") */
        id: string;
        /** The API key last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      }[];
      /** The team ID (example: "team_eyVcnFJcR92BxBkz7N6g5w") */
      teamId: string;
      /** The project name (example: "Default Project") */
      name: string;
      /** The project ID (example: "project_eyVcnFJcR92BxBkz7N6g5w") */
      id: string;
      /** The users of the project (get from the ProjectRoles table) */
      users: {
        /** The user creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        role: "admin" | "editor" | "reader";
        /** The user ID (example: "eyVcnFJcR92BxBkz7N6g5w") */
        id: string;
        /** The user email (example: "herve@scenario.com") */
        email: string;
        /** The user last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      }[];
      updatedAt: string;
    };
  };
export type PostProjectsMembersByProjectIdApiArg = {
  /** The project Id on which to add the member */
  projectId: string;
  body: {
    /** The role you want to give the user */
    role?: string;
    /** The userId of the user you want to add to your project */
    userId?: string;
  };
};
export type PutProjectsMembersByProjectIdAndMemberIdApiResponse =
  /** status 200 200 response */ any;
export type PutProjectsMembersByProjectIdAndMemberIdApiArg = {
  /** The member Id concerned by the new role */
  memberId: string;
  /** The project Id concerned by the role change */
  projectId: string;
  body: {
    /** The role you want to give the member */
    role?: string;
  };
};
export type DeleteProjectsMembersByProjectIdAndMemberIdApiResponse =
  /** status 200 200 response */ object;
export type DeleteProjectsMembersByProjectIdAndMemberIdApiArg = {
  /** The member Id to remove */
  memberId: string;
  /** The project Id concerned by the member removal */
  projectId: string;
};
export type GetProjectWebhookEndpointsApiResponse =
  /** status 200 200 response */ {
    /** A list of the project webhooks */
    webhookEndpoints: {
      /** The date and time the webhook endpoint was created */
      createdAt: string;
      /** The number of calls to the webhook endpoint */
      nbTotalCalls: number;
      /** The events that trigger the webhook. ['*'] indicates that all events are enabled */
      enabledEvents: (
        | "*"
        | "asset.download.completed"
        | "asset.download.created"
        | "asset.download.failed"
        | "inference.cancelled"
        | "inference.completed"
        | "inference.created"
        | "inference.failed"
        | "model.download.completed"
        | "model.download.created"
        | "model.download.failed"
        | "model.training.cancelled"
        | "model.training.completed"
        | "model.training.failed"
        | "model.training.started"
      )[];
      /** The number of calls to the webhook endpoint that have failed */
      nbFailedCalls: number;
      /** A description of the webhook endpoint */
      description?: string;
      /** The ID of the webhook endpoint */
      id: string;
      /** The endpoint's secret, used to generate webhook signatures. Only returned at creation */
      secret?: string;
      /** The ID of the owner of the webhook endpoint */
      ownerId: string;
      /** Whether the webhook is enabled */
      enabled: boolean;
      /** The URL of the webhook endpoint */
      url: string;
      /** The date and time the webhook endpoint was updated */
      updatedAt: string;
    }[];
  };
export type GetProjectWebhookEndpointsApiArg = {
  /** The projectId to get */
  projectId: string;
};
export type PostProjectWebhookEndpointsApiResponse =
  /** status 200 200 response */ {
    webhookEndpoint: {
      /** The date and time the webhook endpoint was created */
      createdAt: string;
      /** The number of calls to the webhook endpoint */
      nbTotalCalls: number;
      /** The events that trigger the webhook. ['*'] indicates that all events are enabled */
      enabledEvents: (
        | "*"
        | "asset.download.completed"
        | "asset.download.created"
        | "asset.download.failed"
        | "inference.cancelled"
        | "inference.completed"
        | "inference.created"
        | "inference.failed"
        | "model.download.completed"
        | "model.download.created"
        | "model.download.failed"
        | "model.training.cancelled"
        | "model.training.completed"
        | "model.training.failed"
        | "model.training.started"
      )[];
      /** The number of calls to the webhook endpoint that have failed */
      nbFailedCalls: number;
      /** A description of the webhook endpoint */
      description?: string;
      /** The ID of the webhook endpoint */
      id: string;
      /** The endpoint's secret, used to generate webhook signatures. Only returned at creation */
      secret?: string;
      /** The ID of the owner of the webhook endpoint */
      ownerId: string;
      /** Whether the webhook is enabled */
      enabled: boolean;
      /** The URL of the webhook endpoint */
      url: string;
      /** The date and time the webhook endpoint was updated */
      updatedAt: string;
    };
  };
export type PostProjectWebhookEndpointsApiArg = {
  projectId: string;
  body: {
    /** The events that trigger the webhook. ['*'] indicates that all events are enabled */
    enabledEvents: (
      | "*"
      | "asset.download.completed"
      | "asset.download.created"
      | "asset.download.failed"
      | "inference.cancelled"
      | "inference.completed"
      | "inference.created"
      | "inference.failed"
      | "model.download.completed"
      | "model.download.created"
      | "model.download.failed"
      | "model.training.cancelled"
      | "model.training.completed"
      | "model.training.failed"
      | "model.training.started"
    )[];
    /** A description of the webhook endpoint */
    description?: string;
    /** The URL of the webhook endpoint */
    url: string;
  };
};
export type PutProjectWebhookEndpointByIdApiResponse =
  /** status 200 200 response */ {
    webhookEndpoint: {
      /** The date and time the webhook endpoint was created */
      createdAt: string;
      /** The number of calls to the webhook endpoint */
      nbTotalCalls: number;
      /** The events that trigger the webhook. ['*'] indicates that all events are enabled */
      enabledEvents: (
        | "*"
        | "asset.download.completed"
        | "asset.download.created"
        | "asset.download.failed"
        | "inference.cancelled"
        | "inference.completed"
        | "inference.created"
        | "inference.failed"
        | "model.download.completed"
        | "model.download.created"
        | "model.download.failed"
        | "model.training.cancelled"
        | "model.training.completed"
        | "model.training.failed"
        | "model.training.started"
      )[];
      /** The number of calls to the webhook endpoint that have failed */
      nbFailedCalls: number;
      /** A description of the webhook endpoint */
      description?: string;
      /** The ID of the webhook endpoint */
      id: string;
      /** The endpoint's secret, used to generate webhook signatures. Only returned at creation */
      secret?: string;
      /** The ID of the owner of the webhook endpoint */
      ownerId: string;
      /** Whether the webhook is enabled */
      enabled: boolean;
      /** The URL of the webhook endpoint */
      url: string;
      /** The date and time the webhook endpoint was updated */
      updatedAt: string;
    };
  };
export type PutProjectWebhookEndpointByIdApiArg = {
  /** The webhook endpoint to update */
  webhookEndpointId: string;
  /** The project Id */
  projectId: string;
  body: {
    /** The events that trigger the webhook. ['*'] indicates that all events are enabled */
    enabledEvents?: (
      | "*"
      | "asset.download.completed"
      | "asset.download.created"
      | "asset.download.failed"
      | "inference.cancelled"
      | "inference.completed"
      | "inference.created"
      | "inference.failed"
      | "model.download.completed"
      | "model.download.created"
      | "model.download.failed"
      | "model.training.cancelled"
      | "model.training.completed"
      | "model.training.failed"
      | "model.training.started"
    )[];
    /** A description of the webhook endpoint */
    description?: string;
    /** Whether the webhook is enabled */
    enabled?: boolean;
    /** The URL of the webhook endpoint */
    url?: string;
  };
};
export type DeleteProjectWebhookEndpointByIdApiResponse =
  /** status 200 200 response */ any;
export type DeleteProjectWebhookEndpointByIdApiArg = {
  /** The webhook endpoint to delete */
  webhookEndpointId: string;
  /** The project Id */
  projectId: string;
};
export type GetProjectWebhookEndpointEventsApiResponse =
  /** status 200 200 response */ {
    /** A list of the project webhook events */
    items: {
      createdAt: string;
      payload: {};
      endpointId: string;
      id: string;
      sentAt: string;
      type:
        | "asset.download.completed"
        | "asset.download.created"
        | "asset.download.failed"
        | "inference.cancelled"
        | "inference.completed"
        | "inference.created"
        | "inference.failed"
        | "model.download.completed"
        | "model.download.created"
        | "model.download.failed"
        | "model.training.cancelled"
        | "model.training.completed"
        | "model.training.failed"
        | "model.training.started";
      attempts: {
        responseStatusCode: number;
        sentAt: string;
      }[];
      status: "created" | "failed" | "retrying" | "success";
      updatedAt: string;
    }[];
  };
export type GetProjectWebhookEndpointEventsApiArg = {
  /** The projectId to get */
  projectId: string;
  webhookEndpointId: string;
};
export type GetWebhookEventApiResponse = /** status 200 200 response */ {
  webhookEvent: {
    createdAt: string;
    payload: {};
    endpointId: string;
    id: string;
    sentAt: string;
    type:
      | "asset.download.completed"
      | "asset.download.created"
      | "asset.download.failed"
      | "inference.cancelled"
      | "inference.completed"
      | "inference.created"
      | "inference.failed"
      | "model.download.completed"
      | "model.download.created"
      | "model.download.failed"
      | "model.training.cancelled"
      | "model.training.completed"
      | "model.training.failed"
      | "model.training.started";
    attempts: {
      responseStatusCode: number;
      sentAt: string;
    }[];
    status: "created" | "failed" | "retrying" | "success";
    updatedAt: string;
  };
};
export type GetWebhookEventApiArg = {
  eventId: string;
  /** The projectId to get */
  projectId: string;
  webhookEndpointId: string;
};
export type PutPromptGeneratorApiResponse =
  /** status 200 200 response */
  | {
      /** The prompt generator mode used to generate the new predictions.
    
    The mode might be different from the one provided in the request. Depending on the given paramters inputs.
    Ex: if the structured mode is provided, but there is either a `modelId` provided or one or mode `assetId` provided, inventive mode will be used to match the determined prompt examples. */
      mode:
        | "completion"
        | "image-captioning"
        | "image-editing"
        | "inventive"
        | "structured"
        | "style-description"
        | "translation";
      /** A short synthesis that describes the given asset(s) or asset(s) model.
    
    Only available for `style-description`. */
      synthesis?: string;
      /** The generated prompts new predictions. */
      newPredictions: string[];
      /** Detected language of the input.
    
    Only available for `translation` mode. */
      detectedLanguage?: string;
    }
  | /** status 269 269 response */ {
      /** The number of creative units consumed for this action. */
      creativeUnitsCost: number;
    };
export type PutPromptGeneratorApiArg = {
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  dryRun?: string;
  body: {
    /** The prompt generation mode */
    mode?:
      | "completion"
      | "image-captioning"
      | "image-editing"
      | "inventive"
      | "structured"
      | "style-description"
      | "translation";
    /** Whether we try to ensure IP removal for new prompt generation. */
    ensureIPCleared?: boolean;
    /** The input image as a data URL (example: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=") or the asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw")
        
        Only available when `mode` is `image-editing-prompt`. */
    image?: string;
    /** If specified, the API will make a best effort to produce the same results, such that repeated requests with the same `seed` and parameters should return the same outputs. Must be used along with the same parameters including prompt, model's state, etc.. */
    seed?: number;
    /** Optional list of words sequences that should not be present in the generated prompts. */
    unwantedSequences?: string[];
    /** The modelId used to condition the generation.
        
        When provided, the generation will take into account model's training images, examples. */
    modelId?: string;
    /** The sampling temperature to use. Higher values like `0.8` will make the output more random, while lower values like `0.2` will make it more focused and deterministic.
        
        We generally recommend altering this or `topP` but not both. */
    temperature?: number;
    /** The asset ids used to condition the generation.
        
        Notes: supersedes the `modelId` parameter when provided. */
    assetIds?: string[];
    /** The number of results to return. */
    numResults?: number;
    /** The initial prompt used with the `completion`, `inventive`, `structured` and `translation` modes.
        
        In `completion`, `inventive` and `structured` modes, the prompt is truncated to roughly 70 words.
        In `translation` mode, the prompt must be between 8 and no more than 512 characters. */
    prompt?: string;
    /** An alternative to sampling with temperature, called nucleus sampling, where the model considers the results of the tokens with top_p probability mass. So `0.1` means only the tokens comprising the top `10%` probability mass are considered.
        
        We generally recommend altering this or `temperature` but not both. */
    topP?: number;
    /** The details level used to generate the captions.
        
        Only available for `image-captioning` mode. */
    detailsLevel?: "action" | "action+style";
  };
};
export type GetRecommendationsModelsApiResponse =
  /** status 200 200 response */ {
    models: {
      /** The training caption words of the model */
      captionWords?: string[];
      /** The URLs of the first 3 training images of the model. To retrieve the full set of images, get it by modelId */
      trainingImages?: {
        /** The training image upload date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** Automatic captioning of the image */
        automaticCaptioning: string;
        /** The URL of the image */
        downloadUrl: string;
        /** The original file name of the image (example: "my-training-image.jpg") */
        name: string;
        /** Description for the image */
        description: string;
        /** The training image ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        id: string;
      }[];
      /** The inputs of the model. Only used for custom models. To retrieve this list, get it by modelId with GET /models/{modelId} */
      inputs?: {
        /** The allowed values of the input of type 'string' or 'string_array'
            In case of string, it's a single value select list
            In case of string_array, it's a multi value select list */
        allowedValues?: string[];
        /** The maximum value of the input (only available for inputs of type 'number' and inputs as array) */
        max?: number;
        /** The kind of the input. Only available for inputs of type 'file' (and 'file_array') */
        kind?: "3d" | "audio" | "document" | "image" | "json" | "video";
        /** The minimum length of the input where the input is a string (also available for each item in string_array) */
        minLength?: number;
        /** The description of the input, to display in the UI as an help text adding information about the input */
        description?: string;
        /** The label of the input displayed in the UI */
        label?: string;
        /** The type of the input */
        type:
          | "boolean"
          | "file"
          | "file_array"
          | "number"
          | "number_array"
          | "string"
          | "string_array";
        /** Whether the input is required */
        required: boolean;
        /** The minimum value of the input (only available for inputs of type 'number' and inputs as array) */
        min?: number;
        /** A hint to the user about the input, to display in the UI with a tooltip */
        hint?: string;
        /** The name of the input internally used by the model and API */
        name: string;
        /** The maximum length of the input where the input is a string (also available for each item in string_array) */
        maxLength?: number;
        /** The group of the input. If 2 inputs have the same group, they will be displayed in the same group in the UI
            They will be always together in this list of inputs */
        group?: string;
      }[];
      /** List of all example asset IDs setup by the model owner */
      exampleAssetIds: string[];
      /** The privacy of the model (default: private) */
      privacy: "private" | "public" | "unlisted";
      /** The date when the model will be soft deleted (only for Free plan) */
      softDeletionOn?: string;
      /** The UI configuration for the model */
      uiConfig?: {
        triggerGenerate?: {
          /** The 'name' of the input where the trigger generate button will be displayed (after the input).
                Do not specify both position and after. */
          after?: string;
          label: string;
          /** The position of the trigger generate button. If position specified, the button will be displayed at the specified position.
                Do not specify both position and after. */
          position?: "bottom" | "top";
        };
      };
      /** The source of the model */
      source: "civitai" | "huggingface" | "other" | "scenario";
      /** The owner ID (example: "team_VFhihHKMRZyDDnZAJwLb2Q") */
      ownerId?: string;
      /** The model type (example: sd-1_5) */
      type:
        | "custom"
        | "flux.1"
        | "flux.1-composition"
        | "flux.1-lora"
        | "flux.1-pro"
        | "flux.1.1-pro-ultra"
        | "flux1.1-pro"
        | "gpt-image-1"
        | "sd-1_5"
        | "sd-1_5-composition"
        | "sd-1_5-lora"
        | "sd-xl"
        | "sd-xl-composition"
        | "sd-xl-lora";
      /** The model creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** Additional information about the model's training */
      trainingStats?: {
        /** The training duration in seconds */
        trainDuration?: number;
        /** The training queued duration in seconds */
        queueDuration?: number;
        /** The training end time as an ISO date string */
        endedAt?: string;
        /** The training start time as an ISO date string */
        startedAt?: string;
      };
      /** Fine-tune the model's inferences with prompt embedding */
      promptEmbedding?: string;
      /** Additional information about the training progress of the model */
      trainingProgress?: {
        /** The stage of the request */
        stage:
          | "pending"
          | "queued-for-train"
          | "running-train"
          | "starting-train";
        /** The remaining time in milliseconds */
        remainingTimeMs?: number;
        /** The progress of the job */
        progress?: number;
        /** The timestamp in millisecond marking the start of the process */
        startedAt?: number;
        /** Position of the job in the queue (ie. the number of job in the queue before this one) */
        position?: number;
        /** Timestamp in milliseconds of the last time the training progress was updated */
        updatedAt: number;
      };
      /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
      id: string;
      /** The class of the model */
      class?: {
        /** The model ID of the class (example: "stable-diffusion-v1-5") */
        modelId: string;
        /** The class name (example: "Character Design") */
        name: string;
        /** The category slug of the class (example: "art-style") */
        category: string;
        /** Some example images URLs to showcase the class */
        thumbnails: string[];
        /** The class prompt (example: "a character design") */
        prompt: string;
        /** The concept prompt of the class (example: "a sks character design") */
        conceptPrompt: string;
        /** The class slug (example: "art-style-character-design") */
        slug: string;
        /** The class status (only published classes are listed, but unpublished classes can still appear in existing models) */
        status: "published" | "unpublished";
      };
      /** The model last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      updatedAt: string;
      /** A thumbnail for your model */
      thumbnail?: {
        /** The AssetId of the image used as a thumbnail for your model (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        assetId: string;
        /** The url of the image used as a thumbnail for your model */
        url: string;
      };
      /** List of model capabilities (example: ["txt2img", "img2img", "txt2img_ip_adapter", ...]) */
      capabilities: (
        | "controlnet"
        | "controlnet_img2img"
        | "controlnet_inpaint"
        | "controlnet_inpaint_ip_adapter"
        | "controlnet_ip_adapter"
        | "controlnet_reference"
        | "controlnet_texture"
        | "img2img"
        | "img2img_ip_adapter"
        | "img2img_texture"
        | "inpaint"
        | "inpaint_ip_adapter"
        | "outpaint"
        | "reference"
        | "reference_texture"
        | "txt2img"
        | "txt2img_ip_adapter"
        | "txt2img_texture"
      )[];
      /** The id of the parent model */
      parentModelId?: string;
      /** The total number of training images */
      trainingImagesNumber: number;
      /** Whether the model is a custom model and can be used only with POST /generate/custom/{modelId} endpoint */
      custom: boolean;
      /** The model keyword, this is a legacy parameter, please use conceptPrompt in parameters */
      modelKeyword?: string;
      /** The author user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
      authorId?: string;
      /** (Deprecated) The user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
      userId?: string;
      /** The associated tags (example: ["sci-fi", "landscape"]) */
      tags: string[];
      /** Fine-tune the model's inferences with negative prompt embedding */
      negativePromptEmbedding?: string;
      /** The concepts is required for the type model: composition */
      concepts?: {
        /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
        modelId: string;
        /** The scale of the model (example: 1.0) */
        scale: number;
      }[];
      /** A list of CollectionId this model belongs to */
      collectionIds: string[];
      /** The model name (example: "Low-poly dwarf") */
      name?: string;
      /** The model's training parameters */
      parameters?: {
        /** Whether to train the text encoder or not
            
            Example: For 100 steps and a value of 0.2, it means that the text encoder will be trained for 20 steps and then the UNet for 80 steps
            
            Note: Legacy parameter, please use `numTextTrainSteps` and `numUNetTrainSteps`
            
            Only available for SD15 and SDXL LoRA training */
        textEncoderTrainingRatio?: number;
        /** The weight of prior preservation loss
            
            Only available for SD15 and SDXL LoRA training */
        priorLossWeight?: number;
        /** Used to reproduce previous results. Default: randomly generated number.
            
            Only available for SD15 and SDXL LoRA training */
        seed?: number;
        /** The number of training steps for the UNet
            
            Only available for SDXL LoRA training */
        numUNetTrainSteps?: number;
        /** Validation frequency. Cannot be greater than maxTrainSteps value
            
            Only available for SD15 and SDXL LoRA training */
        validationFrequency?: number;
        /** Ratio of random crops
            
            Only available for SD15 and SDXL LoRA training */
        randomCropRatio?: number;
        /** Initial learning rate (after the potential warmup period)
            
            Default value varies depending on the model type:
            - For SD1.5 and SDXL: 0.000005
            - For Flux: 0.0004 */
        learningRate?: number;
        /** Optimize the model training task for a specific type of input images. The available values are:
            - "likeness": optimize training for likeness or portrait
            
            Only available for Flux LoRA training */
        optimizeFor?: "likeness" | null;
        /** Whether to random crop or center crop images before resizing to the working resolution
            
            Only available for SD15 and SDXL LoRA training */
        randomCrop?: boolean;
        /** The prompt to specify images in the same class as provided instance images
            
            Only available for SD15 training */
        classPrompt?: string;
        /** The number of training steps for the text encoder
            
            Only available for SDXL LoRA training */
        numTextTrainSteps?: number;
        /** Initial learning rate (after the potential warmup period) for the text encoder
            
            Only available for SDXL LoRA training */
        learningRateTextEncoder?: number;
        /** The Weights And Bias key to use for logging. The maximum length is 40 characters */
        wandbKey?: string;
        /** Whether to scale the learning rate
            
            Note: Legacy parameter, will be ignored
            
            Only available for SD15 and SDXL LoRA training */
        scaleLr?: boolean;
        /** Scale of random crops
            
            Only available for SD15 and SDXL LoRA training */
        randomCropScale?: number;
        /** The scheduler type to use (default: "constant")
            
            Only available for SD15 and SDXL LoRA training */
        lrScheduler?:
          | "constant"
          | "constant-with-warmup"
          | "cosine"
          | "cosine-with-restarts"
          | "linear"
          | "polynomial";
        /** The dimension of the LoRA update matrices
            
            Only available for SDXL and Flux LoRA training
            
            Default value varies depending on the model type:
            - For SDXL: 64
            - For Flux: 16 */
        rank?: number;
        /** Initial learning rate (after the potential warmup period) for the UNet
            
            Only available for SDXL LoRA training */
        learningRateUnet?: number;
        /** Validation prompt
            
            Only available for SD15 and SDXL LoRA training */
        validationPrompt?: string;
        /** The prompt with identifier specifying the instance (or subject) of the class (example: "a daiton dog")
            
            Default value varies depending on the model type:
            - For SD1.5: "daiton" if no class is associated with the model
            - For SDXL: "daiton"
            - For Flux: "" */
        conceptPrompt?: string | null;
        /** Maximum number of training steps to execute (default: varies depending on the model type)
            
            For SDXL LoRA training, please use `numTextTrainSteps` and `numUNetTrainSteps` instead
            
            Default value varies depending on the model type:
            - For SD1.5: round((number of training images * 225) / 3)
            - For SDXL: number of training images * 175
            - For Flux: number of training images * 100
            
            Maximum value varies depending on the model type:
            - For SD1.5 and SDXL: [0, 40000]
            - For Flux: [0, 10000] */
        maxTrainSteps?: number;
      };
      /** List of base model IDs compliant with the model (example: ["flux.1-dev", "flux.1-schnell"])
        This attribute is mainly used for Flux LoRA models */
      compliantModelIds?: string[];
      /** The model status */
      status:
        | "copying"
        | "failed"
        | "new"
        | "trained"
        | "training"
        | "training-canceled";
    }[];
    /** A token to query the next page of recommendations */
    nextToken?: string;
  };
export type GetRecommendationsModelsApiArg = {
  /** The model ids to exclude from the response. The default value is an empty array */
  excludeModelIds?: string;
  /** The maximum number of models to return. The default value is `10` and the maximum value is `20` */
  limit?: string;
  /** The token to retrieve the next page of results. The default value is an empty string */
  nextToken?: string;
  /** The privacy of the models to return. The default value is `private`, possible values are `private` and `public` */
  privacy?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The tags to filter the models by. The tags are comma separated and the default value is an empty string */
  tags?: string;
  /** The model types to exclude from the response. The default value is an empty array */
  excludeTypes?: string;
  /** The type of the models to return. The default value is an empty string */
  modelType?: string;
};
export type PostSearchAssetsApiResponse = /** status 200 200 response */ {
  hits: {
    /** Metadata containing detailed information about the asset's properties and generation parameters */
    metadata: {
      /** Thumbnail image information for the asset. Ex. Canvas thumbnail */
      thumbnail?: {
        /** ID of the asset used as thumbnail */
        assetId: string;
      };
      /** Random seed used for generation, enables reproducibility */
      seed?: string;
      /** ID of the specific model used if asset is model-based */
      modelId?: string;
      /** Classification of the asset (e.g., "image", "video") */
      kind?: string;
      /** Aspect ratio of the asset (e.g., "1:1", "16:9") */
      aspectRatio?: string;
      /** Type of model used for generation (e.g., "sd-1_5", "flux.1") */
      modelType?: string;
      /** Specific type/category of the asset (e.g., "canvas", "inference-txt") */
      type?: string;
      /** Negative prompt used during generation to specify what to avoid */
      negativePrompt?: string;
      /** Scheduler algorithm used during generation */
      scheduler?: string;
      /** File size of the asset in bytes */
      size?: number;
      /** Guidance scale used for diffusion models to control prompt adherence */
      guidance?: number;
      /** Number of inference steps used during generation */
      numInferenceSteps?: number;
      /** ID of the parent job that created this asset */
      parentJobId?: string;
      /** Custom name given to the asset */
      name?: string;
      /** Width of the asset in pixels */
      width?: number;
      /** ID of the base model used for generation */
      baseModelId?: string;
      /** Text prompt used to generate the asset */
      prompt?: string;
      /** Height of the asset in pixels */
      height?: number;
    };
    /** Array of detected NSFW categories */
    nsfw: string[];
    /** Textual description of the asset. Can be either:
        - User-provided description for training images
        - Automatically generated caption for other assets */
    description?: string;
    /** Privacy setting of the asset ("public", "private", or "unlisted") */
    privacy: string;
    /** MIME type of the asset (e.g., "image/png", "image/jpeg") */
    mimeType: string;
    /** User ID of the asset creator/author */
    authorId: string;
    /** Project ID of the asset owner */
    ownerId: string;
    /** Signed URL of the asset */
    url: string;
    /** Array of user-assigned tags for categorization */
    tags: string[];
    /** Creation timestamp in ISO 8601 format (e.g., "2025-01-16T11:19:41.579Z") */
    createdAt: string;
    /** Score assigned to the asset based on usage and popularity */
    score?: number;
    /** Array of collection IDs this asset belongs to */
    collectionIds: string[];
    /** Team ID of the asset owner */
    teamId: string;
    /** Unique identifier for the asset (e.g., "asset_GTrL3mq4SXWyMxkOHRxlpw") */
    id: string;
    /** Last modification timestamp in ISO 8601 format (e.g., "2025-01-16T11:19:41.579Z") */
    updatedAt: string;
  }[];
  /** Number of documents skipped */
  offset: number;
  /** Number of results on each page */
  hitsPerPage?: number;
  /** Exhaustive total number of matches */
  totalHits?: number;
  /** Maximum number of documents returned */
  limit: number;
  /** Exhaustive total number of search result pages */
  totalPages?: number;
  /** Current search results page */
  page?: number;
  /** Estimated total number of hits */
  estimatedTotalHits?: number;
};
export type PostSearchAssetsApiArg = {
  /** If set to true, returns the original asset without transformation */
  originalAssets?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** Filter queries by an attribute's value */
    filter?: string;
    /** Search for similar images with `image` as a reference.
        
        Must be an existing `AssetId` or a valid data URL. */
    image?: string;
    /** Image embedding ratio for hybrid search, applied when `image`, `images.like`, or `images.unlike`
        are provided */
    imageSemanticRatio?: number;
    /** Search for similar images with `images.like` and `images.unlike` as a reference
        
        Must be arrays of existing `AssetId` or valid data URLs. */
    images?: {
      /** Search for similar images with `images.like` as a reference.
            
            Must be an array of existing `AssetId` or valid data URLs. */
      like?: string[];
      /** Search for images that are not similar to `images.unlike` as a reference.
            
            Must be an array of existing `AssetId` or valid data URLs. */
      unlike?: string[];
    };
    /** Number of documents to skip. Must be used with `limit`. Starts from 0. */
    offset?: number;
    /** Search for public images not necessarily belonging to the current `ownerId` */
    public?: boolean;
    /** Maximum number of documents returned for a page. Must be used with `page`. */
    hitsPerPage?: number;
    /** A string used for querying search results. */
    query?: string;
    /** Maximum number of documents returned. Must be used with `offset`. */
    limit?: number;
    /** Sort the search results by the given attributes. Each attribute in the list must be followed by a colon (`:`) and the preferred sorting order: either ascending (`asc`) or descending (`desc`).
        
        Example: `['createdAt:desc']` */
    sortBy?: string[];
    /** Request a specific page of results. Must be used with `hitsPerPage`. */
    page?: number;
    /** Query embedding for hybrid search, if possible */
    querySemanticRatio?: number;
  };
};
export type PostSearchModelsApiResponse = /** status 200 200 response */ {
  hits: {
    /** Thumbnail image information for the model */
    thumbnail?: {
      /** ID of the asset used as thumbnail */
      assetId: string;
      /** Signed URL of the thumbnail */
      url: string;
    };
    /** Array of words used for model captioning and search */
    captionWords: string[];
    /** ID of the parent model this model was derived from */
    parentModelId?: string;
    /** Number of images used to train this model */
    trainingImagesNumber: number;
    /** Array of example asset IDs associated with this model */
    exampleAssetIds: string[];
    /** Privacy setting of the model ("public", "private", or "unlisted") */
    privacy: string;
    /** Source/origin of the model (e.g., "training", "import") */
    source: string;
    /** User ID of the model creator/author */
    authorId: string;
    /** Project ID of the model owner */
    ownerId: string;
    /** Type of the model (e.g., "sd-1_5", "flux.1") */
    type: string;
    /** Array of user-assigned tags for categorization */
    tags: string[];
    /** Creation timestamp in ISO 8601 format (e.g., "2025-01-16T11:19:41.579Z") */
    createdAt: string;
    /** Score assigned to the model based on usage and popularity */
    score?: number;
    /** Array of concept models associated with this model
        Each concept contains a reference to its source model */
    concepts: {
      /** ID of the concept's source model */
      modelId: string;
    }[];
    /** Array of collection IDs this model belongs to */
    collectionIds: string[];
    /** Team ID of the model owner */
    teamId: string;
    /** Display name of the model */
    name: string;
    /** Unique identifier for the model (e.g., "model_GTrL3mq4SXWyMxkOHRxlpw") */
    id: string;
    /** Last modification timestamp in ISO 8601 format (e.g., "2025-01-16T11:19:41.579Z") */
    updatedAt: string;
  }[];
  /** Number of documents skipped */
  offset: number;
  /** Number of results on each page */
  hitsPerPage?: number;
  /** Exhaustive total number of matches */
  totalHits?: number;
  /** Maximum number of documents returned */
  limit: number;
  /** Exhaustive total number of search result pages */
  totalPages?: number;
  /** Current search results page */
  page?: number;
  /** Estimated total number of hits */
  estimatedTotalHits?: number;
};
export type PostSearchModelsApiArg = {
  originalModels?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** Filter queries by an attribute's value */
    filter?: string;
    /** Search for model with `image` as a reference
        
        Must be an existing `AssetId` or a valid data URL. */
    image?: string;
    /** Image embedding ratio for hybrid search, applied when `image`, `images.like`, or `images.unlike`
        are provided */
    imageSemanticRatio?: number;
    /** Search for model with `images.like` and `images.unlike` as a reference
        
        Must be an array of existing `AssetId` or valid data URLs. */
    images?: {
      /** Search for model images with `images.like` as a reference
            
            Must be an array of existing `AssetId` or valid data URLs. */
      like?: string[];
      /** Search for model images that are not similar to `images.unlike` as a reference
            
            Must be an array of existing `AssetId` or valid data URLs. */
      unlike?: string[];
    };
    /** Number of documents to skip. Must be used with `limit`. Starts from 0. */
    offset?: number;
    /** Search for public images not necessarily belonging to the current `ownerId` */
    public?: boolean;
    /** Maximum number of documents returned for a page. Must be used with `page`. */
    hitsPerPage?: number;
    /** A string used for querying search results. */
    query?: string;
    /** Maximum number of documents returned. Must be used with `offset`. */
    limit?: number;
    /** Sort the search results by the given attributes. Each attribute in the list must be followed by a colon (`:`) and the preferred sorting order: either ascending (`asc`) or descending (`desc`).
        
        Example: `['createdAt:desc']` */
    sortBy?: string[];
    /** Request a specific page of results. Must be used with `hitsPerPage`. */
    page?: number;
    /** Query embedding for hybrid search, if possible */
    querySemanticRatio?: number;
  };
};
export type GetTagsApiResponse = /** status 200 200 response */ {
  /** A token to query the next page of tags */
  nextPaginationToken?: string;
  tags: {
    /** The tag creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt: string;
    /** The owner ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
    ownerId: string;
    /** The tag name */
    tagName: string;
    /** The number of items that have this tag */
    itemCount: number;
    /** The tag last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    updatedAt: string;
  }[];
};
export type GetTagsApiArg = {
  /** The number of items to return in the response. The default value is 50, maximum value is 100, minimum value is 1 */
  pageSize?: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  /** A token you received in a previous request to query the next page of items */
  paginationToken?: string;
};
export type GetTeamsApiResponse = /** status 200 200 response */ {
  /** A list of the teams the user belongs to */
  teams: {
    /** The team creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt: string;
    /** Projects of the team */
    projects: {
      createdAt: string;
      name: string;
      id: string;
      updatedAt: string;
    }[];
    /** The context of the team for the current authenticated user */
    context: {
      /** The number of invitations on this team */
      invitationsCount: number;
      /** The number of users on this team */
      usersCount: number;
      /** The authenticated user's role for this team */
      userRole: "admin" | "key" | "member";
      /** The number of API keys on this team */
      keysCount: number;
    };
    /** The team name (example: "Scenario") */
    name: string;
    /** The team ID (example: "eyVcnFJcR92BxBkz7N6g5w") */
    id: string;
    /** The team type */
    type: "personal" | "shared";
    /** The team plan */
    plan:
      | "cu-creator"
      | "cu-pro"
      | "cu-team"
      | "cu-team-v2"
      | "enterprise"
      | "essential"
      | "free"
      | "premium"
      | "pro";
    /** The team update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    updatedAt: string;
  }[];
};
export type GetTeamsApiArg = void;
export type PostTeamsApiResponse = /** status 200 200 response */ {
  team: {
    /** The team creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt: string;
    /** Projects of the team */
    projects: {
      createdAt: string;
      name: string;
      id: string;
      updatedAt: string;
    }[];
    /** The context of the team for the current authenticated user */
    context: {
      /** The number of invitations on this team */
      invitationsCount: number;
      /** The number of users on this team */
      usersCount: number;
      /** The authenticated user's role for this team */
      userRole: "admin" | "key" | "member";
      /** The number of API keys on this team */
      keysCount: number;
    };
    /** The team name (example: "Scenario") */
    name: string;
    /** The team ID (example: "eyVcnFJcR92BxBkz7N6g5w") */
    id: string;
    /** The team type */
    type: "personal" | "shared";
    /** The team plan */
    plan:
      | "cu-creator"
      | "cu-pro"
      | "cu-team"
      | "cu-team-v2"
      | "enterprise"
      | "essential"
      | "free"
      | "premium"
      | "pro";
    /** The team update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    updatedAt: string;
  };
};
export type PostTeamsApiArg = {
  body: {
    /** The team name (example: "Scenario") */
    name?: string;
    /** Whether the team should be indexed */
    shouldIndex?: boolean;
    /** Whether the team should be enriched */
    shouldEnrich?: boolean;
  };
};
export type GetTeamsByTeamIdApiResponse = /** status 200 200 response */ {
  team: {
    /** Projects of the team */
    projects: {
      createdAt: string;
      name: string;
      id: string;
      updatedAt: string;
    }[];
    /** The list of API keys */
    keys: {
      /** The API key creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** The status of the API key */
      apiKeyStatus: "active" | "inactive";
      /** The API key name (example: "eurv-scenario") */
      name: string;
      /** The API key ID (example: "eyVcnFJcR92BxBkz7N6g5w") */
      apiKeyId: string;
      /** The identifier of the API key (example: "eyVcnFJcR92BxBkz7N6g5w") */
      id: string;
      /** The API key last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      updatedAt: string;
    }[];
    /** The search tenant token for Meilisearch direct access */
    tenantToken: string;
    /** The team type */
    type: "personal" | "shared";
    /** The list of teams members and their role */
    users: {
      /** The user creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** The role of the user inside the team */
      role: "admin" | "key" | "member";
      /** The user ID (example: "eyVcnFJcR92BxBkz7N6g5w") */
      id: string;
      /** The user email (example: "herve@scenario.com") */
      email: string;
      /** The user last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      updatedAt: string;
    }[];
    /** The team creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt: string;
    /** The search host for the team */
    searchHost: string;
    /** The search indexes for the team */
    searchIndexes: {
      models: {
        /** The private search index for the team */
        private: string;
        /** The public search index for the team */
        public: string;
      };
      assets: {
        /** The private search index for the team */
        private: string;
        /** The public search index for the team */
        public: string;
      };
    };
    /** The list of pending invitations */
    invitations: {
      /** The user creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** The role of the invited user inside the team */
      role: "admin" | "key" | "member";
      /** The list of project IDs for which the user is invited */
      projectIds?: string[];
      /** The invited user email (example: "herve@scenario.com") */
      email: string;
      /** The status of the invitation */
      status: "accepted" | "expired" | "pending" | "withdrawn";
    }[];
    /** The team name (example: "Scenario") */
    name: string;
    /** The team ID (example: "eyVcnFJcR92BxBkz7N6g5w") */
    id: string;
    /** The team plan */
    plan:
      | "cu-creator"
      | "cu-pro"
      | "cu-team"
      | "cu-team-v2"
      | "enterprise"
      | "essential"
      | "free"
      | "premium"
      | "pro";
    /** The paymentStatus for the team */
    paymentStatus: "failed" | "succeeded";
    /** The team update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    updatedAt: string;
  };
};
export type GetTeamsByTeamIdApiArg = {
  /** The team Id to retrieve */
  teamId: string;
};
export type PutTeamsByTeamIdApiResponse = /** status 200 200 response */ {
  team: {
    /** The team creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    createdAt: string;
    /** Projects of the team */
    projects: {
      createdAt: string;
      name: string;
      id: string;
      updatedAt: string;
    }[];
    /** The context of the team for the current authenticated user */
    context: {
      /** The number of invitations on this team */
      invitationsCount: number;
      /** The number of users on this team */
      usersCount: number;
      /** The authenticated user's role for this team */
      userRole: "admin" | "key" | "member";
      /** The number of API keys on this team */
      keysCount: number;
    };
    /** The team name (example: "Scenario") */
    name: string;
    /** The team ID (example: "eyVcnFJcR92BxBkz7N6g5w") */
    id: string;
    /** The team type */
    type: "personal" | "shared";
    /** The team plan */
    plan:
      | "cu-creator"
      | "cu-pro"
      | "cu-team"
      | "cu-team-v2"
      | "enterprise"
      | "essential"
      | "free"
      | "premium"
      | "pro";
    /** The team update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
    updatedAt: string;
  };
};
export type PutTeamsByTeamIdApiArg = {
  /** The team Id to update */
  teamId: string;
  body: {
    /** The team name (example: "Scenario") */
    name?: string;
  };
};
export type DeleteTeamsByTeamIdApiResponse = /** status 200 200 response */ any;
export type DeleteTeamsByTeamIdApiArg = {
  /** The team Id to delete */
  teamId: string;
};
export type PostTeamsApiKeysByTeamIdApiResponse =
  /** status 200 200 response */ {
    createdAt: string;
    id: string;
    secret: string;
    authorId: string;
    ownerId: string;
  };
export type PostTeamsApiKeysByTeamIdApiArg = {
  /** The team Id on which an api key will be created */
  teamId: string;
  body: {
    /** The API Key name */
    name?: string;
  };
};
export type PutTeamsApiKeyByTeamIdAndKeyIdApiResponse =
  /** status 200 200 response */ any;
export type PutTeamsApiKeyByTeamIdAndKeyIdApiArg = {
  /** The key Id to update */
  keyId: string;
  /** The team Id on which the api key exists */
  teamId: string;
  body: {
    /** The status of the API key */
    apiKeyStatus?: "active" | "inactive";
    /** The name of the API key */
    name?: string;
    /** The limits to apply to the API key, -1 means unlimited, 0 means disabled, positive integer means the limit */
    limits?: {
      /** The number of images upscaled allowed per month */
      upscale?: number;
      /** The number of images pixelated allowed per month */
      pixelate?: number;
      /** The number of models trained allowed per month */
      trainModel?: number;
      /** The number of images generated allowed per month */
      inferenceImages?: number;
      /** The number of images with background removed allowed per month */
      removeBackground?: number;
    };
  };
};
export type DeleteTeamsApiKeyByTeamIdAndKeyIdApiResponse =
  /** status 200 200 response */ object;
export type DeleteTeamsApiKeyByTeamIdAndKeyIdApiArg = {
  /** The key Id to delete */
  keyId: string;
  /** The team Id on which the api key exists */
  teamId: string;
};
export type DeleteTeamsInvitationsByTeamIdApiResponse =
  /** status 200 200 response */ object;
export type DeleteTeamsInvitationsByTeamIdApiArg = {
  /** The invitation email to withdraw from the team */
  email: string;
  /** The team id concerned by the invitation withdrawal */
  teamId: string;
};
export type GetTeamsLimitsByTeamIdApiResponse = /** status 200 200 response */ {
  /** The actual billing period start and end dates ISO strings */
  period: {
    start: string;
    end: string;
  };
  /** The list of one-shot creative units
    Can be empty if the team has no one-shot creative units */
  oneShotCreativeUnits: {
    /** The creation date of the creative units (buy date)
        ISO string */
    createdAt: string;
    /** The amount bought of creative units */
    amount: number;
    /** The expiration date of the creative units
        ISO string */
    expiration: string;
    /** The remaining creative units available */
    remaining: number;
    /** The last update date of the creative units (use date)
        ISO string */
    updatedAt: string;
  }[];
  /** The current value for each relevant limit in the billing period */
  values: {
    canvasAssets: number;
    collections: number;
    apiKeys: number;
    creativeUnits: number;
    seats: number;
  };
  /** The actual plan of the team */
  plan:
    | "cu-creator"
    | "cu-pro"
    | "cu-team"
    | "cu-team-v2"
    | "enterprise"
    | "essential"
    | "free"
    | "premium"
    | "pro";
  /** The actual billing limits values related to the plan */
  limits: {
    defaultSeats: number;
    OTPSessions: number;
    downloadAssets: number;
    parallelInferences: number;
    upload: number;
    downloadModel: number;
    apiKeys: number;
    maxTrainingDatasets: number;
    /** The minimum cooldown applied in case of over head */
    minCooldown: number;
    scalingFactor: number;
    parallelTraining: number;
    /** The amount of creative units available for the plan */
    creativeUnits: number;
    seats: number;
    snapshotsRetention: number;
    canvasAssets: number;
    inferenceBatchSize: number;
    collections: number;
    premiumGenerationSamples: number;
    /** The maximum cooldown applied in case of over head */
    maxCooldown: number;
    canvasAssetLayers: number;
  };
};
export type GetTeamsLimitsByTeamIdApiArg = {
  /** The team id to retrieve limits for */
  teamId: string;
};
export type PostTeamsMembersByTeamIdApiResponse =
  /** status 200 200 response */ {
    team: {
      /** The team creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      createdAt: string;
      /** Projects of the team */
      projects: {
        createdAt: string;
        name: string;
        id: string;
        updatedAt: string;
      }[];
      /** The context of the team for the current authenticated user */
      context: {
        /** The number of invitations on this team */
        invitationsCount: number;
        /** The number of users on this team */
        usersCount: number;
        /** The authenticated user's role for this team */
        userRole: "admin" | "key" | "member";
        /** The number of API keys on this team */
        keysCount: number;
      };
      /** The team name (example: "Scenario") */
      name: string;
      /** The team ID (example: "eyVcnFJcR92BxBkz7N6g5w") */
      id: string;
      /** The team type */
      type: "personal" | "shared";
      /** The team plan */
      plan:
        | "cu-creator"
        | "cu-pro"
        | "cu-team"
        | "cu-team-v2"
        | "enterprise"
        | "essential"
        | "free"
        | "premium"
        | "pro";
      /** The team update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
      updatedAt: string;
    };
  };
export type PostTeamsMembersByTeamIdApiArg = {
  /** The team Id on which to add the member */
  teamId: string;
  body: {
    /** The role you want to give the user */
    role?: "admin" | "member";
    /** The project IDs for which the user is invited */
    projectIds?: string[];
    /** The email of the user you want to add to your team */
    email: string;
  };
};
export type PutTeamsMembersByTeamIdAndMemberIdApiResponse =
  /** status 200 200 response */ any;
export type PutTeamsMembersByTeamIdAndMemberIdApiArg = {
  /** The member Id concerned by the new role */
  memberId: string;
  /** The team Id concerned by the role change */
  teamId: string;
  body: {
    /** The role you want to give the member */
    role?: string;
  };
};
export type DeleteTeamsMembersByTeamIdAndMemberIdApiResponse =
  /** status 200 200 response */ object;
export type DeleteTeamsMembersByTeamIdAndMemberIdApiArg = {
  /** The member Id to remove */
  memberId: string;
  /** The team Id concerned by the member removal */
  teamId: string;
};
export type PostTeamsOscuByTeamIdApiResponse = /** status 200 200 response */ {
  redirectUrl: string;
};
export type PostTeamsOscuByTeamIdApiArg = {
  /** The team id concerned by the OSCU purchase */
  teamId: string;
  body: {
    /** The quantity of OSCU to buy */
    quantity: number;
    /** The payment provider for the OSCU purchase */
    paymentProvider: "applepay" | "scenario" | "stripe";
    /** The callback url for the payment provider */
    callbackUrl?: {
      cancel: string;
      success: string;
    };
  };
};
export type PostTeamsOscuAutoRefillByTeamIdApiResponse =
  /** status 200 200 response */ {
    quantity: number;
    threshold: number;
  };
export type PostTeamsOscuAutoRefillByTeamIdApiArg = {
  /** The team id concerned by the auto-refill */
  teamId: string;
  body: {
    quantity: number;
    threshold: number;
  };
};
export type DeleteTeamsOscuAutoRefillByTeamIdApiResponse =
  /** status 200 200 response */ object;
export type DeleteTeamsOscuAutoRefillByTeamIdApiArg = {
  /** The team id concerned by the auto-refill */
  teamId: string;
};
export type GetTeamsOscuPricesByTeamIdApiResponse =
  /** status 200 200 response */ {
    prices?: {
      expires?: number;
      unitAmount?: number;
      currency?: string;
      creativeUnits?: number;
    }[];
  };
export type GetTeamsOscuPricesByTeamIdApiArg = {
  /** The team Id to retrieve */
  teamId: string;
};
export type GetTeamsSubscriptionsByTeamIdApiResponse =
  /** status 200 200 response */ {
    /** The customer portal url of the team, for stripe paymentProvider */
    customerPortalUrl?: string;
    /** The current subscription period of the team */
    period?: {
      endAt: string;
      startAt: string;
    };
    /** The current paymentProvider for the team */
    paymentProvider: "applepay" | "scenario" | "stripe";
    subscription: {
      /** The price for a single additional seat */
      additionalSeatUnitCost?: number;
      /** The price of the subscription */
      amount?: number;
      /** The autoRefill settings */
      autoRefill?: {
        quantity?: number;
        threshold?: number;
        lastRefill?: string;
        enabled: boolean;
      };
      /** The flag to know if the subscription is canceled at the end of the period */
      cancelAtPeriodEnd?: boolean;
      /** The price for all additional seats */
      additionalSeatsAmount?: number;
      /** The end date of the subscription.
        If the cancelAtPeriodEnd is true, the subscription will be canceled at this date */
      periodEndAt?: string;
      /** The currency of the subscription */
      currency?: string;
      /** The interval of the subscription */
      interval?: "month" | "year";
      /** The plan of the team */
      plan?:
        | "cu-creator"
        | "cu-pro"
        | "cu-team"
        | "cu-team-v2"
        | "enterprise"
        | "essential"
        | "free"
        | "premium"
        | "pro";
      /** The number of seats of the subscription */
      seats: number;
      /** The number of additional seats */
      additionalSeats: number;
    };
    coming?: {
      /** The amount of the subscription */
      amount?: number;
      /** The price for all additional seats */
      additionalSeatsAmount?: number;
      /** The currency of the subscription */
      currency?: string;
      /** The interval of the subscription */
      interval?: "month" | "year";
      /** The plan of the team */
      plan?:
        | "cu-creator"
        | "cu-pro"
        | "cu-team"
        | "cu-team-v2"
        | "enterprise"
        | "essential"
        | "free"
        | "premium"
        | "pro";
      /** The number of seats of the subscription */
      seats?: number;
      /** The start date of the subscription */
      startAt?: string;
      /** The number of additional seats of the subscription */
      additionalSeats?: number;
    };
    /** The current paymentStatus for the team, can be: 'succeeded', 'failed' */
    paymentStatus?: "failed" | "succeeded";
  };
export type GetTeamsSubscriptionsByTeamIdApiArg = {
  /** The team id concerned by the subscription plan */
  teamId: string;
  paymentProvider: string;
};
export type PostTeamsSubscriptionsByTeamIdApiResponse =
  /** status 200 200 response */ {
    redirectUrl: string;
  };
export type PostTeamsSubscriptionsByTeamIdApiArg = {
  /** The team id concerned by the subscription plan */
  teamId: string;
  body: {
    paymentProvider: string;
    /** The interval of the plan. If the plan value is "enterprise", this field will be ignored. */
    interval?: string;
    /** The callback URLs for the payment provider */
    callbackUrl?: {
      cancel?: string;
      success?: string;
    };
    plan: string;
    /** The referral code */
    toltReferral?: string;
  };
};
export type PutTeamsSubscriptionsByTeamIdApiResponse =
  /** status 200 200 response */ object;
export type PutTeamsSubscriptionsByTeamIdApiArg = {
  /** The team id concerned by the subscription plan */
  teamId: string;
  body: {
    paymentProvider: string;
    interval: string;
    plan: string;
  };
};
export type DeleteTeamsSubscriptionsByTeamIdApiResponse =
  /** status 200 200 response */ object;
export type DeleteTeamsSubscriptionsByTeamIdApiArg = {
  /** The team id concerned by the subscription plan */
  teamId: string;
  body: {
    paymentProvider: string;
  };
};
export type GetTeamsSubscriptionsCustomerPortalByTeamIdApiResponse =
  /** status 200 200 response */ {
    redirectUrl: string;
  };
export type GetTeamsSubscriptionsCustomerPortalByTeamIdApiArg = {
  /** The teamId to use */
  teamId: string;
  paymentProvider: string;
};
export type PostTeamsSubscriptionsSeatsByTeamIdApiResponse =
  /** status 200 200 response */ {
    seats: number;
  };
export type PostTeamsSubscriptionsSeatsByTeamIdApiArg = {
  /** The team id concerned by the subscription plan */
  teamId: string;
  body: {
    paymentProvider: string;
    seats: number;
  };
};
export type GetTeamWebhookEndpointsApiResponse =
  /** status 200 200 response */ {
    /** A list of the team webhooks */
    webhookEndpoints: {
      /** The date and time the webhook endpoint was created */
      createdAt: string;
      /** The number of calls to the webhook endpoint */
      nbTotalCalls: number;
      /** The events that trigger the webhook. ['*'] indicates that all events are enabled */
      enabledEvents: (
        | "*"
        | "asset.download.completed"
        | "asset.download.created"
        | "asset.download.failed"
        | "inference.cancelled"
        | "inference.completed"
        | "inference.created"
        | "inference.failed"
        | "model.download.completed"
        | "model.download.created"
        | "model.download.failed"
        | "model.training.cancelled"
        | "model.training.completed"
        | "model.training.failed"
        | "model.training.started"
      )[];
      /** The number of calls to the webhook endpoint that have failed */
      nbFailedCalls: number;
      /** A description of the webhook endpoint */
      description?: string;
      /** The ID of the webhook endpoint */
      id: string;
      /** The endpoint's secret, used to generate webhook signatures. Only returned at creation */
      secret?: string;
      /** The ID of the owner of the webhook endpoint */
      ownerId: string;
      /** Whether the webhook is enabled */
      enabled: boolean;
      /** The URL of the webhook endpoint */
      url: string;
      /** The date and time the webhook endpoint was updated */
      updatedAt: string;
    }[];
  };
export type GetTeamWebhookEndpointsApiArg = {
  /** The team Id to retrieve */
  teamId: string;
};
export type PostWebhookEndpointsApiResponse = /** status 200 200 response */ {
  webhookEndpoint: {
    /** The date and time the webhook endpoint was created */
    createdAt: string;
    /** The number of calls to the webhook endpoint */
    nbTotalCalls: number;
    /** The events that trigger the webhook. ['*'] indicates that all events are enabled */
    enabledEvents: (
      | "*"
      | "asset.download.completed"
      | "asset.download.created"
      | "asset.download.failed"
      | "inference.cancelled"
      | "inference.completed"
      | "inference.created"
      | "inference.failed"
      | "model.download.completed"
      | "model.download.created"
      | "model.download.failed"
      | "model.training.cancelled"
      | "model.training.completed"
      | "model.training.failed"
      | "model.training.started"
    )[];
    /** The number of calls to the webhook endpoint that have failed */
    nbFailedCalls: number;
    /** A description of the webhook endpoint */
    description?: string;
    /** The ID of the webhook endpoint */
    id: string;
    /** The endpoint's secret, used to generate webhook signatures. Only returned at creation */
    secret?: string;
    /** The ID of the owner of the webhook endpoint */
    ownerId: string;
    /** Whether the webhook is enabled */
    enabled: boolean;
    /** The URL of the webhook endpoint */
    url: string;
    /** The date and time the webhook endpoint was updated */
    updatedAt: string;
  };
};
export type PostWebhookEndpointsApiArg = {
  teamId: string;
  body: {
    /** The events that trigger the webhook. ['*'] indicates that all events are enabled */
    enabledEvents: (
      | "*"
      | "asset.download.completed"
      | "asset.download.created"
      | "asset.download.failed"
      | "inference.cancelled"
      | "inference.completed"
      | "inference.created"
      | "inference.failed"
      | "model.download.completed"
      | "model.download.created"
      | "model.download.failed"
      | "model.training.cancelled"
      | "model.training.completed"
      | "model.training.failed"
      | "model.training.started"
    )[];
    /** A description of the webhook endpoint */
    description?: string;
    /** The URL of the webhook endpoint */
    url: string;
  };
};
export type PutWebhookEndpointsByIdApiResponse =
  /** status 200 200 response */ {
    webhookEndpoint: {
      /** The date and time the webhook endpoint was created */
      createdAt: string;
      /** The number of calls to the webhook endpoint */
      nbTotalCalls: number;
      /** The events that trigger the webhook. ['*'] indicates that all events are enabled */
      enabledEvents: (
        | "*"
        | "asset.download.completed"
        | "asset.download.created"
        | "asset.download.failed"
        | "inference.cancelled"
        | "inference.completed"
        | "inference.created"
        | "inference.failed"
        | "model.download.completed"
        | "model.download.created"
        | "model.download.failed"
        | "model.training.cancelled"
        | "model.training.completed"
        | "model.training.failed"
        | "model.training.started"
      )[];
      /** The number of calls to the webhook endpoint that have failed */
      nbFailedCalls: number;
      /** A description of the webhook endpoint */
      description?: string;
      /** The ID of the webhook endpoint */
      id: string;
      /** The endpoint's secret, used to generate webhook signatures. Only returned at creation */
      secret?: string;
      /** The ID of the owner of the webhook endpoint */
      ownerId: string;
      /** Whether the webhook is enabled */
      enabled: boolean;
      /** The URL of the webhook endpoint */
      url: string;
      /** The date and time the webhook endpoint was updated */
      updatedAt: string;
    };
  };
export type PutWebhookEndpointsByIdApiArg = {
  /** The webhook endpoint to update */
  webhookEndpointId: string;
  /** The team Id */
  teamId: string;
  body: {
    /** The events that trigger the webhook. ['*'] indicates that all events are enabled */
    enabledEvents?: (
      | "*"
      | "asset.download.completed"
      | "asset.download.created"
      | "asset.download.failed"
      | "inference.cancelled"
      | "inference.completed"
      | "inference.created"
      | "inference.failed"
      | "model.download.completed"
      | "model.download.created"
      | "model.download.failed"
      | "model.training.cancelled"
      | "model.training.completed"
      | "model.training.failed"
      | "model.training.started"
    )[];
    /** A description of the webhook endpoint */
    description?: string;
    /** Whether the webhook is enabled */
    enabled?: boolean;
    /** The URL of the webhook endpoint */
    url?: string;
  };
};
export type DeleteWebhookEndpointByIdApiResponse =
  /** status 200 200 response */ any;
export type DeleteWebhookEndpointByIdApiArg = {
  /** The webhook endpoint to delete */
  webhookEndpointId: string;
  /** The team Id */
  teamId: string;
};
export type PostUploadsApiResponse = /** status 200 200 response */ {
  upload: {
    originalFileName?: string;
    fileName: string;
    partsCount?: number;
    /** The kind of the file once validated (example: "model") */
    kind: "asset" | "model";
    errorMessage?: string;
    entityId?: string;
    source: "civitai" | "huggingface" | "multipart" | "other" | "url";
    authorId: string;
    ownerId: string;
    url?: string;
    createdAt: string;
    jobId?: string;
    fileSize?: number;
    provider?: "civitai" | "huggingface" | "other";
    parts?: {
      number: number;
      expires: string;
      url: string;
    }[];
    id: string;
    config?: {};
    contentType?: string;
    status:
      | "complete"
      | "failed"
      | "imported"
      | "pending"
      | "validated"
      | "validating";
    updatedAt: string;
  };
};
export type PostUploadsApiArg = {
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  body: {
    /** Required for multipart upload. The original file name of the image (example: "low-res-image.jpg"). It will be ignored if assetId is provided. */
    fileName?: string;
    /** Required for multipart upload. The size of the file in bytes */
    fileSize?: number;
    /** Required for multipart upload and url. The purpose of the file once validated (example: "model") */
    kind?: "asset" | "model";
    /** The civitai.com url of the model (example: "https://civitai.com/models/370194/translucent-subsurface-scattering-test?modelVersionId=413566"). */
    civitaiModelUrl?: string;
    /** The huggingface.co modelName (example: "stabilityai/stable-diffusion-xl-base-1.0").
        No need to setup other fields if you setup huggingFaceModelName */
    huggingFaceModelName?: string;
    /** Required for multipart upload. The number of parts the file will be uploaded in */
    parts?: number;
    /** Required for multipart upload. The MIME type of the file (example: "image/jpeg") */
    contentType?: string;
    /** The url where to download the file.
        If you setup url you MUST setup kind as well. */
    url?: string;
  };
};
export type GetUploadsApiResponse = /** status 200 200 response */ {
  upload: {
    originalFileName?: string;
    fileName: string;
    partsCount?: number;
    /** The kind of the file once validated (example: "model") */
    kind: "asset" | "model";
    errorMessage?: string;
    entityId?: string;
    source: "civitai" | "huggingface" | "multipart" | "other" | "url";
    authorId: string;
    ownerId: string;
    url?: string;
    createdAt: string;
    jobId?: string;
    fileSize?: number;
    provider?: "civitai" | "huggingface" | "other";
    parts?: {
      number: number;
      expires: string;
      url: string;
    }[];
    id: string;
    config?: {};
    contentType?: string;
    status:
      | "complete"
      | "failed"
      | "imported"
      | "pending"
      | "validated"
      | "validating";
    updatedAt: string;
  };
};
export type GetUploadsApiArg = {
  /** The upload Id to retrieve */
  uploadId: string;
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
};
export type PostUploadsActionApiResponse = /** status 200 200 response */ {
  upload: {
    originalFileName?: string;
    fileName: string;
    partsCount?: number;
    /** The kind of the file once validated (example: "model") */
    kind: "asset" | "model";
    errorMessage?: string;
    entityId?: string;
    source: "civitai" | "huggingface" | "multipart" | "other" | "url";
    authorId: string;
    ownerId: string;
    url?: string;
    createdAt: string;
    jobId?: string;
    fileSize?: number;
    provider?: "civitai" | "huggingface" | "other";
    parts?: {
      number: number;
      expires: string;
      url: string;
    }[];
    id: string;
    config?: {};
    contentType?: string;
    status:
      | "complete"
      | "failed"
      | "imported"
      | "pending"
      | "validated"
      | "validating";
    updatedAt: string;
  };
};
export type PostUploadsActionApiArg = {
  /** The projectId used for ownership resource management. Either to assert ownership or to set the owner of the resource(s) */
  projectId: string;
  /** The upload Id to retrieve */
  uploadId: string;
  body: {
    /** The action to perform on an upload, currently only "upload-complete" is supported */
    action: "complete";
  };
};
export type GetUsagesApiResponse = /** status 200 200 response */ {
  activity?: {
    /** The cost of the creative units for this action */
    creativeUnitsCost?: number;
    /** The additional data of the action */
    data: {
      /** Whether the action is an API key action */
      isApiKey?: boolean;
      /** The model for this action */
      model?: {
        /** The training caption words of the model */
        captionWords?: string[];
        /** The URLs of the first 3 training images of the model. To retrieve the full set of images, get it by modelId */
        trainingImages?: {
          /** The training image upload date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
          createdAt: string;
          /** Automatic captioning of the image */
          automaticCaptioning: string;
          /** The URL of the image */
          downloadUrl: string;
          /** The original file name of the image (example: "my-training-image.jpg") */
          name: string;
          /** Description for the image */
          description: string;
          /** The training image ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
          id: string;
        }[];
        /** The inputs of the model. Only used for custom models. To retrieve this list, get it by modelId with GET /models/{modelId} */
        inputs?: {
          /** The allowed values of the input of type 'string' or 'string_array'
                    In case of string, it's a single value select list
                    In case of string_array, it's a multi value select list */
          allowedValues?: string[];
          /** The maximum value of the input (only available for inputs of type 'number' and inputs as array) */
          max?: number;
          /** The kind of the input. Only available for inputs of type 'file' (and 'file_array') */
          kind?: "3d" | "audio" | "document" | "image" | "json" | "video";
          /** The minimum length of the input where the input is a string (also available for each item in string_array) */
          minLength?: number;
          /** The description of the input, to display in the UI as an help text adding information about the input */
          description?: string;
          /** The label of the input displayed in the UI */
          label?: string;
          /** The type of the input */
          type:
            | "boolean"
            | "file"
            | "file_array"
            | "number"
            | "number_array"
            | "string"
            | "string_array";
          /** Whether the input is required */
          required: boolean;
          /** The minimum value of the input (only available for inputs of type 'number' and inputs as array) */
          min?: number;
          /** A hint to the user about the input, to display in the UI with a tooltip */
          hint?: string;
          /** The name of the input internally used by the model and API */
          name: string;
          /** The maximum length of the input where the input is a string (also available for each item in string_array) */
          maxLength?: number;
          /** The group of the input. If 2 inputs have the same group, they will be displayed in the same group in the UI
                    They will be always together in this list of inputs */
          group?: string;
        }[];
        /** List of all example asset IDs setup by the model owner */
        exampleAssetIds: string[];
        /** The privacy of the model (default: private) */
        privacy: "private" | "public" | "unlisted";
        /** The date when the model will be soft deleted (only for Free plan) */
        softDeletionOn?: string;
        /** The UI configuration for the model */
        uiConfig?: {
          triggerGenerate?: {
            /** The 'name' of the input where the trigger generate button will be displayed (after the input).
                        Do not specify both position and after. */
            after?: string;
            label: string;
            /** The position of the trigger generate button. If position specified, the button will be displayed at the specified position.
                        Do not specify both position and after. */
            position?: "bottom" | "top";
          };
        };
        /** The source of the model */
        source: "civitai" | "huggingface" | "other" | "scenario";
        /** The owner ID (example: "team_VFhihHKMRZyDDnZAJwLb2Q") */
        ownerId?: string;
        /** The model type (example: sd-1_5) */
        type:
          | "custom"
          | "flux.1"
          | "flux.1-composition"
          | "flux.1-lora"
          | "flux.1-pro"
          | "flux.1.1-pro-ultra"
          | "flux1.1-pro"
          | "gpt-image-1"
          | "sd-1_5"
          | "sd-1_5-composition"
          | "sd-1_5-lora"
          | "sd-xl"
          | "sd-xl-composition"
          | "sd-xl-lora";
        /** The model creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** Additional information about the model's training */
        trainingStats?: {
          /** The training duration in seconds */
          trainDuration?: number;
          /** The training queued duration in seconds */
          queueDuration?: number;
          /** The training end time as an ISO date string */
          endedAt?: string;
          /** The training start time as an ISO date string */
          startedAt?: string;
        };
        /** Fine-tune the model's inferences with prompt embedding */
        promptEmbedding?: string;
        /** Additional information about the training progress of the model */
        trainingProgress?: {
          /** The stage of the request */
          stage:
            | "pending"
            | "queued-for-train"
            | "running-train"
            | "starting-train";
          /** The remaining time in milliseconds */
          remainingTimeMs?: number;
          /** The progress of the job */
          progress?: number;
          /** The timestamp in millisecond marking the start of the process */
          startedAt?: number;
          /** Position of the job in the queue (ie. the number of job in the queue before this one) */
          position?: number;
          /** Timestamp in milliseconds of the last time the training progress was updated */
          updatedAt: number;
        };
        /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
        id: string;
        /** The class of the model */
        class?: {
          /** The model ID of the class (example: "stable-diffusion-v1-5") */
          modelId: string;
          /** The class name (example: "Character Design") */
          name: string;
          /** The category slug of the class (example: "art-style") */
          category: string;
          /** Some example images URLs to showcase the class */
          thumbnails: string[];
          /** The class prompt (example: "a character design") */
          prompt: string;
          /** The concept prompt of the class (example: "a sks character design") */
          conceptPrompt: string;
          /** The class slug (example: "art-style-character-design") */
          slug: string;
          /** The class status (only published classes are listed, but unpublished classes can still appear in existing models) */
          status: "published" | "unpublished";
        };
        /** The model last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
        /** A thumbnail for your model */
        thumbnail?: {
          /** The AssetId of the image used as a thumbnail for your model (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
          assetId: string;
          /** The url of the image used as a thumbnail for your model */
          url: string;
        };
        /** List of model capabilities (example: ["txt2img", "img2img", "txt2img_ip_adapter", ...]) */
        capabilities: (
          | "controlnet"
          | "controlnet_img2img"
          | "controlnet_inpaint"
          | "controlnet_inpaint_ip_adapter"
          | "controlnet_ip_adapter"
          | "controlnet_reference"
          | "controlnet_texture"
          | "img2img"
          | "img2img_ip_adapter"
          | "img2img_texture"
          | "inpaint"
          | "inpaint_ip_adapter"
          | "outpaint"
          | "reference"
          | "reference_texture"
          | "txt2img"
          | "txt2img_ip_adapter"
          | "txt2img_texture"
        )[];
        /** The id of the parent model */
        parentModelId?: string;
        /** The total number of training images */
        trainingImagesNumber: number;
        /** Whether the model is a custom model and can be used only with POST /generate/custom/{modelId} endpoint */
        custom: boolean;
        /** The model keyword, this is a legacy parameter, please use conceptPrompt in parameters */
        modelKeyword?: string;
        /** The author user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
        authorId?: string;
        /** (Deprecated) The user ID (example: "user_VFhihHKMRZyDDnZAJwLb2Q") */
        userId?: string;
        /** The associated tags (example: ["sci-fi", "landscape"]) */
        tags: string[];
        /** Fine-tune the model's inferences with negative prompt embedding */
        negativePromptEmbedding?: string;
        /** The concepts is required for the type model: composition */
        concepts?: {
          /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
          modelId: string;
          /** The scale of the model (example: 1.0) */
          scale: number;
        }[];
        /** A list of CollectionId this model belongs to */
        collectionIds: string[];
        /** The model name (example: "Low-poly dwarf") */
        name?: string;
        /** The model's training parameters */
        parameters?: {
          /** Whether to train the text encoder or not
                    
                    Example: For 100 steps and a value of 0.2, it means that the text encoder will be trained for 20 steps and then the UNet for 80 steps
                    
                    Note: Legacy parameter, please use `numTextTrainSteps` and `numUNetTrainSteps`
                    
                    Only available for SD15 and SDXL LoRA training */
          textEncoderTrainingRatio?: number;
          /** The weight of prior preservation loss
                    
                    Only available for SD15 and SDXL LoRA training */
          priorLossWeight?: number;
          /** Used to reproduce previous results. Default: randomly generated number.
                    
                    Only available for SD15 and SDXL LoRA training */
          seed?: number;
          /** The number of training steps for the UNet
                    
                    Only available for SDXL LoRA training */
          numUNetTrainSteps?: number;
          /** Validation frequency. Cannot be greater than maxTrainSteps value
                    
                    Only available for SD15 and SDXL LoRA training */
          validationFrequency?: number;
          /** Ratio of random crops
                    
                    Only available for SD15 and SDXL LoRA training */
          randomCropRatio?: number;
          /** Initial learning rate (after the potential warmup period)
                    
                    Default value varies depending on the model type:
                    - For SD1.5 and SDXL: 0.000005
                    - For Flux: 0.0004 */
          learningRate?: number;
          /** Optimize the model training task for a specific type of input images. The available values are:
                    - "likeness": optimize training for likeness or portrait
                    
                    Only available for Flux LoRA training */
          optimizeFor?: "likeness" | null;
          /** Whether to random crop or center crop images before resizing to the working resolution
                    
                    Only available for SD15 and SDXL LoRA training */
          randomCrop?: boolean;
          /** The prompt to specify images in the same class as provided instance images
                    
                    Only available for SD15 training */
          classPrompt?: string;
          /** The number of training steps for the text encoder
                    
                    Only available for SDXL LoRA training */
          numTextTrainSteps?: number;
          /** Initial learning rate (after the potential warmup period) for the text encoder
                    
                    Only available for SDXL LoRA training */
          learningRateTextEncoder?: number;
          /** The Weights And Bias key to use for logging. The maximum length is 40 characters */
          wandbKey?: string;
          /** Whether to scale the learning rate
                    
                    Note: Legacy parameter, will be ignored
                    
                    Only available for SD15 and SDXL LoRA training */
          scaleLr?: boolean;
          /** Scale of random crops
                    
                    Only available for SD15 and SDXL LoRA training */
          randomCropScale?: number;
          /** The scheduler type to use (default: "constant")
                    
                    Only available for SD15 and SDXL LoRA training */
          lrScheduler?:
            | "constant"
            | "constant-with-warmup"
            | "cosine"
            | "cosine-with-restarts"
            | "linear"
            | "polynomial";
          /** The dimension of the LoRA update matrices
                    
                    Only available for SDXL and Flux LoRA training
                    
                    Default value varies depending on the model type:
                    - For SDXL: 64
                    - For Flux: 16 */
          rank?: number;
          /** Initial learning rate (after the potential warmup period) for the UNet
                    
                    Only available for SDXL LoRA training */
          learningRateUnet?: number;
          /** Validation prompt
                    
                    Only available for SD15 and SDXL LoRA training */
          validationPrompt?: string;
          /** The prompt with identifier specifying the instance (or subject) of the class (example: "a daiton dog")
                    
                    Default value varies depending on the model type:
                    - For SD1.5: "daiton" if no class is associated with the model
                    - For SDXL: "daiton"
                    - For Flux: "" */
          conceptPrompt?: string | null;
          /** Maximum number of training steps to execute (default: varies depending on the model type)
                    
                    For SDXL LoRA training, please use `numTextTrainSteps` and `numUNetTrainSteps` instead
                    
                    Default value varies depending on the model type:
                    - For SD1.5: round((number of training images * 225) / 3)
                    - For SDXL: number of training images * 175
                    - For Flux: number of training images * 100
                    
                    Maximum value varies depending on the model type:
                    - For SD1.5 and SDXL: [0, 40000]
                    - For Flux: [0, 10000] */
          maxTrainSteps?: number;
        };
        /** List of base model IDs compliant with the model (example: ["flux.1-dev", "flux.1-schnell"])
                This attribute is mainly used for Flux LoRA models */
        compliantModelIds?: string[];
        /** The model status */
        status:
          | "copying"
          | "failed"
          | "new"
          | "trained"
          | "training"
          | "training-canceled";
      };
      /** The collection for this action */
      collection?: {
        /** The collection creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The collection name */
        name: string;
        assetCount: number;
        /** The collection ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        id: string;
        /** The owner ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        ownerId: string;
        modelCount: number;
        itemCount: number;
        /** The collection last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
      /** The asset for this action */
      asset?: {
        /** Metadata of the asset with some additional information */
        metadata: {
          maxIterations?: number;
          /** Modality to detect */
          modality?:
            | "canny"
            | "depth"
            | "grayscale"
            | "lineart_anime"
            | "mlsd"
            | "normal"
            | "pose"
            | "scribble"
            | "segmentation"
            | "sketch";
          /** If set to true, during the upscaling process, the model will match tiles of the source image with tiles of the style image(s). This will result in a more coherent restyle. Works best with style images that have a similar composition. */
          tileStyle?: boolean;
          /** The modelId used to generate this asset */
          modelId?: string;
          /** A bounding box around the object of interest, in the format [x1, y1, x2, y2]. */
          bbox?: any[];
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          keypointThreshold?: number;
          /** The type of the asset. Ex: 'inference-txt2img' will represent an asset generated from a text to image model */
          type:
            | "background-removal"
            | "canvas"
            | "canvas-drawing"
            | "canvas-export"
            | "detection"
            | "generative-fill"
            | "image-prompt-editing"
            | "img23d-custom"
            | "img2img-custom"
            | "img2video-custom"
            | "inference-controlnet"
            | "inference-controlnet-img2img"
            | "inference-controlnet-inpaint"
            | "inference-controlnet-inpaint-ip-adapter"
            | "inference-controlnet-ip-adapter"
            | "inference-controlnet-reference"
            | "inference-controlnet-texture"
            | "inference-img2img"
            | "inference-img2img-ip-adapter"
            | "inference-img2img-texture"
            | "inference-inpaint"
            | "inference-inpaint-ip-adapter"
            | "inference-reference"
            | "inference-reference-texture"
            | "inference-txt2img"
            | "inference-txt2img-ip-adapter"
            | "inference-txt2img-texture"
            | "patch"
            | "pixelization"
            | "reframe"
            | "restyle"
            | "segment"
            | "segmentation-image"
            | "segmentation-mask"
            | "skybox-base-360"
            | "texture"
            | "texture-albedo"
            | "texture-ao"
            | "texture-edge"
            | "texture-height"
            | "texture-metallic"
            | "texture-normal"
            | "texture-smoothness"
            | "txt23d-custom"
            | "txt2audio-custom"
            | "txt2img-custom"
            | "unknown-custom"
            | "uploaded"
            | "upscale"
            | "upscale-skybox"
            | "upscale-texture"
            | "vectorization"
            | "video2video-custom";
          /** A textual description / keywords describing the object of interest. */
          text?: string;
          height?: number;
          nbMasks?: number;
          /** Amount of decay in creativity over the upscale process. The lowest the value, the less the creativity will be preserved over the upscale process. */
          creativityDecay?: number;
          layerDifference?: number;
          /** Scaling factor (when `targetWidth` not specified) */
          scalingFactor?: number;
          /** The type of the generator used */
          modelType?:
            | "custom"
            | "flux.1"
            | "flux.1-composition"
            | "flux.1-lora"
            | "flux.1-pro"
            | "flux.1.1-pro-ultra"
            | "flux1.1-pro"
            | "gpt-image-1"
            | "sd-1_5"
            | "sd-1_5-composition"
            | "sd-1_5-lora"
            | "sd-xl"
            | "sd-xl-composition"
            | "sd-xl-lora";
          /** The number of outputs to generate. */
          numOutputs?: number;
          /** How angular is the surface? 0 is like a sphere, 1 is like a mechanical object */
          angular?: number;
          /** The target height of the output image. */
          targetHeight?: number;
          /** Flux LoRa or Composition to style the image. */
          concepts?: {
            weightName: string;
            /** The model ID (example: "model_eyVcnFJcR92BxBkz7N6g5w") */
            modelId: string;
            /** The scale of the model (example: 1.0) */
            scale: number;
          }[];
          size?: number;
          spliceThreshold?: number;
          /** The number of pixels to dilate the result masks. */
          dilate?: number;
          style?:
            | "3d-cartoon"
            | "3d-rendered"
            | "anime"
            | "cartoon"
            | "cinematic"
            | "claymation"
            | "cloud-skydome"
            | "comic"
            | "cyberpunk"
            | "enchanted"
            | "fantasy"
            | "ink"
            | "manga"
            | "manga-color"
            | "minimalist"
            | "neon-tron"
            | "oil-painting"
            | "pastel"
            | "photo"
            | "photography"
            | "psychedelic"
            | "retro-fantasy"
            | "scifi-concept-art"
            | "space"
            | "standard"
            | "whimsical";
          /** Strengthen the similarity to the original image during the upscale. Default: optimized for your preset and style. */
          imageFidelity?: number;
          /** Location of the input image in the output. */
          inputLocation?: "bottom" | "left" | "middle" | "right" | "top";
          /** The seed used to generate this asset */
          seed?: string;
          /** The higher the value the more it will look like the secondary reference image(s) */
          secondaryRefFidelity?: number;
          preset?: string;
          trainingImage?: boolean;
          /** Boolean to able return the masks (binary image) in the response. */
          resultMask?: boolean;
          /** The ISO timestamp when the lock on the canvas will expire */
          lockExpiresAt?: string;
          /** The baseModelId that maybe changed at inference time */
          baseModelId?: string;
          pathPrecision?: number;
          rootParentId?: string;
          /** Sharpen tiles. */
          sharpen?: boolean;
          cornerThreshold?: number;
          /** List of style images. Most of the time, only one image is enough. It must be existing AssetIds. */
          styleImages?: string[];
          /** The asset to convert in texture maps. Must reference an existing AssetId. */
          texture?: string;
          filterSpeckle?: number;
          /** Minimum threshold for Grayscale conversion */
          minThreshold?: number;
          /** Maximum threshold for Grayscale conversion */
          maxThreshold?: number;
          /** Condition the influence of the style image(s). The higher the value, the more the style images will influence the upscaled image. */
          styleImagesFidelity?: number;
          /** The control image processed by depth estimator. Must reference an existing AssetId. */
          depthImage?: string;
          parentId?: string;
          parentJobId?: string;
          /** Optional List of secondary style images. Example: portrait of people. It must be existing AssetIds. */
          secondaryRefImages?: string[];
          /** The width of the rendered image. */
          width?: number;
          /** The checkpoint to use */
          checkpoint?: "fastsam_x" | "sam_b" | "sam_h";
          strength?: number;
          /** The id of the Inference describing how this image was generated */
          inferenceId?: string;
          lengthThreshold?: number;
          /** Int to set between 0 and 255 for the opacity of the background in the result images. */
          backgroundOpacity?: number;
          /** The optional aspect ratio given for the generation, only applicable for some models */
          aspectRatio?: string;
          /** Amount of details to remove or add */
          detailsLevel?: number;
          /** Determine the scale at which the upscale process works.
                    - With a small value, the upscale works at the largest scale, resulting in fewer added details and more coherent images. Ideal for portraits, for example.
                    - With a large value, the upscale works at the smallest scale, resulting in more added details and more hallucinations. Ideal for landscapes, for example.
                    
                    (info): A small value is slower and more expensive to run. */
          fractality?: number;
          /** (deprecated) Horizontal expansion ratio. */
          horizontalExpansionRatio?: number;
          /** List of points (label, x, y) in the image where label = 0 for background and 1 for object. */
          points?: any[][];
          mode?: string;
          colorPrecision?: number;
          /** Increase the fidelity to the prompt during upscale. Default: optimized for your preset and style. */
          promptFidelity?: number;
          /** Remove small dark spots (i.e. “pepper”) and connect small bright cracks. */
          betterQuality?: boolean;
          /** Remove background for Grayscale detector */
          removeBackground?: boolean;
          /** Allow the generation of "hallucinations" during the upscale process, which adds additional details and deviates from the original image. Default: optimized for your preset and style. */
          creativity?: number;
          /** Strength for the input image structure preservation */
          structureFidelity?: number;
          /** Preserve the seamless properties of skybox or texture images. Input has to be of same type (seamless). */
          imageType?: "seamfull" | "skybox" | "texture";
          /** The input image to process. Must reference an existing AssetId or be a data URL. */
          image?: string;
          /** The thumbnail of the canvas */
          thumbnail?: {
            /** The AssetId of the image used as a thumbnail for the canvas (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
            assetId: string;
            /** The url of the image used as a thumbnail for the canvas */
            url: string;
          };
          /** The control image for structure. A canny detector will be applied to this image. Must reference an existing AssetId. */
          structureImage?: string;
          /** To invert the relief */
          invert?: boolean;
          kind: "3d" | "audio" | "document" | "image" | "json" | "video";
          colorMode?: string;
          /** High threshold for Canny detector */
          highThreshold?: number;
          /** (deprecated) Vertical expansion ratio. */
          verticalExpansionRatio?: number;
          halfMode?: boolean;
          name?: string;
          /** Additional refinement steps before scaling.
                    
                    If scalingFactor == 1, the refinement process will be applied (1 + refinementSteps) times.
                    If scalingFactor > 1, the refinement process will be applied refinementSteps times. */
          refinementSteps?: number;
          /** The reference images used for the image generation or editing */
          referenceImages?: string[];
          /** The higher the value the more it will look like the style image(s) */
          styleFidelity?: number;
          /** Boolean to output the contours. */
          resultContours?: boolean;
          /** How polished is the surface? 0 is like a rough surface, 1 is like a mirror */
          polished?: number;
          /** The scheduler used to generate this asset */
          scheduler?: string;
          /** Override the embeddings of the model. Only your prompt and negativePrompt will be used. Use with caution. */
          overrideEmbeddings?: boolean;
          progressPercent?: number;
          /** Contrast factor for Grayscale detector */
          factor?: number;
          /** The mask used for the image generation or editing */
          mask?: string;
          /** Low threshold for Canny detector */
          lowThreshold?: number;
          /** The depth fidelity if a depth image provided */
          depthFidelity?: number;
          /** How raised is the surface? 0 is flat like water, 1 is like a very rough rock */
          raised?: number;
          message?: string;
          contours?: number[][][][];
          /** A negative full text prompt that discourages the upscale from generating certain characteristics. It is recommended to test without using a negative prompt. Default: empty string. Example: "Low resolution, blurry, pixelated, noisy." */
          negativePrompt?: string;
          /** If true, use the default parameters */
          defaultParameters?: boolean;
          /** Size proportion of the input image in the output. */
          resizeOption?: number;
          outputIndex?: number;
          /** Save a flipbook of the texture. Deactivated when the input texture is larger than 2048x2048px */
          saveFlipbook?: boolean;
          /** The guidance used to generate this asset */
          guidance?: number;
          /** The number of denoising steps for each image generation. */
          numInferenceSteps?: number;
          hdr?: number;
          /** How shiny is the surface? 0 is like a matte surface, 1 is like a diamond */
          shiny?: number;
          /** Ensure upscaled tile have the same color histogram as original tile. */
          colorCorrection?: boolean;
          /** Overlap percentage for the output image. */
          overlapPercentage?: number;
          /** The prompt that guided the image generation or editing */
          prompt?: string;
          /** Boolean to able output the cut out object. */
          resultImage?: boolean;
          /** The control image already processed by canny detector. Must reference an existing AssetId. */
          cannyStructureImage?: string;
          /** Apply extra control to the Skybox 360 geometry.
                    The higher the value, the more the 360 geometry will influence the generated skybox image.
                    
                    Use with caution. Default is adapted to the other parameters. */
          geometryEnforcement?: number;
          /** Target width for the upscaled image, take priority over scaling factor */
          targetWidth?: number;
        };
        /** The NSFW labels */
        nsfw?: string[];
        /** Automatic captioning of the asset */
        automaticCaptioning?: string;
        /** The description of the asset */
        description?: string;
        /** The privacy of the asset */
        privacy: "private" | "public" | "unlisted";
        /** The date when the asset will be soft deleted (only for Free plan) */
        softDeletionOn?: string;
        /** The mime type of the asset (example: "image/png") */
        mimeType: string;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId: string;
        /** The owner (project) ID (example: "proj_23tlk332lkht3kl2" or "team_dlkhgs23tlk3hlkth32lkht3kl2" for old teams) */
        ownerId: string;
        /** Signed URL to get the asset content */
        url: string;
        /** The associated tags (example: ["sci-fi", "landscape"]) */
        tags: string[];
        /** The asset creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The output index of the asset within the job
                This index is an positive integer that starts at 0
                It is used to differentiate between multiple outputs of the same job
                If the job has only one output, this index is 0
                This is only applicable for generations with: Flux, Skybox, Reframe at the moment */
        outputIndex?: number;
        /** A list of CollectionId this asset belongs to */
        collectionIds: string[];
        /** List of edit capabilities for the asset */
        editCapabilities: (
          | "DETECTION"
          | "GENERATIVE_FILL"
          | "PIXELATE"
          | "PROMPT_EDITING"
          | "REFINE"
          | "REFRAME"
          | "REMOVE_BACKGROUND"
          | "SEGMENTATION"
          | "UPSCALE"
          | "UPSCALE_360"
          | "VECTORIZATION"
        )[];
        /** The embedding of the asset when requested and asset can be embedded
                
                ie: Detection maps don't have embeddings */
        embedding?: number[];
        /** The asset ID (example: "asset_GTrL3mq4SXWyMxkOHRxlpw") */
        id: string;
        /** The status of the asset */
        status: "error" | "pending" | "success";
        /** The asset last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
      /** The job for this action */
      job?: {
        /** The job creation date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        createdAt: string;
        /** The job ID (example: "job_ocZCnG1Df35XRL1QyCZSRxAG8") */
        jobId: string;
        /** Metadata of the job with some additional information */
        metadata: {
          /** The output of the job */
          output?: {};
          /** The inputs for the job */
          input?: {};
          /** List of produced assets for this job */
          assetIds?: string[];
        };
        /** The history of the different statuses the job went through with the ISO string date
                of when the job reached each statuses. */
        statusHistory: {
          date: string;
          status:
            | "canceled"
            | "failure"
            | "in-progress"
            | "queued"
            | "success"
            | "warming-up";
        }[];
        /** Progress of the job (between 0 and 1) */
        progress: number;
        /** The author user ID (example: "dcf121faaa1a0a0bbbd9ca1b73d62aea") */
        authorId?: string;
        /** The type of job */
        jobType:
          | "assets-download"
          | "canvas-export"
          | "caption"
          | "caption-llava"
          | "custom"
          | "describe-style"
          | "detection"
          | "embed"
          | "flux"
          | "flux-model-training"
          | "generate-prompt"
          | "image-generation"
          | "image-prompt-editing"
          | "inference"
          | "model-download"
          | "model-import"
          | "model-training"
          | "openai-image-generation"
          | "patch-image"
          | "pixelate"
          | "reframe"
          | "remove-background"
          | "repaint"
          | "restyle"
          | "segment"
          | "skybox-base-360"
          | "skybox-upscale-360"
          | "texture"
          | "translate"
          | "upload"
          | "upscale"
          | "upscale-skybox"
          | "upscale-texture"
          | "vectorize";
        /** The owner ID (example: "team_U3Qmc8PCdWXwAQJ4Dvw4tV6D") */
        ownerId?: string;
        /** The current status of the job */
        status:
          | "canceled"
          | "failure"
          | "in-progress"
          | "queued"
          | "success"
          | "warming-up";
        /** The job last update date as an ISO string (example: "2023-02-03T11:19:41.579Z") */
        updatedAt: string;
      };
    };
    /** The action name */
    action:
      | "asset"
      | "asset-privacy"
      | "background-removal"
      | "captioning"
      | "collection"
      | "collection-assets"
      | "collection-models"
      | "controlnet"
      | "controlnet-img2img"
      | "controlnet-inpaint"
      | "controlnet-ip-adapter"
      | "controlnet-texture"
      | "copy-asset"
      | "copy-model"
      | "creative-unit-cost"
      | "delete-asset"
      | "delete-collection"
      | "delete-collection-assets"
      | "delete-collection-models"
      | "delete-inference-image"
      | "delete-model"
      | "delete-model-preset"
      | "delete-oscu-auto-refill"
      | "delete-project-member"
      | "delete-subscription"
      | "delete-team-api-key"
      | "delete-team-invitations"
      | "delete-team-member"
      | "delete-training-images"
      | "describe-style"
      | "detection"
      | "download-assets"
      | "download-model"
      | "embed"
      | "generative-fill"
      | "image-prompt-editing"
      | "images-generation"
      | "img2img"
      | "img2img-ip-adapter"
      | "img2img-texture"
      | "inference"
      | "inpaint"
      | "inpaint-ip-adapter"
      | "model"
      | "model-preset"
      | "models-training"
      | "oscu"
      | "patch"
      | "pixelate"
      | "project"
      | "project-member"
      | "reframe"
      | "repaint"
      | "restyle"
      | "segmentation"
      | "skybox-base-360"
      | "skybox-upscale-360"
      | "start-train"
      | "subscription"
      | "subscription-seats"
      | "tag-asset"
      | "tag-model"
      | "team-api-key"
      | "team-member"
      | "texture"
      | "train-succeeded"
      | "training-images-to-model"
      | "transfer-model"
      | "txt2img"
      | "txt2img-ip-adapter"
      | "update-asset"
      | "update-collection"
      | "update-model"
      | "update-model-description"
      | "update-model-examples"
      | "update-oscu-auto-refill"
      | "update-project"
      | "update-subscription"
      | "update-team"
      | "update-team-member"
      | "upscale"
      | "vectorization";
    /** The UTC ISO date of the point */
    time: string;
    /** The projectId of the project for this action */
    projectId: string;
    /** The userId of the user for this action */
    userId: string;
  }[];
  consumption?: {
    /** The userId of the user for this node */
    userId: string;
    /** The consumption of creative units for this user */
    value: number;
  }[];
  usages?: {
    /** Granularity for points (example: "1d", "1h", "1m", "15m") */
    granularity: "15m" | "1d" | "1h" | "1m" | "30m" | "5m";
    /** Name of the usage points (example: "images-generation", "generators-training", "background-removal", "upscale", ...) */
    usageName:
      | "background-removal"
      | "captioning"
      | "creative-unit-cost"
      | "detection"
      | "image-prompt-editing"
      | "images-generation"
      | "models-training"
      | "patch"
      | "pixelate"
      | "repaint"
      | "restyle"
      | "segmentation"
      | "skybox-base-360"
      | "skybox-upscale-360"
      | "texture"
      | "upscale"
      | "vectorization";
    /** The usage data points */
    points: {
      /** The UTC ISO date of the point */
      time: string;
      /** Value of the point */
      value: string;
    }[];
  }[];
};
export type GetUsagesApiArg = {
  /** The user id of the usage. If not provided, returns all usages for the team. */
  userId?: string;
  /** The offset for the activity data. Default is 0. If bad offset or empty, 0 will be returned. Must be a positive integer. */
  activityOffset?: string;
  /** The user ids for filtering the usage data. If not provided, use all users. Can be one or more comma separated values. */
  userIds?: string;
  /** The team identifier for usage data. If omitted, the default team will be used. */
  teamId?: string;
  /** The type of the usage data. Can be one or more comma separated values. Default is all types. If bad type or empty, all types will be returned. */
  type?: string;
  /** The end date of the usage in ISO 8601 format. If not provided, use default timeRange. If provided, startDate is required. */
  endDate?: string;
  /** The project ids for filtering the usage data. If not provided, use all projects. Can be one or more comma separated values. */
  projectIds?: string;
  /** The time range of the usage. If not provided, use default timeRange. If startDate and endDate provided, timeRange is ignored. */
  timeRange?: string;
  /** The start date of the usage in ISO 8601 format. If not provided, use default timeRange. If provided, endDate is required. */
  startDate?: string;
};
export type PostWebhooksClerkEmailsApiResponse =
  /** status 200 200 response */ {
    message?: string;
  };
export type PostWebhooksClerkEmailsApiArg = {
  body: {
    data: {
      delivered_by_clerk: boolean;
      data: {
        app: {
          domain_name: string;
          logo_image_url: string;
          logo_url: string;
          name: string;
          url: string;
        };
        requested_by: string;
        ttl_minutes: number;
        theme: {
          button_text_color: string;
          show_clerk_branding: boolean;
          primary_color: string;
        };
        magic_link: string;
        otp_code: string;
        user: {
          public_metadata: {};
          public_metadata_fallback: string;
        };
        requested_at: string;
      };
      subject: string;
      to_email_address: string;
      body_plain: string;
      body: string;
      email_address_id: string;
      from_email_name: string;
      id: string;
      slug: string;
      object: string;
      status: string;
    };
    event_attributes: {
      http_request: {
        client_ip: string;
        user_agent: string;
      };
    };
    type: "email.created";
    object: string;
    timestamp: number;
  };
};
export type PostWebhooksClerkSessionsApiResponse =
  /** status 200 200 response */ {
    message?: string;
  };
export type PostWebhooksClerkSessionsApiArg = {
  body: {
    object: string;
  };
};
export type PostWebhooksReplicateJobIdApiResponse =
  /** status 200 200 response */ {
    message?: string;
  };
export type PostWebhooksReplicateJobIdApiArg = {
  jobId: string;
  body: {
    webhook?: string;
    created_at: string;
    source: "api" | "web";
    version: string;
    webhook_events_filter?: ("completed" | "logs" | "output" | "start")[];
    completed_at?: string;
    input: {};
    urls: {
      cancel: string;
      stream?: string;
      get: string;
    };
    started_at?: string;
    model: string;
    id: string;
    metrics?: {
      predict_time?: number;
    };
    logs?: string;
    status: "canceled" | "failed" | "processing" | "starting" | "succeeded";
  };
};
export const {
  useGetAssetsQuery,
  useLazyGetAssetsQuery,
  usePostAssetMutation,
  useDeleteAssetMutation,
  usePostDownloadAssetsMutation,
  useGetDownloadAssetsQuery,
  useLazyGetDownloadAssetsQuery,
  usePostAssetGetBulkMutation,
  useGetPublicAssetsQuery,
  useLazyGetPublicAssetsQuery,
  useGetAssetsByAssetIdQuery,
  useLazyGetAssetsByAssetIdQuery,
  usePutAssetByAssetIdMutation,
  useCopyAssetByAssetIdMutation,
  useLockAssetByAssetIdMutation,
  usePrivacyAssetByAssetIdMutation,
  useGetCanvasAssetSnapshotsQuery,
  useLazyGetCanvasAssetSnapshotsQuery,
  usePutAssetsTagsByAssetIdMutation,
  useUnlockAssetByAssetIdMutation,
  useGetCollectionsQuery,
  useLazyGetCollectionsQuery,
  usePostCollectionMutation,
  useGetCollectionsByCollectionIdQuery,
  useLazyGetCollectionsByCollectionIdQuery,
  usePutCollectionsByCollectionIdMutation,
  useDeleteCollectionsByCollectionIdMutation,
  usePutAssetsByCollectionIdMutation,
  useDeleteAssetsByCollectionIdMutation,
  usePutModelsByCollectionIdMutation,
  useDeleteModelsByCollectionIdMutation,
  usePostCaptionInferencesMutation,
  usePostControlnetInferencesMutation,
  usePostControlnetImg2ImgInferencesMutation,
  usePostControlnetInpaintInferencesMutation,
  usePostControlnetInpaintIpAdapterInferencesMutation,
  usePostControlnetIpAdapterInferencesMutation,
  usePostControlnetTextureInferencesMutation,
  usePostGenerateCustomMutation,
  usePostDescribeStyleInferencesMutation,
  usePostDetectInferencesMutation,
  usePostEmbedInferencesMutation,
  usePostGenerativeFillInferencesMutation,
  usePostImg2ImgInferencesMutation,
  usePostImg2ImgIpAdapterInferencesMutation,
  usePostImg2ImgTextureInferencesMutation,
  usePostInpaintInferencesMutation,
  usePostInpaintIpAdapterInferencesMutation,
  usePostPatchInferencesMutation,
  usePostPixelateInferencesMutation,
  usePostPromptInferencesMutation,
  usePostPromptEditingInferencesMutation,
  usePostReframeInferencesMutation,
  usePostRemoveBackgroundInferencesMutation,
  usePostRestyleInferencesMutation,
  usePostSegmentInferencesMutation,
  usePostSkyboxBase360InferencesMutation,
  usePostSkyboxUpscale360InferencesMutation,
  usePostTextureInferencesMutation,
  usePostTranslateInferencesMutation,
  usePostTxt2ImgInferencesMutation,
  usePostTxt2ImgIpAdapterInferencesMutation,
  usePostTxt2ImgTextureInferencesMutation,
  usePostUpscaleInferencesMutation,
  usePostVectorizeInferencesMutation,
  usePutImagesDetectionMutation,
  usePutImagesEraseBackgroundMutation,
  usePutImagePatchMutation,
  usePutImagesPixelateMutation,
  usePutImagesSegmentationMutation,
  usePutImageUpscaleMutation,
  usePutImageVectorizationMutation,
  useGetInferencesQuery,
  useLazyGetInferencesQuery,
  useGetJobsQuery,
  useLazyGetJobsQuery,
  useGetJobIdQuery,
  useLazyGetJobIdQuery,
  usePostJobActionByJobIdMutation,
  useGetMeQuery,
  useLazyGetMeQuery,
  usePutMeMutation,
  useDeleteMeMutation,
  useGetUserConfirmDeletionQuery,
  useLazyGetUserConfirmDeletionQuery,
  useGetUserConfirmInvitationQuery,
  useLazyGetUserConfirmInvitationQuery,
  useGetUserNotificationsByTokenQuery,
  useLazyGetUserNotificationsByTokenQuery,
  usePutUserNotificationsByTokenMutation,
  useGetModelsQuery,
  useLazyGetModelsQuery,
  usePostModelsMutation,
  usePostModelsGetBulkMutation,
  useGetModelsByModelIdQuery,
  useLazyGetModelsByModelIdQuery,
  usePutModelsByModelIdMutation,
  useDeleteModelsByModelIdMutation,
  usePostModelActionByModelIdMutation,
  useGetModelsCategoriesByModelIdQuery,
  useLazyGetModelsCategoriesByModelIdQuery,
  useGetModelsClassesByModelIdQuery,
  useLazyGetModelsClassesByModelIdQuery,
  usePostModelsCopyByModelIdMutation,
  useGetModelsDescriptionByModelIdQuery,
  useLazyGetModelsDescriptionByModelIdQuery,
  usePutModelsDescriptionByModelIdMutation,
  usePostDownloadModelMutation,
  useGetModelsExamplesByModelIdQuery,
  useLazyGetModelsExamplesByModelIdQuery,
  usePutModelsExamplesByModelIdMutation,
  useDeleteModelsImagesByModelIdMutation,
  useGetModelsInferencesByModelIdQuery,
  useLazyGetModelsInferencesByModelIdQuery,
  usePostModelsInferencesByModelIdMutation,
  useDeleteModelsInferencesByModelIdMutation,
  useDeleteModelsInferencesAllByModelIdMutation,
  useGetModelsInferencesByModelIdAndInferenceIdQuery,
  useLazyGetModelsInferencesByModelIdAndInferenceIdQuery,
  useDeleteModelsInferencesByModelIdAndInferenceIdMutation,
  usePostModelsInferencesActionByModelIdAndInferenceIdMutation,
  useGetModelsInferencesImagesByModelIdAndInferenceIdAndImageIdQuery,
  useLazyGetModelsInferencesImagesByModelIdAndInferenceIdAndImageIdQuery,
  useDeleteModelsInferencesImagesByModelIdAndInferenceIdAndImageIdMutation,
  useGetModelPresetsByModelIdQuery,
  useLazyGetModelPresetsByModelIdQuery,
  usePostModelPresetByModelIdMutation,
  usePutModelPresetByModelIdAndPresetIdMutation,
  useDeleteModelPresetByModelIdAndPresetIdMutation,
  useGetModelsScoresPromptByModelIdQuery,
  useLazyGetModelsScoresPromptByModelIdQuery,
  useGetModelsScoresTrainingDatasetByModelIdQuery,
  useLazyGetModelsScoresTrainingDatasetByModelIdQuery,
  usePutModelsTagsByModelIdMutation,
  usePutModelsTrainByModelIdMutation,
  usePostModelTrainingActionByModelIdMutation,
  usePostModelsTrainingImagesByModelIdMutation,
  usePutModelsTrainingImagesByModelIdAndTrainingImageIdMutation,
  useDeleteModelsTrainingImagesByModelIdAndTrainingImageIdMutation,
  usePostModelsTransferByModelIdMutation,
  useGetProjectsQuery,
  useLazyGetProjectsQuery,
  usePostProjectMutation,
  useGetProjectsByProjectIdQuery,
  useLazyGetProjectsByProjectIdQuery,
  usePutProjectsByProjectIdMutation,
  useDeleteProjectsByProjectIdMutation,
  usePostProjectsApiKeysByProjectIdMutation,
  useDeleteProjectsApiKeyByProjectIdAndKeyIdMutation,
  usePostProjectsMembersByProjectIdMutation,
  usePutProjectsMembersByProjectIdAndMemberIdMutation,
  useDeleteProjectsMembersByProjectIdAndMemberIdMutation,
  useGetProjectWebhookEndpointsQuery,
  useLazyGetProjectWebhookEndpointsQuery,
  usePostProjectWebhookEndpointsMutation,
  usePutProjectWebhookEndpointByIdMutation,
  useDeleteProjectWebhookEndpointByIdMutation,
  useGetProjectWebhookEndpointEventsQuery,
  useLazyGetProjectWebhookEndpointEventsQuery,
  useGetWebhookEventQuery,
  useLazyGetWebhookEventQuery,
  usePutPromptGeneratorMutation,
  useGetRecommendationsModelsQuery,
  useLazyGetRecommendationsModelsQuery,
  usePostSearchAssetsMutation,
  usePostSearchModelsMutation,
  useGetTagsQuery,
  useLazyGetTagsQuery,
  useGetTeamsQuery,
  useLazyGetTeamsQuery,
  usePostTeamsMutation,
  useGetTeamsByTeamIdQuery,
  useLazyGetTeamsByTeamIdQuery,
  usePutTeamsByTeamIdMutation,
  useDeleteTeamsByTeamIdMutation,
  usePostTeamsApiKeysByTeamIdMutation,
  usePutTeamsApiKeyByTeamIdAndKeyIdMutation,
  useDeleteTeamsApiKeyByTeamIdAndKeyIdMutation,
  useDeleteTeamsInvitationsByTeamIdMutation,
  useGetTeamsLimitsByTeamIdQuery,
  useLazyGetTeamsLimitsByTeamIdQuery,
  usePostTeamsMembersByTeamIdMutation,
  usePutTeamsMembersByTeamIdAndMemberIdMutation,
  useDeleteTeamsMembersByTeamIdAndMemberIdMutation,
  usePostTeamsOscuByTeamIdMutation,
  usePostTeamsOscuAutoRefillByTeamIdMutation,
  useDeleteTeamsOscuAutoRefillByTeamIdMutation,
  useGetTeamsOscuPricesByTeamIdQuery,
  useLazyGetTeamsOscuPricesByTeamIdQuery,
  useGetTeamsSubscriptionsByTeamIdQuery,
  useLazyGetTeamsSubscriptionsByTeamIdQuery,
  usePostTeamsSubscriptionsByTeamIdMutation,
  usePutTeamsSubscriptionsByTeamIdMutation,
  useDeleteTeamsSubscriptionsByTeamIdMutation,
  useGetTeamsSubscriptionsCustomerPortalByTeamIdQuery,
  useLazyGetTeamsSubscriptionsCustomerPortalByTeamIdQuery,
  usePostTeamsSubscriptionsSeatsByTeamIdMutation,
  useGetTeamWebhookEndpointsQuery,
  useLazyGetTeamWebhookEndpointsQuery,
  usePostWebhookEndpointsMutation,
  usePutWebhookEndpointsByIdMutation,
  useDeleteWebhookEndpointByIdMutation,
  usePostUploadsMutation,
  useGetUploadsQuery,
  useLazyGetUploadsQuery,
  usePostUploadsActionMutation,
  useGetUsagesQuery,
  useLazyGetUsagesQuery,
  usePostWebhooksClerkEmailsMutation,
  usePostWebhooksClerkSessionsMutation,
  usePostWebhooksReplicateJobIdMutation,
} = injectedRtkApi;
